export const QUESTIONS = [
  {
    "id": 1,
    "question": "Which of the following is <italic>not</italic> a common cloud service model?",
    "choice_a": "Software as a Service",
    "choice_b": "Programming as a Service",
    "choice_c": "Infrastructure as a Service",
    "choice_d": "Platform as a Service",
    "correct_answer": "B",
    "explanation": "Programming as a Service is not a common offering; the others are ubiquitous throughout the industry.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      12,
      13,
      3,
      158
    ],
    "source": ""
  },
  {
    "id": 2,
    "question": "All of the following technologies have made cloud service viable except:",
    "choice_a": "Virtualization",
    "choice_b": "Widely available broadband",
    "choice_c": "Cryptographic connectivity",
    "choice_d": "Smart hubs",
    "correct_answer": "D",
    "explanation": "Virtualization allows scalable resource allocation; broadband connections allow users to have remote access from anywhere; cryptographic connections allow for secure remote access. Smart hubs aren't widely used in cloud offerings.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      1,
      2,
      3,
      141,
      144
    ],
    "source": ""
  },
  {
    "id": 3,
    "question": "Cloud vendors are held to contractual obligations with specified metrics by:",
    "choice_a": "Service level agreements (SLAs)",
    "choice_b": "Regulations",
    "choice_c": "Law",
    "choice_d": "Discipline",
    "correct_answer": "A",
    "explanation": "Service level agreements (SLAs) specify objective measures that define what the cloud provider will deliver to the customer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      229,
      148,
      147,
      170,
      12
    ],
    "source": ""
  },
  {
    "id": 4,
    "question": "_____ drive security decisions.",
    "choice_a": "Customer service responses",
    "choice_b": "Surveys",
    "choice_c": "Business requirements",
    "choice_d": "Public opinion",
    "correct_answer": "C",
    "explanation": "Security is usually not a profit center, and is therefore beholden to business drivers; the purpose of security is to support the business.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      5,
      229,
      223,
      225
    ],
    "source": ""
  },
  {
    "id": 5,
    "question": "If a cloud customer cannot get access to the cloud provider, this affects what portion of the CIA triad?",
    "choice_a": "Integrity",
    "choice_b": "Authentication",
    "choice_c": "Confidentiality",
    "choice_d": "Availability",
    "correct_answer": "D",
    "explanation": "Lack of access is an availability issue.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      12,
      2,
      147,
      237
    ],
    "source": ""
  },
  {
    "id": 6,
    "question": "Cloud Access Security Brokers (CASBs) might offer all of the following services EXCEPT:",
    "choice_a": "Single sign on",
    "choice_b": "Business Continuity Planning (BCP) / Disaster Recovery (DR) / Continuity of Operations Plan (COOP)",
    "choice_c": "Identity and access management (IAM)",
    "choice_d": "Key escrow",
    "correct_answer": "B",
    "explanation": "Cloud Access Security Brokers (CASBs) don't usually offer Business Continuity Planning (BCP) / Disaster Recovery (DR) / Continuity of Operations Plan (COOP) services; that's something offered by cloud providers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      12,
      159,
      162,
      161,
      146
    ],
    "source": ""
  },
  {
    "id": 7,
    "question": "Encryption can be used in various aspects of cloud computing, including all of the following except:",
    "choice_a": "Storage",
    "choice_b": "Remote access",
    "choice_c": "Secure sessions",
    "choice_d": "Magnetic swipe cards",
    "correct_answer": "D",
    "explanation": "The data on magnetic swipe cards isn't usually encrypted.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      422,
      473,
      139,
      140,
      206
    ],
    "source": ""
  },
  {
    "id": 8,
    "question": "All of the following are reasons an organization may want to consider cloud migration except:",
    "choice_a": "Reduced personnel costs",
    "choice_b": "Elimination of risks",
    "choice_c": "Reduced operational expenses",
    "choice_d": "Increased efficiency",
    "correct_answer": "B",
    "explanation": "Risks, in general, can be reduced but never eliminated; cloud service, specifically, does not eliminate risk to the cloud customer, because the customer retains a great deal of risk after migration.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      225,
      223,
      224,
      222,
      6
    ],
    "source": ""
  },
  {
    "id": 9,
    "question": "The generally accepted definition of cloud computing includes all of the following characteristics except:",
    "choice_a": "On demand services",
    "choice_b": "Negating the need for backups",
    "choice_c": "Resource pooling",
    "choice_d": "Measured or metered service",
    "correct_answer": "B",
    "explanation": "Backups are still just as important as ever, regardless of where your primary data and backups are stored.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      1,
      8,
      17,
      232,
      165
    ],
    "source": ""
  },
  {
    "id": 10,
    "question": "A gamer is part of the PlayStation Network community cloud. Who owns the PlayStation console in the gamer\u2019s home?",
    "choice_a": "Sony",
    "choice_b": "The community as a whole",
    "choice_c": "The company that made the game that the gamer is playing at the time",
    "choice_d": "The gamer",
    "correct_answer": "D",
    "explanation": "The gamer owns the console in their home. The gamer can turn it on and off at their discretion, sell it, or smash it with a hammer. The various members of a community cloud can all share the underlying resources of the community cloud as they choose. In this case, Sony, the game maker, the gamer, and the other players are all members of the community, and all share different underlying components as they choose.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      10,
      12,
      236,
      2,
      7
    ],
    "source": ""
  },
  {
    "id": 11,
    "question": "The risk that a cloud provider might go out of business and the cloud customer might not be able to recover data is known as:",
    "choice_a": "Vendor closure",
    "choice_b": "Vendor lock out",
    "choice_c": "Vendor lock in",
    "choice_d": "Vending route",
    "correct_answer": "B",
    "explanation": "This is the definition of vendor lock out.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      229,
      230,
      220,
      237
    ],
    "source": ""
  },
  {
    "id": 12,
    "question": "All of the following are features of cloud computing except:",
    "choice_a": "Broad network access",
    "choice_b": "Reversed charging configuration",
    "choice_c": "Rapid scaling",
    "choice_d": "On demand self service",
    "correct_answer": "B",
    "explanation": "This is a nonsense term used as a red herring.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      1,
      8,
      17,
      15,
      19
    ],
    "source": ""
  },
  {
    "id": 13,
    "question": "When a cloud customer uploads Personally identifiable information (PII) to a cloud provider, who becomes ultimately responsible for the security of that Personally identifiable information (PII)?",
    "choice_a": "Cloud provider",
    "choice_b": "Regulators",
    "choice_c": "Cloud customer",
    "choice_d": "The individuals who are the subjects of the Personally identifiable information (PII)",
    "correct_answer": "C",
    "explanation": "Under current law, the data owner is responsible for any breaches that result in unauthorized disclosure of Personally identifiable information (PII); this includes breaches caused by contracted parties and outsources services. The data owner is the cloud customer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      182,
      170,
      196,
      181,
      235
    ],
    "source": ""
  },
  {
    "id": 14,
    "question": "We use which of the following to determine the critical paths, processes, and assets of an organization?",
    "choice_a": "Business requirements",
    "choice_b": "Business impact analysis (BIA)",
    "choice_c": "Risk Management Framework (RMF)",
    "choice_d": "CIA triad",
    "correct_answer": "B",
    "explanation": "The Business impact analysis (BIA) is designed to ascertain the value of the organization's assets, and learn the critical paths and processes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      161,
      229,
      215,
      218
    ],
    "source": ""
  },
  {
    "id": 15,
    "question": "The cloud deployment model that features organizational ownership of the hardware and infrastructure, and usage only by members of that organization, is known as:",
    "choice_a": "Private",
    "choice_b": "Public",
    "choice_c": "Hybrid",
    "choice_d": "Motive",
    "correct_answer": "A",
    "explanation": "This is the definition of a private cloud model.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      9,
      1,
      12,
      10,
      7
    ],
    "source": ""
  },
  {
    "id": 16,
    "question": "The cloud deployment model that features ownership by a cloud provider, with services offered to anyone who wants to subscribe, is known as:",
    "choice_a": "Private",
    "choice_b": "Public",
    "choice_c": "Hybrid",
    "choice_d": "Latent",
    "correct_answer": "B",
    "explanation": "This is the definition of a public cloud model.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      9,
      11,
      12,
      1,
      10
    ],
    "source": ""
  },
  {
    "id": 17,
    "question": "The cloud deployment model that features joint ownership of assets among an affinity group is known as:",
    "choice_a": "Private",
    "choice_b": "Public",
    "choice_c": "Hybrid",
    "choice_d": "Community",
    "correct_answer": "D",
    "explanation": "This is the definition of a community cloud model.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      10,
      9,
      12,
      235,
      236
    ],
    "source": ""
  },
  {
    "id": 18,
    "question": "If a cloud customer wants a secure, isolated sandbox in order to conduct software development and testing, which cloud service model would probably be best?",
    "choice_a": "Infrastructure as a Service (IaaS)",
    "choice_b": "Platform as a Service (PaaS)",
    "choice_c": "Software as a Service (SaaS)",
    "choice_d": "Hybrid",
    "correct_answer": "B",
    "explanation": "Platform as a Service (PaaS) allows the cloud customer to install any kind of software, including software to be tested, on an architecture that includes any desired OSs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      11,
      152,
      156,
      12
    ],
    "source": ""
  },
  {
    "id": 19,
    "question": "If a cloud customer wants a fully operational environment with very little maintenance or administration necessary, which cloud service model would probably be best?",
    "choice_a": "Infrastructure as a Service (IaaS)",
    "choice_b": "Platform as a Service (PaaS)",
    "choice_c": "Software as a Service (SaaS)",
    "choice_d": "Hybrid",
    "correct_answer": "C",
    "explanation": "Software as a Service (SaaS) is the most comprehensive cloud offering, requiring little input and administration on the part of the cloud customer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      12,
      237,
      6,
      1
    ],
    "source": ""
  },
  {
    "id": 20,
    "question": "If a cloud customer wants a barebones environment in which to replicate their own enterprise for Business Continuity (BC) / Disaster Recovery (DR) purposes, which cloud service model would probably be best?",
    "choice_a": "Infrastructure as a Service (IaaS)",
    "choice_b": "Platform as a Service (PaaS)",
    "choice_c": "Software as a Service (SaaS)",
    "choice_d": "Hybrid",
    "correct_answer": "A",
    "explanation": "Infrastructure as a Service (IaaS) offers what is basically a hot/warm DR site, with hardware, connectivity, and utilities, allowing the customer to build out any kind of software configuration (including choosing OSs).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      159,
      161,
      162,
      237
    ],
    "source": ""
  },
  {
    "id": 21,
    "question": "Gathering business requirements can aid the organization in determining all of this information about organizational assets, except:",
    "choice_a": "Full inventory",
    "choice_b": "Usefulness",
    "choice_c": "Value",
    "choice_d": "Criticality",
    "correct_answer": "B",
    "explanation": "When we gather information about business requirements, we need to do a complete inventory, receive accurate valuation of assets (usually from the owners of those assets), and assess criticality; this collection of information does not tell us, objectively, how useful an asset is, however.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      238,
      239,
      544,
      336,
      546
    ],
    "source": ""
  },
  {
    "id": 22,
    "question": "The Business impact analysis (BIA) can be used to provide information about all of the following except:",
    "choice_a": "Risk analysis",
    "choice_b": "Secure acquisition",
    "choice_c": "Business Continuity (BC) / Disaster Recovery (DR) planning",
    "choice_d": "Selection of security controls",
    "correct_answer": "B",
    "explanation": "The Business impact analysis (BIA) gathers asset valuation information that is beneficial for risk analysis and selection of security controls (it helps avoid putting the ten dollar lock on the five dollar bicycle), and criticality information that helps in Business Continuity (BC) / Disaster Recovery (DR) planning by letting the organization understand which systems, data, and personnel are necessary to continuously maintain. However, it does not aid secure acquisition efforts, since the assets examined by the Business impact analysis (BIA) have already been acquired.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      239,
      238,
      240,
      544,
      699
    ],
    "source": ""
  },
  {
    "id": 23,
    "question": "In which cloud service model is the customer required to maintain the OS?",
    "choice_a": "Content as a Service (CaaS)",
    "choice_b": "Software as a Service (SaaS)",
    "choice_c": "Platform as a Service (PaaS)",
    "choice_d": "Infrastructure as a Service (IaaS)",
    "correct_answer": "D",
    "explanation": "In Infrastructure as a Service (IaaS), the service is bare metal, and the customer has to install the OS and the software; the customer then is responsible for maintaining that OS. In the other models, the provider installs and maintains the OS.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      12,
      237,
      23,
      1
    ],
    "source": ""
  },
  {
    "id": 24,
    "question": "In which cloud service model is the customer required to maintain and update only the applications?",
    "choice_a": "Content as a Service (CaaS)",
    "choice_b": "Software as a Service (SaaS)",
    "choice_c": "Platform as a Service (PaaS)",
    "choice_d": "Infrastructure as a Service (IaaS)",
    "correct_answer": "C",
    "explanation": "In Platform as a Service (PaaS), the provider supplies the hardware, connectivity, and OS; the customer installs and maintains applications. In Infrastructure as a Service (IaaS), the customer must also install the OS, and in Software as a Service (SaaS), the provider supplies and maintains the applications.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      237,
      12,
      13,
      148
    ],
    "source": ""
  },
  {
    "id": 25,
    "question": "In which cloud service model is the customer only responsible for the data?",
    "choice_a": "Content as a Service (CaaS)",
    "choice_b": "Software as a Service (SaaS)",
    "choice_c": "Platform as a Service (PaaS)",
    "choice_d": "Infrastructure as a Service (IaaS)",
    "correct_answer": "B",
    "explanation": "Software as a Service (SaaS) is the model in which the customer supplies only the data; in the other models, the customer also supplies the OS, the application, or both.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      12,
      237,
      13,
      1
    ],
    "source": ""
  },
  {
    "id": 26,
    "question": "The cloud customer and provider negotiate their respective responsibilities and rights regarding the capabilities and data of the cloud service. Where is the eventual agreement codified?",
    "choice_a": "Risk Management Framework (RMF)",
    "choice_b": "Contract",
    "choice_c": "Memorandum of understanding (MOU)",
    "choice_d": "Business impact analysis (BIA)",
    "correct_answer": "B",
    "explanation": "The contract codifies the rights and responsibilities of the parties involved upon completion of negotiation. The Risk Management Framework (RMF) aids in risk analysis and design of the environment. An Memorandum of understanding (MOU) is shared between parties for a number of possible reasons. The Business impact analysis (BIA) aids in risk assessment, DC/BR efforts, and selection of security controls.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      232,
      170,
      237,
      13,
      228
    ],
    "source": ""
  },
  {
    "id": 27,
    "question": "In attempting to provide a layered defense, the security practitioner should convince senior management to include security controls of which type?",
    "choice_a": "Technological",
    "choice_b": "Physical",
    "choice_c": "Administrative",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "Layered defense calls for a diverse approach to security.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      241,
      243,
      42,
      448,
      687
    ],
    "source": ""
  },
  {
    "id": 28,
    "question": "Which of the following is considered an administrative control?",
    "choice_a": "Access control process",
    "choice_b": "Keystroke logging",
    "choice_c": "Door locks",
    "choice_d": "Biometric authentication",
    "correct_answer": "A",
    "explanation": "A process is an administrative control; sometimes, the process includes elements of other types of controls (in this case, the access control mechanism might be a technical control, or it might be a physical control), but the process itself is administrative. Keystroke logging is a technical control (or an attack, if done for malicious purposes, and not for auditing); door locks are a physical control; and biometric authentication is a technological control. This is a tricky question.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      241,
      243,
      242,
      448,
      535
    ],
    "source": ""
  },
  {
    "id": 29,
    "question": "Which of the following is considered a technological control?",
    "choice_a": "Firewall software",
    "choice_b": "Fireproof safe",
    "choice_c": "Fire extinguisher",
    "choice_d": "Firing personnel",
    "correct_answer": "A",
    "explanation": "A firewall is a technological control. The safe and extinguisher are physical controls, and firing someone is an administrative control.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      241,
      242,
      551,
      53,
      48
    ],
    "source": ""
  },
  {
    "id": 30,
    "question": "Which of the following is considered a physical control?",
    "choice_a": "Carpets",
    "choice_b": "Ceilings",
    "choice_c": "Doors",
    "choice_d": "Fences",
    "correct_answer": "D",
    "explanation": "Fences are physical controls; carpets and ceilings are architectural features, and a door is not necessarily a control: the lock on the door would be a physical security control. Although you might think of a door as a potential answer, the best answer is the fence; the exam will have questions where more than one answer is correct, and the answer that will score you points is the one that is most correct.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      241,
      553,
      686,
      714,
      712
    ],
    "source": ""
  },
  {
    "id": 31,
    "question": "In a cloud environment, encryption should be used for all of the following except:",
    "choice_a": "Long term storage of data",
    "choice_b": "Near term storage of virtualized images",
    "choice_c": "Secure sessions/VPN",
    "choice_d": "Profile formatting",
    "correct_answer": "D",
    "explanation": "All of the following activities should incorporate encryption, except for profile formatting, which is a made up term.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      422,
      206,
      182,
      170,
      202
    ],
    "source": ""
  },
  {
    "id": 32,
    "question": "The process of hardening a device should include all of the following except:",
    "choice_a": "Improve default accounts",
    "choice_b": "Close unused ports",
    "choice_c": "Delete unnecessary services",
    "choice_d": "Strictly control administrator access",
    "correct_answer": "A",
    "explanation": "We don't want to improve default accounts , we want to remove them. All the other options are steps we take to harden devices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      245,
      244,
      246,
      213,
      214
    ],
    "source": ""
  },
  {
    "id": 33,
    "question": "The process of hardening a device should include which of the following?",
    "choice_a": "Encrypting the OS",
    "choice_b": "Updating and patching the system",
    "choice_c": "Using video cameras",
    "choice_d": "Performing thorough personnel background checks",
    "correct_answer": "B",
    "explanation": "Updating and patching the system helps harden the system. Encrypting the OS is a distractor. That would make the OS/machine impossible to use. Video cameras are a security control, but not one used to harden a device. Background checks are good for vetting personnel, but not for hardening devices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      244,
      246,
      245,
      223,
      142
    ],
    "source": ""
  },
  {
    "id": 34,
    "question": "What is an experimental technology that is intended to create the possibility of processing encrypted data without having to decrypt it first?",
    "choice_a": "Homomorphic",
    "choice_b": "Polyinstantiation",
    "choice_c": "Quantum state",
    "choice_d": "Gastronomic",
    "correct_answer": "A",
    "explanation": "Homomorphic encryption hopes to achieve that goal; the other options are terms that have almost nothing to do with encryption.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      53,
      43,
      57,
      56,
      54
    ],
    "source": ""
  },
  {
    "id": 35,
    "question": "Risk appetite for an organization is determined by which of the following?",
    "choice_a": "Reclusion evaluation",
    "choice_b": "Senior management",
    "choice_c": "Legislative mandates",
    "choice_d": "Contractual agreement",
    "correct_answer": "B",
    "explanation": "Senior management decides the risk appetite of the organization. <br>There is no such thing as reclusion evaluation. <br>Legislative mandates (laws) do not tell an organization which risks are acceptable except in very, very specific industries, and those are outliers. <br>Contracts don\u2019t dictate acceptable risk for an organization; the organization should use its risk appetite to guide how it crafts contracts.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      238,
      240,
      241,
      536,
      545
    ],
    "source": ""
  },
  {
    "id": 36,
    "question": "What is the risk left over after controls and countermeasures are put in place?",
    "choice_a": "Null",
    "choice_b": "High",
    "choice_c": "Residual",
    "choice_d": "Pertinent",
    "correct_answer": "C",
    "explanation": "This is the definition of the term <italic>residual</italic>.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      240,
      238,
      241,
      457,
      59
    ],
    "source": ""
  },
  {
    "id": 37,
    "question": "All of the following are ways of addressing risk, except:",
    "choice_a": "Acceptance",
    "choice_b": "Reversal",
    "choice_c": "Mitigation",
    "choice_d": "Transfer",
    "correct_answer": "B",
    "explanation": "Reversal is not a method for handling risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      241,
      42,
      53,
      54,
      556
    ],
    "source": ""
  },
  {
    "id": 38,
    "question": "To protect data on user devices in a Bring your own device (BYOD) environment, the organization should consider requiring all of the following except:",
    "choice_a": "Data loss prevention (DLP) agents",
    "choice_b": "Local encryption",
    "choice_c": "Multifactor authentication",
    "choice_d": "Two person integrity",
    "correct_answer": "D",
    "explanation": "Although all the other options are ways to harden a mobile device, two person integrity is a concept that has nothing to do with the topic, and, if implemented, would require everyone in your organization to walk around in pairs while using their mobile devices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      214,
      223,
      222,
      142
    ],
    "source": ""
  },
  {
    "id": 39,
    "question": "Devices in the cloud datacenter should be secure against attack. All of the following are means of hardening devices, except:",
    "choice_a": "Using a strong password policy",
    "choice_b": "Removing default passwords",
    "choice_c": "Strictly limiting physical access",
    "choice_d": "Removing all admin accounts",
    "correct_answer": "D",
    "explanation": "Although the rest of the options are good tactics for securing devices, we can't remove all admin accounts; the device will need to be administered at some point, and that account needs to be there.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      244,
      245,
      246,
      487,
      481
    ],
    "source": ""
  },
  {
    "id": 40,
    "question": "Which of the following best describes risk?",
    "choice_a": "Preventable",
    "choice_b": "Everlasting",
    "choice_c": "The likelihood that a threat will exploit a vulnerability",
    "choice_d": "Transient",
    "correct_answer": "C",
    "explanation": "Option C is the definition of risk and risk is never preventable: it can be obviated, attenuated, reduced, and minimized, but never completely prevented. A risk may be everlasting or transient, indicating that risk itself is not limited to being either.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      240,
      238,
      241,
      697,
      699
    ],
    "source": ""
  },
  {
    "id": 41,
    "question": "All of the following are terms used to described the practice of obscuring original raw data so that only a portion is displayed for operational purposes, except:",
    "choice_a": "Tokenization",
    "choice_b": "Data discovery",
    "choice_c": "Obfuscation",
    "choice_d": "Masking",
    "correct_answer": "B",
    "explanation": "Data discovery is a term used to describe the process of identifying information according to specific traits or categories. The rest are all methods for obscuring data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      28,
      508,
      509,
      31,
      26
    ],
    "source": ""
  },
  {
    "id": 42,
    "question": "The goals of Security information and event Management (SIEM) solution implementation include all of the following except:",
    "choice_a": "Centralization of log streams",
    "choice_b": "Trend analysis",
    "choice_c": "Dashboarding",
    "choice_d": "Performance enhancement",
    "correct_answer": "D",
    "explanation": "Security information and event Management (SIEM) does not intend to provide any enhancement of performance; in fact, a Security information and event Management (SIEM) solution may decrease performance because of additional overhead. All the rest are goals of Security information and event Management (SIEM) implementations.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      248,
      247,
      401,
      400,
      626
    ],
    "source": ""
  },
  {
    "id": 43,
    "question": "The goals of Data loss prevention (DLP) solution implementation include all of the following except:",
    "choice_a": "Policy enforcement",
    "choice_b": "Elasticity",
    "choice_c": "Data discovery",
    "choice_d": "Loss of mitigation",
    "correct_answer": "B",
    "explanation": "Data loss prevention (DLP) does not have anything to do with elasticity, which is the capability of the environment to scale up or down according to demand. All the rest are goals of Data loss prevention (DLP) implementations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      250,
      252,
      251,
      412,
      499
    ],
    "source": ""
  },
  {
    "id": 44,
    "question": "Data loss prevention (DLP) solutions can aid in deterring loss due to which of the following?",
    "choice_a": "Randomization",
    "choice_b": "Inadvertent disclosure",
    "choice_c": "Natural disaster",
    "choice_d": "Device failure",
    "correct_answer": "B",
    "explanation": "Data loss prevention (DLP) solutions may protect against inadvertent disclosure. Randomization is a technique for obscuring data, not a risk to data. Data loss prevention (DLP) tools will not protect against risks from natural disasters, or against impacts due to device failure.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      499,
      412,
      414,
      252,
      688
    ],
    "source": ""
  },
  {
    "id": 45,
    "question": "Data loss prevention (DLP) solutions can aid in deterring loss due to which of the following?",
    "choice_a": "Malicious disclosure",
    "choice_b": "Performance issues",
    "choice_c": "Bad policy",
    "choice_d": "Power failure",
    "correct_answer": "A",
    "explanation": "Data loss prevention (DLP) tools can identify outbound traffic that violates the organization's policies. Data loss prevention (DLP) will not protect against losses due to performance issues or power failures. The Data loss prevention (DLP) solution must be configured according to the organization's policies, so bad policies will attenuate the effectiveness of Data loss prevention (DLP) tools, not the other way around.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      412,
      414,
      499,
      688,
      250
    ],
    "source": ""
  },
  {
    "id": 46,
    "question": "What is the experimental technology that might lead to the possibility of processing encrypted data without having to decrypt it first?",
    "choice_a": "Advanced Encryption Standard (AES)",
    "choice_b": "Link encryption",
    "choice_c": "Homomorphic encryption",
    "choice_d": "One time pads",
    "correct_answer": "C",
    "explanation": "Advanced Encryption Standard (AES) is an encryption standard. Link encryption is a method for protecting communications trafic. One time pads are an encryption method.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      503,
      505,
      507,
      255,
      394
    ],
    "source": ""
  },
  {
    "id": 47,
    "question": "Proper implementation of Data loss prevention (DLP) solutions for successful function requires which of the following?",
    "choice_a": "Accurate data categorization",
    "choice_b": "Physical access limitations",
    "choice_c": "USB connectivity",
    "choice_d": "Physical presence",
    "correct_answer": "A",
    "explanation": "Data loss prevention (DLP) tools need to be aware of which information to monitor and which requires categorization (usually done upon data creation, by the data owners). DLPs can be implemented with or without physical access or presence. USB connectivity has nothing to do with Data loss prevention (DLP) solutions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      688,
      29,
      25,
      499,
      412
    ],
    "source": ""
  },
  {
    "id": 48,
    "question": "Tokenization requires two distinct.",
    "choice_a": "Authentication factors",
    "choice_b": "Databases",
    "choice_c": "Encryption keys",
    "choice_d": "Personnel",
    "correct_answer": "B",
    "explanation": "In order to implement tokenization, there will need to be two databases: the database containing the raw, original data, and the token database containing tokens that map to original data. Having two factor authentication is nice, but certainly not required. Encryption keys are not necessary for tokenization. Two person integrity does not have anything to do with tokenization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      253,
      254,
      255,
      503,
      507
    ],
    "source": ""
  },
  {
    "id": 49,
    "question": "Data masking can be used to provide all of the following functionality, except:",
    "choice_a": "Secure remote access",
    "choice_b": "Enforcing least privilege",
    "choice_c": "Test data in sandboxed environments",
    "choice_d": "Authentication of privileged users",
    "correct_answer": "D",
    "explanation": "Data masking does not support authentication in any way. All the others are excellent use cases for data masking.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      502,
      503,
      504,
      395,
      31
    ],
    "source": ""
  },
  {
    "id": 50,
    "question": "Data loss prevention (DLP) can be combined with what other security technology to enhance data controls?",
    "choice_a": "Digital rights management (DRM)",
    "choice_b": "Security information and event Management (SIEM)",
    "choice_c": "Kerberos",
    "choice_d": "Hypervisors",
    "correct_answer": "A",
    "explanation": "Data loss prevention (DLP) can be combined with Digital rights management (DRM) to protect intellectual property; both are designed to deal with data that falls into special categories. Security information and event Management (SIEMs) are used for monitoring event logs, not live data movement. Kerberos is an authentication mechanism. Hypervisors are used for virtualization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      388,
      31,
      394,
      414,
      395
    ],
    "source": ""
  },
  {
    "id": 51,
    "question": "What are the U.S. State Department controls on technology exports known as?",
    "choice_a": "International traffic in arms regulations (ITAR)",
    "choice_b": "Export administration regulations (EAR)",
    "choice_c": "Evaluation assurance level (EAL)",
    "choice_d": "Digital rights management (DRM)",
    "correct_answer": "A",
    "explanation": "International traffic in arms regulations (ITAR) is a Department of State program. Evaluation assurance level (EAL) are part of the Common Criteria standard from International Organization for Standardization (ISO). Digital rights management (DRM) tools are used for protecting electronic processing of intellectual property.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      392,
      393,
      31,
      414,
      385
    ],
    "source": ""
  },
  {
    "id": 52,
    "question": "What are the U.S. Commerce Department controls on technology exports known as?",
    "choice_a": "International traffic in arms regulations (ITAR)",
    "choice_b": "Export administration regulations (EAR)",
    "choice_c": "Evaluation assurance level (EAL)",
    "choice_d": "Digital rights management (DRM)",
    "correct_answer": "B",
    "explanation": "Export administration regulations (EAR) is a Commerce Department program. International traffic in arms regulations (ITAR) is a Department of State program. Evaluation assurance level (EAL) are part of the Common Criteria standard from International Organization for Standardization (ISO). Digital rights management (DRM) tools are used for protecting electronic processing of intellectual property.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      393,
      391,
      385,
      392,
      414
    ],
    "source": ""
  },
  {
    "id": 53,
    "question": "Cryptographic keys for encrypted data stored in the cloud should be .",
    "choice_a": "At least 128 bits long",
    "choice_b": "Not stored with the cloud provider",
    "choice_c": "Split into groups",
    "choice_d": "Generated with redundancy",
    "correct_answer": "B",
    "explanation": "Cryptographic keys should not be stored along with the data they secure, regardless of key length. We don't split crypto keys or generate redundant keys (doing so would violate the principle of secrecy necessary for keys to serve their purpose).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      418,
      494,
      41,
      395,
      396
    ],
    "source": ""
  },
  {
    "id": 54,
    "question": "Best practices for key management include all of the following except:",
    "choice_a": "Have key recovery processes",
    "choice_b": "Maintain key security",
    "choice_c": "Pass keys out of band",
    "choice_d": "Ensure multifactor authentication",
    "correct_answer": "D",
    "explanation": "We should do all of the following except for requiring multifactor authentication, which is pointless in key management.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      418,
      419,
      420,
      719,
      395
    ],
    "source": ""
  },
  {
    "id": 55,
    "question": "Cryptographic keys should be secured ______.",
    "choice_a": "To a level at least as high as the data they can decrypt",
    "choice_b": "In vaults",
    "choice_c": "By armed guards",
    "choice_d": "With two person integrity",
    "correct_answer": "A",
    "explanation": "The physical security of crypto keys is of some concern, but guards or vaults are not always necessary. Two person integrity might be a good practice for protecting keys. The best answer to this question is option A, because it is always true, whereas the remaining options depend on circumstances.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      418,
      41,
      35,
      387,
      515
    ],
    "source": ""
  },
  {
    "id": 56,
    "question": "When crafting plans and policies for data archiving, we should consider all of the following except:",
    "choice_a": "Archive location",
    "choice_b": "The backup process",
    "choice_c": "The format of the data",
    "choice_d": "Immediacy of the technology",
    "correct_answer": "D",
    "explanation": "All of the following things should be considered when creating data archival policies, except option D, which is a nonsense term.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      34,
      36,
      37,
      35,
      29
    ],
    "source": ""
  },
  {
    "id": 57,
    "question": "What is the correct order of the phases of the data life cycle?",
    "choice_a": "Create, Store, Use, Archive, Share, Destroy",
    "choice_b": "Create, Store, Use, Share, Archive, Destroy",
    "choice_c": "Create, Use, Store, Share, Archive, Destroy",
    "choice_d": "Create, Archive, Store, Share, Use, Destroy",
    "correct_answer": "B",
    "explanation": "The other options are the names of the phases, but out of proper order.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      493,
      497,
      496,
      34,
      36
    ],
    "source": ""
  },
  {
    "id": 58,
    "question": "What are third party providers of Identity and access management (IAM) functions for the cloud environment?",
    "choice_a": "Data loss prevention (DLPs)",
    "choice_b": "Cloud Access Security Brokers (CASBs)",
    "choice_c": "Security information and event Management (SIEMs)",
    "choice_d": "Advanced Encryption Standard (AESs)",
    "correct_answer": "B",
    "explanation": "Data loss, leak prevention, and protection is a family of tools used to reduce the possibility of unauthorized disclosure of sensitive information. Security information and event Management (SIEMs) are tools used to collate and manage log data. Advanced Encryption Standard (AES) is an encryption standard.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      31,
      32,
      33,
      394,
      395
    ],
    "source": ""
  },
  {
    "id": 59,
    "question": "What is a cloud storage architecture that manages the data in a hierarchy of files?",
    "choice_a": "Object based storage",
    "choice_b": "File based storage",
    "choice_c": "Database",
    "choice_d": "Content delivery network (CDN)",
    "correct_answer": "B",
    "explanation": "Object based storage stores data as objects in a volume, with labels and metadata. Databases store data in fields, in a relational motif. A Content delivery network (CDN) stores data in caches of copied content near locations of high demand.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      371,
      26,
      370,
      509,
      510
    ],
    "source": ""
  },
  {
    "id": 60,
    "question": "What is a cloud storage architecture that manages the data in caches of copied content close to locations of high demand?",
    "choice_a": "Object based storage",
    "choice_b": "File based storage",
    "choice_c": "Database",
    "choice_d": "Content delivery network (CDN)",
    "correct_answer": "D",
    "explanation": "Object based storage stores data as objects in a volume, with labels and metadata. File based is a cloud storage architecture that manages the data in a hierarchy of files. Databases store data in fields, in a relational motif.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      442,
      443,
      444,
      507,
      505
    ],
    "source": ""
  },
  {
    "id": 61,
    "question": "What is the term we use to describe the general ease and efficiency of moving data from one cloud provider either to another cloud provider or down from the cloud?",
    "choice_a": "Mobility",
    "choice_b": "Elasticity",
    "choice_c": "Obfuscation",
    "choice_d": "Portability",
    "correct_answer": "D",
    "explanation": "Elasticity is the name for the benefit of cloud computing where resources can be apportioned as necessary to meet customer demand. Obfuscation is a technique to hide full raw datasets, either from personnel who do not have need to know or for use in testing. Mobility is not a term pertinent to the CBK.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      1,
      12,
      8,
      237
    ],
    "source": ""
  },
  {
    "id": 62,
    "question": "The various models generally available for cloud Business Continuity (BC) / Disaster Recovery (DR) activities include all of the following except:",
    "choice_a": "Private architecture, cloud backup",
    "choice_b": "Cloud provider, backup from same provider",
    "choice_c": "Cloud provider, backup from another cloud provider",
    "choice_d": "Cloud provider,  backup from private provider",
    "correct_answer": "D",
    "explanation": "This is not a normal configuration and would not likely provide genuine benefit.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      159,
      162,
      161,
      167,
      229
    ],
    "source": ""
  },
  {
    "id": 63,
    "question": "Countermeasures for protecting cloud operations against external attackers include all of the following except:",
    "choice_a": "Continual monitoring for anomalous activity",
    "choice_b": "Detailed and extensive background checks",
    "choice_c": "Hardened devices and systems, including servers, hosts, hypervisors, and virtual machines",
    "choice_d": "Regular and detailed configuration/change management activities",
    "correct_answer": "B",
    "explanation": "Background checks are controls for attenuating potential threats from internal actors; external threats aren't likely to submit to background checks.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      241,
      243,
      534,
      536,
      60
    ],
    "source": ""
  },
  {
    "id": 64,
    "question": "All of the following are techniques to enhance the portability of cloud data, in order to minimize the potential of vendor lock in except:",
    "choice_a": "Avoid proprietary data formats",
    "choice_b": "Use Digital rights management (DRM) and Data loss prevention (DLP) solutions widely throughout the cloud operation",
    "choice_c": "Ensure there are no physical limitations to moving",
    "choice_d": "Ensure favorable contract terms to support portability",
    "correct_answer": "B",
    "explanation": "Digital rights management (DRM) and Data loss prevention (DLP) are used for increased authentication/access control and egress monitoring, respectively, and would actually decrease portability instead of enhancing it.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      229,
      230,
      170,
      185
    ],
    "source": ""
  },
  {
    "id": 65,
    "question": "Which of the following is a technique used to attenuate risks to the cloud environment, resulting in loss or theft of a device used for remote access?",
    "choice_a": "Remote kill switch",
    "choice_b": "Dual control",
    "choice_c": "Muddling",
    "choice_d": "Safe harbor",
    "correct_answer": "A",
    "explanation": "Dual control is not useful for remote access devices, because we'd have to assign two people for every device, which would decrease efficiency and productivity. Muddling is a cocktail preparation technique that involves crushing ingredients. Safe harbor is a policy provision that allows for compliance through an alternate method than the primary instruction.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      58,
      57,
      59,
      44,
      62
    ],
    "source": ""
  },
  {
    "id": 66,
    "question": "Each of the following are dependencies that must be considered when reviewing the Business impact analysis (BIA) after cloud migration except:",
    "choice_a": "The cloud provider's suppliers",
    "choice_b": "The cloud provider's vendors",
    "choice_c": "The cloud provider's utilities",
    "choice_d": "The cloud provider's resellers",
    "correct_answer": "D",
    "explanation": "The cloud provider's resellers are a marketing and sales mechanism, not an operational dependency that could affect the security of a cloud customer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      161,
      4,
      147,
      206
    ],
    "source": ""
  },
  {
    "id": 67,
    "question": "When reviewing the Business impact analysis (BIA) after a cloud migration, the organization should take into account new factors related to data breach impacts. One of these new factors is:",
    "choice_a": "Legal liability can't be transferred to the cloud provider.",
    "choice_b": "Many states have data breach notification laws.",
    "choice_c": "Breaches can cause the loss of proprietary data.",
    "choice_d": "Breaches can cause the loss of intellectual property.",
    "correct_answer": "A",
    "explanation": "State notification laws and the loss of proprietary data/intellectual property pre existed the cloud; only the lack of ability to transfer liability is new.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      237,
      224,
      199,
      173
    ],
    "source": ""
  },
  {
    "id": 68,
    "question": "The cloud customer will have the most control of their data and systems, and the cloud provider will have the least amount of responsibility, in which cloud computing arrangement?",
    "choice_a": "Infrastructure as a Service (IaaS)",
    "choice_b": "Platform as a Service (PaaS)",
    "choice_c": "Software as a Service (SaaS)",
    "choice_d": "Community cloud",
    "correct_answer": "A",
    "explanation": "Infrastructure as a Service (IaaS) entails the cloud customer installing and maintaining the OS, programs, and data; Platform as a Service (PaaS) has the customer installing programs and data; in Software as a Service (SaaS), the customer only uploads data. In a community cloud, data and device owners are distributed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      237,
      235,
      12,
      13
    ],
    "source": ""
  },
  {
    "id": 69,
    "question": "After a cloud migration, the Business impact analysis (BIA) should be updated to include a review of the new risks and impacts associated with cloud operations; this review should include an analysis of the possibility of vendor lock in/lock out. Analysis of this risk may not have to be performed as a new effort, because a lot of the material that would be included is already available from which of the following?",
    "choice_a": "National Institute of Standards and Technology (NIST)",
    "choice_b": "The cloud provider",
    "choice_c": "The cost benefit analysis the organization conducted when deciding on cloud migration",
    "choice_d": "Open source providers",
    "correct_answer": "C",
    "explanation": "National Institute of Standards and Technology (NIST) offers many informative guides and standards, but nothing specific to any one organization. The cloud provider will not have prepared an analysis of lock-out/lock-in potential. Open source providers can offer many useful materials, but, again, nothing specifc to the organization.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      220,
      226,
      225,
      6
    ],
    "source": ""
  },
  {
    "id": 70,
    "question": "A poorly negotiated cloud service contract could result in all of the following detrimental effects except:",
    "choice_a": "Vendor lock in",
    "choice_b": "Malware",
    "choice_c": "Unfavorable terms",
    "choice_d": "Lack of necessary services",
    "correct_answer": "B",
    "explanation": "Malware risks and threats are not affected by the terms of the cloud contract.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      232,
      229,
      231,
      237,
      215
    ],
    "source": ""
  },
  {
    "id": 71,
    "question": "Because of multitenancy, specific risks in the public cloud that don't exist in the other cloud service models include all of the following except:",
    "choice_a": "Risk of loss/disclosure due to legal seizures",
    "choice_b": "Information bleed",
    "choice_c": "DoS/DDoS",
    "choice_d": "Escalation of privilege",
    "correct_answer": "C",
    "explanation": "DoS/DDoS threats and risks are not unique to the public cloud model.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      11,
      9,
      216,
      215,
      12
    ],
    "source": ""
  },
  {
    "id": 72,
    "question": "Countermeasures for protecting cloud operations against internal threats include all of the following except:",
    "choice_a": "Aggressive background checks",
    "choice_b": "Hardened perimeter devices",
    "choice_c": "Skills and knowledge testing",
    "choice_d": "Extensive and comprehensive training programs, including initial, recurring, and refresher sessions",
    "correct_answer": "B",
    "explanation": "Hardened perimeter devices are more useful at attenuating the risk of external attack.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      276,
      216,
      223,
      146,
      227
    ],
    "source": ""
  },
  {
    "id": 73,
    "question": "Countermeasures for protecting cloud operations against internal threats include all of the following except:",
    "choice_a": "Active physical surveillance and monitoring",
    "choice_b": "Active electronic surveillance and monitoring",
    "choice_c": "Redundant ISPs",
    "choice_d": "Masking and obfuscation of data for all personnel without need to know for raw data",
    "correct_answer": "C",
    "explanation": "ISP redundancy is a means to control the risk of externalities, not internal threats.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      216,
      215,
      222,
      223,
      138
    ],
    "source": ""
  },
  {
    "id": 74,
    "question": "Countermeasures for protecting cloud operations against internal threats include all of the following except:",
    "choice_a": "Broad contractual protections to ensure the provider is ensuring an extreme level of trust in its own personnel",
    "choice_b": "Financial penalties for the cloud provider in the event of negligence or malice on the part of its own personnel",
    "choice_c": "Data loss prevention (DLP) solutions",
    "choice_d": "Scalability",
    "correct_answer": "D",
    "explanation": "Scalability is a feature of cloud computing, allowing users to dictate an increase or decrease in service as needed, not a means to counter internal threats.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      216,
      146,
      192,
      13,
      3
    ],
    "source": ""
  },
  {
    "id": 75,
    "question": "Countermeasures for protecting cloud operations against internal threats include all of the following except:",
    "choice_a": "Separation of duties",
    "choice_b": "Least privilege",
    "choice_c": "Conflict of interest",
    "choice_d": "Mandatory vacation",
    "correct_answer": "C",
    "explanation": "Conflict of interest is a threat, not a control.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      215,
      216,
      224,
      276,
      146
    ],
    "source": ""
  },
  {
    "id": 76,
    "question": "Benefits for addressing Business Continuity (BC) / Disaster Recovery (DR) offered by cloud operations include all of the following except:",
    "choice_a": "Metered service",
    "choice_b": "Distributed, remote processing, and storage of data",
    "choice_c": "Fast replication",
    "choice_d": "Regular backups offered by cloud providers",
    "correct_answer": "A",
    "explanation": "Metered service allows cloud customers to minimize expenses, and only pay for what they need and use this has nothing to do with Business Continuity (BC) / Disaster Recovery (DR).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      159,
      161,
      135,
      137
    ],
    "source": ""
  },
  {
    "id": 77,
    "question": "All of the following methods can be used to attenuate the harm caused by escalation of privilege except:",
    "choice_a": "Extensive access control and authentication tools and techniques",
    "choice_b": "Analysis and review of all log data by trained, skilled personnel on a frequent basis",
    "choice_c": "Periodic and effective use of cryptographic sanitization tools",
    "choice_d": "The use of automated analysis tools such as Security information Management (SIM), Security information and event Management (SIEM), and Security event Management (SEM) solutions",
    "correct_answer": "C",
    "explanation": "Cryptographic sanitization is a means of reducing the risks from data remnance, not a way to minimize escalation of privilege.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      215,
      222,
      216,
      144,
      276
    ],
    "source": ""
  },
  {
    "id": 78,
    "question": "What is the hypervisor malicious attackers would prefer to attack?",
    "choice_a": "Type 1",
    "choice_b": "Type 2",
    "choice_c": "Type 3",
    "choice_d": "Type 4",
    "correct_answer": "B",
    "explanation": "Attackers prefer Type 2 hypervisors, because the OS offers more attack surface and potential vulnerabilities. There are no Type 3 or 4 hypervisors.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      14,
      142,
      455,
      244,
      22
    ],
    "source": ""
  },
  {
    "id": 79,
    "question": "What is the term used to describe loss of access to data because the cloud provider has ceased operation?",
    "choice_a": "Closing",
    "choice_b": "Vendor lock out",
    "choice_c": "Vendor lock in",
    "choice_d": "Masking",
    "correct_answer": "B",
    "explanation": "Vendor lock-in is the result of a lack of portability, for any number of reasons. Masking is a means to hide raw datasets from users who do not have need to know. Closing is a nonsense term.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      229,
      230,
      187,
      170
    ],
    "source": ""
  },
  {
    "id": 80,
    "question": "Because Platform as a Service (PaaS) implementations are so often used for software development, what is one of the vulnerabilities that should always be kept in mind?",
    "choice_a": "Malware",
    "choice_b": "Loss/theft of portable devices",
    "choice_c": "Backdoors",
    "choice_d": "DoS/DDoS",
    "correct_answer": "C",
    "explanation": "Software developers often install backdoors as a means to avoid performing entire work flows when adjusting the programs they're working; they often leave backdoors behind in production software, inadvertently or intentionally.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      23,
      8,
      227,
      216,
      215
    ],
    "source": ""
  },
  {
    "id": 81,
    "question": "What is the cloud service model in which the customer is responsible for administration of the OS?",
    "choice_a": "Infrastructure as a Service (IaaS)",
    "choice_b": "Platform as a Service (PaaS)",
    "choice_c": "Software as a Service (SaaS)",
    "choice_d": "QaaS",
    "correct_answer": "A",
    "explanation": "In Infrastructure as a Service (IaaS), the cloud provider only owns the hardware and supplies the utilities. The customer is responsible for the OS, programs, and data. In Platform as a Service (PaaS) and Software as a Service (SaaS), the provider also owns the OS. There is no QaaS. That is a red herring.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      12,
      237,
      13,
      1
    ],
    "source": ""
  },
  {
    "id": 82,
    "question": "To address shared monitoring and testing responsibilities in a cloud configuration, the provider might offer all these to the cloud customer except:",
    "choice_a": "Access to audit logs and performance data",
    "choice_b": "SIM, SIEM, and SEM logs",
    "choice_c": "Data loss prevention (DLP) solution results",
    "choice_d": "Security control administration",
    "correct_answer": "D",
    "explanation": "While the provider might share any of the other options listed, the provider will not share administration of security controls with the customer. Security controls are the sole province of the provider.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      237,
      12,
      13,
      147,
      146
    ],
    "source": ""
  },
  {
    "id": 83,
    "question": "In addition to whatever audit results the provider shares with the customer, what other mechanism does the customer have to ensure trust in the provider's performance and duties?",
    "choice_a": "Statutes",
    "choice_b": "The contract",
    "choice_c": "Security control matrix",
    "choice_d": "Health Insurance Portability and Accountability Act (HIPAA)",
    "correct_answer": "B",
    "explanation": "The contract between the provider and customer enhances the customer's trust by holding the provider financially liable for negligence or inadequate service (although the customer remains legally liable for all inadvertent disclosures). Statutes, however, largely leave customers liable. The security control matrix is a tool for ensuring compliance with regulations. Health Insurance Portability and Accountability Act (HIPAA) is a statute.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      237,
      232,
      170,
      12,
      224
    ],
    "source": ""
  },
  {
    "id": 84,
    "question": "Which kind of SSAE audit report is a cloud customer most likely to receive from a cloud provider?",
    "choice_a": "SOC 1 Type 1",
    "choice_b": "SOC 2 Type 2",
    "choice_c": "SOC 1 Type 2",
    "choice_d": "SOC 3",
    "correct_answer": "D",
    "explanation": "The SOC 3 is the least detailed, so the provider is not concerned about revealing it. The SOC 1 Types 1 and 2 are about financial reporting, and not relevant. The SOC 2 Type 2 is much more detailed and will most likely be kept closely held by the provider.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      267,
      205,
      265,
      266,
      204
    ],
    "source": ""
  },
  {
    "id": 85,
    "question": "Which kind of SSAE audit report is most beneficial for a cloud customer, even though it's unlikely the cloud provider will share it?",
    "choice_a": "SOC 1 Type 1",
    "choice_b": "SOC 2 Type 2",
    "choice_c": "SOC 1 Type 2",
    "choice_d": "SOC 3",
    "correct_answer": "B",
    "explanation": "The SOC 3 is the least detailed, so the provider is not concerned about revealing it. The SOC 1 Types 1 and 2 are about financial reporting and not relevant. The SOC 2 Type 2 is much more detailed and will most likely be kept closely held by the provider.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      205,
      265,
      267,
      266,
      204
    ],
    "source": ""
  },
  {
    "id": 86,
    "question": "The auditor should not  ___________________.",
    "choice_a": "Review documents",
    "choice_b": "Physically visit the business location",
    "choice_c": "Perform system scans",
    "choice_d": "Deliver consulting services",
    "correct_answer": "D",
    "explanation": "The auditor should be impartial to the success of the target organization; consulting creates a conflict of interest.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      260,
      259,
      170,
      215,
      222
    ],
    "source": ""
  },
  {
    "id": 87,
    "question": "Hardening the operating system refers to all of the following except:",
    "choice_a": "Limiting administrator access",
    "choice_b": "Removing antimalware agents",
    "choice_c": "Closing unused ports",
    "choice_d": "Removing unnecessary services and libraries",
    "correct_answer": "B",
    "explanation": "Removing antimalware agents. Hardening the operating system means making it more secure. Limiting administrator access, closing unused ports, and removing unnecessary services and libraries all have the potential to make an OS more secure. But removing anti malware agents would actually make the system less secure. If anything, antimalware agents should be added, not removed.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      262,
      263,
      264,
      104,
      102
    ],
    "source": ""
  },
  {
    "id": 88,
    "question": "The cloud customer's trust in the cloud provider can be enhanced by all of the following except:",
    "choice_a": "Audits",
    "choice_b": "Shared administration",
    "choice_c": "Real time video surveillance",
    "choice_d": "Service level agreements (SLAs)",
    "correct_answer": "C",
    "explanation": "Video surveillance will not provide meaningful information and will not enhance trust. All the others will and do.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      267,
      192,
      237,
      12,
      147
    ],
    "source": ""
  },
  {
    "id": 89,
    "question": "User access to the cloud environment can be administered in all of the following ways except:",
    "choice_a": "Customer directly administers access",
    "choice_b": "Customer provides administration on behalf of the provider",
    "choice_c": "Provider provides administration on behalf the customer",
    "choice_d": "Third party provides administration on behalf of the customer",
    "correct_answer": "B",
    "explanation": "The customer does not administer on behalf of the provider. All the rest are possible options.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      12,
      480,
      237,
      13,
      487
    ],
    "source": ""
  },
  {
    "id": 90,
    "question": "Which kind of SSAE audit reviews controls dealing with the organization's controls for assuring the confidentiality, integrity, and availability of data?",
    "choice_a": "SOC 1",
    "choice_b": "SOC 2",
    "choice_c": "SOC 3",
    "choice_d": "SOC 4",
    "correct_answer": "B",
    "explanation": "SOC 2 deals with the CIA triad. SOC 1 is for financial reporting. SOC 3 is only an attestation by the auditor. There is no SOC 4.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      265,
      205,
      266,
      16,
      267
    ],
    "source": ""
  },
  {
    "id": 91,
    "question": "Which kind of SSAE report comes with a seal of approval from a certified auditor?",
    "choice_a": "SOC 1",
    "choice_b": "SOC 2",
    "choice_c": "SOC 3",
    "choice_d": "SOC 4",
    "correct_answer": "C",
    "explanation": "SOC 2 deals with the CIA triad. SOC 1 is for financial reporting. SOC 3 is only an attestation by the auditor. There is no SOC 4.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      205,
      265,
      267,
      259,
      456
    ],
    "source": ""
  },
  {
    "id": 92,
    "question": "Which of the following is a cloud provider likely to provide to its customers in order to enhance the customer's trust in the provider?",
    "choice_a": "Site visit access",
    "choice_b": "Financial reports to shareholders",
    "choice_c": "Audit and performance log data",
    "choice_d": "Backend administrative access",
    "correct_answer": "C",
    "explanation": "The provider may share audit and performance log data with the customer. The provider will most likely not share any of the other options, since they reveal too much information about the provider's security program.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      267,
      204,
      12,
      237,
      192
    ],
    "source": ""
  },
  {
    "id": 93,
    "question": "In all cloud models, the customer will be given access and ability to modify which of the following?",
    "choice_a": "Data",
    "choice_b": "Security controls",
    "choice_c": "User permissions",
    "choice_d": "OS",
    "correct_answer": "A",
    "explanation": "The customer always owns the data and will therefore always have access to it. The customer will never have administrative access to the security controls, regardless of the model. The customer may or may not have administrative control over user permissions. The customer only has administrative power over the OS in an Infrastructure as a Service (IaaS) model.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      12,
      237,
      8,
      235,
      13
    ],
    "source": ""
  },
  {
    "id": 94,
    "question": "In all cloud models, security controls are driven by which of the following?",
    "choice_a": "Virtualization engine",
    "choice_b": "Hypervisor",
    "choice_c": "Service level agreements (SLAs)",
    "choice_d": "Business requirements",
    "correct_answer": "D",
    "explanation": "Security is always contingent on business drivers and beholden to operational needs. The virtualization engine does not dictate security controls, and the hypervisor may vary (depending on its type and implementation). The Service level agreements (SLAs) do not drive security controls; they drive performance goals.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      238,
      241,
      448,
      535,
      538
    ],
    "source": ""
  },
  {
    "id": 95,
    "question": "In all cloud models, the ________ will retain ultimate liability and responsibility for any data loss or disclosure.",
    "choice_a": "Vendor",
    "choice_b": "Customer",
    "choice_c": "State",
    "choice_d": "Administrator",
    "correct_answer": "B",
    "explanation": "The customer currently always retains legal liability for data loss, even if the provider was negligent or malicious.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      237,
      12,
      13,
      231,
      174
    ],
    "source": ""
  },
  {
    "id": 96,
    "question": "Why will cloud providers be unlikely to allow physical access to their datacenters?",
    "choice_a": "They want to enhance security by keeping information about physical layout and controls confidential.",
    "choice_b": "They want to enhance exclusivity for their customers, so only an elite tier of higherpaying clientele will be allowed physical access.",
    "choice_c": "They want to minimize traffic in those areas, to maximize efficiency of operational personnel.",
    "choice_d": "Most datacenters are inhospitable to human life, so minimizing physical access also minimizes safety concerns.",
    "correct_answer": "A",
    "explanation": "Knowledge of the physical layout and site controls could be of great use to an attacker, so they are kept extremely confidential. The other options are all red herrings.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      344,
      360,
      362,
      361,
      650
    ],
    "source": ""
  },
  {
    "id": 97,
    "question": "Which type of software is most likely to be reviewed by the most personnel, with the most varied perspectives?",
    "choice_a": "Database management software",
    "choice_b": "Open source software",
    "choice_c": "Secure software",
    "choice_d": "Proprietary software",
    "correct_answer": "B",
    "explanation": "Open source software is available to the public, and often draws inspection from numerous, disparate reviewers. A DBMS is not reviewed more or less than other software. All software in a production environment should be secure. That is not a valid discriminator for answering this question. Proprietary software reviews are limited to the personnel employed within the offices of the software developer, which narrows the perspective and necessarily reduces the amount of potential reviewers.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      268,
      269,
      270,
      74,
      73
    ],
    "source": ""
  },
  {
    "id": 98,
    "question": "A firewall can use all of the following techniques for controlling traffic except:",
    "choice_a": "Rule sets",
    "choice_b": "Behavior analysis",
    "choice_c": "Content filtering",
    "choice_d": "Randomization",
    "correct_answer": "D",
    "explanation": "Firewalls do use rules, behavior analytics, and/or content filtering in order to determine which traffic is allowable. Firewalls ought not use random criteria, because any such limitations would be just as likely to damage production efforts as enhance them.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      271,
      272,
      273,
      469,
      206
    ],
    "source": ""
  },
  {
    "id": 99,
    "question": "A honeypot should contain ______ data.",
    "choice_a": "Raw",
    "choice_b": "Production",
    "choice_c": "Useless",
    "choice_d": "Sensitive",
    "correct_answer": "C",
    "explanation": "A honeypot is meant to draw in attackers but not divulge anything of value. It should not use raw, production, or sensitive data.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      274,
      276,
      473,
      223,
      199
    ],
    "source": ""
  },
  {
    "id": 100,
    "question": "Vulnerability assessments cannot detect which of the following?",
    "choice_a": "Malware",
    "choice_b": "Defined vulnerabilities",
    "choice_c": "Zero day exploits",
    "choice_d": "Programming flaws",
    "correct_answer": "C",
    "explanation": "Vulnerability assessments can only detect known vulnerabilities, using definitions. Some malware is known, as are programming flaws. Zero-day exploits, on the other hand, are necessarily unknown, until discovered and exercised by an attacker, and will therefore not be detected by vulnerability assessments.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      215,
      228,
      221,
      222,
      233
    ],
    "source": ""
  },
  {
    "id": 101,
    "question": "Which of the following best represents the REST approach to APIs?",
    "choice_a": "Built on protocol standards",
    "choice_b": "Lightweight and scalable",
    "choice_c": "Relies heavily on XML",
    "choice_d": "Only supports XML output",
    "correct_answer": "B",
    "explanation": "The other answers all list aspects of SOAP.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      398,
      566,
      707,
      451,
      288
    ],
    "source": ""
  },
  {
    "id": 102,
    "question": "Which of the following is not one of the SDLC phases?",
    "choice_a": "Define",
    "choice_b": "Reject",
    "choice_c": "Design",
    "choice_d": "Test",
    "correct_answer": "B",
    "explanation": "The other answers are all possible stages used in software development.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      295,
      280,
      300,
      441,
      439
    ],
    "source": ""
  },
  {
    "id": 103,
    "question": "Which of the following is not a component of the of the STRIDE model?",
    "choice_a": "Spoofing",
    "choice_b": "Repudiation",
    "choice_c": "Information disclosure",
    "choice_d": "External pen testing",
    "correct_answer": "D",
    "explanation": "The other answers all include aspects of the STRIDE model.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      293,
      292,
      295,
      280,
      282
    ],
    "source": ""
  },
  {
    "id": 104,
    "question": "Which of the following best describes SAST?",
    "choice_a": "A set of technologies that analyze application source code, and bit code for coding and design problems that would indicate a security problem or vulnerability",
    "choice_b": "A set of technologies that analyze application bit code, and binaries for coding and design problems that would indicate a security problem or vulnerability",
    "choice_c": "A set of technologies that analyze application source code, byte code, and binaries for coding and design problems that would indicate a security problem or vulnerability",
    "choice_d": "A set of technologies that analyze application source code for coding and design problems that would indicate a security problem or vulnerability",
    "correct_answer": "C",
    "explanation": "All the possible answers are good, and are, in fact, correct. C, however, is the most complete and therefore the best answer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 105,
    "question": "Which of the following best describes data masking?",
    "choice_a": "A method where the last few numbers in a dataset are not obscured. These are often used for authentication.",
    "choice_b": "A method for creating similar but inauthentic datasets used for software testing and user training.",
    "choice_c": "A method used to protect prying eyes from data such as social security numbers and credit card data.",
    "choice_d": "Data masking involves stripping out all similar digits in a string of numbers so as to obscure the original number.",
    "correct_answer": "B",
    "explanation": "Again, all of the following answers are actually correct, but B is the best answer, because it is the most general, includes the others, and is therefore the optimum choice. This is a good example of the type of question that can appear on the actual exam.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      431,
      82,
      286,
      585,
      81
    ],
    "source": ""
  },
  {
    "id": 106,
    "question": "Which of the following best describes a sandbox?",
    "choice_a": "An isolated space where transactions are protected from malicious software",
    "choice_b": "A space where you can safely execute malicious code to see what it does",
    "choice_c": "An isolated space where untested code and experimentation can safely occur separate from the production environment",
    "choice_d": "An isolated space where untested code and experimentation can safely occur within the production environment",
    "correct_answer": "C",
    "explanation": "Options A and B are also correct, but C is more general and incorporates them both. D is incorrect, because sandboxing does not take place in the production environment.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      283,
      284,
      285,
      90,
      82
    ],
    "source": ""
  },
  {
    "id": 107,
    "question": "Identity and access management (IAM) is a security discipline that ensures which of the following?",
    "choice_a": "That all users are properly authorized",
    "choice_b": "That the right individual gets access to the right resources at the right time for the right reasons",
    "choice_c": "That all users are properly authenticated",
    "choice_d": "That unauthorized users will get access to the right resources at the right time for the right reasons",
    "correct_answer": "B",
    "explanation": "Options A and C are also correct, but included in B, making B the best choice. D is incorrect, because we don't want unauthorized users gaining access.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      288,
      367,
      436,
      437,
      583
    ],
    "source": ""
  },
  {
    "id": 108,
    "question": "In a federated identity arrangement using a trusted third party model, who is the identity provider and who is the relying party?",
    "choice_a": "A contracted third party/the various member organizations of the federation",
    "choice_b": "The users of the various organizations within the federation/a CASB",
    "choice_c": "Each member organization/a trusted third party",
    "choice_d": "Each member organization/each member organization",
    "correct_answer": "A",
    "explanation": "In a trusted third-party model of federation, each member organization outsources the review and approval task to a third party they all trust. This makes the third party the identifer (it issues and manages identities for all users in all organizations in the federation), and the various member organizations are the relying parties (the resource providers that share resources based on approval from the third party).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      369,
      367,
      368,
      695,
      576
    ],
    "source": ""
  },
  {
    "id": 109,
    "question": "Which of the following best describes the Organizational Normative Framework (ONF)?",
    "choice_a": "A container for components of an application's security, best practices, catalogued and leveraged by the organization",
    "choice_b": "A framework of containers for all components of application security, best practices, catalogued and leveraged by the organization",
    "choice_c": "A set of application security, and best practices, catalogued and leveraged by the organization",
    "choice_d": "A framework of containers for some of the components of application security, best practices, catalogued and leveraged by the organization",
    "correct_answer": "B",
    "explanation": "Option A is incorrect, because it refers to a specific applications security elements, meaning it is about an Application normative framework (ANF), not the Organizational Normative Framework (ONF). C is true, but not as complete as B, making B the better choice. D suggests that the framework contains only \"some\" of the components, which is why B (which describes \"all\" components) is better.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      417,
      415,
      432,
      93,
      573
    ],
    "source": ""
  },
  {
    "id": 110,
    "question": "APIs are defined as which of the following?",
    "choice_a": "A set of protocols, and tools for building software applications to access a web based software application or tool",
    "choice_b": "A set of standards for building software applications to access a web based software application or tool",
    "choice_c": "A set of routines, standards, protocols, and tools for building software applications to access a web based software application or tool",
    "choice_d": "A set of routines and tools for building software applications to access web based software applications",
    "correct_answer": "C",
    "explanation": "All the answers are true, but C is the most complete.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      397,
      399,
      568,
      566,
      704
    ],
    "source": ""
  },
  {
    "id": 111,
    "question": "The application normative framework is best described as which of the following?",
    "choice_a": "A stand alone framework for storing security practices for the Organizational Normative Framework (ONF)",
    "choice_b": "A subset of the Organizational Normative Framework (ONF)",
    "choice_c": "A superset of the Organizational Normative Framework (ONF)",
    "choice_d": "The complete Organizational Normative Framework (ONF)",
    "correct_answer": "B",
    "explanation": "Remember, there is a one-to-many ratio of Organizational Normative Framework (ONF) to Application normative framework (ANF); each organization has one Organizational Normative Framework (ONF) and many ANFs (one for each application in the organization). Therefore, the Application normative framework (ANF) is a subset of the Organizational Normative Framework (ONF).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      417,
      415,
      432,
      295,
      300
    ],
    "source": ""
  },
  {
    "id": 112,
    "question": "Which of the following best describes SAML?",
    "choice_a": "A standard for developing secure application management logistics",
    "choice_b": "A standard for exchanging authentication and authorization data between security domains",
    "choice_c": "A standard for exchanging usernames and passwords across devices",
    "choice_d": "A standard used for directory synchronization",
    "correct_answer": "B",
    "explanation": "Option C is also true, but not as comprehensive as B. A and D are simply not true.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      560,
      585,
      436,
      288,
      577
    ],
    "source": ""
  },
  {
    "id": 113,
    "question": "Which of the following best describes the purpose and scope of International Organization for Standardization (ISO)/International electrotechnical commission (IEC) 27034 1?",
    "choice_a": "Describes international privacy standards for cloud computing",
    "choice_b": "Provides an overview of application security that introduces definitive concepts, principles, and processes involved in application security",
    "choice_c": "Serves as a newer replacement for National Institute of Standards and Technology (NIST) 800 53 r4",
    "choice_d": "Provides an overview of network and infrastructure security designed to secure cloud applications",
    "correct_answer": "B",
    "explanation": "Option B is a description of the standard; the others are not.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 114,
    "question": "Which of the following best describes data masking?",
    "choice_a": "Data masking is used in place of encryption for better performance.",
    "choice_b": "Data masking is used to hide Personally identifiable information (PII).",
    "choice_c": "Data masking is used to create a similar, inauthentic dataset used for training and software testing.",
    "choice_d": "Data masking is used in place of production data.",
    "correct_answer": "C",
    "explanation": "Options B and D are also correct, but not as comprehensive as C, making C the best choice. A is not correct; we don't want to encrypt data if we're using the data for testing or display purposes, the common uses of masked data.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      284,
      431,
      82,
      288,
      570
    ],
    "source": ""
  },
  {
    "id": 115,
    "question": "Database activity monitoring (DAM) can be:",
    "choice_a": "Host based or network based",
    "choice_b": "Reactive or imperative",
    "choice_c": "Used in the place of encryption",
    "choice_d": "Used in place of data masking",
    "correct_answer": "A",
    "explanation": "We don't use DAM in place of encryption or masking; DAM augments these options without replacing them. \u201cReactive or imperative\u201d has no meaning in this context, and is only a distractor.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      431,
      578,
      432,
      579,
      430
    ],
    "source": ""
  },
  {
    "id": 116,
    "question": "WAFs operate at OSI Layer ___________________.",
    "choice_a": "1",
    "choice_b": "3",
    "choice_c": "5",
    "choice_d": "7",
    "correct_answer": "D",
    "explanation": "WAFs operate at Layer 7 of the OSI model.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      579,
      430,
      577,
      453,
      431
    ],
    "source": ""
  },
  {
    "id": 117,
    "question": "Multifactor authentication consists of at least two items. Which of the following best represents this concept?",
    "choice_a": "A complex password and a secret code",
    "choice_b": "Complex passwords and an HSM",
    "choice_c": "A hardware token and a magnetic strip card",
    "choice_d": "Something you know and something you have",
    "correct_answer": "D",
    "explanation": "Option D is the best, most general, and most accurate answer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      436,
      438,
      437,
      288,
      585
    ],
    "source": ""
  },
  {
    "id": 118,
    "question": "SOAP is a protocol specification providing for the exchange of structured information or data in web services. Which of the following is not true of SOAP?",
    "choice_a": "Standards based",
    "choice_b": "Reliant on XML",
    "choice_c": "Extremely fast",
    "choice_d": "Works over numerous protocols",
    "correct_answer": "C",
    "explanation": "The other answers are true of SOAP.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      559,
      398,
      705,
      560,
      574
    ],
    "source": ""
  },
  {
    "id": 119,
    "question": "Dynamic application security testing (DAST) is best described as which of the following?",
    "choice_a": "Test performed on an application or software product while it is using real data in production",
    "choice_b": "Test performed on an application or software product while it is being executed in memory in an operating system.",
    "choice_c": "Test performed on an application or software product while being consumed by cloud customers",
    "choice_d": "Masking",
    "correct_answer": "B",
    "explanation": "We do the testing prior to deployment, so A and C are incorrect. D is simply a distractor.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      300,
      298,
      283,
      284,
      285
    ],
    "source": ""
  },
  {
    "id": 120,
    "question": "Sandboxing provides which of the following?",
    "choice_a": "A test environment that isolates untrusted code changes for testing in a production environment",
    "choice_b": "A test environment that isolates untrusted code changes for testing in a nonproduction environment",
    "choice_c": "A testing environment where new and experimental code can be tested in a production environment",
    "choice_d": "A testing environment that prevents isolated code from running in a nonproduction environment",
    "correct_answer": "B",
    "explanation": "Options A and C are incorrect, because a sandbox is not in the production environment. D is incorrect in that sandboxing does not prevent code from running.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      283,
      284,
      285,
      298,
      299
    ],
    "source": ""
  },
  {
    "id": 121,
    "question": "What is the lowest tier of datacenter redundancy, according to the Uptime Institute?",
    "choice_a": "1",
    "choice_b": "V",
    "choice_c": "C",
    "choice_d": "4",
    "correct_answer": "A",
    "explanation": "There are four tiers of the Uptime Institute's datacenter redundancy rating system, with 1 being the lowest and 4 the highest.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      95,
      94,
      98,
      99,
      101
    ],
    "source": ""
  },
  {
    "id": 122,
    "question": "What is the amount of fuel that should be on hand to power generators for backup datacenter power, in all tiers, according to the Uptime Institute?",
    "choice_a": "1",
    "choice_b": "1,000 gallons",
    "choice_c": "12 hours",
    "choice_d": "As much as needed to ensure all systems may be gracefully shut down and data securely stored",
    "correct_answer": "C",
    "explanation": "The other answers are distractors.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      291,
      290,
      289,
      545,
      556
    ],
    "source": ""
  },
  {
    "id": 123,
    "question": "Which of the following is not one of the three types of training?",
    "choice_a": "Integral",
    "choice_b": "Initial",
    "choice_c": "Recurring",
    "choice_d": "Refresher",
    "correct_answer": "A",
    "explanation": "The three common types of security training are initial, recurring, and refresher.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      581,
      580,
      582,
      416,
      436
    ],
    "source": ""
  },
  {
    "id": 124,
    "question": "Which of the following is part of the STRIDE model?",
    "choice_a": "Repudiation",
    "choice_b": "Redundancy",
    "choice_c": "Resiliency",
    "choice_d": "Rijndael",
    "correct_answer": "A",
    "explanation": "Repudiation is an element of the STRIDE model; the rest of the answers are not.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      293,
      292,
      295,
      282,
      294
    ],
    "source": ""
  },
  {
    "id": 125,
    "question": "Which of the following is not part of the STRIDE model?",
    "choice_a": "Spoofing",
    "choice_b": "Tampering",
    "choice_c": "Resiliency",
    "choice_d": "Information disclosure",
    "correct_answer": "C",
    "explanation": "Resiliency is not an element of the STRIDE model; all the rest of the answers are.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      293,
      292,
      295,
      280,
      282
    ],
    "source": ""
  },
  {
    "id": 126,
    "question": "Which of the following is not a feature of SAST?",
    "choice_a": "Source code review",
    "choice_b": "Team building efforts",
    "choice_c": "\"White box\" testing",
    "choice_d": "Highly skilled, often expensive outside consultants",
    "correct_answer": "B",
    "explanation": "Team building has nothing to do with SAST; all the rest of the answers are characteristics of SAST.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      295,
      296,
      678,
      293,
      432
    ],
    "source": ""
  },
  {
    "id": 127,
    "question": "Which of the following is not a feature of DAST?",
    "choice_a": "Testing in runtime",
    "choice_b": "User teams performing executable testing",
    "choice_c": "\"Black box\" testing",
    "choice_d": "Binary inspection",
    "correct_answer": "D",
    "explanation": "Binary inspection has nothing to do with DAST, and it is not really a term that means anything in our industry (although it could be interpreted as a type of code review, more related to SAST); all the rest of the answers are characteristics of DAST.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      106,
      98,
      97,
      102,
      112
    ],
    "source": ""
  },
  {
    "id": 128,
    "question": "Which of the following is not a feature of a secure KVM component?",
    "choice_a": "Keystroke logging",
    "choice_b": "Sealed exterior case",
    "choice_c": "Welded chipsets",
    "choice_d": "Push button selectors",
    "correct_answer": "A",
    "explanation": "Keystroke logging is not a characteristic of secure KVM design; in fact, secure KVM components should attenuate the potential for keystroke logging. All the rest of the answers are characteristics of secure KVM components.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      305,
      304,
      603,
      108,
      100
    ],
    "source": ""
  },
  {
    "id": 129,
    "question": "What type of redundancy can we expect to find in a datacenter of any tier?",
    "choice_a": "All operational components",
    "choice_b": "All infrastructure",
    "choice_c": "Emergency egress",
    "choice_d": "Full power capabilities",
    "correct_answer": "C",
    "explanation": "Emergency egress redundancy is the only aspect of datacenters that can be expected to be found in datacenters of any tier; the rest of the answers list characteristics that can be found only in specific tiers.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      589,
      590,
      95,
      94,
      107
    ],
    "source": ""
  },
  {
    "id": 130,
    "question": "What should be the primary focus of datacenter redundancy and contingency planning?",
    "choice_a": "Critical path/operations",
    "choice_b": "Health and human safety",
    "choice_c": "Infrastructure supporting the production environment",
    "choice_d": "Power and HVAC",
    "correct_answer": "B",
    "explanation": "Regardless of the tier level or purpose of any datacenter, design focus for security should always consider health and human safety paramount.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      642,
      590,
      95,
      594,
      636
    ],
    "source": ""
  },
  {
    "id": 131,
    "question": "Which of the following techniques for ensuring cloud datacenter storage resiliency uses parity bits and disk striping?",
    "choice_a": "Cloud bursting",
    "choice_b": "RAID",
    "choice_c": "Data dispersion",
    "choice_d": "SAN",
    "correct_answer": "B",
    "explanation": "Parity bits and disk striping are characteristic of RAID implementations. Cloud bursting is a feature of scalable cloud hosting. Data dispersion uses parity bits, but not disk striping; instead, it uses data chunks and encryption. SAN is a data storage technique, but not focused on resiliency.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      609,
      607,
      615,
      94,
      96
    ],
    "source": ""
  },
  {
    "id": 132,
    "question": "Which resiliency technique attenuates the possible loss of functional capabilities during contingency operations?",
    "choice_a": "Cross training",
    "choice_b": "Metered usage",
    "choice_c": "Proper placement of HVAC temperature measurements tools",
    "choice_d": "Raised floors",
    "correct_answer": "A",
    "explanation": "Cross-training offers attenuation of lost contingency capabilities by ensuring personnel will be able to perform essential tasks, even if they are not primarily assigned to those positions in a full-time capacity. Metered usage is a benefit for cloud customers associated with ensuring value for payment, but not resiliency. Proper placement of HVAC temperature measurement and raised floors both aid in optimizing component performance but are not practically associated with resiliency. This is a difficult question, and it could be read in ways that would suggest other correct answers.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      107,
      102,
      96,
      333,
      446
    ],
    "source": ""
  },
  {
    "id": 133,
    "question": "Which of the following has not been attributed as the cause of lost capabilities due to DoS?",
    "choice_a": "Hackers",
    "choice_b": "Construction equipment",
    "choice_c": "Changing regulatory motif",
    "choice_d": "Squirrels",
    "correct_answer": "C",
    "explanation": "Changing regulations should not result in lack of availability. All the other answers have caused DoS outages.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      307,
      615,
      314,
      602
    ],
    "source": ""
  },
  {
    "id": 134,
    "question": "If a hospital is considering using a cloud data center, which Uptime Institute Tier should it require?",
    "choice_a": "2",
    "choice_b": "4",
    "choice_c": "8",
    "choice_d": "X",
    "correct_answer": "B",
    "explanation": "Tier 4 is the highest in the Uptime Institute standard; it is the only suitable tier for life-critical systems. Tier 2 does not provide sufficient redundancy/resiliency for supporting medical services. There are no Tiers 8 or X. As a test-taking tip, it helps to assume all the hospital's systems will migrate to the cloud unless otherwise stated. There could arguably be hospital systems that are not life-critical which wouldn't require Tier 4, but since that detail is not in the question, the broadest reading is appropriate.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      95,
      592,
      618,
      323,
      636
    ],
    "source": ""
  },
  {
    "id": 135,
    "question": "What is often a major challenge to getting both redundant power and communications utility connections?",
    "choice_a": "Expense",
    "choice_b": "Carrying medium",
    "choice_c": "Personnel deployment",
    "choice_d": "Location of many datacenters",
    "correct_answer": "D",
    "explanation": "The location of many datacenters - rurally situated, distant from metropolitan areas - may create challenges for finding multiple power utility providers and ISPs, as those areas just aren't usually served by multiple vendors. Expense is not usually a concern; economies of scale make costs acceptable as part of the pricing structure. Personnel deployment doesn't usually affect access to either type of connection. The carrying medium has nothing to do with challenges for finding multiple providers and is not even a common industry term.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      289,
      290,
      291,
      310,
      312
    ],
    "source": ""
  },
  {
    "id": 136,
    "question": "Which of the following is not an aspect of physical security that ought to be considered in the planning and design of a cloud datacenter facility?",
    "choice_a": "Perimeter",
    "choice_b": "Vehicular approach/traffic",
    "choice_c": "Fire suppression",
    "choice_d": "Elevation of dropped ceilings",
    "correct_answer": "D",
    "explanation": "The height of dropped ceilings is not a security concern, except in action movies. The rest of the answers are all aspects of physical security that should be taken into account when planning and designing a datacenter.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      553,
      311,
      723,
      725,
      241
    ],
    "source": ""
  },
  {
    "id": 137,
    "question": "The Brewer Nash security model is also known as which of the following?",
    "choice_a": "MAC",
    "choice_b": "The Chinese Wall model",
    "choice_c": "Preventive measures",
    "choice_d": "RBAC",
    "correct_answer": "B",
    "explanation": "The Brewer-Nash model is also known as the Chinese Wall model.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      685,
      712,
      714,
      42,
      43
    ],
    "source": ""
  },
  {
    "id": 138,
    "question": "Which kind of hypervisor would malicious actors prefer to attack, ostensibly because it offers a greater attack surface?",
    "choice_a": "Cat IV",
    "choice_b": "Type II",
    "choice_c": "Bare metal",
    "choice_d": "Converged",
    "correct_answer": "B",
    "explanation": "Type II hypervisors run via the OS on the host machine; this makes them attractive to attackers, as both the machine and the OS offer potential attack vectors. Cat IV and converged are not terms associated with hypervisors. Bare-metal hypervisors (Type I) are less preferable to attackers, as they offer less attack surface.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      14,
      142,
      244,
      455,
      206
    ],
    "source": ""
  },
  {
    "id": 139,
    "question": "Which of the following techniques for ensuring cloud datacenter storage resiliency uses encrypted chunks of data?",
    "choice_a": "Cloud bursting",
    "choice_b": "RAID",
    "choice_c": "Data dispersion",
    "choice_d": "SAN",
    "correct_answer": "C",
    "explanation": "Data dispersion uses parity bits, data chunks, and encryption. Parity bits and disk striping are characteristic of RAID implementations. Cloud-bursting is a feature of scalable cloud hosting. SAN is a data storage technique but not focused on resiliency.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      442,
      443,
      444,
      505,
      502
    ],
    "source": ""
  },
  {
    "id": 140,
    "question": "Which of the following data center redundancy efforts probably poses the greatest threat to human safety?",
    "choice_a": "Emergency egress",
    "choice_b": "Communications",
    "choice_c": "Generators",
    "choice_d": "Spare components",
    "correct_answer": "C",
    "explanation": "Generators require fuel, and fuel is flammable. All the other answers do not represent an appreciable threat to human safety.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      310,
      290,
      291,
      724,
      729
    ],
    "source": ""
  },
  {
    "id": 141,
    "question": "Which form of Business Continuity (BC) / Disaster Recovery (DR) testing has the most impact on operations?",
    "choice_a": "Tabletop",
    "choice_b": "Dry run",
    "choice_c": "Full test",
    "choice_d": "Structured test",
    "correct_answer": "C",
    "explanation": "The full test will involve every asset in the organization, including all personnel. The others will have lesser impact, except for D, which is a red herring.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      556,
      557,
      544,
      319,
      403
    ],
    "source": ""
  },
  {
    "id": 142,
    "question": "Which form of Business Continuity (BC) / Disaster Recovery (DR) testing has the least impact on operations?",
    "choice_a": "Tabletop",
    "choice_b": "Dry run",
    "choice_c": "Full test",
    "choice_d": "Structured test",
    "correct_answer": "A",
    "explanation": "The tabletop testing involves only essential personnel and none of the production assets. The others will have greater impact, except for D, which is a red herring.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      556,
      557,
      319,
      544,
      545
    ],
    "source": ""
  },
  {
    "id": 143,
    "question": "Which characteristic of liquid propane increases its desirability as a fuel for backup generators?",
    "choice_a": "Burn rate",
    "choice_b": "Price",
    "choice_c": "Does not spoil",
    "choice_d": "Flavor",
    "correct_answer": "C",
    "explanation": "Liquid propane does not spoil, which obviates necessity for continually refreshing and restocking it and might make it more cost-effective. The burn rate has nothing to do with its suitability, unless it has some direct bearing on the particular generator the datacenter owner has chosen. The various relative prices of fuel fluctuate. Flavor is a distractor in this question and means nothing.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      310,
      290,
      291,
      556,
      239
    ],
    "source": ""
  },
  {
    "id": 144,
    "question": "How often should the CMB meet?",
    "choice_a": "Whenever regulations dictate",
    "choice_b": "Often enough to address organizational needs and attenuate frustration with delay",
    "choice_c": "Every week",
    "choice_d": "Annually",
    "correct_answer": "B",
    "explanation": "Frustrated employees and managers can increase risk to the organization by implementing their own, unapproved modifcations to the environment. The particular interval changes from organization to organization.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      606,
      314,
      318,
      313,
      308
    ],
    "source": ""
  },
  {
    "id": 145,
    "question": "Adhering to ASHRAE standards for humidity can reduce the possibility of __________.",
    "choice_a": "Breach",
    "choice_b": "Static discharge",
    "choice_c": "Theft",
    "choice_d": "Inversion",
    "correct_answer": "B",
    "explanation": "A datacenter with less than optimum humidity can have a higher static electricity discharge rate. Humidity has no bearing on breaches or theft, and inversion is a nonsense term used as a distractor.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      291,
      725,
      241,
      555,
      556
    ],
    "source": ""
  },
  {
    "id": 146,
    "question": "A UPS should have enough power to last how long?",
    "choice_a": "12 hours",
    "choice_b": "10 minutes",
    "choice_c": "One day",
    "choice_d": "Long enough for graceful shutdown",
    "correct_answer": "D",
    "explanation": "The UPS is intended to last only long enough to save production data currently being processed. The exact quantity of time will depend on many variables and will differ from one datacenter to the next.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      289,
      310,
      290,
      556,
      545
    ],
    "source": ""
  },
  {
    "id": 147,
    "question": "A generator transfer switch should bring backup power online within what time frame?",
    "choice_a": "10 seconds",
    "choice_b": "Before the recovery point objective is reached",
    "choice_c": "Before the UPS duration is exceeded",
    "choice_d": "Three days",
    "correct_answer": "C",
    "explanation": "Generator power should be online before battery backups fail. The specic amount of time will vary between datacenters.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      289,
      291,
      404,
      310,
      556
    ],
    "source": ""
  },
  {
    "id": 148,
    "question": "Which characteristic of automated patching makes it attractive?",
    "choice_a": "Cost",
    "choice_b": "Speed",
    "choice_c": "Noise reduction",
    "choice_d": "Capability to recognize problems quickly",
    "correct_answer": "B",
    "explanation": "Automated patching is much faster and more efficient than manual patching. It is, however, not necessarily any less expensive than manual patching. Manual patching is overseen by administrators, who will recognize problems faster than automated tools. Noise reduction is not a factor in patch management at all.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      316,
      318,
      622,
      102
    ],
    "source": ""
  },
  {
    "id": 149,
    "question": "Which tool can reduce confusion and misunderstanding during a Business Continuity (BC) / Disaster Recovery (DR) response?",
    "choice_a": "Flashlight",
    "choice_b": "Controls matrix",
    "choice_c": "Checklist",
    "choice_d": "Call tree",
    "correct_answer": "C",
    "explanation": "Checklists serve as a reliable guide for Business Continuity (BC) / Disaster Recovery (DR) activity and should be straightforward enough to use that someone not already an expert or trained in Business Continuity (BC) / Disaster Recovery (DR) response could ostensibly accomplish the necessary tasks. Flashlights and call trees are certainly useful during Business Continuity (BC) / Disaster Recovery (DR) actions, but not for the purpose of reducing confusion and misunderstanding. Control matrices are not useful during Business Continuity (BC) / Disaster Recovery (DR) actions.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      321,
      320,
      405,
      334,
      335
    ],
    "source": ""
  },
  {
    "id": 150,
    "question": "When deciding whether to apply specific updates, it is best to follow , in order to demonstrate due care.",
    "choice_a": "Regulations",
    "choice_b": "Vendor guidance",
    "choice_c": "Internal policy",
    "choice_d": "Competitors' actions",
    "correct_answer": "B",
    "explanation": "A datacenter that doesn't follow vendor guidance might be seen as failing to provide due care. Regulations, internal policy, and the actions of competitors might all inform the decision to perform an update and patch, but these are not necessarily directly bearing on due care. This is a difficult, nuanced question, and all the answers are good, but option B is the best.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      318,
      102,
      108,
      314,
      106
    ],
    "source": ""
  },
  {
    "id": 151,
    "question": "The CMB should include representations from all of the following offices except:",
    "choice_a": "Regulators",
    "choice_b": "IT department",
    "choice_c": "Security office",
    "choice_d": "Management",
    "correct_answer": "A",
    "explanation": "Regulators are not involved in an organization's CMB; all the rest are.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      313,
      322,
      324,
      315,
      318
    ],
    "source": ""
  },
  {
    "id": 152,
    "question": "For performance purposes, OS monitoring should include all of the following except:",
    "choice_a": "Disk space",
    "choice_b": "Disk I/O usage",
    "choice_c": "CPU usage",
    "choice_d": "Print spooling",
    "correct_answer": "D",
    "explanation": "Print spooling is not a metric for system performance; all the rest are.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      325,
      327,
      621,
      732,
      731
    ],
    "source": ""
  },
  {
    "id": 153,
    "question": "Maintenance mode requires all of the following actions except:",
    "choice_a": "Remove all active production instances",
    "choice_b": "Initiate enhanced security controls",
    "choice_c": "Prevent new logins",
    "choice_d": "Ensure logging continues",
    "correct_answer": "B",
    "explanation": "While the other answers are all steps in moving from normal operations to maintenance mode, we do not necessarily initiate any enhanced security controls.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      329,
      328,
      330,
      620,
      447
    ],
    "source": ""
  },
  {
    "id": 154,
    "question": "What is one of the reasons a baseline might be changed?",
    "choice_a": "Numerous change requests",
    "choice_b": "Power fluctuation",
    "choice_c": "To reduce redundancy",
    "choice_d": "Natural disaster",
    "correct_answer": "A",
    "explanation": "If the CMB is receiving numerous change requests to the point where the amount of requests would drop by modifying the baseline, then that is a good reason to change the baseline. None of the other reasons should involve the baseline at all.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      315,
      316,
      313,
      314,
      606
    ],
    "source": ""
  },
  {
    "id": 155,
    "question": "In addition to battery backup, a UPS can offer which capability?",
    "choice_a": "Communication redundancy",
    "choice_b": "Line conditioning",
    "choice_c": "Breach alert",
    "choice_d": "Confidentiality",
    "correct_answer": "B",
    "explanation": "A UPS can provide line conditioning, adjusting power so that it is optimized for the devices it serves and smoothing any power fluctuations; it does not offer any of the other listed functions.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      289,
      290,
      291,
      310,
      725
    ],
    "source": ""
  },
  {
    "id": 156,
    "question": "Deviations from the baseline should be investigated and ______.",
    "choice_a": "Documented",
    "choice_b": "Enforced",
    "choice_c": "Revealed",
    "choice_d": "Encouraged",
    "correct_answer": "A",
    "explanation": "All deviations from the baseline should be documented, including details of the investigation and outcome. We do not enforce or encourage deviations. Presumably, we would already be aware of the deviation, so \"revealing\" is not a reasonable answer.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      332,
      331,
      605,
      318,
      401
    ],
    "source": ""
  },
  {
    "id": 157,
    "question": "The baseline should cover which of the following?",
    "choice_a": "As many systems throughout the organization as possible",
    "choice_b": "Data breach alerting and reporting",
    "choice_c": "A process for version control",
    "choice_d": "All regulatory compliance requirement",
    "correct_answer": "A",
    "explanation": "The more systems that be included in the baseline, the more cost-effective and scalable the baseline is. The baseline does not deal with breaches or version control; those are the provinces of the security office and CMB, respectively. Regulatory compliance might (and usually will) go beyond the baseline and involve systems, processes, and personnel that are not subject to the baseline.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      104,
      331,
      333,
      606,
      318
    ],
    "source": ""
  },
  {
    "id": 158,
    "question": "A localized incident or disaster can be addressed in a cost effective manner by using which of the following?",
    "choice_a": "UPS",
    "choice_b": "Generators",
    "choice_c": "Joint operating agreements",
    "choice_d": "Strict adherence to applicable regulations",
    "correct_answer": "C",
    "explanation": "Joint operating agreements can provide nearby relocation sites so that a disruption limited to the organization's own facility and campus can be addressed at a different facility and campus. UPS and generators are not limited to serving needs for localized causes. Regulations do not promote cost savings and are not often the immediate concern during Business Continuity (BC) / Disaster Recovery (DR) activities.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      544,
      319,
      334,
      404,
      545
    ],
    "source": ""
  },
  {
    "id": 159,
    "question": "Generator fuel storage for a cloud datacenter should last for how long, at a minimum?",
    "choice_a": "10 minutes",
    "choice_b": "Three days",
    "choice_c": "Indefinitely",
    "choice_d": "12 hours",
    "correct_answer": "D",
    "explanation": "The Uptime Institute dictates 12 hours of generator fuel for all cloud datacenter tiers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      291,
      310,
      334,
      320,
      699
    ],
    "source": ""
  },
  {
    "id": 160,
    "question": "The Business Continuity (BC) / Disaster Recovery (DR) kit should include all of the following except:",
    "choice_a": "Flashlight",
    "choice_b": "Documentation equipment",
    "choice_c": "Hard drives",
    "choice_d": "Annotated asset inventory",
    "correct_answer": "C",
    "explanation": "While hard drives may be useful in the kit (for instance, if they store Business Continuity (BC) / Disaster Recovery (DR) data such as inventory lists, baselines, and patches), they are not necessarily required. All the other items should be included.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      335,
      336,
      544,
      319,
      238
    ],
    "source": ""
  },
  {
    "id": 161,
    "question": "Which of the following is the least challenging with regard to eDiscovery in the cloud?",
    "choice_a": "Decentralization of data storage",
    "choice_b": "Complexities of International law",
    "choice_c": "Identifying roles such as data owner, controller, and processor",
    "choice_d": "Forensic analysis",
    "correct_answer": "D",
    "explanation": "Forensic analysis is the least challenging of the answers provided as it refers to the analysis of data once it is obtained. The challenges revolve around obtaining the data for analysis due to the complexities of international law, the decentralization of data storage or difficulty knowing where to look, and identifying the data owner, controller, and processor.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      408,
      407,
      357,
      651,
      355
    ],
    "source": ""
  },
  {
    "id": 162,
    "question": "Legal controls refer to which of the following?",
    "choice_a": "Controls designed to comply with laws and regulations related to the cloud environment",
    "choice_b": "Payment card industry (PCI) Data security standard (DSS)",
    "choice_c": "International Organization for Standardization (ISO) 27001",
    "choice_d": "National Institute of Standards and Technology (NIST) 800 53r4",
    "correct_answer": "A",
    "explanation": "Legal controls are those controls that are designed to comply with laws and regulations whether they be local or international.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      347,
      354,
      353,
      356,
      650
    ],
    "source": ""
  },
  {
    "id": 163,
    "question": "Which of the following terms is not associated with cloud forensics?",
    "choice_a": "Analysis",
    "choice_b": "eDiscovery",
    "choice_c": "Chain of custody",
    "choice_d": "Plausibility",
    "correct_answer": "D",
    "explanation": "Plausibility, here, is a distractor and not specifically relevant to cloud forensics.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      406,
      651,
      648,
      358,
      646
    ],
    "source": ""
  },
  {
    "id": 164,
    "question": "Which of the following is not a component of contractual Personally identifiable information (PII)?",
    "choice_a": "Scope of processing",
    "choice_b": "Use of subcontractors",
    "choice_c": "Location of data",
    "choice_d": "Value of data",
    "correct_answer": "D",
    "explanation": "The value of data itself has nothing to do with it being considered a part of contractual Personally identifiable information (PII) even though it may have value associated with it.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      339,
      337,
      338,
      352,
      347
    ],
    "source": ""
  },
  {
    "id": 165,
    "question": "Which of the following is the best example of a key component of regulated Personally identifiable information (PII)?",
    "choice_a": "Items that should be implemented",
    "choice_b": "Mandatory breach reporting",
    "choice_c": "Audit rights of subcontractors",
    "choice_d": "Payment card industry (PCI) Data security standard (DSS)",
    "correct_answer": "B",
    "explanation": "Mandatory breach reporting is the best example of regulated Personally identifiable information (PII) components. The rest are generally considered components of contractual Personally identifiable information (PII).",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      337,
      339,
      346,
      347,
      352
    ],
    "source": ""
  },
  {
    "id": 166,
    "question": "Which of the following is not associated with security?",
    "choice_a": "Confidentiality",
    "choice_b": "Availability",
    "choice_c": "Integrity",
    "choice_d": "Quality",
    "correct_answer": "D",
    "explanation": "Quality is not associated with security in the way that confidentiality, integrity, and availability are.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      347,
      356,
      341,
      650,
      646
    ],
    "source": ""
  },
  {
    "id": 167,
    "question": "Which of the following is the best advantage of external audits?",
    "choice_a": "Independence",
    "choice_b": "Oversight",
    "choice_c": "Cheaper",
    "choice_d": "Better results",
    "correct_answer": "A",
    "explanation": "The primary advantage of external audits based on the choices given would be that of independence. External audits are typically more independent and therefore lead to more effective results.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      340,
      341,
      342,
      343,
      360
    ],
    "source": ""
  },
  {
    "id": 168,
    "question": "Which of the following laws resulted from a lack of independence in audit practices?",
    "choice_a": "Health Insurance Portability and Accountability Act (HIPAA)",
    "choice_b": "Gramm Leach Bliley Act (GLBA)",
    "choice_c": "Sarbanes-Oxley (SOX)",
    "choice_d": "International Organization for Standardization (ISO) 27064",
    "correct_answer": "C",
    "explanation": "Sarbanes-Oxley (SOX) was passed primarily to address the issues of audit independence, poor board over sight, and transparency of findings.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      341,
      345,
      340,
      347,
      360
    ],
    "source": ""
  },
  {
    "id": 169,
    "question": "Which of the following reports is no longer used?",
    "choice_a": "SAS 70",
    "choice_b": "SSAE 16",
    "choice_c": "SOC 1",
    "choice_d": "SOC 3",
    "correct_answer": "A",
    "explanation": "The SAS 70 was a report used in the past primarily for financial reporting and was oftentimes misused in the service provider context. The SSAE 16 standards and subsequent SOC reports are its successors.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      343,
      341,
      344,
      345,
      349
    ],
    "source": ""
  },
  {
    "id": 170,
    "question": "Which of the following report is most aligned with financial control audits?",
    "choice_a": "SOC 1",
    "choice_b": "SOC 2",
    "choice_c": "SOC 3",
    "choice_d": "SSAE 16",
    "correct_answer": "A",
    "explanation": "The SOC 1 report focuses primarily on controls associated with financial services. While IT controls are certainly part of most accounting systems today, the focus is on the controls around those financial systems.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      349,
      343,
      344,
      350,
      351
    ],
    "source": ""
  },
  {
    "id": 171,
    "question": "Which of the following is the primary purpose of an SOC 3 report?",
    "choice_a": "Absolute assurances",
    "choice_b": "Compliance with Payment card industry (PCI) / Data security standard (DSS)",
    "choice_c": "Health Insurance Portability and Accountability Act (HIPAA) compliance",
    "choice_d": "Seal of approval",
    "correct_answer": "D",
    "explanation": "The SOC 3 report is more of an attestation than a full evaluation of controls associated with a service provider.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      341,
      344,
      349,
      343,
      345
    ],
    "source": ""
  },
  {
    "id": 172,
    "question": "Which of the following is the primary purpose of an SOC 3 report?",
    "choice_a": "Absolute assurances",
    "choice_b": "Compliance with PCI/DSS",
    "choice_c": "HIPAA compliance",
    "choice_d": "Seal of approval",
    "correct_answer": "D",
    "explanation": "The SOC 3 report is more of an attestation than a full evaluation of controls associated with a service provider.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      341,
      344,
      349,
      343,
      345
    ],
    "source": ""
  },
  {
    "id": 173,
    "question": "GAAPs are created and maintained by which organization?",
    "choice_a": "International Organization for Standardization (ISO)",
    "choice_b": "International Organization for Standardization (ISO)/International electrotechnical commission (IEC)",
    "choice_c": "Payment card industry (PCI) Council",
    "choice_d": "American institute of certified public accountants (AICPA)",
    "correct_answer": "D",
    "explanation": "The American institute of certified public accountants (AICPA) is the organization responsible for generating and maintaining what are the Generally Accepted Accounting Practices in the United States.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      344,
      343,
      347,
      340,
      351
    ],
    "source": ""
  },
  {
    "id": 174,
    "question": "Which statute addresses security and privacy matters in the financial industry?",
    "choice_a": "Gramm Leach Bliley Act (GLBA)",
    "choice_b": "Family educational rights and privacy act (FERPA)",
    "choice_c": "Sarbanes-Oxley (SOX)",
    "choice_d": "Health Insurance Portability and Accountability Act (HIPAA)",
    "correct_answer": "A",
    "explanation": "Family educational rights and privacy act (FERPA) deals with data protection in the academic industry, Health Insurance Portability and Accountability Act (HIPAA) in the medical industry, and Sarbanes-Oxley (SOX) for publicly traded corporations.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      653,
      652,
      352,
      656,
      354
    ],
    "source": ""
  },
  {
    "id": 175,
    "question": "Which of the following is not an example of a highly regulated environment?",
    "choice_a": "Healthcare",
    "choice_b": "Financial services",
    "choice_c": "Wholesale or distribution",
    "choice_d": "Public companies",
    "correct_answer": "C",
    "explanation": "Wholesalers or distributors are generally not regulated, although the products they sell may be.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      346,
      347,
      654,
      652,
      656
    ],
    "source": ""
  },
  {
    "id": 176,
    "question": "Which of the following SOC report subtypes represents a point in time?",
    "choice_a": "SOC 2",
    "choice_b": "Type I",
    "choice_c": "TypeII",
    "choice_d": "SOC 3",
    "correct_answer": "B",
    "explanation": "An SOC Type I report is designed around a specific point in time as opposed to a report of effectiveness over a period of time.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      349,
      350,
      351,
      343,
      344
    ],
    "source": ""
  },
  {
    "id": 177,
    "question": "Which of the following SOC report subtypes spans a period of time?",
    "choice_a": "SOC 2",
    "choice_b": "SOC 3",
    "choice_c": "SOC 1",
    "choice_d": "TypeII",
    "correct_answer": "D",
    "explanation": "An SOC Type II report is designed around a period of time as opposed to a specific point in time.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      349,
      350,
      351,
      344,
      341
    ],
    "source": ""
  },
  {
    "id": 178,
    "question": "The right to be forgotten refers to which of the following?",
    "choice_a": "The right to no longer pay taxes",
    "choice_b": "Erasing criminal history",
    "choice_c": "The right to have all of a data owner's data erased",
    "choice_d": "Masking",
    "correct_answer": "C",
    "explanation": "The right to be forgotten is about the individual's right to have data removed from a provider at any time per their request. It is being tried in the EU at the moment but does not yet apply here in the United States.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      651,
      355,
      650,
      347,
      646
    ],
    "source": ""
  },
  {
    "id": 179,
    "question": "The right to audit should be a part of what documents?",
    "choice_a": "Service level agreement (SLA)",
    "choice_b": "PLA",
    "choice_c": "All cloud providers",
    "choice_d": "Masking",
    "correct_answer": "A",
    "explanation": "The right to audit should be contained in the client Service level agreement (SLA).",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      344,
      341,
      345,
      343,
      349
    ],
    "source": ""
  },
  {
    "id": 180,
    "question": "Sarbanes-Oxley (SOX) was enacted because of which of the following?",
    "choice_a": "Poor BOD oversight",
    "choice_b": "Lack of independent audits",
    "choice_c": "Poor financial controls",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "Options A, B, and C are reasons leading up to the creation and passage of Sarbanes-Oxley (SOX) .",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      343,
      347,
      660,
      652,
      656
    ],
    "source": ""
  },
  {
    "id": 181,
    "question": "What is a key component of Gramm Leach Bliley Act (GLBA)?",
    "choice_a": "The right to be forgotten",
    "choice_b": "EU Data Directives",
    "choice_c": "The information security program",
    "choice_d": "The right to audit",
    "correct_answer": "C",
    "explanation": "The most important aspect of Gramm Leach Bliley Act (GLBA) was the creation of a formal information security program.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      666,
      664,
      665,
      672,
      667
    ],
    "source": ""
  },
  {
    "id": 182,
    "question": "Which of the following are not associated with Health Insurance Portability and Accountability Act (HIPAA) controls?",
    "choice_a": "Administrative controls",
    "choice_b": "Technical controls",
    "choice_c": "Physical controls",
    "choice_d": "Financial controls",
    "correct_answer": "D",
    "explanation": "Financial controls are not addressed by Health Insurance Portability and Accountability Act (HIPAA).",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      352,
      353,
      362,
      354,
      654
    ],
    "source": ""
  },
  {
    "id": 183,
    "question": "What does the doctrine of the proper law refer to?",
    "choice_a": "How jurisdictional disputes are settled",
    "choice_b": "The law that is applied after the first law is applied",
    "choice_c": "The determination of what law will apply to a case",
    "choice_d": "The proper handling of eDiscovery materials",
    "correct_answer": "A",
    "explanation": "The doctrine of the proper law refers to how jurisdictional disputes are settled.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      348,
      357,
      650,
      347,
      355
    ],
    "source": ""
  },
  {
    "id": 184,
    "question": "The Restatement (Second) Conflict of Law refers to which of the following?",
    "choice_a": "The basis for deciding which laws are most appropriate in a situation where conflicting laws exist",
    "choice_b": "When judges restate the law in an opinion",
    "choice_c": "How jurisdictional disputes are settled",
    "choice_d": "Whether local or federal laws apply in a situation",
    "correct_answer": "A",
    "explanation": "The Restatement (Second) Conflict of Law is the basis used for determining which laws are most appropriate in a situation where conflicting laws exist.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      356,
      348,
      357,
      347,
      650
    ],
    "source": ""
  },
  {
    "id": 185,
    "question": "Which of the following applies to the Stored Communications Act (SCA)?",
    "choice_a": "It's old.",
    "choice_b": "It's in bad need of updating.",
    "choice_c": "It's unclear with regard to current technologies.",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "The Stored Communication Act, passed in 1995, is old, in bad need of updating, and unclear with regard to newer technologies.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      355,
      348,
      357,
      651,
      652
    ],
    "source": ""
  },
  {
    "id": 186,
    "question": "Which is the lowest level of the CSA STAR program?",
    "choice_a": "Continuous monitoring",
    "choice_b": "Self assessment",
    "choice_c": "Hybridization",
    "choice_d": "Attestation",
    "correct_answer": "B",
    "explanation": "The lowest level is Level 1, which is self-assessment, Level 2 is an external third-party attestation, and Level 3 is a continuous-monitoring program. Hybridization does not exist as part of the CSA STAR program.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      359,
      358,
      646,
      647,
      360
    ],
    "source": ""
  },
  {
    "id": 187,
    "question": "Which of the following is a valid risk management metric?",
    "choice_a": "Key performance indicators (KPI)",
    "choice_b": "Key RISK indicators (KRI)",
    "choice_c": "Service level agreement (SLA)",
    "choice_d": "SOC",
    "correct_answer": "B",
    "explanation": "KRI stands for key risk indicator. KRIs are the red flags if you will in the world of risk management. When these change, they indicate something is amiss and should be looked at quickly to determine if the change is minor or indicative of something important.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      363,
      354,
      648,
      361,
      362
    ],
    "source": ""
  },
  {
    "id": 188,
    "question": "Which of the following frameworks focuses specifically on design implementation and management?",
    "choice_a": "International Organization for Standardization (ISO) 31000:2009",
    "choice_b": "Health Insurance Portability and Accountability Act (HIPAA)",
    "choice_c": "International Organization for Standardization (ISO) 27017",
    "choice_d": "National Institute of Standards and Technology (NIST) 800-92",
    "correct_answer": "A",
    "explanation": "International Organization for Standardization (ISO) 31000:2009 specifically focuses on design implementation and management. Health Insurance Portability and Accountability Act (HIPAA) refers to health care regulations, National Institute of Standards and Technology (NIST) 800-92 is about log management, and International Organization for Standardization (ISO) 27017 is about cloud specific security controls.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      363,
      354,
      341,
      345,
      344
    ],
    "source": ""
  },
  {
    "id": 189,
    "question": "Which of the following frameworks identifies the top 8 security risks based on likelihood and impact?",
    "choice_a": "National Institute of Standards and Technology (NIST) 800-53",
    "choice_b": "International Organization for Standardization (ISO) 27000",
    "choice_c": "European Union Agency for Network and Information Security (ENISA)",
    "choice_d": "Control objectives for information and related technologies (COBIT)",
    "correct_answer": "C",
    "explanation": "European Union Agency for Network and Information Security (ENISA) specifically identifies the top 8 security risks based on likelihood and impact.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      648,
      646,
      358,
      345,
      354
    ],
    "source": ""
  },
  {
    "id": 190,
    "question": "The CSA STAR program consists of three levels. Which of the following is not one of those levels?",
    "choice_a": "Self assessment",
    "choice_b": "Third party assessment based certification",
    "choice_c": "SOC 2 audit certification",
    "choice_d": "Continuous monitoring based certification",
    "correct_answer": "C",
    "explanation": "The SOC 2 report is not a part of the CSA Star program. It is a totally different audit reporting standard developed by the American institute of certified public accountants (AICPA).",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      647,
      646,
      358,
      359,
      360
    ],
    "source": ""
  },
  {
    "id": 191,
    "question": "Which International Organization for Standardization (ISO) standard refers to addressing security risks in a supply chain?",
    "choice_a": "International Organization for Standardization (ISO) 27001",
    "choice_b": "International Organization for Standardization (ISO)/International electrotechnical commission (IEC) 28000:2007",
    "choice_c": "International Organization for Standardization (ISO) 18799",
    "choice_d": "International Organization for Standardization (ISO) 31000:2009",
    "correct_answer": "B",
    "explanation": "International Organization for Standardization (ISO) /International electrotechnical commission (IEC) 28000-2007 applies to security controls in supply chains. The others are cloud computing standards by have little to do with supply chain management.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      128,
      648,
      358,
      354,
      356
    ],
    "source": ""
  },
  {
    "id": 192,
    "question": "Which of the following is not a risk management framework?",
    "choice_a": "National Institute of Standards and Technology (NIST) SP 800-37",
    "choice_b": "European Union Agency for Network and Information Security (ENISA)",
    "choice_c": "Key risk indicators (KRI)",
    "choice_d": "International Organization for Standardization (ISO) 31000:2009",
    "correct_answer": "C",
    "explanation": "Key risk indicators are useful, but they are not a framework. International Organization for Standardization (ISO) 31000:2009 is an international standard that focuses on designing, implementing, and reviewing risk management processes and practices. National Institute of Standards and Technology (NIST) SP 800-37 is the Guide for Implementing the Risk Management Framework (RMF), a methodology for handling all organizational risk in a holistic, comprehensive, and continual manner. European Union Agency for Network and Information Security (ENISA) identifies 35 types of risks organizations should consider but goes further by identifying the top eight security risks based on likelihood and impact.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      363,
      354,
      361,
      362,
      344
    ],
    "source": ""
  },
  {
    "id": 193,
    "question": "Which of the following best define risk?",
    "choice_a": "Threat coupled with a breach",
    "choice_b": "Vulnerability coupled with an attack",
    "choice_c": "Threat coupled with a threat actor",
    "choice_d": "Threat coupled with a vulnerability",
    "correct_answer": "D",
    "explanation": "The best definition of risk is that of a threat coupled with a vulnerability.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      354,
      363,
      361,
      125,
      648
    ],
    "source": ""
  },
  {
    "id": 194,
    "question": "Which of the following is not a part of the European Union Agency for Network and Information Security (ENISA) Top 8 Security Risks of cloud computing?",
    "choice_a": "Vendor lock in",
    "choice_b": "Isolation failure",
    "choice_c": "Insecure or incomplete data deletion",
    "choice_d": "Availability",
    "correct_answer": "D",
    "explanation": "The European Union Agency for Network and Information Security (ENISA) Top 8 Security Risks of Cloud Computing does not include availability, even though it is certainly a risk that could be realized.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      358,
      646,
      359,
      648,
      354
    ],
    "source": ""
  },
  {
    "id": 195,
    "question": "Which of the following is a risk management option that halts a business function?",
    "choice_a": "Mitigation",
    "choice_b": "Acceptance",
    "choice_c": "Transference",
    "choice_d": "Avoidance",
    "correct_answer": "D",
    "explanation": "Avoidance halts the business process, mitigation entails using controls to reduce risk, acceptance involves taking on the risk, and transference usually involves insurance.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      363,
      354,
      361,
      648,
      343
    ],
    "source": ""
  },
  {
    "id": 196,
    "question": "Which of the following best describes a cloud carrier?",
    "choice_a": "A person or entity responsible for making a cloud service available to consumers",
    "choice_b": "The intermediary who provides connectivity and transport of cloud services between cloud providers and cloud consumers",
    "choice_c": "The person or entity responsible for keeping cloud services running for customers",
    "choice_d": "The person or entity responsible for transporting data across the Internet",
    "correct_answer": "B",
    "explanation": "A cloud carrier is the intermediary who provides connectivity and transport of cloud services between cloud providers and cloud customers.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      710,
      348,
      358,
      646,
      648
    ],
    "source": ""
  },
  {
    "id": 197,
    "question": "Which of the following methods of addressing risk is most associated with insurance?",
    "choice_a": "Transference",
    "choice_b": "Avoidance",
    "choice_c": "Acceptance",
    "choice_d": "Mitigation",
    "correct_answer": "A",
    "explanation": "Avoidance halts the business process, mitigation entails using controls to reduce risk, acceptance involves taking on the risk, and transference usually involves insurance.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      363,
      354,
      361,
      648,
      343
    ],
    "source": ""
  },
  {
    "id": 198,
    "question": "Which of the following components are part of what a CCSP should review when looking at contracting with a cloud service provider?",
    "choice_a": "The physical layout of the datacenter",
    "choice_b": "Background checks for the provider's personnel",
    "choice_c": "Use of subcontractors",
    "choice_d": "Redundant uplink grafts",
    "correct_answer": "C",
    "explanation": "The use of subcontractors can add risk to the supply chain and should be considered; trusting the provider's management of their vendors and suppliers (including subcontractors) is important to trusting the provider. Conversely, the customer is not likely to be allowed to review the physical design of the datacenter (or, indeed, even know the exact location of the datacenter) or the personnel security specifics for the provider's staff. \"Redundant uplink grafts\" is a nonsense term used as a distractor.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      648,
      358,
      128,
      344,
      351
    ],
    "source": ""
  },
  {
    "id": 199,
    "question": "The difference between KPIs and a KRIs is which of the following?",
    "choice_a": "KPIs no longer exist, having been replaced by KRIs.",
    "choice_b": "KRIs no longer exist, having been replaced by KPIs.",
    "choice_c": "KRIs are forward looking, while KPIs are backward looking.",
    "choice_d": "There is no difference between KPIs and KRIs.",
    "correct_answer": "C",
    "explanation": "Key risk indicators (KRIs) try to predict future risk, while key performance indicators (KPIs) examine events that have already happened. The other answers are just distractors.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      354,
      363,
      657
    ],
    "source": ""
  },
  {
    "id": 200,
    "question": "Which of the following is not a way to manage risk?",
    "choice_a": "Enveloping",
    "choice_b": "Mitigating",
    "choice_c": "Accepting",
    "choice_d": "Transferring",
    "correct_answer": "A",
    "explanation": "Enveloping is a nonsense term, unrelated to risk management. The rest are not.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      354,
      363,
      361,
      648,
      360
    ],
    "source": ""
  },
  {
    "id": 201,
    "question": "Which of the following is not a risk management framework?",
    "choice_a": "Hex GBL",
    "choice_b": "Control objectives for information and related technologies (COBIT)",
    "choice_c": "National Institute of Standards and Technology (NIST) SP 800-37",
    "choice_d": "International Organization for Standardization (ISO) 31000:2009",
    "correct_answer": "A",
    "explanation": "Hex GBL is a reference to a computer part in Terry Pratchett's fictional Discworld universe. The rest are not.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      363,
      354,
      361,
      648,
      360
    ],
    "source": ""
  },
  {
    "id": 202,
    "question": "Which of the following is not appropriate to include in an Service level agreement (SLA)?",
    "choice_a": "The number of user accounts allowed during a specified period",
    "choice_b": "Which personnel are responsible and authorized among both the provider and the customer to declare an emergency and transition the service to contingency operation status",
    "choice_c": "The amount of data allowed to be transmitted and received between the cloud provider and customer",
    "choice_d": "The time allowed to migrate from normal operations to contingency operations",
    "correct_answer": "B",
    "explanation": "Roles and responsibilities should be included in the contract, not the Service level agreement (SLA); a good method to determine whether something might belong in the Service level agreement (SLA) at all is figuring out whether a numerical value is associated with it - in this case, the element involves names and offices (roles), not numerical values, so it's immediately recognizable as something that isn't appropriate for the Service level agreement (SLA). Options A and C are explicitly defined by exact numbers and are just the sort of aspects that belong in the Service level agreement (SLA). Option D, the amount of time allowed to transition between normal and contingency operations, is also an explicit numerical value, but it is not a recurring event, regularly anticipated during each period of performance (or shouldn't be, anyway; if your cloud provider is fluctuating between normal and contingency ops every performance period, you should probably find a new provider), so this is something that can be defined once in the contract, and if the provider fails to perform in the (hopefully rare) event it needs to be evaluated, then the provider is in breach, and there should be remedies available other than the Service level agreement (SLA). This is not an easy question, and understanding the nuances can be difficult.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      710,
      358,
      344,
      351,
      648
    ],
    "source": ""
  },
  {
    "id": 203,
    "question": "What is the Cloud Security Alliance Cloud Controls Matrix (CCM)?",
    "choice_a": "An inventory of cloud service security controls that are arranged into separate security domains",
    "choice_b": "An inventory of cloud services security controls that are arranged into a hierarchy of security domains",
    "choice_c": "A set of regulatory requirements for cloud service providers",
    "choice_d": "A set of software development life cycle requirements for cloud service providers",
    "correct_answer": "A",
    "explanation": "The CSA CCM is an inventory of cloud service security controls that are arranged into separate security domains, not a hierarchy.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      358,
      360,
      648,
      354,
      361
    ],
    "source": ""
  },
  {
    "id": 204,
    "question": "Which of the following is not one of the types of controls?",
    "choice_a": "Transitional",
    "choice_b": "Administrative",
    "choice_c": "Technical",
    "choice_d": "Physical",
    "correct_answer": "A",
    "explanation": "Transitional is not a term we associate with types of controls; the rest are.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      361,
      354,
      343,
      351,
      647
    ],
    "source": ""
  },
  {
    "id": 205,
    "question": "Which of the following is not an example of an essential internal stakeholder?",
    "choice_a": "IT analyst",
    "choice_b": "IT director",
    "choice_c": "CFO",
    "choice_d": "HR director",
    "correct_answer": "A",
    "explanation": "An IT analyst is generally not high enough of a position to be able to provide quality information to other stakeholders. However, the IT director would be in such a positon, as would the others.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      366,
      364,
      128,
      129,
      119
    ],
    "source": ""
  },
  {
    "id": 206,
    "question": "What type of solutions enable enterprises or individuals to store their data and computer files on the Internet using a storage service provider rather than storing the data locally on a physical disk, such as a hard drive or tape backup?",
    "choice_a": "Online backups",
    "choice_b": "Cloud backup solutions",
    "choice_c": "Removable hard drives",
    "choice_d": "Masking",
    "correct_answer": "B",
    "explanation": "Cloud backup solutions enable enterprises to store their data and computer files on the Internet using a storage service rather than storing data locally on a hard disk or tape backup. This has the added benefit of providing access to data should the primary business location be damaged in some way that prevents accessing or restoring data locally due to damaged infrastructure or equipment. Online backups and removable hard drives are other options but do not by default supply the customer with ubiquitous access. Masking is a technology used to partially conceal sensitive data.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      143,
      474,
      8,
      5,
      224
    ],
    "source": ""
  },
  {
    "id": 207,
    "question": "When using an Infrastructure as a Service (IaaS) solution, what is the key benefit for the customer?",
    "choice_a": "Scalability",
    "choice_b": "Metered service",
    "choice_c": "Energy and cooling efficiencies",
    "choice_d": "Transfer of ownership cost",
    "correct_answer": "D",
    "explanation": "The primary benefit to the customer of using Infrastructure as a Service (IaaS) is the transfer of cost of ownership. In a cloud environment, the customer uses and is billed only for what they use as opposed to the full cost of implementation, saving them a significant amount in terms of cost of ownership. While scalability, metered service, and energy and cooling efficiencies are a part of the benefit of a cloud computing environment, they are not the primary benefit or business driver behind Infrastructure as a Service (IaaS) adoption.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      6,
      8,
      3,
      12,
      11
    ],
    "source": ""
  },
  {
    "id": 208,
    "question": "______ focuses on security and encryption to prevent unauthorized copying and limitations on distribution to only those who pay.",
    "choice_a": "Digital rights management (DRM)",
    "choice_b": "Enterprise digital rights management",
    "choice_c": "Bit splitting",
    "choice_d": "Degaussing",
    "correct_answer": "A",
    "explanation": "Digital rights management (DRM) was designed to focus on security and encryption as a means of preventing unauthorized copying and limitations on distribution of content to only those authorized (purchasers). Enterprise digital rights management, also known as Information rights management (IRM), is a subset of Digital rights management (DRM) and typically refers to business to business securing of information rights. Bit splitting is a method of hiding information across multiple geographical boundaries, and degaussing is a method of deleting data permanently from magnetic media.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      31,
      388,
      383,
      33,
      396
    ],
    "source": ""
  },
  {
    "id": 209,
    "question": "Which of the following represents the correct set of four cloud deployment models?",
    "choice_a": "Public, Private, Joint and Community",
    "choice_b": "Public, Private, Hybrid, and Community",
    "choice_c": "Public, Internet, Hybrid, and Community",
    "choice_d": "External, Private, Hybrid, and Community",
    "correct_answer": "B",
    "explanation": "The only correct answer for this is Public, Private, Hybrid, and Community. Joint, Internet, and External are not cloud models.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      10,
      9,
      1,
      8,
      16
    ],
    "source": ""
  },
  {
    "id": 210,
    "question": "What is a special mathematical code that allows encryption hardware/software to encode and then decipher an encrypted message called?",
    "choice_a": "Public key infrastructure (PKI)",
    "choice_b": "Encryption key",
    "choice_c": "Public key",
    "choice_d": "Masking",
    "correct_answer": "B",
    "explanation": "An encryption key is just that: a key used to encrypt and decrypt information. It is mathematical code that supports either hardware or software based encryption used to encode or decode information.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      418,
      419,
      503,
      395,
      494
    ],
    "source": ""
  },
  {
    "id": 211,
    "question": "Which of the following lists the correct six components of the STRIDE threat model?",
    "choice_a": "Spoofing, Tampering, Repudiation, Information Disclosure, Denial of Service, and Elevation of Privilege",
    "choice_b": "Spoofing, Tampering, Repudiation, Information Disclosure, Denial of Service, and Social Engineering Elasticity",
    "choice_c": "Spoofing, Tampering, Repudiation, Information Disclosure, Distributed Denial of Service, and Elevation of Privilege",
    "choice_d": "Spoofing, Tampering, Nonrepudiation, Information Disclosure, Denial of Service, and Elevation of Privilege",
    "correct_answer": "A",
    "explanation": "The letters in STRIDE threat model represent Spoofing of identity, Tampering with data, Repudiation, Information disclosure, Denial of service, and Elevation of privilege. The other options are simply mixed up or incorrect versions of the same.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      293,
      292,
      295,
      280,
      282
    ],
    "source": ""
  },
  {
    "id": 212,
    "question": "What is the term for the assurance that a specific author actually created and sent a specific item to a specific recipient, and that the message was successfully received?",
    "choice_a": "Public key infrastructure (PKI)",
    "choice_b": "Data loss prevention (DLP)",
    "choice_c": "Nonrepudiation",
    "choice_d": "Bit splitting",
    "correct_answer": "C",
    "explanation": "Nonrepudiation means that a specific author or user cannot refute or repudiate that he or she created and/or sent a message and the receiver of the data or message cannot deny they received it.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      516,
      395,
      720,
      718,
      38
    ],
    "source": ""
  },
  {
    "id": 213,
    "question": "What is the correct term for the process of deliberately destroying the encryption keys used to encrypt data?",
    "choice_a": "Poor key management",
    "choice_b": "Public key infrastructure (PKI)",
    "choice_c": "Obfuscation",
    "choice_d": "Crypto shredding",
    "correct_answer": "D",
    "explanation": "The act of crypto shredding means destroying the key that was initially used to encrypt the data, thereby making it forever unrecoverable.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      422,
      22,
      185,
      182,
      225
    ],
    "source": ""
  },
  {
    "id": 214,
    "question": "In a federated environment, who is the relying party, and what do they do?",
    "choice_a": "The relying party is the service provider and they would consume the tokens generated by the identity provider.",
    "choice_b": "The relying party is the service provider and they would consume the tokens generated by the customer.",
    "choice_c": "The relying party is the customer and they would consume the tokens generated by the identity provider.",
    "choice_d": "The relying party is the identity provider and they would consume the tokens generated by the service provider.",
    "correct_answer": "A",
    "explanation": "The identity provider would hold all of the identities and generate a token for known users. The relying party (RP) would be the service provider and would consume the tokens. All other answers are incorrect.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      369,
      368,
      367,
      695,
      576
    ],
    "source": ""
  },
  {
    "id": 215,
    "question": "What is the process of replacing sensitive data with unique identification symbols that retain all the essential information about the data without compromising its security?",
    "choice_a": "Randomization",
    "choice_b": "Elasticity",
    "choice_c": "Obfuscation",
    "choice_d": "Tokenization",
    "correct_answer": "D",
    "explanation": "Replacing sensitive data with unique identification symbols is known as tokenization, a simple and only somewhat effective way of hiding or concealing sensitive data with the replacement of unique identification symbols. It is not considered as strong as encryption but can be effective in keeping prying eyes off of sensitive information. While randomization and obfuscation are also means of concealing information, they are done quite differently.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      503,
      502,
      250,
      412,
      31
    ],
    "source": ""
  },
  {
    "id": 216,
    "question": "Which of the following data storage types are associated or used with Platform as a Service (PaaS)?",
    "choice_a": "Databases and Big Data",
    "choice_b": "Software as a Service (SaaS) application",
    "choice_c": "Tabular",
    "choice_d": "Raw and block",
    "correct_answer": "A",
    "explanation": "Platform as a Service (PaaS) uses databases and Big Data storage types.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      8,
      474,
      143,
      3,
      23
    ],
    "source": ""
  },
  {
    "id": 217,
    "question": "What is the term used for software technology that encapsulates application software from the underlying operating system on which it is executed?",
    "choice_a": "Hypervisor",
    "choice_b": "Application virtualization",
    "choice_c": "VMWare",
    "choice_d": "Software as a Service (SaaS)",
    "correct_answer": "B",
    "explanation": "Application virtualization encapsulates application software from the underlying operating system on which it is executed.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      73,
      75,
      78,
      79,
      283
    ],
    "source": ""
  },
  {
    "id": 218,
    "question": "Which of the following represents the legislation enacted to protect shareholders and the public from enterprise accounting errors and fraudulent practices?",
    "choice_a": "Payment card industry (PCI)",
    "choice_b": "Gramm Leach Bliley Act (GLBA)",
    "choice_c": "Sarbanes Oxley Act (SOX)",
    "choice_d": "Health Insurance Portability and Accountability Act (HIPAA)",
    "correct_answer": "C",
    "explanation": "The Sarbanes Oxley Act (SOX) was enacted in response to the 2000 accounting scandal that caused the bankruptcy of Enron. At that time, top executives laid the claim that they were unaware of the accounting practices that led to the company's demise. Sarbanes-Oxley (SOX) not only forces executives to oversee all accounting practices, but holds them accountable should such activity occur again.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      347,
      651,
      650,
      340,
      358
    ],
    "source": ""
  },
  {
    "id": 219,
    "question": "What is a device called that can safely store and manage encryption keys and is used in servers, data transmission, and log files?",
    "choice_a": "Private key",
    "choice_b": "Hardware security module (HSM)",
    "choice_c": "Public key",
    "choice_d": "Trusted Operating System Module (TOS)",
    "correct_answer": "B",
    "explanation": "A hardware security module is a device that can safely store and manage encryption keys. These can be used in servers, workstations, and so on. Once common type is called the Trusted Platform Module (TPM) and can be found on enterprise workstations and laptops. There is no such term as a trusted operating system, and public and private keys are terms used with Public key infrastructure (PKI).",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      418,
      419,
      420,
      503,
      507
    ],
    "source": ""
  },
  {
    "id": 220,
    "question": "What is a type of cloud infrastructure that is provisioned for open use by the general public and is owned, managed, and operated by a business, academic, or government organization and exists on the premises of the cloud provider called?",
    "choice_a": "Private cloud",
    "choice_b": "Public cloud",
    "choice_c": "Hybrid cloud",
    "choice_d": "Personal cloud",
    "correct_answer": "B",
    "explanation": "This is the very definition of public cloud computing.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      9,
      11,
      1,
      8,
      10
    ],
    "source": ""
  },
  {
    "id": 221,
    "question": "When using transparent encryption of a database, where does the encryption engine reside?",
    "choice_a": "Within the database application itself",
    "choice_b": "At the application using the database",
    "choice_c": "On the instances attached to the volume",
    "choice_d": "In a key management system",
    "correct_answer": "A",
    "explanation": "In transparent encryption, the encryption key for a database is stored in the boot record of the database itself.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      418,
      494,
      507,
      503,
      41
    ],
    "source": ""
  },
  {
    "id": 222,
    "question": "What is a type of assessment called that employs a set of methods, principles, or rules for assessing risk based on non numerical categories or levels?",
    "choice_a": "Quantitative assessment",
    "choice_b": "Qualitative assessment",
    "choice_c": "Hybrid assessment",
    "choice_d": "SOC 2",
    "correct_answer": "B",
    "explanation": "A qualitative assessment is a set of methods or rules for assessing risk based on non mathematical or categories or levels. One that uses those mathematical categories or levels is called a quantitative assessment. There is no such thing as a hybrid assessment, and an SOC 2 is an accounting report regarding control effectiveness.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      240,
      238,
      241,
      243,
      558
    ],
    "source": ""
  },
  {
    "id": 223,
    "question": "What best describes the Cloud Security Alliance Cloud Controls Matrix ?",
    "choice_a": "A set of regulatory requirements for cloud service providers",
    "choice_b": "A set of software development life cycle requirements for cloud service providers",
    "choice_c": "A security controls framework that provides mapping/cross relationships with the main industry accepted security standards, regulations, and controls frameworks such as the International Organization for Standardization (ISO) 27001 27002, ISACA's Control objectives for information and related technologies (COBIT), and Payment card industry (PCI) Data security standard (DSS)",
    "choice_d": "An inventory of cloud service security controls that are arranged into separate security domains",
    "correct_answer": "C",
    "explanation": "The CCM cross references many industry standards, laws, and guidelines.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      110,
      111,
      318,
      606,
      333
    ],
    "source": ""
  },
  {
    "id": 224,
    "question": "When a conflict of laws occurs, determines the jurisdiction in which the dispute will be heard.",
    "choice_a": "Tort law",
    "choice_b": "Doctrine of Proper Law",
    "choice_c": "Common law",
    "choice_d": "Criminal law",
    "correct_answer": "B",
    "explanation": "The Doctrine of Proper Law is used when a dispute occurs over which jurisdiction will hear a case. Tort law refers to civil liability suits. Common law refers to laws regarding marriage, and criminal law refers to violations of state or federal criminal code.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      357,
      348,
      347,
      356,
      650
    ],
    "source": ""
  },
  {
    "id": 225,
    "question": "Which one of the following is the most important security consideration when selecting a new computer facility?",
    "choice_a": "Local law enforcement response times",
    "choice_b": "Location adjacent to competitor's facilities",
    "choice_c": "Aircraft flight paths",
    "choice_d": "Utility infrastructure",
    "correct_answer": "D",
    "explanation": "Of the answers given, option D is the most important. It is vital that any datacenter facility be close to sound facility resources such as power, water, and connectivity.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      554,
      729,
      241,
      556,
      557
    ],
    "source": ""
  },
  {
    "id": 226,
    "question": "Which of the following is always safe to use in the disposal of electronic records within a cloud environment?",
    "choice_a": "Physical destruction",
    "choice_b": "Overwriting",
    "choice_c": "Encryption",
    "choice_d": "Degaussing",
    "correct_answer": "C",
    "explanation": "Encryption can always be used in a cloud environment, but physical destruction, over writing, and degaussing may not be available due to access and physical separation factors.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      422,
      195,
      203,
      172,
      229
    ],
    "source": ""
  },
  {
    "id": 227,
    "question": "Which of the following describes a SYN flood attack?",
    "choice_a": "Rapid transmission of Internet Relay Chat (IRC) messages",
    "choice_b": "Creating a high number of partially open TCP connections",
    "choice_c": "Disabling the Domain Name Service (DNS) server",
    "choice_d": "Excessive list linking of users and files",
    "correct_answer": "B",
    "explanation": "A SYN flood is where a TCP connection attempt is made and then cut short just prior to completion, thereby leaving a server waiting for a response. If enough of these connection attempts are made, a \"flood\" occurs, causing the end unit to consume resources to the point that either services and/or the system itself become unavailable for use. The other options have no connection with a flood of any kind.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      714,
      685,
      522,
      241,
      427
    ],
    "source": ""
  },
  {
    "id": 228,
    "question": "Which of the following is an example of a form of cloud storage that applies to storing an individual's mobile device data in the cloud and providing the individual with access to the data from anywhere?",
    "choice_a": "Raw storage",
    "choice_b": "Flash storage",
    "choice_c": "Obfuscation archiving",
    "choice_d": "Mobile cloud storage",
    "correct_answer": "D",
    "explanation": "Mobile cloud storage is defined as a form of cloud storage that applies to storing an individual's mobile device data in the cloud and providing the individual with access to the data from anywhere.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      49,
      51,
      44,
      42,
      53
    ],
    "source": ""
  },
  {
    "id": 229,
    "question": "Which of the following terms best describes a distributed model where software applications are hosted by a vendor or cloud service provider and made available to customers over network resources?",
    "choice_a": "Infrastructure as a Service (IaaS)",
    "choice_b": "Public cloud",
    "choice_c": "Software as a Service (SaaS)",
    "choice_d": "Private cloud",
    "correct_answer": "C",
    "explanation": "This is the definition of the Software as a Service (SaaS) service model. Public and private are cloud deployment models, and Infrastructure as a Service (IaaS) does not provide applications of any type.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      8,
      9,
      12,
      1,
      11
    ],
    "source": ""
  },
  {
    "id": 230,
    "question": "Which of the following is a federal law enacted in the United States to control the way that financial institutions deal with private information of individuals?",
    "choice_a": "Payment card industry (PCI)",
    "choice_b": "International Organization for Standardization (ISO)/International electrotechnical commission (IEC)",
    "choice_c": "Gramm Leach Bliley Act (GLBA)",
    "choice_d": "Consumer Protection Act",
    "correct_answer": "C",
    "explanation": "The Gramm Leach Bliley Act targets U.S. financial institutions and requires them to deal specifically with protecting account holders' private information. Payment card industry (PCI) refers to credit card processing requirements, International Organization for Standardization (ISO)/International electrotechnical commission (IEC) is a standards organization, and the Consumer Protection Act, while providing oversight for the protection of consumer private information, is limited in scope.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      653,
      353,
      346,
      354,
      355
    ],
    "source": ""
  },
  {
    "id": 231,
    "question": "The typical function of Secure Sockets Layer (SSL) in securing Wireless Application Protocol (WAP) is to protect transmissions that exist:",
    "choice_a": "Between the WAP gateway and the wireless endpoint device",
    "choice_b": "Between the web server and the WAP gateway",
    "choice_c": "From the web server to the wireless endpoint device",
    "choice_d": "Between the wireless device and the base station",
    "correct_answer": "C",
    "explanation": "The purpose of SSL is to encrypt the communication channel between two end points. In this example, it is the end user and the server.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      608,
      97,
      98,
      94,
      101
    ],
    "source": ""
  },
  {
    "id": 232,
    "question": "What is an audit standard for service organizations?",
    "choice_a": "SOC 1",
    "choice_b": "SSAE 18",
    "choice_c": "GAAP",
    "choice_d": "SOC 2",
    "correct_answer": "B",
    "explanation": "Both SOC 1 and SOC 2 are report formats based on the SSAE 18 standard. While SOC 1 reports on controls for financial reporting, SOC 2 (Types 1 and 2) reports on controls associated with security or privacy.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      344,
      341,
      343,
      349,
      345
    ],
    "source": ""
  },
  {
    "id": 233,
    "question": "What is a company that purchases hosting services from a cloud server hosting or cloud computing provider who then resells to its own customers?",
    "choice_a": "Cloud broker",
    "choice_b": "Cloud computing reseller",
    "choice_c": "Cloud proxy",
    "choice_d": "VAR",
    "correct_answer": "B",
    "explanation": "The cloud computing reseller purchases hosting services and then resells them.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      12,
      13,
      8,
      1,
      230
    ],
    "source": ""
  },
  {
    "id": 234,
    "question": "What is a type of computing comparable to grid computing that relies on sharing computing resources rather than having local servers or personal devices to handle applications?",
    "choice_a": "Server hosting",
    "choice_b": "Legacy computing",
    "choice_c": "Cloud computing",
    "choice_d": "Intranet",
    "correct_answer": "C",
    "explanation": "Cloud computing is built on the model of grid computing whereby resources can be pooled and shared rather than having local devices do all the compute and storage functions.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      1,
      2,
      8,
      9,
      141
    ],
    "source": ""
  },
  {
    "id": 235,
    "question": "What is a set of technologies designed to analyze application source code and binaries for coding and design conditions that are indicative of security and vulnerabilities?",
    "choice_a": "Dynamic application security testing (DAST)",
    "choice_b": "Static application security testing (SAST)",
    "choice_c": "Secure coding",
    "choice_d": "Open web application security project (OWASP)",
    "correct_answer": "B",
    "explanation": "Static application security testing (SAST) differs from dynamic application security testing (DAST) in that it looks at source code and binaries to see if it can detect problems before the code is loaded into memory and run.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      298,
      299,
      300,
      570,
      678
    ],
    "source": ""
  },
  {
    "id": 236,
    "question": "All of the following are methods of data discovery, except:",
    "choice_a": "Content-based",
    "choice_b": "User-based",
    "choice_c": "Label-based",
    "choice_d": "Metadata-based",
    "correct_answer": "B",
    "explanation": "All the others are valid methods of data discovery; user-based is a red herring with no meaning.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      28,
      509,
      30,
      690,
      413
    ],
    "source": ""
  },
  {
    "id": 237,
    "question": "Data labels could include all of the following except:",
    "choice_a": "Date data was created",
    "choice_b": "Data owner",
    "choice_c": "Data value",
    "choice_d": "Data of scheduled destruction",
    "correct_answer": "C",
    "explanation": "All the others might be included in data labels, but we don't usually include data value, since it is prone to change frequently, and because it might not be information we want to disclose to anyone who does not have need to know.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      26,
      370,
      28,
      29,
      371
    ],
    "source": ""
  },
  {
    "id": 238,
    "question": "Data labels could include all of the following except:",
    "choice_a": "Source",
    "choice_b": "Delivery vendor",
    "choice_c": "Handling restrictions",
    "choice_d": "Jurisdiction",
    "correct_answer": "B",
    "explanation": "All the others might be included in data labels, but we don't include delivery vendor, which is nonsense in context.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      26,
      370,
      28,
      25,
      29
    ],
    "source": ""
  },
  {
    "id": 239,
    "question": "Data labels could include all of the following except:",
    "choice_a": "Confidentiality level",
    "choice_b": "Distribution limitations",
    "choice_c": "Access restrictions",
    "choice_d": "Multifactor authentication",
    "correct_answer": "D",
    "explanation": "All the others might be included in data labels, but multifactor authentication is a procedure used for access control, not a label.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      26,
      372,
      28,
      25,
      29
    ],
    "source": ""
  },
  {
    "id": 240,
    "question": "All of the following are data analytics modes, except:",
    "choice_a": "Real-time analytics",
    "choice_b": "Datamining",
    "choice_c": "Agile business intelligence",
    "choice_d": "Refractory iterations",
    "correct_answer": "D",
    "explanation": "All the others are data analytics methods, but \"refractory iterations\" is a nonsense term thrown in as a red herring.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      373,
      30,
      375,
      374,
      508
    ],
    "source": ""
  },
  {
    "id": 241,
    "question": "In the cloud, the data owner is usually:",
    "choice_a": "In another jurisdiction",
    "choice_b": "The cloud customer",
    "choice_c": "The cloud provider",
    "choice_d": "The cloud access security broker",
    "correct_answer": "B",
    "explanation": "The data owner is usually considered the cloud customer in a cloud configuration; the data in question is the customer's information, being processed in the cloud. The cloud provider is only leasing services and hardware to the customer. The cloud access security broker (CASB) only handles access control on behalf of the cloud customer, and is not in direct contact with the production data.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      710,
      709,
      646,
      651,
      658
    ],
    "source": ""
  },
  {
    "id": 242,
    "question": "In the cloud, the data processor is usually:",
    "choice_a": "The party that assigns access rights",
    "choice_b": "The cloud customer",
    "choice_c": "The cloud provider",
    "choice_d": "The cloud access security broker",
    "correct_answer": "C",
    "explanation": "In legal terms, when \"data processor\" is defined, it refers to anyone who stores, handles, moves, or manipulates data on behalf of the data owner or controller. In the cloud computing realm, this is the cloud provider.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      658,
      659,
      660,
      709,
      338
    ],
    "source": ""
  },
  {
    "id": 243,
    "question": "Which of the following is not an acceptable means of sanitizing hardware?",
    "choice_a": "Burning",
    "choice_b": "Deletion",
    "choice_c": "Industrial Shredding",
    "choice_d": "Drilling",
    "correct_answer": "B",
    "explanation": "Hardware cannot be sanitized by deleting data. Deleting, as an operation, does not erase the data; it simply removes the logical pointers to the data for processing purposes. Burning, deletion, and drilling can all be used to sufficiently destroy the hardware to the point where data becomes irrecoverable.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      40,
      434,
      35,
      497,
      258
    ],
    "source": ""
  },
  {
    "id": 244,
    "question": "All policies within the organization should include a section that includes all of the following except:",
    "choice_a": "Policy maintenance",
    "choice_b": "Policy review",
    "choice_c": "Policy enforcement",
    "choice_d": "Policy adjudication",
    "correct_answer": "D",
    "explanation": "All the elements except adjudication need to be addressed in each policy. Adjudication is not an element of policy.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      378,
      376,
      34,
      377,
      29
    ],
    "source": ""
  },
  {
    "id": 245,
    "question": "The most pragmatic option for data disposal in the cloud is which of the following?",
    "choice_a": "Melting",
    "choice_b": "Cryptoshredding",
    "choice_c": "Cold fusion",
    "choice_d": "Overwriting",
    "correct_answer": "B",
    "explanation": "We don't have physical ownership, control, or even access to the devices holding the data, so physical destruction, including melting, is not an option. Overwriting is a possibility, but it is complicated by the difficulty of locating all the sectors and storage areas that might have contained our data, and by the likelihood that constant backups in the cloud increase the chance we'll miss something as it's being overwritten. Cryptoshredding is the only reasonable alternative. Cold fusion is a red herring.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      41,
      40,
      35,
      434,
      494
    ],
    "source": ""
  },
  {
    "id": 246,
    "question": "What is the intellectual property protection for the tangible expression of a creative idea?",
    "choice_a": "Copyright",
    "choice_b": "Patent",
    "choice_c": "Trademark",
    "choice_d": "Trade secret",
    "correct_answer": "A",
    "explanation": "Copyrights are protected tangible expressions of creative works.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      31,
      386,
      395,
      32,
      33
    ],
    "source": ""
  },
  {
    "id": 247,
    "question": "What is the intellectual property protection for a useful manufacturing innovation?",
    "choice_a": "Copyright",
    "choice_b": "Patent",
    "choice_c": "Trademark",
    "choice_d": "Trade secret",
    "correct_answer": "B",
    "explanation": "Patents protect processes (as well as inventions, new plantlife, and decorative patterns).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 248,
    "question": "What is the intellectual property protection for a very valuable set of sales leads?",
    "choice_a": "Copyright",
    "choice_b": "Patent",
    "choice_c": "Trademark",
    "choice_d": "Trade secret",
    "correct_answer": "D",
    "explanation": "Confidential sales and marketing materials unique to the organization are trade secrets.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      385,
      29,
      31,
      25,
      24
    ],
    "source": ""
  },
  {
    "id": 249,
    "question": "What is the intellectual property protection for a confidential recipe for muffins?",
    "choice_a": "Copyright",
    "choice_b": "Patent",
    "choice_c": "Trademark",
    "choice_d": "Trade secret",
    "correct_answer": "D",
    "explanation": "Confidential recipes unique to the organization are trade secrets.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      385,
      31,
      28,
      25,
      512
    ],
    "source": ""
  },
  {
    "id": 250,
    "question": "What is the intellectual property protection for the logo of a new video game?",
    "choice_a": "Copyright",
    "choice_b": "Patent",
    "choice_c": "Trademark",
    "choice_d": "Trade secret",
    "correct_answer": "C",
    "explanation": "Logos and symbols and phrases and color schemes that describe brands are trademarks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      41
    ],
    "source": ""
  },
  {
    "id": 251,
    "question": "What is the aspect of the DMCA that has often been abused and places the burden of proof on the accused?",
    "choice_a": "Toll exemption",
    "choice_b": "Decryption program prohibition",
    "choice_c": "Takedown notice",
    "choice_d": "Puppet plasticity",
    "correct_answer": "C",
    "explanation": "The DMCA provision for takedown notices allows copyright holders to demand removal of suspect content from the web, and puts the burden of proof on whoever posted the material; this function has been abused by griefers and trolls and overzealous content producers. There is no toll exemption in DMCS The decryption program prohibition makes DeCSS and other similar programs illegal. Puppet plasticity is a nonsense term used for a distraction.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      392,
      31,
      386,
      395,
      414
    ],
    "source": ""
  },
  {
    "id": 252,
    "question": "What is the federal agency that accepts applications for new patents?",
    "choice_a": "USDA",
    "choice_b": "USPTO",
    "choice_c": "OSHA",
    "choice_d": "SEC",
    "correct_answer": "B",
    "explanation": "The U.S. Patent and Trademark Office accepts, reviews, and approves applications for new patents. The USDA creates and enforces agriculture regulation. OSHA oversees workplace safety regulations. The SEC regulates publicly traded corporations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 253,
    "question": "IRM tools use a variety of methods for enforcement of intellectual property rights. These include all of the following except:",
    "choice_a": "Support-based licensing",
    "choice_b": "Local agent enforcement",
    "choice_c": "Dip switch validity",
    "choice_d": "Media-present checks",
    "correct_answer": "C",
    "explanation": "IRM solutions use all these methods except for dip switch validity, which is a nonsense term.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      32,
      31,
      390,
      395,
      394
    ],
    "source": ""
  },
  {
    "id": 254,
    "question": "Which of the following does not have a personal privacy law that limits the way all citizens and entities can share personal data?",
    "choice_a": "Japan",
    "choice_b": "Belgium",
    "choice_c": "Argentina",
    "choice_d": "The United States",
    "correct_answer": "D",
    "explanation": "The United States does not have a single, overarching personal privacy law; instead, the US often protects personal information by industry (HIPAA, GLBA, FERPA, and so forth.). Belgium, like all EU member countries, adheres to the GDPR. Argentina\u2019s Personal Data Protection Act cleaves to the EU regulation, as does Japan\u2019s Act on the Protection of Personal Information.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      652,
      653,
      656,
      348,
      357
    ],
    "source": ""
  },
  {
    "id": 255,
    "question": "IRM solutions should generally include all of the following functions, except:",
    "choice_a": "Persistency",
    "choice_b": "Automatic self-destruct",
    "choice_c": "Automatic expiration",
    "choice_d": "Dynamic policy control",
    "correct_answer": "B",
    "explanation": "IRMtools should include all the functions listed except for self-destruction, which might hurt someone.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      32,
      31,
      395,
      389,
      390
    ],
    "source": ""
  },
  {
    "id": 256,
    "question": "Gathering business requirements aids in determining information about organizational assets. Which of the following is not determined by this process?",
    "choice_a": "Criticality",
    "choice_b": "Robustness",
    "choice_c": "Value",
    "choice_d": "ROI",
    "correct_answer": "B",
    "explanation": "Robustness is not a trait measured by the process of reviewing business requirements.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      238,
      544,
      537,
      336,
      241
    ],
    "source": ""
  },
  {
    "id": 257,
    "question": "Which of the following is one example of a data discovery method?",
    "choice_a": "Bastion host based",
    "choice_b": "Metadata based",
    "choice_c": "Firewall based",
    "choice_d": "SIEM based",
    "correct_answer": "B",
    "explanation": "There are several types of data discovery types: content based, label based, and metadata based. Metadata is the data about the data, such as file location, who created it, when was it created, and so on.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      28,
      509,
      30,
      508,
      510
    ],
    "source": ""
  },
  {
    "id": 258,
    "question": "Which of the following is a term used to describe the practice of obscuring original raw data so that only a portion is displayed for operational purposes?",
    "choice_a": "Data discovery",
    "choice_b": "Hashing",
    "choice_c": "Masking",
    "choice_d": "Public key infrastructure",
    "correct_answer": "C",
    "explanation": "Masking is a form of confidentiality assurance that often replaces the original information with asterisks or Xs.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      502,
      503,
      386,
      31,
      414
    ],
    "source": ""
  },
  {
    "id": 259,
    "question": "Which of the following is a characteristic of modern data center design?",
    "choice_a": "Weak physical security",
    "choice_b": "Located in metropolitan areas",
    "choice_c": "Located in desert climates",
    "choice_d": "Power redundancy",
    "correct_answer": "D",
    "explanation": "One of the foundational design characteristics in modern data center design involves ensuring redundant power systems. Data centers can be located anywhere, and typically have strong physical security.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      289,
      310,
      290,
      311,
      291
    ],
    "source": ""
  },
  {
    "id": 260,
    "question": "What is the term used to describe the ease and efficiency of moving data from one provider to another?",
    "choice_a": "Portability",
    "choice_b": "Mobility",
    "choice_c": "Forklifting",
    "choice_d": "Vendor lock-out",
    "correct_answer": "A",
    "explanation": "Portability is the term used to describe the ease and efficiency of moving data from one cloud provider to another.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      18,
      185,
      1,
      468,
      204
    ],
    "source": ""
  },
  {
    "id": 261,
    "question": "Which of the following is not a characteristic of REST?",
    "choice_a": "Lightweight and scalable",
    "choice_b": "Supports multiple protocols",
    "choice_c": "Relies heavily on XML",
    "choice_d": "Stateless",
    "correct_answer": "C",
    "explanation": "REST is a stateless, lightweight, multiprotocol approach to providing web services. It does not rely on XML.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      397,
      398,
      703,
      704,
      563
    ],
    "source": ""
  },
  {
    "id": 262,
    "question": "In what cloud service model is the customer responsible for administration of the operating system?",
    "choice_a": "PaaS",
    "choice_b": "SaaS",
    "choice_c": "DaaS",
    "choice_d": "IaaS",
    "correct_answer": "D",
    "explanation": "In the infrastructure as a service model, the customer is responsible for the operating system. In PaaS and SaaS, the provider is responsible.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      8,
      12,
      237,
      13,
      147
    ],
    "source": ""
  },
  {
    "id": 263,
    "question": "Which is the highest level of data center redundancy, according to the Uptime Institute?",
    "choice_a": "4",
    "choice_b": "5",
    "choice_c": "3",
    "choice_d": "10",
    "correct_answer": "A",
    "explanation": "The Uptime Institute has four tiers of data center redundancy rating, with the highest being 4 and the lowest 1.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      589,
      586,
      588,
      593,
      595
    ],
    "source": ""
  },
  {
    "id": 264,
    "question": "Of the following, which type of test has the most impact on operations?",
    "choice_a": "Tabletop exercise",
    "choice_b": "Dry run",
    "choice_c": "Full test",
    "choice_d": "Structured test",
    "correct_answer": "C",
    "explanation": "A full test will always be the most comprehensive of tests. It includes every asset in the organization and all personnel.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      556,
      557,
      238,
      459,
      555
    ],
    "source": ""
  },
  {
    "id": 265,
    "question": "Which of the following has increased the viability of cloud services?",
    "choice_a": "Smart bus hubs",
    "choice_b": "Virtualization",
    "choice_c": "Agile development",
    "choice_d": "High-speed switching",
    "correct_answer": "B",
    "explanation": "Virtualization allows scalable resource allocation, which has in turn dramatically increased the viability of cloud services.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      141,
      14,
      2,
      11,
      15
    ],
    "source": ""
  },
  {
    "id": 266,
    "question": "Which of the following takes advantage of the information developed in the business impact analysis (BIA)?",
    "choice_a": "Calculating ROI",
    "choice_b": "Risk analysis",
    "choice_c": "Calculating TCO",
    "choice_d": "Securing asset acquisitions",
    "correct_answer": "B",
    "explanation": "Among other things, the BIA gathers asset valuation information that is crucial to risk management analysis and further selection of security controls.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      240,
      238,
      544,
      241,
      699
    ],
    "source": ""
  },
  {
    "id": 267,
    "question": "Which of the following is the best example of a SIEM function?",
    "choice_a": "Performance enhancements",
    "choice_b": "REST",
    "choice_c": "SOAP",
    "choice_d": "Centralization of log streams",
    "correct_answer": "D",
    "explanation": "In addition to centralization of log streams, SIEMs provide the ability to do trend analysis and view dashboards of activity.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      402,
      400,
      247,
      401,
      248
    ],
    "source": ""
  },
  {
    "id": 268,
    "question": "What is the lowest tier of data center redundancy according to the Uptime Institute?",
    "choice_a": "1",
    "choice_b": "3",
    "choice_c": "5",
    "choice_d": "7",
    "correct_answer": "A",
    "explanation": "There are four tiers of data center redundancy, with 1 being the lowest and 4 being the highest.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      588,
      589,
      590,
      591,
      594
    ],
    "source": ""
  },
  {
    "id": 269,
    "question": "What is a function common to many egress monitoring solutions?",
    "choice_a": "Elasticity",
    "choice_b": "Data discovery",
    "choice_c": "Metered service",
    "choice_d": "Satellite links",
    "correct_answer": "B",
    "explanation": "Egress monitoring has nothing to do with elasticity, metered service, or satellite links. However, egress monitoring tools often feature data discovery functions.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      326,
      400,
      247,
      402,
      101
    ],
    "source": ""
  },
  {
    "id": 270,
    "question": "Which of the following is the best example of a countermeasure used to protect cloud operations against external attackers?",
    "choice_a": "Continual monitoring for anomalous activity",
    "choice_b": "Detailed and extensive background checks",
    "choice_c": "Use of generic hardware in building infrastructure components",
    "choice_d": "Cameras inside the data center",
    "correct_answer": "A",
    "explanation": "Continual monitoring for anomalous activity is a great way to detect potential external attacks. The other answers have nothing to do with protecting cloud operations from external threats.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      402,
      401,
      108,
      627,
      333
    ],
    "source": ""
  },
  {
    "id": 271,
    "question": "Which of the following is included in the STRIDE model?",
    "choice_a": "Spoofing",
    "choice_b": "Testing",
    "choice_c": "Database",
    "choice_d": "Erasure",
    "correct_answer": "A",
    "explanation": "The STRIDE threat model includes spoofing, tampering, repudiation, information disclosure, and elevation of privilege.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      293,
      292,
      295,
      282,
      294
    ],
    "source": ""
  },
  {
    "id": 272,
    "question": "Which of the following is the most important mechanism to ensure trust in the cloud provider's performance and duties?",
    "choice_a": "The contract",
    "choice_b": "Statutory law",
    "choice_c": "CSA Security Alliance Cloud Controls Matrix",
    "choice_d": "SLA provisions",
    "correct_answer": "A",
    "explanation": "The contract between the provider and the customer provides trust between the two parties by holding the provider legally responsible for its contractual obligations.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      710,
      344,
      358,
      648,
      651
    ],
    "source": ""
  },
  {
    "id": 273,
    "question": "Which of the following is a characteristic of liquid propane gas that makes it attractive as a fuel for backup generators?",
    "choice_a": "Does not spoil",
    "choice_b": "Burn rate",
    "choice_c": "Price",
    "choice_d": "Ubiquitous",
    "correct_answer": "A",
    "explanation": "One primary advantage of LP gas is that it does not spoil the way gasoline and diesel fuel can. After sitting in tanks for extended periods, both diesel and gas will spoil and no longer burn properly.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      310,
      290,
      291,
      312,
      556
    ],
    "source": ""
  },
  {
    "id": 274,
    "question": "Of the following elements, which is the primary driver of security decisions?",
    "choice_a": "Location",
    "choice_b": "Access",
    "choice_c": "Resiliency",
    "choice_d": "Business requirements",
    "correct_answer": "D",
    "explanation": "Business requirements will and should always be what drives security decisions.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      546,
      238,
      544,
      336,
      537
    ],
    "source": ""
  },
  {
    "id": 275,
    "question": "Egress monitoring solutions can aid in reducing the possibility of losses due to ______.",
    "choice_a": "Inadvertent disclosure",
    "choice_b": "Natural disasters",
    "choice_c": "Device failures",
    "choice_d": "Randomization",
    "correct_answer": "A",
    "explanation": "Egress monitoring tools can aid in reducing the possibility of inadvertent disclosures. They are not designed to assist in any of the other situations.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      401,
      402,
      400,
      249,
      326
    ],
    "source": ""
  },
  {
    "id": 276,
    "question": "Which of the following represents a technique to enhance the portability of cloud data?",
    "choice_a": "Avoiding proprietary data formats",
    "choice_b": "DRM",
    "choice_c": "DLP",
    "choice_d": "Comprehensive auditing",
    "correct_answer": "A",
    "explanation": "Avoiding proprietary data formats will aid portability efforts. DRM, DLP, and audits have no impact on portability.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      18,
      422,
      197,
      206,
      9
    ],
    "source": ""
  },
  {
    "id": 277,
    "question": "What term best describes a set of technologies that analyze application source code, byte code, and binaries for coding and design problems that would indicate a security problem or vulnerability?",
    "choice_a": "DAST",
    "choice_b": "SAST",
    "choice_c": "MFA",
    "choice_d": "STRIDE",
    "correct_answer": "B",
    "explanation": "DAST stands for dynamic application security testing and cannot analyze source code as it analyzes code while it is running. MFA stands for multifactor authentication, and STRIDE is a threat model concept.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      298,
      299,
      300,
      295,
      294
    ],
    "source": ""
  },
  {
    "id": 278,
    "question": "Of the following, which type of SSAE audit report is the cloud provider most likely to be willing to share without any additional participation from the cloud customer?",
    "choice_a": "SOC 1 Type 1",
    "choice_b": "SOC 3",
    "choice_c": "SOC 2 Type 1",
    "choice_d": "SOC 3 Type 2",
    "correct_answer": "B",
    "explanation": "SOC 3 is the least detailed report, designed for public dissemination. There is no SOC 3 Type 2 report.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      344,
      349,
      341,
      345,
      350
    ],
    "source": ""
  },
  {
    "id": 279,
    "question": "Which of the following terms is not associated with the STRIDE model?",
    "choice_a": "Spoofing",
    "choice_b": "Tampering",
    "choice_c": "Resiliency",
    "choice_d": "Information disclosure",
    "correct_answer": "C",
    "explanation": "Resiliency is not a component of the STRIDE model, which consists of spoofing, tampering, repudiation, information disclosure, and elevation of privilege.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      293,
      295,
      280,
      292,
      297
    ],
    "source": ""
  },
  {
    "id": 280,
    "question": "Inability to remotely access a cloud provider impacts which of the three elements of the CIA triad?",
    "choice_a": "Integrity",
    "choice_b": "Availability",
    "choice_c": "Confidentiality",
    "choice_d": "Access controls",
    "correct_answer": "B",
    "explanation": "The element of availability is impacted if a remote user cannot access the cloud provider.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      16,
      144,
      2,
      147,
      148
    ],
    "source": ""
  },
  {
    "id": 281,
    "question": "In which cloud service model is the customer required to maintain and update only the applications?",
    "choice_a": "SaaS",
    "choice_b": "IaaS",
    "choice_c": "PaaS",
    "choice_d": "DaaS",
    "correct_answer": "C",
    "explanation": "In the platform as a service model, the customer is paying for access to a (virtual) machine with an operating system on which to install applications. Since the customer owns the applications, it is their responsibility to keep the applications up to date.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      8,
      12,
      237,
      235,
      13
    ],
    "source": ""
  },
  {
    "id": 282,
    "question": "In which cloud service model is the customer responsible for only the data?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "DaaS",
    "correct_answer": "C",
    "explanation": "In the SaaS model, the infrastructure, OS, and application are managed by the cloud provider.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      8,
      12,
      237,
      13,
      235
    ],
    "source": ""
  },
  {
    "id": 283,
    "question": "Egress monitoring solutions can aid in reducing the potential for loss due to ________.",
    "choice_a": "Data seizure",
    "choice_b": "Crypto-shredding",
    "choice_c": "Malicious disclosure",
    "choice_d": "Encryption",
    "correct_answer": "C",
    "explanation": "Egress monitoring tools identify outbound traffic that violates an organization's policies, such as when a malicious user attempts data exfiltration.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      98,
      97,
      249,
      402,
      400
    ],
    "source": ""
  },
  {
    "id": 284,
    "question": "Compliance with ASHRAE data center standards for humidity can help reduce the risk of which of the following?",
    "choice_a": "Static discharge",
    "choice_b": "Malicious users",
    "choice_c": "Increased power usage",
    "choice_d": "Increased heating cooling expenses",
    "correct_answer": "A",
    "explanation": "The ASHRAE standards provide for humidity standards that reduce the chances of static discharge, which could be catastrophic in a data center environment.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      594,
      592,
      595,
      593,
      326
    ],
    "source": ""
  },
  {
    "id": 285,
    "question": "Of the following, which does not represent a level of the CSA STAR certification program?",
    "choice_a": "Self-assessment",
    "choice_b": "SOC 2 Type 3",
    "choice_c": "Third-party assessment-based certifications",
    "choice_d": "Continuous monitoring-based certification",
    "correct_answer": "B",
    "explanation": "SOC 2 Type 3 is not an actual report format. All of the other options are part of the levels of the CSA STAR certification program.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      647,
      646,
      360,
      359,
      358
    ],
    "source": ""
  },
  {
    "id": 286,
    "question": "Which of the following is a service that might be offered by a cloud access security broker (CASB)?",
    "choice_a": "BC/DR/COOP",
    "choice_b": "SIEM services",
    "choice_c": "Key escrow",
    "choice_d": "Risk assessments",
    "correct_answer": "C",
    "explanation": "Cloud security access brokers typically provide services such as key escrow, single sign-on, and identity and access management. All of the other options are outside the scope of their activities.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      12,
      480,
      481,
      206,
      147
    ],
    "source": ""
  },
  {
    "id": 287,
    "question": "The ___________________ codifies the rights and responsibilities of the parties involved upon completion of negotiation.",
    "choice_a": "SLA",
    "choice_b": "Contract",
    "choice_c": "MOU",
    "choice_d": "RFP",
    "correct_answer": "B",
    "explanation": "The SLA is the subset of the contract concerning service performance, and the other options are red herrings and have nothing to do with codification of rights and responsibilities.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      710,
      339,
      347,
      358,
      343
    ],
    "source": ""
  },
  {
    "id": 288,
    "question": "In cloud computing, which of the following best describes the data owner?",
    "choice_a": "Cloud provider",
    "choice_b": "Resides in a different jurisdiction",
    "choice_c": "Cloud broker",
    "choice_d": "Cloud customer",
    "correct_answer": "D",
    "explanation": "The cloud customer is generally accepted as the data owner.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      709,
      710,
      658,
      337,
      339
    ],
    "source": ""
  },
  {
    "id": 289,
    "question": "What is a technology that may lead to the ability to process encrypted data without having to decrypt it first?",
    "choice_a": "AES encryption",
    "choice_b": "MD5 hashing",
    "choice_c": "Message authentication",
    "choice_d": "Homomorphic encryption",
    "correct_answer": "D",
    "explanation": "Homomorphic encryption is an experimental technology that would allow ciphertext to be manipulated in processes and still produce the same results as when the unencrypted plaintext of the same data is processed.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      503,
      255,
      40,
      41,
      31
    ],
    "source": ""
  },
  {
    "id": 290,
    "question": "Which of the following does not represent an attack on a network?",
    "choice_a": "Syn flood",
    "choice_b": "Denial of service",
    "choice_c": "Nmap scan",
    "choice_d": "Brute force",
    "correct_answer": "C",
    "explanation": "All of the rest of these options represent specific network attacks. Nmap is a relatively harmless scanning utility designed for network mapping. Although it can be used to gather information about a network as part of the process of developing an attack, it is not by itself an attack tool.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      539,
      520,
      713,
      714,
      685
    ],
    "source": ""
  },
  {
    "id": 291,
    "question": "When migrating to the cloud, which of the following dependencies are not important as part of the BIA review process?",
    "choice_a": "Cloud provider's suppliers",
    "choice_b": "Cloud provider's vendors",
    "choice_c": "Cloud provider's utilities",
    "choice_d": "Cloud provider's resellers and brokers",
    "correct_answer": "D",
    "explanation": "All options except D are important dependencies when reviewing the BIA.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      240,
      545,
      556,
      558,
      459
    ],
    "source": ""
  },
  {
    "id": 292,
    "question": "A _________________ is an isolated space where untested code and experimentation can safely occur separate from the production environment.",
    "choice_a": "Hypervisor",
    "choice_b": "Sandbox",
    "choice_c": "Virtual machine",
    "choice_d": "Virtual application",
    "correct_answer": "B",
    "explanation": "A sandbox is designed and used specifically for testing and experimenting in a manner in which live data cannot be harmed.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      283,
      284,
      285,
      298,
      299
    ],
    "source": ""
  },
  {
    "id": 293,
    "question": "Which of the following is a feature of SAST?",
    "choice_a": "Testing applications while running in RAM",
    "choice_b": "Pen testing",
    "choice_c": "Team-building efforts",
    "choice_d": "Source code review",
    "correct_answer": "D",
    "explanation": "Static application security testing (SAST) examines source code while the application is not running.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      298,
      300,
      295,
      283,
      676
    ],
    "source": ""
  },
  {
    "id": 294,
    "question": "How long should an uninterruptible power supply (UPS) be able to run during a sustained power outage?",
    "choice_a": "Long enough for administrative intervention",
    "choice_b": "Long enough to complete a graceful system shutdown",
    "choice_c": "Until the power resumes",
    "choice_d": "4 hours",
    "correct_answer": "B",
    "explanation": "A UPS is configured to safely shut down systems in order to save data in the event of a power failure.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      289,
      290,
      291,
      404,
      427
    ],
    "source": ""
  },
  {
    "id": 295,
    "question": "Which of the following terms is not associated with the CIA triad?",
    "choice_a": "Integrity",
    "choice_b": "Availability",
    "choice_c": "Confidentiality",
    "choice_d": "Independence",
    "correct_answer": "D",
    "explanation": "The CIA triad consists of confidentiality, integrity, and availability. Independence is a term used in the world of IT audits.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      16,
      259,
      215,
      226,
      221
    ],
    "source": ""
  },
  {
    "id": 296,
    "question": "Which of the following is not an example of encryption used in cloud computing?",
    "choice_a": "Storage encryption",
    "choice_b": "Session encryption",
    "choice_c": "Data masking",
    "choice_d": "TLS remote access",
    "correct_answer": "C",
    "explanation": "Data masking is a technique whereby similar text strings are used in place of real data. Options A, B, and D are all examples of encryption in cloud computing.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      422,
      233,
      182,
      1,
      2
    ],
    "source": ""
  },
  {
    "id": 297,
    "question": "Of the following, who best represents the data processor in cloud computing?",
    "choice_a": "Cloud provider",
    "choice_b": "Cloud customer",
    "choice_c": "Cloud broker",
    "choice_d": "Cloud",
    "correct_answer": "A",
    "explanation": "The legal definition of a data processor is anyone who stores, handles, moves, or manipulates data on behalf of the data owner/controller. In the case of cloud computing, this is the cloud provider.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      658,
      659,
      709,
      660,
      337
    ],
    "source": ""
  },
  {
    "id": 298,
    "question": "Of the following, which term is most closely associated with egress monitoring tools?",
    "choice_a": "Data classification",
    "choice_b": "Data scrubbing",
    "choice_c": "Data sharing",
    "choice_d": "Data management",
    "correct_answer": "A",
    "explanation": "Data classification is vital in egress monitoring solutions. This typically occurs at the time of data creation.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      101,
      401,
      249,
      326,
      603
    ],
    "source": ""
  },
  {
    "id": 299,
    "question": "What is the phase of an investigation where evidence is collected?",
    "choice_a": "eDiscovery",
    "choice_b": "eTriage",
    "choice_c": "Forensic analysis",
    "choice_d": "Data collection",
    "correct_answer": "A",
    "explanation": "eDiscovery is about gathering evidence.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      407,
      406,
      408,
      650,
      649
    ],
    "source": ""
  },
  {
    "id": 300,
    "question": "Of the following, which is not a feature of DAST?",
    "choice_a": "Runtime testing",
    "choice_b": "Executable testing by teams",
    "choice_c": "Black-box testing",
    "choice_d": "Code review",
    "correct_answer": "D",
    "explanation": "All of the other items listed are features of dynamic application security testing.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      300,
      295,
      293,
      296,
      431
    ],
    "source": ""
  },
  {
    "id": 301,
    "question": "How quickly should data center transfer switches bring backup power online in the event of a main failure?",
    "choice_a": "3 seconds",
    "choice_b": "1 minute",
    "choice_c": "5 minutes",
    "choice_d": "Before the battery backups fail",
    "correct_answer": "D",
    "explanation": "The purpose of the transfer switch is to redirect power consumption from utility power to generator power; this should be done fast enough to ensure power is available when the batteries fail.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      289,
      290,
      310,
      291,
      427
    ],
    "source": ""
  },
  {
    "id": 302,
    "question": "Of the following, which is an example of a technical control?",
    "choice_a": "Fire suppression equipment",
    "choice_b": "Audit trails",
    "choice_c": "Security policies",
    "choice_d": "Configuration procedures",
    "correct_answer": "B",
    "explanation": "Audit trails are an example of a technical control. Fire suppression equipment, security policies, and configuration procedures are all examples of administrative controls.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      241,
      243,
      44,
      242,
      42
    ],
    "source": ""
  },
  {
    "id": 303,
    "question": "Of the following, which is the most important?",
    "choice_a": "Health and human safety",
    "choice_b": "Access control policy",
    "choice_c": "Encryption",
    "choice_d": "Multifactor authentication",
    "correct_answer": "A",
    "explanation": "Health and human safety is always the paramount security concern.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      352,
      347,
      650,
      351,
      343
    ],
    "source": ""
  },
  {
    "id": 304,
    "question": "In order for tokenization to work properly, which of the following must be in place?",
    "choice_a": "Multifactor authentication",
    "choice_b": "Asymmetric encryption keys",
    "choice_c": "Two databases",
    "choice_d": "Multifactor key fobs",
    "correct_answer": "C",
    "explanation": "Tokenization requires two databases: one containing the raw, original data and a second that contains the tokens that map to the original data.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      253,
      254,
      503,
      507,
      255
    ],
    "source": ""
  },
  {
    "id": 305,
    "question": "In which of the following does the customer have the most control of their data and systems while the cloud provider will have the least amount of responsibility?",
    "choice_a": "PaaS",
    "choice_b": "IaaS",
    "choice_c": "SaaS",
    "choice_d": "DaaS",
    "correct_answer": "B",
    "explanation": "In the infrastructure as a service model, the provider offers and manages the physical plant and connectivity to underlying hardware. All systems and data are the responsibility of the customer.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      8,
      237,
      12,
      13,
      235
    ],
    "source": ""
  },
  {
    "id": 306,
    "question": "Which of the following adds nothing or very little to enhancing trust of the cloud provider?",
    "choice_a": "Audit reports",
    "choice_b": "CCTV surveillance",
    "choice_c": "Shared administration",
    "choice_d": "Service-level agreements",
    "correct_answer": "B",
    "explanation": "CCTV surveillance generally does very little to enhance the trust of a cloud provider. The other factors provide information as to the integrity of security operations, which is highly valued and will add to the trust factor of the cloud provider.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      343,
      358,
      360,
      648,
      351
    ],
    "source": ""
  },
  {
    "id": 307,
    "question": "Which of the following not a feature of a secure KVM (keyboard/video/mouse) component?",
    "choice_a": "Sealed exterior case",
    "choice_b": "A TPM chip",
    "choice_c": "Push-button selectors",
    "choice_d": "Welded chipsets",
    "correct_answer": "B",
    "explanation": "A TPM (Trusted Platform Module) is a security device found on an individual machine and is designed to store encryption keys securely. Options A, C, and D are all features of secure KVMs.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      305,
      306,
      304,
      100,
      716
    ],
    "source": ""
  },
  {
    "id": 308,
    "question": "A threat coupled with vulnerability is best defined as a ______________.",
    "choice_a": "Problem",
    "choice_b": "Risk assessment",
    "choice_c": "Risk",
    "choice_d": "Penetration test",
    "correct_answer": "C",
    "explanation": "A vulnerability combined with a specific threat is defined as a risk.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      697,
      699,
      546,
      554,
      543
    ],
    "source": ""
  },
  {
    "id": 309,
    "question": "Which of the following is the kind of hypervisor preferred by hackers due to its increased attack surface?",
    "choice_a": "Type I",
    "choice_b": "Type III",
    "choice_c": "Type IV",
    "choice_d": "Type II",
    "correct_answer": "D",
    "explanation": "Type II hypervisors are appealing to attackers because they have more potential for flaws and vulnerabilities due to the fact that there is an operating system running underneath the hypervisor.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      14,
      142,
      15,
      215,
      217
    ],
    "source": ""
  },
  {
    "id": 310,
    "question": "Which of the following is the best example of a technical control?",
    "choice_a": "Access control lists",
    "choice_b": "Door locks",
    "choice_c": "Overriding security policy",
    "choice_d": "Configuration guidelines",
    "correct_answer": "A",
    "explanation": "Only access control lists are a technical control. Door locks are a physical control, and both the policy and guidelines represent administrative controls.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      241,
      243,
      242,
      448,
      44
    ],
    "source": ""
  },
  {
    "id": 311,
    "question": "Which of the following is a service that provides replication of data across various locations?",
    "choice_a": "Software defined networking (SDN)",
    "choice_b": "Virtual network",
    "choice_c": "Content delivery network (CDN)",
    "choice_d": "Local area network (LAN)",
    "correct_answer": "C",
    "explanation": "A content delivery network (CDN) is a service that distributes data.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      410,
      409,
      411,
      371,
      26
    ],
    "source": ""
  },
  {
    "id": 312,
    "question": "After a cloud migration, risks must be reviewed. However, a complete analysis is not necessary because much of the material has already been compiled in which of the following?",
    "choice_a": "The cost-benefit analysis completed prior to migration",
    "choice_b": "The recent BIA",
    "choice_c": "The last risk assessment",
    "choice_d": "NIST 800-54r4",
    "correct_answer": "A",
    "explanation": "Most of the risks associated with the cloud migration are examined in the cost-benefit phase of evaluation and therefore do not need to be revisited.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      6,
      215,
      216,
      217,
      226
    ],
    "source": ""
  },
  {
    "id": 313,
    "question": "Which of the following is not an acceptable practice for user access control administration?",
    "choice_a": "Customer directly administers access",
    "choice_b": "Provider provides administration on behalf of the customer",
    "choice_c": "Customer provides access administration on behalf of provider",
    "choice_d": "Third party provides administration on behalf of the customer",
    "correct_answer": "C",
    "explanation": "The customer never provides access control on behalf of the provider. All the other options are acceptable.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      481,
      487,
      480,
      12,
      489
    ],
    "source": ""
  },
  {
    "id": 314,
    "question": "Of the following data center redundancy characteristics, which will be in place regardless of tier?",
    "choice_a": "All hardware",
    "choice_b": "Power",
    "choice_c": "Emergency egress",
    "choice_d": "Cooling",
    "correct_answer": "C",
    "explanation": "Human life is always the first priority, so all data centers must have an emergency egress. The other characteristics will only be in place and associated with specific tiers.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      588,
      590,
      587,
      593,
      594
    ],
    "source": ""
  },
  {
    "id": 315,
    "question": "Which of the following is the most important in a BC/DR incident?",
    "choice_a": "Checklists",
    "choice_b": "Redundant power",
    "choice_c": "Backups",
    "choice_d": "Spare hardware",
    "correct_answer": "A",
    "explanation": "A BC/DR event is no time to be scrambling around trying to figure out what to do. Having a plan in place and executing it is dependent on everyone understanding the plan, and checklists are the way we work through steps of the plan in order.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      320,
      545,
      556,
      557,
      697
    ],
    "source": ""
  },
  {
    "id": 316,
    "question": "Of the following, which is not associated with vendor lock-in?",
    "choice_a": "Statutory compliance",
    "choice_b": "Poorly written contracts",
    "choice_c": "Nonportable data formats",
    "choice_d": "Market forces",
    "correct_answer": "A",
    "explanation": "Statutory compliance refers to state and federal laws. They cannot force a customer to stay with a cloud provider. However, all the rest are problems that can lead to vendor lock-in.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      18,
      229,
      230,
      220,
      182
    ],
    "source": ""
  },
  {
    "id": 317,
    "question": "Of the following, which is the most practical and secure type of data disposal in the cloud?",
    "choice_a": "Overwriting",
    "choice_b": "Scrubbing",
    "choice_c": "Crypto-shredding",
    "choice_d": "Degaussing",
    "correct_answer": "C",
    "explanation": "Crypto-shredding is the most practical method for cloud environments. The others are not realistic in that they require physical access to the facility or logical access to all hardware the data has been stored on, which is not pragmatic in a cloud environment.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      423,
      422,
      231,
      195,
      152
    ],
    "source": ""
  },
  {
    "id": 318,
    "question": "Poorly negotiated contracts can cause many problems. Of the following, which is not an example of what can happen when contracts are not properly negotiated?",
    "choice_a": "Unfavorable terms",
    "choice_b": "Malware",
    "choice_c": "Vendor lock-in",
    "choice_d": "Paying for services not used",
    "correct_answer": "B",
    "explanation": "Malware is not the result of a poorly negotiated cloud contract. However, unfavorable terms, paying for services not used, and vendor lock-in are all possible effects of a poorly negotiated contract.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      710,
      128,
      345,
      648,
      652
    ],
    "source": ""
  },
  {
    "id": 319,
    "question": "A set of routines, standards, protocols, and tools for building software applications to access a web-based software application or tool is best described by which of the following?",
    "choice_a": "API",
    "choice_b": "ABC",
    "choice_c": "ONF",
    "choice_d": "ANF",
    "correct_answer": "A",
    "explanation": "The application programming interface (API) is a set of routines, standards, protocols, and tools for building software applications to access a web-based software application or tool.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      441,
      704,
      568,
      702,
      579
    ],
    "source": ""
  },
  {
    "id": 320,
    "question": "Of the following, which represents the audit results in an SSAE audit dealing with confidentiality, integrity, and availability of data?",
    "choice_a": "SOC 2",
    "choice_b": "SOC 1",
    "choice_c": "SOX 2",
    "choice_d": "SOX 1",
    "correct_answer": "A",
    "explanation": "The SOC 2 report deals specifically with what are called the trust principles, and they include the CIA triad. The SOC 1 is designed for reviewing financial controls, and there is no \u201cSOX\u201d audit.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      344,
      341,
      343,
      349,
      345
    ],
    "source": ""
  },
  {
    "id": 321,
    "question": "When you are designing redundancy and contingency planning in a data center, which of the following is the most important consideration?",
    "choice_a": "Power availability",
    "choice_b": "Health and human safety",
    "choice_c": "HVAC capabilities",
    "choice_d": "Redundant telco providers",
    "correct_answer": "B",
    "explanation": "While the other options are important, they are all subordinate to human health and safety, which is the first priority of any security program.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      590,
      589,
      588,
      95,
      636
    ],
    "source": ""
  },
  {
    "id": 322,
    "question": "Of the following, whose advice should be given the most weight on the decision to patch a live production system?",
    "choice_a": "Customer",
    "choice_b": "Vendor",
    "choice_c": "Internal compliance",
    "choice_d": "Supervisor",
    "correct_answer": "B",
    "explanation": "The vendor should be the one advising when and how to patch a system as they will have the most up-to-date information and it will be their patches you are applying.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      318,
      316,
      622,
      102,
      624
    ],
    "source": ""
  },
  {
    "id": 323,
    "question": "Of the following, which is most closely associated with financial controls?",
    "choice_a": "SOC 1",
    "choice_b": "SOC 2",
    "choice_c": "SOC 3",
    "choice_d": "SCO 4",
    "correct_answer": "A",
    "explanation": "The SOC 1 report is primarily for reporting on financial controls.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      341,
      344,
      349,
      353,
      343
    ],
    "source": ""
  },
  {
    "id": 324,
    "question": "Which of the following best represent the three distinct levels of the CSA STAR program?",
    "choice_a": "Third-party assessment, attestation, and ongoing monitoring",
    "choice_b": "Self-assessment, SOC 2, and ongoing monitoring",
    "choice_c": "Self-assessment, attestation, and ongoing monitoring certification",
    "choice_d": "Self-assessment, attestation, and certification",
    "correct_answer": "C",
    "explanation": "Self-assessment, attestation, and ongoing monitoring certification are the three levels of STAR certification.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      358,
      646,
      359,
      360,
      647
    ],
    "source": ""
  },
  {
    "id": 325,
    "question": "Which term best describes when a cloud provider goes out of business and leaves the customer unable to retrieve data?",
    "choice_a": "Vendor lock-in",
    "choice_b": "Vendor lock-out",
    "choice_c": "Bankruptcy",
    "choice_d": "Vendor closure",
    "correct_answer": "B",
    "explanation": "This is the definition of vendor lock-out: when the cloud provider goes out of business and you can no longer access your data. This must be considered when you are determining whether to cloud migration.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      229,
      230,
      232,
      170,
      237
    ],
    "source": ""
  },
  {
    "id": 326,
    "question": "Of the following, which is not directly related to DLP?",
    "choice_a": "High-speed bandwidth",
    "choice_b": "Egress monitoring",
    "choice_c": "Regulatory compliance",
    "choice_d": "Policy enforcement",
    "correct_answer": "A",
    "explanation": "Data loss protection (DLP) are tools for egress monitoring, and regulatory compliance and policy enforcement are some of their goals. High-speed bandwidth has no direct relationship to DLP.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      412,
      413,
      499,
      688,
      250
    ],
    "source": ""
  },
  {
    "id": 327,
    "question": "Which of the following is the term used for the intellectual property protection for the tangible expression of creative ideas?",
    "choice_a": "Trademark",
    "choice_b": "Registration",
    "choice_c": "Copyright",
    "choice_d": "Trade secret",
    "correct_answer": "C",
    "explanation": "Copyrights are designed to protect tangible expressions of creative works, like books, articles, music, and so on.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      385,
      386,
      395,
      31,
      33
    ],
    "source": ""
  },
  {
    "id": 328,
    "question": "Object and volume storage are used with ___________________.",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "DaaS",
    "correct_answer": "A",
    "explanation": "Object and volume storage are both related to infrastructure.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      409,
      494,
      497,
      498,
      253
    ],
    "source": ""
  },
  {
    "id": 329,
    "question": "The application normative framework is best described as _________.",
    "choice_a": "A stand-alone framework",
    "choice_b": "NIST 800-54r4",
    "choice_c": "A superset of the ONF",
    "choice_d": "A subset of the ONF",
    "correct_answer": "D",
    "explanation": "The application framework is a subset of the organizational framework with a many-to-one relationship.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      417,
      415,
      93,
      579,
      452
    ],
    "source": ""
  },
  {
    "id": 330,
    "question": "Of the following SOC reports, which is the most commonly advertised?",
    "choice_a": "SOC 1",
    "choice_b": "SOC 2 Type 2",
    "choice_c": "SOC 2 Type 1",
    "choice_d": "SOC 3",
    "correct_answer": "D",
    "explanation": "The SOC 3 report is merely an attestation by an auditor. It does not contain any confidential information and is therefore readily available upon request and often even advertised on websites.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      341,
      344,
      349,
      345,
      647
    ],
    "source": ""
  },
  {
    "id": 331,
    "question": "All of the following should be represented in the configuration/change management board except ___________________.",
    "choice_a": "IT department",
    "choice_b": "Regulators",
    "choice_c": "Security department",
    "choice_d": "Management",
    "correct_answer": "B",
    "explanation": "All others should be represented in CMB activities.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      606,
      322,
      324,
      323,
      604
    ],
    "source": ""
  },
  {
    "id": 332,
    "question": "Which of the following best represents the primary function of a SOC 3 report?",
    "choice_a": "Seal of approval",
    "choice_b": "HIPAA compliance",
    "choice_c": "PCI compliance",
    "choice_d": "SOX compliance",
    "correct_answer": "A",
    "explanation": "The SOC 3 report is an attestation that an evaluation has occurred and that everything passed. It contains no details.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      344,
      341,
      349,
      343,
      345
    ],
    "source": ""
  },
  {
    "id": 333,
    "question": "Which of the following is the intermediary who provides connectivity and transport of cloud services between cloud providers and cloud customers?",
    "choice_a": "Cloud provider",
    "choice_b": "Cloud broker",
    "choice_c": "Cloud carrier",
    "choice_d": "Cloud proxy",
    "correct_answer": "C",
    "explanation": "The cloud carrier is distinct in that they provide connectivity and transport services between cloud providers and customers. Brokers and providers provide other services, and there is no such thing as a cloud proxy.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      131,
      130,
      133,
      134,
      114
    ],
    "source": ""
  },
  {
    "id": 334,
    "question": "Of the following, which is not a characteristic of cloud computing?",
    "choice_a": "White-box testing",
    "choice_b": "Broad network access",
    "choice_c": "Rapid scaling",
    "choice_d": "On-demand self-service",
    "correct_answer": "A",
    "explanation": "White-box testing tests the program logic and is used for unit and integration testing. It has nothing to do with cloud characteristics.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      8,
      7,
      158,
      148,
      156
    ],
    "source": ""
  },
  {
    "id": 335,
    "question": "Which of the following is not a process used in device hardening?",
    "choice_a": "Strict administrator access",
    "choice_b": "Unused port closures",
    "choice_c": "Dual power supplies",
    "choice_d": "Deletion of unused/unnecessary services",
    "correct_answer": "C",
    "explanation": "While having secondary redundant power supplies helps with device redundancy, it has nothing to do with device hardening. Each of the other options helps in the hardening process.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      104,
      611,
      612,
      610,
      108
    ],
    "source": ""
  },
  {
    "id": 336,
    "question": "Of the following, which would be used to protect the intellectual property of a manufacturing process?",
    "choice_a": "Copyright",
    "choice_b": "Trademark",
    "choice_c": "Patent",
    "choice_d": "Trade secret",
    "correct_answer": "C",
    "explanation": "Patents are designed to protect the intellectual property of processes.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      385,
      386,
      396,
      29,
      25
    ],
    "source": ""
  },
  {
    "id": 337,
    "question": "What is the primary function of a hardware security module (HSM)?",
    "choice_a": "Ensures adequate device power",
    "choice_b": "Integration testing",
    "choice_c": "Security accreditation",
    "choice_d": "Safely stores and manages encryption keys",
    "correct_answer": "D",
    "explanation": "The HSM is a device embedded into the hardware of another device and is used to store encryption keys. If implemented properly, it is far stronger than saving and storing keys in software.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      418,
      494,
      507,
      503,
      31
    ],
    "source": ""
  },
  {
    "id": 338,
    "question": "Which of the following is not a good example of countermeasures designed to protect cloud operations from internal threats?",
    "choice_a": "Vendor lock-out",
    "choice_b": "Egress monitoring",
    "choice_c": "Admin employee background checks",
    "choice_d": "User training",
    "correct_answer": "A",
    "explanation": "Vendor lock-out refers to a cloud provider no longer providing service, which is an external problem. All the rest are valid methods of protecting against internal threats.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      108,
      603,
      323,
      401,
      402
    ],
    "source": ""
  },
  {
    "id": 339,
    "question": "Which of the following is a standard for exchanging authentication and authorization of data between security domains?",
    "choice_a": "HTML",
    "choice_b": "SAML",
    "choice_c": "REST",
    "choice_d": "DNS",
    "correct_answer": "B",
    "explanation": "This is the definition of SAML. None of the other options has anything to do with authentication or authorization.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      576,
      705,
      369,
      368,
      701
    ],
    "source": ""
  },
  {
    "id": 340,
    "question": "When monitoring for performance reasons, which of the following should not be included?",
    "choice_a": "Free disk space",
    "choice_b": "Disk I/O",
    "choice_c": "CPU usage",
    "choice_d": "Printer queue performance",
    "correct_answer": "D",
    "explanation": "Print spooling is not an accepted performance measure. All the others are critical to keeping the environment running at peak efficiency.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      325,
      327,
      621,
      248,
      104
    ],
    "source": ""
  },
  {
    "id": 341,
    "question": "With regard to PII stored in the cloud, who is ultimately responsible for the security of that PII?",
    "choice_a": "Cloud provider",
    "choice_b": "Cloud broker",
    "choice_c": "Cloud customer",
    "choice_d": "System administrator",
    "correct_answer": "C",
    "explanation": "The cloud customer is always the data owner and therefore ultimately responsible for the security of PII.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      339,
      338,
      648,
      344,
      354
    ],
    "source": ""
  },
  {
    "id": 342,
    "question": "Which of the following is a technique used in hardening a device?",
    "choice_a": "Use of SSL for communications",
    "choice_b": "Patching and updating",
    "choice_c": "PKI",
    "choice_d": "OS encryption",
    "correct_answer": "B",
    "explanation": "Updating and keeping systems patched is one of the most effective ways to keep them secure. If you were to encrypt the OS, you would not be able to use the system, and SSL and PKI refer to ways of protecting communications.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      104,
      102,
      318,
      108,
      603
    ],
    "source": ""
  },
  {
    "id": 343,
    "question": "Of the following, which would be used to protect a company's sales lead information?",
    "choice_a": "Trademark",
    "choice_b": "Copyright",
    "choice_c": "Patent",
    "choice_d": "Trade secret",
    "correct_answer": "D",
    "explanation": "Information specific to a company and that is unique to them would be covered under the term trade secret.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      385,
      386,
      31,
      29,
      25
    ],
    "source": ""
  },
  {
    "id": 344,
    "question": "Which of the following is an example of best practices for storing encryption keys?",
    "choice_a": "Storing them separately from data",
    "choice_b": "Using AES",
    "choice_c": "At least 256 bits",
    "choice_d": "Putting on a thumb drive and removed",
    "correct_answer": "A",
    "explanation": "You never want to store encryption keys with the data they are protecting. They should always be stored on a separate system. However, a thumb drive does not constitute a separate system and could easily lead to key compromise.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      418,
      419,
      420,
      494,
      41
    ],
    "source": ""
  },
  {
    "id": 345,
    "question": "Which of the following is one example of a way to protect a data center from the impact of external threats?",
    "choice_a": "Masking and obfuscation",
    "choice_b": "Redundant policies",
    "choice_c": "Redundant ISPs",
    "choice_d": "HVAC",
    "correct_answer": "C",
    "explanation": "Having redundant ISPs or carriers provides the data center with protection against such external threats as DDoS, intentional fiber cuts, and similar effects.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      311,
      289,
      290,
      554,
      556
    ],
    "source": ""
  },
  {
    "id": 346,
    "question": "Regardless of cloud deployment or service model, the customer will always be allowed access to which of the following?",
    "choice_a": "Access controls",
    "choice_b": "User permissions",
    "choice_c": "Data",
    "choice_d": "Hypervisor",
    "correct_answer": "C",
    "explanation": "Regardless of model, the customer owns the data and will therefore always be allowed access to it.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      235,
      237,
      12,
      13,
      195
    ],
    "source": ""
  },
  {
    "id": 347,
    "question": "Which of the following has never caused a data center outage?",
    "choice_a": "Squirrels",
    "choice_b": "Changes in regulations",
    "choice_c": "Construction",
    "choice_d": "Hackers",
    "correct_answer": "B",
    "explanation": "A change in regulations has never resulted in a data center outage, but each of the other options has caused many outages.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      289,
      310,
      290,
      291,
      729
    ],
    "source": ""
  },
  {
    "id": 348,
    "question": "When a system is put into maintenance mode, which of the following occurs?",
    "choice_a": "All active production instances are removed and new logins are prevented while logging continues.",
    "choice_b": "All active production instances are removed while logging continues.",
    "choice_c": "New logins are prevented while logging continues.",
    "choice_d": "All active production instances are suspended and new logins are prevented while logging continues.",
    "correct_answer": "A",
    "explanation": "This is the only option that includes all of the maintenance mode actions.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      329,
      328,
      620,
      614,
      447
    ],
    "source": ""
  },
  {
    "id": 349,
    "question": "Which of the following would be used to learn the critical paths, processes, and assets of an organization?",
    "choice_a": "Business impact analysis",
    "choice_b": "Business requirements",
    "choice_c": "Risk assessment",
    "choice_d": "Penetration test",
    "correct_answer": "A",
    "explanation": "Business impact analysis (BIA) is designed to identify and ascertain the value of assets in addition to the critical paths and processes.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      238,
      544,
      556,
      239,
      427
    ],
    "source": ""
  },
  {
    "id": 350,
    "question": "Which type of intellectual property protection would apply to a secret recipe?",
    "choice_a": "Trade secret",
    "choice_b": "Copyright",
    "choice_c": "Trademark",
    "choice_d": "Patent",
    "correct_answer": "A",
    "explanation": "A recipe that is not secret could be protected by a patent.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      385,
      379,
      382,
      388,
      396
    ],
    "source": ""
  },
  {
    "id": 351,
    "question": "Which of the following is not a countermeasure designed to protect against internal threats?",
    "choice_a": "Separation of duties",
    "choice_b": "Data masking",
    "choice_c": "DLP solutions",
    "choice_d": "Scalability",
    "correct_answer": "D",
    "explanation": "All except option D are designed to protect against unreliable personnel actions, including by cloud administrators.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      108,
      603,
      323,
      111,
      627
    ],
    "source": ""
  },
  {
    "id": 352,
    "question": "Security controls for all types of cloud services and models are driven primarily by which of the following?",
    "choice_a": "Regulations",
    "choice_b": "Business requirements",
    "choice_c": "State laws",
    "choice_d": "Best practices",
    "correct_answer": "B",
    "explanation": "Security controls should always be based on the needs of the business. Regulations, state laws, and best practices may all shape the business requirements but are not direct drivers themselves.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      238,
      537,
      241,
      679,
      243
    ],
    "source": ""
  },
  {
    "id": 353,
    "question": "Of the following, which is a valid reason for a baseline to change?",
    "choice_a": "New hardware",
    "choice_b": "Numerous change requests",
    "choice_c": "New hypervisor",
    "choice_d": "New database",
    "correct_answer": "B",
    "explanation": "The best reason for changing a baseline is numerous change requests. If too many changes are being requested, it is a sign that the baseline needs to be reviewed and changed in order to meet these new demands.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      315,
      313,
      314,
      331,
      318
    ],
    "source": ""
  },
  {
    "id": 354,
    "question": "Which of the following is the cloud deployment model where organizational ownership of the hardware and infrastructure belong to and can only be used by a single customer?",
    "choice_a": "Private cloud",
    "choice_b": "IaaS",
    "choice_c": "Hybrid cloud",
    "choice_d": "PaaS",
    "correct_answer": "A",
    "explanation": "The private cloud model is where ownership and usage are limited to a single customer. IaaS and PaaS are service models, and the hybrid cloud model may allow shared resources.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      9,
      11,
      10,
      8,
      1
    ],
    "source": ""
  },
  {
    "id": 355,
    "question": "Of the following, which is responsible for determining an organization's risk appetite?",
    "choice_a": "Risk appetite assessment",
    "choice_b": "Senior management",
    "choice_c": "Legislative mandates",
    "choice_d": "SLAs",
    "correct_answer": "B",
    "explanation": "Senior management determines the risk appetite of an organization.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      536,
      241,
      238,
      457,
      459
    ],
    "source": ""
  },
  {
    "id": 356,
    "question": "Of the following, which would be used to protect the intellectual property of a logo for a business?",
    "choice_a": "Trademark",
    "choice_b": "Copyright",
    "choice_c": "Trade secret",
    "choice_d": "Patent",
    "correct_answer": "A",
    "explanation": "Trademarks are designed to protect symbols such as a company logo or trade name.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      386,
      395,
      387,
      29,
      26
    ],
    "source": ""
  },
  {
    "id": 357,
    "question": "How should cryptographic keys be protected?",
    "choice_a": "AES 256",
    "choice_b": "To a level at least as high as the data they are protecting",
    "choice_c": "SHA-2",
    "choice_d": "As high as is possible",
    "correct_answer": "B",
    "explanation": "Cryptographic keys should always be protected with safeguards at least as stringent, if not more, than the level of the data they are protecting.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      418,
      494,
      493,
      496,
      497
    ],
    "source": ""
  },
  {
    "id": 358,
    "question": "Which of the following is a countermeasure designed to protect against internal threats?",
    "choice_a": "Conflicts of interest",
    "choice_b": "Web application firewalls",
    "choice_c": "Penetration tests",
    "choice_d": "Separation of duties",
    "correct_answer": "D",
    "explanation": "Of the choices, separation of duties is the best answer. Separation of duties ensures that no single person in an organization can violate security protocols by themselves. Web application firewalls are designed to protect against external threats, as are penetration tests. Conflicts of interest are not applicable to the question.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      314,
      111,
      108,
      603,
      324
    ],
    "source": ""
  },
  {
    "id": 359,
    "question": "Who is ultimately legally responsible for data loss or disclosure in the cloud?",
    "choice_a": "Cloud service provider",
    "choice_b": "Cloud broker",
    "choice_c": "Cloud customer",
    "choice_d": "Cloud administrator",
    "correct_answer": "C",
    "explanation": "The cloud customer, also the data owner, is always ultimately legally responsible for unauthorized disclosures.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      709,
      658,
      660,
      337,
      408
    ],
    "source": ""
  },
  {
    "id": 360,
    "question": "Battery backups or UPSs serve many purposes. Along with providing power, which of the following do they provide?",
    "choice_a": "Line conditioning",
    "choice_b": "User discipline",
    "choice_c": "Elevated access",
    "choice_d": "Cost savings",
    "correct_answer": "A",
    "explanation": "Battery backups also provide a critical function in that they condition the line. What this means is that they add and suppress power curves that are a part of normal minute-by-minute fluctuations in voltage and amperage delivered. This smoothing out, or conditioning, helps equipment to last much longer since it is no longer subjected to varying voltages or amperage.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 361,
    "question": "Which of the following cloud deployment models features ownership by a cloud service provider with service offerings for anyone interested?",
    "choice_a": "Public",
    "choice_b": "Private",
    "choice_c": "IaaS",
    "choice_d": "Community",
    "correct_answer": "A",
    "explanation": "The private cloud model is not open to anyone interested, and IaaS is a service model. In addition, the community model has restrictions as to who may join.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      9,
      10,
      12,
      13,
      1
    ],
    "source": ""
  },
  {
    "id": 362,
    "question": "After all controls and countermeasure are put in place and operating effectively, the risk left over is referred to as ________.",
    "choice_a": "Recurring risk",
    "choice_b": "Residual risk",
    "choice_c": "Returning risk",
    "choice_d": "Reduced risk",
    "correct_answer": "B",
    "explanation": "Residual risk literally means the risk left over. In this case, it refers to risk left over after all controls and countermeasures are in place.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      240,
      241,
      238,
      448,
      457
    ],
    "source": ""
  },
  {
    "id": 363,
    "question": "The Digital Millennium Copyright Act (DMCA) criminalizes the production or dissemination of which of the following?",
    "choice_a": "Distribution technology intended to circumvent copyright protection and the works they protect",
    "choice_b": "Pornographic material intended to circumvent measures that control access to copyrighted works",
    "choice_c": "Technology or services intended to be used in terrorist activity",
    "choice_d": "Technology, devices, or services intended to circumvent copyright techniques used to protect digital media such as video and audio recordings",
    "correct_answer": "D",
    "explanation": "The DMCA criminalizes the production or dissemination of technology, devices, or services intended to circumvent copyright techniques used to protect digital media such as video and audio recordings; this includes some decryption tools.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      347,
      348,
      355,
      651,
      672
    ],
    "source": ""
  },
  {
    "id": 364,
    "question": "Which of the following are examples of attacks blocked by web application firewalls (WAFs)?",
    "choice_a": "Code forgery",
    "choice_b": "Xmas tree attack",
    "choice_c": "Syn flood",
    "choice_d": "XSS and SQL injection",
    "correct_answer": "D",
    "explanation": "WAFs are particularly suited for blocking and stopping XSS and SQL injection attacks. Xmas tree and Syn flood attacks occur at the network level and so do not apply. Code forgery is a made-up term.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      579,
      577,
      578,
      430,
      295
    ],
    "source": ""
  },
  {
    "id": 365,
    "question": "Which model provides the most secure, isolated environment for a cloud customer to conduct software development and testing?",
    "choice_a": "PaaS",
    "choice_b": "IaaS",
    "choice_c": "SaaS",
    "choice_d": "Hybrid",
    "correct_answer": "A",
    "explanation": "PaaS allows the cloud customer to install any kind of software, including software to be tested, on an architecture that includes any desired operating systems.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      8,
      11,
      12,
      156,
      237
    ],
    "source": ""
  },
  {
    "id": 366,
    "question": "Of the following, which is not a consideration when planning for physical security concerns?",
    "choice_a": "Local language variations",
    "choice_b": "CCTV coverage",
    "choice_c": "Traffic patterns",
    "choice_d": "Chance of natural disasters",
    "correct_answer": "A",
    "explanation": "Local languages have nothing to do with physical security. All the others are valid concerns.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      241,
      553,
      311,
      721,
      46
    ],
    "source": ""
  },
  {
    "id": 367,
    "question": "Deviations from baselines should be ______.",
    "choice_a": "Documented and investigated",
    "choice_b": "Refused",
    "choice_c": "Accepted",
    "choice_d": "Tabulated and reported",
    "correct_answer": "A",
    "explanation": "Any deviations from baselines should be thoroughly investigated and documented. If there are valid reasons for the deviation, the baseline may need to be reviewed and/or changed.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      605,
      332,
      331,
      604,
      606
    ],
    "source": ""
  },
  {
    "id": 368,
    "question": "Which of the following best represents the concept of the community cloud?",
    "choice_a": "Features joint responsibility among users of a single customer",
    "choice_b": "Features joint ownership of assets among a member group",
    "choice_c": "Features joint ownership of software among a member group",
    "choice_d": "Features ownership of assets by cloud provider",
    "correct_answer": "B",
    "explanation": "The community cloud is defined by its joint ownership of assets among a member group.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      10,
      235,
      237,
      236,
      231
    ],
    "source": ""
  },
  {
    "id": 369,
    "question": "Which of the following is something you cannot do when dealing with risk?",
    "choice_a": "Mitigation",
    "choice_b": "Transfer",
    "choice_c": "Reverse",
    "choice_d": "Accept",
    "correct_answer": "C",
    "explanation": "Risk cannot be reversed. It can only be mitigated, transferred, or accepted.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      240,
      238,
      457,
      546,
      697
    ],
    "source": ""
  },
  {
    "id": 370,
    "question": "The data life cycle has six stages. Of the following, which is the correct sequence?",
    "choice_a": "Create, Store, Use, Share, Archive, Destroy",
    "choice_b": "Create, Store, Share, Use, Archive, Destroy",
    "choice_c": "Create, Use, Store, Share, Archive, Destroy",
    "choice_d": "Create, Store, Use, Share, Archive, Delete",
    "correct_answer": "A",
    "explanation": "Option A shows the proper sequence.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      421,
      422,
      423,
      230,
      206
    ],
    "source": ""
  },
  {
    "id": 371,
    "question": "In order to provide a secure environment for application testing, which service model would be the best fit?",
    "choice_a": "PaaS",
    "choice_b": "IaaS",
    "choice_c": "SaaS",
    "choice_d": "DaaS",
    "correct_answer": "A",
    "explanation": "PaaS (platform as a service) allows the customer to install and run any applications they want on any operating system environment they may need.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      8,
      13,
      152,
      237,
      23
    ],
    "source": ""
  },
  {
    "id": 372,
    "question": "What is a good way to secure devices in a BYOD environment?",
    "choice_a": "Encrypt device drives",
    "choice_b": "WAFs",
    "choice_c": "Remove Java from all platforms",
    "choice_d": "Discontinue the use of Flash",
    "correct_answer": "A",
    "explanation": "Of these answers, the best one would be to use encryption on devices. BYOD devices may be lost or stolen, and this would prevent unauthorized viewing of data.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      422,
      423,
      16,
      206,
      144
    ],
    "source": ""
  },
  {
    "id": 373,
    "question": "Which of the following is a DRM solution for protecting intellectual property rights?",
    "choice_a": "Media-present checks",
    "choice_b": "Law enforcement notifications",
    "choice_c": "eDiscovery",
    "choice_d": "Digital forensics",
    "correct_answer": "A",
    "explanation": "Media-present checks look to see if protected media is present before allowing content to be played or distributed.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      31,
      379,
      382,
      388,
      390
    ],
    "source": ""
  },
  {
    "id": 374,
    "question": "Of the following, which would be most useful in a disaster that is primarily local, such as an interruption of communications service?",
    "choice_a": "Joint operating agreements",
    "choice_b": "Diesel generators",
    "choice_c": "Assistance from regulatory agencies",
    "choice_d": "Assistance from local law enforcement",
    "correct_answer": "A",
    "explanation": "Having a joint operating agreement with a sister facility can assist greatly when dealing with a local disaster that does not affect a large area.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      544,
      319,
      403,
      334,
      554
    ],
    "source": ""
  },
  {
    "id": 375,
    "question": "In regard to recent EU regulations concerning privacy, which of the following represents the right to be forgotten?",
    "choice_a": "The subject's right to have all data about them completely erased from a provider's environment",
    "choice_b": "The right to have all of a data owner's personal information erased from a provider's environment",
    "choice_c": "The right to have incorrect data erased",
    "choice_d": "The right to have all criminal data erased",
    "correct_answer": "A",
    "explanation": "In the EU, privacy is considered a human right, and the subject (the human individual identified by the data) has the power over how their identifying data is distributed/used/stored. A subject can request that a service provider erase all data about the subject, and the provider must comply to avoid criminal charges for noncompliance.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      355,
      347,
      653,
      651,
      648
    ],
    "source": ""
  },
  {
    "id": 376,
    "question": "Which of the following cloud service models requires the least amount of maintenance, administration, and support by the cloud customer?",
    "choice_a": "SaaS",
    "choice_b": "PaaS",
    "choice_c": "IaaS",
    "choice_d": "DaaS",
    "correct_answer": "A",
    "explanation": "The software as a service (SaaS) model requires the least intervention because the provider is responsible for maintaining the operating system, hardware, and software.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      8,
      12,
      237,
      13,
      148
    ],
    "source": ""
  },
  {
    "id": 377,
    "question": "Which of the following is not an example of hardening devices?",
    "choice_a": "Removal of admin accounts",
    "choice_b": "Change default usernames and passwords",
    "choice_c": "Patching systems to current versions",
    "choice_d": "Installing host-based anti-malware/IPS/egress monitoring agents",
    "correct_answer": "A",
    "explanation": "Removal of admin accounts is not an option \u2014 without them you could not administer the devices. All other options are valid.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      104,
      262,
      264,
      263,
      95
    ],
    "source": ""
  },
  {
    "id": 378,
    "question": "Of the following bodies, which does not have a comprehensive federal privacy law that protects its citizens' personal data?",
    "choice_a": "United States",
    "choice_b": "Europe",
    "choice_c": "Singapore",
    "choice_d": "Argentina",
    "correct_answer": "A",
    "explanation": "The United States is the only entity in this list that does not have a comprehensive policy directed at protecting its citizens' privacy.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      653,
      652,
      656,
      347,
      654
    ],
    "source": ""
  },
  {
    "id": 379,
    "question": "Which of the following best describes DAST?",
    "choice_a": "Tests performed on an application or software product while it is being executed in memory",
    "choice_b": "Tests performed on an application or software product that involves a code review",
    "choice_c": "Tests performed on an application or software product without the user's knowledge",
    "choice_d": "Tests performed on a network while it is being executed in memory",
    "correct_answer": "A",
    "explanation": "Dynamic application security testing is testing conducted while the application is resident in memory and being executed.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      300,
      298,
      285,
      284,
      283
    ],
    "source": ""
  },
  {
    "id": 380,
    "question": "Of the following, which cloud data storage process uses encrypted chunks of data?",
    "choice_a": "Data dispersion",
    "choice_b": "RAID 5",
    "choice_c": "RAID 0",
    "choice_d": "RAID 3",
    "correct_answer": "A",
    "explanation": "Data dispersion uses chunks of data, erasure coding, and encryption.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      505,
      41,
      494,
      496,
      493
    ],
    "source": ""
  },
  {
    "id": 381,
    "question": "How long should the fuel that is stored for data center generators be able to keep the data center up?",
    "choice_a": "12 hours",
    "choice_b": "24 hours",
    "choice_c": "8 hours",
    "choice_d": "48 hours",
    "correct_answer": "A",
    "explanation": "Based on Uptime Institute guidelines, enough fuel should be on hand to keep the generator running for at least 12 hours regardless of the data center tier.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      95,
      588,
      589,
      590,
      597
    ],
    "source": ""
  },
  {
    "id": 382,
    "question": "What is a situation in which more users are connected to a system than can be fully supported?",
    "choice_a": "Oversubscription",
    "choice_b": "Bad luck",
    "choice_c": "Temporal shift",
    "choice_d": "Peak usage",
    "correct_answer": "A",
    "explanation": "The question is the definition of oversubscription. This can happen in a multitenant environment like cloud computing if not properly managed.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      8,
      1,
      15,
      203,
      206
    ],
    "source": ""
  },
  {
    "id": 383,
    "question": "Which of the following is a technology solution for securing databases?",
    "choice_a": "NIST",
    "choice_b": "SAST",
    "choice_c": "SAML",
    "choice_d": "DAM",
    "correct_answer": "D",
    "explanation": "Database activity monitoring (DAM) is a security technology used for monitoring and analyzing database activity that operates independently of the database management system. NIST is the National Institute of Standards and Technology, SAST is a type of application testing, and SAML is a technology used with identity access management.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      431,
      578,
      430,
      579,
      432
    ],
    "source": ""
  },
  {
    "id": 384,
    "question": "Which of the following is the act of identifying or verifying the eligibility of a station, originator, or individual to access specific information?",
    "choice_a": "Authorization",
    "choice_b": "Authentication",
    "choice_c": "eDiscovery",
    "choice_d": "Remote Access",
    "correct_answer": "B",
    "explanation": "Option B is typically a measure designed to protect against fraudulent transmission by establishing the validity of a transmission, message, station, or originator.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      293,
      296,
      294,
      295,
      431
    ],
    "source": ""
  },
  {
    "id": 385,
    "question": "A formal policy that is signed by management and acknowledged by the user is known as a ___________________.",
    "choice_a": "Password policy",
    "choice_b": "Risk assessment",
    "choice_c": "Acceptable use policy",
    "choice_d": "Information security policy",
    "correct_answer": "C",
    "explanation": "The acceptable use policy (AUP) is designed to make clear to employees what is acceptable as well as unacceptable use of company-owned computing equipment and data such as email.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      129,
      134,
      119,
      124,
      664
    ],
    "source": ""
  },
  {
    "id": 386,
    "question": "What is a term that describes very large sets of information that are used to determine trends and other patterns generally undetectable by humans?",
    "choice_a": "PII",
    "choice_b": "Big data",
    "choice_c": "ePHI",
    "choice_d": "Cloud data",
    "correct_answer": "B",
    "explanation": "Big data refers to extremely large data sets used to determine patterns and trends such as purchasing or travel trends of large groups of people.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      195,
      199,
      422,
      423
    ],
    "source": ""
  },
  {
    "id": 387,
    "question": "What is an important term in the field of data forensics that refers to maintaining control of evidence?",
    "choice_a": "eDiscovery",
    "choice_b": "Probably cause",
    "choice_c": "Chain of custody",
    "choice_d": "The Doctrine of Property",
    "correct_answer": "C",
    "explanation": "Chain of custody refers to documenting control of evidence from the time it is collected until it is presented to the court.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 388,
    "question": "________________ is a term used to describe an arrangement that can be made among multiple enterprises to let subscribers use the same identification data to obtain access to all enterprises in the network.",
    "choice_a": "Federation",
    "choice_b": "MFA",
    "choice_c": "Extrapolation",
    "choice_d": "EDP",
    "correct_answer": "A",
    "explanation": "Federation is an arrangement that can be made among multiple enterprises allowing them to use the same identification data to obtain access to all enterprises' resources within the group.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      584,
      585,
      576,
      437,
      286
    ],
    "source": ""
  },
  {
    "id": 389,
    "question": "What is the name of the security discipline that enables the right individuals to access the right resources at the right time and for the right reasons?",
    "choice_a": "Homomorphic encryption",
    "choice_b": "IAM",
    "choice_c": "GAPP",
    "choice_d": "SDLC",
    "correct_answer": "B",
    "explanation": "The security discipline is called IAM (identitification and access management), and it ensures that the right user always has access to the right resources at the right times for the right reasons, based on their identity.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      437,
      286,
      576,
      368,
      416
    ],
    "source": ""
  },
  {
    "id": 390,
    "question": "What are the activities involving the generation, storage, distribution, deletion, archiving, and application of keys in accordance with a formal security policy?",
    "choice_a": "Key management",
    "choice_b": "Security management",
    "choice_c": "Application management",
    "choice_d": "SDLC",
    "correct_answer": "A",
    "explanation": "These are all activities associated with encryption key management and are critical for the safety and security of key usage.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      418,
      419,
      420,
      494,
      497
    ],
    "source": ""
  },
  {
    "id": 391,
    "question": "The ____________________ controls the entire infrastructure and is independent of physical network configuration.",
    "choice_a": "Hypervisor",
    "choice_b": "SDN",
    "choice_c": "Management plane",
    "choice_d": "Infrastructure as a Service",
    "correct_answer": "C",
    "explanation": "The management plane is used to create logical networking connections regardless of physical layout.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      107,
      598,
      108,
      94,
      447
    ],
    "source": ""
  },
  {
    "id": 392,
    "question": "________ are software or devices that monitor networks or systems for malicious activities or policy violations and produce electronic alerts and/or reports to a management station.",
    "choice_a": "OSs",
    "choice_b": "HSMs",
    "choice_c": "NIDSs",
    "choice_d": "VPNs",
    "correct_answer": "C",
    "explanation": "Network intrusion detection systems (NIDSs) watch for anomalous or malicious system activity at the network level and provide alerts and/or reports on such activity.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      98,
      97,
      402,
      326,
      104
    ],
    "source": ""
  },
  {
    "id": 393,
    "question": "Which of the following best describes a qualitative risk assessment?",
    "choice_a": "Typically employs a set of methods, principles, or rules for assessing risk based on numerical categories",
    "choice_b": "Typically employs a set of methods, principles, or rules for assessing risk based on numbers",
    "choice_c": "Typically employs a set of methods, principles, or rules for assessing risk based on nonnumerical categories",
    "choice_d": "Typically employs a set of methods, principles, or rules for assessing risk based on threat categories",
    "correct_answer": "C",
    "explanation": "As opposed to quantitative assessments, which use specific numerical values such as 1, 2, and 3, qualitative assessments use nonnumerical categories that are relative in nature, such as high, medium, and low.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      240,
      238,
      699,
      697,
      558
    ],
    "source": ""
  },
  {
    "id": 394,
    "question": "Which term refers to a system's ability to cordon off or protect certain aspects of the compute environment such as processing, memory, and other resources needed in the compute transaction?",
    "choice_a": "Virtualization",
    "choice_b": "Emulation",
    "choice_c": "ASLR",
    "choice_d": "Sandboxing",
    "correct_answer": "D",
    "explanation": "Sandboxing is often used for testing applications in development or carving out resources that cannot then touch other parts of the same system.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      283,
      284,
      285,
      73,
      300
    ],
    "source": ""
  },
  {
    "id": 395,
    "question": "_________________ is the idea of identifying specific points of vulnerability and then implementing countermeasures to protect or thwart those points from successful exploitation.",
    "choice_a": "TCI reference model",
    "choice_b": "Penetration testing",
    "choice_c": "Transcending",
    "choice_d": "Threat modeling",
    "correct_answer": "D",
    "explanation": "Threat modeling is used specifically to identify points of vulnerability in order to implement countermeasures as part of the overall system protection activity.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      295,
      292,
      280,
      282,
      294
    ],
    "source": ""
  },
  {
    "id": 396,
    "question": "________________ refers to the idea of a cloud provider or solution not allowing the customer to move their applications or data in the event the customer needs or wants to do so.",
    "choice_a": "Vendor lock-in",
    "choice_b": "Cloud forklift",
    "choice_c": "Vendor lock-out",
    "choice_d": "SLA",
    "correct_answer": "A",
    "explanation": "Vendor lock-in is a serious concern for the cloud customer.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      18,
      230,
      229,
      231,
      12
    ],
    "source": ""
  },
  {
    "id": 397,
    "question": "A/an ________________ specifies which users or system processes have access to a specific object such as an application or process in addition to what operations they can perform.",
    "choice_a": "DNS",
    "choice_b": "SDN",
    "choice_c": "ACL",
    "choice_d": "SLA",
    "correct_answer": "C",
    "explanation": "An access control list (ACL) specifies which users or system processes have access to an object.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      288,
      437,
      585,
      431,
      579
    ],
    "source": ""
  },
  {
    "id": 398,
    "question": "___________________ is a database security technology for monitoring and analyzing database activity that operates independently of the DBMS and does not rely on native (DBMS resident) auditing or native logs.",
    "choice_a": "TCP/IP",
    "choice_b": "SIM",
    "choice_c": "SIEM",
    "choice_d": "DAM",
    "correct_answer": "D",
    "explanation": "DAM is designed to watch database activity natively, so it does not rely on other logs or log systems such as SIEMs.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      431,
      432,
      430,
      577,
      82
    ],
    "source": ""
  },
  {
    "id": 399,
    "question": "What is a process in which electronic data is sought for the purposes of using it as evidence in a civil or criminal case?",
    "choice_a": "eDiscovery",
    "choice_b": "ePHI",
    "choice_c": "Drafting",
    "choice_d": "Right to be forgotten",
    "correct_answer": "A",
    "explanation": "eDiscovery refers to locating data to be used in civil or criminal proceedings.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      406,
      408,
      407,
      651,
      649
    ],
    "source": ""
  },
  {
    "id": 400,
    "question": "Which of the following best describes federation?",
    "choice_a": "Allows a single user to authenticate using a process that then allows access across multiple IT systems or even organizations",
    "choice_b": "Allows access across multiple jurisdictions",
    "choice_c": "Allows a single user to authenticate in a cloud environment",
    "choice_d": "Requires multifactor authentication",
    "correct_answer": "A",
    "explanation": "Federated SSO allows users to authenticate once but then be granted access to resources of other federated organizations within the federation.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      367,
      585,
      369,
      82,
      286
    ],
    "source": ""
  },
  {
    "id": 401,
    "question": "Which of the following best describes HIPAA?",
    "choice_a": "US federal law for electronic healthcare transactions and national identifiers for providers, health plans, and employers",
    "choice_b": "EU standards for electronic healthcare transactions and national identifiers for providers, health plans, and employers",
    "choice_c": "Contractual standards for electronic healthcare transactions and national identifiers for providers, health plans, and employers",
    "choice_d": "ISO standards for electronic healthcare transactions and national identifiers for providers, health plans, and employers",
    "correct_answer": "A",
    "explanation": "Passed in 1996 as the Health Portability and Accountability Act, it provides the standards for electronic healthcare transactions and national identifiers for providers, health plans, and employers.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      653,
      352,
      347,
      345,
      341
    ],
    "source": ""
  },
  {
    "id": 402,
    "question": "Which of the following terms best describes a logical grouping of devices that allows traffic to be contained and operate at high speeds?",
    "choice_a": "PAN",
    "choice_b": "SDLC",
    "choice_c": "DNS",
    "choice_d": "LAN",
    "correct_answer": "D",
    "explanation": "LANs are the backbone of the infrastructure because they do exactly this.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      424,
      425,
      426,
      577,
      701
    ],
    "source": ""
  },
  {
    "id": 403,
    "question": "________________ storage is used when files are stored with additional metadata and are accessible through APIs and web interfaces.",
    "choice_a": "Object",
    "choice_b": "RAID",
    "choice_c": "Content",
    "choice_d": "Redundant",
    "correct_answer": "A",
    "explanation": "Objects (files) are stored with additional metadata such as content type, redundancy requirements, creation dates, and so on and are then accessible via APIs and/or through a web interface.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      370,
      28,
      26,
      494,
      410
    ],
    "source": ""
  },
  {
    "id": 404,
    "question": "A penetration test is designed to ___________.",
    "choice_a": "Document ongoing attacks",
    "choice_b": "Test a system for vulnerabilities that would allow an attacker to gain control over said system",
    "choice_c": "Detect attacks in real time",
    "choice_d": "Test a system, network, or web application for vulnerabilities that would allow an attacker to gain control over said system, network, or application",
    "correct_answer": "D",
    "explanation": "A penetration test is a test that is designed to take advantage of any vulnerability it can find to compromise a system or gain unauthorized access. This includes testing not just systems but also networks and applications.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      300,
      298,
      294,
      677,
      676
    ],
    "source": ""
  },
  {
    "id": 405,
    "question": "A _____________ typically employs a set of methods, principles, or rules for assessing risk based on absolute numerical values.",
    "choice_a": "Qualitative assessment",
    "choice_b": "SLA",
    "choice_c": "QoS",
    "choice_d": "Quantitative assessment",
    "correct_answer": "D",
    "explanation": "A quantitative assessment employs a set of methods or rules much like a qualitative assessment, with the difference being the use of absolute numerical values. So instead of high, medium, and low, values such as 1, 2, and 3 are used.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      240,
      238,
      699,
      557,
      556
    ],
    "source": ""
  },
  {
    "id": 406,
    "question": "All of the following entitles are required to use FedRAMP-accredited cloud service providers except ___________________.",
    "choice_a": "The US Postal Service",
    "choice_b": "The Department of Homeland Security",
    "choice_c": "Federal Express",
    "choice_d": "The CIA",
    "correct_answer": "C",
    "explanation": "Federal Express is a private company; only federal entities are required to comply with FedRAMP. All the other options are federal entities.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      176,
      233,
      10,
      182,
      168
    ],
    "source": ""
  },
  {
    "id": 407,
    "question": "The ____________ is designed to determine the damage caused from losing the support/availability of any particular resource to an organization.",
    "choice_a": "BIA",
    "choice_b": "PCP",
    "choice_c": "BCD",
    "choice_d": "DR",
    "correct_answer": "A",
    "explanation": "The business impact analysis (BIA) determines the impact on a business from the loss of support or availability of any resource.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      238,
      544,
      239,
      404,
      241
    ],
    "source": ""
  },
  {
    "id": 408,
    "question": "___________ is a method of hiding data with substitute characters such as Xs or asterisks.",
    "choice_a": "Sandboxing",
    "choice_b": "Data masking",
    "choice_c": "Encryption",
    "choice_d": "Virtualization",
    "correct_answer": "B",
    "explanation": "This is an example of data masking. Sandboxing and virtualization are ways to abstract programs away from actual hardware. Encryption uses a two-way process to convert plaintext to ciphertext; changing letters to Xs or asterisks is not encryption, as it is not reversible.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      503,
      507,
      414,
      26,
      31
    ],
    "source": ""
  },
  {
    "id": 409,
    "question": "This approach to public key cryptography uses much smaller keys than traditional cryptography to provide the same level of security.",
    "choice_a": "AES",
    "choice_b": "SSL",
    "choice_c": "Elliptical curve",
    "choice_d": "MD5",
    "correct_answer": "C",
    "explanation": "Elliptical curve cryptography (ECC) uses algebraic elliptical curves that result in much smaller keys that can provide the same level of safety as much larger ones used in traditional key cryptography.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      22,
      184,
      197,
      210,
      214
    ],
    "source": ""
  },
  {
    "id": 410,
    "question": "A ______________ consists of a computer, data, or a network site that appears to be part of a network but is actually isolated and monitored. It also appears to contain data or resources of value that are in fact fake.",
    "choice_a": "Honeypot",
    "choice_b": "HIDS",
    "choice_c": "Virtual application",
    "choice_d": "Sandbox",
    "correct_answer": "A",
    "explanation": "A honeypot consists of a computer, data, or a network site that appears to be part of a network and seems to contain information or a resource of value to attackers but is actually isolated and monitored. Although a honeypot may be run in a sandbox, they are not the same thing.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      614,
      610,
      613,
      402,
      401
    ],
    "source": ""
  },
  {
    "id": 411,
    "question": "Which of the following is not typically a BC/DR construct involving cloud computing?",
    "choice_a": "On-premises production environment; cloud BC/DR environment",
    "choice_b": "Cloud production environment; same provider BC/DR environment",
    "choice_c": "Cloud production environment; different provider BC/DR environment",
    "choice_d": "Cloud production environment; on-premises BC/DR environment",
    "correct_answer": "D",
    "explanation": "Organizations do not typically host contingency operations at an on-premises facility when they already operate a production environment in the cloud. All the other options are common BC/DR arrangements involving cloud computing.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      697,
      556,
      557,
      545,
      336
    ],
    "source": ""
  },
  {
    "id": 412,
    "question": "MTTR is best described as which of the following?",
    "choice_a": "The average cost to repair a device that has failed or is in need of repair",
    "choice_b": "The average time it takes to replace a device that has failed or is in need of repair",
    "choice_c": "The average time it takes to repair a device that has failed or is in need of repair",
    "choice_d": "The maximum time it takes to repair a device that has failed or is in need of repair",
    "correct_answer": "C",
    "explanation": "Mean time to repair (MTTR) is the time required to repair a device that has failed or is in need of repair. The term mean indicates the average time as opposed to the actual or past experiences.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      427,
      556,
      545,
      557,
      241
    ],
    "source": ""
  },
  {
    "id": 413,
    "question": "Which of the following represents the Security and Privacy Controls for US Federal Information Systems and Organizations?",
    "choice_a": "NIST 800-146",
    "choice_b": "NIST 800-14",
    "choice_c": "NIST 800-53 r4",
    "choice_d": "NIST 800-123",
    "correct_answer": "C",
    "explanation": "NIST 800-53 r4 describes ways to ensure the proper application of appropriate security requirements and security controls to all US federal government information and information management. The others are legitimate NIST documents with different purposes.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      636,
      318
    ],
    "source": ""
  },
  {
    "id": 414,
    "question": "Which form of authentication is used to enable SSO and enables the user to log into more than one application or website using the same credentials?",
    "choice_a": "SSL",
    "choice_b": "Username and password",
    "choice_c": "Multifactor authentication",
    "choice_d": "OpenID",
    "correct_answer": "D",
    "explanation": "OpenID is one form of authentication used to enable SSO and enables the user to log into more than one application or website using the same credentials.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      583,
      576,
      436,
      437,
      438
    ],
    "source": ""
  },
  {
    "id": 415,
    "question": "Which form of cloud storage applies to storing an individual's data in the cloud while providing access from anywhere?",
    "choice_a": "Object storage",
    "choice_b": "Cloud file storage",
    "choice_c": "Personal cloud storage",
    "choice_d": "Enterprise cloud storage",
    "correct_answer": "C",
    "explanation": "Personal cloud storage is the storage of a single user's data in the cloud, allowing them access from anywhere on the Internet.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      33,
      31,
      24,
      386,
      493
    ],
    "source": ""
  },
  {
    "id": 416,
    "question": "REST is best described by which of the following?",
    "choice_a": "Relies on stateful communications",
    "choice_b": "Does not require caching",
    "choice_c": "Does not rely on best practices for web services",
    "choice_d": "Relies on stateless, client-server, cacheable communications",
    "correct_answer": "D",
    "explanation": "Representational State Transfer (REST) relies on stateless, client-server, cacheable communications. It is a software architecture consisting of guidelines and best practices for creating scalable web services.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      703,
      397,
      277,
      566,
      398
    ],
    "source": ""
  },
  {
    "id": 417,
    "question": "Security Assertion Markup Language is ________.",
    "choice_a": "HTML and closed source based",
    "choice_b": "XML and open standards based",
    "choice_c": "SQL and open source based",
    "choice_d": "Fake",
    "correct_answer": "B",
    "explanation": "SAML is an XML-based, open standard data format designed for the exchange of authentication and authorization data between parties.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      576,
      574,
      694,
      705,
      559
    ],
    "source": ""
  },
  {
    "id": 418,
    "question": "_____________ is an agentless means of ensuring a VM's security baseline does not change over time by examining such things as physical location and network settings.",
    "choice_a": "ECC",
    "choice_b": "VMI",
    "choice_c": "HIDS",
    "choice_d": "NIDS",
    "correct_answer": "B",
    "explanation": "Virtual machine introspection (VMI) is an agentless means of ensuring a VM's security baseline does not change over time by examining things such as physical address, network settings, and installed OS. These ensure that the baseline has not been inadvertently or maliciously tampered with.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      15,
      244,
      246,
      154,
      149
    ],
    "source": ""
  },
  {
    "id": 419,
    "question": "A database activity monitor (DAM) functions at layer ___________________ of the OSI model.",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "5",
    "choice_d": "7",
    "correct_answer": "D",
    "explanation": "A DAM is a Layer 7 appliance. All the other options are incorrect.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      578,
      577,
      431,
      430,
      453
    ],
    "source": ""
  },
  {
    "id": 420,
    "question": "The practice of using strong magnets to erase and scramble data on magnetic media is called ___________.",
    "choice_a": "Degaussing",
    "choice_b": "Scrubbing",
    "choice_c": "Crypto shredding",
    "choice_d": "Bit splitting",
    "correct_answer": "A",
    "explanation": "Degaussing refers to the practice of using strong magnets for scrambling data on magnetic media such as hard drives and tapes. Although scrubbing generally can scramble data as well as degaussing, it does not use magnets.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      40,
      433,
      35,
      41,
      435
    ],
    "source": ""
  },
  {
    "id": 421,
    "question": "A special piece of numeric code that allows encryption hardware or software to encrypt and then decrypt a message is called a/an ___________.",
    "choice_a": "HSM",
    "choice_b": "Encryption key",
    "choice_c": "Elliptical curve",
    "choice_d": "Hash",
    "correct_answer": "B",
    "explanation": "An encryption key is the numeric string that allows for encryption and decryption to occur.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      422,
      206,
      182,
      149,
      23
    ],
    "source": ""
  },
  {
    "id": 422,
    "question": "The US government program that mandates a standardized approach to security assessments, authorization, and continuous monitoring of cloud products and services is called ______________.",
    "choice_a": "FISMA",
    "choice_b": "HIPAA",
    "choice_c": "FedRAMP",
    "choice_d": "GLBA",
    "correct_answer": "C",
    "explanation": "FedRAMP is a US federal program that mandates a standardized approach to security assessments, authorization, and continuous monitoring of cloud products and services. FedRAMP certification can be quite costly and difficult to achieve but is required for cloud hosting services provided to a US government agency or contractor.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      113,
      110,
      108,
      94,
      602
    ],
    "source": ""
  },
  {
    "id": 423,
    "question": "Which of the following is an example of two-factor authentication?",
    "choice_a": "Strong passwords",
    "choice_b": "Unique user ID and password",
    "choice_c": "Something you know",
    "choice_d": "User ID and physical characteristics",
    "correct_answer": "D",
    "explanation": "Only option D involves two distinct factors (something you know and something you are).",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      436,
      437,
      438,
      295,
      368
    ],
    "source": ""
  },
  {
    "id": 424,
    "question": "Which of the following is used to describe a framework of application security best practices that have been catalogued and are leveraged by the organization and contain at least one or more subcomponents?",
    "choice_a": "ANF",
    "choice_b": "ONF",
    "choice_c": "NIST",
    "choice_d": "Hi Trust",
    "correct_answer": "B",
    "explanation": "An Organization Normative Framework (ONF) is a framework of so-called containers of application security best practices catalogued and leveraged by the organization and contains at least one or more subcomponents known as application normative frameworks (ANFs).",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      417,
      415,
      432,
      431,
      93
    ],
    "source": ""
  },
  {
    "id": 425,
    "question": "Which of the following is a popular API construction model?",
    "choice_a": "SSO",
    "choice_b": "GUI",
    "choice_c": "REST",
    "choice_d": "HTML",
    "correct_answer": "C",
    "explanation": "Representational State Transfer (REST) is a method for designing APIs at the moment. Graphical user interface (GUI), Hypertext Markup Language (HTML), and single sign-on (SSO) are not means of programming APIs; options A, B, and D are incorrect.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      439,
      397,
      566,
      568,
      704
    ],
    "source": ""
  },
  {
    "id": 426,
    "question": "What has enabled cloud computing to become a real and scalable service offering due primarily to savings, sharing capabilities, and allocation of resources across multiple tenants and environments?",
    "choice_a": "Virtualization technologies",
    "choice_b": "Storage technologies",
    "choice_c": "International agreements",
    "choice_d": "Increases in computing power",
    "correct_answer": "A",
    "explanation": "Virtualization technologies have been the driving force behind enabling cloud computing to become a real and scalable service due to the savings, sharing, and allocation of resources across multiple tenants and environments.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      15,
      141,
      11,
      3,
      142
    ],
    "source": ""
  },
  {
    "id": 427,
    "question": "Which of the following terms best describes the amount an organization should expect to lose on an annual basis due to a specific type of incident?",
    "choice_a": "ARO",
    "choice_b": "BIA",
    "choice_c": "BLE",
    "choice_d": "ALE",
    "correct_answer": "D",
    "explanation": "The term that best describes the amount an organization should expect to lose on an annual basis due to one type of incident is annual loss expectancy (ALE) and is calculated by multiplying the annual rate of occurrence (ARO) by the single loss expectancy (SLE).",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      427,
      556,
      545,
      679,
      459
    ],
    "source": ""
  },
  {
    "id": 428,
    "question": "What is the principal issue concerning transborder data flow?",
    "choice_a": "Government taxation standards differ.",
    "choice_b": "Differences may exist in customs or procedures.",
    "choice_c": "Encryption must be implemented.",
    "choice_d": "Legal requirements may not be the same.",
    "correct_answer": "D",
    "explanation": "The concern with transborder data flow is that the legal requirements may be different between the countries. An additional concern with transborder data flow is that the level of risk may be different depending on privacy laws and laws affecting intellectual property, such as trademark and copyright.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      357,
      658,
      347,
      711,
      650
    ],
    "source": ""
  },
  {
    "id": 429,
    "question": "Both short-term and long-term strategies designed to assist organizations in recovering from activities that disrupt critical functions are called ___________________.",
    "choice_a": "BC/DR",
    "choice_b": "BCP",
    "choice_c": "DR",
    "choice_d": "BIA",
    "correct_answer": "A",
    "explanation": "Business continuity (BC) and disaster recovery (DR) are both strategies designed to aid organizations in recovering from disruptions in activities. They can cover both short-term and long-term strategies.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      544,
      319,
      334,
      238,
      336
    ],
    "source": ""
  },
  {
    "id": 430,
    "question": "Which of the following best describes the purpose of a DMZ?",
    "choice_a": "Isolates public-facing network elements that would otherwise be vulnerable to attack",
    "choice_b": "Isolates email servers that are Internet facing and protects them from attacks",
    "choice_c": "Provides network elements such as routers that are Internet facing to protect them from attack",
    "choice_d": "Tracks incoming attack patterns",
    "correct_answer": "A",
    "explanation": "A demilitarized zone (DMZ) isolates network elements that are public facing and would otherwise be vulnerable to attack.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 431,
    "question": "Which theoretical type of encryption technology enables the processing of encrypted data without the need to decrypt data in order to perform computations?",
    "choice_a": "AES",
    "choice_b": "Homomorphic",
    "choice_c": "PKI",
    "choice_d": "MD5",
    "correct_answer": "B",
    "explanation": "Homomorphic encryption would enable the processing of encrypted data without the need to first decrypt it; it has never been proven outside research situations.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      503,
      507,
      418,
      394,
      501
    ],
    "source": ""
  },
  {
    "id": 432,
    "question": "The OWASP is a nonprofit international organization focused on improving ___________________.",
    "choice_a": "Software testing",
    "choice_b": "Software security",
    "choice_c": "SDLC",
    "choice_d": "REST",
    "correct_answer": "B",
    "explanation": "The Open Web Application Security Project (OWASP) is an international nonprofit that focuses on identifying software vulnerabilities and educating developers in the practice of secure coding.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      295,
      299,
      300,
      268,
      270
    ],
    "source": ""
  },
  {
    "id": 433,
    "question": "Which of the following best describes a way for customers to rent hardware, operating systems, storage, and network capacity over the Internet from a cloud service provider?",
    "choice_a": "IaaS",
    "choice_b": "AaaS",
    "choice_c": "SaaS",
    "choice_d": "PaaS",
    "correct_answer": "A",
    "explanation": "Infrastructure as a service (IaaS) allows cloud customers to rent fundamental computing resources such as processing power, storage, networking, and related infrastructure over the Internet. In IaaS, the customer typically has control over operating systems, storage, and deployed applications, while the cloud provider manages the underlying physical infrastructure. PaaS is different because it provides a managed application platform, where the customer deploys applications without managing the underlying operating system or infrastructure.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      8,
      2,
      3,
      12,
      13
    ],
    "source": ""
  },
  {
    "id": 434,
    "question": "Which of the following best describes the use of several smaller disks rather than a single large disk for storage purposes as well as redundancy and speed?",
    "choice_a": "RADE",
    "choice_b": "SAN",
    "choice_c": "NAS",
    "choice_d": "RAID",
    "correct_answer": "D",
    "explanation": "Redundant array of independent disks (RAID) is a way of using a group of smaller and usually less-expensive disks as opposed to a single large disk. Different RAID levels provide varying degrees of redundancy and speed based on the number of disks used and the manner in which they are deployed.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      444,
      443,
      442,
      409,
      435
    ],
    "source": ""
  },
  {
    "id": 435,
    "question": "Which of the following best describes the formal, legal agreement between two or more organizations that may or may not contain incentives and/or penalties?",
    "choice_a": "SLA",
    "choice_b": "SDLC",
    "choice_c": "PLA",
    "choice_d": "SOC",
    "correct_answer": "A",
    "explanation": "The service-level agreement (SLA) is a formal agreement between two or more organizations that may or may not contain incentives or penalties. The primary use of the SLA is to determine if the provider is in fact providing the services being purchased.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      148,
      147,
      231,
      168,
      155
    ],
    "source": ""
  },
  {
    "id": 436,
    "question": "Which of the following terms is not associated with cloud forensics?",
    "choice_a": "Analysis",
    "choice_b": "eDiscovery",
    "choice_c": "Chain of custody",
    "choice_d": "Plausibility",
    "correct_answer": "D",
    "explanation": "Plausibility, here, is a distractor and not specifically relevant to cloud forensics.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      112,
      401,
      627,
      402,
      111
    ],
    "source": ""
  },
  {
    "id": 437,
    "question": "What is the primary characteristic of volume storage?",
    "choice_a": "They are volumes attached to virtual storage and act or behave just like a physical drive or array.",
    "choice_b": "They are drives attached to physical storage and act or behave just like a physical drive or array.",
    "choice_c": "They are volumes attached to physical storage and act or behave just like a physical drive or array.",
    "choice_d": "They are drives attached to virtual storage and act or behave just like a physical drive or array.",
    "correct_answer": "A",
    "explanation": "Volume storage consists of volumes that are attached to virtual storage and act or behave just like a physical drive or array.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      442,
      443,
      444,
      435,
      434
    ],
    "source": ""
  },
  {
    "id": 438,
    "question": "Which federal standard is for the accreditation of secure and well-architected cryptographic modules produced by private sector vendors?",
    "choice_a": "FIPS 120",
    "choice_b": "ISO 27002",
    "choice_c": "CobiT",
    "choice_d": "FIPS 140-2",
    "correct_answer": "D",
    "explanation": "FIPS 140-2 is the federal standard for the accreditation and distinguishing of secure and well-architected cryptographic modules produced by private sector vendors who see to or are in the process of having their solutions and services certified by the US government departments and regulated industries that collect, store, transfer, or share data that is deemed to be sensitive but not classified.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      391,
      392,
      495,
      494,
      41
    ],
    "source": ""
  },
  {
    "id": 439,
    "question": "________________ systems provide air management that separates the cool air from the heat produced as exhaust of servers.",
    "choice_a": "HIPAA",
    "choice_b": "GLBA",
    "choice_c": "HVAC",
    "choice_d": "NIST",
    "correct_answer": "C",
    "explanation": "Heating, ventilation, and air-conditioning (HVAC) systems separate the cool air from the heat caused by servers. They provide air management including racks with built-in ventilation or alternate cold/hot aisles.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      241,
      724,
      728,
      723,
      721
    ],
    "source": ""
  },
  {
    "id": 440,
    "question": "Which piece of the security triad is about ensuring that data is accurate and complete?",
    "choice_a": "Integrity",
    "choice_b": "Confidentiality",
    "choice_c": "Access controls",
    "choice_d": "Encryption",
    "correct_answer": "A",
    "explanation": "Integrity ensures that data has not been altered by an unauthorized entity. That includes being complete and accurate.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      16,
      215,
      422,
      206,
      184
    ],
    "source": ""
  },
  {
    "id": 441,
    "question": "What is the property whereby a sender cannot deny they sent a message?",
    "choice_a": "Integrity",
    "choice_b": "PKI",
    "choice_c": "Nonrepudiation",
    "choice_d": "Confidentiality",
    "correct_answer": "C",
    "explanation": "Nonrepudiation is a term that describes the idea that an author of a file or message cannot deny having created it.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      514,
      515,
      516,
      720,
      38
    ],
    "source": ""
  },
  {
    "id": 442,
    "question": "Which type of information can be traced back to an individual user, sometimes through the use of tracking cookies?",
    "choice_a": "PPI",
    "choice_b": "PCI",
    "choice_c": "PII",
    "choice_d": "ISO",
    "correct_answer": "C",
    "explanation": "Personally identifiable information (PII) is a legal category of information that identifies a specific person.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      337,
      660,
      652,
      132,
      115
    ],
    "source": ""
  },
  {
    "id": 443,
    "question": "The term RPO is best described by which of the following?",
    "choice_a": "A term used in BC and DR describing an acceptable amount of data that might be lost due to an outage before severe consequences are experienced",
    "choice_b": "A term used in BC and DR describing a point in time after which an outage has occurred, beyond which recovery becomes extremely difficult or impossible",
    "choice_c": "A term used in BC and DR describing the minimum allowable amount of data that might be lost due to an outage before severe consequences are experienced",
    "choice_d": "A term used in BC and DR describing the maximum allowable amount of value that might be lost due to an outage before consequences are experienced",
    "correct_answer": "A",
    "explanation": "Recovery point objective (RPO) is a term used in BC and DR describing the tolerable amount of data that might be lost due to an outage before severe consequences are experienced.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      319,
      336,
      545,
      556,
      427
    ],
    "source": ""
  },
  {
    "id": 444,
    "question": "Secret sharing made short (SSMS) is a method of which of the following?",
    "choice_a": "Bit splitting",
    "choice_b": "Homomorphic encryption",
    "choice_c": "Elliptical curve cryptography",
    "choice_d": "AES",
    "correct_answer": "A",
    "explanation": "SSMS is a method of bit splitting that uses the three phases: encryption, using an information dispersal algorithm, and splitting the encryption key using the secret sharing algorithm. The fragments are signed and distributed to different cloud storage services, making it difficult to decrypt without both arbitrarily chosen data and encryption key fragments.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      418,
      419,
      503,
      507,
      40
    ],
    "source": ""
  },
  {
    "id": 445,
    "question": "Which of the following identifies vulnerabilities in applications, operating systems, or network devices?",
    "choice_a": "Vulnerability assessment",
    "choice_b": "Nmap scan",
    "choice_c": "Packet analysis",
    "choice_d": "WAF",
    "correct_answer": "A",
    "explanation": "A vulnerability assessment or scan is designed to identify known vulnerabilities in applications, operating systems, or network devices. An Nmap scan may discover vulnerabilities but is designed primarily as a network services discovery tool and is not generally used with applications.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      106,
      98,
      301,
      104,
      262
    ],
    "source": ""
  },
  {
    "id": 446,
    "question": "Which of the following describes the act of permanently and completely removing personal identifiers from data, such as converting personally identifiable information (PII) into aggregated data?",
    "choice_a": "Anonymization",
    "choice_b": "Disk scrubbing",
    "choice_c": "Degaussing",
    "choice_d": "Crypto-shredding",
    "correct_answer": "A",
    "explanation": "Anonymization is the act of permanently and completely removing personal identifiers from data. Disk scrubbing, degaussing, and crypto-shredding each refers to eliminating all data, not just PII.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      41,
      40,
      29,
      25,
      27
    ],
    "source": ""
  },
  {
    "id": 447,
    "question": "_______________ often uses access control and encryption to prevent unauthorized copying and limitation of distribution to only those who pay.",
    "choice_a": "PCI",
    "choice_b": "IRM",
    "choice_c": "SDN",
    "choice_d": "Doctrine of the Proper Law",
    "correct_answer": "B",
    "explanation": "Information rights management (IRM) is a means to prevent unauthorized copying and limitation of distribution to only those who pay for content.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      394,
      395,
      379,
      380,
      389
    ],
    "source": ""
  },
  {
    "id": 448,
    "question": "Which regulation introduced significant changes for data processors and controllers who work across international borders?",
    "choice_a": "GDPR",
    "choice_b": "GLBA",
    "choice_c": "ISO 27000",
    "choice_d": "HIPAA",
    "correct_answer": "A",
    "explanation": "The European Union General Data Protection Regulation of 2016 (EU GDPR 2016) introduced significant changes for data processors and controllers operating in and across the EU. Some of those changes included the concept of consent, transfers abroad, the right to be forgotten, establishment of the data protection officer, home state regulation, and increased sanctions.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      658,
      659,
      660,
      656,
      348
    ],
    "source": ""
  },
  {
    "id": 449,
    "question": "A ________________ is generally a type of network device designed to allow only authorized traffic through its interfaces.",
    "choice_a": "SIEM",
    "choice_b": "Firewall",
    "choice_c": "Honeypot",
    "choice_d": "HIDS",
    "correct_answer": "B",
    "explanation": "A firewall is a type of network device that allows only authorized traffic to flow across its interfaces.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      97,
      94,
      613,
      610,
      612
    ],
    "source": ""
  },
  {
    "id": 450,
    "question": "MTD/MAD is a measure of which of the following?",
    "choice_a": "A point in time after an outage has occurred and beyond which recovery becomes extremely difficult or impossible",
    "choice_b": "The optimal time it takes to recover a system after an outage",
    "choice_c": "A weak point in a specific program that makes it unrecoverable after an outage has occurred",
    "choice_d": "A point in time before an incident occurs",
    "correct_answer": "A",
    "explanation": "The maximum tolerable downtime/maximum allowable downtime (MTD/MAD) is a point in time after an outage has occurred and beyond which recovery becomes extremely difficult or impossible.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      334,
      319,
      544,
      427,
      557
    ],
    "source": ""
  },
  {
    "id": 451,
    "question": "Which of the following best describes a Type 1 hypervisor?",
    "choice_a": "Synchronization device for cloud IT environments",
    "choice_b": "Uses a minimal piece of software to manage the underlying hardware resources such as RAM, CPU, and storage",
    "choice_c": "Access control mechanism for cloud administrators",
    "choice_d": "Uses a separate piece of hardware to manage the underlying hardware resources such as RAM, CPU, and storage",
    "correct_answer": "B",
    "explanation": "A Type 1 hypervisor uses a minimal piece of software to manage the underlying resources. A Type 2 hypervisor is a piece of software installed on top of or as part of a device's operating system.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      14,
      142,
      455,
      8,
      158
    ],
    "source": ""
  },
  {
    "id": 452,
    "question": "A(n) ________________________ is a combination of two or more distinct cloud infrastructures that remain unique entities but are bound together by standardized or proprietary technology that enables data and application portability.",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "Hybrid cloud",
    "choice_d": "Private cloud",
    "correct_answer": "C",
    "explanation": "A hybrid cloud is a combination of two or more distinct cloud infrastructures that remain unique entities but are bound together by standardized or proprietary technology that enables data and application portability.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      9,
      1,
      11,
      13,
      8
    ],
    "source": ""
  },
  {
    "id": 453,
    "question": "Which of the following standards helps organizations to establish and maintain an ISMS?",
    "choice_a": "ISO 27001",
    "choice_b": "ISO 27009",
    "choice_c": "ITIL",
    "choice_d": "PCI",
    "correct_answer": "A",
    "explanation": "ISO 27001 describes an information security management system (ISMS) as a set of interrelated elements that organizations use to manage and control information security risks to protect and preserve the confidentiality, integrity, and availability of information.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      363,
      354,
      358,
      341,
      648
    ],
    "source": ""
  },
  {
    "id": 454,
    "question": "Which of the following best describes the cloud computing term portability?",
    "choice_a": "The ability to move operations from one cloud provider to another (or out of the cloud)",
    "choice_b": "Legal liability for the provider",
    "choice_c": "Regulatory inducement",
    "choice_d": "Speed of processing and quality of service",
    "correct_answer": "A",
    "explanation": "Portability refers to the ease with which a customer can leave a specific cloud provider without undue loss or harm.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      18,
      12,
      1,
      235,
      170
    ],
    "source": ""
  },
  {
    "id": 455,
    "question": "Which of the following best describes a Service Organization Controls 1 (SOC 1) report?",
    "choice_a": "Is relevant to a user entity's internal controls over the five security principles",
    "choice_b": "Focuses on the user entity's internal controls over financial reporting",
    "choice_c": "Focuses on the user entity's internal controls over the vendor management process",
    "choice_d": "Focuses on the user entity's internal controls over proper access and authorization",
    "correct_answer": "B",
    "explanation": "An SOC 1 report focuses on the user entity's internal controls over financial reporting.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      349,
      350,
      343,
      341,
      351
    ],
    "source": ""
  },
  {
    "id": 456,
    "question": "Which of the following best describes the term ROI?",
    "choice_a": "Used to describe part of the SDLC",
    "choice_b": "Used to describe a particular SaaS",
    "choice_c": "Used to describe a profitability ratio",
    "choice_d": "Used to describe a software rollout phase",
    "correct_answer": "C",
    "explanation": "Return on investment (ROI) is a term used to describe a profitability ratio. It is generally calculated by dividing net profit by net assets.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      573
    ],
    "source": ""
  },
  {
    "id": 457,
    "question": "The SOC 2 report covers which of the following security principles?",
    "choice_a": "Security, availability, processing integrity, confidentiality, privacy",
    "choice_b": "Confidentiality, integrity, availability",
    "choice_c": "Encrypting, hashing, and digital signatures",
    "choice_d": "Identification, authentication, and authorization",
    "correct_answer": "A",
    "explanation": "SOC 2 reports are relevant to the target entity's internal controls over the five security principles of security, availability, processing integrity, confidentiality, and privacy.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      344,
      341,
      345,
      349,
      350
    ],
    "source": ""
  },
  {
    "id": 458,
    "question": "Which hierarchical database contains mappings of domain names to various types of data such as IP addresses?",
    "choice_a": "WINS",
    "choice_b": "AD",
    "choice_c": "Open Directory",
    "choice_d": "DNS",
    "correct_answer": "D",
    "explanation": "The Domain Name System (DNS) consists of a hierarchical database mapping of domain names to various data types such as IP addresses. DNS allows you to find human-readable or \u201cfriendly\u201d names such as www.isc2.org as opposed to having to remember long IP addresses.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      95,
      94,
      602,
      599,
      447
    ],
    "source": ""
  },
  {
    "id": 459,
    "question": "Which type of cloud storage combines public and private cloud storage where some critical information stays inside the enterprise and other information resides outside?",
    "choice_a": "Hybrid",
    "choice_b": "Community",
    "choice_c": "Distributed",
    "choice_d": "Encrypted",
    "correct_answer": "A",
    "explanation": "Hybrid cloud storage is a combination of public cloud storage and private cloud storage, where some critical data resides in the enterprise's private cloud and other data is stored and accessible from a public cloud storage provider.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      9,
      1,
      7,
      11,
      8
    ],
    "source": ""
  },
  {
    "id": 460,
    "question": "Which of the following best describes the characteristics of a private cloud?",
    "choice_a": "An infrastructure provisioned for exclusive use by a single customer",
    "choice_b": "An infrastructure provisioned for use by many customers",
    "choice_c": "An infrastructure owned by several customers",
    "choice_d": "An application owned by a single customer",
    "correct_answer": "A",
    "explanation": "A private cloud is an infrastructure provisioned for exclusive use by a single customer.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      9,
      1,
      10,
      8,
      136
    ],
    "source": ""
  },
  {
    "id": 461,
    "question": "Which of the following is a messaging protocol that uses specifications designed for exchanging structured information in web services and operates independently of the client operating system?",
    "choice_a": "Java",
    "choice_b": "REST",
    "choice_c": "DAST",
    "choice_d": "SOAP",
    "correct_answer": "D",
    "explanation": "Simple Object Access Protocol (SOAP) is a messaging specification designed for exchanging structured information in web services and operates independently of the client operating system.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      559,
      278,
      705,
      561,
      565
    ],
    "source": ""
  },
  {
    "id": 462,
    "question": "Which of the following best describes a set of practices that focus on aligning IT services with business needs?",
    "choice_a": "ITIL",
    "choice_b": "ISO",
    "choice_c": "HIPAA",
    "choice_d": "GLBA",
    "correct_answer": "A",
    "explanation": "The Information Technology Infrastructure Library (ITIL) is a set of practices that focus on aligning IT services with business needs.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      445,
      446,
      323,
      264,
      107
    ],
    "source": ""
  },
  {
    "id": 463,
    "question": "Which of the following best describes SSO?",
    "choice_a": "SSO allows a user to access an application with a single set of credentials for authentication and authorization.",
    "choice_b": "SSO allows a user to access multiple websites with a single set of credentials for authentication and authorization.",
    "choice_c": "SSO allows a user to access multiple applications with a single set of credentials for authentication and authorization.",
    "choice_d": "SSO allows a user to access multiple applications with multiple sets of credentials for authentication.",
    "correct_answer": "C",
    "explanation": "Single sign-on (SSO) allows a user to access multiple applications with a single set of credentials for authentication and authorization.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      583,
      695,
      584,
      585,
      288
    ],
    "source": ""
  },
  {
    "id": 464,
    "question": "____________ is the process of transitioning all or part of a company's data, applications, and services from onsite premises behind the firewall to the cloud.",
    "choice_a": "Forklifting",
    "choice_b": "Cloud portability",
    "choice_c": "Cloud enablement",
    "choice_d": "Cloud migration",
    "correct_answer": "D",
    "explanation": "Cloud migration is the process of transitioning all or part of a company's data, applications, and services from onsite premises behind the firewall to the cloud. This enables information to be provided over the Internet on an on-demand basis.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      1,
      8,
      7,
      6,
      5
    ],
    "source": ""
  },
  {
    "id": 465,
    "question": "Which of the following is a service that replicates data across geographic areas?",
    "choice_a": "CDN",
    "choice_b": "Cloud service",
    "choice_c": "Cloud storage",
    "choice_d": "ISO",
    "correct_answer": "A",
    "explanation": "A content delivery network (CDN) is a service that replicates data across many locations.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      410,
      409,
      411,
      414,
      500
    ],
    "source": ""
  },
  {
    "id": 466,
    "question": "Which of the following best describes mechanisms designed to restrict a list of possible actions down to allowed or permitted actions?",
    "choice_a": "Controls",
    "choice_b": "DNS",
    "choice_c": "Routers",
    "choice_d": "SDNs",
    "correct_answer": "A",
    "explanation": "Controls are mechanisms designed to restrict a list of possible actions down to allowed or permitted actions.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      448,
      450,
      241,
      45,
      44
    ],
    "source": ""
  },
  {
    "id": 467,
    "question": "Why is it important to force all instantiated virtual machines to check current configuration records?",
    "choice_a": "Snapshotted images don't take patches.",
    "choice_b": "Configurations are constantly changing.",
    "choice_c": "Documentation is difficult in the cloud.",
    "choice_d": "Users are always changing configurations.",
    "correct_answer": "A",
    "explanation": "VMs are saved as files when not in use; patches can't be applied to these files, so any VM taken out of storage and put into production needs to be checked against configuration versions to determine if there were patches applied to the environment while it was stored. All the other options are distractors.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      316,
      105,
      604,
      605,
      102
    ],
    "source": ""
  },
  {
    "id": 468,
    "question": "The CSA is _____________________.",
    "choice_a": "The world's leading organization dedicated to defining and raising awareness of cloud computing",
    "choice_b": "An international standard for cloud computing",
    "choice_c": "A network standard for converged networks",
    "choice_d": "The Australian standard for privacy in cloud computing",
    "correct_answer": "A",
    "explanation": "The Cloud Security Alliance (CSA) is the world's leading organization dedicated to defining and raising awareness of best practices to help ensure a secure cloud computing environment.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      358,
      646,
      360,
      359,
      648
    ],
    "source": ""
  },
  {
    "id": 469,
    "question": "Which of the following is a suite of extensions that adds a level of security to a vital Internet protocol by enabling response validation?",
    "choice_a": "OWASP",
    "choice_b": "DNSSEC",
    "choice_c": "XML",
    "choice_d": "SAML",
    "correct_answer": "B",
    "explanation": "The Domain Name System Security Extensions (DNSSEC) is a suite of extensions that adds security to the Domain Name System (DNS) protocol by enabling DNS response validation. Specifically, DNSSEC provides origin authority, data integrity, and authenticated denial of service. With DNSSEC, the DNS protocol is much less susceptible to certain types of attacks, particularly DNS spoofing.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      608,
      717,
      603,
      106,
      627
    ],
    "source": ""
  },
  {
    "id": 470,
    "question": "Which of the following is a black-box test in which the tool must discover individual execution paths?",
    "choice_a": "DAST",
    "choice_b": "SAST",
    "choice_c": "Penetration testing",
    "choice_d": "DNSSEC",
    "correct_answer": "A",
    "explanation": "Dynamic application security testing (DAST) is a form of black-box application testing whereby the tool must discover individual execution paths. Unlike SAST, which analyzes code \u201coffline\u201d, DAST is used against applications in their running state.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      300,
      298,
      570,
      441,
      282
    ],
    "source": ""
  },
  {
    "id": 471,
    "question": "Which type of hypervisor has an operating system installed on the hardware and then the virtual manager software installed on top of it?",
    "choice_a": "Type 1",
    "choice_b": "Type 3",
    "choice_c": "Type 2",
    "choice_d": "Type 4",
    "correct_answer": "C",
    "explanation": "A Type 2 hypervisor is one in which an operating system is installed onto the hardware with the hypervisor being installed on top of the OS. These types of hypervisors are thought to be more vulnerable to attack because the attack surface is larger, therefore providing more opportunities for intrusions.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      14,
      142,
      15,
      244,
      455
    ],
    "source": ""
  },
  {
    "id": 472,
    "question": "Which type of framework contains only the information required for a specific business application to reach a targeted level of trust?",
    "choice_a": "ONF",
    "choice_b": "ISMS",
    "choice_c": "Risk assessment",
    "choice_d": "ANF",
    "correct_answer": "D",
    "explanation": "An application normative framework (ANF) is a subset of an ONF that contains only the information required for a specific business application to reach the targeted level of trust. There is a many-to-one relationship between the ANF and the ONF.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      417,
      415,
      93,
      64,
      572
    ],
    "source": ""
  },
  {
    "id": 473,
    "question": "Which are the two most widely used API formats?",
    "choice_a": "SOAP and REST",
    "choice_b": "DAST and SAST",
    "choice_c": "GLBA and PCI",
    "choice_d": "ONF and ANF",
    "correct_answer": "A",
    "explanation": "APIs are a set of routines, standards, protocols, and tools for building software applications to access a web-based software application or tool. The two most widely used are REST and SOAP.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      568,
      397,
      566,
      567,
      703
    ],
    "source": ""
  },
  {
    "id": 474,
    "question": "Which type of cloud infrastructure is provisioned for open use by the general public?",
    "choice_a": "Hybrid cloud",
    "choice_b": "Community cloud",
    "choice_c": "Cloud storage",
    "choice_d": "Public cloud",
    "correct_answer": "D",
    "explanation": "A public cloud infrastructure is provisioned for open use by the general public and may be owned, managed, and operated by a business, academic, or government organization or some combination of them and exists on the premises of the cloud provider.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      9,
      11,
      10,
      8,
      14
    ],
    "source": ""
  },
  {
    "id": 475,
    "question": "Generally considered a white-box test, which technique examines application code for problems without actually executing the code?",
    "choice_a": "DAST",
    "choice_b": "Pen testing",
    "choice_c": "Vulnerability scanning",
    "choice_d": "SAST",
    "correct_answer": "D",
    "explanation": "Static application security testing (SAST) is when application code is examined without executing the program.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      298,
      299,
      300,
      676,
      295
    ],
    "source": ""
  },
  {
    "id": 476,
    "question": "Which cryptography technique destroys data by making it unreadable?",
    "choice_a": "Elliptical curve cryptography",
    "choice_b": "Homomorphic cryptography",
    "choice_c": "Hashing",
    "choice_d": "Crypto-shredding",
    "correct_answer": "D",
    "explanation": "Crypto-shredding is the process of deliberately destroying the encryption keys that are used to encrypt data, thereby rendering it unreadable. This technique is often used in the cloud environment since locating all data fragments and destroying them is effectively impossible due to the nature of cloud computing.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      422,
      206,
      152,
      203,
      221
    ],
    "source": ""
  },
  {
    "id": 477,
    "question": "Which type of attack occurs when an application receives untrusted data and then sends it to a web browser without proper validation?",
    "choice_a": "SQL injection",
    "choice_b": "Brute-force",
    "choice_c": "XSS",
    "choice_d": "Man in the middle",
    "correct_answer": "C",
    "explanation": "A cross-site scripting (XSS) attack occurs when an application receives untrusted data and then sends it to a web browser without proper validation, allowing an attacker to execute scripts in the user's browser, hijack sessions, or engage in other malicious behavior.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      579,
      704,
      570,
      294,
      300
    ],
    "source": ""
  },
  {
    "id": 478,
    "question": "Which of the following is not typically included in the list of critical assets specified for continuity during BC/DR contingency operations?",
    "choice_a": "Systems",
    "choice_b": "Data",
    "choice_c": "Cash",
    "choice_d": "Personnel",
    "correct_answer": "C",
    "explanation": "Although cash is important for a business to function in general, it is not one of the critical BC/DR assets, which include personnel, systems, and data.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      161,
      5,
      160,
      159,
      163
    ],
    "source": ""
  },
  {
    "id": 479,
    "question": "____________________ describes the relationship between shareholders and other stakeholders in the organization versus the senior management of the corporation.",
    "choice_a": "Corporate governance",
    "choice_b": "SLA",
    "choice_c": "PLA",
    "choice_d": "Vendor management agreements",
    "correct_answer": "A",
    "explanation": "Corporate governance is defined as the relationship between shareholders and other stakeholders in the organization versus the senior management.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      180,
      7,
      16,
      193,
      182
    ],
    "source": ""
  },
  {
    "id": 480,
    "question": "What is a primary difference between web hosting and cloud server hosting?",
    "choice_a": "Cloud hosting consists of multiple connected servers providing the cloud-hosting environment.",
    "choice_b": "Web hosting is much more flexible and scalable.",
    "choice_c": "Web hosting offers more control over applications.",
    "choice_d": "Backups are more easily completed with web hosting.",
    "correct_answer": "A",
    "explanation": "Cloud server hosting is a type of hosting in which hosting services are available to customers on demand via the Internet as opposed to being provided by a single server or virtual server. In a cloud services model, multiple connected servers that a cloud server comprises provide the hosting environment.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      1,
      8,
      9,
      14,
      23
    ],
    "source": ""
  },
  {
    "id": 481,
    "question": "The CSA CCM provides which of the following?",
    "choice_a": "A list of fundamental security principles that guide cloud vendors and assist prospective cloud customers in assessing the overall security risk of a cloud provider",
    "choice_b": "Mandates for applying best known security practices",
    "choice_c": "A law that dictates regulated security functions",
    "choice_d": "A list of potential PII data that is subject to protection",
    "correct_answer": "A",
    "explanation": "The CSA CCM (Cloud Controls Matrix) provides fundamental security principles that guide cloud vendors and assist prospective cloud customers in assessing the overall security risk of a cloud provider (often in the form of the Consensus Assessments Initiative Questionnaire [CAIQ]).",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      648,
      646,
      358,
      360,
      647
    ],
    "source": ""
  },
  {
    "id": 482,
    "question": "At which layer of the OSI model does an API gateway operate?",
    "choice_a": "Networking",
    "choice_b": "Session",
    "choice_c": "Presentation",
    "choice_d": "Application",
    "correct_answer": "D",
    "explanation": "An API gateway runs on OSI Layer 7. The function of a gateway is to solve the problem related to the formatting of datA computer program running on Layer 7 will extract the data in its original format and may reformat the data for use in the lower layers.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      452,
      577,
      453,
      579,
      700
    ],
    "source": ""
  },
  {
    "id": 483,
    "question": "Which of the following best describes authorization?",
    "choice_a": "The act of identifying or verifying the eligibility of a user to access a program or process",
    "choice_b": "The act of identifying a person by password",
    "choice_c": "The act identifying a person by biometrics",
    "choice_d": "The granting of right of access to a user, program, or process",
    "correct_answer": "D",
    "explanation": "Authorization is the granting of right of access to a user, program, or process. All the other options are related to authentication.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      288,
      286,
      368,
      436,
      83
    ],
    "source": ""
  },
  {
    "id": 484,
    "question": "The acronym ARO is best defined to represent which of the following?",
    "choice_a": "The number of times a specific type of event or security incident occurs within a 12-month period",
    "choice_b": "The rate of return on a particular project over a 12-month period",
    "choice_c": "The point in time after which a return to operations is no longer feasible",
    "choice_d": "The number of times a security process is optimized or updated in a 12-month period",
    "correct_answer": "A",
    "explanation": "The annual rate of occurrence (ARO) is the rate of occurrence of a specific event or security incident one could expect to occur in any given 12-month period.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 485,
    "question": "Availability refers to which of the following?",
    "choice_a": "The amount of uptime in any given 30-day period",
    "choice_b": "The amount of uptime specified in the SLA",
    "choice_c": "Whether authorized users can access services and/or data",
    "choice_d": "The amount of uptime promised by the cloud vendor",
    "correct_answer": "C",
    "explanation": "Availability, one of the three legs of the CIA triad, represents when services and/or data can be accessed in an authorized manner.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      16,
      17,
      148,
      215,
      141
    ],
    "source": ""
  },
  {
    "id": 486,
    "question": "The term auditability means which of the following?",
    "choice_a": "A particular service or data that is covered under state or federal regulations",
    "choice_b": "Something being in a state of readiness for auditing",
    "choice_c": "The state of data being covered by audit standards of the AICPA",
    "choice_d": "The AICPA standard for SCO reports",
    "correct_answer": "B",
    "explanation": "Something is said to be auditable when it is in a state of readiness for auditing. Cloud providers are often required to maintain a state of auditability as a way of maintaining compliance.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      454,
      456,
      455,
      16,
      204
    ],
    "source": ""
  },
  {
    "id": 487,
    "question": "What does a cloud provider offer customers?",
    "choice_a": "An application hosting environment",
    "choice_b": "Reduced BCDR pricing",
    "choice_c": "Managed services on premise",
    "choice_d": "Access to an IT environment, usually via the Internet",
    "correct_answer": "D",
    "explanation": "Cloud providers offer customers access to an IT environment, usually via the Internet.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      12,
      13,
      237,
      158,
      148
    ],
    "source": ""
  },
  {
    "id": 488,
    "question": "A community cloud has which of the following characteristics?",
    "choice_a": "Differing concerns such as mission, security requirements, policy, and compliance considerations",
    "choice_b": "Exclusive community-based ownership, management, and operation of the environment on premises",
    "choice_c": "Shared concerns such as mission, security requirements, policy, and compliance considerations",
    "choice_d": "Specific security requirements, policy, and compliance implementations for a single customer",
    "correct_answer": "C",
    "explanation": "Community clouds are characterized by shared concerns such as mission, security requirements, policy, and compliance considerations. One or more of the organizations in the community, a third party, or some combination thereof own, manage, and/or operate the environment.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      10,
      9,
      12,
      237,
      236
    ],
    "source": ""
  },
  {
    "id": 489,
    "question": "Which of the following best describes software-defined networking (SDN)?",
    "choice_a": "Controlling network devices from a single management interface",
    "choice_b": "The idea of using a hyper-converged network model to stream efficiencies",
    "choice_c": "The idea of controlling network provisioning via the hypervisor",
    "choice_d": "The idea of separating the network control plane from the actual network forwarding plane",
    "correct_answer": "D",
    "explanation": "SDN is the idea of separating the network control plane from the actual network forwarding plane. This allows for greater control over networking capabilities and for integration of such things as APIs.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      520,
      522,
      521,
      536,
      540
    ],
    "source": ""
  },
  {
    "id": 490,
    "question": "The SDLC is characterized by which of the following?",
    "choice_a": "The concept of establishing clear phases and methodologies as part of software development",
    "choice_b": "The Agile Manifesto",
    "choice_c": "The Waterfall development model",
    "choice_d": "The separation of the management and forwarding planes",
    "correct_answer": "A",
    "explanation": "The software development life cycle (SDLC) is the concept of establishing clear phases and methodologies as part of software development.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      295,
      300,
      441,
      439,
      567
    ],
    "source": ""
  },
  {
    "id": 491,
    "question": "Which of the following models offers the capability of using an application solution running on a vendor's or cloud provider's infrastructure?",
    "choice_a": "SaaS",
    "choice_b": "IaaS",
    "choice_c": "PaaS",
    "choice_d": "AaaS",
    "correct_answer": "A",
    "explanation": "Software as a service (SaaS) offers the user the capability of using the vendor's or cloud provider's application solution on their existing infrastructure.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      8,
      9,
      13,
      12,
      6
    ],
    "source": ""
  },
  {
    "id": 492,
    "question": "Which of the following is not commonly considered a form of privacy data processing?",
    "choice_a": "Storing",
    "choice_b": "Computing",
    "choice_c": "Destroying",
    "choice_d": "Buying",
    "correct_answer": "D",
    "explanation": "Purchasing is not normally an activity related to privacy data processing. All the other options fall into the definition of processing.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      660,
      658,
      339,
      337,
      653
    ],
    "source": ""
  },
  {
    "id": 493,
    "question": "Which of the following best describes SLE?",
    "choice_a": "The amount of expected loss due to any specific single incident",
    "choice_b": "The amount of expected damage or loss due to any and all incidents in a year",
    "choice_c": "The amount of expected loss or damage due to security incidents",
    "choice_d": "The amount of expected damage due to any single storage failure incident",
    "correct_answer": "A",
    "explanation": "Single loss expectancy (SLE) is the amount of expected damage or loss from any single specific security incident.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 494,
    "question": "Which of the following is a framework that allows a diverse group of individuals to communicate securely?",
    "choice_a": "Digital certificates",
    "choice_b": "PKI",
    "choice_c": "SSL",
    "choice_d": "Elliptical curve cryptography",
    "correct_answer": "B",
    "explanation": "Public key infrastructure (PKI) is a framework of programs, procedures, communication protocols, and public key cryptography that enables a diverse group of individuals to communicate securely.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      228,
      1,
      5,
      5
    ],
    "source": ""
  },
  {
    "id": 495,
    "question": "Confidentiality refers to which of the following?",
    "choice_a": "The concept of keeping all information secret",
    "choice_b": "The concept of keeping information secret from anyone other than someone with equal or greater access",
    "choice_c": "The concept of keeping information secret from anyone other than someone with authorized access",
    "choice_d": "The concept of keeping information secret from anyone other than the system administrator",
    "correct_answer": "C",
    "explanation": "Confidentiality refers to the concept of keeping information secret from anyone other than someone with authorized access.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      16,
      192,
      195,
      197,
      199
    ],
    "source": ""
  },
  {
    "id": 496,
    "question": "Which of the following describes attributes of public cloud computing?",
    "choice_a": "Minimal management effort and shared resources",
    "choice_b": "High maintenance but low cost",
    "choice_c": "Slow release of resources",
    "choice_d": "Limited access",
    "correct_answer": "A",
    "explanation": "Public cloud computing is characterized by ubiquitous access to shared resources that require minimal management of the shared resources.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      1,
      2,
      9,
      11,
      12
    ],
    "source": ""
  },
  {
    "id": 497,
    "question": "Which of the following represents the six stages of the data lifecycle in order?",
    "choice_a": "Create, use, store, share, archive, and destroy",
    "choice_b": "Create, store, use, share, archive, and destroy",
    "choice_c": "Create, use, share, store, archive, and destroy",
    "choice_d": "Create, share, use, store, archive, and destroy",
    "correct_answer": "B",
    "explanation": "The data lifecycle consists of six stages. In order they are create, store, use, share, archive, and destroy.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      421,
      422,
      423,
      195,
      184
    ],
    "source": ""
  },
  {
    "id": 498,
    "question": "Which of the following data storage types are used with PaaS?",
    "choice_a": "Tabular and object",
    "choice_b": "Unstructured",
    "choice_c": "Structured and unstructured",
    "choice_d": "Raw and block",
    "correct_answer": "C",
    "explanation": "Platform as a service (PaaS) uses structured and unstructured data types.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      411,
      493,
      496,
      25,
      29
    ],
    "source": ""
  },
  {
    "id": 499,
    "question": "Where is a NIDS deployed in a cloud or enterprise environment?",
    "choice_a": "On the segment being monitored",
    "choice_b": "On the device being monitored",
    "choice_c": "Near the firewall or gateway",
    "choice_d": "On a virtual server",
    "correct_answer": "A",
    "explanation": "A network intrusion detection system (NIDS) is deployed anywhere on the network segment being monitored. This can be, but does not need to be, near the network gateway.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      98,
      97,
      326,
      402,
      249
    ],
    "source": ""
  },
  {
    "id": 500,
    "question": "When using transparent database encryption, where is the engine deployed?",
    "choice_a": "Within the database",
    "choice_b": "On the database server",
    "choice_c": "At the gateway",
    "choice_d": "In the browser",
    "correct_answer": "A",
    "explanation": "Transparent database encryption requires the encryption to reside within the database itself.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      503,
      418,
      494,
      507,
      501
    ],
    "source": ""
  },
  {
    "id": 501,
    "question": "Which of following does not have to occur before an authorized party can formally declare that an organization can return to normal after contingency or BC/DR operations?",
    "choice_a": "Safety risks have been addressed.",
    "choice_b": "Operating conditions have returned to normal.",
    "choice_c": "Health hazards have been abated.",
    "choice_d": "New measures have been implemented to prevent similar incidents.",
    "correct_answer": "D",
    "explanation": "Although implementing new preventative measures might be helpful, they are generally not necessary to resume operations. However, it is necessary to have a high degree of assurance that all safety and health hazards have been abated and operating conditions and risks have returned to normal.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      162,
      160,
      166,
      5,
      158
    ],
    "source": ""
  },
  {
    "id": 502,
    "question": "Software developers creating products for cloud environments need to consider: _____________",
    "choice_a": "The language used in the geographic area of the end user",
    "choice_b": "The overall price of development",
    "choice_c": "The shared use of underlying resources",
    "choice_d": "How digital certificates might be used in the cloud",
    "correct_answer": "C",
    "explanation": "Shared resources can create the potential for side-channel attacks if the software is not created with the proper controls.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      78,
      73,
      71,
      69,
      75
    ],
    "source": ""
  },
  {
    "id": 503,
    "question": "Which of the following is one aspect of secure software development for the cloud that should be considered?",
    "choice_a": "Application-based firewalls",
    "choice_b": "Process isolation",
    "choice_c": "Enhancement mechanisms",
    "choice_d": "Language barriers",
    "correct_answer": "B",
    "explanation": "Process isolation can reduce the possibility of side-channel attacks in an environment with shared resources.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      78,
      69,
      73,
      71,
      283
    ],
    "source": ""
  },
  {
    "id": 504,
    "question": "Which of the following is an attack vector that should be specifically addressed in PaaS environments?",
    "choice_a": "Fire",
    "choice_b": "Insider threat",
    "choice_c": "SQL injection",
    "choice_d": "Physical intrusion",
    "correct_answer": "C",
    "explanation": "PaaS environments often include databases; SQL injection is a common form of attacking databases. All the other options need to be addressed in any data center/environment, not specifically PaaS.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      73,
      75,
      578,
      69,
      71
    ],
    "source": ""
  },
  {
    "id": 505,
    "question": "The organization that publishes the STAR certification program for cloud providers is ___________________.",
    "choice_a": "ISO",
    "choice_b": "NIST",
    "choice_c": "UNICEF",
    "choice_d": "CSA",
    "correct_answer": "D",
    "explanation": "The Cloud Security Alliance publishes the STAR program.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      358,
      646,
      647,
      360,
      344
    ],
    "source": ""
  },
  {
    "id": 506,
    "question": "What is the organization that publishes and maintains the Common Criteria certification program for IT products?",
    "choice_a": "NIST",
    "choice_b": "ISO",
    "choice_c": "NATO",
    "choice_d": "UNESCO",
    "correct_answer": "B",
    "explanation": "ISO publishes and maintains the Common Criteria program.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      675,
      363,
      344,
      646,
      648
    ],
    "source": ""
  },
  {
    "id": 507,
    "question": "This type of control might affect the functionality of egress monitoring solutions.",
    "choice_a": "Firewall",
    "choice_b": "Personnel training",
    "choice_c": "Bollards",
    "choice_d": "Encryption",
    "correct_answer": "D",
    "explanation": "Encrypted data may be impossible for the egress monitoring solution to read, thereby making the tool useless.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      45,
      59,
      43,
      48,
      57
    ],
    "source": ""
  },
  {
    "id": 508,
    "question": "Log data should be protected _______.",
    "choice_a": "On premises",
    "choice_b": "Away from the cloud provider",
    "choice_c": "With controls as or more stringent than the systems being logged",
    "choice_d": "By administrators who are directly involved with the particular clients in question",
    "correct_answer": "C",
    "explanation": "Log data is sensitive and valuable and must be protected at a level as high or higher than the systems being logged.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      38,
      39,
      25,
      34,
      386
    ],
    "source": ""
  },
  {
    "id": 509,
    "question": "Most PII is gathered by ________.",
    "choice_a": "EU companies",
    "choice_b": "Voluntary disclosure",
    "choice_c": "Malicious attackers",
    "choice_d": "Insidious methods",
    "correct_answer": "B",
    "explanation": "Most PII is gathered from individuals who voluntarily disclose it.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      24,
      27,
      29,
      31,
      34
    ],
    "source": ""
  },
  {
    "id": 510,
    "question": "Alice is the CEO for a software company; she is considering migrating the operation from the current traditional on-premises environment into the cloud. Which cloud service model should she most likely consider for her company\u2019s purposes?",
    "choice_a": "Platform as a service (PaaS)",
    "choice_b": "Software as a service (SaaS)",
    "choice_c": "Backup as a service (Baas)",
    "choice_d": "Infrastructure as a service (IaaS)",
    "correct_answer": "A",
    "explanation": "PaaS will allow her developers to create and design their software on a variety of operating systems (OSs), increasing the breadth of the market she can sell to. Also, she can use geographically dispersed programmers to work on projects concurrently, and the provider will be responsible for maintaining and updating the OSs as necessary. IaaS is a less attractive option because it would retain the need for Alice\u2019s company to administer the OSs in addition to building their software; it might be less expensive in terms of paying the cloud provider, but the time and effort and personnel necessary to maintain the OSs would offset that cost, probably in a net-negative way. SaaS is not an option; Alice wants her company to build software, not rent it or buy it. Backup as a Service (BaaS) would not be useful for creating, designing, or deploying Alice\u2019s company\u2019s software.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      8,
      1,
      3,
      7,
      13
    ],
    "source": ""
  },
  {
    "id": 511,
    "question": "Alice is the CEO for a software company; she is considering migrating the operation from the current traditional on-premises environment into the cloud. Which aspect of cloud computing should she be <italic>most</italic> concerned about, in terms of security issues?",
    "choice_a": "Multitenancy",
    "choice_b": "Metered service",
    "choice_c": "Service-level agreement (SLA)",
    "choice_d": "Remote access",
    "correct_answer": "A",
    "explanation": "Of these four options, multitenancy poses the greatest risk to software developers in the cloud, because developers need to be concerned with two things: protecting their intellectual property (the software they\u2019re making) and protecting resource calls their software makes to the underlying infrastructure (which, if detectable by other cloud customers, could provide information that constitutes a side-channel attack). Metered service doesn\u2019t pose much of a security risk. The SLA might include some security aspects (such as response time), but it\u2019s usually more of a performance-ensuring tool, and this choice is not as good as option A. Remote access, in this particular case, provides more benefit than risk: Alice can utilize work from developers located across the country or across the planet. While she does have to consider the risks inherent in all remote access, those risks are not as significant as the risks due to multitenancy, so option A is still preferable.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      11,
      216,
      2,
      225,
      227
    ],
    "source": ""
  },
  {
    "id": 512,
    "question": "Alice is the CEO for a software company; she is considering migrating the operation from the current traditional on-premises environment into the cloud. In order to protect her company\u2019s intellectual property, Alice might want to consider implementing all these techniques/solutions <italic>except</italic> ___________________.",
    "choice_a": "Egress monitoring",
    "choice_b": "Encryption",
    "choice_c": "Turnstiles",
    "choice_d": "Digital watermarking",
    "correct_answer": "C",
    "explanation": "Turnstiles are a physical security barrier to prevent piggybacking/tailgating (an unauthorized person coming through an entrance behind someone who is authorized), but they don\u2019t really present much protection for intellectual property in this case. Egress monitoring (often referred to as \u201cDLP\u201d solutions) is a great way to reduce the likelihood of intellectual property leaving the owner\u2019s control in an unexpected/unapproved manner. Likewise, strong encryption is useful in the cloud to reduce the impact of theft either from leakage to other cloud tenants or from insider threats (such as malicious admins in the employ of the cloud provider). Finally, digital watermarks aid protection of intellectual property by proving original ownership, which is essential for enforcing intellectual property rights (in the case of software design, mainly copyright protections).",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      216,
      223,
      422,
      231,
      227
    ],
    "source": ""
  },
  {
    "id": 513,
    "question": "Alice is the CEO for a software company; she is considering migrating the operation from the current traditional on-premises environment into the cloud. What is probably the biggest factor in her decision?",
    "choice_a": "Network scalability",
    "choice_b": "Off-site backup capability",
    "choice_c": "Global accessibility",
    "choice_d": "Reduced overall cost due to outsourcing administration",
    "correct_answer": "D",
    "explanation": "While all of these are traits of cloud computing and will likely benefit Alice\u2019s company, from her position as senior manager of the organization she is likely to consider the financial benefit first and foremost.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      6,
      1,
      8,
      227,
      214
    ],
    "source": ""
  },
  {
    "id": 514,
    "question": "In which of the following situations does the data owner have to administer the OS?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "Off-site archive",
    "choice_d": "SaaS",
    "correct_answer": "A",
    "explanation": "With infrastructure as a service (IaaS), the customer (data owner) will administer the OS and applications. In PaaS, the provider will manage the underlying hardware and the OS. In an on-premises enterprise, the data owner is also the system owner and will be responsible for everything. In an SaaS environment, the cloud provider will handle all aspects of processing, except for adding and manipulating the production data.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      8,
      12,
      237,
      13,
      147
    ],
    "source": ""
  },
  {
    "id": 515,
    "question": "You are setting up a cloud implementation for an online retailer who will accept credit card payments. According to the Payment Card Industry Data Security Standard (PCI DSS), what can you never store for any length of time?",
    "choice_a": "Personal data of consumers",
    "choice_b": "The credit card verification (CCV) number",
    "choice_c": "The credit card number",
    "choice_d": "Home address of the customer",
    "correct_answer": "B",
    "explanation": "PCI DSS requires that the CCV (or, sometimes, \u201cCVV\u201d for \u201ccard verification value\u201d) only be used in the transaction, not stored. The data described in all the other options may be stored after the transaction is complete.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      473,
      461,
      421,
      190,
      213
    ],
    "source": ""
  },
  {
    "id": 516,
    "question": "The Payment Card Industry Data Security Standard (PCI DSS) distinguishes merchants by different tiers, based on ___________.",
    "choice_a": "Number of transactions per year",
    "choice_b": "Dollar value of transactions per year",
    "choice_c": "Geographic location",
    "choice_d": "Jurisdiction",
    "correct_answer": "A",
    "explanation": "The four merchant levels in PCI are distinguished by the number of transactions that merchant conducts in a year. The dollar value of transactions per year, geographic location, and jurisdiction are not attributes that are evaluated for PCI DSS tier levels.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      460,
      462,
      213,
      190,
      461
    ],
    "source": ""
  },
  {
    "id": 517,
    "question": "What is usually considered the difference between business continuity (BC) efforts and disaster recovery (DR) efforts?",
    "choice_a": "BC involves a recovery time objective (RTO), and DR involves a recovery point objective (RPO).",
    "choice_b": "BC is for events caused by humans (like arson or theft), whereas DR is for natural disasters.",
    "choice_c": "BC is about maintaining critical functions during a disruption of normal operations, and DR is about recovering to normal operations after a disruption.",
    "choice_d": "BC involves protecting human assets (personnel, staff, users), whereas DR is about protecting property (assets, data).",
    "correct_answer": "C",
    "explanation": "Technically, BC efforts are meant to ensure that critical business functions can continue during a disruptive event, and DR efforts are supposed to support the return to normal operations. However, in practice, the efforts often coincide, use the same plans/personnel, and have many of the same procedures. <br>Option A is incorrect; both BC and DR use the RTO and RPO as metrics to determine success. <br>Option B is incorrect; BC and DR efforts are not specific to the cause of a disruptive event. <br>Option D is incorrect; health and human safety should be paramount in all security efforts, with very few exceptions.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      159,
      163,
      162,
      161,
      160
    ],
    "source": ""
  },
  {
    "id": 518,
    "question": "For business continuity and disaster recovery (BC/DR) purposes, the contract between the primary cloud provider and customer should include all of the following <italic>except</italic> ___________________.",
    "choice_a": "Which party will be responsible for initiating a BC/DR response activity",
    "choice_b": "How a BC/DR response will be initiated",
    "choice_c": "How soon the customer\u2019s data can be ported to a new cloud provider in the event a disruptive event makes the current provider unable to continue service",
    "choice_d": "How much a new cloud provider will charge the customer if data has to be ported from the current cloud provider because of a disruptive event",
    "correct_answer": "D",
    "explanation": "The contract between the cloud customer and current cloud provider has no bearing on what the customer will have to pay to a new provider; that will be governed by the contract between the customer and the new provider. <br>All the other options are topics that should be addressed in the contract between the current cloud provider and the cloud customer in order to properly address BCDR needs.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      232,
      229,
      231,
      18,
      147
    ],
    "source": ""
  },
  {
    "id": 519,
    "question": "When the cloud customer requests modifications to the current contract or service-level agreement (SLA) for business continuity/disaster recovery (BD/DR) purposes, who should absorb the cost of modification?",
    "choice_a": "The customer absorbs the cost.",
    "choice_b": "The provider absorbs the cost.",
    "choice_c": "The cost should be split equally.",
    "choice_d": "Modifications don\u2019t cost anything.",
    "correct_answer": "A",
    "explanation": "The customer will have to pay for the costs of modification requested by the customer, regardless of purpose. The provider does not absorb the cost when the customer\u2019s requests a modification of the SLA. Though an even split of the cost between customer and provider may seem fair, the customer pays for all costs associated with modifications to the SLA by the customer. Finally, customer modifications to their SLA are chargeable expenses that will almost certainly be paid for by the customer.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      232,
      229,
      170,
      12,
      147
    ],
    "source": ""
  },
  {
    "id": 520,
    "question": "Which of the following is <italic>not</italic> a factor an organization might use in the cost\u2013benefit analysis when deciding whether to migrate to a cloud environment?",
    "choice_a": "Pooled resources in the cloud",
    "choice_b": "Shifting from IT investment as capital expenditures to operational expenditures",
    "choice_c": "The time savings and efficiencies offered by the cloud service",
    "choice_d": "Branding associated with which cloud provider might be selected",
    "correct_answer": "D",
    "explanation": "The brand associated with the cloud provider should not influence the cost\u2013benefit analysis; the cloud provider\u2019s brand (and even which cloud provider an organization uses) will most likely not even be known to the consumers who have a business relationship with the organization. <br>All the other options are topics the organization should review as part of a cost\u2013benefit analysis when considering cloud migration.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      6,
      136,
      224,
      226,
      12
    ],
    "source": ""
  },
  {
    "id": 521,
    "question": "Which of the following is the <italic>least</italic> important factor an organization might use in the cost\u2013benefit analysis when deciding whether to migrate to a cloud environment?",
    "choice_a": "Depreciation of IT assets",
    "choice_b": "Shift in focus from IT dependencies to business process opportunities",
    "choice_c": "Whether the provider bills on a monthly or weekly basis",
    "choice_d": "Costs associated with utility consumption",
    "correct_answer": "C",
    "explanation": "The timing of recurring payments to the provider will probably not be a significant factor in the cost\u2013benefit analysis. <br>All the other options are topics that are more important to review when an organization is considering cloud migration.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      136,
      218,
      217,
      219,
      224
    ],
    "source": ""
  },
  {
    "id": 522,
    "question": "Which of the following is an aspect of IT costs that will likely be reduced by moving from a traditional, on-premises IT environment into the cloud?",
    "choice_a": "Number of users",
    "choice_b": "Cost of software licensing",
    "choice_c": "Number of applications",
    "choice_d": "Number of clientele",
    "correct_answer": "B",
    "explanation": "In a traditional environment, enterprise software costs can be exorbitant, and the price of licensing doesn\u2019t even reflect the hidden costs associated with licensing, such as managing the license library. In a cloud arrangement, especially software as a service (SaaS), the customer pays only the contract fee to the cloud provider, and it is the provider\u2019s responsibility to arrange for software licensing and to manage those licenses. <br>Option A is incorrect because the number of users should not be affected whether the organization is operating in the cloud or a legacy environment. The exception would be the reduced number of privileged users, because the cloud provider will be handling more administrative tasks in the environment; however, because \u201cprivileged\u201d was not specified, option B is still a better answer. <br>Option C is incorrect because that may or may not be true of an organization\u2019s migration to the cloud. <br> Option D is incorrect because the organization certainly hopes it is not going to lose clientele by moving to the cloud!",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      6,
      8,
      5,
      158,
      227
    ],
    "source": ""
  },
  {
    "id": 523,
    "question": "Which of the following is an aspect of IT costs that will likely be reduced by moving from a traditional, on-premises IT environment to the cloud?",
    "choice_a": "Utilities costs",
    "choice_b": "Security costs",
    "choice_c": "Landscaping costs",
    "choice_d": "Travel costs",
    "correct_answer": "A",
    "explanation": "Cloud providers are purchasing utilities (power, water, Internet connectivity) at such a massive rate that they can realize per-unit cost savings that would far exceed any smaller organizations\u2019 pricing for individual data centers. In this case, economies of scale are very much in favor of the larger entity. <br>Option B may or may not be true, depending on the degree of sensitivity and value of the organization\u2019s data and what controls the organization will request/contract for in the cloud. <br>Options C and D are not influenced by cloud migration in any way and are wholly dependent on other factors within the organization.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      6,
      1,
      9,
      145,
      148
    ],
    "source": ""
  },
  {
    "id": 524,
    "question": "Which of the following is an aspect of IT costs that will likely be reduced by moving from a traditional, on-premises IT environment to the cloud?",
    "choice_a": "Personnel training",
    "choice_b": "Personnel turnover",
    "choice_c": "Capital expenses for IT assets",
    "choice_d": "Loss due to an internal data breach",
    "correct_answer": "C",
    "explanation": "Constant reinvestment in IT assets (which are almost always obsolete by the time they\u2019re marketed, much less by the time they\u2019re deployed in operational environments) is plagued with sunk costs; money spent on hardware devices or software licenses is unlikely to be recovered. Avoiding expenditures for IT systems by moving to the cloud means reducing these costs considerably. <br>Option A is incorrect; cloud migration should not affect the need for personnel training; employees will just need to be trained in a different manner. <br>Options B and D should not be affected by cloud migration in any way; whether your organization has a high personnel turnover rate or risk from internal threat is not based on whether the IT environment is owned or leased.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      6,
      5,
      7,
      136,
      148
    ],
    "source": ""
  },
  {
    "id": 525,
    "question": "Although cloud migration might offer significant cost savings for an organization, which of the following factors might reduce the actual financial benefit the organization realizes in a cloud environment?",
    "choice_a": "Altitude of the cloud data center",
    "choice_b": "Security controls and countermeasures",
    "choice_c": "Loss of ownership of IT assets",
    "choice_d": "Costs of Internet connectivity for remote users",
    "correct_answer": "B",
    "explanation": "Every security process, tool, and behavior entails a related cost, both financially and operationally. Although a \u201cbase price\u201d cloud service might appear extremely affordable compared to the traditional environment, add-ons such as encryption, digital rights management (DRM), security incident/event management (SIM/SEM/SIEM), and intrustion detection/prevention systems (IDS/IPS) may all come with additional cost and may degrade performance, thus reducing the cost savings compared to the cost of operations prior to migration. This is extremely important for the organization to consider before migration, especially if the organization exists in a highly regulated industry. <br>Option A is incorrect because the altitude of the cloud data center does not translate into a reduction of the actual financial benefit the organization would realize in moving to the cloud environment. <br>Option C is wrong because it should be the opposite of the actual case: losing ownership of the IT assets, and paying only for the use of those assets, should lead directly to a savings over the costs of a traditional IT environment, if compared on a seat-to-seat basis. <br>Option D should not be true; the cost of connecting users to the Internet should not be significantly greater if the organization operates in the cloud or with an on-premises data center\u2014if the cost is considerably greater, the organization should never have migrated in the first place.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      6,
      3,
      5,
      223,
      225
    ],
    "source": ""
  },
  {
    "id": 526,
    "question": "What is the international standard that dictates creation of an organizational information security management system (ISMS)?",
    "choice_a": "NIST SP 800-53",
    "choice_b": "PCI DSS",
    "choice_c": "ISO 27001",
    "choice_d": "NIST SP 800-37",
    "correct_answer": "C",
    "explanation": "ISO 27001 mandates an ISMS; organizations can be certified according to compliance with 27001. <br>National Institute of Standards and Technology (NIST) SP 800-53 is the list of security controls approved for use by U.S. government agencies and a means to map them to the Risk Management Framework. <br>The Payment Card Industry Data Security Standard (PCI DSS) is the payment card industry\u2019s framework of compliance for all entities accepting or processing credit card payments. <br>NIST SP 800-37 is the Risk Management Framework.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      192,
      465,
      463,
      464,
      197
    ],
    "source": ""
  },
  {
    "id": 527,
    "question": "ISO 27001 favors which type of technology?",
    "choice_a": "Open source",
    "choice_b": "PC",
    "choice_c": "Cloud-based",
    "choice_d": "None",
    "correct_answer": "D",
    "explanation": "The ISO 27001 standard is designed to be product agnostic. The other answers suggest ISO 27001 favors a type of technology, and are therefore incorrect.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      463,
      465,
      192,
      230,
      158
    ],
    "source": ""
  },
  {
    "id": 528,
    "question": "Why might an organization choose to comply with the ISO 27001 standard?",
    "choice_a": "Price",
    "choice_b": "Ease of implementation",
    "choice_c": "International acceptance",
    "choice_d": "Speed",
    "correct_answer": "C",
    "explanation": "The ISO standards are almost universally accepted and recognized, and they\u2019re even mandated for certain industries/locales. <br>They are not, however, cheap, fast, or easy to adopt, implement, and audit against, so all the other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      192,
      463,
      228,
      233,
      210
    ],
    "source": ""
  },
  {
    "id": 529,
    "question": "Why might an organization choose to comply with NIST SP 800-series standards?",
    "choice_a": "Price",
    "choice_b": "Ease of implementation",
    "choice_c": "International acceptance",
    "choice_d": "Speed",
    "correct_answer": "A",
    "explanation": "The NIST standards are not particularly easy or fast to implement (in fact, they require continual improvement), and they are not widely recognized or mandated outside of the U.S. government federal sector. <br>However, they are in the public domain, so an organization would not have to pay for the standards material if the organization chose to use NIST standards.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      228,
      1,
      192,
      233,
      210
    ],
    "source": ""
  },
  {
    "id": 530,
    "question": "Which standard contains guidance for selecting, implementing, and managing information security controls mapped to an information security management system (ISMS) framework?",
    "choice_a": "ISO 27002",
    "choice_b": "Payment Card Industry Data Security Standard (PCI DSS)",
    "choice_c": "NIST SP 800-37",
    "choice_d": "Health Insurance Portability and Accountability Act (HIPAA)",
    "correct_answer": "A",
    "explanation": "ISO 27002 is used for choosing security controls in order to comply with the ISMS, which is contained in ISO 27001. <br>PCI DSS is the payment card industry\u2019s framework of compliance for all entities accepting or processing credit card payments. <br>NIST SP 800-37 is the Risk Management Framework. <br>HIPAA is the U.S. law regarding patient data privacy in the medical sector.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      192,
      197,
      196,
      465,
      228
    ],
    "source": ""
  },
  {
    "id": 531,
    "question": "The current American Institute of Certified Public Accountants (AICPA) publishes the ___________________ standard, from which the Service Organization Control (SOC) reports are derived.",
    "choice_a": "Sherwood Applied Business Security Architecture (SABSA)",
    "choice_b": "Statement on Standards for Attestation Engagements (SSAE) 18",
    "choice_c": "Biba",
    "choice_d": "NIST SP 800-53",
    "correct_answer": "B",
    "explanation": "SSAE 18 is the current AICPA audit standard, as of 2018. <br>All the other options are distractors: SABSA is an IT architecture framework, Biba is an access control model, and NIST SP 800-53 contains guidance for selecting security controls in accordance with the Risk Management Framework.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      205,
      265,
      204,
      193,
      483
    ],
    "source": ""
  },
  {
    "id": 532,
    "question": "Which U.S. federal law affects banking and insurance companies?",
    "choice_a": "NIST 800-53",
    "choice_b": "HIPAA",
    "choice_c": "Sarbanes-Oxley Act (SOX)",
    "choice_d": "Gramm-Leach-Bliley Act (GLBA)",
    "correct_answer": "D",
    "explanation": "GLBA is a U.S. federal law pertaining to financial and insurance customer information. <br>NIST 800-53 is a standard, not a law, so option A is incorrect. <br>Health Insurance Portability and Accountability Act (HIPAA) is a U.S. federal law concerning medical information, so option B is incorrect. <br>SOX affects publicly traded corporations, making option C incorrect.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      182,
      179,
      178,
      172,
      168
    ],
    "source": ""
  },
  {
    "id": 533,
    "question": "The Statement on Standards for Attestation Engagements 18 (SSAE 18) Service Organization Control (SOC) reports are audit tools promulgated by the American Institute of Certified Public Accountants (AICPA). What kind of entities were SOC reports designed to audit?",
    "choice_a": "U.S. federal government",
    "choice_b": "Privately held companies",
    "choice_c": "Companies that provide services",
    "choice_d": "Nonprofit organizations",
    "correct_answer": "C",
    "explanation": "The SSAE 18 is an audit standard, and the SOC reports were specifically designed to report on the suitability of organizations that provide services. This is not to say that SOC reports are not used to assess other types of organizations\u2014they are, but they were not designed for that purpose, so all the other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      205,
      265,
      266,
      204,
      483
    ],
    "source": ""
  },
  {
    "id": 534,
    "question": "The Statement on Standards for Attestation Engagements (SSAE) 18 Service Organization Control (SOC) reports are audit tools promulgated by the American Institute of Certified Public Accountants (AICPA). As an IT security professional, when reviewing SOC reports for a cloud provider, which report would you <italic>most</italic> like to see?",
    "choice_a": "SOC 1",
    "choice_b": "SOC 2, Type 1",
    "choice_c": "SOC 2, Type 2",
    "choice_d": "SOC 3",
    "correct_answer": "C",
    "explanation": "The SOC 2, Type 2 report will provide details on IT security controls used by the target and how well those controls function. <br>The SOC 1 report provides information about financial reporting mechanisms of the target only and is of little interest to the IT security professional, so option A is incorrect. <br>The SOC 2, Type 1 report describes IT security controls designed by the target only but not how effectively those controls function, so option B is incorrect. <br>The SOC 3 report is only an attestation that the target was audited and that it passed the audit, without detail, so option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      205,
      266,
      265,
      267,
      456
    ],
    "source": ""
  },
  {
    "id": 535,
    "question": "The Statement on Standards for Attestation Engagements (SSAE) 18 Service Organization Control (SOC) reports are audit tools promulgated by the American Institute of Certified Public Accountants (AICPA). As an investor, when reviewing SOC reports for a cloud provider, which report would you <italic>most</italic> like to see?",
    "choice_a": "SOC 1",
    "choice_b": "SOC 2, Type 1",
    "choice_c": "SOC 2, Type 2",
    "choice_d": "SOC 3",
    "correct_answer": "A",
    "explanation": "The SOC 1 report provides information about financial reporting mechanisms of the target only. Although this information may be of little use to the IT security professional, it may be of great use to potential investors, if for nothing other than providing some assurance that reporting is valid and believable. <br>The SOC 2, Type 1 report describes IT security controls designed by the target only but not how effectively those controls function. While of some interest to the IT security professional, this is of little interest to the investor, so option B is incorrect. <br>The SOC 2, Type 2 report will provide details on IT security controls used by the target and how well those controls function. While of great interest to the IT security professional, this is of little interest to the investor, so option C is incorrect. <br>The SOC 3 report is only an attestation that the target was audited and that it passed the audit, without detail, so option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      205,
      265,
      266,
      267,
      456
    ],
    "source": ""
  },
  {
    "id": 536,
    "question": "The Statement on Standards for Attestation Engagements (SSAE) 18 Service Organization Control (SOC) reports are audit tools promulgated by the American Institute of Certified Public Accountants (AICPA). You are an IT security professional working for an organization that is considering migrating from your on-premises environment into the cloud. Assuming some have passed SSAE 18 audits and some haven\u2019t, which SOC report might be best to use for your initial review of several different cloud providers in order to narrow down the field of potential services in a fast, easy way?",
    "choice_a": "SOC 1",
    "choice_b": "SOC 2, Type 1",
    "choice_c": "SOC 2, Type 2",
    "choice_d": "SOC 3",
    "correct_answer": "D",
    "explanation": "The SOC 3 report is an attestation that the target was audited and that it passed the audit, without detail; you could use the SOC 3 reports to quickly narrow down the list of possible providers by eliminating the ones without SOC 3s. <br>The SOC 1 report provides information about financial reporting mechanisms of the target only. This information may be of little use to the IT security professional and won\u2019t help you choose a cloud vendor, so option A is incorrect. <br>The SOC 2, Type 1 report describes IT security controls designed by the target only but not how effectively those controls function. While of some interest to the IT security professional, it is more comprehensive and detailed than a SOC 3 report, so it would take more time; option B is incorrect. <br>The SOC 2, Type 2 report will provide details on IT security controls used by the target and how well those controls function. While of great interest to the IT security professional, it is very detailed and comprehensive and wouldn\u2019t be a speedy tool to narrow the field. Option C is incorrect.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      265,
      267,
      266,
      205,
      456
    ],
    "source": ""
  },
  {
    "id": 537,
    "question": "Which of the following entities would <italic>not</italic> be covered by the Payment Card Industry Data Security Standard (PCI DSS)?",
    "choice_a": "A bank issuing credit cards",
    "choice_b": "A retailer accepting credit cards as payment",
    "choice_c": "A business that processes credit card payments on behalf of a retailer",
    "choice_d": "A company that offers credit card debt repayment counseling",
    "correct_answer": "D",
    "explanation": "PCI DSS applies only to those entities that want to engage in the business of taking or processing credit card payments, which would include options A, B, and C. A counseling service is not engaged in commerce involving credit cards and therefore is under no obligation to adhere to the PCI DSS.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      461,
      190,
      460,
      473,
      182
    ],
    "source": ""
  },
  {
    "id": 538,
    "question": "What sort of legal enforcement may the Payment Card Industry (PCI) Security Standards Council <italic>not</italic> bring to bear against organizations that fail to comply with the Payment Card Industry Data Security Standard (PCI DSS)?",
    "choice_a": "Fines",
    "choice_b": "Jail time",
    "choice_c": "Suspension of credit card processing privileges",
    "choice_d": "Subject to increased audit frequency and scope",
    "correct_answer": "B",
    "explanation": "Because PCI DSS is strictly voluntary, and the PCI Council is not a government body but a consortium of private interests, they cannot detain or imprison anyone. <br>They can, however, assess fees, suspend processing privileges, and require more auditing, so the other answers are true and therefore incorrect.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      190,
      461,
      173,
      182,
      208
    ],
    "source": ""
  },
  {
    "id": 539,
    "question": "The Payment Card Industry Data Security Standard (PCI DSS) merchant levels are based on ___________________.",
    "choice_a": "Dollar value of transactions over the course of a year",
    "choice_b": "Number of transactions over the course of a year",
    "choice_c": "Location of the merchant or processor",
    "choice_d": "Dollar value and number of transactions over the course of a year",
    "correct_answer": "B",
    "explanation": "The PCI merchant levels are based on how many transactions a compliant entity engages in over the course of a year. <br>All the other options are incorrect because the dollar value of transactions and location of the merchant or processor are not the criteria used for determining PCI DSS merchant levels. Only the transactions a compliant entity engages in over the course of a year is the correct answer.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      460,
      462,
      461,
      190,
      213
    ],
    "source": ""
  },
  {
    "id": 540,
    "question": "In terms of greatest stringency and requirements for security validation, which is the highest merchant level in the Payment Card Industry (PCI) standard?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "A",
    "explanation": "Merchant level 1 is for the merchants that engage in the most transactions per year (six million or more). It carries with it the requirement for the most comprehensive, detailed, and repeated security validation actions. <br>It may be tempting to choose the highest number when choosing an answer for the highest merchant level. It may be counterintuitive to think that level 1 would be a higher level than a level 4. However, level 1 is the highest merchant level and is the correct answer to this question.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      460,
      473,
      214,
      226,
      7
    ],
    "source": ""
  },
  {
    "id": 541,
    "question": "The Payment Card Industry Data Security Standard (PCI DSS) requires ___________________ security requirements for entities involved in credit card payments and processing.",
    "choice_a": "Technical",
    "choice_b": "Nontechnical",
    "choice_c": "Technical and nontechnical",
    "choice_d": "Neither technical nor nontechnical",
    "correct_answer": "C",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS) requires multiple kinds of technical and nontechnical security requirements (including specific control types) for those entities that choose to subscribe to the standard. <br>Option A is partially correct and partially incorrect. While the security requirements are partially technical, some requirements are also nontechnical. Therefore, option A is incorrect. <br>Option B is also partially correct and partially incorrect. While the security requirements are partially nontechnical, some requirements are technical. Therefore, option B is incorrect. <br>Option C is incorrect because the requirements are technical and nontechnical, not neither technical nor nontechnical.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      210,
      461,
      467,
      473,
      460
    ],
    "source": ""
  },
  {
    "id": 542,
    "question": "According to the Payment Card Industry Data Security Standard (PCI DSS), if a merchant is going to store credit cardholder information for any length of time, what type of security protection <italic>must</italic> be used?",
    "choice_a": "Tokenization or masking",
    "choice_b": "Obfuscation or tokenization",
    "choice_c": "Masking or obfuscation",
    "choice_d": "Tokenization or encryption",
    "correct_answer": "D",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS) allows for cardholder information at rest to be secured with either tokenization or encryption, but use of one is mandatory. <br>The other options are distractors and not dictated by PCI DSS. They can, however, be useful in fulfilling certain credit card support services, such as customer support, where the personnel engaged in the activity (customer support agents, for instance) may need access to a limited set of the cardholder\u2019s account information (for instance, name, mailing address, and date of the payment) but do not have a need to know other elements of that data set (particularly, the full credit card number); masking and obfuscation can satisfy that business need without putting data unduly at risk.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      473,
      461,
      195,
      192,
      199
    ],
    "source": ""
  },
  {
    "id": 543,
    "question": "What element of credit cardholder information may <italic>never</italic> be stored for any length of time, according to the Payment Card Industry Data Security Standard (PCI DSS)?",
    "choice_a": "The full credit card number",
    "choice_b": "The card verification value (CVV)",
    "choice_c": "The cardholder\u2019s mailing address",
    "choice_d": "The cardholder\u2019s full name",
    "correct_answer": "B",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS) disallows the storage of the CVV for any length of time; the CVV may only be used during the payment transaction, and not saved. <br>The other options may be stored for future transactions with the same merchant. However, unlike the CVV they may be stored by the merchant.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      473,
      461,
      462,
      196,
      197
    ],
    "source": ""
  },
  {
    "id": 544,
    "question": "When reviewing IT security products that have been subjected to Common Criteria certification, what does the Evaluation Assurance Level (EAL) tell you?",
    "choice_a": "How secure the product is from an external attack",
    "choice_b": "How thoroughly the product has been tested",
    "choice_c": "The level of security the product delivers to an environment",
    "choice_d": "The level of trustworthiness you can have if you deploy the product",
    "correct_answer": "B",
    "explanation": "The EAL is a measure of how thoroughly the security features the product vendor claims the product offers have been tested and reviewed, and by whom. <br>The EAL does not offer any true measure of how well those security features will work in a production environment so options A and C are incorrect. Whether those features are preferable to other features offered by competing products, or whether the product is \u201cgood.\u201d. Therefore, option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      475,
      476,
      233,
      477,
      463
    ],
    "source": ""
  },
  {
    "id": 545,
    "question": "Which Common Criteria Evaluation Assurance Level (EAL) is granted to those products that are functionally tested by their manufacturer/vendor?",
    "choice_a": "1",
    "choice_b": "3",
    "choice_c": "5",
    "choice_d": "7",
    "correct_answer": "A",
    "explanation": "EAL 1 is for functionally tested products. <br>Option B is incorrect because EAL 3 is for solutions that have been methodically tested and checked. <br>Option C, EAL 5 is incorrect because that is for solutions that have been semi-formally designed and tested. <br>Option D is incorrect because EAL 7 is for solutions that have been formally verified design and tested.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      233,
      476,
      475,
      228,
      219
    ],
    "source": ""
  },
  {
    "id": 546,
    "question": "Which Common Criteria Evaluation Assurance Level (EAL) is granted to those products that are formally verified in terms of design and tested by an independent third party?",
    "choice_a": "1",
    "choice_b": "3",
    "choice_c": "5",
    "choice_d": "7",
    "correct_answer": "D",
    "explanation": "EAL 7 is for those products that have undergone independent third-party testing and verification of security feature design. All other options are distractors and incorrect. <br>EAL 1 is for functionally tested products. <br>EAL 3 is for solutions that have been methodically tested and checked. <br>EAL 5 is for solutions that have been semi-formally designed and tested.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      233,
      476,
      475,
      477,
      145
    ],
    "source": ""
  },
  {
    "id": 547,
    "question": "Who pays for the Common Criteria certification of an IT product?",
    "choice_a": "National Institute of Standards and Technology (NIST)",
    "choice_b": "The vendor/manufacturer",
    "choice_c": "The cloud customer",
    "choice_d": "The end user",
    "correct_answer": "B",
    "explanation": "The vendor/manufacturer of a given product will pay to have it certified, with the premise that certification costs are offset by premium prices that certified products command and that customers won\u2019t purchase uncertified products. <br>NIST does not certify products for Common Criteria. NIST is a U.S. government organization. <br>Option C is incorrect because the cloud customer does not pay to have IT products certified. <br>Option D is incorrect because the end user is an individual and individuals do not pay to have IT products certified. <br>(Note: Of course, the manufacturer/vendor is going to amortize the cost of the certification process across the price of the products they sell, so the customers who purchase the product will eventually \u201cpay\u201d for the certification, but that\u2019s a very oblique and abstract way of reading the question.).",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      233,
      475,
      1,
      7,
      182
    ],
    "source": ""
  },
  {
    "id": 548,
    "question": "Who publishes the list of cryptographic modules validated according to the Federal Information Processing Standard (FIPS) 140-2?",
    "choice_a": "The U.S. Office of Management and Budget (OMB)",
    "choice_b": "The International Standards Organization (ISO)",
    "choice_c": "International Information System Security Certification Consortium, or  ISC2",
    "choice_d": "The National Institute of Standards and Technology (NIST)",
    "correct_answer": "D",
    "explanation": "NIST publishes the list of validated crypto modules. The other choices are government or non-government organizations that are not involved with publishing the list of cryptographic modules that meet FIPS 140-2 requirements.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      233,
      1,
      182,
      197,
      228
    ],
    "source": ""
  },
  {
    "id": 549,
    "question": "Who performs the review process for hardware security modules (HSMs) in accordance with the Federal Information Processing Standard (FIPS) 140-2?",
    "choice_a": "The National Institute of Standards and Technology (NIST)",
    "choice_b": "The National Security Agency (NSA)",
    "choice_c": "Independent (private) laboratories",
    "choice_d": "The European Union Agency for Network and Information Security (ENISA)",
    "correct_answer": "C",
    "explanation": "Vendors seeking HSM certification under FIPS 140-2 send their products to independent laboratories that have been validated as Cryptographic Module Testing Laboratories under the National Voluntary Laboratory Accreditation Program (the Accreditation Program is run by NIST, which approves the laboratories). As of this writing, 21 labs in the United States and Canada are accredited. <br>Option A is incorrect because NIST does not perform the review process. NIST approves the independent laboratories that perform the review process. <br>Option B is incorrect. Of all the activities that the NSA does perform, reviewing the process for Hardware Security Modules in accordance with FIPS 140-2 is certainly not one of them. <br>Option D is incorrect because the ENISA is a European Union organization that supports European Union institutions and stakeholders.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      233,
      228,
      176,
      182,
      197
    ],
    "source": ""
  },
  {
    "id": 550,
    "question": "In terms of the number of security functions offered, which is the highest Federal Information Processing Standard (FIPS) 140-2 security level a cryptographic module can achieve in certification?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "D",
    "explanation": "The highest security level a product can reach is 4. Option A is incorrect because Level 1 is the lowest level of security. Option B is incorrect because Level 2 simply improves upon the physical security of Level 2. Option C is incorrect because Level 3 improves upon Level 2 certification and adds tamper-detection/response capabilities.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      233,
      192,
      208,
      154,
      205
    ],
    "source": ""
  },
  {
    "id": 551,
    "question": "What distinguishes the Federal Information Processing Standard (FIPS) 140-2 security levels for cryptographic modules?",
    "choice_a": "The level of sensitivity of data they can be used to protect",
    "choice_b": "The amount of physical protection provided by the product, in terms of tamper resistance",
    "choice_c": "The size of the IT environment the product can be used to protect",
    "choice_d": "The geographic locations in which the product is allowed",
    "correct_answer": "B",
    "explanation": "The security levels acknowledge different levels of physical protection offered by a crypto module, with 1 offering crypto functionality and no real physical protection and 4 offering tamper-resistant physical features and automatic zeroization of security parameters upon detection of tamper attempts. <br>The question asks what distinguishes the security levels for cryptographic modules. Option A focuses on the sensitivity of the data being protected. The sensitivity of the data that is being protected is important when it comes to the cryptographic module being used, but that is not the distinction between the security levels in FIPS 140-2. <br>Option C is incorrect because the size of the IT environment the cryptographic module is protecting is not what distinguishes the different levels. <br>Option D is not correct because whether the cryptographic module is or is not allowed in a certain geographic location has no bearing on whether or not it works. The cryptographic module either works or it does not, regardless of its location.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      233,
      475,
      210,
      217,
      182
    ],
    "source": ""
  },
  {
    "id": 552,
    "question": "For U.S. government agencies, what level of data sensitivity/classification may be processed by cryptographic modules certified according to the Federal Information Processing Standard (FIPS) 140-2 criteria?",
    "choice_a": "Sensitive but unclassified (SBU)",
    "choice_b": "Secret",
    "choice_c": "Top Secret",
    "choice_d": "Sensitive Compartmentalized Information (SCI)",
    "correct_answer": "A",
    "explanation": "FIPS 140-2 is only for SBU data. Options B, C, and D are incorrect because FIPS 140-2 certifies cryptographic modules for unclassified data. Secret, Top Secret, and Sensitive Compartmentalized Information all are categorized as classified information when it refers to their sensitivity level.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      233,
      192,
      197,
      177,
      182
    ],
    "source": ""
  },
  {
    "id": 553,
    "question": "Who pays for cryptographic modules to be certified in accordance with Federal Information Processing Standard (FIPS) 140-2 criteria?",
    "choice_a": "The U.S. government",
    "choice_b": "Module vendors",
    "choice_c": "Certification laboratories",
    "choice_d": "Module users",
    "correct_answer": "B",
    "explanation": "Vendors who want their products certified under FIPS 140-2 must pay the laboratory that performs the evaluation. <br>Option A is incorrect because the U.S. government is not in the business of paying for cryptographic module certifications. The U.S. government can require the use of cryptographic modules in certain situations. <br>Certification laboratories receive funds for certifying cryptographic modules. They do not pay to have them certified. Therefore, option C is incorrect. <br>Option D is incorrect. Users do not pay to have solutions certified.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      233,
      467,
      197,
      199,
      209
    ],
    "source": ""
  },
  {
    "id": 554,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. What is probably the single <italic>most</italic> important way of countering the highest number of items on the OWASP Top Ten (regardless of year)?",
    "choice_a": "Social engineering training",
    "choice_b": "Disciplined coding practices and processes",
    "choice_c": "White-box source code testing",
    "choice_d": "Physical controls at all locations at which the application is eventually used",
    "correct_answer": "B",
    "explanation": "Most of the items on the Top Ten could be addressed with strong coding practices and by adhering to strict internal management processes (on the part of the organization involved in development). A good number of the items that continually appear on the list, such as injection, cross-site scripting, insecure direct object references, security misconfiguration, missing function-level access control, use of components with known vulnerabilities, and unvalidated redirects and forwards, can all be addressed by basic development practices, such as bounds checking/input validation, code validation/verification protocols, and informed oversight of the project. <br>Strangely, option A is not correct in this case. Social engineering is perhaps the aspect of information security that is least understood (by users) and easiest to exploit, and it is the attack tactic most likely to succeed. Social engineering training could probably reduce the greatest number of overall security threats in our field today. However, this specific question is all about application security, and the element of social engineering is negligible. <br>Option C is not correct because source code testing is only one aspect of code review and would not address as many items on the Top Ten as option B would. <br>Option D is not correct for much the same reason option A is incorrect; this question is specifically about application security, and the physical protection element is very minor.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      23,
      156,
      215,
      223,
      209
    ],
    "source": ""
  },
  {
    "id": 555,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list usually includes \u201cinjection.\u201d In most cases, what is the attacker trying to do with an injection attack?",
    "choice_a": "Get the user to allow access for the attacker.",
    "choice_b": "Insert malware onto the system.",
    "choice_c": "Trick the application into running commands.",
    "choice_d": "Penetrate the facility hosting the software.",
    "correct_answer": "C",
    "explanation": "In injection attacks (a large percentage of which are called SQL injection, for the prevalence with which attackers target databases with this attack), the attacker enters a string of command code into a user-facing field in an attempt to get the application to run the command. This results in a process that the attacker can leverage or puts the software into a fail state that might negate some of the security controls that are present in normal operation. <br>Option A is incorrect; this is a description of social engineering. <br>Option B is incorrect; SQL injection does not typically involve malware. <br>An attack that allows someone to penetrate a facility is a physical attack. The attacker has to physically be at the facility itself. Option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      273,
      21,
      223,
      208,
      227
    ],
    "source": ""
  },
  {
    "id": 556,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list usually includes \u201cinjection.\u201d In most cases, what is the method for reducing the risk of an injection attack?",
    "choice_a": "User training",
    "choice_b": "Hardening the OS",
    "choice_c": "Input validation/bounds checking",
    "choice_d": "Physical locks",
    "correct_answer": "C",
    "explanation": "Attackers attempting injection put command code into a data entry field; if the application has suitable input validation (that is, refusing code strings and confirming that input conforms to field value types), it will block those attacks. <br>Injection attacks target applications, not users, so user training has little to do with preventing injection, making option A incorrect. <br>The OS usually has little to do with injection attacks, which usually target user-facing web apps that ride on the OS, so option B is not correct. <br>Injection attacks are logical, not physical, so locks won\u2019t aid the security effort in this case, making option D incorrect.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      273,
      23,
      223,
      214,
      227
    ],
    "source": ""
  },
  {
    "id": 557,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list often includes \u201cbroken authentication and session management.\u201d Which of the following is a good method for reducing the risk of broken authentication and session management?",
    "choice_a": "Do not use custom authentication schemes.",
    "choice_b": "Implement widespread training programs.",
    "choice_c": "Ensure that strong input validation is in place.",
    "choice_d": "Use X.400 protocol standards.",
    "correct_answer": "A",
    "explanation": "This answer requires a bit of thought and knowledge of common practices. Throughout the IT industry, many developers attempt to design and implement their own authentication schema. According to OWASP, this approach is almost always a bad idea because of the many vulnerabilities such custom schemes may fail to address. Using approved, tested authentication implementations is a way to avoid this problem. <br>Authentication schema should be transparent to users, who will have little or (preferably) no control over that element of communication. Thus, training is not applicable in this case, making option B wrong. <br>Input validation is used to counter injection attacks and has no efficacy in authentication implementations, making option C incorrect. <br>The X.400 standards are for email communication and are not applicable to session authentication; thus, option D is wrong.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      479,
      144,
      223,
      215,
      23
    ],
    "source": ""
  },
  {
    "id": 558,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list often includes \u201cbroken authentication and session management.\u201d Which of the following is <italic>not</italic>  a practice/vulnerability that can lead to broken authentication and infringe on session management?",
    "choice_a": "Session identification exposed in URLs",
    "choice_b": "Unprotected stored credentials",
    "choice_c": "Lack of session timeout",
    "choice_d": "Failure to follow Health Insurance Portability and Accountability Act (HIPAA) guidance",
    "correct_answer": "D",
    "explanation": "HIPAA is the U.S. federal law governing medical information; it has nothing to do with authentication or session management. Failure to follow HIPAA leads to regulatory noncompliance (for those covered by it). <br>All the other options are practices that can enhance an attacker\u2019s ability to compromise authentication implementations and sessions.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      479,
      177,
      182,
      273,
      144
    ],
    "source": ""
  },
  {
    "id": 559,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list often includes \u201cbroken authentication and session management.\u201d Which of the following is <italic>not</italic> a practice/vulnerability that can lead to broken authentication and infringe on session management?",
    "choice_a": "Failure to rotate session IDs after a successful login",
    "choice_b": "Easily guessed authentication credentials",
    "choice_c": "Weak physical entry points in the data center",
    "choice_d": "Credentials sent over unencrypted lines",
    "correct_answer": "C",
    "explanation": "As breaking authentication and session management is a logical attack, lack of physical controls don\u2019t affect such attacks. <br>All the other options are practices that can enhance an attacker\u2019s ability to compromise authentication implementations and sessions.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      479,
      482,
      144,
      149,
      273
    ],
    "source": ""
  },
  {
    "id": 560,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list usually includes \u201ccross-site scripting (XSS).\u201d Which of the following is <italic>not</italic> a method for reducing the risk of XSS attacks?",
    "choice_a": "Put untrusted data in only allowed slots of HTML documents.",
    "choice_b": "HTML escape when including untrusted data in any HTML elements.",
    "choice_c": "Use the attribute <code>escape</code> when including untrusted data in attribute elements.",
    "choice_d": "Encrypt all HTML documents.",
    "correct_answer": "D",
    "explanation": "In many cases, HTML documents are meant to be seen by the public or new users who do not yet have trust associations (accounts) with the organization, so encrypting every HTML document would be counter to the purpose. Moreover, total encryption of everything, even material that is not particularly sensitive or valuable, incurs an additional cost with no appreciable benefit. <br>The other options are all actions that OWASP recommends for reducing the risk of XSS attacks: <code> www.owasp.org/index.php/XSS_(Cross_Site_Scripting)_Prevention_Cheat_Sheet.</code>",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      273,
      223,
      225,
      222,
      215
    ],
    "source": ""
  },
  {
    "id": 561,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list usually includes \u201ccross-site scripting (XSS).\u201d Which of the following is <italic>not</italic> a method for reducing the risk of XSS attacks?",
    "choice_a": "Use an auto-escaping template system.",
    "choice_b": "Use XML escape for all identity assertions.",
    "choice_c": "Sanitize HTML markup with a library designed for the purpose.",
    "choice_d": "HTML escape JSON values in an HTML context and read the data with JSON.parse.",
    "correct_answer": "B",
    "explanation": "Option B is incorrect because the answer narrows the risk for only the identity assertions and does not address XSS attack risks. All the other options are actions recommended by OWASP for reducing XSS attack risks. <br>This question is particularly difficult as it delves into a level of detail that may or may not appear on the actual exam; however, all source documents listed in the <italic>Candidate Information Bulletin</italic> , including the OWASP Top Ten, are fair game for the test, so it is best to have at least an understanding of these sources.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      273,
      223,
      222,
      216,
      215
    ],
    "source": ""
  },
  {
    "id": 562,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list often includes \u201cinsecure direct object references.\u201d Which of these is an example of an insecure direct object reference?",
    "choice_a": "<code> www.sybex.com/authoraccounts/benmalisow </code>",
    "choice_b": "<code> 10 ? \"sybex accounts\"; 20 goto 10 </code>",
    "choice_c": "<code> mysql -u [bmalisow] -p [database1]; </code>",
    "choice_d": "<code> bmalisow@sybex.com </code>",
    "correct_answer": "A",
    "explanation": "The URL in option A reveals a location of specific data as well as the format for potential other data (such as other authors\u2019 pages/accounts); this is a classic example of an insecure direct object reference. <br>Option B is a DoS program string; C is a SQL database command line (which wouldn\u2019t reveal any information on its own; it would prompt for a password); and option D is just an email address.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      273,
      198,
      208,
      23,
      182
    ],
    "source": ""
  },
  {
    "id": 563,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list often includes \u201cinsecure direct object references.\u201d Which of these is a method to counter the risks of insecure direct object references?",
    "choice_a": "Perform user security training.",
    "choice_b": "Check access each time a direct object reference is called by an untrusted source.",
    "choice_c": "Install high-luminosity interior lighting throughout the facility.",
    "choice_d": "Append each object with sufficient metadata to properly categorize and classify based on asset value and sensitivity.",
    "correct_answer": "B",
    "explanation": "Untrusted sources calling a direct reference should be authenticated to ensure that the source has authorization to access that object. <br>Option A will not aid in insecure direct object risks; this is not a user issue, usually, but a programming issue. Option C is for physical security, while insecure direct object references are logical attacks. Option D does not reduce the risk of insecure direct object references because classification and categorization are not protections themselves but need to be paired with proper control sets in order to provide protection.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      140,
      215,
      223,
      225,
      208
    ],
    "source": ""
  },
  {
    "id": 564,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list often includes \u201csecurity misconfiguration.\u201d Which of these is an example of a security misconfiguration?",
    "choice_a": "Not providing encryption keys to untrusted users",
    "choice_b": "Having a public-facing website",
    "choice_c": "Leaving default accounts unchanged",
    "choice_d": "Using turnstiles instead of mantraps",
    "correct_answer": "C",
    "explanation": "Default accounts are a continual security problem in the InfoSec space, and one that is relatively easy to address. Any new systems should be checked for default accounts, which should be stripped out before deployment. <br>Untrusted users should not have encryption keys, so this is not a misconfiguration; therefore, option A is incorrect. <br>A public-facing website can be extremely useful for marketing purposes and is not necessarily a security issue in and of itself, so option B is incorrect. <br>Option D might or might not be true; both turnstiles and mantraps are physical security controls, and we can\u2019t be sure whether one or the other is preferable in any given situation, so we don\u2019t know if this is a misconfiguration or a proper configuration. Option C is therefore preferable.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      244,
      245,
      208,
      223,
      155
    ],
    "source": ""
  },
  {
    "id": 565,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list often includes \u201csecurity misconfiguration.\u201d Which of these is an example of a security misconfiguration?",
    "choice_a": "Having unpatched software in the production environment",
    "choice_b": "Leaving unprotected portable media in the workplace",
    "choice_c": "Letting data owners determine the classifications/categorizations of their data",
    "choice_d": "Preventing users from accessing untrusted networks",
    "correct_answer": "A",
    "explanation": "Any software with out-of-date builds can be considered misconfigured. <br>Option B is bad security practice but not considered a misconfiguration. <br>Data owners are supposed to classify/categorize the data under their control, so option C is not a correct answer. <br>Preventing users from reaching untrusted resources may be a proper control in a given environment, so option D is not a misconfiguration, and not a correct answer.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      208,
      273,
      223,
      227,
      155
    ],
    "source": ""
  },
  {
    "id": 566,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list often includes \u201csecurity misconfiguration.\u201d Which of these is a technique to reduce the potential for a security misconfiguration?",
    "choice_a": "Enforce strong user access control processes.",
    "choice_b": "Have a repeatable hardening process for all systems/software.",
    "choice_c": "Use encryption for all remote access.",
    "choice_d": "Use encryption for all stored data.",
    "correct_answer": "B",
    "explanation": "This question requires some thought. All the options are examples of good security practices and could therefore arguably be ways to reduce misconfiguration risks. However, option B is the best answer for this specific question: it is a method for reducing risks due to misconfiguration\u2014a repeatable process for hardening systems/software that addresses other bad practices and is itself a good practice. This is the best answer.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      246,
      208,
      223,
      155,
      212
    ],
    "source": ""
  },
  {
    "id": 567,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list usually includes \u201csecurity misconfiguration.\u201d Which of these is a technique to reduce the potential for a security misconfiguration?",
    "choice_a": "Broad user training that includes initial, recurring, and refresher sessions",
    "choice_b": "Deeper personnel screening procedures for privileged users than is used for regular users",
    "choice_c": "A repeatable patching process that includes updating libraries as well as software",
    "choice_d": "Randomly auditing all user activity, with additional focus on privileged users",
    "correct_answer": "C",
    "explanation": "All the options are examples of good security practices and could therefore arguably be ways to reduce misconfiguration risks. However, option C is the best answer for this specific question. The other three options are <br></br>personnel/administrative/managerial controls, where the security misconfiguration is more a technical issue, which requires a technical solution.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      273,
      208,
      223,
      212,
      149
    ],
    "source": ""
  },
  {
    "id": 568,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list usually includes \u201csecurity misconfiguration.\u201d Which of these is a technique to reduce the potential for a security misconfiguration?",
    "choice_a": "Purchase only trusted devices/components.",
    "choice_b": "Follow a published, known industry standard for baseline configurations.",
    "choice_c": "Hire only screened, vetted candidates for all positions.",
    "choice_d": "Update policy on a regular basis, according to a proven process.",
    "correct_answer": "B",
    "explanation": "All the options are examples of good security practices and could therefore arguably be ways to reduce misconfiguration risks. However, option B is the best answer for this specific question. The other three options are <br></br>personnel/administrative/managerial controls, where the security misconfiguration is more a technical issue, which requires a technical solution.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      273,
      208,
      223,
      212,
      149
    ],
    "source": ""
  },
  {
    "id": 569,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list usually includes \u201csecurity misconfiguration.\u201d Which of these is a technique to reduce the potential for a security misconfiguration?",
    "choice_a": "Get regulatory approval for major configuration modifications.",
    "choice_b": "Update the business continuity and disaster recovery (BC/DR) plan on a timely basis.",
    "choice_c": "Train all users on proper security procedures.",
    "choice_d": "Perform periodic scans and audits of the environment.",
    "correct_answer": "D",
    "explanation": "All of these are good security practices, but only option D is a method for detecting and addressing misconfigurations.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      149,
      221,
      208,
      223,
      155
    ],
    "source": ""
  },
  {
    "id": 570,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list often includes \u201csensitive data exposure.\u201d Which of these is a technique to reduce the potential for a sensitive data exposure?",
    "choice_a": "Extensive user training on proper data handling techniques",
    "choice_b": "Advanced firewalls inspecting all inbound traffic, to include content-based screening",
    "choice_c": "Ensuring the use of utility backup power supplies",
    "choice_d": "Roving security guards",
    "correct_answer": "A",
    "explanation": "Users are the most likely source of sensitive data exposure, particularly inadvertently. Ensuring that users know how to handle material properly is an excellent means for addressing the issue. <br>Option B is incorrect because firewalls that inspect inbound traffic only will not notice data exposed accidentally or maliciously as it travels outbound. <br>Option C is incorrect because it has nothing to do with data disclosure and is instead about business continuity and disaster recovery (BC/DR). <br>Option D is incorrect because it has nothing to do with data disclosure and is instead about physical security.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      196,
      473,
      223,
      149,
      182
    ],
    "source": ""
  },
  {
    "id": 571,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list often includes \u201csensitive data exposure.\u201d All of the following are techniques for reducing the possibility of exposing sensitive data, <italic>except</italic>  ________.",
    "choice_a": "Destroying sensitive data as soon as possible",
    "choice_b": "Avoiding categorizing data as sensitive",
    "choice_c": "Using proper key management when encrypting sensitive data",
    "choice_d": "Disabling autocomplete on forms that collect sensitive data",
    "correct_answer": "B",
    "explanation": "Data needs to be categorized according to its value/sensitivity; avoiding accurate categorization is just as troublesome, from a security perspective, as not categorizing the data or overcategorizing it (putting it in a higher category than it deserves). <br>All the other options are ways of reducing the risk of sensitive data disclosure. Option A reduces the possibility of disclosure by reducing the amount of data on hand (from the OWASP: \u201cData you don\u2019t have can\u2019t be stolen\u201d). Option C reduces the chance of disclosing keys, which leads to disclosing the data. Option D reduces the possibility that the form will disclose sensitive data to someone filling it out by prompting with an entry that should be protected.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      473,
      225,
      226,
      219,
      217
    ],
    "source": ""
  },
  {
    "id": 572,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list sometimes includes \u201cmissing function level access control.\u201d Which of these is a technique to reduce the potential for a missing function-level access control?",
    "choice_a": "Set the default to deny all access to functions, and require authentication/authorization for each access request.",
    "choice_b": "HTML escape all HTML attributes.",
    "choice_c": "Restrict permissions based on an access control list (ACL).",
    "choice_d": "Refrain from including direct access information in URLs.",
    "correct_answer": "A",
    "explanation": "Setting the default to denying access forces all resource requests to be verified, thus ensuring that no particular function may be run without explicitly ensuring that it was called by an authorized user. <br>Option B is used to deter cross-site scripting attacks, so it is incorrect. <br>Option C is correct but insufficient; option A includes a more restrictive mode, so is therefore a better choice. <br>Option D is used to deter the possibility of insecure direct object references, so it is incorrect.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      206,
      273,
      223,
      208,
      149
    ],
    "source": ""
  },
  {
    "id": 573,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list sometimes includes \u201cmissing function level access control.\u201d Which of these is a technique to reduce the potential for a missing function-level access control?",
    "choice_a": "Run a process as both user and privileged user, compare results, and determine similarity.",
    "choice_b": "Run automated monitoring and audit scripts.",
    "choice_c": "Include browser buttons/navigation elements to secure functions.",
    "choice_d": "Enhance user training to include management personnel.",
    "correct_answer": "A",
    "explanation": "The method in option A will help you determine if there are functions that regular users should not have access to and thereby demonstrate that you are missing necessary controls. <br>According to the OWASP, \u201cautomated tools are unlikely to find these problems,\u201d so option B is incorrect. <br>Option C is incorrect because it is the exact opposite of what you\u2019re trying to accomplish; this is an example of what happens when function-level access controls are missing. <br>Option D in no way addresses the problem of missing function-level access controls, which is a technical problem, not a user issue.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      481,
      480,
      206,
      471,
      456
    ],
    "source": ""
  },
  {
    "id": 574,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list often includes \u201ccross-site request forgery\u201d (CSRF). Which of these is a technique to reduce the potential for a CSRF?",
    "choice_a": "Train users to detect forged HTTP requests.",
    "choice_b": "Have users remove all browsers from their devices.",
    "choice_c": "Don\u2019t allow links to or from other websites.",
    "choice_d": "Include a CAPTCHA code as part of the user resource request process.",
    "correct_answer": "D",
    "explanation": "Having the user authenticate the intentional request is a way to reduce the automated, forged requests attackers might submit as part of CSRF; CAPTCHA is a great way to reduce the likelihood of success for automated attacks. <br>Option A is incorrect because HTTP requests are usually made by the browser, without the user\u2019s knowledge; the user has no perspective of such requests, so this wouldn\u2019t be a useful mechanism in prevention. <br>Option B is incorrect because it\u2019s unrealistic. Removing all browsers would decrease the utility of the systems to the point where productivity would be negligible. <br>Option C is incorrect for similar reasons; the danger from CSRF is not because of links to the target website but because of the browser behavior.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      273,
      223,
      215,
      208,
      219
    ],
    "source": ""
  },
  {
    "id": 575,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list often includes \u201ccross-site request forgery\u201d (CSRF). A CSRF attack might be used for all the following malicious actions <italic>except</italic> ___________________.",
    "choice_a": "The attacker could have the user log into one of the user\u2019s online accounts.",
    "choice_b": "The attacker could collect the user\u2019s online account login credentials, to be used by the attacker later.",
    "choice_c": "The attacker could have the user perform an action in one of the user\u2019s online accounts.",
    "choice_d": "The attacker could trick the user into calling a fraudulent customer service number hosted by the attacker and talk the user into disclosing personal information.",
    "correct_answer": "D",
    "explanation": "This is a description of social engineering, not CSRF, which is a browser-based attack. <br> All the other options are possible exploits an attacker might try to accomplish with a CSRF attack.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      273,
      215,
      223,
      208,
      149
    ],
    "source": ""
  },
  {
    "id": 576,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list often includes \u201ccross-site request forgery\u201d (CSRF). Which of the following is a good way to deter CSRF attacks?",
    "choice_a": "Have your website refuse all HTTP resource requests.",
    "choice_b": "Ensure that all HTTP resource requests include a unique, unpredictable token.",
    "choice_c": "Don\u2019t allow e-commerce on your website.",
    "choice_d": "Process all user requests with only one brand of browser, and refuse all resource requests from other browsers.",
    "correct_answer": "B",
    "explanation": "This is the option OWASP recommends as the very least form of protection. Having a unique, unpredictable token for each session reduces the likelihood an attacker will be able to reuse tokens known by the browser or craft tokens that can be used in future attacks. <br>Option A is not optimal or sensible because it would inhibit all web traffic and remote access. <br>Option C is not optimal or sensible because it would severely limit your online capabilities. <br>Option D is not sensible because all browsers use stored tokens/cookies, and no browser is preferable for the purpose over others.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      273,
      223,
      226,
      219,
      149
    ],
    "source": ""
  },
  {
    "id": 577,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list often includes \u201cusing components with known vulnerabilities.\u201d Which of the following is a good way to protect against this problem?",
    "choice_a": "Use only components your organization has written.",
    "choice_b": "Update to current versions of component libraries as soon as possible.",
    "choice_c": "Never use anyone else\u2019s component library.",
    "choice_d": "Apply patches to old component libraries.",
    "correct_answer": "B",
    "explanation": "This is not an easy question and requires an understanding of how component libraries are used in software design. <br>Option B is preferable to the others because, according to the OWASP, publishers of component libraries do not often patch old components but rather issue the fixed component(s) as a new version. This is also why option D is incorrect. <br>Options A and C are two ways of stating the same thing, and not optimal; trying to use this method would require every one of your software packages to be wholly written by your programmers, which is actually not more secure than using published component libraries because the risk of additional human error and lack of review is introduced to the process.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      227,
      223,
      216,
      222,
      225
    ],
    "source": ""
  },
  {
    "id": 578,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list often includes \u201cusing components with known vulnerabilities.\u201d Why would an organization ever use components with known vulnerabilities to create software?",
    "choice_a": "The organization is insured.",
    "choice_b": "The particular vulnerabilities exist only in a context not being used by developers.",
    "choice_c": "Some vulnerabilities exist only in foreign countries.",
    "choice_d": "A component might have a hidden vulnerability.",
    "correct_answer": "B",
    "explanation": "This is not an easy question and requires an understanding of how component libraries are used in software design. <br>Option B makes the most sense; some vulnerabilities are known to exist only when a component is used in a specific way or with specific services; if the programmers are not including that way of using the component or the risky service, then the vulnerability would not pose a threat to the software they are creating and may therefore be acceptable. <br>Option A is not correct because an underwriter would be unlikely to cover a claim resulting solely from negligence; using a component with a known vulnerability and putting the product/user at risk knowingly would probably invalidate any insurance policy. <br>Option C might conceivably be considered correct in a fashion; different countries have different legislation/regulations, and a vulnerability that could cause noncompliance in one country might not in another. However, this is a rather tortured reading of the question, requiring some convoluted reasoning, and this option is therefore not the best answer. <br>Option D is not correct because a hidden vulnerability, by definition, is not a known vulnerability.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      223,
      215,
      227,
      217,
      219
    ],
    "source": ""
  },
  {
    "id": 579,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list often includes \u201cusing components with known vulnerabilities.\u201d Which of the following is a good way to protect against this problem?",
    "choice_a": "Use only standard libraries.",
    "choice_b": "Review all updates/lists/notifications for components your organization uses.",
    "choice_c": "Be sure to HTML escape all attribute elements.",
    "choice_d": "Increase the user training budget.",
    "correct_answer": "B",
    "explanation": "Staying current with published vulnerabilities for your component is crucial. This might not be simple as there are many versions of design components and nomenclature is not always uniform. <br>Option A is incorrect because even standard libraries are subject to vulnerabilities, so you have to review notifications about those as well. <br>Option C is not correct; this is a method for reducing the risk of cross-site scripting (XSS) attacks. <br>Option D will not work as users have no influence or effect on which components are used in software design.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      221,
      227,
      223,
      215,
      226
    ],
    "source": ""
  },
  {
    "id": 580,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list sometimes includes \u201cunvalidated redirects and forwards.\u201d Which of the following is a good way to protect against this problem?",
    "choice_a": "HTML escape all HTML attributes.",
    "choice_b": "Train users to recognize invalidated links.",
    "choice_c": "Block all inbound resource requests.",
    "choice_d": "Implement audit logging.",
    "correct_answer": "B",
    "explanation": "Oddly enough, this may be a good topic to explain during user training; when an attacker is trying to conduct an attack by exploiting unvalidated redirects and forwards, it is often in conjunction with a social engineering/phishing aspect. Users trained to recognize social engineering/phishing indicators might be able to avoid susceptibility to these attacks. <br>Option A is not correct; this is a method for reducing the risk of cross-site scripting (XSS) attacks. <br>Option C is not correct; it is ridiculous and would result in preventing all remote access. <br>Option D is not correct; audit logging would only track activity, not prevent a user from being directed/forwarded to an attack site.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      223,
      219,
      222,
      208,
      149
    ],
    "source": ""
  },
  {
    "id": 581,
    "question": "The Open Web Application Security Project (OWASP) Top Ten is a list of web application security threats that is created by a member-driven OWASP committee of application development experts and published approximately every 24 months. The OWASP Top Ten list often includes \u201cunvalidated redirects and forwards.\u201d Which of the following is a good way to protect against this problem?",
    "choice_a": "Don\u2019t use redirects/forwards in your applications.",
    "choice_b": "Refrain from storing credentials long term.",
    "choice_c": "Implement security incident/event monitoring (security information and event management [SIEM]/security information management [SIM]/security event management [SEM]) solutions.",
    "choice_d": "Implement digital rights management (DRM) solutions.",
    "correct_answer": "A",
    "explanation": "Basic as it may seem, not including redirects and forwards within your software is an easy way to avoid the problem altogether, and redirects/forwards are not necessary for efficient usage. <br>Option B is incorrect because this type of attack is not aimed at stored credentials. <br>Options C and D are both incorrect because neither of those types of solutions detect or prevent this type of attack.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      223,
      215,
      216,
      273,
      227
    ],
    "source": ""
  },
  {
    "id": 582,
    "question": "You are the security subject matter expert (SME) for an organization considering a transition from a traditional IT enterprise environment into a hosted cloud provider\u2019s data center. One of the challenges you\u2019re facing is whether your current applications in the on-premises environment will function properly with the provider\u2019s hosted systems and tools. This is a(n) ___________________ issue.",
    "choice_a": "Interoperability",
    "choice_b": "Portability",
    "choice_c": "Stability",
    "choice_d": "Security",
    "correct_answer": "A",
    "explanation": "This is the definition of cloud migration interoperability challenges. Portability is the measure of how difficult it might be to move the organization\u2019s systems/data from a given cloud host to another cloud host. Stability has no specific meaning here and is just a distractor. Security might be an element of this challenge but is not the optimum answer; the question posed a concern about functionality, not disclosure or tainting the information.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      18,
      1,
      8,
      7,
      5
    ],
    "source": ""
  },
  {
    "id": 583,
    "question": "You are the security subject matter expert (SME) for an organization considering a transition from a traditional IT enterprise environment into a hosted cloud provider\u2019s data center. One of the challenges you\u2019re facing is whether the provider will have undue control over your data once it is within the provider\u2019s data center; will the provider be able to hold your organization hostage because they have your data? This is a(n) ___________________ issue.",
    "choice_a": "Interoperability",
    "choice_b": "Portability",
    "choice_c": "Stability",
    "choice_d": "Security",
    "correct_answer": "B",
    "explanation": "This is the definition of cloud migration portability, the measure of how difficult it might be to move the organization\u2019s systems/data from a given cloud host to another cloud host. Interoperability issues involve whether the cloud customer\u2019s legacy services/data will interface properly with the provider\u2019s systems. Stability has no specific meaning here and is just a distractor. Security might be an element of this challenge, but it is not the optimum answer; the question posed a concern about functionality, not disclosure or tainting the information.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      18,
      170,
      185,
      7,
      136
    ],
    "source": ""
  },
  {
    "id": 584,
    "question": "You are the security subject matter expert (SME) for an organization considering a transition from a traditional IT enterprise environment into a hosted cloud provider\u2019s data center. One of the challenges you\u2019re facing is whether the cloud provider will be able to comply with the existing legislative and contractual frameworks your organization is required to follow. This is a ___________________ issue.",
    "choice_a": "Resiliency",
    "choice_b": "Privacy",
    "choice_c": "Performance",
    "choice_d": "Regulatory",
    "correct_answer": "D",
    "explanation": "This is the definition of a regulatory issue. Option B might also be a factor in this kind of issue, but because the subject of privacy or any specific related topic (such as personally identifiable information [PII], the European Union General Data Protection Regulation) was not mentioned, option D is the better answer. Resiliency issues involve the provider\u2019s ability to handle disruptive externalities, such as natural disasters, system failures, and utility outages. Performance issues address the ability of the provider to meet the customer\u2019s IT needs.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      172,
      182,
      170,
      168,
      233
    ],
    "source": ""
  },
  {
    "id": 585,
    "question": "You are the security subject matter expert (SME) for an organization considering a transition from a traditional IT enterprise environment into a hosted cloud provider\u2019s data center. One of the challenges you\u2019re facing is whether the cloud provider will be able to allow your organization to substantiate and determine with some assurance that all of the contract terms are being met. This is a(n) ___________________ issue.",
    "choice_a": "Regulatory",
    "choice_b": "Privacy",
    "choice_c": "Resiliency",
    "choice_d": "Auditability",
    "correct_answer": "D",
    "explanation": "This is not an easy question. In the context of the question, the cloud customer is trying to ascertain whether they are getting what they\u2019re paying for; that is, a way for them to audit the cloud provider and the service as a whole. This is not a regulatory issue, as it concerns the contractual agreement between the provider and the customer, not a third party performing oversight. It is also not a privacy issue (primarily; privacy concerns might be part of the contract, but it\u2019s not the prevailing aspect of the issue here). Resiliency issues involve the provider\u2019s ability to handle disruptive externalities, such as natural disasters, system failures, or utility outages.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      204,
      170,
      158,
      13,
      147
    ],
    "source": ""
  },
  {
    "id": 586,
    "question": "Encryption is an essential tool for affording security to cloud-based operations. While it is possible to encrypt every system, piece of data, and transaction that takes place on the cloud, why might that not be the optimum choice for an organization?",
    "choice_a": "Key length variances don\u2019t provide any actual additional security.",
    "choice_b": "It would cause additional processing overhead and time delay.",
    "choice_c": "It might result in vendor lockout.",
    "choice_d": "The data subjects might be upset by this.",
    "correct_answer": "B",
    "explanation": "Encryption consumes processing power and time; as with all security controls, additional security means measurably less operational capability\u2014there is always a trade-off between security and productivity. <br>Option A is gibberish and only a distractor. <br>Option C is incorrect because vendor lockout does not result from encryption; it is what might happen if the cloud provider goes out of business while holding your data. <br>Data subjects are the individuals whose personally identifiable information (PII) an organization holds; usually, they will not know or care if something is encrypted (unless there is a breach of that PII, and then investigators will want to determine how that PII was protected) and would probably welcome total encryption, even though that might mean a decrease in operational capability.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      223,
      4,
      217,
      226,
      5
    ],
    "source": ""
  },
  {
    "id": 587,
    "question": "Encryption is an essential tool for affording security to cloud-based operations. While it is possible to encrypt every system, piece of data, and transaction that takes place on the cloud, why might that not be the optimum choice for an organization?",
    "choice_a": "It could increase the possibility of physical theft.",
    "choice_b": "Encryption won\u2019t work throughout the environment.",
    "choice_c": "The protection might be disproportionate to the value of the asset(s).",
    "choice_d": "Users will be able to see everything within the organization.",
    "correct_answer": "C",
    "explanation": "Security should be commensurate with asset value, as determined by management; putting extra security on everything in an environment is usually not cost effective. The other options don\u2019t make sense. For example, encryption doesn\u2019t affect the potential for physical theft, encryption can be implemented organization-wide, and access controls can be placed on encrypted information as well as unencrypted.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      218,
      228,
      217,
      224,
      422
    ],
    "source": ""
  },
  {
    "id": 588,
    "question": "Which of the following is <italic>not</italic> an element of the identification component of identity and access management (IAM)?",
    "choice_a": "Provisioning",
    "choice_b": "Management",
    "choice_c": "Discretion",
    "choice_d": "Deprovisioning",
    "correct_answer": "C",
    "explanation": "Discretion is not an element of identification and has no meaning in this context. All the other options are aspects of the identification portion of IAM.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      479,
      478,
      480,
      491,
      492
    ],
    "source": ""
  },
  {
    "id": 589,
    "question": "Which of the following entities is <italic>most</italic> likely to play a vital role in the identity provisioning aspect of a user\u2019s experience in an organization?",
    "choice_a": "The accounting department",
    "choice_b": "The human resources (HR) office",
    "choice_c": "The maintenance team",
    "choice_d": "The purchasing office",
    "correct_answer": "B",
    "explanation": "Of these options, HR is most likely to participate in identity provisioning; HR will usually validate the user\u2019s identity against some documentation (driver\u2019s license, passport, etc.) as part of the user\u2019s initial employment process and then pass confirmation of validation along to whatever entity issues system sign-on credentials. None of the other entities usually takes part in user identification.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      478,
      480,
      490,
      488,
      155
    ],
    "source": ""
  },
  {
    "id": 590,
    "question": "Why is the deprovisioning element of the identification component of identity and access management (IAM) so important?",
    "choice_a": "Extra accounts cost so much extra money.",
    "choice_b": "Open but unassigned accounts are vulnerabilities.",
    "choice_c": "User tracking is essential to performance.",
    "choice_d": "Encryption has to be maintained.",
    "correct_answer": "B",
    "explanation": "Unused accounts that remain open can serve as attack vectors. All the other options are not associated with identity and access management.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      478,
      479,
      489,
      481,
      245
    ],
    "source": ""
  },
  {
    "id": 591,
    "question": "All of the following are reasons to perform review and maintenance actions on user accounts <italic>except</italic> ___________________.",
    "choice_a": "To determine whether the user still needs the same access",
    "choice_b": "To determine whether the user is still with the organization",
    "choice_c": "To determine whether the data set is still applicable to the user\u2019s role",
    "choice_d": "To determine whether the user is still performing well",
    "correct_answer": "D",
    "explanation": "Job performance is not a germane aspect of account review and maintenance; that is a management concern, not an access control issue. All the other options are legitimate access control concerns.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      487,
      488,
      489,
      481,
      480
    ],
    "source": ""
  },
  {
    "id": 592,
    "question": "Who should be involved in review and maintenance of user accounts/access?",
    "choice_a": "The user\u2019s manager",
    "choice_b": "The security manager",
    "choice_c": "The accounting department",
    "choice_d": "The incident response team",
    "correct_answer": "A",
    "explanation": "This is not an easy question. The best answer to the question does not appear on the list; that would be the data owner, because the data owner should be the ultimate arbiter of who has what access to the data under the owner\u2019s control. However, of these options, A is the best; the user\u2019s manager will have the greatest amount of insight into the role of the user within the organization and therefore will understand best which data the user needs to access. The security manager does not have this insight, and the task of reviewing all access for all users within the organization would be far too large an undertaking for that position. Accounting and incident response play no part in reviewing ongoing user account applicability.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      488,
      487,
      481,
      214,
      221
    ],
    "source": ""
  },
  {
    "id": 593,
    "question": "Which of the following protocols is <italic>most</italic> applicable to the identification process aspect of identity and access management (IAM)?",
    "choice_a": "Secure Sockets Layer (SSL)",
    "choice_b": "Internet Protocol Security (IPSec)",
    "choice_c": "Lightweight Directory Access Protocol (LDAP)",
    "choice_d": "Amorphous ancillary data transmission (AADT)",
    "correct_answer": "C",
    "explanation": "LDAP is used in constructing and maintaining centralized directory services, which are vital in all aspects of IAM. SSL and IPSec are used to create secure communication sessions\u2014important, but not most applicable for IAM. AADT is a fictitious term used as a distractor.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      490,
      492,
      491,
      479,
      478
    ],
    "source": ""
  },
  {
    "id": 594,
    "question": "Privileged user (administrators, managers, and so forth) accounts need to be reviewed more closely than basic user accounts. Why is this?",
    "choice_a": "Privileged users have more encryption keys.",
    "choice_b": "Regular users are more trustworthy.",
    "choice_c": "There are extra controls on privileged user accounts.",
    "choice_d": "Privileged users can cause more damage to the organization.",
    "correct_answer": "D",
    "explanation": "The additional capabilities of privileged users make their activities riskier to the organization, so these accounts bear extra review. The number of encryption keys a user has is meaningless out of context; the amount of risk is the issue, not the number of keys. The user\u2019s type (regular versus privileged) is not an indicator, itself, of trustworthiness. Additional review activity for privileged users is an extra control we place on privileged users, not a reason for doing so.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      487,
      481,
      488,
      215,
      217
    ],
    "source": ""
  },
  {
    "id": 595,
    "question": "The additional review activities that might be performed for privileged user accounts could include all of the following <italic>except</italic> ___________________ .",
    "choice_a": "Deeper personnel background checks",
    "choice_b": "Review of personal financial accounts for privileged users",
    "choice_c": "More frequent reviews of the necessity for access",
    "choice_d": "Pat-down checks of privileged users to deter against physical theft",
    "correct_answer": "D",
    "explanation": "The efficacy of frisking administrators and managers is doubtful, and the harm to morale and disparity of enforcement likely outweighs any security benefit. All the other options could and should be included in privileged account review.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      482,
      481,
      487,
      484,
      488
    ],
    "source": ""
  },
  {
    "id": 596,
    "question": "If personal financial account reviews are performed as an additional review control for privileged users, which of the following characteristics is <italic>least</italic> likely to be a useful indicator for review purposes?",
    "choice_a": "Too much money in the account",
    "choice_b": "Too little money in the account",
    "choice_c": "The bank branch being used by the privileged user",
    "choice_d": "Specific senders/recipients",
    "correct_answer": "C",
    "explanation": "Which bank branch a privileged user frequents is unlikely to be of consequence. Too much money can indicate that the privileged user is accepting payment from someone other than the employer, which can be an indicator of malfeasance or corruption. Too little money can indicate that the privileged user is subject to undue financial stress, which might be the result of behavior that makes the privileged user susceptible to subversion, such as a drug habit, family problems, or excess gambling. Specific senders and recipients of personal funds can indicate untoward activity on the part of the privileged user.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      484,
      486,
      481,
      487,
      482
    ],
    "source": ""
  },
  {
    "id": 597,
    "question": "How often should the accounts of privileged users be reviewed?",
    "choice_a": "Annually",
    "choice_b": "Twice a year",
    "choice_c": "Monthly",
    "choice_d": "More often than regular user account reviews",
    "correct_answer": "D",
    "explanation": "There is no specific rule for the timeliness of privileged user account reviews. However, as a matter of course, privileged user accounts should be reviewed more often than the accounts of regular users because privileged users can cause more damage and therefore entail more risk.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      487,
      488,
      489,
      481,
      217
    ],
    "source": ""
  },
  {
    "id": 598,
    "question": "Privileged user account access should be ___________________.",
    "choice_a": "Temporary",
    "choice_b": "Pervasive",
    "choice_c": "Thorough",
    "choice_d": "Granular",
    "correct_answer": "A",
    "explanation": "Privileged users should have privileged access to specific systems/data only for the duration necessary to perform their administrative function; any longer incurs more risk than value. The other options are not associated with appropriate privilege access management.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      481,
      487,
      489,
      480,
      488
    ],
    "source": ""
  },
  {
    "id": 599,
    "question": "The Cloud Security Alliance (CSA) publishes the Notorious Nine, a list of common threats to organizations participating in cloud computing. According to the CSA\u2019s Notorious Nine list, data breaches can be ___________________.",
    "choice_a": "Overt or covert",
    "choice_b": "International or subterranean",
    "choice_c": "From internal or external sources",
    "choice_d": "Voluminous or specific",
    "correct_answer": "C",
    "explanation": "The CSA points out that data breaches come from a variety of sources, including both internal personnel and external actors. Although breaches might be overt or covert, or large or small, we don\u2019t usually think of them in these terms, and the CSA doesn\u2019t discuss them that way, so options A and D aren\u2019t correct. Option B is incorrect because subterranean is not associated with the CSA\u2019s Notorious Nine list of common threats.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      216,
      181,
      175,
      182,
      171
    ],
    "source": ""
  },
  {
    "id": 600,
    "question": "The Cloud Security Alliance (CSA) publishes the Notorious Nine, a list of common threats to organizations participating in cloud computing. According to the CSA, an organization that operates in the cloud environment and suffers a data breach may be required to ___________________.",
    "choice_a": "Notify affected users",
    "choice_b": "Reapply for cloud service",
    "choice_c": "Scrub all affected physical memory",
    "choice_d": "Change regulatory frameworks",
    "correct_answer": "A",
    "explanation": "Data breach notification laws are plentiful; organizations operating in the cloud are almost sure to be subject to one or more such laws. <br>Option B is incorrect because the CSA does not suggest that an organization that operates in the cloud environment and suffers a data breach may be required to reapply for cloud service. <br>Option C is unlikely because most cloud customers won\u2019t have physical access to/control of devices; moreover, a breach does not always entail sanitization. <br>Option D does not make sense, either; regulations are imposed on organizations, as legal mandates, and an organization does not get to choose which regulations affect it.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      181,
      178,
      182,
      234,
      172
    ],
    "source": ""
  },
  {
    "id": 601,
    "question": "The Cloud Security Alliance (CSA) publishes the Notorious Nine, a list of common threats to organizations participating in cloud computing. According to the CSA, an organization that suffers a data breach might suffer all of the following negative effects <italic>except</italic> ___________________.",
    "choice_a": "Cost of compliance with notification laws",
    "choice_b": "Loss of public perception/goodwill",
    "choice_c": "Loss of market share",
    "choice_d": "Cost of detection",
    "correct_answer": "D",
    "explanation": "The cost of detection exists whether or not the organization suffers a breach. All other options are costs an organization will likely face as the result of a breach.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      175,
      173,
      181,
      178,
      224
    ],
    "source": ""
  },
  {
    "id": 602,
    "question": "The Cloud Security Alliance (CSA) publishes the Notorious Nine, a list of common threats to organizations participating in cloud computing. According to the CSA, in the event of a data breach, a cloud customer will likely need to comply with all the following data breach notification requirements <italic>except</italic> ___________________.",
    "choice_a": "Multiple state laws",
    "choice_b": "Contractual notification requirements",
    "choice_c": "All standards-based notification schemes",
    "choice_d": "Any applicable federal regulations",
    "correct_answer": "C",
    "explanation": "This question requires a bit of thought. Option C is correct because an organization is not required to subscribe to all standards but instead only the standards it selects (or are imposed on it through regulation). However, most cloud customers will have to comply with multiple state laws (at the very least, the laws of the states where the customer\u2019s organization resides, where the data center resides, and where its end clientele reside); any contractual requirements (between the cloud customer and its consumers, vendors, or service providers, such as, for example, Payment Card Industry Data Security Standard [PCI DSS]); and any federal regulations that govern that cloud customer\u2019s industry.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      190,
      181,
      182,
      461,
      170
    ],
    "source": ""
  },
  {
    "id": 603,
    "question": "The Cloud Security Alliance (CSA) publishes the Notorious Nine, a list of common threats to organizations participating in cloud computing. According to the CSA, data loss can be suffered as a result of ___________________ activity.",
    "choice_a": "Malicious or inadvertent",
    "choice_b": "Casual or explicit",
    "choice_c": "Web-based or stand-alone",
    "choice_d": "Managed or independent",
    "correct_answer": "A",
    "explanation": "Data loss can be the result of deliberate or accidental behavior. The other options are less correct than option A.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      226,
      218,
      219,
      422
    ],
    "source": ""
  },
  {
    "id": 604,
    "question": "The Cloud Security Alliance (CSA) publishes the Notorious Nine, a list of common threats to organizations participating in cloud computing. According to the CSA, all of the following activity can result in data loss <italic>except</italic> ___________________.",
    "choice_a": "Misplaced crypto keys",
    "choice_b": "Improper policy",
    "choice_c": "Ineffectual backup procedures",
    "choice_d": "Accidental overwrite",
    "correct_answer": "B",
    "explanation": "Bad policy won\u2019t explicitly lead to data loss, but it might hinder efforts to counter data loss. However, misplaced crypto keys can result in a self-imposed denial of service, bad backup procedures can result in failure to retain data (a form of data loss), and accidental overwrites occur all the time\u2014hence the need for proper backups.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      422,
      423,
      143,
      209,
      225
    ],
    "source": ""
  },
  {
    "id": 605,
    "question": "The Cloud Security Alliance (CSA) publishes the Notorious Nine, a list of common threats to organizations participating in cloud computing. According to the CSA, service traffic hijacking can affect which portion of the CIA triad?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "All of the triad",
    "correct_answer": "D",
    "explanation": "All. Service traffic hijacking can affect all portions of the CIA triad. Through hijacking, an attacker could eavesdrop on legitimate communication (breaching confidentiality), insert inaccurate/incorrect data into legitimate communication (damaging integrity), and/or redirect legitimate users from valid services (making the legitimate sources unavailable). Although all of the answers are correct, option D is the most comprehensive and therefore the best answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      215,
      12,
      8,
      220
    ],
    "source": ""
  },
  {
    "id": 606,
    "question": "The Cloud Security Alliance (CSA) publishes the Notorious Nine, a list of common threats to organizations participating in cloud computing. The CSA recommends the prohibition of ___________________ in order to diminish the likelihood of account/service traffic hijacking.",
    "choice_a": "All user activity",
    "choice_b": "Sharing account credentials between users and services",
    "choice_c": "Multifactor authentication",
    "choice_d": "Interstate commerce",
    "correct_answer": "B",
    "explanation": "Users sharing account credentials is a fairly common (although undesirable) practice and one that can lead to significant misuse of the organization\u2019s resources and greatly increase risk to the organization. Although ending all user activity would make our IT environments so much more secure and defensible, it would also make them utterly useless from a productivity standpoint, so option A is incorrect. Option C is incorrect because the CSA recommends multifactor authentication as a means to reduce the risk of hijacking. Though not documented on the CSA\u2019s website, the CSA most certainly does not recommend the prohibition of interstate commerce in order to diminish the likelihood of account/service traffic hijacking. Therefore, option D is an incorrect answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      215,
      222,
      223,
      225,
      221
    ],
    "source": ""
  },
  {
    "id": 607,
    "question": "The Cloud Security Alliance (CSA) publishes the Notorious Nine, a list of common threats to organizations participating in cloud computing. According to the CSA, which aspect of cloud computing makes it particularly susceptible to account/service traffic hijacking?",
    "choice_a": "Scalability",
    "choice_b": "Metered service",
    "choice_c": "Remote access",
    "choice_d": "Pooled resources",
    "correct_answer": "C",
    "explanation": "Cloud computing users are especially susceptible to hijacking attacks because all of their use is contingent on remote access; users in a traditional internal environment are not passing as much traffic over untrusted infrastructure (the Internet), and the type of traffic is often different (where identity credentials are passed only to servers/systems that are locally, physically connected to the user\u2019s device). <br>Scalability might be seen as an attribute of cloud computing that increases the potential for hijacking attacks because a proliferation of users means more attack surface. But even that aspect is contingent on the users accessing cloud resources remotely, so option C is still a better answer than A. <br>The metered service nature of cloud computing has nothing to do with a hijacking threat; metered service indicates that the customer pays only for those resources users consume. <br>Cloud customers pool resources might be of concern when considering hijacking attacks because poorly configured cloud environments could leave one cloud customer subject to attack by another tenant in that same environment. But, again, hijacking is predicated on attacking data in transit, so it is the remote access aspect that is the best answer for this question.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      1,
      3,
      12,
      144,
      206
    ],
    "source": ""
  },
  {
    "id": 608,
    "question": "The Cloud Security Alliance (CSA) publishes the Notorious Nine, a list of common threats to organizations participating in cloud computing. According to the CSA, what is one reason the threat of insecure interfaces and APIs is so prevalent in cloud computing?",
    "choice_a": "Most of the cloud customer\u2019s interaction with resources will be performed through APIs.",
    "choice_b": "APIs are inherently insecure.",
    "choice_c": "Attackers have already published vulnerabilities for all known APIs.",
    "choice_d": "APIs are known carcinogens.",
    "correct_answer": "A",
    "explanation": "Because a significant percentage of cloud customer interactions with the cloud environment will utilize APIs, the threat of insecure APIs is of great concern in cloud computing. <br>Option B is incorrect because APIs are not inherently insecure and it is unlikely that the CSA has stated that they are. <br>Option C is incorrect because it is predicated on the inaccurate notion that all APIs are inherently insecure and that the vulnerabilities of all known APIs have been published. <br>Lastly, option D is inaccurate because APIs are not known carcinogens. To be a carcinogen, the carcinogen needs to be a substance that causes cancer in living tissue. As far as we know, APIs do not cause cancer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      12,
      13,
      1,
      7
    ],
    "source": ""
  },
  {
    "id": 609,
    "question": "The Cloud Security Alliance (CSA) publishes the Notorious Nine, a list of common threats to organizations participating in cloud computing. According to the CSA, what is one reason the threat of insecure interfaces and APIs is so prevalent in cloud computing?",
    "choice_a": "Cloud customers and third parties are continually enhancing and modifying APIs.",
    "choice_b": "APIs can have automated settings.",
    "choice_c": "It is impossible to uninstall APIs.",
    "choice_d": "APIs are a form of malware.",
    "correct_answer": "A",
    "explanation": "The continuous modification of APIs issued/designed by cloud providers introduces the potential for vulnerabilities to be created in interfaces that were previously thought to be vetted and secure. Increased complexity necessarily means increased potential for vulnerability. And third-party modifications may lead to user credentials being unknowingly exposed to those third parties. <br>Automation is not inherently a source of threats/vulnerabilities, so option B is not correct. <br>Options C and D are not true.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      220,
      215,
      225,
      221,
      142
    ],
    "source": ""
  },
  {
    "id": 610,
    "question": "The Cloud Security Alliance (CSA) publishes the Notorious Nine, a list of common threats to organizations participating in cloud computing. According to the CSA, what is one reason the threat of insecure interfaces and APIs is so prevalent in cloud computing?",
    "choice_a": "APIs are always used for administrative access.",
    "choice_b": "Customers perform many high-value tasks via APIs.",
    "choice_c": "APIs are cursed.",
    "choice_d": "It is impossible to securely code APIs.",
    "correct_answer": "B",
    "explanation": "APIs will be used for many tasks that could have a significant negative impact on the organization, so any vulnerabilities are of great concern. <br>Not all API interaction involves administrative access, so option A is wrong. <br>APIs may or may not be cursed. <br>Secure code practices can be used to design robust APIs, so option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      215,
      2,
      8,
      232,
      221
    ],
    "source": ""
  },
  {
    "id": 611,
    "question": "The Cloud Security Alliance (CSA) publishes the Notorious Nine, a list of common threats to organizations participating in cloud computing. According to the CSA, why are denial-of-service (DoS) attacks such a significant threat to cloud operations?",
    "choice_a": "DoS attackers operate internationally.",
    "choice_b": "There are no laws against DoS attacks, so they are impossible to prosecute.",
    "choice_c": "Availability issues prevent productivity in the cloud.",
    "choice_d": "DoS attacks that can affect cloud providers are easy to launch.",
    "correct_answer": "C",
    "explanation": "If users can\u2019t access the cloud provider, then the operational environment is, for all intents and purposes, useless. DoS attacks that affect availability of cloud services are therefore a great concern. <br>A lot of attackers/criminals operate internationally; this has no bearing on whether an organization operates in the cloud or otherwise. Option A is incorrect. <br>There are laws prohibiting DoS attacks, so option B is incorrect. <br>The volume of DoS traffic necessary to disrupt modern cloud providers is rather significant, so these types of attacks are not simple. Option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      17,
      5,
      221,
      224
    ],
    "source": ""
  },
  {
    "id": 612,
    "question": "The Cloud Security Alliance (CSA) publishes the Notorious Nine, a list of common threats to organizations participating in cloud computing. According to the CSA, what do we call denial-of-service (DoS) attacks staged from multiple machines against a specific target?",
    "choice_a": "Invasive denial of service (IDoS)",
    "choice_b": "Pervasive denial of service (PDoS)",
    "choice_c": "Massive denial of service (MDoS)",
    "choice_d": "Distributed denial of service (DDoS)",
    "correct_answer": "D",
    "explanation": "Denial-of-service attacks staged from multiple machines against a specific target is the definition of a DDoS. All the other options are either fictitious or are not typically associated with the definition of DDoS.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      1,
      1,
      8,
      14,
      20
    ],
    "source": ""
  },
  {
    "id": 613,
    "question": "The Cloud Security Alliance (CSA) publishes the Notorious Nine, a list of common threats to organizations participating in cloud computing. According to the CSA, what aspect of managed cloud services makes the threat of malicious insiders so alarming?",
    "choice_a": "Scalability",
    "choice_b": "Multitenancy",
    "choice_c": "Metered service",
    "choice_d": "Flexibility",
    "correct_answer": "B",
    "explanation": "In a managed cloud service context, one malicious cloud administrator could ostensibly victimize a great number of cloud customers, making the impact much greater than a sole insider in the legacy environment. <br>The other options are not applicable to the insider threat.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      12,
      13,
      484,
      232,
      225
    ],
    "source": ""
  },
  {
    "id": 614,
    "question": "The Cloud Security Alliance (CSA) publishes the Notorious Nine, a list of common threats to organizations participating in cloud computing. According to the CSA, what aspect of managed cloud services makes the threat of abuse of cloud services so alarming from a management perspective?",
    "choice_a": "Scalability",
    "choice_b": "Multitenancy",
    "choice_c": "Resiliency",
    "choice_d": "Broadband connections",
    "correct_answer": "A",
    "explanation": "Because users in cloud customer organizations often do not pay directly for cloud services (and are often not even aware of the cost of use), scalability can be a significant management concern; individuals, offices, or departments within the organization can create dozens or even hundreds of new virtual systems in a cloud environment, for whatever purpose they need or desire, and the cost is realized only by the department in the organization that is charged with paying the bill. This type of abuse hinges on the immense scalability of cloud services and is frequently not associated with any malicious intent but is instead an inadvertent result of well-intentioned or careless behavior. <br>The other options are not applicable to the threat of abuse of cloud services.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      7,
      6,
      225,
      230
    ],
    "source": ""
  },
  {
    "id": 615,
    "question": "The Cloud Security Alliance (CSA) publishes the Notorious Nine, a list of common threats to organizations participating in cloud computing. According to the CSA, which of the following is <italic>not</italic> an aspect of due diligence that the cloud customer should be concerned with when considering a migration to a cloud provider?",
    "choice_a": "Ensuring that any legacy applications are not dependent on internal security controls before moving them to the cloud environment",
    "choice_b": "Reviewing all contractual elements to appropriately define each party\u2019s roles, responsibilities, and requirements",
    "choice_c": "Assessing the provider\u2019s financial standing and soundness",
    "choice_d": "Vetting the cloud provider\u2019s administrators and personnel to ensure the same level of trust as the legacy environment",
    "correct_answer": "D",
    "explanation": "The cloud customer will not have any insight into the personnel security aspects of the cloud provider; when an organization contracts out a service, the organization loses that granular level of control. <br>It is imperative that the cloud customer determine whether any application dependencies exist in the legacy environment before migrating to the cloud. <br>Reviewing the contract between the cloud customer and provider is an essential element of due diligence. <br>Determining the long-term financial viability of a cloud provider is a way to avoid losing production capability/data in the cloud.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      229,
      237,
      12,
      170,
      6
    ],
    "source": ""
  },
  {
    "id": 616,
    "question": "The Cloud Security Alliance (CSA) publishes the Notorious Nine, a list of common threats to organizations participating in cloud computing. A cloud customer that does not perform sufficient due diligence can suffer harm if the cloud provider they\u2019ve selected goes out of business. What do we call this problem?",
    "choice_a": "Vendor lock-in",
    "choice_b": "Vendor lockout",
    "choice_c": "Vendor incapacity",
    "choice_d": "Unscaled",
    "correct_answer": "B",
    "explanation": "This is the definition of vendor lockout. <br>Vendor lock-in is when data portability is limited, either through unfavorable contract language or technical limitations. <br>Vendor incapacity and unscaled are not meaningful terms in the context of cloud computing.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      229,
      230,
      220,
      231
    ],
    "source": ""
  },
  {
    "id": 617,
    "question": "Which of the following is <italic>not</italic> a method for creating logical segmentation in a cloud data center?",
    "choice_a": "Virtual local area networks (VLANs)",
    "choice_b": "Network address translation (NAT)",
    "choice_c": "Bridging",
    "choice_d": "Hubs",
    "correct_answer": "D",
    "explanation": "A hub is a (mostly archaic) network device that simply connects physical machines together; it cannot serve the purpose of network segmentation. <br>All the other options are segmentation methods/tools. Option C may be perceived as a viable answer because bridges connect network segments (allowing a segmented network, but not really creating segmentation), but option D is a better choice for this question.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      469,
      140,
      471,
      470,
      2
    ],
    "source": ""
  },
  {
    "id": 618,
    "question": "According to  ISC2, the lack/ambiguity of physical endpoints as individual network components in the cloud environment creates what kind of threat/concern?",
    "choice_a": "The lack of defined endpoints makes it difficult to uniformly define, manage, and protect IT assets.",
    "choice_b": "Without physical endpoints, it is impossible to apply security controls to an environment.",
    "choice_c": "Without physical endpoints, it is impossible to track user activity.",
    "choice_d": "The lack of physical endpoints increases the opportunity for physical theft/damage.",
    "correct_answer": "A",
    "explanation": "Knowing exactly where and what your assets are, from an IT security professional\u2019s perspective, allows you to better apply uniform and ubiquitous governance and controls across the environment. Without these clear demarcations, that task becomes more difficult. <br>Nothing is impossible; these tasks may become more challenging, but not impossible. So options B and C are incorrect. <br>Option D is not true because lack of physical endpoints may actually reduce the threat of physical theft/damage.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      7,
      16,
      207,
      204,
      1
    ],
    "source": ""
  },
  {
    "id": 619,
    "question": "When should cloud providers allow platform as a service (PaaS) customers shell access to the servers running their instances?",
    "choice_a": "Never",
    "choice_b": "Weekly",
    "choice_c": "Only when the contract stipulates that requirement",
    "choice_d": "Always",
    "correct_answer": "A",
    "explanation": "PaaS customers should never be given shell access to underlying infrastructure because any changes by one customer may negatively impact other customers in a multitenant environment. <br>All the other options are simply incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      12,
      13,
      140,
      480
    ],
    "source": ""
  },
  {
    "id": 620,
    "question": "In a PaaS implementation, each instance should have its own user-level permissions; when instances share common policies/controls, the cloud security professional should be careful to reduce the possibility of ___________________ and ___________________ over time.",
    "choice_a": "Denial of service (DoS)/physical theft",
    "choice_b": "Authorization creep/inheritance",
    "choice_c": "Sprawl/hashing",
    "choice_d": "Intercession/side-channel attacks",
    "correct_answer": "B",
    "explanation": "Mass permissions assigned to multiple instances may be susceptible to inadvertent authorization creep and permission inheritance over time as users shift roles and responsibilities and are assigned to new tasks and teams and as new users come into the existing, fluid environment. <br>All the other options are just wrong, with at least one nonsensical element in each.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      214,
      12,
      142,
      156,
      226
    ],
    "source": ""
  },
  {
    "id": 621,
    "question": "In a platform as a service (PaaS) environment, user access management often requires that data about user activity be collected, analyzed, audited, and reported against rule-based criteria. These criteria are usually based on ___________________.",
    "choice_a": "International standards",
    "choice_b": "Federal regulations",
    "choice_c": "Organizational policies",
    "choice_d": "Federation directives",
    "correct_answer": "C",
    "explanation": "Organizational policies dictate rules for access entitlement. <br>International standards do not apply to every organization\u2019s internal needs and individual user roles, so option A is incorrect. <br>Not all organizations are bound by all (or any) federal regulations, but all organizations should have policies regarding user access rules, so option B is incorrect. <br>Option D is a nod to Star Trek and also incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      206,
      208,
      481,
      456,
      194
    ],
    "source": ""
  },
  {
    "id": 622,
    "question": "An essential element of access management, ___________________ is the practice of confirming that an individual is who they claim to be.",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Nonrepudiation",
    "choice_d": "Regression",
    "correct_answer": "A",
    "explanation": "Authentication is verifying that the user is who they claim to be and assigning them an identity assertion (usually a user ID) based on that identity. <br>Authorization is granting access based on permissions allocated to a particular user/valid identity assertion. <br>Nonrepudiation is the security concept of not allowing a participant in a transaction to deny that they participated. <br>Regression is a statistical concept not relevant to the question in any way.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      478,
      480,
      481,
      487,
      492
    ],
    "source": ""
  },
  {
    "id": 623,
    "question": "An essential element of access management, ___________________ is the practice of granting permissions based on validated identification.",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Nonrepudiation",
    "choice_d": "Regression",
    "correct_answer": "B",
    "explanation": "This is the definition of authorization. <br>Authentication is verifying that the user is who they claim to be and assigning them an identity assertion (usually a user ID) based on that identity. <br>Nonrepudiation is the security concept of not allowing a participant in a transaction to deny that they participated. <br>Regression is a statistical concept not relevant to the question in any way.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      478,
      487,
      481,
      208,
      482
    ],
    "source": ""
  },
  {
    "id": 624,
    "question": "What is the usual order of an access management process?",
    "choice_a": "Access-authorization-authentication",
    "choice_b": "Authentication-authorization-access",
    "choice_c": "Authorization-authentication-access",
    "choice_d": "Authentication-access-authorization",
    "correct_answer": "B",
    "explanation": "In access management, the user is first authenticated (their identity verified and validated as correct), then authorized (permissions granted based on their valid identity), and given access.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      478,
      480,
      492,
      490,
      140
    ],
    "source": ""
  },
  {
    "id": 625,
    "question": "Why are platform as a service (PaaS) environments at a higher likelihood of suffering backdoor vulnerabilities?",
    "choice_a": "They rely on virtualization.",
    "choice_b": "They are often used for software development.",
    "choice_c": "They have multitenancy.",
    "choice_d": "They are scalable.",
    "correct_answer": "B",
    "explanation": "PaaS environments are attractive for software development because they allow testing of software on multiple operating systems that are administered by the cloud provider. Software developers routinely use backdoors as development and administrative tools in their products; these backdoors, if left in software when it ships, are significant vulnerabilities. <br>All cloud environments, including PaaS, rely on virtualization, have multitenancy, and are scalable, so those options are not correct.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      23,
      156,
      227,
      216
    ],
    "source": ""
  },
  {
    "id": 626,
    "question": "Backdoors are sometimes left in software by developers ___________________.",
    "choice_a": "In lieu of other security controls",
    "choice_b": "As a means to counter denial-of-service (DoS) attacks",
    "choice_c": "Inadvertently or on purpose",
    "choice_d": "As a way to distract attackers",
    "correct_answer": "C",
    "explanation": "Backdoors that were used legitimately during the development process can sometimes be left in a production version of the delivered software accidentally, when developers forget to remove them. Sometimes, these products ship with backdoors purposefully placed there for administrative and customer service functions as well. <br>Option A is incorrect as backdoors are not a control. <br>Option B is incorrect because backdoors don\u2019t serve as DoS protection in any way. <br>Option D is incorrect because backdoors are not distractions for attackers, but means for attack.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      227,
      156,
      23,
      216,
      214
    ],
    "source": ""
  },
  {
    "id": 627,
    "question": "Alice is staging an attack against Bob\u2019s website. She is able to introduce a string of command code into a database Bob is running, simply by entering the command string into a data field. This is an example of which type of attack?",
    "choice_a": "Insecure direct object reference",
    "choice_b": "Buffer overflow",
    "choice_c": "SQL injection",
    "choice_d": "Denial of service",
    "correct_answer": "C",
    "explanation": "This is an example of typical SQL injection. All the other options are also attacks listed in the Open Web Application Security Project (OWASP) Top Ten, but they do not have the characteristics as the one contained in the question.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 628,
    "question": "Bob is staging an attack against Alice\u2019s website. He is able to embed a link on her site that will execute malicious code on a visitor\u2019s machine if the visitor clicks on the link. This is an example of which type of attack?",
    "choice_a": "Cross-site scripting",
    "choice_b": "Broken authentication/session management",
    "choice_c": "Security misconfiguration",
    "choice_d": "Insecure cryptographic storage",
    "correct_answer": "A",
    "explanation": "This is the definition of a cross-site scripting attack. Options B and C are also attacks listed in the Open Web Application Security Project (OWASP) Top Ten. Option D is not in the Top Ten and is a fictitious option.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      217,
      219,
      221,
      223,
      224
    ],
    "source": ""
  },
  {
    "id": 629,
    "question": "Alice is staging an attack against Bob\u2019s website. She has discovered that Bob has been storing cryptographic keys on a server with a default admin password and is able to get access to those keys and violate confidentiality and access controls. This is an example of which type of attack?",
    "choice_a": "SQL injection",
    "choice_b": "Buffer overflow",
    "choice_c": "Using components with known vulnerabilities",
    "choice_d": "Security misconfiguration",
    "correct_answer": "D",
    "explanation": "This is likely a security misconfiguration, as crypto keys must not be disclosed or the cryptosystem does not provide protection; most successful attacks on cryptosystems have been configuration/implementation attacks, not mathematical or statistical. The other options are all also in the Open Web Application Security Project (OWASP) Top Ten.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      244,
      245,
      206,
      233,
      23
    ],
    "source": ""
  },
  {
    "id": 630,
    "question": "Which of the following is a management risk that organizations migrating to the cloud will have to address?",
    "choice_a": "Insider threat",
    "choice_b": "Virtual sprawl",
    "choice_c": "Distributed denial-of-service (DDoS) attacks",
    "choice_d": "Natural disasters",
    "correct_answer": "B",
    "explanation": "In the cloud environment, it is very easy for a user to generate a new virtual instance; that is one of the advantages of the cloud. However, this can pose a problem for management, as users might generate many more instances than expected because the users don\u2019t usually realize (or have to pay) the per-instance costs associated with doing so. However, the organization will have to pay the full price of many more instances at the end of each billing cycle, and exceeding the allotted amount dictated by the contract can be quite expensive. In the traditional environment, this would not pose a risk because the number of possible instances is limited by the resource capacity within the organization and additional instances don\u2019t have attendant direct costs. All the other options are not cloud-specific risks; they also exist in the traditional environment.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      215,
      225,
      222,
      223,
      5
    ],
    "source": ""
  },
  {
    "id": 631,
    "question": "Which kind of hypervisor is the preferred target of attackers, and why?",
    "choice_a": "Type 1, because it is more straightforward",
    "choice_b": "Type 1, because it has a greater attack surface",
    "choice_c": "Type 2, because it is less protected",
    "choice_d": "Type 2, because it has a greater attack surface",
    "correct_answer": "D",
    "explanation": "A Type 2 hypervisor is run on top of an existing operating system, greatly increasing the potential attack surface. <br>Option A does not make logical sense; a Type 1 hypervisor is not more straightforward than other hypervisors. Option A is not the correct answer. <br>Option B is not true. A Type 1 hypervisor has a smaller attack surface, not a larger one. <br>Option C is not true in general. Type 2 hypervisors are not necessarily less protected than other hypervisors. Option C is not the correct answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      14,
      142,
      455,
      223,
      226
    ],
    "source": ""
  },
  {
    "id": 632,
    "question": "Which of the following would make a good provision to include in the service-level agreement (SLA) between cloud customer and provider?",
    "choice_a": "Location of the data center",
    "choice_b": "Amount of data uploaded/downloaded during a pay period",
    "choice_c": "Type of personnel security controls for network administrators",
    "choice_d": "Physical security barriers on the perimeter of the data center campus",
    "correct_answer": "B",
    "explanation": "Option B is the only element that lends itself well to a discrete, objective metric; the other options might be something the customer is interested in but will often have little control over; if the customer is insistent on those points, they should be included in the contract, not the SLA.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      12,
      237,
      147,
      170
    ],
    "source": ""
  },
  {
    "id": 633,
    "question": "What is the <italic>most</italic> significant aspect of the service-level agreement (SLA) that incentivizes the cloud provider to perform?",
    "choice_a": "The thoroughness with which it details all aspects of cloud processing",
    "choice_b": "The financial penalty for not meeting service levels",
    "choice_c": "The legal liability for violating data breach notification requirements",
    "choice_d": "The risk exposure to the cloud provider",
    "correct_answer": "B",
    "explanation": "Usually, when a provider does not meet the terms specific in the SLA, the provider will not be paid for a period of service; this is the strongest, most immediate tool at the customer\u2019s disposal. The other options simply are not true.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      232,
      147,
      170,
      237,
      234
    ],
    "source": ""
  },
  {
    "id": 634,
    "question": "From a customer perspective, all of the following are benefits of infrastructure as a service (IaaS) cloud services <italic>except</italic> ___________________.",
    "choice_a": "Reduced cost of ownership",
    "choice_b": "Reduced energy costs",
    "choice_c": "Metered usage",
    "choice_d": "Reduced cost of administering the operating system (OS) in the cloud environment",
    "correct_answer": "D",
    "explanation": "In an IaaS configuration, the customer still has to maintain the OS, so option D is the only answer that is not a direct benefit for the cloud customer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      12,
      237,
      11,
      1
    ],
    "source": ""
  },
  {
    "id": 635,
    "question": "From an academic perspective, what is the main distinction between an event and an incident?",
    "choice_a": "Incidents can last for extended periods (days or weeks), whereas an event is momentary.",
    "choice_b": "Incidents can happen at the network level, whereas events are restricted to the system level.",
    "choice_c": "Events are anything that can occur in the IT environment, whereas incidents are unscheduled events.",
    "choice_d": "Events occur only during processing, whereas incidents can occur at any time.",
    "correct_answer": "C",
    "explanation": "This is the textbook definition of an incident versus event. However, this question is not easy, because many sources in the IT security field define incidents differently; it\u2019s common to think of incidents as events that have an adverse impact, or incidents are something that require response. However, option C is the correct answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      157,
      147,
      158,
      159,
      206
    ],
    "source": ""
  },
  {
    "id": 636,
    "question": "The cloud computing characteristic of elasticity promotes which aspect of the CIA triad?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "None",
    "correct_answer": "D",
    "explanation": "Elasticity is a beneficial characteristic in that it supports the management goal of matching resources to user needs, but it does not provide any security benefit.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      16,
      1,
      225,
      215
    ],
    "source": ""
  },
  {
    "id": 637,
    "question": "A hosted cloud environment is great for an organization to use as ___________________.",
    "choice_a": "Storage of physical assets",
    "choice_b": "A testbed/sandbox",
    "choice_c": "A platform for managing unsecured production data",
    "choice_d": "A cost-free service for meeting all user needs",
    "correct_answer": "B",
    "explanation": "Cloud customers can test different hardware/software implementations in the cloud without affecting the production environment and use this information to make decisions before investing in particular solutions. Option A is not true because the cloud does not store physical assets. Option C is not accurate because production data in the cloud must still be secured. And option D is not true because cloud hosting is not free; there is some cost (even if that cost is less than it would be for comparable on-premises hosting).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      3,
      8,
      4,
      5
    ],
    "source": ""
  },
  {
    "id": 638,
    "question": "What is the entity that created the Statement on Standards for Attestation Engagements (SSAE) auditing standard and certifies auditors for that standard?",
    "choice_a": "National Institute of Standards and Technology (NIST)",
    "choice_b": "European Network and Information Security Agency (ENISA)",
    "choice_c": "General Data Protection Regulation (GDPR)",
    "choice_d": "American Institute of Certified Public Accountants (AICPA)",
    "correct_answer": "D",
    "explanation": "The American Institute of Certified Public Accountants publishes the SSAE 18 standard. NIST is a U.S. government entity that publishes many standards for federal agencies, so option A is incorrect. ENISA is a European Union (EU) standards body, so option B is incorrect. The GDPR is an EU law about privacy data, so option C is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      205,
      233,
      182,
      176,
      1
    ],
    "source": ""
  },
  {
    "id": 639,
    "question": "The current American Institute of Certified Public Accountants (AICPA) standard codifies certain audit reporting mechanisms. What are these called?",
    "choice_a": "Sarbanes-Oxley Act (SOX) reports",
    "choice_b": "Secure Sockets Layer (SSL) audits",
    "choice_c": "Sherwood Applied Business Structure Architecture (SABSA)",
    "choice_d": "System and Organization Controls (SOC) reports",
    "correct_answer": "D",
    "explanation": "SOC reports are the audit reporting mechanisms dictated by SSAE 18. SOX is a federal law targeting publicly traded corporations in the United States. SSL is a way to conduct secure online transactions. SABSA is an architecture framework.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      265,
      205,
      266,
      267,
      204
    ],
    "source": ""
  },
  {
    "id": 640,
    "question": "Which of the following is <italic>not</italic> a report used to assess the design and selection of security controls within an organization?",
    "choice_a": "Consensus Assessments Initiative Questionnaire (CAIQ)",
    "choice_b": "Cloud Security Alliance Cloud Controls Matrix (CSA CCM)",
    "choice_c": "SOC 1",
    "choice_d": "SOC 2 Type 1",
    "correct_answer": "C",
    "explanation": "The SOC 1 audit report is not for security controls; it is for financial reporting controls. The AICPA SOC 2 Type 1 audit report reviews the controls an organization has selected and designed. Both the CAIQ and the CCM are tools created by the CSA to review an organization\u2019s controls across several frameworks, regulations, and standards.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      205,
      266,
      265,
      456,
      204
    ],
    "source": ""
  },
  {
    "id": 641,
    "question": "Which of the following is a report used to assess the implementation and effectiveness of security controls within an organization?",
    "choice_a": "SOC 1",
    "choice_b": "SOC 2 Type 1",
    "choice_c": "SOC 2 Type 2",
    "choice_d": "SOC 3",
    "correct_answer": "C",
    "explanation": "The SOC 2 Type 2 reviews the implementation of security controls. The SOC 1 reviews financial reporting controls, not security controls. The SOC 2 Type 1 reviews the design and selection of security controls, not implementation. The SOC 3 is only an attestation of an audit, so option C is better.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      266,
      205,
      265,
      267,
      456
    ],
    "source": ""
  },
  {
    "id": 642,
    "question": "___________________ is an example of due care, and ___________________ is an example of due diligence.",
    "choice_a": "Privacy data security policy; auditing the controls dictated by the privacy data security policy",
    "choice_b": "The European Union General Data Protection Regulation (GDPR); the Gramm-Leach-Bliley Act (GLBA)",
    "choice_c": "Locks on doors; turnstiles",
    "choice_d": "Perimeter defenses; internal defenses",
    "correct_answer": "A",
    "explanation": "Due care is the minimal level of effort necessary to perform your duty to others; in cloud security, that is often the care that the cloud customer is required to demonstrate in order to protect the data it owns. Due diligence is any activity taken in support or furtherance of due care. This answer, then, is optimum: the due care is set out by the policy, and activities that support the policy (here, auditing the controls the policy requires) are a demonstration of due diligence. <br>The General Data Protection Regulation (GDPR) and GLBA are both legislative mandates; these might dictate a standard of due care, but they are not the due care or due diligence, specifically. <br>Door locks and turnstiles are physical security controls; they both might be examples of due care efforts, but neither demonstrates due diligence. <br>Due care and diligence can be demonstrated by either internal or external controls/processes; there is no distinction to be made based on where the control is situated.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      209,
      220,
      229,
      174,
      190
    ],
    "source": ""
  },
  {
    "id": 643,
    "question": "In a Lightweight Directory Access Protocol (LDAP) environment, each entry in a directory server is identified by a ___________________.",
    "choice_a": "Domain name (DN)",
    "choice_b": "Distinguished name (DN)",
    "choice_c": "Directory name (DN)",
    "choice_d": "Default name (DN)",
    "correct_answer": "B",
    "explanation": "The distinguished name (DN) is the nomenclature for all entries in an LDAP environment. <br>A domain name is used to identify one or more IP addresses. For instance, Microsoft.com and google.com are domain names. Option A is incorrect. <br>A directory name is typically associated with a file system structure and not something related to LDAP. Option C is incorrect. <br>\u201dDefault Name\u201d is not a common term, and is made up. Option D is not the correct answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      490,
      491,
      492,
      144,
      8
    ],
    "source": ""
  },
  {
    "id": 644,
    "question": "Each of the following is an element of the Identification phase of the identity and access management (IAM) process <italic>except</italic> ___________________.",
    "choice_a": "Provisioning",
    "choice_b": "Inversion",
    "choice_c": "Management",
    "choice_d": "Deprovisioning",
    "correct_answer": "B",
    "explanation": "Inversion is not part of the IAM process at all and has no meaning in this context. All the other options are elements of identification.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      479,
      478,
      492,
      491,
      480
    ],
    "source": ""
  },
  {
    "id": 645,
    "question": "Which of the following is true about two-person integrity?",
    "choice_a": "It forces all employees to distrust one another.",
    "choice_b": "It requires two different identity and access management matrices (IAM).",
    "choice_c": "It forces collusion for unauthorized access.",
    "choice_d": "It enables more thieves to gain access to the facility.",
    "correct_answer": "C",
    "explanation": "By creating a need for two identity assertions or authentication elements to access assets, two-person integrity prevents a single person from gaining unauthorized access and forces a would-be criminal to join up with at least one other person to conduct a crime. This reduces the possibility of the crime taking place. <br>All the other options are simply untrue and are therefore exceedingly poor choices for answers to CCSP test questions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      480,
      140,
      223,
      224,
      168
    ],
    "source": ""
  },
  {
    "id": 646,
    "question": "All of the following are statutory regulations <italic>except</italic> the ___________________.",
    "choice_a": "Gramm-Leach-Bliley Act (GLBA)",
    "choice_b": "Health Information Portability and Accountability Act (HIPAA)",
    "choice_c": "Federal Information Systems Management Act (FISMA)",
    "choice_d": "Payment Card Industry Data Security Standard (PCI DSS)",
    "correct_answer": "D",
    "explanation": "The PCI DSS is a voluntary standard, having only contractual obligation. All the other options are statutes, created by lawmaking bodies.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      461,
      190,
      182,
      170,
      168
    ],
    "source": ""
  },
  {
    "id": 647,
    "question": "A cloud data encryption situation where the cloud customer retains control of the encryption keys and the cloud provider only processes and stores the data could be considered a ___________________.",
    "choice_a": "Threat",
    "choice_b": "Risk",
    "choice_c": "Hybrid cloud deployment model",
    "choice_d": "Case of infringing on the rights of the provider",
    "correct_answer": "C",
    "explanation": "Because the cloud customer will retain ownership of some elements of hardware, software, or both at the customer\u2019s location (for instance, hardware security modules [HSMs]), client-side key management could be considered a hybrid cloud model. <br>Option A is incorrect because the scenario stated in the question does not identify a threat. <br>Option B is incorrect because the scenario stated in the question does not identify a risk. Allowing the customer to retain their own encryption keys is actually less risky than sharing their encryption keys with the provider. <br>Option D is incorrect because the provider does not have a right to the customer\u2019s encryption keys, so, there cannot be an infringement on the provider\u2019s rights.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      9,
      12,
      237,
      235,
      231
    ],
    "source": ""
  },
  {
    "id": 648,
    "question": "Which of the following is one of the benefits of a private cloud deployment?",
    "choice_a": "Less cost",
    "choice_b": "Higher performance",
    "choice_c": "Retaining control of governance",
    "choice_d": "Reduction in need for maintenance capability on the customer side",
    "correct_answer": "C",
    "explanation": "With a private cloud deployment, the customer gets to dictate governance requirements, which is a significant benefit for customers in highly regulated industries. <br>Private clouds typically cost more than public cloud deployments, so option A is incorrect. <br>Performance is not necessarily enhanced (or decreased) by any of the cloud deployment models, so option B is incorrect. <br>Retaining a higher degree of control over the cloud environment will necessarily require the cloud customer to have more maintenance capability, not less, so option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      9,
      7,
      206,
      235,
      170
    ],
    "source": ""
  },
  {
    "id": 649,
    "question": "What are the two general delivery modes for the software as a service (SaaS) model?",
    "choice_a": "Ranked and free",
    "choice_b": "Hosted application management and software on demand",
    "choice_c": "Intrinsic motivation complex and undulating perspective details",
    "choice_d": "Framed and modular",
    "correct_answer": "B",
    "explanation": "In SaaS, the cloud provider might license and deliver commercially available software for the customer, via the cloud (hosted application management), or provide the customer access to the provider\u2019s proprietary software (software on demand). <br>All the other options are incorrect. The options contain legitimate words put together to form gibberish.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      12,
      13,
      11,
      237
    ],
    "source": ""
  },
  {
    "id": 650,
    "question": "Your organization has migrated into a platform as a service (PaaS) configuration. A network administrator within the cloud provider has accessed your data and sold a list of your users to a competitor. Who is required to make data breach notifications in accordance with all applicable laws?",
    "choice_a": "The network admin responsible",
    "choice_b": "The cloud provider",
    "choice_c": "The regulators overseeing your deployment",
    "choice_d": "Your organization",
    "correct_answer": "D",
    "explanation": "The cloud customer is ultimately responsible for all legal repercussions involving data security and privacy; the cloud provider might be liable for financial costs related to these responsibilities, but those damages can only be recovered long after the notifications have been made by the cloud customer. <br>All the other options are incorrect because they do not correctly identify who is required to make data breach notifications in accordance with all applicable laws. That responsibility rests with the cloud customer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      237,
      12,
      181,
      178,
      182
    ],
    "source": ""
  },
  {
    "id": 651,
    "question": "If an organization wants to retain the <italic>most</italic> control of their assets in the cloud, which service and deployment model combination should they choose?",
    "choice_a": "Platform as a service (PaaS), community",
    "choice_b": "Infrastructure as a service (IaaS), hybrid",
    "choice_c": "Software as a service (SaaS), public",
    "choice_d": "Infrastructure as a service (IaaS), private",
    "correct_answer": "D",
    "explanation": "An IaaS service model allows an organization to retain the most control of their IT assets in the cloud; the cloud customer is responsible for the operating system, the applications, and the data in the cloud. The private cloud model allows the organization to retain the greatest degree of governance control in the cloud; all the other deployment models would necessitate giving up governance control in an environment with pooled resources.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      9,
      12,
      237,
      7
    ],
    "source": ""
  },
  {
    "id": 652,
    "question": "If an organization wants to realize the <italic>most</italic> cost savings by reducing administrative overhead, which service and deployment model combination should they choose?",
    "choice_a": "Platform as a service (PaaS), community",
    "choice_b": "Infrastructure as a service (IaaS), hybrid",
    "choice_c": "Software as a service (SaaS), public",
    "choice_d": "Infrastructure as a service (IaaS), private",
    "correct_answer": "C",
    "explanation": "With SaaS, the cloud customer is responsible only for the data in the cloud; the cloud provider is responsible for the underlying IT infrastructure, the operating system, and the applications; maintenance for this service model will be minimal, compared to the others. A public cloud deployment will reduce costs even more, as it is the least expensive of the options\u2014with the least amount of control for the cloud customer. <br>All the other options would include some degree of administration of the cloud resources on the part of the cloud customer and so are not as optimal as option C.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      9,
      237,
      6,
      12
    ],
    "source": ""
  },
  {
    "id": 653,
    "question": "In which of these options does the encryption engine reside within the application accessing the database?",
    "choice_a": "Transparent encryption",
    "choice_b": "Symmetric-key encryption",
    "choice_c": "Application-level encryption",
    "choice_d": "Homomorphic encryption",
    "correct_answer": "C",
    "explanation": "In application-level encryption, the application will encrypt data before it is placed in the database. In transparent encryption, the entire database is encrypted. Symmetric-key encryption is a kind of encryption and not truly indicative of a strategy used in database encryption. Homomorphic encryption is an experimental, theoretical process that might allow processing encrypted information without the need to decrypt it first.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      503,
      507,
      494,
      418,
      255
    ],
    "source": ""
  },
  {
    "id": 654,
    "question": "You are the security team leader for an organization that has an infrastructure as a service (IaaS) production environment hosted by a cloud provider. You want to implement an event monitoring (security information and event management [SIEM]/security information management [SIM]/security event management [SEM]) solution in your production environment in order to acquire better data for security defenses and decisions. Which of the following is probably your <italic>most</italic> significant concern about implementing this solution in the cloud?",
    "choice_a": "The solution should give you better analysis capability by automating a great deal of the associated tasks.",
    "choice_b": "Dashboards produced by the tool are a flawless management benefit.",
    "choice_c": "You will have to coordinate with the cloud provider to ensure that the tool is acceptable and functioning properly.",
    "choice_d": "Senior management will be required to approve the acquisition and implementation of the tool.",
    "correct_answer": "C",
    "explanation": "Because the tool will require at least some installation and reporting capability within the cloud environment, it is essential to coordinate with the cloud provider to ensure that the solution you choose will function properly and is allowed by the provider. Option A is true, but not a major concern; that is a benefit of SIEM/SEM/SIM tools. Option B is not true because dashboards can often misconstrue pertinent reporting data when they are used to chase management goals instead of distilling raw data appropriately. Option D is not true because management should not be involved in such granular decisions.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      38,
      39,
      33,
      24,
      414
    ],
    "source": ""
  },
  {
    "id": 655,
    "question": "Which of the following is <italic>not</italic> a step in the crypto-shredding process?",
    "choice_a": "Encrypt data with a particular encryption engine.",
    "choice_b": "Encrypt first resulting keys with another encryption engine.",
    "choice_c": "Save backup of second resulting keys.",
    "choice_d": "Destroy original second resulting keys.",
    "correct_answer": "C",
    "explanation": "In crypto-shredding, the purpose is to make the data unrecoverable; saving a backup of the keys would attenuate that outcome because the keys would still exist for the purpose of recovering data. All other steps outline the crypto-shredding process.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      41,
      40,
      35,
      418,
      494
    ],
    "source": ""
  },
  {
    "id": 656,
    "question": "Which of the following sanitization methods is feasible for use in the cloud?",
    "choice_a": "Crypto-shredding",
    "choice_b": "Degaussing",
    "choice_c": "Physical destruction",
    "choice_d": "Overwriting",
    "correct_answer": "A",
    "explanation": "Cloud customers are allowed to encrypt their own data and manage their own keys; crypto-shredding is therefore possible. Degaussing is not likely in the cloud because it requires physical access to the storage devices and because most cloud providers are using solid-state drives (SSDs) for storage, which are not magnetic. Physical destruction is not feasible because the cloud customer doesn\u2019t own the hardware and therefore won\u2019t be allowed to destroy it. Overwriting probably won\u2019t work because finding all data in all aspects of the cloud is difficult and the data is constantly being backed up and securely stored, so a thorough process would be very tricky.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      40,
      41,
      35,
      434,
      435
    ],
    "source": ""
  },
  {
    "id": 657,
    "question": "Which of the following is <italic>not</italic> a method for enhancing data portability?",
    "choice_a": "Crypto-shredding",
    "choice_b": "Using standard data formats",
    "choice_c": "Avoiding proprietary services",
    "choice_d": "Favorable contract terms",
    "correct_answer": "A",
    "explanation": "Crypto-shredding is for secure sanitization, not portability. The other methods all enhance portability.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      40,
      41,
      28,
      36,
      26
    ],
    "source": ""
  },
  {
    "id": 658,
    "question": "When implementing a digital rights management (DRM) solution in a cloud environment, which of the following does <italic>not</italic> pose an additional challenge for the cloud customer?",
    "choice_a": "Users might be required to install a DRM agent on their local devices.",
    "choice_b": "DRM solutions might have difficulty interfacing with multiple different operating systems and services.",
    "choice_c": "DRM solutions might have difficulty interacting with virtualized instances.",
    "choice_d": "Ownership of intellectual property might be difficult to ascertain.",
    "correct_answer": "D",
    "explanation": "The owner of intellectual property will not change whether the material is stored in the cloud or in a legacy environment. Moving into the cloud will probably result in more use of personal devices, requiring users to install local DRM agents, so option A is true, making it not a suitable answer to this question. Options B and C are also true, due to the nature of cloud computing, and are therefore also not suitable for this question.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      33,
      32,
      31,
      24,
      386
    ],
    "source": ""
  },
  {
    "id": 659,
    "question": "When implementing cryptography in a cloud environment, where is the worst place to store the keys?",
    "choice_a": "With the cloud provider",
    "choice_b": "Off the cloud, with the data owner",
    "choice_c": "With a third-party provider, in key escrow",
    "choice_d": "Anywhere but with the cloud provider",
    "correct_answer": "A",
    "explanation": "Option A creates a conflict of interest and does not enforce separation of duties. <br>The best practice is to not store cryptographic keys with the data they encrypt, to avoid a potential conflict of interest and to enforce separation of duties. Each of the other choices is a reasonable choice and therefore not the answer to this question.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      493,
      494,
      31,
      386,
      41
    ],
    "source": ""
  },
  {
    "id": 660,
    "question": "Which of the following is <italic>not</italic> a security concern related to archiving data for long-term storage?",
    "choice_a": "Long-term storage of the related cryptographic keys",
    "choice_b": "Format of the data",
    "choice_c": "Media the data resides on",
    "choice_d": "Underground depth of the storage facility",
    "correct_answer": "D",
    "explanation": "A long-term storage facility may or may not be located underground; the security of that facility (and the data contained therein) is not dependent on this aspect. Option A is a security concern because loss of the keys may result in losing the data (by losing access to the data), and keeping the keys with the data they protect increases risk. Both the format of the data and the media on which it resides (options B and C) are important to bear in mind, as either (or both) may be outmoded by the time the data might need to be retrieved from the archive; data and formats do not age well.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      36,
      41,
      418,
      40,
      37
    ],
    "source": ""
  },
  {
    "id": 661,
    "question": "Data dispersion is a cloud data security technique that is most similar to which legacy implementation?",
    "choice_a": "Business continuity and disaster recovery (BC/DR)",
    "choice_b": "Redundant Array of Inexpensive Disks (RAID)",
    "choice_c": "Software-defined networking (SDN)",
    "choice_d": "Content delivery network (CDN)",
    "correct_answer": "B",
    "explanation": "Data dispersion is basically RAID in the cloud, with data elements parsed and stored over several areas/devices instead of stored as a unit in a single place. RAID (and data dispersion) does aid in BC/DR activities by increasing the robustness and resiliency of stored data, but BC/DR is a much more general discipline, so it is not the optimum answer for the question. SDN is used for abstracting network control commands away from production data, and CDN is usually used for ensuring quality of streaming media.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      442,
      443,
      444,
      494,
      496
    ],
    "source": ""
  },
  {
    "id": 662,
    "question": "Data dispersion uses ___________, where the traditional implementation is called \u201cstriping.\u201d",
    "choice_a": "Chunking",
    "choice_b": "Vaulting",
    "choice_c": "Lumping",
    "choice_d": "Grouping",
    "correct_answer": "A",
    "explanation": "Where RAID used data striping across multiple drives, with data dispersion this technique is referred to as \u201cchunking,\u201d or sometimes \u201csharding\u201d when encryption is also used. The other options are not common data dispersion terms used in cloud computing and have no meaning in this context.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      410,
      442,
      443,
      507,
      503
    ],
    "source": ""
  },
  {
    "id": 663,
    "question": "Data dispersion uses ___________, where the traditional implementation is called \u201cparity bits.\u201d",
    "choice_a": "Smurfing",
    "choice_b": "Snarfing",
    "choice_c": "Erasure coding",
    "choice_d": "Real-time bitlinking",
    "correct_answer": "C",
    "explanation": "Erasure coding is the practice of having sufficient data to replace a lost chunk in data dispersion, protecting against the possibility of a device failing while it holds a given chunk; parity bits serve the same purpose in a traditional RAID configuration. The other options are not common data dispersion terms used in cloud computing and have no meaning in this context.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      442,
      494,
      496,
      497,
      493
    ],
    "source": ""
  },
  {
    "id": 664,
    "question": "Data dispersion provides protection for all the following security aspects <italic>except</italic> ___________________.",
    "choice_a": "Protecting confidentiality against external attack on the storage area",
    "choice_b": "Loss of availability due to single-storage-device failure",
    "choice_c": "Loss due to seizure by law enforcement in a multitenant environment",
    "choice_d": "Protecting against loss due to user error",
    "correct_answer": "D",
    "explanation": "Data dispersion can\u2019t aid in inadvertent loss caused by an errant user; if the user accidentally deletes/corrupts a file, that file will be deleted/corrupted across all the storage spaces where it is dispersed. The technique does, however, protect against the other risks. It enhances confidentiality because an attacker gaining illicit access to a single storage space will only get a chunk of the data, which is useless without the other chunks. This same aspect also protects loss when law enforcement seizes a specific storage device/space when they are investigating another tenant at the same cloud provider your organization uses. And loss of availability due to single device failure is probably the primary reason for having data dispersion (like RAID before it).",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      505,
      442,
      250,
      412,
      31
    ],
    "source": ""
  },
  {
    "id": 665,
    "question": "Your organization is migrating the production environment to an infrastructure as a service (IaaS) cloud implementation. Your users will need to be able to get access to their data, install programs, and partition memory space for their own purposes. You should configure the cloud memory as ___________________.",
    "choice_a": "Object",
    "choice_b": "Volume",
    "choice_c": "Synthetic",
    "choice_d": "Database",
    "correct_answer": "B",
    "explanation": "Volume storage allows all the functions described in the question. Object storage has data arranged in a file structure, and databases arrange data in tables and relational schemes; neither of these options offers the functions described in the question. Synthetic is not a cloud memory configuration option.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      411,
      442,
      443,
      494,
      496
    ],
    "source": ""
  },
  {
    "id": 666,
    "question": "Your organization is migrating the production environment to an infrastructure as a service (IaaS) cloud implementation. Your users will need to be able to get access to their data and share data with other users in a defined way, according to a hierarchy. You should configure the cloud memory as ___________________.",
    "choice_a": "Object storage",
    "choice_b": "Volume storage",
    "choice_c": "Synthetic storage",
    "choice_d": "Databases",
    "correct_answer": "A",
    "explanation": "Object storage is usually arranged in a file hierarchy. Volume storage has data with no defined structure (only memory space), and databases arrange data in tables and relational schemes; neither of these options offers the functions described in the question. Synthetic is not a cloud memory configuration option.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      33,
      31,
      383,
      411,
      25
    ],
    "source": ""
  },
  {
    "id": 667,
    "question": "What is one of the benefits of implementing an egress monitoring solution?",
    "choice_a": "Preventing distributed denial of service (DDoS) attacks",
    "choice_b": "Inventorying data assets",
    "choice_c": "Interviewing data owners",
    "choice_d": "Protecting against natural disasters",
    "correct_answer": "B",
    "explanation": "Egress monitoring solutions (often referred to as DLP tools, where DLP stands for data loss protection or data leak prevention, or some combination of these terms) require the organization to appropriately inventory and classify data assets so the tool knows what to protect. DLP does not aid in protections for DDoS or natural disasters, which affect availability, not confidentiality (DLP only enhances confidentiality efforts). Option C is not a benefit of implementing an egress monitoring solution.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      412,
      688,
      29,
      28,
      413
    ],
    "source": ""
  },
  {
    "id": 668,
    "question": "Egress monitoring solutions usually include a function that ___________________.",
    "choice_a": "Arbitrates contract breaches",
    "choice_b": "Performs personnel evaluation reviews",
    "choice_c": "Discovers data assets according to classification/categorization",
    "choice_d": "Applies another level of access control",
    "correct_answer": "C",
    "explanation": "Egress monitoring solutions (often referred to as DLP tools, where DLP stands for data loss protection or data leak prevention, or some combination of these terms) will often include a discovery function, which will locate data assets according to criteria defined by the organization. DLP solutions cannot arbitrate contract breaches or perform personnel evaluations. Usually, DLPs also do not apply additional access controls; that is typically a characteristic of a digital rights management (DRM) solution.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      688,
      510,
      28,
      414,
      412
    ],
    "source": ""
  },
  {
    "id": 669,
    "question": "Egress monitoring solutions usually include a function that ___________________.",
    "choice_a": "Uses biometrics to scan users",
    "choice_b": "Inspects incoming packets",
    "choice_c": "Resides on client machines",
    "choice_d": "Uses stateful inspection",
    "correct_answer": "C",
    "explanation": "Egress monitoring solutions (often referred to as DLP tools, where DLP stands for data loss protection or data leak prevention, or some combination of these terms) will often include an agent that resides on client devices in order to inspect data being shared/sent by end users. DLP tools do not inspect incoming packets, with or without stateful inspection; this is the job of firewalls. DLP solutions do not typically use biometrics in any way.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      413,
      412,
      414,
      500,
      689
    ],
    "source": ""
  },
  {
    "id": 670,
    "question": "Digital rights management (DRM) solutions (sometimes referred to as information rights management, or IRM) can be used to protect all sorts of sensitive data but are usually particularly designed to secure ___________.",
    "choice_a": "Personally identifiable information (PII)",
    "choice_b": "Intellectual property",
    "choice_c": "Plans and policies",
    "choice_d": "Marketing material",
    "correct_answer": "B",
    "explanation": "DRM is mainly designed to protect intellectual property. It can also sometimes be used for securing PII, but intellectual property is a better answer here. Plans and policies aren\u2019t usually protected in this manner, and marketing material is usually meant to be disseminated, so it does not require protection.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      385,
      386,
      396,
      31,
      33
    ],
    "source": ""
  },
  {
    "id": 671,
    "question": "Digital rights management (DRM) solutions (sometimes referred to as information rights management, or IRM) often protect unauthorized distribution of what type of intellectual property?",
    "choice_a": "Patents",
    "choice_b": "Trademarks",
    "choice_c": "Personally identifiable information (PII)",
    "choice_d": "Copyright",
    "correct_answer": "D",
    "explanation": "DRM is often deployed to ensure that copyrighted material (frequently software) is only delivered to and used by licensed recipients. Patents are more complicated and not often distributed to a mass market, so DRM does not assist in that way. Trademarks are representations of a brand and meant to be distributed, so DRM does not protect them. PII is not typically a type of intellectual property.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      31,
      394,
      32,
      33,
      385
    ],
    "source": ""
  },
  {
    "id": 672,
    "question": "Which of the following characteristics is associated with digital rights management (DRM) solutions (sometimes referred to as information rights management, or IRM)?",
    "choice_a": "Persistence",
    "choice_b": "Influence",
    "choice_c": "Resistance",
    "choice_d": "Trepidation",
    "correct_answer": "A",
    "explanation": "Persistence is the trait that allows DRM protection to follow protected files wherever they might be stored/copied. The other options are not characteristics associated with DRM solutions.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      32,
      31,
      380,
      394,
      33
    ],
    "source": ""
  },
  {
    "id": 673,
    "question": "Which of the following characteristics is associated with digital rights management (DRM) solutions (sometimes referred to as information rights management, or IRM)?",
    "choice_a": "Automatic expiration",
    "choice_b": "Multilevel aggregation",
    "choice_c": "Enhanced detail",
    "choice_d": "Broad spectrum",
    "correct_answer": "A",
    "explanation": "Automatic expiration is the trait that allows DRM tools to prevent access to objects when a license expires or to remove protections when intellectual property moves into the public domain. The other options are not characteristics associated with DRM solutions.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      32,
      395,
      380,
      31,
      33
    ],
    "source": ""
  },
  {
    "id": 674,
    "question": "Which of the following characteristics is associated with digital rights management (DRM) solutions (sometimes referred to as information rights management, or IRM)?",
    "choice_a": "Transparent encryption modification",
    "choice_b": "Bilateral enhancement",
    "choice_c": "Continuous audit trail",
    "choice_d": "Encompassing flow",
    "correct_answer": "C",
    "explanation": "Continuous audit trail is the trait that allows DRM tools to log and exhibit all access to a given object. The other options are not characteristics associated with DRM solutions.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      32,
      31,
      720,
      38,
      39
    ],
    "source": ""
  },
  {
    "id": 675,
    "question": "Which of the following characteristics is associated with digital rights management (DRM) solutions (sometimes referred to as information rights management, or IRM)?",
    "choice_a": "Mapping to existing access control lists (ACLs)",
    "choice_b": "Delineating biometric catalogs",
    "choice_c": "Preventing multifactor authentication",
    "choice_d": "Prohibiting unauthorized transposition",
    "correct_answer": "A",
    "explanation": "Mapping to existing access control lists (ACLs) is the trait that allows DRM tools to provide additional access control protections for the organization\u2019s assets. The other options are not characteristics associated with DRM solutions.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      32,
      31,
      380,
      395,
      386
    ],
    "source": ""
  },
  {
    "id": 676,
    "question": "According to the  ISC2 Cloud Secure Data Lifecycle, which phase comes soon after (or at the same time as) the Create phase?",
    "choice_a": "Store",
    "choice_b": "Use",
    "choice_c": "Deploy",
    "choice_d": "Archive",
    "correct_answer": "A",
    "explanation": "The Cloud Secure Data Life Cycle phases are, in order, Create, Store, Use, Share, Archive, Destroy (a good mnemonic might be CSU-SAD). <br>Options B and D are phases of CSU-SAD but do not immediately follow Create. <br>Option C is not a phase of CSU-SAD.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      493,
      494,
      495,
      497,
      498
    ],
    "source": ""
  },
  {
    "id": 677,
    "question": "According to the  ISC2 Cloud Secure Data Life Cycle, which phase comes immediately before the Share phase?",
    "choice_a": "Create",
    "choice_b": "Destroy",
    "choice_c": "Use",
    "choice_d": "Encrypt",
    "correct_answer": "C",
    "explanation": "The Cloud Secure Data Life Cycle phases are, in order, Create, Store, Use, Share, Archive, Destroy (a good mnemonic might be CSU-SAD). <br>Options A and B are phases of CSU-SAD but do not immediately precede Share. <br>Option D is not a phase of CSU-SAD.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      497,
      495,
      498,
      496,
      493
    ],
    "source": ""
  },
  {
    "id": 678,
    "question": "Why is the term  ISC2 Cloud Secure Data Life Cycle actually somewhat inaccurate?",
    "choice_a": "The term is not used only by  ISC2.",
    "choice_b": "Not all phases are secure.",
    "choice_c": "Not all phases take place in the cloud.",
    "choice_d": "It\u2019s not actually a cycle.",
    "correct_answer": "D",
    "explanation": "The Cloud Secure Data Life Cycle phases are, in order, Create, Store, Use, Share, Archive, Destroy (a good mnemonic might be CSU-SAD). This is not truly a cycle because data does not continue after the destroy phase (that is to say, the same data or process does not go back to create after destroy). <br>Option A might be considered true because the CSU-SAD cycle is not unique to  ISC2, but this is not the best answer; option D is preferable because it is not truly a cycle. <br>Options B and C are incorrect because activity in each of the phases involves security aspects and all phases relate to how data is involved in the cloud.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      497,
      495,
      498,
      496,
      493
    ],
    "source": ""
  },
  {
    "id": 679,
    "question": "According to the ISC2 Cloud Secure Data Life Cycle, in which phase should the process of categorization/classification of data occur?",
    "choice_a": "Create",
    "choice_b": "Store",
    "choice_c": "Define",
    "choice_d": "Use",
    "correct_answer": "A",
    "explanation": "The Cloud Secure Data Life Cycle phases are, in order, Create, Store, Use, Share, Archive, Destroy (a good mnemonic might be CSU-SAD). The best practice for categorizing/classifying data is to do so when it is first created/collected so that the proper security controls can be applied to it throughout the rest of the cycle. <br>Options B and D are phases of the CSU-SAD but are not the proper times to be applying classification/categorization; that would be too late in the cycle. <br>Option C is not a phase of CSU-SAD.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      497,
      493,
      494,
      495,
      29
    ],
    "source": ""
  },
  {
    "id": 680,
    "question": "Which of the following should occur during the final phase of the Cloud Secure Data Life Cycle?",
    "choice_a": "Data dispersion",
    "choice_b": "Crypto-shredding",
    "choice_c": "Cryptoparsing",
    "choice_d": "Cryptosporidium",
    "correct_answer": "B",
    "explanation": "The Cloud Secure Data Life Cycle phases are, in order, Create, Store, Use, Share, Archive, Destroy (a good mnemonic might be CSU-SAD). Crypto-shredding (also called cryptographic erasure) is the preferred method of data sanitization for a cloud environment; this should take place in the final phase of the cycle, destroy. <br>Option A is incorrect because data dispersion is a means of making data more resilient and secure; in the final phase of the cycle, we want to get rid of the data, not make it resistant to loss. <br>Option C is incorrect because cryptoparsing is a made-up term and used here as a distractor. <br>Option D is incorrect because cryptosporidium is a microorganism and is not associated with InfoSec.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      40,
      41,
      496,
      497,
      495
    ],
    "source": ""
  },
  {
    "id": 681,
    "question": "At what phase of the Cloud Secure Data Life Cycle does data enter long-term storage?",
    "choice_a": "The first",
    "choice_b": "The second",
    "choice_c": "The fourth",
    "choice_d": "The fifth",
    "correct_answer": "D",
    "explanation": "The Cloud Secure Data Life Cycle phases are, in order, Create, Store, Use, Share, Archive, Destroy (a good mnemonic might be CSU-SAD). Archiving (the fifth phase) is the process of moving data out of the production environment and into long-term storage. <br>The other phases in the options are create, store, and share and are therefore incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      497,
      495,
      496,
      36,
      34
    ],
    "source": ""
  },
  {
    "id": 682,
    "question": "What is a form of cloud storage where data is stored as objects, arranged in a hierarchal structure, like a file tree?",
    "choice_a": "Volume storage",
    "choice_b": "Databases",
    "choice_c": "Content delivery network (CDN)",
    "choice_d": "Object storage",
    "correct_answer": "D",
    "explanation": "Object storage stores data as objects (hence the name), often arranged in a hierarchical structure. <br>Volume storage is not a hierarchal cloud storage structure and is therefore an incorrect answer for this question. <br>Option B is incorrect because databases are applications in both traditional and cloud computing. <br>A CDN is a geographically distributed network of proxy servers and their data centers. Option C is incorrect because it is not a form of cloud storage.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      494,
      497,
      442,
      443,
      409
    ],
    "source": ""
  },
  {
    "id": 683,
    "question": "What is a form of cloud storage where data is stored in a logical storage area assigned to the user but not necessarily physically attached or even geographically proximate to the compute node the user is utilizing?",
    "choice_a": "Volume storage",
    "choice_b": "Databases",
    "choice_c": "Content delivery network (CDN)",
    "choice_d": "Object storage",
    "correct_answer": "A",
    "explanation": "In volume storage, the user is assigned a logical drive space into which anything (such as raw data, objects, or applications) may be saved or installed, similar to a mounted drive on a traditional network. <br>Databases store data in an arrangement of characteristics and values, not in an unstructured drive space, so option B is incorrect. <br>CDNs are for distributing data with less chance of quality loss, so option C is incorrect. <br>Object storage arranges data as objects in a structured hierarchy, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      442,
      443,
      444,
      494,
      493
    ],
    "source": ""
  },
  {
    "id": 684,
    "question": "What is a form of cloud storage often used for streaming multimedia data to users?",
    "choice_a": "Volume storage",
    "choice_b": "Databases",
    "choice_c": "Content delivery network (CDN)",
    "choice_d": "Neutral storage",
    "correct_answer": "C",
    "explanation": "CDNs are often used to place large stores of multimedia data in a location geographically near to the end users who will consume that data; this approach is designed mostly to accomplish a reduction in data degradation due to distance between resource and user. <br>Volume storage assigns a logical, unstructured drive space to the user, so option A is incorrect. <br>Databases store data in an arrangement of characteristics and values, so option B is incorrect. <br>Neutral storage is not a form of cloud storage, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      36,
      442,
      443,
      420,
      386
    ],
    "source": ""
  },
  {
    "id": 685,
    "question": "What type of data storage is often used in platform as a service (PaaS) arrangements?",
    "choice_a": "Ephemeral",
    "choice_b": "Database",
    "choice_c": "Long-term",
    "choice_d": "Nefarious",
    "correct_answer": "B",
    "explanation": "The PaaS model allows the cloud customer to install and run applications in the cloud environment. With a database, the cloud customer can store data in a database administered by the cloud provider but can then tailor applications and services for reaching into and manipulating that database. <br>Ephemeral and long-term storage take place in the software as a service (SaaS) model, and there is no such thing as \u201cnefarious data storage,\u201d so the other options are incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      411,
      493,
      494,
      442,
      371
    ],
    "source": ""
  },
  {
    "id": 686,
    "question": "What is a form of cloud data protection where data is spread across multiple storage devices/locations, similar to RAID in the legacy environment?",
    "choice_a": "Infringing",
    "choice_b": "Data dispersion",
    "choice_c": "Voiding",
    "choice_d": "Crypto-shredding",
    "correct_answer": "B",
    "explanation": "Data dispersion is the cloud version of using RAID arrays, protecting data by spreading it across multiple volumes/devices. <br>Options A and C are terms that have no meaning in this context.<br>Crypto-shredding is a form of device/media sanitization utilizing cryptography and has nothing to do with RAID, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      442,
      443,
      410,
      41,
      40
    ],
    "source": ""
  },
  {
    "id": 687,
    "question": "Erasure coding, in the cloud, is similar to what element of RAID implementations in a traditional IT environment?",
    "choice_a": "Deltas",
    "choice_b": "Inversion",
    "choice_c": "Parity bits",
    "choice_d": "Transposition",
    "correct_answer": "C",
    "explanation": "Similar to parity bits in RAID, erasure coding is used in cloud data dispersion implementations to create a situation where data can still be recovered even if a segment or portion of the dispersed data is lost (due to drive failure, disaster, etc.). <br>Options A and B have no meaning in this context so they are incorrect. <br>Transposition is a cryptographic technique and does not relate to RAID in any way, so option D is also incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      442,
      443,
      444,
      507,
      494
    ],
    "source": ""
  },
  {
    "id": 688,
    "question": "DLP (data loss prevention or data leak protection) solutions are implemented in the hopes of securing ___________________.",
    "choice_a": "Sensitive data that may leave the organization\u2019s control",
    "choice_b": "All data within the organization\u2019s control",
    "choice_c": "Data being processed by the organization\u2019s users",
    "choice_d": "Data that could be intercepted while out of the organization\u2019s control",
    "correct_answer": "A",
    "explanation": "DLP, also referred to as egress monitoring, is used to detect and prevent sensitive data from leaving the organization\u2019s control without proper approval. <br>Because it is designed to prevent the egress of only certain data sets, options B and C are not correct. <br>Controlling data outside the reach of the organization is difficult at best. While there are some mechanisms that might accomplish this, DLP is not specifically designed for that purpose, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      412,
      414,
      250,
      413,
      689
    ],
    "source": ""
  },
  {
    "id": 689,
    "question": "Which of the following will DLP (data loss prevention or data leak protection) solutions most likely <italic>not</italic> inspect?",
    "choice_a": "Email content",
    "choice_b": "FTP traffic",
    "choice_c": "Material saved to portable media",
    "choice_d": "Voice over Internet Protocol\u00a0(VoIP) conversations",
    "correct_answer": "D",
    "explanation": "Commercial DLP products that monitor speech in real time and censor conversations are not yet widely available. <br>A proper DLP solution will monitor all the technologies in the other options, so those are incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      500,
      499,
      413,
      414,
      690
    ],
    "source": ""
  },
  {
    "id": 690,
    "question": "DLP (data loss prevention or data leak protection) solutions may use all of the following techniques to identify sensitive data <italic>except</italic> ___________________.",
    "choice_a": "Pattern matching",
    "choice_b": "Inference",
    "choice_c": "Keyword identification",
    "choice_d": "Metadata tags",
    "correct_answer": "B",
    "explanation": "Inference is an attack technique that derives sensitive material from an aggregation of innocuous data; DLP tools, thus far, do not have this capability. <br>All the other techniques listed may be used by DLP solutions to detect sensitive data before it leaves the control of the owner.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      690,
      414,
      413,
      499,
      28
    ],
    "source": ""
  },
  {
    "id": 691,
    "question": "You are the security manager of a small firm that has just purchased an egress monitoring solution to implement in your cloud-based production environment. In which of the following cases would you <italic>not</italic> have to get permission from the cloud provider to install and implement the tool?",
    "choice_a": "If it\u2019s hardware-based and your production environment is in an infrastructure as a service (IaaS) model",
    "choice_b": "If you purchased it from a vendor other than the cloud provider",
    "choice_c": "If it\u2019s software-based and your production environment is in a platform as a service (PaaS) model",
    "choice_d": "If it affects all guest instances on any given host device",
    "correct_answer": "C",
    "explanation": "A cloud customer can install applications on a PaaS environment, usually as they see fit and without prior coordination with the provider. <br>If you are introducing hardware into the cloud environment, you will need permission from your cloud provider, regardless of the deployment model you use. Therefore, option A is incorrect (and unlikely to occur, as permission is probably not going to be granted). <br>Although the provider may offer an egress monitoring function as an add-on service, which would be permissible for you to use, the use of an outside vendor\u2019s product may have to be reviewed by the provider before implementation, based on a number of other variables (such as the other possible answers). Option C is preferable, so option B is incorrect. <br>Affecting all images on a host may impact other customers in a multitenant environment, so option D is not the correct answer.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      412,
      33,
      32,
      24,
      39
    ],
    "source": ""
  },
  {
    "id": 692,
    "question": "You are the security manager of a small firm that has just purchased an egress monitoring solution to implement in your cloud-based production environment. Before implementing the solution, what should you explain to senior management?",
    "choice_a": "The additional risks of external attack associated with using the tool",
    "choice_b": "The production impact it will have on the environment",
    "choice_c": "What the price of the tool was",
    "choice_d": "How the solution works",
    "correct_answer": "B",
    "explanation": "All security functions come with an attendant negative productivity effect: the most secure environment will be the least productive, and the most productive will be the least secure. Egress monitoring tools will have an overhead cost in terms of production impact and loss of efficiency and speed. This may affect the cost savings that were realized in a cloud migration from the legacy environment, and senior management needs to understand this trade-off. <br>Implementing an egress monitoring solution should not incur any additional risks of external attack, so option A is incorrect. <br>Because the tool has already been purchased, explaining the purchase price is irrelevant at this point, so option C is incorrect. <br>If it was germane (and it was likely not), you should have explained how the tool works before purchasing it; explaining at this point might be interesting but is not as important as option B, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      412,
      506,
      414,
      499,
      396
    ],
    "source": ""
  },
  {
    "id": 693,
    "question": "You are the security manager of a small firm that has just purchased an egress monitoring solution to implement in your cloud-based production environment. Which of these activities should you perform before deploying the tool?",
    "choice_a": "Survey your company\u2019s departments about the data under their control.",
    "choice_b": "Reconstruct your firewalls.",
    "choice_c": "Harden all your routers.",
    "choice_d": "Adjust the hypervisors.",
    "correct_answer": "A",
    "explanation": "In order to \u201ctrain\u201d the egress monitoring solution properly, you\u2019ll need to inform it as to which data in your organization is sensitive\u2026and, in order to do that, you\u2019ll need to determine what information your data owners deem sensitive; a survey is a way to do that. <br>A proper egress monitoring solution should not affect or be affected by the firewalls, routers, or hypervisors, so options B, C, and D are incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      412,
      25,
      29,
      24,
      26
    ],
    "source": ""
  },
  {
    "id": 694,
    "question": "You are the security manager of a small firm that has just purchased an egress monitoring solution to implement in your cloud-based production environment. What should you expect immediately following the implementation of the tool?",
    "choice_a": "Immediate decrease in lost data",
    "choice_b": "A series of false-positive indications",
    "choice_c": "Increase in morale across the organization",
    "choice_d": "Increase in gross revenue",
    "correct_answer": "B",
    "explanation": "It will take a while for the tool to \u201clearn\u201d the particulars of your environment and to be conditioned properly. A significant number of false-positive indications will be expected in the near term, until you can hone the responses to properly meet your organization\u2019s needs. <br>The tool will not work optimally immediately upon implementation, so option A is incorrect. <br>Egress monitoring tools do not affect morale or revenues, so options C and D are incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      412,
      38,
      39,
      510,
      414
    ],
    "source": ""
  },
  {
    "id": 695,
    "question": "You are the security manager of a small firm that has just purchased an egress monitoring solution to implement in your cloud-based production environment. What should you <italic>not</italic> expect the tool to address?",
    "choice_a": "Sensitive data sent inadvertently in user emails",
    "choice_b": "Sensitive data captured by screenshots",
    "choice_c": "Sensitive data moved to external devices",
    "choice_d": "Sensitive data in the contents of files sent via File Transfer Protocol (FTP)",
    "correct_answer": "B",
    "explanation": "It\u2019s unlikely that any egress monitoring tools will be able to detect sensitive data captured, stored, and/or sent as graphic image files, which is the usual form of screenshots. <br>A proper egress monitoring tool should be able to detect all the other types of activity, so the other options are incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      499,
      500,
      414,
      28,
      510
    ],
    "source": ""
  },
  {
    "id": 696,
    "question": "You are the security manager of a small firm that has just purchased an egress monitoring solution to implement in your cloud-based production environment. In order to get truly holistic coverage of your environment, you should be sure to include _______ as a step in the deployment process.",
    "choice_a": "Getting signed user agreements from all users",
    "choice_b": "Installation of the solution on all assets in the cloud data center",
    "choice_c": "Adoption of the tool in all routers between your users and the cloud provider",
    "choice_d": "Ensuring that all your customers install the tool",
    "correct_answer": "A",
    "explanation": "This is a tricky question. In the cloud environment, we know that all users will be entering the environment through remote access; in many cases, this will include the use of their personal devices. In order for egress monitoring solutions to function properly, all devices accessing the production environment must have local agents installed, and that requires signed user agreements. <br>It would be unnecessary (and intrusive, and cumbersome) to install agents on all assets in the cloud data center, which includes not only your organization\u2019s assets but also those of all the other cloud tenants in that data center. This might even be illegal. Option B is incorrect. <br>Assuming you could install (or even know) all the routers between your users and the cloud data center is ridiculous; option C is incorrect. <br>Getting your customer to install an egress monitoring client would be nice, in theory\u2026but also pointless. Your customers don\u2019t work for you; they are outside your organization. Egress monitoring tools are used to prevent sensitive data from leaving your environment; by the time it has reached a customer, sensitive information is far outside your control and the egress monitoring tool would be of no use. Option D is therefore incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      412,
      499,
      32,
      24,
      510
    ],
    "source": ""
  },
  {
    "id": 697,
    "question": "You are the security manager of a small firm that has just purchased an egress monitoring solution to implement in your cloud-based production environment. In order to increase the security value of the tool, you should consider combining it with ___________________.",
    "choice_a": "Digital rights management (DRM) and security event and incident management (SIEM) tools",
    "choice_b": "An investment in upgraded project management software",
    "choice_c": "Digital insurance policies",
    "choice_d": "The Uptime Institute\u2019s Tier certification",
    "correct_answer": "A",
    "explanation": "Egress monitoring tools combined with DRM and SIEM enhance the security value of each because you create in-depth/layered defense. <br>Project management software does not really have anything to do with security, so option B is incorrect. <br>Insurance is a risk transfer mechanism and does not aid in risk mitigation efforts; egress monitoring is for risk mitigation, so option C is incorrect. <br>The Tier certification program is for the cloud provider and is not used by the cloud customer, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      412,
      31,
      38,
      252,
      414
    ],
    "source": ""
  },
  {
    "id": 698,
    "question": "You are the security manager of a small firm that has just purchased an egress monitoring solution to implement in your cloud-based production environment. You are interested in fielding the solution as an awareness tool to optimize security for your organization through conditioning user behavior. You decide to set the solution to ___________________.",
    "choice_a": "Suspend user accounts and notify the security office when it detects possible sensitive data egress attempted by a user",
    "choice_b": "Halt the transaction and notify the user\u2019s supervisor when the user attempts to transfer sensitive data",
    "choice_c": "Query the user as to whether they intend to send sensitive data upon detection of an attempted transfer",
    "choice_d": "Sever remote connections upon detection of a possible sensitive data transfer",
    "correct_answer": "C",
    "explanation": "These are all possible settings for a modern egress monitoring solution. However, the best option, in light of the question, is to query the user as to their intent; this aids the user in understanding and knowing when sensitive data might be leaving the organization accidentally, through a mistake on the user\u2019s part. The other options are more severe and restrictive; these will enhance security but reduce productivity and are management and technological controls instead of awareness tools, so they are incorrect answers for this question.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      412,
      499,
      29,
      26,
      38
    ],
    "source": ""
  },
  {
    "id": 699,
    "question": "You are the security manager of a small firm that has just purchased an egress monitoring solution to implement in your cloud-based production environment. You understand that all of the following aspects of cloud computing may make proper deployment of the tool difficult or costly <italic>except</italic> ___________________.",
    "choice_a": "Data will not remain in one place or form in the cloud",
    "choice_b": "The cloud environment will include redundant and resilient architecture",
    "choice_c": "There will be a deleterious impact on production upon installing the tool",
    "choice_d": "You might not have sufficient proper administrative rights in the cloud infrastructure",
    "correct_answer": "B",
    "explanation": "The fact that cloud data centers are designed with multiple redundancies of all systems and components won\u2019t really have any bearing on your decision and implementation of your egress monitoring solution. <br>Because data will move across nodes in the data center and will take different forms (such as live data in a virtualized instance or snapshotted data saved in a file store when a virtual machine is not being used at a specific moment), you will have to determine how the tool will function in that environment, and whether it was designed for cloud usage. Option A is incorrect. <br>Option C is true for any environment, not just the cloud; all security functions necessarily negatively impact operations and production. Option B is a better answer. <br>Option D is also correct; without administrative privileges to the underlying hardware (which customers should not have), the customer may not be able to install monitoring agents everywhere necessary for those tools to work properly.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      412,
      500,
      38,
      39,
      510
    ],
    "source": ""
  },
  {
    "id": 700,
    "question": "Egress monitoring solutions can aid all of the following security-related efforts <italic>except</italic> ___________________.",
    "choice_a": "Access control",
    "choice_b": "Data exfiltration",
    "choice_c": "E-discovery/forensics",
    "choice_d": "Data categorization/classification",
    "correct_answer": "A",
    "explanation": "Egress monitoring solutions do not facilitate access control efforts in any way. <br>Egress monitoring tools do, however, provide all the functions listed in the other options, so those are incorrect.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      414,
      412,
      499,
      395,
      31
    ],
    "source": ""
  },
  {
    "id": 701,
    "question": "The cloud security professional should be aware that encryption would most likely be necessary in all the following aspects of a cloud deployment <italic>except</italic> ___________________.",
    "choice_a": "Data at rest",
    "choice_b": "Data in motion",
    "choice_c": "Data in use",
    "choice_d": "Data of relief",
    "correct_answer": "D",
    "explanation": "The term <italic>data of relief</italic> doesn\u2019t really mean anything and is therefore the correct answer for this question. <br>Encryption is used in all other aspects of cloud data.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      494,
      497,
      507,
      418,
      493
    ],
    "source": ""
  },
  {
    "id": 702,
    "question": "As with the traditional IT environment, cloud data encryption includes all the following elements <italic>except</italic> ___________________.",
    "choice_a": "The user",
    "choice_b": "The data itself",
    "choice_c": "The encryption engine",
    "choice_d": "The encryption keys",
    "correct_answer": "A",
    "explanation": "The user is not really an aspect of an encryption deployment, although it may be argued that the user will need to refrain from disclosing their own key(s) to anyone else. <br>The other three options are the components of an encryption deployment.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      418,
      503,
      507,
      394,
      395
    ],
    "source": ""
  },
  {
    "id": 703,
    "question": "Volume storage encryption in an infrastructure as a service (IaaS) arrangement will protect against data loss due to all of the following activities <italic>except</italic> ___________________.",
    "choice_a": "Physical loss or theft of a device",
    "choice_b": "Disgruntled users",
    "choice_c": "Malicious cloud administrators accessing the data",
    "choice_d": "Virtual machine snapshots stolen from storage",
    "correct_answer": "B",
    "explanation": "An authorized user will still be able to access and decrypt the data for which they\u2019ve been granted permissions, so encryption will not offer any protections for that threat. <br>Volume storage encryption will, however, protect against all the other threats, because any outsider (that is, a person who does not have access to the volume operating system) will be able to steal only encrypted data, which they should not be able to decrypt in a timely fashion. Therefore, all the other options are incorrect.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      418,
      503,
      507,
      395,
      719
    ],
    "source": ""
  },
  {
    "id": 704,
    "question": "In an infrastructure as a service (IaaS) arrangement, all of the following are examples of object storage encryption <italic>except</italic> ___________________.",
    "choice_a": "File-level encryption",
    "choice_b": "Digital rights management (DRM)",
    "choice_c": "Application-level encryption",
    "choice_d": "Transport Layer Security (TLS)",
    "correct_answer": "D",
    "explanation": "TLS is encryption used in a communication session, not a storage volume. <br>All the other options are examples of object storage encryption options, so they are incorrect.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      503,
      507,
      418,
      494,
      395
    ],
    "source": ""
  },
  {
    "id": 705,
    "question": "All of the following are database encryption options that could be used in a platform as a service (PaaS) implementation <italic>except</italic> ___________________.",
    "choice_a": "File-level encryption",
    "choice_b": "Secure Sockets Layer (SSL)",
    "choice_c": "Transparent encryption",
    "choice_d": "Application-level encryption",
    "correct_answer": "B",
    "explanation": "SSL is encryption used in a communication session, not a storage volume. <br>All the other options are examples of database encryption options, so they are incorrect.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      418,
      503,
      507,
      494,
      411
    ],
    "source": ""
  },
  {
    "id": 706,
    "question": "In application-level encryption, where does the encryption engine reside?",
    "choice_a": "In the application accessing the database",
    "choice_b": "In the operating system on which the application is run",
    "choice_c": "Within the database accessed by the application",
    "choice_d": "In the volume where the database resides",
    "correct_answer": "A",
    "explanation": "The application contains the encryption engine used in application-level encryption. <br>The operating system is responsible for providing the resources an application needs and for running the applications. The operating system does not do application-level encryption, so option B is incorrect. <br>Option C is incorrect because application-level encryption is performed by the application that interfaces with the database. <br>The application-level encryption engine may or may not reside in the same volume as the database engine, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      418,
      503,
      507,
      494,
      31
    ],
    "source": ""
  },
  {
    "id": 707,
    "question": "Which of the following database encryption techniques can be used to encrypt specific tables within the database?",
    "choice_a": "File-level encryption",
    "choice_b": "Transparent encryption",
    "choice_c": "Application-level encryption",
    "choice_d": "Object-level encryption",
    "correct_answer": "B",
    "explanation": "Encrypting specific tables within the database is one of the options of transparent encryption; this is not true of the other options, so they are incorrect.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      494,
      255,
      254,
      386,
      396
    ],
    "source": ""
  },
  {
    "id": 708,
    "question": "Which of the following database encryption techniques makes it difficult to perform database functions (searches, indexing, etc.)?",
    "choice_a": "File-level encryption",
    "choice_b": "Transparent encryption",
    "choice_c": "Application-level encryption",
    "choice_d": "Volume encryption",
    "correct_answer": "C",
    "explanation": "Application-level encryption involves encrypting the data before it enters the fields of the database; it is much more difficult to search and review data that has been encrypted, so this reduces the functionality of the database. <br>All the other options are incorrect because they are not database encryption techniques.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      503,
      507,
      255,
      494,
      418
    ],
    "source": ""
  },
  {
    "id": 709,
    "question": "According to  ISC2, where should the cloud customer\u2019s encryption keys be stored?",
    "choice_a": "With the cloud customer",
    "choice_b": "With a third-party provider",
    "choice_c": "At the cloud provider data center",
    "choice_d": "Anywhere but with the cloud provider",
    "correct_answer": "D",
    "explanation": "Best practice is to not keep the encryption keys alongside the data they\u2019ve been used to encrypt. <br>Options A and B are both viable but not as good as option D, which is more general and includes them both. <br>Option C is clearly incorrect because it is counter to the best practice advice offered by  ISC2.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      418,
      494,
      41,
      503,
      507
    ],
    "source": ""
  },
  {
    "id": 710,
    "question": "Which of the following is <italic>not</italic> used to determine data retention requirements?",
    "choice_a": "Legislation",
    "choice_b": "Business needs",
    "choice_c": "Average media longevity",
    "choice_d": "Contracts",
    "correct_answer": "C",
    "explanation": "Data retention periods should be established in policy regardless of the projected lifetime of the media the data resides on. All the other options do/should influence data retention periods.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      34,
      377,
      29,
      25,
      392
    ],
    "source": ""
  },
  {
    "id": 711,
    "question": "Event monitoring tools (security information and event management [SIEM]/security information management [SIM]/security event management [SEM]) can aid in which of the following efforts?",
    "choice_a": "External hacking detection",
    "choice_b": "Prediction of physical device theft",
    "choice_c": "Data classification/categorization issues",
    "choice_d": "Social engineering attacks",
    "correct_answer": "A",
    "explanation": "Event monitoring tools can help detect external hacking efforts by tracking and reporting on common hack-related activity, such as repeated failed login attempts and scanning. It is unlikely that these tools could predict physical device theft; they could, of course, report on a device that is no longer connected to the environment after it has been removed by noting a lack of event activity, but that\u2019s not quite the same thing. Event monitoring tools don\u2019t aid in data classification/categorization; egress monitoring and digital rights management tools might provide that function, though. Social engineering attacks are mostly transparent to the majority of logical tools (the exception being social engineering efforts combined with IT traffic, such as phishing, which might be detected by email filters and sophisticated firewalls).",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      38,
      413,
      412,
      500,
      414
    ],
    "source": ""
  },
  {
    "id": 712,
    "question": "Event monitoring tools (security information and event management [SIEM]/security information management [SIM]/security event management [SEM]) can aid in which of the following efforts?",
    "choice_a": "Detecting untrained personnel",
    "choice_b": "Predicting system outages",
    "choice_c": "Sending alerts for conflicts of interest",
    "choice_d": "Enforcing mandatory vacation",
    "correct_answer": "B",
    "explanation": "Event monitoring tools can be used to predict system outages by noting decreases in performance; repeated performance issues can be an indicator a device is failing. While an event monitoring tool might be able to detect a user who continually conducts unproductive activity or fails to complete certain functions, it is impossible to determine if the source of the problem is lack of training. These tools in no way serve to detect conflict of interest or enforce mandatory vacation, which are managerial/administrative controls.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      38,
      720,
      412,
      413,
      500
    ],
    "source": ""
  },
  {
    "id": 713,
    "question": "Event monitoring tools (security information and event management [SIEM]/security information management [SIM]/security event management [SEM]) can aid in which of the following efforts?",
    "choice_a": "Reducing workload for production personnel",
    "choice_b": "Decreasing size of log files",
    "choice_c": "Optimizing performance",
    "choice_d": "Ensuring adequate lighting of workspaces",
    "correct_answer": "C",
    "explanation": "Event monitoring tools can detect repeated performance issues, which can be used by administrators and architects to enhance performance/productivity. These tools don\u2019t aid in the managerial function of noting individual workload, nor do they reduce log file sizes (indeed, they might add to the size of log files) or have anything to do with lighting.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      39,
      38,
      510,
      413,
      500
    ],
    "source": ""
  },
  {
    "id": 714,
    "question": "Event monitoring tools (security information and event management [SIEM]/security information management [SIM]/security event management [SEM]) can aid in which of the following efforts?",
    "choice_a": "Detecting ambient heating, ventilation, and air-conditioning (HVAC) problems",
    "choice_b": "Ensuring proper cloud migration",
    "choice_c": "Deciding risk parameters",
    "choice_d": "Protecting all physical entry points against the threat of fire",
    "correct_answer": "A",
    "explanation": "Event monitoring tools can detect repeated performance issues, which can be indicative of improper temperature settings in the data center; also, some system monitoring metrics, such as CPU temperature, can directly indicate inadequate HVAC performance. These tools do not aid in cloud migration (which is the task of architects and administrators) nor in risk decisions (which is the task of senior management); they also don\u2019t provide any kind of assistance with fire.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      38,
      39,
      412,
      500,
      374
    ],
    "source": ""
  },
  {
    "id": 715,
    "question": "In addition to predictive capabilities, event monitoring tools (security information and event management [SIEM]/security information management [SIM]/security event management [SEM]) are instrumental in what other security function?",
    "choice_a": "Personnel safety",
    "choice_b": "Vehicle tracking",
    "choice_c": "Incident evidence",
    "choice_d": "Acoustic dampening",
    "correct_answer": "C",
    "explanation": "Event logs are used to reconstruct a narrative of activity; they tell the story of what happened, how it happened, and so forth. This is crucial for evidentiary purposes. Event logging tools do not aid in any of the other options (especially \u201cacoustic dampening,\u201d which is gibberish in this context).",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      38,
      37,
      720,
      36,
      510
    ],
    "source": ""
  },
  {
    "id": 716,
    "question": "Which of the following is one of the benefits of event monitoring tools (security information and event management [SIEM]/security information management [SIM]/security event management [SEM])?",
    "choice_a": "Greater physical security",
    "choice_b": "Psychological deterrence",
    "choice_c": "Cost savings",
    "choice_d": "More logs can be reviewed, at faster speeds",
    "correct_answer": "D",
    "explanation": "The manual element of log review is tedious and necessarily slow because it requires a trained, knowledgeable person to perform the task; these tools can greatly increase the amount of log data that can be reviewed, in a much shorter amount of time. These tools do not, however, aid in any of the other options.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      38,
      39,
      413,
      510,
      374
    ],
    "source": ""
  },
  {
    "id": 717,
    "question": "As in a traditional IT environment, proper key management is crucial in the cloud. Which of the following principles is <italic>not</italic> true regarding key management?",
    "choice_a": "It is good practice to introduce pseudorandom numbers when generating keys.",
    "choice_b": "Public keys should never be shared with anyone.",
    "choice_c": "Losing the keys is equivalent to losing the data.",
    "choice_d": "Symmetric keys should be passed out of band.",
    "correct_answer": "B",
    "explanation": "Public keys have to be shared in order for asymmetric cryptography to function properly; that is their purpose. Private keys, on the other hand, must remain secret, known only to the individuals to whom they are assigned. <br>Seeding key generation processes with pseudorandom numbers makes decryption that much more difficult and is a desired practice, so option A is incorrect. <br>Losing keys to encrypted data means that the data stays encrypted, which is a way of applying a denial-of-service attack on yourself, so option C is incorrect. <br>Symmetric keys, known as shared secrets, ought to be transmitted to recipients over a different medium than the mode of communication intended for the encrypted traffic. If the users intend to use encrypted email, for instance, they should pass the keys via telephone. Option D is therefore incorrect.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      418,
      419,
      420,
      41,
      33
    ],
    "source": ""
  },
  {
    "id": 718,
    "question": "Which of the following is a good business case for the use of data masking?",
    "choice_a": "The shipping department should get only a masked version of the customer\u2019s address.",
    "choice_b": "The customer service department should get only a masked version of the customer\u2019s Social Security (SS) number.",
    "choice_c": "The billing department should get only a masked version of the customer\u2019s credit card number.",
    "choice_d": "The Human Resources (HR) department should get only a masked version of the employee\u2019s driver\u2019s license number.",
    "correct_answer": "B",
    "explanation": "The customer service representative may need to see a partial version of the customer\u2019s SS number to verify that the customer is who they claim to be, but that representative does not need to see the full number, which would create an unnecessary risk. <br>The shipping department definitely needs the customer\u2019s address in order to send things to the customer, so option A is not correct. <br>The billing department needs the customer\u2019s full credit card number to process payments, so option C is incorrect. <br>HR needs the employee\u2019s full license number in order to verify and validate the employee\u2019s identity, so option D is not correct.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      31,
      29,
      25,
      24,
      28
    ],
    "source": ""
  },
  {
    "id": 719,
    "question": "All of the following are methods of data masking suggested by  ISC2 <italic>except</italic> ___________________.",
    "choice_a": "Random substitution",
    "choice_b": "Algorithmic substitution",
    "choice_c": "Deletion",
    "choice_d": "Conflation",
    "correct_answer": "D",
    "explanation": "Conflation is not a masking technique and is meaningless in this context. All the others are suggested as possible masking techniques.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      503,
      502,
      504,
      255,
      414
    ],
    "source": ""
  },
  {
    "id": 720,
    "question": "If data masking is being performed for software testing purposes, which of the following is <italic>not</italic> a good masking technique to use?",
    "choice_a": "Random substitution",
    "choice_b": "Shuffling",
    "choice_c": "Deletion",
    "choice_d": "Algorithmic substitution",
    "correct_answer": "C",
    "explanation": "While deletion is a very good way to avoid the possibility of inadvertently disclosing production data in a test environment, it also eliminates the usefulness of the data set as a plausible approximation of the production environment, greatly reducing the quality of the testing. <br>The other options modify the raw production data into something that approximates the real environment without disclosing real data, to a greater or lesser extent; some are better than the others, but they are all better than deletion for testing purposes.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      502,
      503,
      504,
      258,
      256
    ],
    "source": ""
  },
  {
    "id": 721,
    "question": "For which use case would it probably be best to use static masking?",
    "choice_a": "Creating a test environment for a new application",
    "choice_b": "Allowing a customer service representative limited access to account data",
    "choice_c": "Providing detailed reports to regulators",
    "choice_d": "Notifying shareholders",
    "correct_answer": "A",
    "explanation": "Static masking involves modification of an entire data set, all at once. This would be a good method to create a sample data set for testing purposes. <br>Static testing for customer service use would be overkill; replicating all the customer accounts at once so that the fraction of customers who contact customer service may receive assistance is inefficient and cumbersome, and customer account information is likely to change between static updates, making it less useful. Therefore, option B is incorrect. <br>Neither regulators nor shareholders need to see masked data, so both options C and D are incorrect.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      503,
      504,
      25,
      29,
      36
    ],
    "source": ""
  },
  {
    "id": 722,
    "question": "For which use case would it probably be best to use dynamic masking?",
    "choice_a": "Creating a test environment for a new application",
    "choice_b": "Allowing a customer service representative limited access to account data",
    "choice_c": "Sending incident response notifications",
    "choice_d": "Implementing business continuity and disaster recovery (BC/DR)",
    "correct_answer": "B",
    "explanation": "Dynamically masking a user\u2019s account information each time a customer service representative accesses that data is an efficient, secure means of masking data as necessary. <br>Trying to mask each data element as it is called by an application in a test environment would be unwieldy and not likely to provide accurate test data, so option A is incorrect. <br>Neither incident response nor BC/DR purposes need masked data, so both options C and D are incorrect.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      502,
      503,
      504,
      501,
      31
    ],
    "source": ""
  },
  {
    "id": 723,
    "question": "What is one possible risk associated with the use of algorithmic masking for obscuring a data set?",
    "choice_a": "You could corrupt the production data.",
    "choice_b": "The data could be subject to easy inadvertent disclosure.",
    "choice_c": "Algorithms are two-way operations.",
    "choice_d": "A null set has no test value.",
    "correct_answer": "C",
    "explanation": "Using an algorithm to mask data suggests that the same algorithm, if learned or reverse-engineered by an aggressor, could be used on the masked data to reveal the production data. <br>Algorithmic masking causes no more risk to production data than the other masking methods, so option A is incorrect. <br>Accidental disclosure <italic>might</italic> be interpreted as the same thing as determining the original data from the masked set, so option B might be considered accurate, but option C is a better way of stating the risk, so B is incorrect. <br>Option D is about the use of the deletion technique for masking, not algorithmic, so it is incorrect. <br>This is not an easy question, and it involves some abstract thought to arrive at the correct answer.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      502,
      503,
      504,
      255,
      414
    ],
    "source": ""
  },
  {
    "id": 724,
    "question": "________ is a direct identifier, and ________ is an indirect identifier.",
    "choice_a": "Username; password",
    "choice_b": "User\u2019s name; user\u2019s age",
    "choice_c": "User\u2019s IP address; user\u2019s media access control\u00a0(MAC) address",
    "choice_d": "Location; income level",
    "correct_answer": "B",
    "explanation": "The user\u2019s name is a direct identifier, explicitly stating who that person is. The user\u2019s age is not a direct identifier because it doesn\u2019t specify a certain person, but it is a piece of demographic information that could be used to narrow down the user\u2019s identity from a group of users of different ages, so it is an indirect identifier. <br>Username and password are identity assertions and authentication credentials, not identifiers. The username might be a direct identifier, but the password is neither a direct nor an indirect identifier (especially if it is kept secret, as it should be). Option A is thus incorrect. <br>Option C is incorrect because both elements could be considered direct identifiers (depending on the jurisdiction) if the user\u2019s machine is considered a legal representation of the user. <br>Option D is incorrect because both elements are indirect identifiers.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      25,
      29,
      24,
      28,
      26
    ],
    "source": ""
  },
  {
    "id": 725,
    "question": "Anonymization is the process of removing _____ from data sets.",
    "choice_a": "Access",
    "choice_b": "Cryptographic keys",
    "choice_c": "Numeric values",
    "choice_d": "Identifying information",
    "correct_answer": "D",
    "explanation": "Anonymization is the process of removing identifiers from data sets so that data analysis tools and techniques cannot be used by malicious entities to divine personal or sensitive data from non-sensitive aggregated data sets. <br>All the other answers are incorrect because they are not part of the anonymization process.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      502,
      28,
      25,
      29,
      509
    ],
    "source": ""
  },
  {
    "id": 726,
    "question": "Tokenization is a method of obscuring data that, other than encryption, can be used to comply with _______ standards.",
    "choice_a": "Gramm-Leach-Bliley Act (GLBA)",
    "choice_b": "Payment Card Industry (PCI)",
    "choice_c": "Child Online Protection Act (COPA)",
    "choice_d": "Sarbanes-Oxley Act (SOX)",
    "correct_answer": "B",
    "explanation": "PCI requires that credit card numbers and other cardholder data be obscured when stored for any length of time. Encryption is one approved method; tokenization is another. <br>GLBA, COPA, and SOX do not specifically require obscuring stored data, so those options are incorrect.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      253,
      254,
      255,
      503,
      392
    ],
    "source": ""
  },
  {
    "id": 727,
    "question": "Tokenization requires at least __ database(s).",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Three",
    "choice_d": "Four",
    "correct_answer": "B",
    "explanation": "Tokenization will require, at a minimum, a database for the tokens and another for the stored sensitive data. <br>One database will not suffice; a single database holding both the tokens and the sensitive data they represent would not be in compliance with any standard requiring data to be obscured. Option A is thus incorrect. <br>Option C might be an answer some readers choose; it is easy to overthink this question. You might consider that the data requires two databases (one for tokens, one for sensitive data), and that access control would require a third database (for authentication credentials); however, the tokenization methodology does not strictly require that access be controlled through an authentication server. Option C is therefore incorrect. Be sure not to read more into the question than appears at face value. <br>Option D is incorrect; that\u2019s just too many databases.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      253,
      254,
      255,
      507,
      503
    ],
    "source": ""
  },
  {
    "id": 728,
    "question": "Data owners might consider using tokenization for all of the following reasons <italic>except</italic> ___________________.",
    "choice_a": "Regulatory or contractual compliance",
    "choice_b": "Inference",
    "choice_c": "Reduced cost of compliance",
    "choice_d": "Mitigating risk from data lost to intrusion",
    "correct_answer": "B",
    "explanation": "Inference is an attack strategy, not a reason for implementing tokenization. All the other answers are good reasons to implement tokenization, and they are therefore not correct.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      253,
      255,
      503,
      507,
      254
    ],
    "source": ""
  },
  {
    "id": 729,
    "question": "Bit-splitting, also known as data dispersion, might be thought of as _______ in the cloud.",
    "choice_a": "RAID",
    "choice_b": "BIOS",
    "choice_c": "DDoS",
    "choice_d": "SYN-ACK",
    "correct_answer": "A",
    "explanation": "In the traditional environment, a RAID array is a set of disks/drives on which data is spread to enhance the availability, security, and resiliency of the data. In the cloud, bit-splitting/data dispersion performs this same function in much the same way. <br>All the other options have nothing to do with spreading data across multiple storage areas.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      442,
      443,
      444,
      493,
      497
    ],
    "source": ""
  },
  {
    "id": 730,
    "question": "Bit-splitting also provides security against data breaches by ___________________.",
    "choice_a": "Removing all access to unauthorized parties",
    "choice_b": "Ensuring that an unauthorized user only gets a useless fragment of data",
    "choice_c": "Moving data across jurisdictional boundaries",
    "choice_d": "Tracking all incoming access requests",
    "correct_answer": "B",
    "explanation": "Bit-splitting involves chopping data sets up into segments and storing those segments in multiple places/devices. An attacker getting access to one segment won\u2019t be gaining anything of value because one segment of the data set would most likely make no sense out of context. <br>Bit-splitting may or may not function as an access control method; option B is preferable to A. <br>Bit-splitting may or may not move data across jurisdictions, which may or may not be useful to the data owner; option B is preferable to C. <br>Bit-splitting does not, in itself, provide access logs; option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      505,
      494,
      414,
      26,
      370
    ],
    "source": ""
  },
  {
    "id": 731,
    "question": "If bit-splitting is used to store data sets across multiple jurisdictions, how may this enhance security?",
    "choice_a": "By making seizure of data by law enforcement more difficult",
    "choice_b": "By hiding it from attackers in a specific jurisdiction",
    "choice_c": "By ensuring that users can only accidentally disclose data to one geographic area",
    "choice_d": "By restricting privilege user access",
    "correct_answer": "A",
    "explanation": "When law enforcement entities wish to seize assets (including data), they must cooperate with other law enforcement agencies in other jurisdictions if the data is not contained fully within their own. This may aid a data owner who is concerned about the risk of losing their data in a multitenant environment if another tenant conducts illicit activity and law enforcement seizes an entire data storage device as part of an investigation, accidentally collecting data belonging to innocent parties. <br>Attackers are jurisdiction-agnostic; they don\u2019t care where data is stored or what laws apply. Option B is thus incorrect. <br>Authorized users can access bit-split data regardless of the location and can disclose information worldwide; option C is incorrect. <br>Bit-splitting does not pertain to types of access roles; option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      505,
      393,
      24,
      412,
      250
    ],
    "source": ""
  },
  {
    "id": 732,
    "question": "Which of the following is a possible negative aspect of bit-splitting?",
    "choice_a": "Less security",
    "choice_b": "Greatest risk of unauthorized access",
    "choice_c": "Significantly greater processing overhead",
    "choice_d": "Violating regulatory compliance",
    "correct_answer": "C",
    "explanation": "Bit-splitting, as with many security methods/technologies, carries a significantly greater overhead than data sets that don\u2019t use this method. Bit-splitting, in particular, takes an extensive amount of processing to perform. <br>Bit-splitting should make a data set more secure and decrease the chance of unauthorized access, so options A and B are incorrect. <br>It is unlikely that bit-splitting would violate regulatory standards; even if that were to be the case, it is <italic>always</italic> true that bit-splitting carries greater overhead, so option C is preferable to D.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      505,
      506,
      414,
      494,
      496
    ],
    "source": ""
  },
  {
    "id": 733,
    "question": "Which of the following is a possible negative aspect of bit-splitting?",
    "choice_a": "It may require trust in additional third parties beyond the primary cloud service provider.",
    "choice_b": "There may be cause for management concern that the technology will violate internal policy.",
    "choice_c": "Users will have far greater difficulty understanding the implementation.",
    "choice_d": "Limited vendors make acquisition and support challenging.",
    "correct_answer": "A",
    "explanation": "This is not a simple question and requires the reader to think through the situation suggested by each answer. Option A is correct because the data owner may opt to perform bit-splitting across multiple cloud services to enhance security (not all the \u201ceggs\u201d will be in one \u201cbasket\u201d). When this is the case, the data owner will have additional dependencies: all the vendors involved in storing the various data elements. <br>There should be no additional management concern; if bit-splitting is not compliant with the data owner\u2019s policy, it won\u2019t be adopted. Option B is incorrect. <br>Bit-splitting implementations should be transparent to users; option C is incorrect. <br>There are plenty of vendors offering bit-splitting solutions; option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      505,
      24,
      29,
      496,
      33
    ],
    "source": ""
  },
  {
    "id": 734,
    "question": "Which of the following is a possible negative aspect of bit-splitting?",
    "choice_a": "Greater chance of physical theft of assets",
    "choice_b": "Loss of public image",
    "choice_c": "Some risk to availability, depending on the implementation",
    "choice_d": "A small fire hazard",
    "correct_answer": "C",
    "explanation": "Ironically, data dispersion can lead to some additional risk of loss of availability, depending on the method/breadth of the dispersion. If the data is spread across multiple cloud providers, there is a possibility that an outage at one provider will make the data set unavailable to users, regardless of location. However, there are methods for attenuating this threat, and bit-splitting usually provides greater availability of data over traditional storage without dispersion. <br>Data dispersion should have no effect on physical theft risks and would actually serve to minimize the opportunity for an attacker to acquire useful sensitive data as the data would be on several geographically disparate devices. Option A is incorrect. <br>Bit-splitting should have no effect on public image whatsoever; option B is incorrect. <br>Bit-splitting does not have an attendant fire risk; option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      505,
      41,
      35,
      250,
      414
    ],
    "source": ""
  },
  {
    "id": 735,
    "question": "Which of the following is a theoretical technology that is intended to allow encrypted material to be processed and manipulated without decrypting it first?",
    "choice_a": "Inverse postulation",
    "choice_b": "Homomorphic encryption",
    "choice_c": "Didactic alignment",
    "choice_d": "Obverse reinstantiation",
    "correct_answer": "B",
    "explanation": "This is the definition of homomorphic encryption. <br>All the other answers are meaningless.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      41,
      40,
      41
    ],
    "source": ""
  },
  {
    "id": 736,
    "question": "Which of the following is a data discovery approach used by e-commerce retailers to discern and predict shoppers\u2019 needs?",
    "choice_a": "Big data",
    "choice_b": "Real-time analytics",
    "choice_c": "Agile analytics",
    "choice_d": "Agile business intelligence",
    "correct_answer": "B",
    "explanation": "Real-time analytics allows for reactive and predictive operations (such as recommending other, related products) based on customers\u2019 current and past shopping behavior. <br>All the other answers are data discovery approaches but not used for this particular application (options C and D are two names for the same thing).",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      30,
      373,
      509,
      508,
      510
    ],
    "source": ""
  },
  {
    "id": 737,
    "question": "Which of the following is a data discovery approach that offers insight to trends of trends, using both historical and predictive approaches?",
    "choice_a": "Obverse polyglotism",
    "choice_b": "Big data",
    "choice_c": "Real-time analytics",
    "choice_d": "Agile analytics/business intelligence",
    "correct_answer": "D",
    "explanation": "The Agile approach to data analysis offers greater insight and capabilities than previous generations of analytical technologies. <br>Options B and C are other data discovery technologies, but neither is the correct answer. <br>Option A is incorrect because obverse polyglotism is just a made up term that does not have any relevance as an answer to the question.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      30,
      373,
      509,
      510,
      508
    ],
    "source": ""
  },
  {
    "id": 738,
    "question": "Which of the following is <italic>not</italic> a data discovery technique?",
    "choice_a": "Metadata",
    "choice_b": "Labels",
    "choice_c": "Content analysis",
    "choice_d": "Data hover",
    "correct_answer": "D",
    "explanation": "Data hover is a made up term which is not a data discovery technique. All the other answers are actual data discovery techniques.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      509,
      28,
      30,
      688,
      370
    ],
    "source": ""
  },
  {
    "id": 739,
    "question": "Which of the following data discovery techniques involves using extra information automatically appended/included with the intended data when the data is created?",
    "choice_a": "Metadata",
    "choice_b": "Labels",
    "choice_c": "Content analysis",
    "choice_d": "Data hover",
    "correct_answer": "A",
    "explanation": "This is the definition of metadata: data about data, usually created by systems (hardware and/or software) when the data is captured/collected. <br>Options B and C are also data discovery techniques, but not involving metadata. <br>Data hover is a made up term and is therefore, not a data discovery technique, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      28,
      26,
      509,
      29,
      688
    ],
    "source": ""
  },
  {
    "id": 740,
    "question": "When labeling is used as a data discovery technique, who should be applying the labels?",
    "choice_a": "The security office",
    "choice_b": "Users",
    "choice_c": "Data owners",
    "choice_d": "Regulators",
    "correct_answer": "C",
    "explanation": "The data owners, presumably the personnel closest to and most familiar with the data, should be the ones labeling it. <br>The other answers are incorrect because they are not the data owners.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      24,
      29,
      28,
      372,
      508
    ],
    "source": ""
  },
  {
    "id": 741,
    "question": "When data labels are being used in an environment (for discovery and other purposes), when should the labels be applied?",
    "choice_a": "During the risk assessment",
    "choice_b": "As part of the business impact analysis (BIA)",
    "choice_c": "At collection/creation",
    "choice_d": "When the discovery tools are implemented",
    "correct_answer": "C",
    "explanation": "For the most efficient classification/categorization process, and to streamline the application of proper controls, data labeling should be performed when the data is first being collected/created. <br>Options A and B are incorrect because they are not part of a data labeling process. <br>Option D is incorrect because the discovery tools need to have the data labeled to work properly.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      26,
      370,
      372,
      28,
      494
    ],
    "source": ""
  },
  {
    "id": 742,
    "question": "Which of the following tools might be useful in data discovery efforts that are based on content analysis?",
    "choice_a": "Egress monitoring solutions",
    "choice_b": "Digital rights management (DRM)",
    "choice_c": "iSCSI",
    "choice_d": "Fibre Channel over Ethernet (FCoE)",
    "correct_answer": "A",
    "explanation": "Egress monitoring tools (often referred to as DLP) are specifically designed to seek out and identify data sets based on content; this is part of how they operate. They can be used for or in conjunction with content-based data discovery efforts. <br>Digital rights management (DRM) is an additional access control solution for objects, so option B is incorrect. <br>Internet Small Computer System Interface (iSCSI) allows storage controller commands to be sent over a Transmission Control Protocol (TCP) network and has nothing to do with data discovery; thus, option C is incorrect. <br>Fibre Channel over Ethernet (FCoE) is a standard for approaching fiber-media speeds of data transfer on an Ethernet network; it has nothing to do with data discovery, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      28,
      412,
      509,
      414,
      30
    ],
    "source": ""
  },
  {
    "id": 743,
    "question": "All of the following might be used as data discovery characteristics in a content-analysis-based data discovery effort <italic>except</italic> ___________________.",
    "choice_a": "Keywords",
    "choice_b": "Pattern matching",
    "choice_c": "Frequency",
    "choice_d": "Inheritance",
    "correct_answer": "D",
    "explanation": "Inheritance has nothing to do with content analysis; it is usually referring to object-oriented traits derived from originating objects. <br>All the other answers are characteristics of content that can be used in content-analysis methods of data discovery.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      689,
      509,
      28,
      29,
      25
    ],
    "source": ""
  },
  {
    "id": 744,
    "question": "What is the risk to the organization posed by dashboards that display data discovery results?",
    "choice_a": "Increased chance of external penetration",
    "choice_b": "Flawed management decisions based on edited displays",
    "choice_c": "Higher likelihood of inadvertent disclosure",
    "choice_d": "Raised incidence of physical theft",
    "correct_answer": "B",
    "explanation": "Because dashboards are often used for management purposes (graphical representations of technical data), management pressures often result in skewed data dashboarding (\u201cno red!\u201d), which can lead to the \u201cdata\u201d being used for fallacious decisions. <br>All the other answers are not affected by dashboarding at all and are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      28,
      29,
      252,
      510,
      508
    ],
    "source": ""
  },
  {
    "id": 745,
    "question": "Which of these is <italic>most</italic> likely to have the greatest negative impact on data discovery effort?",
    "choice_a": "Bandwidth latency issues",
    "choice_b": "Poor physical security of the data center",
    "choice_c": "Severe statutory regulation",
    "choice_d": "Inaccurate or incomplete data",
    "correct_answer": "D",
    "explanation": "A data discovery effort can only be as effective as the veracity and quality of the data it addresses. Bad data will result in ineffective data discovery. <br>All the other answers do not impact data discovery efforts and are only distractors. (Poor bandwidth might slow down data discovery, but it won\u2019t have true negative impact, so option D is still better.).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      29,
      509,
      688,
      370
    ],
    "source": ""
  },
  {
    "id": 746,
    "question": "Cloud customers performing data discovery efforts will have to ensure that the cloud provider attends to all of the following requirements <italic>except</italic> ___________________.",
    "choice_a": "Allowing sufficient access to large volumes of data",
    "choice_b": "Preserving metadata tags",
    "choice_c": "Assigning labels",
    "choice_d": "Preserving and maintaining the data",
    "correct_answer": "C",
    "explanation": "Label assignment is a task of the data owner\u2014the cloud customer, not the provider. <br>All the other answers are requirements for the cloud provider to meet the data discovery needs of the customer and should be negotiated before migration.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      28,
      24,
      29,
      26,
      372
    ],
    "source": ""
  },
  {
    "id": 747,
    "question": "Where should the cloud provider\u2019s data discovery requirements be listed?",
    "choice_a": "National Institute of Standards and Technology (NIST)\u00a0Special Publication (SP) 800-53",
    "choice_b": "Applicable laws and regulations",
    "choice_c": "Payment Card Industry Data Security Standard (PCI DSS)",
    "choice_d": "The managed services contract and SLA",
    "correct_answer": "D",
    "explanation": "The cloud customer will have to determine which levels of performance/responsibilities on the part of the provider will be necessary to meet the customer\u2019s needs for data discovery. These should be codified in the contract/service-level agreement (SLA). <br>The other answers are general regulations and standards; they will not contain specific guidance for every customer\u2019s needs and are only distractors.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      29,
      28,
      510,
      508
    ],
    "source": ""
  },
  {
    "id": 748,
    "question": "Who will determine data classifications for the cloud customer?",
    "choice_a": "The cloud provider",
    "choice_b": "National Institute of Standards and Technology (NIST)",
    "choice_c": "Regulators",
    "choice_d": "The cloud customer",
    "correct_answer": "D",
    "explanation": "This is a difficult question and requires insight on the practice of classifying data and a good understanding of the material. While the determination of what sorts of data need to be protected may come from external sources (laws, standards, regulations, etc.), the classification of data for each data owner/cloud customer will be specific to that entity. Therefore, the cloud customer will have to impose data classification schema on itself and its own data. <br>The other answers represent external entities, some of whom might require that certain information be handled with a certain duty or care (such as Payment Card Industry [PCI] mandates for cardholder information). However, these entities will not impose a classification scheme on the data owner or cloud customer; that responsibility falls on the data owner or cloud customer to do for itself and the data under its control.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      25,
      24,
      26,
      27
    ],
    "source": ""
  },
  {
    "id": 749,
    "question": "An organization\u2019s data classification scheme <italic>must</italic> include which of the following categories?",
    "choice_a": "File size",
    "choice_b": "Origin of the data",
    "choice_c": "Sensitivity of the data",
    "choice_d": "Whatever the data owner decides",
    "correct_answer": "D",
    "explanation": "This is a difficult, and somewhat tricky, question. Each organization has to decide, for itself, how to classify its own data. With that said, many factors bear on this determination: external regulations and drivers, the type of industry in which the organization operates, and so forth. But the kinds of data the organization uses, and how that data is sorted, will differ for every organization, and each must make its own determination on how to best sort that data. <br>All the other answers are factors that an organization might consider when creating a classification scheme, but they are not mandatory for every organization. Option D is still the best answer for this question.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      25,
      513,
      512,
      24
    ],
    "source": ""
  },
  {
    "id": 750,
    "question": "Classification is usually considered a facet of data ______.",
    "choice_a": "Security",
    "choice_b": "Labeling",
    "choice_c": "Control",
    "choice_d": "Markup",
    "correct_answer": "B",
    "explanation": "This is another difficult question. Classification of data is an element of labeling, insofar as labeling is the grouping of data into discrete categories and types. Labels must be affixed to objects and data sets in accordance with an overall policy that lists objective criteria to guide the data owner(s) in assigning the appropriate label; this is a form of classification. <br>Option A might be considered apt, as labeling and classification fall generally under the auspices of \u201csecurity,\u201d but option B is more specific and therefore correct. <br>Classification is not considered a facet of data control or data markup. Therefore, options C and D are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      26,
      29,
      370,
      372
    ],
    "source": ""
  },
  {
    "id": 751,
    "question": "Data classification can be ______ or ______.",
    "choice_a": "Inverse or obverse",
    "choice_b": "Automatic or manual",
    "choice_c": "Correct or incorrect",
    "choice_d": "Diurnal or nocturnal",
    "correct_answer": "B",
    "explanation": "An organization could implement an automated tool that assigns labels based on certain criteria (location of the source of the data, time, creator, content, etc.), much like metadata, or the organization could require that data creators/collectors assign labels when the data is first created/collected, according to a policy that includes discrete, objective classification guidance. <br>Option A is incorrect because even though the word pair may seem pretty technical, together they are meaningless with respect to data classification. <br>It may be true that data classification can be correct or incorrect, however, option C is not as good of an answer as option B. The goal for the data owner is to correctly classify the data and not to incorrectly classify the data. So, option C is incorrect. <br>It is difficult to imagine data classification that only takes place at a certain time of day. Therefore, it is not likely to be the correct answer and certainly option D is not as good an answer as option B.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      25,
      26,
      513,
      370
    ],
    "source": ""
  },
  {
    "id": 752,
    "question": "Data may need to be reclassified for all the following reasons <italic>except</italic> ___________________.",
    "choice_a": "Color change",
    "choice_b": "Time",
    "choice_c": "Repurposing",
    "choice_d": "Transfer of ownership",
    "correct_answer": "A",
    "explanation": "Color is unlikely to be a characteristic for which data is classified, much less reclassified. Although some exceptions might exist (motion picture production, satellite imagery, paint vendors, etc.), those would be far from the norm, and the other answers are much more general cases and would apply to many more organizations. Therefore, color is the correct answer (in the negative), and the rest are incorrect (because they are true).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      512,
      25,
      29,
      34,
      35
    ],
    "source": ""
  },
  {
    "id": 753,
    "question": "Proper ______ need(s) to be assigned to each data classification/category.",
    "choice_a": "Dollar values",
    "choice_b": "Metadata",
    "choice_c": "Security controls",
    "choice_d": "Policies",
    "correct_answer": "C",
    "explanation": "The purposes of classifying/categorizing data is to create proper associated control sets for each data type and aid the efficiency and cost-effectiveness of applying those controls to that data. <br>While dollar value may be a good metric for assessing data type in many organizations, it is not the only such trait, and not for all organizations; option C is still a better answer, so A is wrong. <br>Metadata may or may not be used in a classification/categorization scheme; option B is incorrect. <br>Policies are not assigned to data types; a policy will dictate how data classifications/categories are assigned to data. Option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      29,
      34,
      31,
      24
    ],
    "source": ""
  },
  {
    "id": 754,
    "question": "Data transformation in a cloud environment should be of great concern to organizations considering cloud migration because __________ could affect data classification processes and implementations.",
    "choice_a": "Multitenancy",
    "choice_b": "Virtualization",
    "choice_c": "Remote access",
    "choice_d": "Physical distance",
    "correct_answer": "B",
    "explanation": "Data transforming from raw objects to virtualized instances to snapshotted images back into virtualized instances and then back out to users in the form of raw data may affect the organization\u2019s current classification methodology; classification techniques and tools that were suitable for the traditional IT environment might not withstand the standard cloud environment. This should be a factor of how the organization considers and perceives the risk of cloud migration. <br>Multitenancy should be a consideration of cloud migration for the potential risks of data leakage and disclosure but not because of data transformation. Option A is not correct. <br>Remote access and physical distance should not include aspects of data transformation that are not already considered in the traditional IT environment, so options C and D are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      25,
      27,
      370,
      493
    ],
    "source": ""
  },
  {
    "id": 755,
    "question": "Who is ultimately responsible for a data breach that includes personally identifiable information (PII), in the event of negligence on the part of the cloud provider?",
    "choice_a": "The user",
    "choice_b": "The subject",
    "choice_c": "The cloud provider",
    "choice_d": "The cloud customer",
    "correct_answer": "D",
    "explanation": "The cloud customer, as the PII data owner, is ultimately legally responsible for all losses of PII data. The customer may be able to recoup some of the costs of damages related to the breach by placing <italic>financial</italic>  liability on the provider through the user of strong contract terms and conditions, but all <italic>legal</italic> responsibility falls on the customer, in all cases. <br>The other options are parties that may have some partial or contributory responsibility for the breach (especially, in this case, the provider, who was negligent), but the ultimate responsibility lies with the customer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      29,
      392,
      35,
      38
    ],
    "source": ""
  },
  {
    "id": 756,
    "question": "In a personally identifiable information (PII) context, who is the subject?",
    "choice_a": "The cloud customer",
    "choice_b": "The cloud provider",
    "choice_c": "The regulator",
    "choice_d": "The individual",
    "correct_answer": "D",
    "explanation": "The subject is the human being to whom the PII applies. <br>The other answers are not data subjects, and are therefore incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      31,
      29,
      25,
      28
    ],
    "source": ""
  },
  {
    "id": 757,
    "question": "In a personally identifiable information (PII) context, who is the processor?",
    "choice_a": "The cloud customer",
    "choice_b": "The cloud provider",
    "choice_c": "The regulator",
    "choice_d": "The individual",
    "correct_answer": "B",
    "explanation": "In a PII context, the processor is any entity that processes data on behalf or at the behest of the data owner. In the case of most managed cloud service arrangements that will be the cloud service provider. (The cloud customer may also process its own data, but the customer is the data owner/controller.) <br>Options A, C, and D are all incorrect. The cloud customer provides the subject\u2019s PII to the cloud provider for processing. The regulator ensures that the PII is protected properly and the individual is the data subject. So, options A, C, and D are incorrect answers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      29,
      386,
      27,
      25
    ],
    "source": ""
  },
  {
    "id": 758,
    "question": "In a personally identifiable information (PII) context, who is the controller?",
    "choice_a": "The cloud customer",
    "choice_b": "The cloud provider",
    "choice_c": "The regulator",
    "choice_d": "The individual",
    "correct_answer": "A",
    "explanation": "In a PII context, the controller is the entity that creates/collects, owns, or manages the data\u2014that is, the data owner. In a managed cloud service arrangement, that would be the cloud customer. <br>Options B, C, and D are all incorrect. The cloud provider is the entity that processes the PII data. The regulator ensures that the PII is protected properly and the individual is the data subject.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      29,
      31,
      25,
      27
    ],
    "source": ""
  },
  {
    "id": 759,
    "question": "In a personally identifiable information (PII) context, which of the following is <italic>not</italic> normally considered \u201cprocessing\u201d?",
    "choice_a": "Storing",
    "choice_b": "Viewing",
    "choice_c": "Destroying",
    "choice_d": "Printing",
    "correct_answer": "B",
    "explanation": "This is not a simple question, and it requires a bit of insight into uses of data. The most suitable answer here is \u201cviewing,\u201d as it is entirely passive; the viewer is not performing any action on the data. \u201cProcessing,\u201d in a PII context, is any manipulation of the data, to include securing or destroying it, in electronic or hard-copy form. In a \u201cviewing\u201d action, the processor would be displaying the data to the viewer, while the viewer is only receiving it, not storing it or using it. Note that the answer did not involve \u201cusing,\u201d which definitely would be a processing action. <br>All the other answers are examples of processing and therefore not correct.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      31,
      24,
      38,
      29,
      26
    ],
    "source": ""
  },
  {
    "id": 760,
    "question": "Which of the following countries does <italic>not</italic> have a national privacy law that concerns personally identifiable information (PII) and applies to all entities?",
    "choice_a": "Argentina",
    "choice_b": "The United States",
    "choice_c": "Italy",
    "choice_d": "Australia",
    "correct_answer": "B",
    "explanation": "The United States has some federal PII laws that apply to specific sectors (the government itself [Privacy Act], medical providers [Health Information Portability and Accountability Act], financial and insurance vendors [Gramm-Leach-Bliley Act], etc.), but not a single, overarching federal law that addresses PII in a uniform, nationwide manner. <br>All the other options list countries that have such laws, and those options are therefore incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      393,
      392,
      34,
      29,
      27
    ],
    "source": ""
  },
  {
    "id": 761,
    "question": "In protections afforded to personally identifiable information (PII) under the U.S. Health Information Portability and Accountability Act (HIPAA), the subject must ____ in order to allow the vendor to share their personal data.",
    "choice_a": "Opt in",
    "choice_b": "Opt out",
    "choice_c": "Undergo screening",
    "choice_d": "Provide a biometric template",
    "correct_answer": "A",
    "explanation": "Under HIPAA, the subject must opt in to information sharing\u2014that is, the subject (the patient) must explicitly state, in writing and with a signature, who the vendor is allowed to share personal information with, such as family members, spouses, parents, and children. (Under HIPAA, this personal information is referred to as electronic private health information [ePHI].) The vendor is prohibited from sharing the patient\u2019s data with anyone else. <br>Under HIPAA, the patient does not have to opt out of information sharing; the default situation is to not share patient data. Option B is incorrect. <br>HIPAA does not require any kind of screening or template, so Options C and D are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      37,
      34,
      35,
      24,
      29
    ],
    "source": ""
  },
  {
    "id": 762,
    "question": "In protections afforded to personally identifiable information (PII) under the U.S. Gramm-Leach-Bliley Act (GLBA), the subject must ____ in order to prevent the vendor from sharing their personal data.",
    "choice_a": "Opt in",
    "choice_b": "Opt out",
    "choice_c": "Undergo screening",
    "choice_d": "Provide a biometric template",
    "correct_answer": "B",
    "explanation": "Under GLBA, financial and insurance vendors are allowed to share account holders\u2019 personal data with other entities (including other businesses owned by the same vendor) unless the account holder explicitly states, in writing, that the vendor is not allowed to do so. The vendor is required to provide a form for opting out of data sharing when the account holder creates the account and annually every subsequent year. <br>Option A is incorrect; under GLBA, the default situation allows banks and insurance providers (owned by the same entity) to share customer data-- the customer must opt out of this arrangement if the customer doesn\u2019t want information shared. <br>Options C and D are incorrect because they do not relate to the sharing of PII data by a bank or insurer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      392,
      29,
      27,
      24,
      34
    ],
    "source": ""
  },
  {
    "id": 763,
    "question": "The European Union (EU), with its implementation of privacy directives and regulations, treats individual privacy as ________.",
    "choice_a": "A passing fad",
    "choice_b": "A human right",
    "choice_c": "A legal obligation",
    "choice_d": "A business expense",
    "correct_answer": "B",
    "explanation": "The EU is probably at the forefront of global efforts to sanctify and enshrine personal privacy; the current statutes and precedents based on court decisions have clearly denoted Europe\u2019s intent to treat individual privacy as a human right. <br>Options A and D are simply incorrect. <br>It is very possible to consider option C as correct because European businesses are held to strict standards regarding the privacy data under their control. However, option B has more significance and is more general, so it is the proper selection among this list.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      392,
      29,
      27,
      24,
      34
    ],
    "source": ""
  },
  {
    "id": 764,
    "question": "If your organization collects/creates privacy data associated with European Union (EU) citizens and you operate in the cloud, you must <italic>prevent</italic> your provider from storing/moving/processing that data where?",
    "choice_a": "Argentina",
    "choice_b": "The United States",
    "choice_c": "Japan",
    "choice_d": "Israel",
    "correct_answer": "B",
    "explanation": "The EU regulations associated with personally identifiable information (PII) belonging to EU citizens prohibit that data to be utilized in any way in any country that does not have a national privacy law commensurate with the EU regulations. Of this list, only the United States has no such law. Indeed, the EU regulations might very well be taken to be aimed directly at the United States, and probably for good reason; the United States has not proven to be a good steward of or even recognize the importance of personal privacy.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      393,
      27,
      24,
      34,
      29
    ],
    "source": ""
  },
  {
    "id": 765,
    "question": "European Union (EU) personal privacy protections include the right to be ___________________.",
    "choice_a": "Secure",
    "choice_b": "Delivered",
    "choice_c": "Forgotten",
    "choice_d": "Protected",
    "correct_answer": "C",
    "explanation": "The right to be forgotten is the EU\u2019s codification of an individual\u2019s right to have any data store containing their own personal data purged of all personally identifiable information (PII). There are, of course, some obvious exceptions (such as law enforcement databases). <br>The other answers are not as accurate; \u201cthe right to be forgotten\u201d is a very well-known and important aspect of the GDPR.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      392,
      34,
      37,
      29
    ],
    "source": ""
  },
  {
    "id": 766,
    "question": "The Cloud Security Alliance (CSA) has developed a model for cloud privacy frameworks called the Privacy Level Agreement (PLA). Why might a cloud service provider be reluctant to issue or adhere to a PLA?",
    "choice_a": "A PLA might limit the provider\u2019s liability.",
    "choice_b": "A PLA would force the provider to accept more liability.",
    "choice_c": "A PLA is nonbinding.",
    "choice_d": "A PLA is not enforceable.",
    "correct_answer": "B",
    "explanation": "Under current laws and regulations, ultimate liability for the security of privacy data rests on the data controller\u2014that is, the cloud customer. A PLA would require the cloud provider to document expectations for the cloud customer\u2019s data security, which would be an explicit admission of liability. There is little motivation for cloud providers to take on this additional liability (and the costs associated with it) with no mandate or market force pushing them to do so. <br>Option A is wrong because the provider\u2019s liability is already limited under current legal schemes; the PLA would not enhance that limitation. <br>Options C and D are wrong because agreements (as contracts) are both binding and enforceable, and even if they were not, those are not reasons.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      392,
      29,
      395,
      33
    ],
    "source": ""
  },
  {
    "id": 767,
    "question": "The\u00a0Cloud\u00a0Security Alliance\u00a0Cloud Controls Matrix\u00a0(CSA\u00a0CCM) lists security controls from all the following frameworks <italic>except</italic> ___________________.",
    "choice_a": "ISACA\u2019s Control Objectives for Information and Related Technology (COBIT)",
    "choice_b": "Payment Card Industry Data Security Standard (PCI DSS)",
    "choice_c": "The Capability Maturity Model (CMM)",
    "choice_d": "International Organization for Standardization (ISO) 27001",
    "correct_answer": "C",
    "explanation": "The CMM is not included in the CSA CCM and, indeed, is not even a security framework. <br>All the other options are included in the CSA CCM and are therefore not correct answers for this question.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      392,
      718,
      511,
      513,
      498
    ],
    "source": ""
  },
  {
    "id": 768,
    "question": "The Cloud Security Alliance Cloud Controls Matrix (CSA CCM) lists security controls from all the following laws <italic>except</italic> ___________________.",
    "choice_a": "Health Information Portability and Accountability Act (HIPAA)",
    "choice_b": "Family Education Rights and Privacy Act (FERPA)",
    "choice_c": "Personal Information Protection and Electronic Documents Act (PIPEDA)",
    "choice_d": "Digital Millennium Copyright Act (DMCA)",
    "correct_answer": "D",
    "explanation": "The DMCA deals with intellectual property and not specifically with personal privacy. It is not included in the CSA CCM. <br>All the other answers are laws that are included in the CSA CCM and are therefore not correct answers for this question.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      392,
      393,
      34,
      29,
      25
    ],
    "source": ""
  },
  {
    "id": 769,
    "question": "Digital rights management (DRM) tools might be used to protect all the following assets <italic>except</italic> ___________________.",
    "choice_a": "A trusted device",
    "choice_b": "Proprietary software",
    "choice_c": "Medical records",
    "choice_d": "Financial data",
    "correct_answer": "A",
    "explanation": "DRM solutions are mainly designed to protect intellectual property assets (and mainly those covered by copyright, hence the name), but they can also be used to provide enhanced protection to other electronic information. All the other options are forms of electronic information, while option A is a piece of hardware; DRM does not enhance hardware security, so this is the correct answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      31,
      32,
      394,
      33,
      414
    ],
    "source": ""
  },
  {
    "id": 770,
    "question": "Deploying digital rights management (DRM) tools in a bring-your-own-device (BYOD) environment will require ___________________.",
    "choice_a": "User consent and action",
    "choice_b": "Enhanced security protocols",
    "choice_c": "Use of the cloud",
    "choice_d": "Newer, upgraded devices",
    "correct_answer": "A",
    "explanation": "Deploying DRM usually requires installing a local agent on each device intended for use in that environment; with BYOD, that means getting all users to agree and install that agent because they own the devices. <br>DRM <italic>is</italic> an enhanced security protocol, so option B is incorrect. <br>The cloud is not specifically necessary for DRM implementations, even in BYOD environments, so option C is incorrect. <br>Any DRM solution involving a BYOD environment must be suitable for all devices, not just a certain selection, because the organization can\u2019t easily mandate which devices are used (otherwise, it\u2019s not BYOD). Option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      32,
      31,
      383,
      395,
      414
    ],
    "source": ""
  },
  {
    "id": 771,
    "question": "Deploying digital rights management (DRM) tools in a bring-your-own-device (BYOD) environment will require ___________________.",
    "choice_a": "A uniform browser installation",
    "choice_b": "Platform-agnostic solutions",
    "choice_c": "Turnstiles",
    "choice_d": "A secondary business continuity and disaster recovery (BC/DR) vendor",
    "correct_answer": "B",
    "explanation": "In a BYOD environment, users might bring any number of devices/operating systems to the network, and any DRM solution selected for the purpose must interact well with all of them. <br>The organization cannot dictate specific packages in a BYOD environment\u2014otherwise it is not BYOD\u2014so option A is incorrect. <br>Turnstiles are for physical access control and have no bearing on BYOD or DRM, so option C is incorrect. <br>BYOD and DRM should have no effect on BC/DR vendors (or the numbers thereof), and vice versa, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      32,
      31,
      380,
      389,
      383
    ],
    "source": ""
  },
  {
    "id": 772,
    "question": "The Cloud Security Alliance Cloud Controls Matrix (CSA CCM) addresses all the following security architecture elements <italic>except</italic> ___________________.",
    "choice_a": "Physical security",
    "choice_b": "Infrastructure as a service (IaaS)",
    "choice_c": "Application security",
    "choice_d": "Business drivers",
    "correct_answer": "D",
    "explanation": "The CSA CCM does not deal with whether security controls are feasible or correct from a business perspective, only whether they are applicable to an organization under certain regulations. <br>All the other answers are architecture elements addressed by the CSA CCM and are therefore incorrect answers for this question.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      498,
      496,
      493,
      392,
      378
    ],
    "source": ""
  },
  {
    "id": 773,
    "question": "DRM requires that every data resource be provisioned with _______.",
    "choice_a": "A tracking device",
    "choice_b": "An access policy",
    "choice_c": "A hardware security module (HSM)",
    "choice_d": "A biometric system",
    "correct_answer": "B",
    "explanation": "For DRM to work properly, each resource needs to be outfitted with an access policy so that only authorized entities may make use of that resource. <br>All the other answers are incorrect because they are too specific and not required by any regulation/legislation. Therefore, options A, C, and D are poor choices and also incorrect answers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      31,
      380,
      389,
      383,
      395
    ],
    "source": ""
  },
  {
    "id": 774,
    "question": "Digital rights management (DRM) tools can be combined with _______ to enhance security capabilities.",
    "choice_a": "Roaming identity services (RIS)",
    "choice_b": "Egress monitoring solutions (DLP)",
    "choice_c": "Internal hardware settings (BIOS)",
    "choice_d": "The TEMPEST program",
    "correct_answer": "B",
    "explanation": "DRM and DLP work well to address complementary security issues\u2014namely, asset classification/categorization and discovery, along with access and dissemination of those assets. <br>RIS is a made-up term, so option A is not correct. <br>Adjusting BIOS settings is not particularly relevant to DRM in any way, so option C is incorrect. <br>TEMPEST is a program for harvesting data from electromagnetic emanations, so option D is not correct.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      414,
      31,
      413,
      26,
      28
    ],
    "source": ""
  },
  {
    "id": 775,
    "question": "Digital rights management (DRM) tools should enforce _______, which is the characteristic of access rights following the object, in whatever form or location it might be or move to.",
    "choice_a": "Continuous audit trail",
    "choice_b": "Limiting printing output",
    "choice_c": "Persistence",
    "choice_d": "Automatic expiration",
    "correct_answer": "C",
    "explanation": "Access rights following the object in whatever form or location it might be or move to is the definition of persistence, one of the required traits for a DRM solution of any quality. <br>All the other answers are traits that should be included in DRM solutions but do not match the definition in the question, so they are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      32,
      31,
      380,
      389,
      383
    ],
    "source": ""
  },
  {
    "id": 776,
    "question": "Digital rights management (DRM) tools should enforce _______, which is the practice of capturing all relevant system events.",
    "choice_a": "Continuous audit trail",
    "choice_b": "Limiting printing output",
    "choice_c": "Persistence",
    "choice_d": "Automatic expiration",
    "correct_answer": "A",
    "explanation": "Capturing all relevant system events is the definition of a continuous audit trail, one of the required traits for a DRM solution of any quality. <br>All the other answers are traits that should be included in DRM solutions but do not match the definition in the question, so they are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      38,
      39,
      720,
      394,
      31
    ],
    "source": ""
  },
  {
    "id": 777,
    "question": "Digital rights management (DRM) tools should enforce _______, which is the capability to revoke access based on the decision of the object owner or an administrator action.",
    "choice_a": "Integration with email filtering engines",
    "choice_b": "Disabling screencap capabilities",
    "choice_c": "Continuous audit trail",
    "choice_d": "Dynamic policy control",
    "correct_answer": "D",
    "explanation": "The question describes dynamic policy control, one of the required traits for a DRM solution of any quality. <br>All the other answers are traits that should be included in DRM solutions but do not match the definition in the question, so they are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      379,
      382,
      388,
      394,
      386
    ],
    "source": ""
  },
  {
    "id": 778,
    "question": "Digital rights management (DRM) tools should enforce _______, which is the revocation of access based on time.",
    "choice_a": "Persistence",
    "choice_b": "Disabling screencap capabilities",
    "choice_c": "Automatic expiration",
    "choice_d": "Dynamic policy control",
    "correct_answer": "C",
    "explanation": "The question describes automatic expiration, one of the required traits for a DRM solution of any quality. <br>All the other answers are traits that should be included in DRM solutions but do not match the definition in the question, so they are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      31,
      394,
      386,
      382,
      383
    ],
    "source": ""
  },
  {
    "id": 779,
    "question": "Digital rights management (DRM) tools should enforce _______, which is interoperability with the organization\u2019s other access control activities.",
    "choice_a": "Persistence",
    "choice_b": "Support for existing authentication security infrastructure",
    "choice_c": "Continuous audit trail",
    "choice_d": "Dynamic policy control",
    "correct_answer": "B",
    "explanation": "The question describes support for existing authentication security infrastructure, one of the required traits for a DRM solution of any quality. <br>All the other answers are traits that should be included in DRM solutions but do not match the definition in the question, so they are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      32,
      394,
      395,
      386,
      380
    ],
    "source": ""
  },
  {
    "id": 780,
    "question": "In a data retention policy, what is perhaps the <italic>most</italic> crucial element?",
    "choice_a": "Location of the data archive",
    "choice_b": "Frequency of backups",
    "choice_c": "Security controls in long-term storage",
    "choice_d": "Data recovery procedures",
    "correct_answer": "D",
    "explanation": "This is not an easy question and requires some interpretation and abstract thought. All of the elements listed are extremely important aspects of the data retention policy. However, using proper data retrieval procedures is the one without which all the others may become superfluous. An organization can perform thorough backups in a timely manner and secure them properly at an excellent location, but if those backups can\u2019t be used to restore the operational environment, they are pointless. <br>All the other options are important, but option D is probably the most important.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      36,
      34,
      377,
      37,
      35
    ],
    "source": ""
  },
  {
    "id": 781,
    "question": "_______ is the practice of taking data out of the production environment and putting it into long-term storage.",
    "choice_a": "Deletion",
    "choice_b": "Archiving",
    "choice_c": "Crypto-shredding",
    "choice_d": "Storing",
    "correct_answer": "B",
    "explanation": "The question states the definition of archiving. <br>Deletion involves using the operating system or an application to obscure the location of an object or file, so option A is wrong. <br>Crypto-shredding is a secure sanitization technique using cryptographic techniques, so option C is wrong. <br>Storing is a general term covering all retention of data, so option B is a better answer than option D.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      36,
      34,
      37,
      40,
      41
    ],
    "source": ""
  },
  {
    "id": 782,
    "question": "In general, all policies within an organization should include each of the following elements <italic>except</italic> ___________________.",
    "choice_a": "The date on which the policy will expire",
    "choice_b": "The assignment of an entity to review the applicability of the possibility occasionally",
    "choice_c": "The assignment of an entity to monitor and maintain the process described in the policy",
    "choice_d": "A list of the laws, regulations, practices, and/or standards that drove the creation of the policy",
    "correct_answer": "A",
    "explanation": "Not all policies are temporary or have expected durations; usually, policy is an enduring piece of governance that will continue until such time as it is revoked. <br>All the other options are elements that should usually be included in policies.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      376,
      378,
      34,
      377,
      35
    ],
    "source": ""
  },
  {
    "id": 783,
    "question": "The goals of secure sanitization (or \u201cdata destruction\u201d) include all of the following <italic>except</italic> ___________________.",
    "choice_a": "Removing data objects or files",
    "choice_b": "Minimizing or eliminating data remanence",
    "choice_c": "Removing pointers and metadata about specific files or objects",
    "choice_d": "Creating a secure, archived copy for business continuity and disaster recovery (BC/DR) purposes",
    "correct_answer": "D",
    "explanation": "Secure sanitization is intended to ensure that there is no possible way for the data to be recovered; a backup copy would defeat the entire purpose. <br>All the other answers are goals of secure sanitization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      40,
      35,
      434,
      433,
      435
    ],
    "source": ""
  },
  {
    "id": 784,
    "question": "Why is deleting a file or object insufficient for secure sanitization purposes?",
    "choice_a": "Drives and disks must be demagnetized for true secure destruction.",
    "choice_b": "Physical destruction is the only acceptable method of secure sanitization.",
    "choice_c": "Deletion usually only removes pointers or indicators of file location.",
    "choice_d": "Only administrators should be allowed to delete files or objects.",
    "correct_answer": "C",
    "explanation": "Deletion, using basic system assets (usually the operating system), mainly involves removing pointers to and addresses of the files or objects that are the targets of deletion. This leaves the raw data remaining on the storage resource, and it could be recovered later. <br>Options A and B both include secure destruction methods, but they are not exclusive (obviously, because there are two of them), so therefore they are untrue and also incorrect. <br>Option D does not make practical sense; if users could not delete files/objects, common workplace activity would become burdensome and difficult.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      40,
      41,
      35,
      433,
      434
    ],
    "source": ""
  },
  {
    "id": 785,
    "question": "Data destruction in the cloud is difficult because __________.",
    "choice_a": "Cloud data doesn\u2019t have substance",
    "choice_b": "Regulations prevent it",
    "choice_c": "The hardware belongs to the provider",
    "choice_d": "Most of the data is subterranean",
    "correct_answer": "C",
    "explanation": "The preferred methods of secure sanitization require physical access to (and control of) the hardware on which the data is stored; in the cloud, this belongs to the cloud provider, and the cloud customer will not be allowed to perform destructive procedures. <br>Options A, B, and D are incorrect because the question is about the difficulty of performing data destruction in the cloud computing environment. Often, the only reliable form of data destruction is to destroy the hardware where it is stored. None of these options address that question the way that option C does.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      434,
      40,
      35,
      41,
      24
    ],
    "source": ""
  },
  {
    "id": 786,
    "question": "Data destruction in the cloud is difficult because __________.",
    "choice_a": "Data in the cloud is constantly being replicated and backed up",
    "choice_b": "Delete commands are prohibited in the cloud",
    "choice_c": "Internet service providers (ISPs) will not allow destruction of data stored in the cloud",
    "choice_d": "The end clients may prevent it",
    "correct_answer": "A",
    "explanation": "One of the benefits of using managed cloud services is that most providers are constantly performing backup and preservation activities in order to ensure that customers do not lose data. This can make it complicated for customers to even locate all their stored data, much less permanently destroy it. <br>Delete commands are certainly allowed in the cloud. Otherwise, cloud providers would eventually run out of storage space. Option B is incorrect. <br>Option C is incorrect because ISPs do not have the authority to prohibit the destruction of data by data owners. <br>It may be unclear who the \u201cend client\u201d is in option D. If the end client is the individual, then it does not make sense that the individual would prohibit the destruction of data by the cloud provider, given that the cloud provider owns the hardware itself.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      36,
      35,
      41,
      34,
      24
    ],
    "source": ""
  },
  {
    "id": 787,
    "question": "Data destruction in the cloud is difficult because __________.",
    "choice_a": "Only law enforcement is permitted to destroy cloud data",
    "choice_b": "The largest cloud vendors have prevented customers from destroying data",
    "choice_c": "Cloud data renews itself automatically",
    "choice_d": "The cloud is often a multitenant environment",
    "correct_answer": "D",
    "explanation": "Secure sanitization would affect storage resources where more than one customer stores their data; truly secure destructive measures would likely result in destroying data belonging to someone else. <br>Law enforcement can destroy their own data, however, law enforcement is not permitted to destroy data that belongs to other individuals. Option A is therefore incorrect. <br>Option B is incorrect because data destruction is required from time to time in the cloud as part of system maintenance. <br>Fortunately, option C is incorrect. If data renewed itself automatically in the cloud then cloud providers would eventually run out of storage space.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      35,
      41,
      434,
      40,
      24
    ],
    "source": ""
  },
  {
    "id": 788,
    "question": "Which of the following is the best and only completely secure method of data destruction?",
    "choice_a": "Degaussing",
    "choice_b": "Crypto-shredding",
    "choice_c": "Physical destruction of resources that store the data",
    "choice_d": "Legal order issued by the prevailing jurisdiction where the data is geographically situated",
    "correct_answer": "C",
    "explanation": "Destroying the drive, disk, and media where the data resides is the only true, complete method of data destruction. <br>Options A and B are also good methods for data destruction, but neither is the best method. <br>Option D is incorrect because a legal order is not a secure method of data destruction and therefore it cannot be the correct answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      40,
      41,
      434,
      435,
      433
    ],
    "source": ""
  },
  {
    "id": 789,
    "question": "Aside from the fact that the cloud customer probably cannot reach the physical storage assets of the cloud provider and that wiping an entire storage space would impact other customers, why would degaussing probably not be an effective means of secure sanitization in the cloud?",
    "choice_a": "All the data storage space in the cloud is already gaussed.",
    "choice_b": "Cloud data storage may not be affected by degaussing.",
    "choice_c": "Federal law prohibits it in the United States.",
    "choice_d": "The blast radius is too wide.",
    "correct_answer": "B",
    "explanation": "Cloud data storage likely uses solid-state drives (or disks), which are not affected by degaussing because they don\u2019t use magnetic properties to store data. <br>Option A is incorrect because it is untrue. A gauss is a unit of magnetism. Not all data storage devices in the cloud are magnetic. Some storage space does not require magnetism to work. Solid State Drives (SSDs) are an example of a type of storage space that does not rely on magnetism to store data. <br>Federal law does not prohibit degaussing of magnetic media in the United States so option C is incorrect. <br>Option D is incorrect because process of degaussing magnetic media does not produce a blast and therefore it does not produce a blast radius.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      433,
      435,
      40,
      41,
      35
    ],
    "source": ""
  },
  {
    "id": 790,
    "question": "Is overwriting a feasible secure sanitization method in the cloud?",
    "choice_a": "Yes, but only if you use multiple passes.",
    "choice_b": "No, because you can\u2019t get physical access to cloud storage resources.",
    "choice_c": "Yes, but it requires a final pass with all zeros or ones.",
    "choice_d": "No, because the logical location of the stored data is almost impossible to determine.",
    "correct_answer": "D",
    "explanation": "Overwriting is the practice of filling the entire storage of the target data with randomized characters (usually involving multiple passes and a final pass with a single, repeated character). In the cloud, this is untenable for many reasons, including the fact that cloud data is constantly moving from one storage resource to another and is not kept in a single, identifiable logical location for an extended period of time (which is actually a security benefit). Without you knowing which storage resources to overwrite, overwriting is impossible. <br>All the other options are only distractors. Options A and C describe elements of the overwriting process but not reasons why it\u2019s challenging in the cloud. Option B is true, but overwriting does not require physical access, so the option is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      40,
      41,
      434,
      433,
      435
    ],
    "source": ""
  },
  {
    "id": 791,
    "question": "All of the following are reasons overwriting is not a viable secure sanitization method for data stored in the cloud <italic>except</italic> ___________________.",
    "choice_a": "Overwriting an entire storage resource would affect other tenants\u2019 data",
    "choice_b": "Regulators usually frown on the practice",
    "choice_c": "Locating the specific storage locations of cloud data is almost impossible",
    "choice_d": "Data is being backed constantly in the cloud; before you finished overwriting an entire data set, it would have been replicated elsewhere",
    "correct_answer": "B",
    "explanation": "Regulators do not disapprove of secure sanitization; it is an acceptable form of secure data destruction if implemented properly. <br>All the other answers are actual reasons overwriting is not a viable secure sanitization method in the cloud.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      40,
      41,
      434,
      435,
      433
    ],
    "source": ""
  },
  {
    "id": 792,
    "question": "Which of the following might make crypto-shredding difficult or useless?",
    "choice_a": "The cloud provider also managing the organization\u2019s keys",
    "choice_b": "Lack of physical access to the environment",
    "choice_c": "External attackers",
    "choice_d": "Lack of user training and awareness",
    "correct_answer": "A",
    "explanation": "Crypto-shredding relies on the eventual destruction of the final keys; if keys are not under the management of the customer, they may be replicated or difficult to dispose of. <br>The lack of physical access to the cloud environment should not affect the crypto-shredding process, so option B is incorrect. <br>External attackers should not affect the crypto-shredding process, so option C is incorrect. <br>Crypto-shredding should not require input or activity from users, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      41,
      40,
      418,
      24,
      37
    ],
    "source": ""
  },
  {
    "id": 793,
    "question": "Crypto-shredding requires at least ___ cryptosystem(s).",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Three",
    "choice_d": "Four",
    "correct_answer": "B",
    "explanation": "The proper procedure for crypto-shredding requires two cryptosystems: one to encrypt the target data, the other to encrypt the resulting data encryption keys. All the other answers are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      40,
      41,
      418,
      503,
      395
    ],
    "source": ""
  },
  {
    "id": 794,
    "question": "In addition to having it for business continuity and disaster recovery (BC/DR) purposes, data archiving might also be useful for ___________________.",
    "choice_a": "Ensuring profitability",
    "choice_b": "Increasing performance",
    "choice_c": "Motivating users",
    "choice_d": "Correcting accidental errors",
    "correct_answer": "D",
    "explanation": "If users inadvertently erase or modify data, an archived backup copy could be useful for restoring the original, correct version. <br>All the other answers are incorrect; archiving does none of those things.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      36,
      34,
      377,
      35,
      30
    ],
    "source": ""
  },
  {
    "id": 795,
    "question": "In addition to having it for business continuity and disaster recovery (BC/DR) purposes, data archiving might also be useful for ___________________.",
    "choice_a": "Team building and morale",
    "choice_b": "Forensic investigation",
    "choice_c": "Choosing security controls",
    "choice_d": "Enhancing quality",
    "correct_answer": "B",
    "explanation": "An archived data set could be useful for investigative purposes, especially if it covers a significant period of time and includes multiple copies. The archived versions may be used as a reference to determine when a certain malicious activity occurred, which is useful during an investigation. <br>All the other answers are incorrect; archiving does not aid in these functions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      37,
      36,
      38,
      34,
      377
    ],
    "source": ""
  },
  {
    "id": 796,
    "question": "In addition to having it for business continuity and disaster recovery (BC/DR) purposes, data archiving might also be useful for ___________________.",
    "choice_a": "Compliance/audit",
    "choice_b": "Monitoring performance",
    "choice_c": "Gathering investment",
    "choice_d": "Enforcing policy",
    "correct_answer": "A",
    "explanation": "Archiving may be required by regulation, and archived versions of the environment or data may be used to create deliverables for auditors, especially if the archive included event logs. <br>Archived data is not an optimum gauge of performance because it is not \u201clive\u201d data\u2014that is, the archived data is no longer in the operational environment and so is not a useful indicator of how well that environment currently operates. Option B is therefore incorrect. <br>Archiving has nothing to do with investment; option C is incorrect. <br>Archiving may occur as the result of policy but is not an enforcement tool; thus, option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      36,
      34,
      37,
      38,
      392
    ],
    "source": ""
  },
  {
    "id": 797,
    "question": "Who is responsible for performing archiving activities in a managed cloud environment?",
    "choice_a": "The cloud customer",
    "choice_b": "The cloud provider",
    "choice_c": "The customer\u2019s regulator",
    "choice_d": "Depends on the contract",
    "correct_answer": "D",
    "explanation": "Many cloud providers will offer archiving services as a feature of the basic cloud service; realistically, most providers are already performing this function to avoid inadvertent loss of customer data, so marketing it is a logical step. However, because the customer is ultimately responsible for the data, the customer may elect to use another, or an additional, archive method. The contract will stipulate specific terms, such as archive size, duration, and so on. <br>Either the cloud customer or provider (or <italic>both</italic> ) may perform archiving, depending on the contract terms, so options A and B are incorrect. <br>Regulators do not perform archiving; option C is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      34,
      36,
      37,
      29
    ],
    "source": ""
  },
  {
    "id": 798,
    "question": "Data archiving and retention policies should include _________.",
    "choice_a": "How long the data must be kept before destruction",
    "choice_b": "The depth of underground storage bunkers used for archiving",
    "choice_c": "The names of specific personnel tasked with restoring data in the event of data loss in the operational environment",
    "choice_d": "The name(s) of regulators approving the policy",
    "correct_answer": "A",
    "explanation": "The policy for data archiving and retention must include guidance on the length of time data is expected to remain stored. <br>Describing or prescribing the physical specifications of a secure archive facility is probably beyond the responsibility or requirements of a data owner (and belowground storage is not a requirement for archiving and retention), so option B is incorrect. <br>Although it is important to task and train personnel to take part in data restoration from archived data, naming the specific personnel in the policy is not an optimum or useful practice, so option C is incorrect. <br>Although management is responsible for publishing and promulgating policy and governance, the name of the specific manager is not the essential element (but their office or position is). Regulators don\u2019t personally approve internal policies of the organizations they oversee, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      34,
      377,
      37,
      24,
      35
    ],
    "source": ""
  },
  {
    "id": 799,
    "question": "What should data archiving and retention policies include?",
    "choice_a": "Names of personnel allowed to receive backup media, if third-party off-site archiving services are used",
    "choice_b": "Explicit statement of data formats and types of storage media",
    "choice_c": "A list of personnel whose data will be archived on a regular basis",
    "choice_d": "Which Internet service provider (ISP) should be used for backup procedures",
    "correct_answer": "B",
    "explanation": "It is important to indicate the data format and media type for long-term storage in order to ensure restoration capability; outdated or obsolete data formats and media may not be useful for restoration of data to the operational environment several years after it has been stored. <br>Options A and C are not correct because specific names don\u2019t belong at the policy level of governance; the specific names (or identification credentials) of allowed third-party recipients should be included at the process/procedure level of governance, and a list of <italic>offices</italic> or <italic>departments</italic>  whose data will be archived can be included in the policy. <br>Option D is not correct because the particular ISP should not have any bearing on the archiving policy.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      34,
      36,
      377,
      435,
      40
    ],
    "source": ""
  },
  {
    "id": 800,
    "question": "If the organization operates in a cloud environment, security operations procedures should include specific contact information for all of the following <italic>except</italic> ___________________.",
    "choice_a": "Applicable regulatory entities",
    "choice_b": "Federal and local law enforcement",
    "choice_c": "The originator or publisher of the governing policy",
    "choice_d": "The cloud provider\u2019s security response office",
    "correct_answer": "C",
    "explanation": "Once the policies have been published and put into force, the names and contact information of the people who crafted them are no longer useful or germane. <br>All the other options represent entities that the organization may want to contact in the event of a security incident or breach and so should be included in security procedure documentation.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      38,
      39,
      376,
      24,
      391
    ],
    "source": ""
  },
  {
    "id": 801,
    "question": "If the organization operates in a cloud environment, security operations procedures should include guidance for all of the following audit or logging processes <italic>except</italic> ___________________.",
    "choice_a": "Definition of security events and incidents",
    "choice_b": "The brand or vendor of the cloud provider\u2019s audit or logging tool",
    "choice_c": "Process for adding new audit or logging rules",
    "choice_d": "Process for filtering out false positives by amending the rule set",
    "correct_answer": "B",
    "explanation": "This is a question that requires some thought. All the answers are processes or elements that should be included in the security operations\u2019 procedures except for option B; the cloud customer will not get to select, or probably even know, what tools and devices the cloud provider has put into place, so this will not be included in the customer\u2019s procedures.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      39,
      38,
      24,
      378,
      720
    ],
    "source": ""
  },
  {
    "id": 802,
    "question": "What does <italic>nonrepudiation</italic>  mean?",
    "choice_a": "Prohibiting certain parties from a private conversation",
    "choice_b": "Ensuring that a transaction is completed before saving the results",
    "choice_c": "Ensuring that someone cannot turn off auditing capabilities while performing a function",
    "choice_d": "Preventing any party that participates in a transaction from claiming that it did not",
    "correct_answer": "D",
    "explanation": "Option D is the definition of nonrepudiation. <br>Option A is a description of confidentiality. <br>Option B is an element of the Atomicity, Consistency, Isolation, Durability (ACID) test to enhance the utility and security of a database. <br>Option C is a technique to reduce the likelihood of nonrepudiation but not the definition of the term.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      386,
      31,
      396,
      38,
      720
    ],
    "source": ""
  },
  {
    "id": 803,
    "question": "You are in charge of creating the business continuity and disaster recovery (BC/DR) plan and procedures for your organization. Your organization has its production environment hosted in a cloud environment. You are considering using cloud backup services for your BC/DR purposes as well. What would probably be the best strategy for this approach, in terms of redundancy and resiliency?",
    "choice_a": "Have your cloud provider also provide BC/DR backup.",
    "choice_b": "Keep a BC/DR backup on the premises of your corporate headquarters.",
    "choice_c": "Use another cloud provider for the BC/DR backup.",
    "choice_d": "Move your production environment back into your corporate premises, and use your cloud provider to host your BC/DR backup.",
    "correct_answer": "C",
    "explanation": "It\u2019s best to have your backup at another cloud provider in case whatever causes an interruption in service occurs throughout your primary provider\u2019s environment; this will be more complicated and expensive, but it provides the best redundancy and resiliency. Using the same provider for production and backup is not a bad option, but it entails the risk of the same contingency affecting both copies of your data. Having either the backup or the production environment localized does not provide the best protection, so neither option B nor option D is desirable.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      334,
      319,
      684,
      290,
      310
    ],
    "source": ""
  },
  {
    "id": 804,
    "question": "You are in charge of creating the business continuity and disaster recovery (BC/DR) plan and procedures for your organization. You decide to have a tabletop test of the BC/DR activity. Which of the following will offer the best value during the test?",
    "choice_a": "Have all participants conduct their individual activities via remote meeting technology.",
    "choice_b": "Task a moderator well versed in BC/DR actions to supervise and present scenarios to the participants, including randomized special events.",
    "choice_c": "Provide copies of the BC/DR policy to all participants.",
    "choice_d": "Allow all users in your organization to participate.",
    "correct_answer": "B",
    "explanation": "A trained and experienced moderator can guide the participants through the activity, enhancing their training and noting pitfalls and areas for improvement. Option A is not preferable because having the participants gathered together ensures their full attention and provides interaction that remote participation might not yield. Option C is a baseline; all participants should have copies of the policy as a matter of course. Option D is not useful in a tabletop exercise; only critical participants in the organization should take part in the tabletop.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      334,
      544,
      557,
      556,
      241
    ],
    "source": ""
  },
  {
    "id": 805,
    "question": "You are in charge of creating the business continuity and disaster recovery (BC/DR) plan and procedures for your organization. Your organization has its production environment hosted by a cloud provider, and you have appropriate protections in place. Which of the following is a significant consideration for your BC/DR backup?",
    "choice_a": "Enough personnel at the BC/DR recovery site to ensure proper operations",
    "choice_b": "Good cryptographic key management",
    "choice_c": "Access to the servers where the BC/DR backup is stored",
    "choice_d": "Forensic analysis capabilities",
    "correct_answer": "B",
    "explanation": "This is a difficult question that requires a great deal of thought. Option B is correct because appropriate cloud data security practices will require encrypting a great deal of the data, and having the keys will be necessary during contingency operations in order to access the backup; without the keys, you won\u2019t be able to access your data. Option A is not correct because using the cloud for BC/DR will allow personnel to access the backup from anywhere they can get broadband connectivity, not specifically a recovery site. Option C is not correct because the customer will rarely have physical access to servers in the cloud environment. Option D is not correct because forensic analysis is not a significant consideration in BC/DR; it is much more important for incident response.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      48,
      53,
      54,
      334,
      47
    ],
    "source": ""
  },
  {
    "id": 806,
    "question": "You are in charge of creating the business continuity and disaster recovery (BC/DR) plan and procedures for your organization. You are going to conduct a full test of the BC/DR plan. Which of the following strategies is an optimum technique to avoid major issues?",
    "choice_a": "Have another full backup of the production environment stored prior to the test.",
    "choice_b": "Assign all personnel tasks to perform during the test.",
    "choice_c": "Have the cloud provider implement a simulated disaster at a random moment in order to maximize realistic testing.",
    "choice_d": "Have your regulators present at the test so they can monitor performance.",
    "correct_answer": "A",
    "explanation": "A full test will involve both the production environment and the backup data; it is possible to create an actual disaster during a full test by ruining the availability of both. Therefore, it is crucial to have a full backup, distinct from the BC/DR backup, in order to roll back from the test in case something goes horribly wrong. <br>Option B is incorrect because not all personnel will have tasks to perform; most personnel will have to evacuate from the facility only during a full test. <br>Option C is incorrect because the cloud provider should not initiate the test, and the test should not take place at a random moment. <br>Option D is not correct because the regulators\u2019 presence will not add any value to the test.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      556,
      557,
      545,
      334,
      319
    ],
    "source": ""
  },
  {
    "id": 807,
    "question": "A Security Assertion Markup Language (SAML) identity assertion token uses the ___________________ protocol.",
    "choice_a": "Extensible Markup Language (XML)",
    "choice_b": "Hypertext Transfer Protocol (HTTP)",
    "choice_c": "Hypertext Markup Language (HTML)",
    "choice_d": "American Standard Code for Information Interchange (ASCII)",
    "correct_answer": "A",
    "explanation": "Security Assertion Markup Language (SAML) is based on XML. HTTP is used for port 80 web traffic; HTML is used to present web pages. ASCII is the universal alphanumeric character set.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      542,
      541,
      543,
      55,
      685
    ],
    "source": ""
  },
  {
    "id": 808,
    "question": "The minimum essential characteristics of a cloud data center are often referred to as \u201cping, power, pipe.\u201d What does this term mean?",
    "choice_a": "Remote access for customer to racked devices in the data center; electrical utilities; connectivity to an Internet service provider (ISP)/the Internet",
    "choice_b": "Application suitability; availability; connectivity",
    "choice_c": "Infrastructure as a service (IaaS); software as a service (SaaS); platform as a service (PaaS)",
    "choice_d": "Anti-malware tools; controls against distributed denial of service (DDoS) attacks; physical/environmental security controls, including fire suppression",
    "correct_answer": "A",
    "explanation": "Option A is the definition of the term; the other answers are not.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      532,
      685,
      312,
      724,
      725
    ],
    "source": ""
  },
  {
    "id": 809,
    "question": "To support all aspects of the CIA triad (confidentiality, integrity, availability), all of the following aspects of a cloud data center need to be engineered with redundancies <italic>except</italic> ___________________.",
    "choice_a": "Power supply",
    "choice_b": "HVAC",
    "choice_c": "Administrative offices",
    "choice_d": "Internet service provider (ISP)/connectivity lines",
    "correct_answer": "C",
    "explanation": "The administrative offices of a cloud data center rarely are part of the critical functions of the operation; a data center could likely endure the loss of the administrative offices for a considerable length of time, so redundancy here is probably not cost effective. <br>All the other items <italic>are</italic> part of the critical path and need redundancies.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      289,
      555,
      312,
      241,
      725
    ],
    "source": ""
  },
  {
    "id": 810,
    "question": "Who is the cloud carrier?",
    "choice_a": "The cloud customer",
    "choice_b": "The cloud provider",
    "choice_c": "The regulator overseeing the cloud customer\u2019s industry",
    "choice_d": "The ISP between the cloud customer and provider",
    "correct_answer": "D",
    "explanation": "Option D is the definition of a cloud carrier, from National Institute of Standards and Technology (NIST) Special Publication (SP) 500-292. <br>All the other options are incorrect, as defined by NIST SP 500-292 .",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      679,
      42,
      534,
      535,
      241
    ],
    "source": ""
  },
  {
    "id": 811,
    "question": "Which of the following terms describes a means to centralize logical control of all networked nodes in the environment, abstracted from the physical connections to each?",
    "choice_a": "Virtual private network (VPN)",
    "choice_b": "Software-defined network (SDN)",
    "choice_c": "Access control lists (ACLs)",
    "choice_d": "Role-based access control (RBAC)",
    "correct_answer": "B",
    "explanation": "The question describes a software-defined network (SDN). <br>A VPN is used for creating an encrypted communications tunnel over an untrusted medium, so option A is incorrect. <br>ACLs are used as centralized repositories for identification, authentication, and authorization purposes, so option C is incorrect. <br>RBAC is an access control model used to assign permissions based on job functions within an organization, so option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      520,
      536,
      714,
      712,
      685
    ],
    "source": ""
  },
  {
    "id": 812,
    "question": "In software-defined networking (SDN), the northbound interface (NBI) usually handles traffic between the ___________________ and the ___________________.",
    "choice_a": "Cloud customer; ISP",
    "choice_b": "SDN controllers; SDN applications",
    "choice_c": "Cloud provider; ISP",
    "choice_d": "Router; host",
    "correct_answer": "B",
    "explanation": "The NBI usually handles traffic between the SDN controllers and SDN applications. <br>Options A and C are incorrect because neither of those options lists any of the SDN infrastructure, be that the controllers or the applications. Option D may be <italic>arguably</italic> correct, as there might be an NBI handling that traffic between those nodes, but option B is more specific and always true for this definition, so it is the better choice.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      520,
      522,
      685,
      712,
      532
    ],
    "source": ""
  },
  {
    "id": 813,
    "question": "Software-defined networking (SDN) allows network administrators and architects to perform all the following functions <italic>except</italic> __________________.",
    "choice_a": "Reroute traffic based on current customer demand",
    "choice_b": "Create logical subnets without having to change any actual physical connections",
    "choice_c": "Filter access to resources based on specific rules or settings",
    "choice_d": "Deliver streaming media content in an efficient manner by placing it closer to the end user",
    "correct_answer": "D",
    "explanation": "Option D is really a definition of a CDN (content delivery network). <br>All the other options are aspects of SDNs.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      521,
      520,
      522,
      532,
      535
    ],
    "source": ""
  },
  {
    "id": 814,
    "question": "Which of the following is a device specially purposed to handle the issuance, distribution, and storage of cryptographic keys?",
    "choice_a": "Key management box (KMB)",
    "choice_b": "Hardware security module (HSM)",
    "choice_c": "Ticket-granting ticket (TGT)",
    "choice_d": "Trusted computing base (TCB)",
    "correct_answer": "B",
    "explanation": "The question describes an HSM.<br> KMB is a nonsense term used as a distractor, so it is incorrect. <br>TGT is a term associated with Kerberos single sign-on systems and is incorrect. <br>The TCB includes the elements of hardware and software (usually in the operating system) that ensure that a system can only be controlled by those with the proper permissions (i.e., admins with root control), so it is also incorrect.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      53,
      54,
      48,
      43,
      55
    ],
    "source": ""
  },
  {
    "id": 815,
    "question": "When discussing the cloud, we often segregate the data center into the terms <italic>compute, storage</italic>, and <italic>networking</italic>. Compute is made up of ___________________ and ___________________.",
    "choice_a": "Routers; hosts",
    "choice_b": "Application programming interface (APIs); northbound interface (NBIs)",
    "choice_c": "Central processing unit (CPU); random-access memory (RAM)",
    "choice_d": "Virtualized; actual hardware devices",
    "correct_answer": "C",
    "explanation": "The compute nodes of a cloud data center can be measured in terms of how many central processing units (CPUs) and how much random access memory (RAM) is available within the center. <br>Option A is incorrect because routers would be considered a part of the networking of a data center (and because option C is a better answer). <br>Option B involves applications and how traffic flows between them and storage controllers; it has nothing to do with the compute nodes and is therefore wrong. <br>Option D might obliquely be considered correct because it\u2019s technically true (compute nodes will include both virtual and hardware machines), but option C is a much better and more accurate choice.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      533,
      532,
      50,
      714,
      712
    ],
    "source": ""
  },
  {
    "id": 816,
    "question": "All of the following can be used to properly apportion cloud resources <italic>except</italic> ___________________.",
    "choice_a": "Reservations",
    "choice_b": "Shares",
    "choice_c": "Cancellations",
    "choice_d": "Limits",
    "correct_answer": "C",
    "explanation": "\u201cCancellations\u201d is not a term used to describe a resource allotment methodology. All of the other options are such terms.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      527,
      532,
      522,
      312,
      684
    ],
    "source": ""
  },
  {
    "id": 817,
    "question": "Which of the following is a method for apportioning resources that involves setting guaranteed minimums for all tenants/customers within the environment?",
    "choice_a": "Reservations",
    "choice_b": "Shares",
    "choice_c": "Cancellations",
    "choice_d": "Limits",
    "correct_answer": "A",
    "explanation": "The question is the definition of reservations.<br>Options B and D are also resource apportioning methods, but they do not fall under the definition described in the question. <br>Option C is incorrect because it has no meaning in this context.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      526,
      527,
      536,
      532,
      534
    ],
    "source": ""
  },
  {
    "id": 818,
    "question": "Which of the following is a method for apportioning resources that involves setting maximum usage amounts for all tenants/customers within the environment?",
    "choice_a": "Reservations",
    "choice_b": "Shares",
    "choice_c": "Cancellations",
    "choice_d": "Limits",
    "correct_answer": "D",
    "explanation": "The question describes limits. <br>Options A and B are also resource apportioning methods, but they do not fall under the definition described in the question. <br>Option C is because it has no meaning in this context.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      526,
      527,
      532,
      536,
      534
    ],
    "source": ""
  },
  {
    "id": 819,
    "question": "Which of the following is a method for apportioning resources that involves prioritizing resource requests to resolve contention situations?",
    "choice_a": "Reservations",
    "choice_b": "Shares",
    "choice_c": "Cancellations",
    "choice_d": "Limits",
    "correct_answer": "B",
    "explanation": "The question describes shares. <br>Options A and D are also resource apportioning methods, but they do not fall under the definition described in the question. <br>Option C is incorrect because it has no meaning in this context.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      524,
      527,
      523,
      526,
      525
    ],
    "source": ""
  },
  {
    "id": 820,
    "question": "A bare-metal hypervisor is Type ___________________.",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "A",
    "explanation": "A bare-metal hypervisor is a Type 1 hypervisor. <br>Option B describes another type of hypervisor; the other options are incorrect because there is no such thing as a Type 3 or Type 4 hypervisor.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      529,
      532,
      531,
      534,
      530
    ],
    "source": ""
  },
  {
    "id": 821,
    "question": "A hypervisor that runs inside another operating system (OS) is a Type ___________________ hypervisor.",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "B",
    "explanation": "The question describes a Type 2 hypervisor. <br>Option A describes another type of hypervisor; the other options are incorrect because there is no such thing as a Type 3 or Type 4 hypervisor.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      529,
      532,
      531,
      534,
      530
    ],
    "source": ""
  },
  {
    "id": 822,
    "question": "A Type ___________________ hypervisor is probably more difficult to defend than other hypervisors.",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "B",
    "explanation": "A Type 2 hypervisor relies on the underlying operating system (OS) to operate properly; the underlying OS offers a large attack surface for aggressors. <br>A Type 1 hypervisor boots directly from the hardware; it\u2019s much easier to secure a machine\u2019s Basic Input/Output System (BIOS) than an entire OS, so option B is better than option A. <br>Options C and D are incorrect because there is no such thing as a Type 3 or Type 4 hypervisor.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      530,
      529,
      534,
      532,
      531
    ],
    "source": ""
  },
  {
    "id": 823,
    "question": "One of the security challenges of operating in the cloud is that additional controls must be placed on file storage systems because ___________________.",
    "choice_a": "File stores are always kept in plain text in the cloud",
    "choice_b": "There is no way to sanitize file storage space in the cloud",
    "choice_c": "Virtualization necessarily prevents the use of application-based security controls",
    "choice_d": "Virtual machines are stored as snapshotted files when not in use",
    "correct_answer": "D",
    "explanation": "VMs are snapshotted and simply stored as files when they are not being used; an attacker who gains access to those file stores could ostensibly steal entire machines in highly portable, easily copied formats. Therefore, these cloud storage spaces must include a significant amount of controls. <br>Options A and C are simply untrue. <br>Option B is untrue when crypto-shredding is utilized.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      42,
      49,
      52,
      53,
      48
    ],
    "source": ""
  },
  {
    "id": 824,
    "question": "What is the main reason virtualization is used in the cloud?",
    "choice_a": "Virtual machines (VMs) are easier to administer.",
    "choice_b": "If a VM is infected with malware, it can be easily replaced.",
    "choice_c": "With VMs, the cloud provider does not have to deploy an entire hardware device for every new user.",
    "choice_d": "VMs are easier to operate than actual devices.",
    "correct_answer": "C",
    "explanation": "While options A and B are both also true, C is the most significant reason cloud data centers use VMs. If the cloud provider had to purchase a new box for every user, the cost of cloud services would be as much as running a traditional environment (or likely cost even more), and there would be no reason for any organization to migrate to the cloud, especially considering the risks associated with disclosing data to a third party. <br>Option D is simply untrue. VMs are not easier to operate than actual devices.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      532,
      534,
      312,
      49,
      50
    ],
    "source": ""
  },
  {
    "id": 825,
    "question": "Orchestrating resource calls is the job of the ___________________.",
    "choice_a": "Administrator",
    "choice_b": "Router",
    "choice_c": "VM",
    "choice_d": "Hypervisor",
    "correct_answer": "D",
    "explanation": "The question describes what the hypervisor does. (Note that the answer \u201coperating system\u201d would also work here but was not one of the options.) <br>Option A is incorrect; the allocation of resources is not performed manually. <br>The router directs traffic between networks; it does not apportion resources. Therefore, option B is incorrect. <br>A VM makes resource calls; option C is incorrect.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      532,
      533,
      534,
      523,
      526
    ],
    "source": ""
  },
  {
    "id": 826,
    "question": "Which of the following terms describes a cloud storage area that uses a filesystem/hierarchy?",
    "choice_a": "Volume storage",
    "choice_b": "Object storage",
    "choice_c": "Logical unit number (LUN)",
    "choice_d": "Block storage",
    "correct_answer": "B",
    "explanation": "Object storage is, literally, a means of storing objects in a hierarchy such as a file tree. <br>All the other options are terms used to describe cloud storage areas without file structures.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      51,
      49,
      50,
      42,
      45
    ],
    "source": ""
  },
  {
    "id": 827,
    "question": "Typically, which form of cloud storage is used in the near term for snapshotted virtual machine (VM) images?",
    "choice_a": "Volume storage",
    "choice_b": "Object storage",
    "choice_c": "Logical unit number (LUN)",
    "choice_d": "Block storage",
    "correct_answer": "B",
    "explanation": "Snapshotted VM images are usually kept in object storage, as files. <br>All the other options are incorrect and option C is not a type of storage.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      51,
      49,
      552,
      42,
      44
    ],
    "source": ""
  },
  {
    "id": 828,
    "question": "Who operates the management plane?",
    "choice_a": "Regulators",
    "choice_b": "End consumers",
    "choice_c": "Privileged users",
    "choice_d": "Privacy data subjects",
    "correct_answer": "C",
    "explanation": "Only the most trusted administrators and managers will have access to the cloud data center\u2019s management plane. These will usually be cloud provider employees, but some cloud customer personnel may be granted limited access to arrange their organization\u2019s cloud resources. <br>Regulators do not operate a customer\u2019s management plane, so option A is incorrect. <br>Option B is ambiguous. However, a consumer of data is unlikely to have been given the elevated privileges necessary of operate the management plane in a cloud environment. Option B is incorrect. <br>Option D is also an ambiguous answer. Only the most trusted administrators and managers have access to the cloud data center\u2019s management plane. A privacy data subject is neither a most trusted administrator nor a trusted manager. Therefore, option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      242,
      448,
      534,
      532,
      459
    ],
    "source": ""
  },
  {
    "id": 829,
    "question": "What is probably the <italic>optimum</italic> way to avoid vendor lock-in?",
    "choice_a": "Use nonproprietary data formats.",
    "choice_b": "Use industry-standard media.",
    "choice_c": "Use strong cryptography.",
    "choice_d": "Use favorable contract language.",
    "correct_answer": "D",
    "explanation": "The contract is probably the cloud customer\u2019s best tool for avoiding vendor lock-in; contract terms will establish how easy it is to migrate your organization\u2019s data to another provider in a timely, cost-effective manner. <br>Options A and B are also important ways to avoid vendor lock-in, but D is the best answer. <br>Option C is incorrect and will not aid in avoiding vendor lock-in.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      525,
      403,
      404,
      545,
      543
    ],
    "source": ""
  },
  {
    "id": 830,
    "question": "Who will determine whether your organization\u2019s cloud migration is satisfactory from a compliance perspective?",
    "choice_a": "The cloud provider",
    "choice_b": "The cloud customer",
    "choice_c": "The regulator(s)",
    "choice_d": "The Internet service provider (ISP)",
    "correct_answer": "C",
    "explanation": "The regulator(s) overseeing your industry/organization will make the final determination as to whether your cloud configuration is suitable to meet their requirements. It is best to coordinate with your regulator(s) when first considering cloud migration. <br>Cloud providers, cloud customers, and ISPs are not particularly concerned about whether an organization\u2019s migration is satisfactory from a compliance perspective. The words, \u201ccompliance perspective\u201d should automatically bring to mind regulator(s). Options A, B, and D are therefore incorrect answers.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      679,
      680,
      681,
      540,
      518
    ],
    "source": ""
  },
  {
    "id": 831,
    "question": "What is probably the best way to avoid problems associated with vendor lock-out?",
    "choice_a": "Use strong contract language.",
    "choice_b": "Use nonproprietary data and media formats.",
    "choice_c": "Use strong cryptography.",
    "choice_d": "Use another provider for backup purposes.",
    "correct_answer": "D",
    "explanation": "Vendor lockout occurs when the provider suddenly leaves the market, as during a bankruptcy or acquisition. The risks associated with lockout include denial of service, because of total unavailability of your data. The best way to handle these risks is to have another, full backup of your data with another vendor and the ability to reconstitute your operating environment in a time frame that doesn\u2019t exceed your recovery time objective (RTO). <br>The other options do not aid in addressing vendor lockout.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      404,
      403,
      556,
      525,
      49
    ],
    "source": ""
  },
  {
    "id": 832,
    "question": "In a public cloud services arrangement, who creates governance that will determine which controls are selected for the data center and how they are deployed?",
    "choice_a": "The cloud provider",
    "choice_b": "The cloud customer",
    "choice_c": "The regulator(s)",
    "choice_d": "The end user",
    "correct_answer": "A",
    "explanation": "Because the cloud provider owns and operates the cloud data center, the provider will craft and promulgate the governance that determines the control selection and usage. This is another risk the cloud customer must consider when migrating into the cloud; the customer\u2019s governance will no longer have direct precedence over the environment where the customer\u2019s data is located. <br>Both the cloud customer and the regulator(s) may have specific control mandates that might require the customer to deploy additional security controls (at the customer side, within the data, as agents on the user devices, or on the provider side or in application programming interfaces [APIs] as allowed by the service model or contract), so options B and C are also partially true, but A is a better answer as it is more general. <br>Option D untrue because the end user does not determine which controls are selected for the cloud data center and how they are deployed. That is the responsibility of the cloud provider.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      536,
      241,
      459,
      537,
      535
    ],
    "source": ""
  },
  {
    "id": 833,
    "question": "What is the term that describes the situation when a malicious user or attacker can exit the restrictions of a virtual machine (VM) and access another VM residing on the same host?",
    "choice_a": "Host escape",
    "choice_b": "Guest escape",
    "choice_c": "Provider exit",
    "choice_d": "Escalation of privileges",
    "correct_answer": "B",
    "explanation": "The question describes a guest escape. <br>Options A and C are other risks of operating in the cloud. Option D can lead to A or B, but B describes the more specific situation and therefore the correct answer.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      534,
      532,
      550,
      551,
      535
    ],
    "source": ""
  },
  {
    "id": 834,
    "question": "What is the term that describes the situation when a malicious user or attacker can exit the restrictions of a single host and access other nodes on the network?",
    "choice_a": "Host escape",
    "choice_b": "Guest escape",
    "choice_c": "Provider exit",
    "choice_d": "Escalation of privileges",
    "correct_answer": "A",
    "explanation": "The question describes host escape. <br>Options B and C are other risks of operating in the cloud. Option D can lead to A or B, but A is the more specific situation and therefore the correct answer.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      532,
      534,
      712,
      714,
      685
    ],
    "source": ""
  },
  {
    "id": 835,
    "question": "___________________ is/are probably the main cause of virtualization sprawl.",
    "choice_a": "Malicious attackers",
    "choice_b": "Lack of provider controls",
    "choice_c": "Lack of customer controls",
    "choice_d": "Ease of use",
    "correct_answer": "D",
    "explanation": "Because most cloud users don\u2019t see direct costs in creating new VM instances (the bills usually go to a single point of contact in the organization, not the user or the user\u2019s office), they may tend to create additional VMs at a significant rate, without realizing the attendant cost. This is largely because it is so easy to do and has no apparent cost, from their perspective. <br>All the other options do not cause virtualization sprawl.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      535,
      537,
      534,
      532,
      312
    ],
    "source": ""
  },
  {
    "id": 836,
    "question": "Sprawl is mainly a(n) ___________________ problem.",
    "choice_a": "Technical",
    "choice_b": "External",
    "choice_c": "Management",
    "choice_d": "Logical",
    "correct_answer": "C",
    "explanation": "Sprawl needs to be addressed from a managerial perspective because it is caused by allowed user actions (usually in a completely authorized capacity). <br>Options A and D mean the same thing and could be considered as contributing to sprawl because the technological capabilities of virtualization create the ease of use that can cause sprawl. However, option C is a better answer. <br>Option B is incorrect; sprawl occurs within the organization.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      535,
      536,
      537,
      241,
      534
    ],
    "source": ""
  },
  {
    "id": 837,
    "question": "Which of the following risks exists in the traditional environment but is dramatically increased by moving into the cloud?",
    "choice_a": "Physical security breaches",
    "choice_b": "Loss of utility power",
    "choice_c": "Financial upheaval",
    "choice_d": "Man-in-the-middle attacks",
    "correct_answer": "D",
    "explanation": "Because all cloud access is remote access, the risks to data in transit are dramatically heightened in the cloud. <br>The other options exist in both the traditional environment and the cloud but are probably actually reduced in the cloud because cloud providers can use economies of scale to invest in means to reduce those risks in ways that individual organizations would not be able to.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      43,
      53,
      45,
      58,
      59
    ],
    "source": ""
  },
  {
    "id": 838,
    "question": "A fundamental aspect of security principles, ___________________ should be implemented in the cloud as well as in traditional environments.",
    "choice_a": "Continual uptime",
    "choice_b": "Defense in depth",
    "choice_c": "Multifactor authentication",
    "choice_d": "Separation of duties",
    "correct_answer": "B",
    "explanation": "Defense in depth, or layered defense, is perhaps the most fundamental characteristic of all security concepts. <br>Options A and C are security aspects of some environments, and option A is likely to be a necessary trait of managed cloud services, but they are not fundamentals\u2014they are specifics. <br>Option D is specifically an administrative control; the question is looking for a fundamental aspect of security. Option B is more general (it applies to all types of security, in all industries and uses) and therefore is the correct choice for this question.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      241,
      42,
      44,
      45,
      46
    ],
    "source": ""
  },
  {
    "id": 839,
    "question": "From a security perspective, automation of configuration aids in ___________________.",
    "choice_a": "Enhancing performance",
    "choice_b": "Reducing potential attack vectors",
    "choice_c": "Increasing ease of use of the systems",
    "choice_d": "Reducing need for administrative personnel",
    "correct_answer": "B",
    "explanation": "A secure baseline configuration, applied and maintained automatically, ensures the optimum security footprint with the least attack surface. <br>All the other options are benefits of automated configuration but are not specifically security enhancements.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      538,
      540,
      517,
      539,
      534
    ],
    "source": ""
  },
  {
    "id": 840,
    "question": "prevalent protocol used in identity federation.",
    "choice_a": "Hypertext Transfer Protocol (HTTP)",
    "choice_b": "Security Assertion Markup Language (SAML)",
    "choice_c": "File Transfer Protocol (FTP)",
    "choice_d": "WS-Federation",
    "correct_answer": "B",
    "explanation": "The Security Assertion Markup Language (SAML) is probably the most common protocol being used for identity federation at the moment. <br>Options A and C are not identity federation protocols. <br>Option D is a federation specification, but it also uses SAML tokens.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      542,
      541,
      543,
      691,
      241
    ],
    "source": ""
  },
  {
    "id": 841,
    "question": "A user signs on to a cloud-based social media platform. In another browser tab, the user finds an article worth posting to the social media platform. The user clicks on the platform\u2019s icon listed on the article\u2019s website, and the article is automatically posted to the user\u2019s account on the social media platform. This is an example of what?",
    "choice_a": "Single sign-on",
    "choice_b": "Insecure direct identifiers",
    "choice_c": "Identity federation",
    "choice_d": "Cross-site scripting",
    "correct_answer": "C",
    "explanation": "This is a very popular function of federated identity. <br>Single sign-on (SSO) is similar to federation, but it is limited to a single organization; federation is basically SSO across multiple organizations. Option A is incorrect. <br>Options B and D are threats listed in the Open Web Application Security Project (OWASP) Top Ten; they are incorrect.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      45,
      44,
      55,
      57,
      60
    ],
    "source": ""
  },
  {
    "id": 842,
    "question": "A group of clinics decides to create an identification federation for their users (medical providers and clinicians). If they opt to review each other, for compliance with security governance and standards they all find acceptable, what is this federation model called?",
    "choice_a": "Cross-certification",
    "choice_b": "Proxy",
    "choice_c": "Single sign-on",
    "choice_d": "Regulated",
    "correct_answer": "A",
    "explanation": "The cross-certification federation model is also known as a <italic>web of trust</italic>. <br>Proxy is another model for federation, so option B is incorrect. <br>Single sign-on is similar to federation, but it is limited to a single organization; option C is incorrect. <br>Option D does not have relevance in this context and is therefore incorrect as an answer.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      543,
      541,
      542,
      241,
      679
    ],
    "source": ""
  },
  {
    "id": 843,
    "question": "A group of clinics decides to create an identification federation for their users (medical providers and clinicians). If they opt to hire a third party to review each organization, for compliance with security governance and standards they all find acceptable, what is this federation model called?",
    "choice_a": "Cross-certification",
    "choice_b": "Proxy",
    "choice_c": "Single sign-on",
    "choice_d": "Regulated",
    "correct_answer": "B",
    "explanation": "In the proxy federation model, the third party acts on behalf of the member organizations, reviewing each to ensure that they are all acceptable to the others. <br>Cross-certification is another model for federation, so option A is incorrect. <br>Single sign-on is similar to federation, but it is limited to a single organization; option C is incorrect. <br>Option D does not have relevance in this context and is therefore incorrect as an answer.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      543,
      541,
      542,
      241,
      536
    ],
    "source": ""
  },
  {
    "id": 844,
    "question": "A group of clinics decides to create an identification federation for their users (medical providers and clinicians). If they opt to use the web of trust model for federation, who is/are the identity provider(s)?",
    "choice_a": "Each organization",
    "choice_b": "A trusted third party",
    "choice_c": "The regulator overseeing their industry",
    "choice_d": "All of their patients",
    "correct_answer": "A",
    "explanation": "In a web of trust federation model, all of the participating organizations are identity providers; each organization will assign identity credentials to its own authorized users, and all the other organizations in the federation will accept those credentials. <br>A trusted third party, regulators, and clientele are not involved in the web of trust model, so the other options are incorrect.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      541,
      542,
      543,
      242,
      536
    ],
    "source": ""
  },
  {
    "id": 845,
    "question": "A group of clinics decides to create an identification federation for their users (medical providers and clinicians). If they opt to use the web of trust model for federation, who is/are the service providers?",
    "choice_a": "Each organization",
    "choice_b": "A trusted third party",
    "choice_c": "The regulator overseeing their industry",
    "choice_d": "All of their patients",
    "correct_answer": "A",
    "explanation": "In a web of trust model, each member organization usually supplies both the access/identification credentials and the resources that the users want to access, so the organizations are both the identity providers and service providers in a web of trust federation model. <br>A trusted third party, regulators, and clientele are not involved in the web of trust model, so the other options are incorrect.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      541,
      542,
      543,
      55,
      241
    ],
    "source": ""
  },
  {
    "id": 846,
    "question": "A group of clinics decides to create an identification federation for their users (medical providers and clinicians). In this federation, all of the participating organizations would need to be in compliance with what U.S. federal regulation?",
    "choice_a": "Gramm-Leach-Bliley Act (GLBA)",
    "choice_b": "Family and Medical Leave Act (FMLA)",
    "choice_c": "Payment Card Industry Data Security Standard (PCI DSS)",
    "choice_d": "Health Information Portability and Accountability Act (HIPAA)",
    "correct_answer": "D",
    "explanation": "While it\u2019s likely the participating organizations will be subject to other federal regulations, HIPAA covers electronic patient information, so it will definitely be applicable in this case. <br>GLBA covers financial and insurance service providers, so option A is incorrect. <br>FMLA dictates how employers give vacation time to employees, so option B is incorrect. <br>PCI DSS is a contractual, not regulatory, standard, so option C is incorrect.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      543,
      542,
      679,
      680,
      55
    ],
    "source": ""
  },
  {
    "id": 847,
    "question": "What is the process of granting access to resources?",
    "choice_a": "Identification",
    "choice_b": "Authentication",
    "choice_c": "Authorization",
    "choice_d": "Federation",
    "correct_answer": "C",
    "explanation": "The question describes authorization. <br>Options A and B are part of the overall identity and access management (IAM) process, as is option C, but they do not specifically describe granting access to resources. <br>Federation is a means of conducting IAM across organizations; option C is more specific, so D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      242,
      241,
      448,
      449,
      691
    ],
    "source": ""
  },
  {
    "id": 848,
    "question": "The process of identity management includes all the following elements <italic>except</italic> __________________.",
    "choice_a": "Provisioning",
    "choice_b": "Maintenance",
    "choice_c": "Deprovisioning",
    "choice_d": "Redaction",
    "correct_answer": "D",
    "explanation": "Redacting is an editorial process of excising sensitive information from disclosed data. All the other options are elements of identity management.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      242,
      241,
      543,
      542,
      541
    ],
    "source": ""
  },
  {
    "id": 849,
    "question": "Which organizational entity usually performs the verification part of the provisioning element of the identification process?",
    "choice_a": "Information technology (IT)",
    "choice_b": "Security",
    "choice_c": "Human resources (HR)",
    "choice_d": "Sales",
    "correct_answer": "C",
    "explanation": "This is a complicated question and requires thinking through the portions of the identification process. <br>Identification of personnel is usually verified during the hiring process, when HR checks identification documents (such as a passport or birth certificate) to confirm the applicant\u2019s identity, often as part of a tax registration process. <br>Options A and B include offices that may play a role in the identification process, but it is usually HR that does the actual verification. <br>Option D, \u201cSales\u201d is untrue. If a Sales department exists in an organization, it does not perform the verification part of the provisioning element of the identification process.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      241,
      459,
      536,
      44,
      43
    ],
    "source": ""
  },
  {
    "id": 850,
    "question": "Of the following options, which is a reason cloud data center audits are often less easy to verify than traditional audits?",
    "choice_a": "Data in the cloud can\u2019t be audited.",
    "choice_b": "Controls in the cloud can\u2019t be audited.",
    "choice_c": "Getting physical access can be difficult.",
    "choice_d": "There are no regulators for cloud operations.",
    "correct_answer": "C",
    "explanation": "Cloud providers may be reluctant to grant physical access, even to their customers, on the assumption that allowing access would disclose information about security controls. In some cases, cloud customers won\u2019t even know the location(s) of the data center(s) where their data is stored. <br>The other options are all untrue. Data in the cloud and controls in the cloud can most certainly be audited. So, options A and B are incorrect. D is untrue; there are regulators for all industries, including those that operate in the cloud.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      241,
      44,
      59,
      448,
      449
    ],
    "source": ""
  },
  {
    "id": 851,
    "question": "Of the following options, which is a reason cloud data center audits are often less easy to verify than traditional audits?",
    "choice_a": "Cryptography is present.",
    "choice_b": "Auditors don\u2019t like the cloud.",
    "choice_c": "Cloud equipment is resistant to audit.",
    "choice_d": "They often rely on data the provider chooses to disclose.",
    "correct_answer": "D",
    "explanation": "In many circumstances, a cloud audit will depend on which information a cloud provider discloses, which makes auditing difficult and less trustworthy. <br>Option A is incorrect because cryptography is sometimes present in traditional environments and audits still take place. <br>Option B is incorrect; auditors\u2019 opinions are not relevant. <br>Option C is untrue; equipment does not resist auditing-- it is inanimate and unfeeling.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      44,
      60,
      543,
      45,
      42
    ],
    "source": ""
  },
  {
    "id": 852,
    "question": "Of the following options, which is a reason cloud data center audits are often less easy to verify than audits in traditional data centers?",
    "choice_a": "They frequently rely on third parties.",
    "choice_b": "The standards are too difficult to follow.",
    "choice_c": "The paperwork is cumbersome.",
    "choice_d": "There aren\u2019t enough auditors.",
    "correct_answer": "A",
    "explanation": "Because cloud audits are often the result of third-party assertions, recipients of cloud audit reports may be more skeptical of the results than they would have been of traditional audits, in which the recipients may have performed firsthand. <br>Option B is untrue. The difficulty of standards is not a hindrance to audit.<br>Option C is untrue. Paperwork does not hinder audits. <br>Option D is not only untrue, but also hilarious. If you have ever been involved in an audit, you know that there are plenty of auditors to go around.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      44,
      680,
      241,
      545,
      556
    ],
    "source": ""
  },
  {
    "id": 853,
    "question": "The cloud customer will usually not have physical access to the cloud data center. This enhances security by ___________________.",
    "choice_a": "Reducing the need for qualified personnel",
    "choice_b": "Limiting access to sensitive information",
    "choice_c": "Reducing jurisdictional exposure",
    "choice_d": "Ensuring statutory compliance",
    "correct_answer": "B",
    "explanation": "The \u201csensitive information,\u201d in this case, is whatever knowledge of the data center\u2019s security controls and processes might be gathered by physically visiting the data center. Even though a cloud customer cannot get access to the facility, this also means that other cloud customers (some of whom may be inimical to another customer\u2019s interests) also will not have access, so none would have advantage over the other(s). <br>Option A is incorrect because qualified personnel are still required whether a cloud environment has limited access to their data center or not. In fact, security may be degraded by having unqualified personnel rather than qualified personnel working in the cloud data center. <br>Option C is incorrect because reducing jurisdictional exposure does not enhance security. <br>There may be a correlation between ensuring statutory compliance and enhancing security as it applies to limiting access to the cloud data center. However, option B is a better answer because it is certainly true. Therefore, option D is not the best answer to the question.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      241,
      448,
      44,
      42,
      58
    ],
    "source": ""
  },
  {
    "id": 854,
    "question": "Which of the following controls would be useful to build into a virtual machine baseline image for a cloud environment?",
    "choice_a": "GPS tracking/locator",
    "choice_b": "Automated vulnerability scan on system startup",
    "choice_c": "Access control list (ACL) of authorized personnel",
    "choice_d": "Write protection",
    "correct_answer": "B",
    "explanation": "Because VMs don\u2019t take updates when they are not in use (snapshotted and saved as image files) and updates may be pushed while the VMs are saved, it\u2019s important to ensure that they receive updates when they are next instantiated. <br>A physical tracking mechanism won\u2019t be of much aid for virtual devices because they aren\u2019t physically stolen like hardware boxes, so option A is incorrect. <br>Having an ACL in the image baseline would create a situation where every user from every cloud customer could access every VM in the data center; option C is incorrect. <br>Write protection is used in forensic analysis of machines (virtual or otherwise); it would not be useful in an operational baseline. Option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      550,
      457,
      458,
      532,
      44
    ],
    "source": ""
  },
  {
    "id": 855,
    "question": "Which of the following controls would be useful to build into a virtual machine baseline image for a cloud environment?",
    "choice_a": "Automatic registration with the configuration management system",
    "choice_b": "Enhanced user training and awareness media",
    "choice_c": "Mechanisms that prevent the file from being copied",
    "choice_d": "Keystroke loggers",
    "correct_answer": "A",
    "explanation": "Version control can be difficult in a virtual environment because saved VMs don\u2019t receive updates. Ensuring that each VM is the correct version is a function of configuration management (CM), and CM controls can be built into the baseline. <br>Each organization will have its own training and awareness program, and there is no one-size-fits-all solution that is appropriate; this does not belong in the baseline. Option B is incorrect. <br>Having a baseline that cannot be copied is pointless; option C is incorrect. <br>Keystroke loggers will create a huge volume of detailed, stored data that will pose more of a security risk (and may actually be a violation of customer privacy regulations) than any benefit it offers; option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      517,
      538,
      458,
      457,
      550
    ],
    "source": ""
  },
  {
    "id": 856,
    "question": "Virtual machine (VM) configuration management (CM) tools should probably include ___________________.",
    "choice_a": "Biometric recognition",
    "choice_b": "Anti-tampering mechanisms",
    "choice_c": "Log file generation",
    "choice_d": "Hackback capabilities",
    "correct_answer": "C",
    "explanation": "Event logging is essential for incident management and resolution; this can be set as an automated function of the CM tools. <br>Not all systems need or can utilize biometrics; option A is incorrect. <br>Usually, <italic>tampering</italic> refers to physical intrusion of a device; since the question is about VMs, it is probably not applicable. Option B is incorrect. <br>Hackback is illegal in many jurisdictions; option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      61,
      60,
      534,
      550,
      540
    ],
    "source": ""
  },
  {
    "id": 857,
    "question": "Using a virtual machine baseline image could be very useful for which of the following options?",
    "choice_a": "Physical security",
    "choice_b": "Auditing",
    "choice_c": "Training",
    "choice_d": "Customization",
    "correct_answer": "B",
    "explanation": "A specified configuration built to defined standards and with a controlled process can be used to demonstrate that all VMs within an environment include certain controls; this can greatly enhance the efficiency of an audit process. <br>The VM\u2019s image has very little to do with physical security or training; options A and C are incorrect. <br>Baseline images are the opposite of customization; option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      538,
      241,
      44,
      545,
      556
    ],
    "source": ""
  },
  {
    "id": 858,
    "question": "What can be revealed by an audit of a baseline virtual image, used in a cloud environment?",
    "choice_a": "Adequate physical protections in the data center",
    "choice_b": "Potential criminal activity before it occurs",
    "choice_c": "Whether necessary security controls are in place and functioning properly",
    "choice_d": "Lack of user training and awareness",
    "correct_answer": "C",
    "explanation": "The baseline will contain the suite of security controls applied uniformly throughout the environment. <br>A VM image audit is unlikely to involve any form of physical security; A is incorrect. <br>Baselines won\u2019t predictively show malicious activity; B is incorrect. <br>Baselines also do not have anything to do with user training and awareness; option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      538,
      517,
      458,
      241,
      550
    ],
    "source": ""
  },
  {
    "id": 859,
    "question": "Using one cloud provider for your operational environment and another for your BC/DR backup will also give you the additional benefit of ___________________.",
    "choice_a": "Allowing any custom VM builds you use to be instantly ported to another environment",
    "choice_b": "Avoiding vendor lock-in/lock-out",
    "choice_c": "Increased performance",
    "choice_d": "Lower cost",
    "correct_answer": "B",
    "explanation": "Having an additional backup with a different provider means that if your primary provider becomes unusable for any reason (including bankruptcy or unfavorable contract terms), your data is not held hostage or lost. <br>Custom VMs may or may not work in a new environment; this is actually a risk when porting data out of the production environment; option A is incorrect. <br>Performance probably will not increase if data is replicated to another cloud provider; in fact, you will probably lose some load balancing capability you might have had if you kept the data and backups together. Option C is incorrect. <br>Having two providers will always be more costly than a single provider; option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      699,
      557,
      239,
      45,
      42
    ],
    "source": ""
  },
  {
    "id": 860,
    "question": "Having your BC/DR backup stored with the same cloud provider as your production environment can help you ___________________.",
    "choice_a": "Maintain regulatory compliance",
    "choice_b": "Spend less of your budget on traveling",
    "choice_c": "Train your users about security awareness",
    "choice_d": "Recover quickly from minor incidents",
    "correct_answer": "D",
    "explanation": "Having the backup within the same environment can allow easy rollback to a last known good state or to reinstantiate clean VM images after minor incidents (e.g., a malware infection in certain VMs). <br>Ease of compliance will not be determined by the location of the backup, so option A is incorrect. <br>Traveling should not be a major cost for cloud usage; option B is incorrect. <br>The location of the backups won\u2019t have any effect on user training; option C is incorrect.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      557,
      556,
      552,
      550,
      42
    ],
    "source": ""
  },
  {
    "id": 861,
    "question": "If you use the cloud for BC/DR purposes, even if you don\u2019t operate your production environment in the cloud, you can cut costs by eliminating your ___________________.",
    "choice_a": "Security personnel",
    "choice_b": "BC/DR policy",
    "choice_c": "Old access credentials",
    "choice_d": "Need for a physical hot site/warm site",
    "correct_answer": "D",
    "explanation": "Having your data backed up and accessible in the cloud eliminates any need for having a distinct hot site/warm site separate from your primary operating environment; instead, your personnel can recover operations from anywhere with a good broadband connection. <br>Cloud BC/DR capability does not remove the necessity of security personnel and appropriate policies; both options A and B are incorrect. <br>Option C makes no sense as an answer to the question. It is unclear how you can cut costs by eliminating your old access credentials. In fact, it is difficult to imagine how that is a true statement. Therefore, option C is a poor choice and option D is the best choice.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      557,
      556,
      699,
      320,
      42
    ],
    "source": ""
  },
  {
    "id": 862,
    "question": "If the cloud is used for BC/DR purposes, the loss of ___________________ could gravely affect your organization\u2019s RTO.",
    "choice_a": "Any cloud administrator",
    "choice_b": "A specific VM",
    "choice_c": "Your policy and contract documentation",
    "choice_d": "ISP connectivity",
    "correct_answer": "D",
    "explanation": "Without ISP connectivity, nobody will be able to use the Internet and, thus, the cloud. Of course, realistically, without Internet connectivity not much business will get done anyway, for most organizations, regardless of whether they were operating in the cloud or on-premise. <br>Option A is incorrect because the loss of any, single, cloud administrator is unlikely to gravely affect your organization\u2019s RTO. <br>The loss of a specific VM will probably not gravely affect your organization\u2019s RTO. VMs can be reinstantiated with ease. Option B is incorrect. <br>The loss of your policy and contract documentation cannot gravely affect your organization\u2019s RTO. Option C is untrue.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      320,
      556,
      536,
      535,
      684
    ],
    "source": ""
  },
  {
    "id": 863,
    "question": "What is the <italic>most</italic> important asset to protect in cloud BC/DR activities?",
    "choice_a": "Intellectual property",
    "choice_b": "Hardware at the cloud data center",
    "choice_c": "Personnel",
    "choice_d": "Data on portable media",
    "correct_answer": "C",
    "explanation": "Health and human safety is always paramount in all security activity. <br>All the other options are assets that should be protected, but nothing is as important as option C, so they are incorrect answers for this question.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      553,
      544,
      334,
      545,
      557
    ],
    "source": ""
  },
  {
    "id": 864,
    "question": "When considering cloud data replication strategies (i.e., whether you are making backups at the block, file, or database level), which element of your organization\u2019s BC/DR plan will be <italic>most</italic> affected by your choice?",
    "choice_a": "Recovery time objective",
    "choice_b": "Recovery point objective",
    "choice_c": "Maximum allowable downtime",
    "choice_d": "Mean time to failure",
    "correct_answer": "B",
    "explanation": "The recovery point objective (RPO) is a measure of data that can be lost in an outage without irreparably damaging the organization. Data replication strategies will most affect this metric, as the choice of strategy will determine how much recent data is available for recovery purposes. <br>Recovery time objective (RTO) is a measure of how long an organization can endure an outage without irreparable harm. This may be affected by the replication strategy, but not as much as the RPO. Option A is incorrect. <br>The maximum allowable downtime (MAD) is how long an organization can suffer an outage before ceasing to be an organization. This is not dependent on the RPO, and the data replication strategy won\u2019t have much effect on it at all. Option C is incorrect. <br>The mean time to failure (MTTF) is a measure of how long an asset is expected to last (usually hardware), as determined by the manufacturer/vendor. The data replication strategy will have no bearing on this whatsoever. Option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      42,
      50,
      545,
      557,
      556
    ],
    "source": ""
  },
  {
    "id": 865,
    "question": "In addition to BC/DR, what other benefit can your data archive/backup provide?",
    "choice_a": "Physical security enforcement",
    "choice_b": "Access control methodology",
    "choice_c": "Security control against data breach",
    "choice_d": "Availability for data lost accidentally",
    "correct_answer": "D",
    "explanation": "A data backup/archive can offer your organization an operational \u201creachback\u201d capability, where admins can assist users in recovering data lost by accident or carelessness. <br>The backup/archive does not aid in any of the areas in the other options. So, options A, B, and C are incorrect.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      42,
      46,
      47,
      44,
      59
    ],
    "source": ""
  },
  {
    "id": 866,
    "question": "Which of the following risks is probably <italic>most</italic> significant when choosing to use one cloud provider for your operational environment and another for BC/DR backup/archive?",
    "choice_a": "Physical intrusion",
    "choice_b": "Proprietary formats/lack of interoperability",
    "choice_c": "Vendor lock-in/lock-out",
    "choice_d": "Natural disasters",
    "correct_answer": "B",
    "explanation": "When using two different cloud providers, a cloud customer runs the risk that data/software formats used in the operational environment can\u2019t be readily adapted to the other provider\u2019s service, thus causing delays during an actual failover. <br>Risks of physical intrusion are neither obviated nor enhanced by choosing to use two cloud providers; option A is incorrect. <br>Using a different cloud provider for backup/archiving actually reduces the risks of outages due to vendor lock-in/lockout and natural disasters, so options C and D are not correct.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      42,
      545,
      556,
      699,
      46
    ],
    "source": ""
  },
  {
    "id": 867,
    "question": "Return to normal operations is a phase in BC/DR activity when the emergency is over and regular production can resume. Which of the following can sometimes be the result when the organization uses two different cloud providers for the production and BC/DR environments?",
    "choice_a": "Both providers are affected by the emergency, extending the time before return to normal can occur.",
    "choice_b": "The BC/DR provider becomes the new normal production environment.",
    "choice_c": "Regulators will find the organization in violation of compliance guidance.",
    "choice_d": "All data is lost irretrievably.",
    "correct_answer": "B",
    "explanation": "Theoretically, all the options are possibly true. However, option B is the most likely to occur and is fairly common in practice; the cost and risk of moving operations from one environment/provider to another is sizable, so staying with the secondary provider (making them the new primary) is a good way to reduce some of the risk involved in returning to normal.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      545,
      556,
      558,
      699,
      697
    ],
    "source": ""
  },
  {
    "id": 868,
    "question": "Which of these determines the critical assets, recovery time objective (RTO), and recover point objective (RPO) for BC/DR purposes?",
    "choice_a": "Business drivers",
    "choice_b": "User input",
    "choice_c": "Regulator mandate",
    "choice_d": "Industry standards",
    "correct_answer": "A",
    "explanation": "The business requirements will determine the crucial aspects of BC/DR. <br>All the other options may constitute some input that will influence the BC/DR, but they are not the prevailing factors, so are incorrect.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      544,
      336,
      334,
      546,
      319
    ],
    "source": ""
  },
  {
    "id": 869,
    "question": "What artifact\u2014which should already exist within the organization\u2014can be used to determine the critical assets necessary to protect in the BC/DR activity?",
    "choice_a": "Quantitative risk analysis",
    "choice_b": "Qualitative risk analysis",
    "choice_c": "Business impact analysis",
    "choice_d": "Risk appetite",
    "correct_answer": "C",
    "explanation": "The business impact analysis (BIA) is designed for this purpose: to determine the critical path of assets/resources/data within the organization. It is a perfect tool to use in shaping the BC/DR plan. <br>The risk analyses options and the risk appetite option may provide input for the BIA, but they are not what is used to determine the critical assets necessary to protect in the BC/DR activity. So, options A, B, and D are incorrect.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      544,
      238,
      545,
      699,
      697
    ],
    "source": ""
  },
  {
    "id": 870,
    "question": "Which of the following is probably the <italic>most</italic> important element to address if your organization is using two different cloud providers for the production and BC/DR environments?",
    "choice_a": "Do they cost the same?",
    "choice_b": "Do they have similar facility protections in place?",
    "choice_c": "What level of end-user support do they each offer?",
    "choice_d": "Can the backup provider meet the same SLA requirements as the primary?",
    "correct_answer": "D",
    "explanation": "If the contingency operation will last for any extended period of time, it is important to know whether all the same service expectations can be met by the backup provider as were available in the production environment. <br>All the other questions are important, but not as crucial as option D, so they are incorrect.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      545,
      556,
      557,
      536,
      540
    ],
    "source": ""
  },
  {
    "id": 871,
    "question": "In a managed cloud services arrangement, who invokes a BC/DR action?",
    "choice_a": "The cloud provider",
    "choice_b": "The cloud customer",
    "choice_c": "Depends on the contract",
    "choice_d": "Any user",
    "correct_answer": "C",
    "explanation": "BC/DR responsibilities must be negotiated and codified in the contract; initiation could be something performed by provider or customer, depending on circumstances, so the parties must agree before those circumstances are realized. <br>It is exceedingly unlikely that \u201cany user\u201d in a managed cloud services arrangement can invoke a BC/DR action. Option D is therefore a poor choice for the answer to the question.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      334,
      545,
      320,
      336,
      335
    ],
    "source": ""
  },
  {
    "id": 872,
    "question": "What do you need to do in order to fully ensure that a BC/DR action will function during a contingency?",
    "choice_a": "Audit all performance functions.",
    "choice_b": "Audit all security functions.",
    "choice_c": "Perform a full-scale test.",
    "choice_d": "Mandate this capability in the contract.",
    "correct_answer": "C",
    "explanation": "Without a full test, you can\u2019t be sure the BC/DR plan/process will work the way it is intended. <br>Audits are good, but they will not demonstrate actual performance the way a test will, so options A and B are incorrect. <br>It is important that the BC/DR capacity and performance be included in the contract, but that will not truly ensure that the functionality exists; a test is required, so option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      557,
      556,
      545,
      336,
      335
    ],
    "source": ""
  },
  {
    "id": 873,
    "question": "Which of the following is probably the <italic>most</italic> important activity, of those listed?",
    "choice_a": "Regularly update the BC/DR plan/process.",
    "choice_b": "Have contact information for all personnel in the organization.",
    "choice_c": "Have contact information for essential BC/DR personnel.",
    "choice_d": "Have contact information for local law enforcement.",
    "correct_answer": "A",
    "explanation": "All of these are important, but without regular updates, the information will soon become outdated and a lot less useful.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      545,
      556,
      697,
      699,
      459
    ],
    "source": ""
  },
  {
    "id": 874,
    "question": "The BC/DR plan/policy should include all of the following <italic>except</italic> ___________________.",
    "choice_a": "Tasking for the office responsible for maintaining/enforcing the plan",
    "choice_b": "Contact information for essential entities, including BC/DR personnel and emergency services agencies",
    "choice_c": "Copies of the laws/regulations/standards governing specific elements of the plan",
    "choice_d": "Checklists for BC/DR personnel to follow",
    "correct_answer": "C",
    "explanation": "This is not an easy question, because <italic>every</italic> plan/policy should include mention of the governance documents that drive the formation of the plan/policy; however, these can be included by reference only\u2014you don\u2019t need to include full copies of these governance documents. <br>All the other options should be included in the BC/DR plan/policy.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      546,
      459,
      536,
      519,
      556
    ],
    "source": ""
  },
  {
    "id": 875,
    "question": "The BC/DR plan/process should be written and documented in such a way that it can be used by ___________________.",
    "choice_a": "Users",
    "choice_b": "Essential BC/DR team members",
    "choice_c": "Regulators",
    "choice_d": "Someone with the requisite skills",
    "correct_answer": "D",
    "explanation": "This question is difficult. You want your BC/DR plan/process to include sufficient detail such that it could be followed by someone with the right background (perhaps IT for certain roles, security for others, etc.) but without any experience or specific training in that role. This is because a contingency of the scope that would require initiation of BC/DR activities might involve dramatic, significant external forces to the point where the personnel normally tasked with BC/DR actions are not available (for instance, natural disasters, fire, civil disruption, etc.), so the tasks may need to be completed by whoever is available at the time. <br>The BC/DR plan/process should be written and documented in such a way that someone with the requisite skills can use it. It is unlikely that typical users or regulators have the requisite skills to perform many of the BC/DR activities. Therefore options A and C are poor choices for answers to the question. <br>It is tempting to choose option B, however, option D is a better answer because it ensures that someone with the requisite skills will be able to read the BC/DR plan and perform the activities they document. Having to rely on essential BC/DR team members being present and available to follow the plan is risky. So option B is incorrect.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      320,
      335,
      336,
      546,
      556
    ],
    "source": ""
  },
  {
    "id": 876,
    "question": "Which of the following probably poses the <italic>most</italic> significant risk to the organization?",
    "choice_a": "Not having essential BC/DR personnel available during a contingency",
    "choice_b": "Not including all BC/DR elements in the cloud contract",
    "choice_c": "Returning to normal operations too soon",
    "choice_d": "Telecommunications outages",
    "correct_answer": "C",
    "explanation": "A premature return to normal operations can jeopardize not only production, but personnel; if the contingency that caused the BC/DR action is not fully complete/addressed, there may still be danger remaining. <br>The BC/DR plan/process should take into account both the absence of essential personnel and telecommunications capabilities, so options A and D are incorrect. <br>Option B does present a serious problem for the organization, but C is still a greater risk, so B is incorrect.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      545,
      556,
      557,
      697,
      239
    ],
    "source": ""
  },
  {
    "id": 877,
    "question": "Which of the following probably poses the <italic>most</italic> significant risk to the organization?",
    "choice_a": "Lack of data confidentiality during a contingency",
    "choice_b": "Lack of regulatory compliance during a contingency",
    "choice_c": "Returning to normal operations too late",
    "choice_d": "Lack of encrypted communications during a contingency",
    "correct_answer": "C",
    "explanation": "Not returning to normal operations in a timely fashion can cause you to exceed the RTO and the MAD. <br>During a contingency, some of the requirements your organization faces may relax somewhat; for instance, if a life-threatening natural disaster occurs, regulators will likely understand if some of the normal compliance activities/controls are not fully incorporated while personnel and assets are moved to safety (depending on the nature of the industry, of course). Options A and B are therefore incorrect; option C poses a greater risk. <br>Option D is a distractor; not all organizations need encrypted communications during contingencies.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      545,
      556,
      557,
      427,
      459
    ],
    "source": ""
  },
  {
    "id": 878,
    "question": "Why does the physical location of your data backup and/or BC/DR failover environment matter?",
    "choice_a": "It may affect regulatory compliance.",
    "choice_b": "Lack of physical security",
    "choice_c": "Environmental factors such as humidity",
    "choice_d": "It doesn\u2019t matter. Data can be saved anywhere without consequence.",
    "correct_answer": "A",
    "explanation": "Depending on your industry and the nature of your data, moving information into another jurisdiction may affect or invalidate your regulatory compliance. <br>Cloud providers, wherever they are located, should compensate for environmental and physical security factors, so this should have no impact on your potential risk; options B and C are incorrect. <br>Option D is incorrect because it is blanket statement that is not always true. In fact, for some organizations, the physical location where their data is stored can have serious regulatory consequences.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      45,
      42,
      699,
      545,
      241
    ],
    "source": ""
  },
  {
    "id": 879,
    "question": "According to the European Union Agency for Network and Information Security (ENISA), a cloud risk assessment should provide a means for customers to accomplish all these assurance tasks <italic>except</italic> ___________________.",
    "choice_a": "Assess risks associated with cloud migration",
    "choice_b": "Compare offerings from different cloud providers",
    "choice_c": "Reduce the risk of regulatory noncompliance",
    "choice_d": "Reduce the assurance burden on cloud providers",
    "correct_answer": "C",
    "explanation": "ENISA\u2019s approach to cloud risk assessments does not specifically address this type of assurance, probably because of the wide variety of possible regulators and the difficulty in crafting a risk assessment that would address them all. <br>All the other options are assurance efforts that ENISA\u2019s cloud risk assessment is meant to enhance, so they are incorrect answers for this question.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      238,
      240,
      699,
      697,
      525
    ],
    "source": ""
  },
  {
    "id": 880,
    "question": "The European Union Agency for Network and Information Security\u2019s (ENISA\u2019s) definition of cloud computing differs slightly from the definition offered by  ISC2 (and, for instance, NIST). What is one of the characteristics listed by ENISA but <italic>not</italic> included in the  ISC2 definition?",
    "choice_a": "Metered service",
    "choice_b": "Shared resources",
    "choice_c": "Scalability",
    "choice_d": "Programmatic management",
    "correct_answer": "D",
    "explanation": "ENISA includes \u201cprogrammatic management\u201d as a defining trait of cloud computing, even specifying \u201cthrough WS API.\u201d This is not included in the definition published by  ISC2 (or by NIST). <br>All the other characteristics are included in the  ISC2 (and NIST) definitions.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      42,
      47,
      48,
      53,
      55
    ],
    "source": ""
  },
  {
    "id": 881,
    "question": "Risk should always be considered from a business perspective. Risk is often balanced by corresponding ___________________.",
    "choice_a": "Profit",
    "choice_b": "Performance",
    "choice_c": "Cost",
    "choice_d": "Opportunity",
    "correct_answer": "D",
    "explanation": "The only reason organizations accept any level of risk is because of the potential benefit also afforded by a risky activity. <br>Profit is not the hallmark of every opportunity (or every organization\u2014many organizations are nonprofit or government based), so option A is incorrect. <br>Likewise, not all risky activities offer a chance to enhance performance, so option B is incorrect. <br>Cost is not a benefit, so that doesn\u2019t even make sense in the context of the question; option C is not correct.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      240,
      238,
      239,
      556,
      457
    ],
    "source": ""
  },
  {
    "id": 882,
    "question": "When considering the option to migrate from an on-premise environment to a hosted cloud service, an organization should weigh the risks of allowing external entities to access the cloud data for collaborative purposes against ___________________.",
    "choice_a": "Not securing the data in the traditional environment",
    "choice_b": "Disclosing the data publicly",
    "choice_c": "Inviting external personnel into the traditional workspace in order to enhance collaboration",
    "choice_d": "Sending the data outside the traditional environment for collaborative purposes",
    "correct_answer": "D",
    "explanation": "The cloud greatly enhances opportunities for collaboration between organizations, mostly by giving external parties some limited access to the owner\u2019s data in the cloud. While there is risk in this situation, the truly comparable risk in the traditional environment would result from sending data outside the organization to external collaborators. (Furthermore, the organization has to balance this risk against the cost of business of not being able to collaborate, if data is never shared with third parties.) <br>Option A is ridiculous; data should be secured whether it is in an on-premise environment or in the cloud. <br>Option B does not create a true equivalence; disclosing data under controlled conditions is not the same as public disclosure. <br>Option C is not equivalent to the costs/benefits of the other forms of collaboration; it would be too cumbersome for the organization to truly benefit from collaboration in a modern business environment.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      45,
      42,
      59,
      57,
      312
    ],
    "source": ""
  },
  {
    "id": 883,
    "question": "There are many ways to handle risk. However, the usual methods for addressing risk are not all possible in the cloud because ___________________.",
    "choice_a": "Cloud data risks cannot be mitigated",
    "choice_b": "Migrating into a cloud environment necessarily means you are accepting all risks",
    "choice_c": "Some risks cannot be transferred to a cloud provider",
    "choice_d": "Cloud providers cannot avoid risk",
    "correct_answer": "C",
    "explanation": "Under current legal frameworks, some risks (such as legal liability for privacy data breaches) cannot be transferred to a contracted party, so the data owners (that is, cloud customers) will still retain those risks. <br>Option A is ridiculous; risks can and should be mitigated, even in the cloud. <br>Option B is not correct; cloud migration will require some risk acceptance, but that is true for everything except avoided risk. <br>Option D is incorrect; cloud providers can choose not to offer services or not to accept certain clients.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      681,
      240,
      697,
      536,
      45
    ],
    "source": ""
  },
  {
    "id": 884,
    "question": "In which cloud service model does the customer lose the <italic>most</italic> control over governance?",
    "choice_a": "Infrastructure as a service (IaaS)",
    "choice_b": "Platform as a service (PaaS)",
    "choice_c": "Software as a service (SaaS)",
    "choice_d": "Private cloud",
    "correct_answer": "C",
    "explanation": "As the models increase in level of abstraction and service, the customer\u2019s control over the environment decreases.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      536,
      42,
      44,
      45,
      47
    ],
    "source": ""
  },
  {
    "id": 885,
    "question": "Which of the following poses a <italic>new</italic> risk in the cloud, not affecting the traditional, on-premise IT environment?",
    "choice_a": "Internal threats",
    "choice_b": "Multitenancy",
    "choice_c": "Natural disasters",
    "choice_d": "Distributed denial of service (DDoS) attacks",
    "correct_answer": "B",
    "explanation": "Sharing resources with other, unknown customers (some of whom may be competitors of or even hostile to the organization) is a risk not faced by organizations that maintain their own, on-premise data centers. <br>All the other answers are threats that exist in both environments and are therefore incorrect.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      532,
      52,
      49,
      50,
      312
    ],
    "source": ""
  },
  {
    "id": 886,
    "question": "In addition to the security offered by the cloud provider, a cloud customer must consider the security offered by ___________________.",
    "choice_a": "The respective regulator",
    "choice_b": "The end user(s)",
    "choice_c": "Any vendor the cloud customer previously used in the on-premise environment",
    "choice_d": "Any third parties the provider depends on",
    "correct_answer": "D",
    "explanation": "Because supply chain dependencies can affect service, the cloud customer will need assurance that any third-party reliance is secure. <br>Regulators and end users do not provide security to the enterprise, so options A and B are incorrect. <br>The vendors used for on-premise security will no longer affect the data, so option C is incorrect.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      403,
      404,
      536,
      535,
      459
    ],
    "source": ""
  },
  {
    "id": 887,
    "question": "Which of the following poses a <italic>new</italic> risk in the cloud, not affecting the traditional, on-premise IT environment?",
    "choice_a": "User carelessness",
    "choice_b": "Inadvertent breach",
    "choice_c": "Device failure",
    "choice_d": "Resource exhaustion",
    "correct_answer": "D",
    "explanation": "It is possible that a cloud provider will be unable to handle an increased load during contingency situations where <italic>all</italic> its customers are demanding additional resources far beyond their usual contracted rate. While this is unlikely (many cloud providers, especially the major operators in the market, have resources that greatly exceed any possible demand by their customers), it could conceivably occur if a significant number of customers experience an immediate and dramatic need for capacity, such as during a major BC/DR event (a region-wide natural disaster or a physical attack on a city). This is not something that would affect an on-premise solution; your organization\u2019s data center is not affected by others\u2019 demand for resources (although the on-premise environment may be affected by the same contingency that causes cloud resource exhaustion, of course). <br>All the other options portray risks faced by both cloud and on-premise environments.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      697,
      556,
      557,
      403,
      532
    ],
    "source": ""
  },
  {
    "id": 888,
    "question": "Where is isolation failure probably <italic>least</italic> likely to pose a significant risk?",
    "choice_a": "Public cloud",
    "choice_b": "Private cloud",
    "choice_c": "PaaS environment",
    "choice_d": "SaaS environment",
    "correct_answer": "B",
    "explanation": "Guest escape (a malicious user leaving the confines of a VM and able to access other VMs on the same machine) is less likely to occur and to have a significant impact in an environment provisioned for and used by a single customer. <br>In a public cloud, this is more likely and would be more significant, so option A is incorrect. <br>The service model doesn\u2019t specifically dictate the likelihood of occurrence or impact (both PaaS and IaaS could be in a private or public cloud, which is the more important factor), so both options C and D are incorrect.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      534,
      714,
      712,
      52,
      238
    ],
    "source": ""
  },
  {
    "id": 889,
    "question": "Which of the following poses a <italic>new</italic> risk in the cloud, not affecting the traditional, on-premise environment?",
    "choice_a": "Fire",
    "choice_b": "Legal seizure of another firm\u2019s assets",
    "choice_c": "Mandatory privacy data breach notifications",
    "choice_d": "Flooding",
    "correct_answer": "B",
    "explanation": "Because of multitenancy and shared resources in the cloud, law enforcement may seize a cloud customer\u2019s assets (a physical device, a data set, etc.) and inadvertently capture assets belonging to another, unsuspected/innocent organization. This could not happen in a situation where all individual organizations only kept their own assets on their own premises. <br>All the other options include risks that exist in the traditional, on-premise environment, as well as the cloud, so they are incorrect.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      52,
      532,
      241,
      544,
      536
    ],
    "source": ""
  },
  {
    "id": 890,
    "question": "Which of these does the cloud customer need to ensure protection of intellectual property created in the cloud?",
    "choice_a": "Digital rights management (DRM) solutions",
    "choice_b": "Identity and access management (IAM) solutions",
    "choice_c": "Strong contractual clauses",
    "choice_d": "Crypto-shredding",
    "correct_answer": "C",
    "explanation": "This is not an easy question; the simple answer seems to be option A, which is true for data stored/saved/migrated to the cloud (and property that already has been created in the cloud), but for new intellectual property created in the cloud, strong contract language in favor of the customer\u2019s rights is very necessary. Without clear-language support about the customer\u2019s ownership of all intellectual property created in the cloud data center, the cloud provider could, ostensibly, make a claim on such property, as the provider\u2019s resources were used in a collaborative effort to create that property. <br>Options B and D are security controls used to protect all sorts of assets, including intellectual property, but they are not as specifically addressing the creation of new intellectual property in the cloud the way explicit contract clauses would, so option C is still the better answer.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      42,
      43,
      44,
      45,
      241
    ],
    "source": ""
  },
  {
    "id": 891,
    "question": "What could be the result of failure of the cloud provider to secure the hypervisor in such a way that one user on a virtual machine can see the resource calls of another user\u2019s virtual machine?",
    "choice_a": "Unauthorized data disclosure",
    "choice_b": "Inference attacks",
    "choice_c": "Social engineering",
    "choice_d": "Physical intrusion",
    "correct_answer": "B",
    "explanation": "While it is possible that one guest VM seeing the resource calls of another VM could possibly allow one guest to see the other\u2019s data, it\u2019s much more likely that a user seeing another user\u2019s use of resources, rather than raw data, would allow the viewer to infer something about the victim\u2019s behavior/usage/assets. <br>Likewise, it may be possible for the viewer to leverage knowledge of this usage as part of a social engineering attack, but that would be subsequent to the inference itself; option B is still better than C. <br>Lack of resource isolation does not affect physical intrusions, which is just a distractor here.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      534,
      532,
      52,
      550,
      241
    ],
    "source": ""
  },
  {
    "id": 892,
    "question": "Key generation in a cloud environment might have less entropy than the traditional environment for all the following reasons <italic>except</italic> ___________________.",
    "choice_a": "Lack of direct input devices",
    "choice_b": "No social factors",
    "choice_c": "Uniform build",
    "choice_d": "Virtualization",
    "correct_answer": "B",
    "explanation": "Social factors should not/don\u2019t affect the level of entropy in a random number generator. <br>However, all the other factors listed in the other answers <italic>do</italic>, and that means that a malicious user in the cloud would be more likely (statistically) to guess/predict the random number used to create/seed an encryption key made in that same cloud environment. Cloud customers should take this into account when designing/planning their cloud configuration.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      53,
      43,
      48,
      52,
      54
    ],
    "source": ""
  },
  {
    "id": 893,
    "question": "Lack of industry-wide standards for cloud computing creates a potential for ___________________.",
    "choice_a": "Privacy data breach",
    "choice_b": "Privacy data disclosure",
    "choice_c": "Vendor lock-in",
    "choice_d": "Vendor lock-out",
    "correct_answer": "C",
    "explanation": "Without uniformity of data formats and service mechanisms, there is no assurance that a customer would be able to easily move their cloud operation from one provider to another; this can result in lock-in. <br>All the other options are not affected by lack of standards.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      535,
      542,
      312,
      545,
      556
    ],
    "source": ""
  },
  {
    "id": 894,
    "question": "What can hamper the ability of a cloud customer to protect their assets in a managed services arrangement?",
    "choice_a": "Prohibitions on port scanning and penetration testing",
    "choice_b": "Geographical dispersion",
    "choice_c": "Rules against training users",
    "choice_d": "Laws that prevent them from doing so",
    "correct_answer": "A",
    "explanation": "Many cloud providers prohibit activities that are common for administrative and security purposes but can also be construed/used for hacking; this includes port scanning and penetration testing. These restrictions can reduce the customer\u2019s ability to perform basic security functions. <br>While geographical dispersion of cloud assets might make securing those assets more difficult in the notional sense (customer administrators can\u2019t physically visit the devices that host their data), remoteness does not necessarily inhibit good security practices, which can be performed at a remove. This is not as detrimental as rules against port scanning/pen testing, so option B is incorrect. <br>There are no rules against user training or laws against securing your own assets, in the cloud or otherwise; options C and D are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      44,
      241,
      45,
      42,
      534
    ],
    "source": ""
  },
  {
    "id": 895,
    "question": "Cloud administration almost necessarily violates the principles of the ___________________ security model.",
    "choice_a": "Brewer-Nash (Chinese Wall)",
    "choice_b": "Graham-Denning",
    "choice_c": "Bell-LaPadula",
    "choice_d": "Biba",
    "correct_answer": "A",
    "explanation": "Brewer-Nash was specifically created for managed services arrangements, where an administrator for a given customer might also have access to a competitor\u2019s data/environment; the model requires that administrators not be assigned to competing customers. In the modern cloud provider model, a cloud data center administrator will almost definitely have access to many customers from the same industry (i.e., competitors) but probably won\u2019t even know it. <br>All the other options are access control security models; cloud administrators will not (or should not) be assigning access rights, so all these options are wrong.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      242,
      241,
      448,
      449,
      44
    ],
    "source": ""
  },
  {
    "id": 896,
    "question": "The physical layout of a cloud data center campus should include redundancies of all the following <italic>except</italic> ___________________.",
    "choice_a": "Physical perimeter security controls (fences, lights, walls, etc.)",
    "choice_b": "The administration/support staff building",
    "choice_c": "Electrical utility lines",
    "choice_d": "Communications connectivity lines",
    "correct_answer": "B",
    "explanation": "Administrative and support staff are usually not part of the critical path of a data center; they are nonfunctional-requirement elements, not functional requirements. <br>All the other options are mission-critical elements of the cloud data center and must have redundancy capabilities.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      311,
      289,
      290,
      553,
      555
    ],
    "source": ""
  },
  {
    "id": 897,
    "question": "Best practice for planning the physical resiliency for a cloud data center facility includes ___________________.",
    "choice_a": "Having one point of egress for personnel",
    "choice_b": "Ensuring that any cabling/connectivity enters the facility from different sides of the building/property",
    "choice_c": "Ensuring that all parking areas are near generators so that personnel in high-traffic areas are always illuminated by emergency lighting, even when utility power is not available",
    "choice_d": "Ensuring that the foundation of the facility is rated to withstand earthquake tremors",
    "correct_answer": "B",
    "explanation": "To avoid a situation where severing a given physical connection results in severing its backup as well (such as construction/landscaping, etc.), have redundant lines enter on different sides of the building. <br>For health and human safety, multiple egress points from each facility is preferred (and often required by law); option A is incorrect. <br>Emergency lighting should receive power regardless of their proximity to the power source, and parking vehicles near generators is a bad idea from a safety perspective; option C is incorrect. <br>Not all facilities need to withstand earthquakes; this may be true of data centers in California, but not in Sydney, so it is not an industry-wide best practice. Option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      554,
      553,
      555,
      289,
      290
    ],
    "source": ""
  },
  {
    "id": 898,
    "question": "The physical layout of a cloud data center campus should include redundancies of all the following <italic>except</italic> ___________________.",
    "choice_a": "Generators",
    "choice_b": "HVAC units",
    "choice_c": "Generator fuel storage",
    "choice_d": "Points of personnel ingress",
    "correct_answer": "D",
    "explanation": "People entering the facility can be vectored through a single security checkpoint as a means of enhancing access control; multiple lines of ingress are not necessary (although multiple lines of <italic>egress</italic> are essential to ensure health and human safety). <br>All the other options are facility elements that require redundancy.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      554,
      553,
      555,
      289,
      729
    ],
    "source": ""
  },
  {
    "id": 899,
    "question": "There are two reasons to conduct a test of the organization\u2019s recovery from backup in an\u00a0environment other than the primary production environment. Which of the following is one of them?",
    "choice_a": "It costs more to conduct a test at the same location as the primary workplace.",
    "choice_b": "You don\u2019t want to waste travel budget on what is only a test.",
    "choice_c": "The risk of negative impact to both production and backup is too high.",
    "choice_d": "There won\u2019t be enough room for everyone to sit in the primary facility.",
    "correct_answer": "C",
    "explanation": "A recovery from backup into the production environment carries the risk of failure of both data sets\u2014the production set and the backup set. This can cause cataclysmic harm to the organization. <br>Recovering in the primary facility would probably be cheaper than having a different test facility, so option A is incorrect. <br>A proper test is worth the financial expenditure, so option B is incorrect. <br>Option D is incorrect because any BCDR plan would account for sufficient personnel workspace.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      557,
      556,
      545,
      58,
      241
    ],
    "source": ""
  },
  {
    "id": 900,
    "question": "There are two reasons to conduct a test of the organization\u2019s recovery from backup in an\u00a0environment other than the primary production environment. Which of the following is one of them?",
    "choice_a": "It is good to invest in more than one community.",
    "choice_b": "You want to approximate contingency conditions, which includes not operating in the primary location.",
    "choice_c": "It is good for your personnel to see other places occasionally.",
    "choice_d": "Your regulators won\u2019t follow you off-site, so you\u2019ll be unobserved during your test.",
    "correct_answer": "B",
    "explanation": "Assuming your facility is not available during contingency operations allows you to better approximate an emergency situation, which adds realism to the test. <br>Though option A is an act of benevolence on the part of the organization towards the community, option B is still a better answer for the question. <br>Option C is an act of benevolence on the part of the organization towards the employee, option B is still a better answer for the question. <br>Option D is incorrect because it makes assumptions that cannot be counted upon. Regulatory oversight should not be avoided, and should always be assumed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      556,
      557,
      241,
      58,
      54
    ],
    "source": ""
  },
  {
    "id": 901,
    "question": "In an IaaS arrangement, who accepts responsibility for securing cloud-based applications?",
    "choice_a": "The cloud provider",
    "choice_b": "The cloud customer",
    "choice_c": "The regulator",
    "choice_d": "The end user/client",
    "correct_answer": "B",
    "explanation": "In an infrastructure as a service (IaaS) model, the provider is only responsible for provisioning the devices and computing/storage capacity; the customer is responsible for everything else, including the security of the applications. <br>All the other answers are incorrect because those individuals/organizations do not accept responsibility for securing cloud-based applications.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      44,
      42,
      50,
      536,
      241
    ],
    "source": ""
  },
  {
    "id": 902,
    "question": "Industry best practices dictate that cloud customers do not ___________________.",
    "choice_a": "Create their own identity and access management (IAM) solutions",
    "choice_b": "Create contract language that favors them over the provider",
    "choice_c": "Retrain personnel for cloud operations",
    "choice_d": "Encrypt data before it reaches the cloud",
    "correct_answer": "A",
    "explanation": "According to ENISA, custom IAM builds can become weak if not properly implemented. <br>Strong contract language in favor of the customer is always desirable for the customer, so option B is incorrect. <br>Training for specific conditions is always advisable, so option C is incorrect. <br>There is nothing wrong with having encryption take place before data is sent to the cloud, so option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      54,
      62,
      43,
      48,
      42
    ],
    "source": ""
  },
  {
    "id": 903,
    "question": "It is possible for the cloud customer to transfer ___________________ risk to the provider, but the cloud customer always retains ultimate legal risk.",
    "choice_a": "Market",
    "choice_b": "Perception",
    "choice_c": "Data",
    "choice_d": "Financial",
    "correct_answer": "D",
    "explanation": "With strong contract terms, the cloud customer may be able to recover monetary damages (and even penalties) from the cloud provider as a result of a loss suffered by the customer; however, legal liability remains with the cloud customer. <br>The other answers are not relevant in this context.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      681,
      536,
      405,
      545,
      241
    ],
    "source": ""
  },
  {
    "id": 904,
    "question": "A process for ___________________ can aid in protecting against data disclosure due to lost devices.",
    "choice_a": "User punishment",
    "choice_b": "Credential revocation",
    "choice_c": "Law enforcement notification",
    "choice_d": "Device tracking",
    "correct_answer": "B",
    "explanation": "Revoking credentials that might be lost when a device goes missing is a way to mitigate the possibility of those credentials being used by an unauthorized person. <br>Punishing a user and notifying law enforcement does not prevent data from being disclosed; options A and C are incorrect. <br>Tracking devices may assist recovery efforts, but it won\u2019t protect against data disclosures during the period the device is not under the organization\u2019s control; option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      54,
      48,
      44,
      45,
      59
    ],
    "source": ""
  },
  {
    "id": 905,
    "question": "All of the following can be used in the process of anomaly detection <italic>except</italic> ___________________.",
    "choice_a": "The ratio of failed to successful logins",
    "choice_b": "Transactions completed successfully",
    "choice_c": "Event time of day",
    "choice_d": "Multiple concurrent logins",
    "correct_answer": "B",
    "explanation": "Of all these options, only B is not something that will reveal untoward behavior.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      549,
      548,
      547,
      241,
      556
    ],
    "source": ""
  },
  {
    "id": 906,
    "question": "Critical components should be protected with ___________________.",
    "choice_a": "Strong passwords",
    "choice_b": "Chain-link fences",
    "choice_c": "Homomorphic encryption",
    "choice_d": "Multifactor authentication",
    "correct_answer": "D",
    "explanation": "Multifactor authentication offers additional protections for assets that are critical to the organization. <br>All logins should utilize strong passwords, whether they are critical or not, so option A is incorrect. <br>Some form of physical perimeter security is useful, but not necessarily chain-link fences, and not only for critical assets (perimeter security will protect all assets on the campus), so option B is incorrect. <br>Homomorphic encryption is a theoretical technology; option C is incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      692,
      691,
      241,
      544,
      43
    ],
    "source": ""
  },
  {
    "id": 907,
    "question": "It\u2019s important to maintain a current asset inventory list, including surveying your environment on a regular basis, in order to ___________________.",
    "choice_a": "Prevent unknown, unpatched assets from being used as back doors to the environment",
    "choice_b": "Ensure that any lost devices are automatically entered into the acquisition system for repurchasing and replacement",
    "choice_c": "Maintain user morale by having their devices properly catalogued and annotated",
    "choice_d": "Ensure that billing for all devices is handled by the appropriate departments",
    "correct_answer": "A",
    "explanation": "An asset that is not tracked will not be maintained properly, and an improperly maintained asset provides an avenue for attack. <br>Options B and D are management issues, not security issues; option A is preferable to both of them. <br>Option C is incorrect; users don\u2019t care if their devices are catalogued and anotated. Option C is a poor choice for an answer to the question.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      238,
      240,
      517,
      239,
      60
    ],
    "source": ""
  },
  {
    "id": 908,
    "question": "Which of the following can enhance data portability?",
    "choice_a": "Interoperable export formats",
    "choice_b": "Egress monitoring solutions",
    "choice_c": "Strong physical protections",
    "choice_d": "Agile business intelligence",
    "correct_answer": "A",
    "explanation": "Data formatted in a manner that allows its reuse in other environments is essential for portability. <br>None of the other options are relevant to the issue of data portability.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      50,
      53,
      57,
      45,
      42
    ],
    "source": ""
  },
  {
    "id": 909,
    "question": "Which of the following can enhance application portability?",
    "choice_a": "Using the same cloud provider for the production environment and archiving",
    "choice_b": "Conducting service trials in an alternate cloud provider environment",
    "choice_c": "Providing cloud-usage training for all users",
    "choice_d": "Tuning web application firewalls (WAFs) to detect anomalous activity in inbound communications",
    "correct_answer": "B",
    "explanation": "Testing is a great way to enhance assurance that applications will work in the new environment. <br>None of the other options are relevant to the issue of application portability.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      556,
      557,
      545,
      427,
      58
    ],
    "source": ""
  },
  {
    "id": 910,
    "question": "What should the cloud customer do to ensure that disaster recovery activities don\u2019t exceed the maximum allowable downtime (MAD)?",
    "choice_a": "Make sure any alternate provider can support the application needs of the organization.",
    "choice_b": "Ensure that contact information for all first responder agencies are correct and up-to-date at all times.",
    "choice_c": "Select an appropriate recovery time objective (RTO).",
    "choice_d": "Regularly review all regulatory directives for disaster response.",
    "correct_answer": "C",
    "explanation": "The RTO must always be less than the MAD. <br>It is good to know that services will operate in the alternate environment and that first response contact info is current, but neither determines the speed with which services and data will be available during contingency operations; options A and B are incorrect. <br>Regulators will usually not dictate MAD/RTO for a given organization; option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      319,
      544,
      334,
      556,
      427
    ],
    "source": ""
  },
  {
    "id": 911,
    "question": "Which of the following would probably best aid an organization in deciding whether to migrate from a traditional environment to a particular cloud provider?",
    "choice_a": "Rate sheets comparing a cloud provider to other cloud providers",
    "choice_b": "Cloud provider offers to provide engineering assistance during the migration",
    "choice_c": "The cost/benefit measure of closing the organization\u2019s relocation site (hot site/warm site) and using the cloud for disaster recovery instead",
    "choice_d": "SLA satisfaction surveys from other (current and past) cloud customers",
    "correct_answer": "D",
    "explanation": "Of the listed options, knowing how other customers feel about a provider may be the most valuable data point; it is the most realistic depiction of whether an organization realized projected/anticipated benefits after a migration. <br>Options A and B are just marketing materials and should not, by themselves, be all that convincing for making a migration decision. <br>Option C is a good factor to consider, but it is only a very small piece of what migration entails; D is still a much better option.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      312,
      557,
      556,
      545,
      427
    ],
    "source": ""
  },
  {
    "id": 912,
    "question": "A cloud provider will probably require all of the following <italic>except</italic> ___________________ before a customer conducts a penetration test.",
    "choice_a": "Notice",
    "choice_b": "Description of scope of the test",
    "choice_c": "Physical location of the launch point",
    "choice_d": "Knowledge of time frame/duration",
    "correct_answer": "C",
    "explanation": "Because cloud access is remote access, pen tests will be remote tests; it doesn\u2019t really matter what the physical origin of the simulated attack is. <br>All the other options are items the provider will want to know before the customer launches the test.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      556,
      241,
      459,
      405,
      62
    ],
    "source": ""
  },
  {
    "id": 913,
    "question": "Cloud providers will probably not allow ___________________ as part of a customer\u2019s penetration test.",
    "choice_a": "Network mapping",
    "choice_b": "Vulnerability scanning",
    "choice_c": "Reconnaissance",
    "choice_d": "Social engineering",
    "correct_answer": "D",
    "explanation": "Performing live deception and trickery against employees of the cloud provider (or its suppliers/vendors) could be construed as unethical and possibly illegal, especially without their knowledge and/or consent. Social engineering probably won\u2019t be involved in penetration tests run by customers. <br>All the other options are legitimate activities a customer might perform during a penetration test (with provider permission).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      405,
      241,
      44,
      45,
      540
    ],
    "source": ""
  },
  {
    "id": 914,
    "question": "A cloud customer performing a penetration test without the provider\u2019s permission is risking ___________________.",
    "choice_a": "Malware contamination",
    "choice_b": "Excessive fees for SLA violations",
    "choice_c": "Loss of market share",
    "choice_d": "Prosecution",
    "correct_answer": "D",
    "explanation": "In most jurisdictions, the activity involved in penetration testing would be considered criminal, and quite serious, and the provider would be justified in seeking law enforcement involvement and prosecution. <br>None of the other answers make sense with respect to the question.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      681,
      241,
      459,
      679,
      536
    ],
    "source": ""
  },
  {
    "id": 915,
    "question": "When a customer performs a penetration test in the cloud, why isn\u2019t the test an optimum simulation of attack conditions?",
    "choice_a": "Attackers don\u2019t use remote access for cloud activity",
    "choice_b": "Advanced notice removes the element of surprise",
    "choice_c": "When cloud customers use malware, it\u2019s not the same as when attackers use malware",
    "choice_d": "Regulator involvement changes the attack surface",
    "correct_answer": "B",
    "explanation": "Because all penetration tests launched by the customer require notifying the provider beforehand (and getting permission), the simulation loses quite a bit of realism. In the traditional environment, where the organization had full control over its own assets, penetration tests could involve double-blind status, which was much more realistic. <br>Everyone uses remote access for cloud activity, so option A is incorrect. <br>Cloud customers will not be able to deploy malware as part of a test because that is a crime, so option C is wrong. <br>Regulators are not involved in penetration tests, so option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      44,
      43,
      42,
      45,
      53
    ],
    "source": ""
  },
  {
    "id": 916,
    "question": "Managed cloud services exist because the service is less expensive for each customer than creating the same services for themselves in a traditional environment. What is the technology that creates most of the cost saving in the cloud environment?",
    "choice_a": "Emulation",
    "choice_b": "Secure remote access",
    "choice_c": "Crypto-shredding",
    "choice_d": "Virtualization",
    "correct_answer": "D",
    "explanation": "Virtualization allows for the scalability and cost reduction available in managed cloud services. <br>All the other options are incorrect because they do not cite the technology that creates most of the cost saving in the cloud environment. Only virtualization provides this cost savings.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      532,
      534,
      312,
      536,
      535
    ],
    "source": ""
  },
  {
    "id": 917,
    "question": "Managed cloud services exist because the service is less expensive for each customer than creating the same services for themselves in a traditional environment. From the customer perspective, most of the cost differential created between the traditional environment and the cloud through virtualization is achieved by removing ___________________.",
    "choice_a": "External risks",
    "choice_b": "Internal risks",
    "choice_c": "Regulatory compliance",
    "choice_d": "Sunk capital investment",
    "correct_answer": "D",
    "explanation": "In the traditional environment, the cloud customer must pay for a device for every user, which requires additional capacity that is almost never fully used; this represents a cost with no associated benefit. Moving into a virtualized environment allows the organization to only pay for resources that are utilized and not for underutilized or unused capacity. <br>The risks and regulatory requirements for an organization do not go away when the organization moves into the cloud, so there is no cost savings associated with these elements. Therefore, all of the other options are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      312,
      532,
      534,
      536,
      535
    ],
    "source": ""
  },
  {
    "id": 918,
    "question": "Managed cloud services exist because the service is less expensive for each customer than creating the same services for themselves in a traditional environment. Using a managed service allows the customer to realize significant cost savings through the reduction of ___________________.",
    "choice_a": "Risk",
    "choice_b": "Security controls",
    "choice_c": "Personnel",
    "choice_d": "Data",
    "correct_answer": "C",
    "explanation": "An organization operating in the cloud should not need as many IT personnel as would be required to operate a traditional enterprise with the same level of services for users; this can represent a significant cost savings. <br>Moving into the cloud reduces neither risk nor data; options A and D are incorrect. <br>Arguably, the cloud customer may realize some cost savings through cloud migration because the customer will not be solely responsible for acquiring, deploying, and managing security controls. However, security controls still exist\u2014they are, instead, the responsibility of the cloud provider, and the price of applying them is enclosed in the cost of the cloud service. Moreover, this savings is not nearly as significant as the savings realized through reduction in personnel, so option C is still preferable.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      312,
      536,
      535,
      534,
      241
    ],
    "source": ""
  },
  {
    "id": 919,
    "question": "Which of the following is a risk posed by the use of virtualization?",
    "choice_a": "Internal threats interrupting service through physical accidents (spilling drinks, tripping over cables, etc.)",
    "choice_b": "The ease of transporting stolen virtual machine images",
    "choice_c": "Increased susceptibility of virtual systems to malware",
    "choice_d": "Electromagnetic pulse",
    "correct_answer": "B",
    "explanation": "Because virtual machine images are stored as imaged files, an attacker able to access the stored files would have a much easier time transporting those files than transporting actual drives/machines. <br>Option A actually represents a risk in the physical environment that is reduced by the use of virtual machines and is incorrect. <br>VMs are not any more or less susceptible to malware or EMP, so options C and D are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      532,
      550,
      52,
      62,
      47
    ],
    "source": ""
  },
  {
    "id": 920,
    "question": "The tasks performed by the hypervisor in the virtual environment can be most likened to the tasks of the ___________________ in the traditional environment.",
    "choice_a": "Central processing unit (CPU)",
    "choice_b": "Security team",
    "choice_c": "Operating system (OS)",
    "choice_d": "Pretty Good Privacy (PGP)",
    "correct_answer": "C",
    "explanation": "Both the hypervisor and the OS orchestrate access to resources (the hypervisor coordinates requests from VMs, and the OS coordinates requests from applications). <br>Option A is incorrect because the CPU in a traditional environment performs calculations, while the operating system manages resources and performs process scheduling. <br>The security team in a traditional environment has a narrow and focused role, not like the operating system that manages the entire system and its resources. <br>Pretty Good Privacy is an application that performs a specific, limited role. Option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      532,
      534,
      551,
      241,
      459
    ],
    "source": ""
  },
  {
    "id": 921,
    "question": "Mass storage in the cloud will most likely currently involve ___________________.",
    "choice_a": "Spinning platters",
    "choice_b": "Tape drives",
    "choice_c": "Magnetic disks",
    "choice_d": "Solid-state drives (SSDs)",
    "correct_answer": "D",
    "explanation": "Solid-state drives (SSDs) are currently the most efficient and durable storage technology, so cloud providers will favor them. <br>All the other options are older technologies that employ magnetic media in one form or another, while SSD employs electronic circuitry to store data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      49,
      50,
      51,
      46,
      42
    ],
    "source": ""
  },
  {
    "id": 922,
    "question": "What is the type of cloud storage arrangement that involves the use of associating metadata with the saved data?",
    "choice_a": "Volume",
    "choice_b": "Block",
    "choice_c": "Object",
    "choice_d": "Redundant",
    "correct_answer": "C",
    "explanation": "In object storage, data objects/files are saved in the storage space along with relevant metadata such as content type and creation date. <br>Options A and B are different names for the same type of storage arrangement and incorrect. <br>Option D has no meaning in this context.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      51,
      49,
      50,
      48,
      57
    ],
    "source": ""
  },
  {
    "id": 923,
    "question": "According to the <italic>NIST Cloud Computing Reference Architecture</italic>, which of the following is most likely a cloud carrier?",
    "choice_a": "Amazon Web Services",
    "choice_b": "Netflix",
    "choice_c": "Verizon",
    "choice_d": "Nessus",
    "correct_answer": "C",
    "explanation": "NIST\u2019s definition of <italic>cloud carrier</italic> is \u201can intermediary that provides connectivity and transport of cloud services from Cloud Providers to Cloud Consumers.\u201d <br>Of the choices, option C best represents this definition.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      42,
      48,
      50,
      57,
      62
    ],
    "source": ""
  },
  {
    "id": 924,
    "question": "Resolving resource contentions in the cloud will most likely be the job of the ___________________.",
    "choice_a": "Router",
    "choice_b": "Emulator",
    "choice_c": "Regulator",
    "choice_d": "Hypervisor",
    "correct_answer": "D",
    "explanation": "The hypervisor orchestrates assignment of resources and is responsible for avoiding and resolving contention. <br>The router manages traffic flow, which might be considered as resolving contention issues for resource requests outside the local device (for example, from a given device to the storage cluster) but wouldn\u2019t handle resource requests inside a given device (such as a VM on the device making a request to the device CPU), so option D is a better answer. <br>An emulator virtualizes programs, not machines, and is not responsible for orchestrating resource calls, so option B is incorrect. <br>Regulators do not manage resources, so option C is incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      532,
      533,
      534,
      714,
      524
    ],
    "source": ""
  },
  {
    "id": 925,
    "question": "Security controls installed on a guest virtual machine operating system (VM OS) will <italic>not</italic> function when ___________________.",
    "choice_a": "The user is accessing the VM remotely",
    "choice_b": "The OS is not scanned for vulnerabilities",
    "choice_c": "The OS is not subject to version control",
    "choice_d": "The VM is not active while in storage",
    "correct_answer": "D",
    "explanation": "Security controls operating on a guest VM OS are only active while the VM is active; when the VM is stored, it is snapshotted and saved as a file, so those controls won\u2019t be active either. <br>All user access to the VMs will be done remotely; option A is simply incorrect. <br>Security controls on OSs that are not scanned or subject to version control may be out of date or not optimized, but they will still function (just not as well), so option D is still preferable to B and C.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      550,
      552,
      551,
      534,
      241
    ],
    "source": ""
  },
  {
    "id": 926,
    "question": "Typically, SSDs are ___________________.",
    "choice_a": "More expensive than spinning platters",
    "choice_b": "Larger than tape backup",
    "choice_c": "Heavier than tape libraries",
    "choice_d": "More subject to malware than traditional drives",
    "correct_answer": "A",
    "explanation": "Solid-state drives (SSDs) are usually more expensive, per drive, than their counterparts. However, as the industry matures, this is changing rapidly. Moreover, cloud providers are usually buying devices at such a scale and under such a budget that individual price differentials for device types is not the main criteria for making purchase decisions. <br>Size and shape are not defining criteria of SSDs or tapes; options B and C are irrelevant (and also somewhat wrong). <br>The physical nature of the drive does not affect its vulnerability to malware; option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      49,
      50,
      51,
      312,
      684
    ],
    "source": ""
  },
  {
    "id": 927,
    "question": "Typically, SSDs are ___________________.",
    "choice_a": "Harder to install than magnetic memory",
    "choice_b": "Faster than magnetic drives",
    "choice_c": "Harder to administer than tape libraries",
    "choice_d": "More likely to fail than spinning platters",
    "correct_answer": "B",
    "explanation": "SSD technology offers a great increase in speed and efficiency. <br>SSDs are not typically more difficult to install or administer than traditional technology, nor are they more likely to fail than other storage devices, so all the other options are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      50,
      49,
      684,
      683,
      682
    ],
    "source": ""
  },
  {
    "id": 928,
    "question": "Typically, SSDs are ___________________.",
    "choice_a": "Impossible to destroy physically",
    "choice_b": "Not vulnerable to degaussing",
    "choice_c": "Subject to a longer warranty",
    "choice_d": "Protected by international trade laws",
    "correct_answer": "B",
    "explanation": "Because SSDs do not use magnetic properties to store data, degaussing is not a suitable means of sanitizing SSDs. <br>All the other options are untrue and are therefore inappropriate answers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      57,
      56,
      53,
      47,
      48
    ],
    "source": ""
  },
  {
    "id": 929,
    "question": "Of the following control techniques/solutions, which can be combined to enhance the protections offered by each?",
    "choice_a": "Fences/firewalls",
    "choice_b": "Asset inventories/personnel training",
    "choice_c": "Data dispersion/encryption",
    "choice_d": "Intrusion prevention solutions/intrusion detection solutions",
    "correct_answer": "C",
    "explanation": "Theoretically, all combinations of security controls are preferable to any one security control used by itself (this is the principle of layered defense). All of the potential responses are therefore true. However, of this list, the pairing that makes the most sense is option C, because encrypting the data while also spreading it across multiple storage devices/locations increases the protection each one offers against certain common threats (in this case, physical theft of a storage device, failure of a device, legal seizure of a device in a multitenant environment, etc.).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      241,
      42,
      48,
      684,
      52
    ],
    "source": ""
  },
  {
    "id": 930,
    "question": "Of the following control techniques/solutions, which can be combined to enhance the protections offered by each?",
    "choice_a": "Razor tape/background checks",
    "choice_b": "Least privilege/generators",
    "choice_c": "DLP/DRM",
    "choice_d": "Personnel badging/secure baselines",
    "correct_answer": "C",
    "explanation": "Theoretically, all combinations of security controls are preferable to any one security control used by itself (this is the principle of layered defense). All of the potential responses are therefore true. However, of this list, the pairing that makes the most sense is option C, because adding another layer of access control on objects while also detecting outbound motion of objects increases the protection each one offers against certain common threats (in this case, internal threats, escalation of privilege, unauthorized or inadvertent dissemination of data, etc.).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      241,
      243,
      448,
      45,
      44
    ],
    "source": ""
  },
  {
    "id": 931,
    "question": "Risk assessment is the responsibility of ___________________.",
    "choice_a": "Companies offering managed cloud services",
    "choice_b": "Regulatory bodies",
    "choice_c": "Every organization",
    "choice_d": "Legislative entities",
    "correct_answer": "C",
    "explanation": "Every organization is responsible for performing its own risk assessment for its own particular business needs. <br>Cloud providers will not perform risk assessments on behalf of their customers. <br>Regulatory bodies and legislative entities do not perform risk assessments.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      240,
      238,
      699,
      697,
      334
    ],
    "source": ""
  },
  {
    "id": 932,
    "question": "Which entity can <italic>best</italic> aid the organization in avoiding vendor lock-in?",
    "choice_a": "Senior management",
    "choice_b": "The IT security office",
    "choice_c": "General counsel",
    "choice_d": "The cloud security representative",
    "correct_answer": "C",
    "explanation": "The best method for avoiding vendor lock-in is to have strong contract language favorable to the customer; the entity best equipped to craft contracts is the office of the general counsel. <br>Senior management can assist the organization to avoid vendor lock-in by tasking the correct resources (offices/personnel) to perform vendor selection activities, but option A is not as accurate as C. <br>Security personnel will have the technical skills and knowledge to properly determine the organization\u2019s IT needs and can inform general counsel as to what services/resources will best meet the organization\u2019s needs, but these entities are not as adept and trained at crafting contract language as the attorneys. Options B and D are not preferable to C.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      525,
      524,
      403,
      459,
      241
    ],
    "source": ""
  },
  {
    "id": 933,
    "question": "Perhaps the best method for avoiding vendor lock-out is also a means for enhancing BC/DR capabilities. This is ___________________.",
    "choice_a": "Having a warm site within 250 miles of the primary production environment",
    "choice_b": "Using one cloud provider for primary production and another for backup purposes",
    "choice_c": "Building a data center above the flood plain",
    "choice_d": "Cross-training all personnel",
    "correct_answer": "B",
    "explanation": "Using distinct cloud providers for production and backup ensures that the loss of one provider, for any reason, will not result in a total loss of the organization\u2019s data. <br>None of the other options  address vendor lock-out and are therefore unsuitable as answers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      334,
      404,
      556,
      536,
      525
    ],
    "source": ""
  },
  {
    "id": 934,
    "question": "___________________ can often be the result of inadvertent activity.",
    "choice_a": "DDoS",
    "choice_b": "Phishing",
    "choice_c": "Sprawl",
    "choice_d": "Disasters",
    "correct_answer": "C",
    "explanation": "Users in a cloud environment may not realize the attendant costs that come along with creating many new virtual instances, and the ease with which new instances are created allows users to do so without much effort. <br>While DDoS and phishing may include an element of user gullibility and ignorance, at least one party (the attacker) is not engaged in inadvertent activity\u2014their behavior is very purposeful. Options A and B are incorrect. <br>While inadvertent action can often result in incidents, disasters are usually at a much greater scale and aren\u2019t as likely to be the result of unknowing action; option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      535,
      537,
      44,
      312,
      556
    ],
    "source": ""
  },
  {
    "id": 935,
    "question": "Of the following, which is probably the <italic>most</italic> significant risk in a managed cloud environment?",
    "choice_a": "DDoS",
    "choice_b": "Management plane breach",
    "choice_c": "Guest escape",
    "choice_d": "Physical attack on the utility service lines",
    "correct_answer": "B",
    "explanation": "Management plane breach allows an attacker to gain full control of the environment and can affect all aspects of the CIA triad. <br>DDoS and physically attacking the utility lines, options A and D, only affect availability, which is a significant negative impact but not as bad as option B, which can affect integrity and confidentiality as well. <br>Guest escape is a breach limited to a specific device and the virtual machines on that device; this is not as much impact as breaching the management plane, which gives full access to the entire environment.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      534,
      532,
      241,
      53,
      48
    ],
    "source": ""
  },
  {
    "id": 936,
    "question": "What is the optimal number of entrances to the cloud data center campus?",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Three",
    "choice_d": "Four",
    "correct_answer": "A",
    "explanation": "Controlling access is optimized by minimizing access. <br>All the other options are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      241,
      536,
      448,
      449,
      44
    ],
    "source": ""
  },
  {
    "id": 937,
    "question": "The cloud data center campus physical access point should include all of the following <italic>except</italic> ___________________.",
    "choice_a": "Reception area",
    "choice_b": "Video surveillance",
    "choice_c": "Badging procedure",
    "choice_d": "Mantrap structures",
    "correct_answer": "D",
    "explanation": "Usually, mantrap areas control access to sensitive locations within a facility, not an entrance to the facility. <br>All the other options are optimal elements of a facility entrance point.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      241,
      554,
      448,
      555,
      242
    ],
    "source": ""
  },
  {
    "id": 938,
    "question": "Where should multiple egress points be included?",
    "choice_a": "At the power distribution substation",
    "choice_b": "Within the data center",
    "choice_c": "In every building on the campus",
    "choice_d": "In the security operations center",
    "correct_answer": "C",
    "explanation": "Health and human safety is a paramount goal of security; all facilities must have multiple emergency egress points. <br>All the other options are included in option C, so, option C is the better answer.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      555,
      553,
      554,
      729,
      241
    ],
    "source": ""
  },
  {
    "id": 939,
    "question": "Which of the following is a risk in the cloud environment that does not exist or is not as prevalent in the traditional environment?",
    "choice_a": "DDoS",
    "choice_b": "Isolation failure",
    "choice_c": "External attack",
    "choice_d": "Internal attack",
    "correct_answer": "B",
    "explanation": "In the traditional environment, when all resources are owned, controlled, and used by the organization\u2019s personnel, loss of isolation will only expose data to other members of the organization; isolation failure in the cloud environment may expose data to people outside the organization, a more significant impact. <br>All the other options are risks that have similar likelihoods and impacts in the cloud and traditional environments and are therefore incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      42,
      44,
      45,
      52,
      53
    ],
    "source": ""
  },
  {
    "id": 940,
    "question": "All security controls necessarily ___________________.",
    "choice_a": "Are expensive",
    "choice_b": "Degrade performance",
    "choice_c": "Require senior management approval",
    "choice_d": "Will work in the cloud environment as well as they worked in the traditional environment",
    "correct_answer": "B",
    "explanation": "Security and productivity/operations are always trade-offs. <br>Option A is a generalization that may or may not be true depending on several variables. Some security controls are inexpensive to implement. <br>Senior management approval may be required before security controls can be implemented, however, some may not need prior approval. It depends on the organization and how it is managed. Option C is incorrect. <br>Option D is another generalization that may or may not be true. Whether a security control will work in the cloud environment as well as they worked in the traditional environment depends on the control and how it is implemented. Option B is a better choice.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      241,
      243,
      240,
      448,
      450
    ],
    "source": ""
  },
  {
    "id": 941,
    "question": "Which of the following is a risk in the cloud environment that does not exist or is not as prevalent in the traditional environment?",
    "choice_a": "Legal liability in multiple jurisdictions",
    "choice_b": "Loss of productivity due to DDoS",
    "choice_c": "Ability of users to gain access to their physical workplace",
    "choice_d": "Fire",
    "correct_answer": "A",
    "explanation": "Because cloud providers may use data centers that span state (or even national) borders, new legal risks may be introduced to the customer\u2019s organization after cloud migration. <br>All the other options are risks faced by organizations in both the cloud and traditional environments and are therefore incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      681,
      45,
      42,
      43,
      47
    ],
    "source": ""
  },
  {
    "id": 942,
    "question": "Which of the following is a risk in the cloud environment that does not exist or is not as prevalent in the traditional environment?",
    "choice_a": "Loss of availability due to DDoS",
    "choice_b": "Loss of value due to DDoS",
    "choice_c": "Loss of confidentiality due to DDoS",
    "choice_d": "Loss of liability due to DDoS",
    "correct_answer": "A",
    "explanation": "In the traditional environment, if DDoS prevented the organization\u2019s connectivity with the Internet or other organizations, users still had access to their own data but simply could not share it or use it in external transactions; this hampered productivity, but not availability. In the cloud, without connectivity outside the organization, users cannot reach their data, which is an availability issue. <br>DDoS does not affect value, confidentiality, or liability; all the other options are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      42,
      44,
      45,
      532,
      536
    ],
    "source": ""
  },
  {
    "id": 943,
    "question": "DDoS attacks do not affect ___________________ for cloud customers.",
    "choice_a": "Productivity",
    "choice_b": "Availability",
    "choice_c": "Connectivity",
    "choice_d": "Integrity",
    "correct_answer": "D",
    "explanation": "DDoS prevents all these things except for data integrity. DDoS only prevents communication; it does not usually result in modified data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      53,
      54,
      59,
      334,
      699
    ],
    "source": ""
  },
  {
    "id": 944,
    "question": "Sprawl in the cloud can lead to significant additional costs to the organization because of ___________________.",
    "choice_a": "Larger necessary physical footprint",
    "choice_b": "Much larger utility consumption",
    "choice_c": "Software licensing",
    "choice_d": "Requisite additional training",
    "correct_answer": "C",
    "explanation": "In some instances, more virtualized machines will entail a relative increase in the number of software seat licenses, which can be a significant expense. <br>Typically, cloud customers do not pay extra for additional consumption of floor space or power usage for number of virtual machines; these costs are rolled into the per-instance price, so options A and B are incorrect. <br>Option D is incorrect; users don\u2019t require more training if they have more virtual assets.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      535,
      536,
      312,
      532,
      54
    ],
    "source": ""
  },
  {
    "id": 945,
    "question": "It is best to use variables in ___________________.",
    "choice_a": "Baseline configurations",
    "choice_b": "Security control implementations",
    "choice_c": "Contract language",
    "choice_d": "BC/DR tests",
    "correct_answer": "D",
    "explanation": "When performing BC/DR tests, it is useful to create scenarios that are unpredictable and vary from previous tests so as to better approximate conditions of an actual disaster. <br>All the other answers represent elements that should avoid variables as much as possible and are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      557,
      556,
      558,
      336,
      335
    ],
    "source": ""
  },
  {
    "id": 946,
    "question": "ISO 27034 mandates a framework for application security within an organization. According to the standard, each organization should have a(n) ___________________, and each application within the organization should have its own ___________________.",
    "choice_a": "Organizational Normative Framework (ONF), Application Normative Framework (ANF)",
    "choice_b": "Application Normative Framework (ANF), Organizational Normative Framework (ONF)",
    "choice_c": "Standard Application Security (SAS), Application Normative Framework (ANF)",
    "choice_d": "Organizational Normative Framework (ONF), Standard Application Security (SAS)",
    "correct_answer": "A",
    "explanation": "The ONF lists all the controls used in all the applications within an organization; each ANF lists the particular controls used in each application the organization has. Standard Application Security is a made-up term therefore options C and D are incorrect.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      417,
      295,
      300,
      282,
      294
    ],
    "source": ""
  },
  {
    "id": 947,
    "question": "According to ISO 27034, there is one Organizational Normative Framework (ONF) in the organization, and ___________________ Application Normative Framework (ANF[s]) for each application within that organization.",
    "choice_a": "Many",
    "choice_b": "Three",
    "choice_c": "No",
    "choice_d": "One",
    "correct_answer": "D",
    "explanation": "Each application will have its own ANF, derived from the organization\u2019s ONF. This can be a difficult question because there are many ANFs in the organization, but only one for each application. The reader needs to examine the question carefully.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      417,
      415,
      432,
      93,
      292
    ],
    "source": ""
  },
  {
    "id": 948,
    "question": "What language is used in the Simple Object Access Protocol (SOAP) application design protocol?",
    "choice_a": "Hypertext Markup Language (HTML)",
    "choice_b": "X.509",
    "choice_c": "Extensible Markup Language (XML)",
    "choice_d": "Hypertext Transfer Protocol (HTTP)",
    "correct_answer": "C",
    "explanation": "SOAP necessarily uses XML. <br>HTML is a language used to tag text files so that they can be displayed with different fonts, colors, graphics and hyperlinks. HTML is not used in SOAP. Option A is incorrect. <br>Option B is incorrect because X.509 is a standard and the question is about a programming language. <br>Option D is incorrect because HTTP is protocol and the question is about a programming language.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      559,
      560,
      561,
      705,
      574
    ],
    "source": ""
  },
  {
    "id": 949,
    "question": "Typically, representational state transfer\u00a0(REST) interactions do <italic>not</italic> require ___________________.",
    "choice_a": "Credentials",
    "choice_b": "Sessions",
    "choice_c": "Servers",
    "choice_d": "Clients",
    "correct_answer": "B",
    "explanation": "Generally, a REST interaction involves the client asking the server (through an application programming interface [API]) for data, sometimes as the result of processing; the server processes the request and returns the result. In REST, an enduring session, where the server has to store some temporary data about the client, is not necessary. <br>These interactions obviously involve servers and clients, so options C and D are not correct. <br>Using REST does not eliminate the need for credentials, so option A is not correct.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      562,
      566,
      707,
      576,
      286
    ],
    "source": ""
  },
  {
    "id": 950,
    "question": "Representational state transfer\u00a0(REST) application programming interfaces (APIs) use ___________________ protocol verbs.",
    "choice_a": "Hypertext Markup Language (HTML)",
    "choice_b": "Hypertext Transfer Protocol (HTTP)",
    "choice_c": "Extensible Markup Language (XML)",
    "choice_d": "American Standard Code for Information Interchange (ASCII)",
    "correct_answer": "B",
    "explanation": "Roy Fielding, the author of the PhD dissertation that created REST, was also the author of HTTP, so it\u2019s no surprise the command set is the same. <br>All the other options are incorrect because the REST APIs do not use HTML, XML or ASCII as protocol verbs.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      565,
      566,
      567,
      705,
      398
    ],
    "source": ""
  },
  {
    "id": 951,
    "question": "The architecture of the World Wide Web, as it works today, is ___________________.",
    "choice_a": "JavaScript Open Notation (JSON)",
    "choice_b": "Denial of service (DoS)",
    "choice_c": "Representational state transfer (REST)",
    "choice_d": "Extensible Markup Language (XML)",
    "correct_answer": "C",
    "explanation": "The web is mainly HTTP, which is a RESTful protocol. <br>All the other options are incorrect because they do not answer the question about the architecture of the World Wide Web.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      566,
      398,
      707,
      451,
      577
    ],
    "source": ""
  },
  {
    "id": 952,
    "question": "RESTful responses can come from the server in ___________________ or ___________________ formats.",
    "choice_a": "Extensible Markup Language (XML), JavaScript Open Notation (JSON)",
    "choice_b": "Hypertext Transfer Protocol (HTTP), X.509",
    "choice_c": "American Standard Code for Information Interchange (ASCII), text",
    "choice_d": "Hypertext Markup Language (HTML), Extensible Markup Language (XML)",
    "correct_answer": "A",
    "explanation": "Servers can return REST requests to clients in a number of formats, including XML and JSON. <br>X.509 certificates are used for passing session encryption information, not data requests, so option B is incorrect. <br>Servers usually return data requests in some sort of display format, not plain text or ASCII, so option C is incorrect. <br>HTML responses would simply be an entire web page, not specific data, so option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      568,
      569,
      707,
      706,
      570
    ],
    "source": ""
  },
  {
    "id": 953,
    "question": "Which of the following is an informal industry term for moving applications from a traditional environment into the cloud?",
    "choice_a": "Instantiation",
    "choice_b": "Porting",
    "choice_c": "Grandslamming",
    "choice_d": "Forklifting",
    "correct_answer": "D",
    "explanation": "All the other options are simply words used in other contexts. They are incorrect.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      92,
      68,
      71,
      70,
      65
    ],
    "source": ""
  },
  {
    "id": 954,
    "question": "Developers creating software for the cloud environment should bear in mind cloud-specific risks such as ___________________ and ___________________.",
    "choice_a": "DoS and DDoS (denial of service and distributed denial of service)",
    "choice_b": "Multitenancy and third-party administrators",
    "choice_c": "Unprotected servers and unprotected clients",
    "choice_d": "Default configurations and user error",
    "correct_answer": "B",
    "explanation": "All the other options are risks that exist in the traditional environment as well as the cloud.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      69,
      71,
      72,
      73,
      74
    ],
    "source": ""
  },
  {
    "id": 955,
    "question": "When an organization considers cloud migrations, the organization\u2019s software developers will need to know which ___________________ and which ___________________ the organization will be using, in order to properly and securely create suitable applications.",
    "choice_a": "Geographic location, native language",
    "choice_b": "Legal restrictions, specific ISP",
    "choice_c": "Service model, deployment model",
    "choice_d": "Available bandwidth, telecommunications country code",
    "correct_answer": "C",
    "explanation": "In order for developers to properly create and secure applications, they will need to understand the extent of resource sharing (public/private/hybrid/community) and level of control (infrastructure as a service [IaaS], platform as a service [PaaS], software as a service [SaaS]) the organization will expect in the cloud environment. <br>Each of the other options includes at least one element that programmers don\u2019t need to know (specifically, the native language, Internet service provider [ISP], country code) and is therefore incorrect.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      75,
      72,
      73,
      74,
      70
    ],
    "source": ""
  },
  {
    "id": 956,
    "question": "Which of the following is perhaps the best method for reducing the risk of a specific application <italic>not</italic> delivering the proper level of functionality and performance when it is moved from the traditional environment into the cloud?",
    "choice_a": "Remove the application from the organization\u2019s production environment and replace it with something else.",
    "choice_b": "Negotiate and conduct a trial run in the cloud environment for that application before permanently migrating.",
    "choice_c": "Make sure the application is fully updated and patched according to all vendor specifications.",
    "choice_d": "Run the application in an emulator.",
    "correct_answer": "B",
    "explanation": "A trial run in the cloud will reveal any functionality/performance loss before a permanent cloud migration. <br>Option A doesn\u2019t reduce any risk for a specific application; it trades the risk of one application not operating correctly with the risk of another application not working correctly. This answer is wrong. <br>All applications should be reasonably patched and updated, whether it is in the traditional environment or the cloud. Option C is incorrect. <br>An emulator won\u2019t reduce the risk of degraded performance; it will probably result in degraded performance. Option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      90,
      283,
      73,
      75,
      82
    ],
    "source": ""
  },
  {
    "id": 957,
    "question": "Software developers designing applications for the cloud should expect to include options to ensure all of the following capabilities <italic>except</italic> ___________________.",
    "choice_a": "Encryption of data at rest",
    "choice_b": "Encryption of data in transit",
    "choice_c": "Data masking",
    "choice_d": "Hashing database fields",
    "correct_answer": "D",
    "explanation": "Not all programs (or organizations) will require database access, or even use databases, and hashing is not a common requirement. <br>All the other functions are expected in the majority of cloud operations.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      73,
      72,
      75,
      64,
      82
    ],
    "source": ""
  },
  {
    "id": 958,
    "question": "In a platform as a service (PaaS) model, who should <italic>most</italic> likely be responsible for the security of the applications in the production environment?",
    "choice_a": "Cloud customer",
    "choice_b": "Cloud provider",
    "choice_c": "Regulator",
    "choice_d": "Programmers",
    "correct_answer": "A",
    "explanation": "In PaaS, the customer is responsible for the administration (and security) of applications. <br>Neither regulators nor programmers are responsible for the security of the applications in the production environment. That is the responsibility of the cloud customer. <br>It may appear as though the cloud provider should be responsible for application security, however, as the cloud customer acquires more responsibility for their cloud environment, the cloud provider assumes less responsibility. Option B is incorrect.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      75,
      64,
      63,
      73,
      69
    ],
    "source": ""
  },
  {
    "id": 959,
    "question": "In the testing phase of the software development life cycle (SDLC), software performance and ___________________ should both be reviewed.",
    "choice_a": "Quality",
    "choice_b": "Brevity",
    "choice_c": "Requirements",
    "choice_d": "Security",
    "correct_answer": "D",
    "explanation": "Performance and security both need to be reviewed for adequacy. <br>In this context, <italic>quality</italic> would be synonymous with <italic>performance</italic> and <italic>requirements</italic>, so D is a better answer than A or C. <br>Brevity is not a trait we look for in testing, even though it may be desirable in programming, so B is incorrect.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      678,
      441,
      426,
      573,
      293
    ],
    "source": ""
  },
  {
    "id": 960,
    "question": "Regardless of which model the organization uses for system development, in which phase of the software development lifecycle (SDLC) will user input be requested and considered?",
    "choice_a": "Define",
    "choice_b": "Design",
    "choice_c": "Develop",
    "choice_d": "Detect",
    "correct_answer": "A",
    "explanation": "In the Define phase, we\u2019re trying to determine the purpose of the software, in terms of meeting the users\u2019 needs; therefore, we may solicit input from the user community in order to figure out what they really want. <br>Options B and C are other phases of the SDLC, but not all SDLC models incorporate user input in these phases, so the options are not correct. <br>Option D is not a phase of the SDLC and is incorrect.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      295,
      280,
      300,
      439,
      64
    ],
    "source": ""
  },
  {
    "id": 961,
    "question": "Which phase of the software development life cycle (SDLC) is most likely to involve crypto-shredding?",
    "choice_a": "Define",
    "choice_b": "Design",
    "choice_c": "Test",
    "choice_d": "Disposal",
    "correct_answer": "D",
    "explanation": "Disposal is the only phase concerned with the sanitization of media or destruction of data. <br>All the other options are also SDLC phases, however, crypto-shredding is much more likely to be used in the disposal phase.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      82,
      64,
      63,
      90,
      88
    ],
    "source": ""
  },
  {
    "id": 962,
    "question": "Where are business requirements most likely to be mapped to software construction?",
    "choice_a": "Define",
    "choice_b": "Design",
    "choice_c": "Test",
    "choice_d": "Secure Operations",
    "correct_answer": "B",
    "explanation": "Design is the correct answer, as this is where the requirements gathered during the Define phase are mapped to system designs. <br>All the other options are SDLC phases where requirements are not mapped to software construction.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      572,
      571,
      441,
      573,
      295
    ],
    "source": ""
  },
  {
    "id": 963,
    "question": "All of the following are usually nonfunctional requirements <italic>except</italic> ___________________.",
    "choice_a": "Color",
    "choice_b": "Sound",
    "choice_c": "Security",
    "choice_d": "Function",
    "correct_answer": "D",
    "explanation": "Function is usually <italic>the</italic> functional requirement, describing what action the tool/process satisfies. <br>All the others are usually nonfunctional requirements. Exceptions to this are when the characteristic listed is the actual desired function. For instance, if the product is a tool that enunciates text so that a blind user can hear the words, then sound would be the functional requirement. If the product is a security tool such as a firewall or data loss prevention (DLP) solution, then security would be a functional requirement. Otherwise, these are nonfunctional requirements for standard products.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      571,
      416,
      72,
      73,
      74
    ],
    "source": ""
  },
  {
    "id": 964,
    "question": "Designers making applications for the cloud have to take into consideration risks and operational constraints that did not exist or were not as pronounced in the traditional environment. Which of the following is an element cloud app designers may have to consider incorporating in software for the cloud that may not have been as important in the traditional environment?",
    "choice_a": "Identity and access management (IAM) capability",
    "choice_b": "Distributed denial of service (DDoS) resistance",
    "choice_c": "Encryption for data at rest and in motion",
    "choice_d": "Field validation",
    "correct_answer": "C",
    "explanation": "Traditional apps won\u2019t usually require encryption in all phases of the data life cycle because data is protected in several stages in the traditional environment without the need for additional controls. In the cloud environment, however, data exposed at any point in the life cycle might constitute an inadvertent disclosure, so cloud apps require encryption for data at rest and in motion (and usually in use as well). <br>Even traditional apps require IAM and field validation functions, so options A and D are incorrect. <br>Most anti-DDoS activity will be performed by hardware and communication software run by the cloud provider or Internet service provider (ISP); developers should not typically need to include anti-DDoS elements in their programs. Option B is incorrect.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      79,
      81,
      71,
      72,
      75
    ],
    "source": ""
  },
  {
    "id": 965,
    "question": "Designers making applications for the cloud have to take into consideration risks and operational constraints that did not exist or were not as pronounced in the traditional environment. Which of the following is an element cloud app designers may have to consider incorporating in software for the cloud that might not have been as important in the traditional environment?",
    "choice_a": "Application isolation",
    "choice_b": "Inference framing",
    "choice_c": "Known secure library components",
    "choice_d": "Testing that uses known bad data",
    "correct_answer": "A",
    "explanation": "Because the cloud is a multitenant environment, one of the concerns that developers should consider is how well the application prevents other applications/users from observing its operation and resource calls. In the traditional environment, this is not usually required because the organization owns the underlying infrastructure (as a single tenant) and there is very little risk in exposing the application\u2019s functionality. <br><italic>Inference framing</italic> is a nonsense term, used here only as a distractor. <br>Software should include known secure components, and testing should include known bad data (fuzz testing), whether it is going to be used in the cloud or in a traditional environment, so options C and D are incorrect.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      69,
      71,
      73,
      75,
      64
    ],
    "source": ""
  },
  {
    "id": 966,
    "question": "Designers making applications for the cloud have to take into consideration risks and operational constraints that did not exist or were not as pronounced in the traditional environment. Which of the following is an element cloud app designers may not be able to use as readily in the cloud environment as it was deployed in the traditional environment?",
    "choice_a": "Cryptography",
    "choice_b": "STRIDE testing",
    "choice_c": "Field validation",
    "choice_d": "Logging",
    "correct_answer": "D",
    "explanation": "The cloud provider may have controls that restrict logging, or the delivery of log data, in the environment; this can make it complicated for cloud developers to include that functionality/security element in cloud apps. <br>All the other options are things that can (and should) be done with software whether the application is being used in traditional or cloud environments, so those options are incorrect.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      82,
      64,
      71,
      83,
      286
    ],
    "source": ""
  },
  {
    "id": 967,
    "question": "All of these can affect the quality of service expected from an application <italic>except</italic> ___________________.",
    "choice_a": "Encryption",
    "choice_b": "Egress monitoring",
    "choice_c": "Anti-malware tools",
    "choice_d": "Use of known secure libraries/components",
    "correct_answer": "D",
    "explanation": "Using only known secure libraries and components in software design may slow down development efforts but shouldn\u2019t impact how the application runs. <br>All the other options are security controls that will degrade performance because they require additional overhead; these options are incorrect.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      300,
      299,
      561,
      439,
      441
    ],
    "source": ""
  },
  {
    "id": 968,
    "question": "The possibility that a user could gain access or control of an application so as to take on administrator or management capabilities is called ___________________.",
    "choice_a": "Inversion",
    "choice_b": "Spoofing",
    "choice_c": "Repudiation",
    "choice_d": "Escalation of privilege",
    "correct_answer": "D",
    "explanation": "This is the definition of escalation of privilege (sometimes referred to as \u201celevation of privilege\u201d). <br><italic>Inversion</italic> is a nonsense term in this context and just a distractor. <br>Options B and C are threat modeling elements but are not correct answers for this question.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      83,
      69,
      288,
      286,
      294
    ],
    "source": ""
  },
  {
    "id": 969,
    "question": "Which of the following is <italic>not</italic> checked when using the STRIDE threat model?",
    "choice_a": "The ability of users to gain administrative access rights without proper permission",
    "choice_b": "The ability of internal personnel to trigger business continuity/disaster recovery activities",
    "choice_c": "The ability of a participant in a transaction to refute that they\u2019ve taken part in the transaction",
    "choice_d": "The ability of an unauthorized user to pretend to be an authorized user",
    "correct_answer": "B",
    "explanation": "The STRIDE threat model does not deal with business continuity and disaster recovery (BC/DR) actions. <br>All the other options are elements of STRIDE (escalation of privilege, repudiation, and spoofing, respectively) and are therefore not correct.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      293,
      292,
      296,
      294,
      282
    ],
    "source": ""
  },
  {
    "id": 970,
    "question": "It is very likely that your organization\u2019s users will use unapproved application programming interfaces (APIs), especially in a bring your own device (BYOD) environment, because ___________________.",
    "choice_a": "Users are constantly trying to break the security of your environment",
    "choice_b": "APIs can\u2019t ever be secure",
    "choice_c": "Hackers are constantly infiltrating all APIs",
    "choice_d": "Users enhance their productivity however they can",
    "correct_answer": "D",
    "explanation": "Users in the production environment will leverage whatever tools and techniques they can in order to get their job done in a better, faster way, often regardless of whether this complies with security policies. <br>All the other options are untrue and therefore cannot be the correct answer. For test-taking purposes, be very suspicious of words like, \u201cconstantly\u201d and \u201ccan\u2019t ever\u201d in answer choices.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      81,
      71,
      82,
      69,
      64
    ],
    "source": ""
  },
  {
    "id": 971,
    "question": "Some current software developers are not aware of security problems within the programs they\u2019re creating because ___________________.",
    "choice_a": "Young programmers are not nearly as disciplined in their coding practices as older programmers",
    "choice_b": "Some current programmers don\u2019t write code line by line and instead use code component libraries",
    "choice_c": "Coding languages have not been secure for 20 years",
    "choice_d": "Users are not clear in defining their requirements at the outset of the software development life cycle (SDLC)",
    "correct_answer": "B",
    "explanation": "Because many programs are currently constructed from \u201cbuilding block\u201d components found in code libraries, any security issues within specific components may not be understood or identified by coders who don\u2019t know the code inside the component. <br>Option A is an unfair generalization. <br>Option C is another broad generalization that may or may not be true.. Option B is a better answer.<br>Option D does not relate to the question about the SDLC and is therefore a poor choice for an answer.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      441,
      295,
      280,
      298,
      299
    ],
    "source": ""
  },
  {
    "id": 972,
    "question": "What is the <italic>most</italic> secure form of code testing and review?",
    "choice_a": "Open source",
    "choice_b": "Proprietary/internal",
    "choice_c": "Neither open source nor proprietary",
    "choice_d": "Combination of open source and proprietary",
    "correct_answer": "D",
    "explanation": "Obviously, using multiple forms of code review will produce more secure results than any one form of review, in the same way that having multiple forms of security controls (physical, logical, administrative, etc.) will provide better security than just one type. <br>The question is which is the \u201cmost\u201d secure form of code testing and review. That would be the most extensive. Since the correct answer is a combination of open source and proprietary, the least secure would be least extensive. Option A is strictly open source so that is incorrect. Option C is neither open source nor proprietary, which is even less extensive. Option C is incorrect. Proprietary/internal is also less extensive than Option D. So Option B is incorrect.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      268,
      269,
      298,
      299,
      300
    ],
    "source": ""
  },
  {
    "id": 973,
    "question": "What is the major difference between authentication and authorization?",
    "choice_a": "Code verification/code implementation",
    "choice_b": "Identity validation/access permission",
    "choice_c": "Inverse incantation/obverse instantiation",
    "choice_d": "User access/privileged access",
    "correct_answer": "B",
    "explanation": "This is the textbook definition of these terms. All the other options are incorrect answers.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      436,
      438,
      437,
      695,
      576
    ],
    "source": ""
  },
  {
    "id": 974,
    "question": "Access should be based on ___________________.",
    "choice_a": "Regulatory mandates",
    "choice_b": "Business needs and acceptable risk",
    "choice_c": "User requirements and management requests",
    "choice_d": "Optimum performance and security provision",
    "correct_answer": "B",
    "explanation": "Business needs and risk acceptable to senior management should drive all organizational decisions, including access. Specific user or object access will, of course, be delegated down from senior management to a manageable layer of the organization, but the principle applies. <br>This decision, however, should be informed by pertinent externalities, which include regulatory mandates (option A), user requirements and management requests (option C), and, to some degree, the trade-off of performance and security (option D, and both characteristics should also be dictated by senior management as an aspect of acceptable risk). While these externalities and options all play a part in determining appropriate access, they are all subordinate to business needs and acceptable risk, which are paramount; B is still the best answer to this question.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      573,
      572,
      64,
      288,
      294
    ],
    "source": ""
  },
  {
    "id": 975,
    "question": "Who should determine which users have access to which specific objects?",
    "choice_a": "The cloud provider",
    "choice_b": "Senior management",
    "choice_c": "Data owners",
    "choice_d": "System administrators",
    "correct_answer": "C",
    "explanation": "The data owner is responsible for the disposition of the data under their control; this includes access decisions. <br>The cloud provider is not typically the data owner; option A is incorrect. <br>Ostensibly, senior management is the data owner (the organization, as a whole, is the legal owner of the data, and the senior managers are the legal representatives of the organization). However, in practice, this responsibility can be (and usually is) delegated down to a manageable level, where the data owner for a given data set understands it best and can provide a sufficiently granular control of that data set. This is rarely senior management and is more likely department heads, branch managers, or some other form of middle management. Option C is preferable to B. <br>System administrators will usually be the literal granters of access, insofar as admins will modify access control systems that allow or disallow access for specific individuals or roles. However, the sysadmin does not make the decision of who is granted access and instead responds to direction from data owners (middle management); again, option C is preferable to D.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      63,
      64,
      82,
      83,
      288
    ],
    "source": ""
  },
  {
    "id": 976,
    "question": "All of the following are identity federation standards commonly found in use today <italic>except</italic> ___________________.",
    "choice_a": "WS-Federation",
    "choice_b": "OpenID",
    "choice_c": "OAuth (Open Authorization)",
    "choice_d": "Pretty Good Privacy (PGP)",
    "correct_answer": "D",
    "explanation": "PGP is an email encryption tool, not an identity federation standard. All the other options are federation standards.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      695,
      694,
      576,
      574,
      575
    ],
    "source": ""
  },
  {
    "id": 977,
    "question": "Which of the following is a federation standard/protocol that does <italic>not</italic> rely on Simple Object Access Protocol (SOAP),  Security Assertion Markup Language (SAML), or Extensible Markup Language (XML)?",
    "choice_a": "WS-Federation",
    "choice_b": "OpenID Connect",
    "choice_c": "Service Organization Control (SOC) 2",
    "choice_d": "Open Web Application Security Project (OWASP)",
    "correct_answer": "B",
    "explanation": "OpenID Connect is a federation protocol that uses representational state transfer (REST) and JavaScript Object Notation (JSON); it was specifically designed with mobile apps in mind, instead of only web-based federation. <br>WS-Federation is a federation protocol that is part of the WS-Security family of standards and reliant on Simple Object Access Protocol (SOAP), so option A is incorrect. <br>Option C is incorrect; SOC 2 is a type of Statement on Standards for Attestation Engagements (SSAE) 18 audit report, not a federation standard. <br>OWASP is a volunteer group of and for web app developers, not a federation standard or protocol, so option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      575,
      574,
      694,
      695,
      576
    ],
    "source": ""
  },
  {
    "id": 978,
    "question": "Authentication mechanisms typically include any or all of the following <italic>except</italic> ___________________.",
    "choice_a": "Something you know",
    "choice_b": "Someone you know",
    "choice_c": "Something you have",
    "choice_d": "Something you are",
    "correct_answer": "B",
    "explanation": "Because there is no transitive property of identification and authentication, knowing a trusted entity is not sufficient for validating an identity assertion. <br>All the other options are typical authentication mechanisms and so are incorrect.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      436,
      438,
      437,
      367,
      369
    ],
    "source": ""
  },
  {
    "id": 979,
    "question": "Which of the following constitutes a multifactor authentication process or procedure?",
    "choice_a": "Using an automated teller machine (ATM) to get cash with your credit or debit card",
    "choice_b": "Using a password and personal identification number (PIN) to log into a website",
    "choice_c": "Presenting a voice sample and fingerprint to access a secure facility",
    "choice_d": "Displaying a birth certificate and a credit card",
    "correct_answer": "A",
    "explanation": "At the ATM, the customer will use the card (something you have) and enter a PIN (something you know). This is true multifactor authentication. <br>A password and PIN are both something you know, so option B is incorrect. <br>Using a voice sample and fingerprint are two forms of something you are, so option C is incorrect. <br>A birth certificate and credit card are both something you have, so option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      436,
      585,
      288,
      368,
      416
    ],
    "source": ""
  },
  {
    "id": 980,
    "question": "Typically, multifactor authentication should be used ___________________.",
    "choice_a": "In every IT transaction",
    "choice_b": "For high-risk operations and data that is particularly sensitive",
    "choice_c": "When remote users are logging into the cloud environment",
    "choice_d": "Only in the traditional environment",
    "correct_answer": "B",
    "explanation": "Multifactor authentication should be considered for operations that have a significant risk or that deal with highly sensitive data (for instance, privileged user logins or when handling financial transactions). <br>Requiring multifactor authentication for every transaction is an undue burden on both the users and the systems and is a needless addition of extra overhead, so option A is incorrect. <br>All cloud access will entail remote login; this is a common operation, so adding multifactor authentication is an unnecessary burden in most cases. Option C is incorrect. <br>The decision to use multifactor authentication should be based on the risk of the operation and the sensitivity of the data, not on whether it takes place in the traditional or online environment, so option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      288,
      437,
      436,
      585,
      83
    ],
    "source": ""
  },
  {
    "id": 981,
    "question": "A web application firewall (WAF) usually operates at Layer ___________________ of the Open Systems Interconnection (OSI) model.",
    "choice_a": "2",
    "choice_b": "3",
    "choice_c": "7",
    "choice_d": "Q",
    "correct_answer": "C",
    "explanation": "A WAF is a Layer 7 tool. <br>All the other options are incorrect.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      579,
      577,
      430,
      701,
      453
    ],
    "source": ""
  },
  {
    "id": 982,
    "question": "A web application firewall (WAF) can understand and act on ___________________ traffic.",
    "choice_a": "Malicious",
    "choice_b": "Simple Mail Transfer Protocol (SMTP)",
    "choice_c": "Internet Control Message Protocol (ICMP)",
    "choice_d": "Hypertext Transfer Protocol (HTTP)",
    "correct_answer": "D",
    "explanation": "WAFs recognize HTTP traffic and can respond to traffic that matches prohibited rulesets or conditions. <br>Option A is technically correct; a WAF can be given a ruleset that recognizes certain forms of attack traffic. However, this answer is too general, and D is a much better response for this question. <br>Options B and C are protocols not usually inspected by WAFs and are therefore incorrect.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      579,
      577,
      701,
      74,
      704
    ],
    "source": ""
  },
  {
    "id": 983,
    "question": "WAFs can be used to reduce the likelihood that ___________________ attacks will be successful.",
    "choice_a": "Social engineering",
    "choice_b": "Physical theft",
    "choice_c": "Obverse inflection",
    "choice_d": "Cross-site scripting",
    "correct_answer": "D",
    "explanation": "WAFs can be used to attenuate the possibility that cross-site scripting attacks will be successful. <br>WAFs do not protect against social engineering or physical attacks in any way, so options A and B are incorrect. <br>Option C is a nonsense term and is therefore incorrect.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      74,
      570,
      577,
      81,
      72
    ],
    "source": ""
  },
  {
    "id": 984,
    "question": "A database activity monitor (DAM) tool usually operates at Layer ___________________ of the Open Systems Interconnection (OSI) model.",
    "choice_a": "1",
    "choice_b": "5",
    "choice_c": "7",
    "choice_d": "2",
    "correct_answer": "C",
    "explanation": "A DAM is a Layer 7 tool. <br>All the other options are incorrect.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      578,
      577,
      431,
      430,
      579
    ],
    "source": ""
  },
  {
    "id": 985,
    "question": "Database activity monitors (DAMs) can be used to reduce the potential success of ___________________ attacks.",
    "choice_a": "SQL injection",
    "choice_b": "Cross-site scripting",
    "choice_c": "Insecure direct-object reference",
    "choice_d": "Social engineering",
    "correct_answer": "A",
    "explanation": "DAMs can be used to reduce the possibility that SQL injection attacks will be successful. <br>DAMs do not protect against cross-site scripting, insecure direct-object reference, or social engineering attacks in any way, so options B, C, and D are incorrect.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      578,
      431,
      570,
      293,
      296
    ],
    "source": ""
  },
  {
    "id": 986,
    "question": "Which security tool can perform content inspection of Secure File Transfer Protocol (SFTP) communications?",
    "choice_a": "Web application firewall (WAF)",
    "choice_b": "Database activity monitor (DAM)",
    "choice_c": "Extensible Markup Language (XML) gateway",
    "choice_d": "Single sign-on\u00a0(SSO)",
    "correct_answer": "C",
    "explanation": "The XML gateway can provide this functionality; it acts as a reverse proxy and can perform content inspection on many traffic protocols. <br>The WAF and DAM are also security tools that inspect traffic but do not usually handle SFTP content, so options A and B are incorrect. <br>Option D, single sign-on, concerns authentication functions, not communications traffic, and is only a distractor in this context.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      577,
      701,
      702,
      560,
      431
    ],
    "source": ""
  },
  {
    "id": 987,
    "question": "To deploy a set of microservices to clients instead of building one monolithic application, it is best to use a(n) ___________________ to coordinate client requests.",
    "choice_a": "Extensible Markup Language (XML) gateway",
    "choice_b": "Application programming interface (API) gateway",
    "choice_c": "Web application firewall (WAF)",
    "choice_d": "Database activity monitor (DAM)",
    "correct_answer": "B",
    "explanation": "An API gateway translates requests from clients into multiple requests to many microservices and delivers the content as a whole via an API it assigns to that client/session. <br>XML gateways, WAFs, and DAMs are also tools used frequently in cloud-based enterprises, but they do not handle microservice requests in a meaningful way.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      702,
      701,
      700,
      452,
      579
    ],
    "source": ""
  },
  {
    "id": 988,
    "question": "Firewalls can detect attack traffic by using all these methods <italic>except</italic> ___________________.",
    "choice_a": "Known past behavior in the environment",
    "choice_b": "Identity of the malicious user",
    "choice_c": "Point of origination",
    "choice_d": "Signature matching",
    "correct_answer": "B",
    "explanation": "While it would be wonderful, for security purposes, to know the identity of attackers before or while they\u2019re making an attack, this is information the attacker doesn\u2019t usually share. <br>All the other options are methods firewalls can use to recognize attacks.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      577,
      293,
      296,
      80,
      81
    ],
    "source": ""
  },
  {
    "id": 989,
    "question": "Transport Layer Security (TLS) provides ___________________ and ___________________ for communications.",
    "choice_a": "Privacy, security",
    "choice_b": "Security, optimization",
    "choice_c": "Privacy, integrity",
    "choice_d": "Enhancement, privacy",
    "correct_answer": "C",
    "explanation": "TLS maintains the confidentiality and integrity of communications, often between a web browser and a server. <br>In this context, <italic>privacy</italic> and <italic>security</italic> mean much the same thing; <italic>privacy</italic> is synonymous with <italic>confidentiality</italic>, which is a subset of the overall topic of security. Therefore, option A is repetitive and not correct. <br>TLS does not optimize performance or add any sort of enhancement, so options B and D are incorrect.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      705,
      577,
      451,
      430,
      579
    ],
    "source": ""
  },
  {
    "id": 990,
    "question": "Transport Layer Security (TLS) uses a new ___________________ for each secure connection.",
    "choice_a": "Symmetric key",
    "choice_b": "Asymmetric key",
    "choice_c": "Public-private key pair",
    "choice_d": "Inverse comparison",
    "correct_answer": "A",
    "explanation": "TLS uses symmetric key crypto for each communications session in order to secure the connection; the session key is uniquely generated each time a new connection is made. <br>Options B and C are names for another type of encryption. Asymmetric encryption is also used in establishing a secure TLS connection; however, the keys used in this portion of the process will not change from session to session, and therefore these options are incorrect. <br>Option D is a nonsense term and is therefore incorrect.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      705,
      81,
      564,
      436,
      451
    ],
    "source": ""
  },
  {
    "id": 991,
    "question": "A virtual private network (VPN) is used to protect data in transit by ___________________.",
    "choice_a": "Securing each end of a client-server connection",
    "choice_b": "Creating an encrypted tunnel between two endpoints",
    "choice_c": "Encrypting databases",
    "choice_d": "Restricting key access to only eight parties",
    "correct_answer": "B",
    "explanation": "A VPN is a temporary, synthetic encrypted tunnel between two endpoints (often a client and a server). <br>Option A is subtly misleading; the VPN secures the connection <italic>between</italic> two endpoints, not the ends of the connection. This option is incorrect. <br>Option C is not correct; VPN is not used for encrypting databases\u2014it is used for encrypting communications. <br>Option D is incorrect; the symmetric key used in VPN is shared only between two parties (the endpoints), and the elements of the asymmetric key pair are either held by only one party (the owner of each private key) or by anyone at all (public key).",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      577,
      451,
      430,
      293,
      296
    ],
    "source": ""
  },
  {
    "id": 992,
    "question": "The employment of users in dynamic software testing should best be augmented by ___________________.",
    "choice_a": "Having the developers review the code",
    "choice_b": "Having the developers perform dynamic testing",
    "choice_c": "Using automated agents to perform dynamic testing",
    "choice_d": "Social engineering",
    "correct_answer": "C",
    "explanation": "Users may not offer enough coverage for larger software products that have a great deal of functionality; it can be useful to also use automated agents to checks paths that users might not often attempt or utilize. <br>The developers should not be involved in any form of testing the software as they have an inherent conflict of interest, so options A and B are incorrect. <br>Dynamic testing does not involve social engineering; option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      678,
      676,
      677,
      300,
      285
    ],
    "source": ""
  },
  {
    "id": 993,
    "question": "Why do developers have an inherent conflict of interest in testing software they\u2019ve created?",
    "choice_a": "They are notoriously bad, as a group, at testing.",
    "choice_b": "They work for the same department as the testing personnel.",
    "choice_c": "They have a vested interest in having the software perform well.",
    "choice_d": "They are never trained on testing procedures.",
    "correct_answer": "C",
    "explanation": "This is the definition of \u201cconflict of interest.\u201d <br>All the other answers are incorrect.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      677,
      676,
      678,
      69,
      83
    ],
    "source": ""
  },
  {
    "id": 994,
    "question": "Sandboxing can often be used for ___________________.",
    "choice_a": "Optimizing the production environment by moving processes that are not frequently used into the sandbox",
    "choice_b": "Allowing secure remote access for users who need resources in the cloud environment",
    "choice_c": "Running malware for analysis purposes",
    "choice_d": "Creating secure subnets of the production environment",
    "correct_answer": "C",
    "explanation": "A sandbox can be used to run malware for analysis purposes as it won\u2019t affect (or infect) the production environment; it\u2019s worth noting, though, that some malware is sandbox-aware, so additional antimalware measures are advisable. <br>Options A, B, and D are not correct because the sandbox should be completely disconnected (air-gapped) from the production environment so that users can\u2019t perform productive activity there.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      283,
      285,
      284,
      80,
      77
    ],
    "source": ""
  },
  {
    "id": 995,
    "question": "Sandboxing can often be used for ___________________.",
    "choice_a": "Testing user awareness and training",
    "choice_b": "Testing security response capabilities",
    "choice_c": "Testing software before putting it into production",
    "choice_d": "Testing regulatory response to new configurations and modifications",
    "correct_answer": "C",
    "explanation": "Software that has either been purchased from a vendor or developed internally can be tested in a sandboxed environment that mimics the production environment in order to determine whether there will be any interoperability problems when it is installed into actual production. <br>All the other options aren\u2019t uses for sandboxes and are incorrect.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      283,
      284,
      73,
      90,
      300
    ],
    "source": ""
  },
  {
    "id": 996,
    "question": "Application virtualization can typically be used for ___________________.",
    "choice_a": "Running an application in a non-native environment",
    "choice_b": "Installing updates to a system\u2019s operating system (OS)",
    "choice_c": "Preventing escalation of privilege by untrusted users",
    "choice_d": "Enhancing performance of systems",
    "correct_answer": "A",
    "explanation": "Virtualized applications can run on platforms that wouldn\u2019t otherwise allow them to function, such as running Microsoft apps on a Linux box. <br>Because the virtualization engine encapsulates the application from the native runtime environment, patches can\u2019t be applied through virtualized programs; option B is incorrect. <br>Virtualization really doesn\u2019t have anything to do with access control; option C is incorrect. <br>The overhead of running a software virtualization engine will actually add to system overhead, not decrease it, so option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      77,
      76,
      85,
      73,
      74
    ],
    "source": ""
  },
  {
    "id": 997,
    "question": "Application virtualization can typically be used for ___________________.",
    "choice_a": "Denying access to untrusted users",
    "choice_b": "Detecting and mitigating distributed denial-of-service (DDoS) attacks",
    "choice_c": "Replacing encryption as a necessary control",
    "choice_d": "Running an application on an endpoint without installing it",
    "correct_answer": "D",
    "explanation": "Application virtualization allows the software to run on a simulated environment on the device without the need to install it on the device. <br>Virtualization really doesn\u2019t have anything to do with access control; option A is incorrect. <br>Virtualization neither detects nor responds to DDoS; option B is incorrect. <br>Virtualization does not replace encryption; if data needs to be secure within the virtualization environment, encryption may still have to be utilized. Option C is incorrect.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      283,
      85,
      73,
      74,
      77
    ],
    "source": ""
  },
  {
    "id": 998,
    "question": "Any organization that complies with ISO 27034 will have a maximum of ___________________ Organizational Normative Framework(s) (ONF)(s).",
    "choice_a": "0",
    "choice_b": "1",
    "choice_c": "5",
    "choice_d": "25",
    "correct_answer": "B",
    "explanation": "ISO 27034 dictates that an organization will have a collection of security controls used for all software within that organization; this collection is called the ONF. <br>All the other options are distractors and incorrect.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      417,
      74,
      73,
      72,
      65
    ],
    "source": ""
  },
  {
    "id": 999,
    "question": "Under ISO 27034, every application within a given organization will have an attendant set of controls assigned to it; the controls for a given application are listed in the ___________________.",
    "choice_a": "ONF",
    "choice_b": "ANF",
    "choice_c": "TTF",
    "choice_d": "FTP",
    "correct_answer": "B",
    "explanation": "Each application in an organization compliant with ISO 27034 will be assigned an Application Normative Framework (ANF), which lists all the controls assigned to that application. <br>Technically, the controls for each application within an organization compliant with ISO 27034 will be listed in the Organizational Normative Framework (ONF), because the ONF is the list of all controls for all applications; however, for a given application, only the controls used for that application are listed in an ANF, so option B is a preferable answer to A. <br>TTF (time to failure) has no meaning in this context, so option C is incorrect. <br>FTP (File Transfer Protocol) is a protocol for transferring files and not applicable here; option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      417,
      295,
      282,
      294,
      561
    ],
    "source": ""
  },
  {
    "id": 1000,
    "question": "Static application security testing (SAST) is usually considered a ___________________ form of testing.",
    "choice_a": "White-box",
    "choice_b": "Black-box",
    "choice_c": "Gray-box",
    "choice_d": "Parched field",
    "correct_answer": "A",
    "explanation": "SAST is often referred to as white-box testing. <br>Black-box testing does not include access to source code, which is required for SAST. Option B is therefore incorrect. <br>Option C is a combination of black-box and white-box testing so option C is an incorrect answer for this question. <br>Option D has no meaning in this context.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      298,
      300,
      299,
      676,
      677
    ],
    "source": ""
  },
  {
    "id": 1001,
    "question": "Static application security testing (SAST) examines ___________________.",
    "choice_a": "Software outcomes",
    "choice_b": "User performance",
    "choice_c": "System durability",
    "choice_d": "Source code",
    "correct_answer": "D",
    "explanation": "In SAST, testers review the source code of an application in order to determine security flaws and operational errors. <br>While determining \u201csoftware outcomes\u201d may be considered a possible goal of SAST, \u201csource code\u201d is a much better answer, as it is more specific and applicable to the question. Option D is still preferable. <br>SAST does not check user performance or system durability; options B and C are incorrect.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      298,
      300,
      570,
      678,
      284
    ],
    "source": ""
  },
  {
    "id": 1002,
    "question": "Dynamic application security testing (DAST) is usually considered a ___________________ form of testing.",
    "choice_a": "White-box",
    "choice_b": "Black-box",
    "choice_c": "Gray-box",
    "choice_d": "Parched field",
    "correct_answer": "B",
    "explanation": "DAST is often referred to as black-box testing. <br>White-box testing requires the tester to have access to source code, which is not provided in DAST. Option A is therefore incorrect. <br>Option C is a combination of black-box and white-box testing so option C is an incorrect answer for this question. <br>Option D has no meaning in this context.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      300,
      298,
      283,
      284,
      285
    ],
    "source": ""
  },
  {
    "id": 1003,
    "question": "Dynamic application security testing (DAST) checks software functionality in ___________________.",
    "choice_a": "The production environment",
    "choice_b": "A runtime state",
    "choice_c": "The cloud",
    "choice_d": "An IaaS configuration",
    "correct_answer": "B",
    "explanation": "DAST is performed while the application is running. <br>Software testing should <italic>not</italic> take place in the production environment; option A is incorrect. <br>DAST, like other forms of testing, may or may not take place in the cloud and is not confined to any particular service model (although it is unlikely to occur in software as a service [SaaS] environments); options C and D are incorrect.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      300,
      283,
      284,
      570,
      678
    ],
    "source": ""
  },
  {
    "id": 1004,
    "question": "Vulnerability scans are dependent on ___________________ in order to function.",
    "choice_a": "Privileged access",
    "choice_b": "Vulnerability signatures",
    "choice_c": "Malware libraries",
    "choice_d": "Forensic analysis",
    "correct_answer": "B",
    "explanation": "Vulnerability scans use signatures of known vulnerabilities to detect and report those vulnerabilities. <br>Vulnerability scans do not typically require administrative access to function; option A is incorrect. <br>Both malware libraries and forensic analysis of existing vulnerabilities may be used to create the signatures that vulnerability scanning tools utilize to detect and report vulnerabilities; however, these answers are too specific (limiting the answer), making option B a better answer than either C or D.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      298,
      299,
      300,
      295,
      280
    ],
    "source": ""
  },
  {
    "id": 1005,
    "question": "Due to their reliance on vulnerability signatures, vulnerability scanners will not detect ___________________.",
    "choice_a": "User error",
    "choice_b": "Improper control selection",
    "choice_c": "Cloud vulnerabilities",
    "choice_d": "Unknown vulnerabilities",
    "correct_answer": "D",
    "explanation": "Because vulnerability scanning tools require vulnerability signatures to operate effectively, unknown vulnerabilities that might exist in the scanned system won\u2019t be detected (no signature has been created by vendors until a vulnerability is known). <br>User errors are not detected by vulnerability scans; option A is incorrect. <br>Scans can\u2019t tell you whether you\u2019ve picked the optimum security controls for your environment; option B is incorrect. <br>Vulnerability scanning tools may or may not detect cloud-based vulnerabilities, depending on the tool used, the level of access to the target environment, and the settings applied to the scanner; option C is less accurate than option D.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      298,
      300,
      677,
      280,
      294
    ],
    "source": ""
  },
  {
    "id": 1006,
    "question": "Penetration testing is a(n) ___________________ form of security assessment.",
    "choice_a": "Active",
    "choice_b": "Comprehensive",
    "choice_c": "Total",
    "choice_d": "Inexpensive",
    "correct_answer": "A",
    "explanation": "A penetration test requires the tester to analyze the security of an environment from the perspective of an attacker; this also includes actually taking action that would result in breaching that environment. <br>Penetration tests may or may not be comprehensive, depending on the intended scope and area of analysis. Option B is incorrect. <br>While it\u2019s nice to think of any security assessment as <italic>total</italic>, that is an extreme term, like <italic>all</italic> or <italic>never</italic>; such terms can rarely be used in security because there are no absolutes when dealing with risk, and it has no meaning in this context. Option C is not correct. <br>Although the cost of a penetration test will vary according to a vast range of variables, it will rarely be considered inexpensive, especially relative to other forms of security testing. Option D is not correct.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      676,
      677,
      300,
      294,
      284
    ],
    "source": ""
  },
  {
    "id": 1007,
    "question": "Dynamic software security testing should include ___________________.",
    "choice_a": "Source code review",
    "choice_b": "User training",
    "choice_c": "Penetration testing",
    "choice_d": "Known bad data",
    "correct_answer": "D",
    "explanation": "Also called fuzz testing, dynamic testing methods should include known bad inputs in order to determine how the program will handle the \u201cwrong\u201d data (will it fail into a state that is less secure than normal operations, etc.). <br>Source code review is not part of dynamic testing; option A is incorrect. <br>For accurate quality testing, user familiarity with the target software should be minimal and should not be assessed; option B is not correct. <br>Penetration includes active steps to overcome security measures; this is rarely the purpose of software testing; option C is not the best answer.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      300,
      298,
      285,
      678,
      441
    ],
    "source": ""
  },
  {
    "id": 1008,
    "question": "According to Open Web Application Security Project (OWASP) recommendations, active software security testing should include all of the following <italic>except</italic> ___________________.",
    "choice_a": "Information gathering",
    "choice_b": "User surveys",
    "choice_c": "Configuration and deployment management testing",
    "choice_d": "Identity management testing",
    "correct_answer": "B",
    "explanation": "User surveys are not an element of active security testing, although they might be used in acceptance testing. All of the other options are included in the OWASP guide to active security testing.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      300,
      676,
      441,
      570,
      283
    ],
    "source": ""
  },
  {
    "id": 1009,
    "question": "According to Open Web Application Security Project (OWASP) recommendations, active software security testing should include all of the following <italic>except</italic> ___________________.",
    "choice_a": "Authentication testing",
    "choice_b": "Authorization testing",
    "choice_c": "Session management testing",
    "choice_d": "Privacy review testing",
    "correct_answer": "D",
    "explanation": "Privacy review testing is not included in the OWASP guide to active security testing, although it might be included as an aspect of compliance testing (for organizations in highly regulated industries). All of the other options are included in the OWASP guide to active security testing.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      300,
      298,
      676,
      677,
      283
    ],
    "source": ""
  },
  {
    "id": 1010,
    "question": "According to Open Web Application Security Project (OWASP) recommendations, active software security testing should include all of the following <italic>except</italic> ___________________.",
    "choice_a": "Session initiation testing",
    "choice_b": "Input validation testing",
    "choice_c": "Testing for error handling",
    "choice_d": "Testing for weak cryptography",
    "correct_answer": "A",
    "explanation": "While session management testing is included in the OWASP guide to active software security testing, session initiation is not. All of the other options are included in the OWASP guide to active security testing.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      300,
      298,
      676,
      677,
      678
    ],
    "source": ""
  },
  {
    "id": 1011,
    "question": "According to Open Web Application Security Project (OWASP) recommendations, active software security testing should include all of the following <italic>except</italic> ___________________.",
    "choice_a": "Business logic testing",
    "choice_b": "Client-side testing",
    "choice_c": "Intuition testing",
    "choice_d": "Information gathering",
    "correct_answer": "C",
    "explanation": "Intuition testing is not part of the OWASP guide to active security testing. All of the other options are included in the OWASP guide to active security testing.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      300,
      298,
      676,
      677,
      678
    ],
    "source": ""
  },
  {
    "id": 1012,
    "question": "Static software security testing typically uses ___________________ as a measure of how thorough the testing was.",
    "choice_a": "Number of testers",
    "choice_b": "Flaws detected",
    "choice_c": "Code coverage",
    "choice_d": "Malware hits",
    "correct_answer": "C",
    "explanation": "This metric is usually expressed as a percentage of lines of code. For example, \u201cSAST covered 90% of the source code.\u201d <br>The number of testers involved means very little when discussing testing coverage; this is a distractor and not correct. <br>In some cases, testing reports might include a statistic representing the number of flaws discovered in the code; however, this is usually not a pertinent metric (undetected flaws can\u2019t be measured, so counting the ones that have doesn\u2019t add to your surety the code is secure), and code coverage is used more often. Option C is preferable to option B. <br>Testing should first occur in an environment where the software has not even been exposed to the possibility of malware infection. Option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      298,
      300,
      677,
      678,
      283
    ],
    "source": ""
  },
  {
    "id": 1013,
    "question": "Dynamic software security testing typically uses ___________________ as a measure of how thorough the testing was.",
    "choice_a": "User coverage",
    "choice_b": "Code coverage",
    "choice_c": "Path coverage",
    "choice_d": "Total coverage",
    "correct_answer": "C",
    "explanation": "In dynamic software security testing, the objective is to test a significant sample of the possible logical paths from data input to output. <br>User coverage is a distractor and has no real meaning in this context; option A is incorrect. <br>Code coverage is the metric used in static testing, making option B incorrect. <br>While it would be nice to test each and every data pathway through an application, with both known good and known bad data, that could be unrealistic, depending on the number of possible branches in the application; this goes up exponentially every time another option/choice is added to the program. Total coverage is not a metric\u2014it\u2019s a hope. Option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      300,
      284,
      676,
      677,
      441
    ],
    "source": ""
  },
  {
    "id": 1014,
    "question": "Software security testing should involve both known good and known bad data in order to simulate both ___________________ and ___________________.",
    "choice_a": "Managers, users",
    "choice_b": "Regulators, users",
    "choice_c": "Vendors, users",
    "choice_d": "Users, attackers",
    "correct_answer": "D",
    "explanation": "Known good data is used to determine if the software fulfills the business requirements for which it was acquired. Known bad data tests the ability of the software to handle inputs and conditions that might put it into a fail state; these inputs and conditions can be invoked either purposefully (by attackers) or inadvertently (by users who make mistakes). <br>Testing does not attempt to mimic managers, regulators, or vendors, so the other answers are incorrect.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      300,
      293,
      294,
      284,
      570
    ],
    "source": ""
  },
  {
    "id": 1015,
    "question": "Training programs should be tracked and monitored in order to fulfill both ___________________ and ___________________ requirements. Choose the best response.",
    "choice_a": "Business, security",
    "choice_b": "Regulatory, legal",
    "choice_c": "User, managerial",
    "choice_d": "Vendor, supplier",
    "correct_answer": "B",
    "explanation": "This is not a simple question, and more than one answer could be construed as correct, but option B is the best answer. Tracking and monitoring personnel training is absolutely vital in order to demonstrate regulatory requirements (and many, if not all, organizations are obligated to comply with some regulation that mandates user training) and legal requirements (as an element of due diligence in the modern workplace). <br>Option A is the other answer that could be perceived as accurate, but there is a bit of nuance that makes it less preferable than B. Security is a business requirement\u2014it may not be a <italic>functional</italic> requirement, but it is a requirement nonetheless. Therefore, these two terms are repetitive; security requirements are just a subset of business requirements. Option B is still the better answer. <br>Options C and D do not make sense in this context.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      572,
      571,
      573,
      63,
      81
    ],
    "source": ""
  },
  {
    "id": 1016,
    "question": "Task-centric training is typically for ___________________.",
    "choice_a": "All personnel",
    "choice_b": "Specific personnel",
    "choice_c": "Management personnel",
    "choice_d": "HR personnel",
    "correct_answer": "B",
    "explanation": "Training is usually a formal process involving detailed information. This is for those personnel who are involved with the specific topic or task for which the training is intended (for example, personnel involved in business continuity and disaster recovery (BC/DR) activities should get specific, detailed training on how to perform those actions). <br>Option A incorrect because not all personnel require task-centric training. Training required for all personnel in an organization cannot be task-centric training, by definition (not all personnel perform the same tasks). <br>Options C and D are incorrect because they would only answer a subset of the question. Management personnel would receive management training and HR personnel would receive HR training. The correct answer is task-centric training is for specific personnel.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      580,
      581,
      582,
      90,
      89
    ],
    "source": ""
  },
  {
    "id": 1017,
    "question": "Awareness instruction is typically for ___________________.",
    "choice_a": "All personnel",
    "choice_b": "Specific personnel",
    "choice_c": "Management personnel",
    "choice_d": "HR personnel",
    "correct_answer": "A",
    "explanation": "Awareness efforts are usually intended to reach as wide an audience as possible within the organization, for generalized information. For instance, fire drills are awareness exercises; everyone in the facility needs to know how to get out and where to go. <br>Specific personnel, management personnel, and HR personnel would all receive task-centric training in addition to the awareness instruction that all personnel receive. Options B, C, and D are incorrect.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      581,
      580,
      582,
      72,
      573
    ],
    "source": ""
  },
  {
    "id": 1018,
    "question": "Why is cloud security training particularly important for software developers?",
    "choice_a": "Software developers are the mainstay of every cloud environment.",
    "choice_b": "You can\u2019t have a cloud environment without software developers.",
    "choice_c": "Security controls cannot be added to software after the fact and must be included from the very first steps of software development.",
    "choice_d": "Many modern software developers don\u2019t understand how the code underlying the libraries they use actually works.",
    "correct_answer": "D",
    "explanation": "Modern developers usually aren\u2019t writing code\u2014they are recombining library components in novel ways to create new functionality. They may not understand the security risks associated with their work, especially for the cloud environment, which entails a different set of challenges from the traditional environment, which the developers might be more familiar with. <br>Options A and B are actually the same concept, reworded, which is patently untrue: depending on the cloud deployment and service models the organization chooses to use, software developers may or may not be crucial (for instance, in a software as a service [SaaS] public cloud, many organizations won\u2019t even need internal development teams). <br>Option C is just wrong: security controls <italic>can</italic> be added to software after it has been fielded. This is just not a best practice, as it is usually less effective and more expensive (in terms of both money and overhead).",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      72,
      73,
      74,
      75,
      64
    ],
    "source": ""
  },
  {
    "id": 1019,
    "question": "Software developers should receive cloud-specific training that highlights the challenges involved with having a production environment that operates in the cloud. One of these challenges is ___________________.",
    "choice_a": "The massive additional hacking threat, especially from foreign sources",
    "choice_b": "The prevalent use of encryption in all data life-cycle phases",
    "choice_c": "Drastic increase of risk due to distributed denial-of-service (DDoS) attacks",
    "choice_d": "Additional regulatory mandates",
    "correct_answer": "B",
    "explanation": "Because cloud operations are so dependent on encryption protections in all data life-cycle phases, developers will have to accommodate the additional overhead and interoperability encryption requires. <br>The hacking threat (foreign or otherwise) does not change whether the target is the cloud or the (connected) traditional environment; option A is incorrect. <br>Likewise, the threat of DDoS attacks does not increase; if anything, it may decrease, because the cloud provider may be more resistant to such attacks than individual organizations would be. Option C is not correct. <br>Regulatory requirements may or may not change when moving into the cloud. Moreover, developers are not likely to be the ones interpreting and responding to these new mandates; that is a level of abstraction above developer insight into software requirements. Option D is not preferable to B.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      73,
      79,
      81,
      72,
      82
    ],
    "source": ""
  },
  {
    "id": 1020,
    "question": "Software developers should receive cloud-specific training that highlights the challenges involved with having a production environment that operates in the cloud. One of these challenges is ___________________.",
    "choice_a": "Lack of management oversight",
    "choice_b": "Additional workload in creating governance for two environments (the cloud data center and client devices)",
    "choice_c": "Increased threat of malware",
    "choice_d": "The need for process isolation",
    "correct_answer": "D",
    "explanation": "Because shared resources in the cloud may mean increased opportunity for side-channel attacks, developers will have to design programs to function in a way that ensures process isolation. <br>Management oversight should not change from a policy perspective, regardless of where the processing is taking place; option A is incorrect. <br>There is no additional workload resulting from cloud migration; in fact, the load should decrease, because the cloud customer cannot impose governance on the cloud provider. Option B is wrong. <br>Malware threat does not increase or decrease in the cloud environment; option C is incorrect.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      78,
      71,
      69,
      73,
      72
    ],
    "source": ""
  },
  {
    "id": 1021,
    "question": "Which security technique is <italic>most</italic> preferable when creating a limited functionality for customer service personnel to review account data related to sales made to your clientele?",
    "choice_a": "Anonymization",
    "choice_b": "Masking",
    "choice_c": "Encryption",
    "choice_d": "Training",
    "correct_answer": "B",
    "explanation": "Masking allows customer service representatives to review clients\u2019 sales and account information without revealing the entirety of those records (for instance, obscuring credit card numbers except for the last four digits). <br>Anonymization strips out identifying information from a record. This would not aid in limiting customer service personnel from viewing sensitive data, but it would make it impossible for customer service personnel to know who they were communicating with and leave them unable to identify customers, which would defeat the purpose of their existence. Option A is incorrect. <br>Encryption of sales/account records would not limit customer service personnel in their review of account records. It would either disallow them to see the records at all or allow them to see the entirety of the records (depending on whether the representatives were given keys to that encrypted data). Option C is incorrect. <br>Training does not limit access; option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      82,
      83,
      573,
      294,
      63
    ],
    "source": ""
  },
  {
    "id": 1022,
    "question": "At which phase of the software development life cycle (SDLC) is user involvement <italic>most</italic> crucial?",
    "choice_a": "Define",
    "choice_b": "Design",
    "choice_c": "Develop",
    "choice_d": "Test",
    "correct_answer": "A",
    "explanation": "While some development models allow for user involvement in the entirety of the process, user input is most necessary in the Define phase, where developers can understand the business/user requirements\u2014what the system/software is actually supposed to produce, in terms of function and performance. All the other options are beneficial phases to gauge user input, but not as crucial as option A.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      441,
      439,
      300,
      296,
      293
    ],
    "source": ""
  },
  {
    "id": 1023,
    "question": "At which phase of the software development lifecycle (SDLC) should security personnel first be involved?",
    "choice_a": "Define",
    "choice_b": "Design",
    "choice_c": "Develop",
    "choice_d": "Test",
    "correct_answer": "A",
    "explanation": "The earlier security inputs are included in the project, the more efficient and less costly security controls are overall. The Define phase is the earliest part of the SDLC. All the other options are later phases and incorrect.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      295,
      300,
      439,
      416,
      64
    ],
    "source": ""
  },
  {
    "id": 1024,
    "question": "At which phase of the software development lifecycle (SDLC) is it probably <italic>most</italic> useful to involve third-party personnel?",
    "choice_a": "Define",
    "choice_b": "Design",
    "choice_c": "Develop",
    "choice_d": "Test",
    "correct_answer": "D",
    "explanation": "During testing, getting outside perspective is invaluable, for both performance and security purposes; internal development and review capabilities are enhanced by augmentation from external parties. <br>All the other phases are not normally appropriate for external participation.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      270,
      268,
      269,
      298,
      299
    ],
    "source": ""
  },
  {
    "id": 1025,
    "question": "In software development lifecycle (SDLC) implementations that include a Secure Operations phase, which of the following security techniques or tools are implemented during that phase?",
    "choice_a": "Vulnerability assessments and penetration testing",
    "choice_b": "Performance testing and security control validation",
    "choice_c": "Requirements fulfillment testing",
    "choice_d": "Threat modeling and secure design review",
    "correct_answer": "A",
    "explanation": "Once the system is deployed operationally, continuous security monitoring, including periodic vulnerability assessments and penetration testing, is recommended. All the other options are security functions that should take place in phases prior to the system\u2019s deployment.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      299,
      300,
      431,
      90,
      580
    ],
    "source": ""
  },
  {
    "id": 1026,
    "question": "A cloud environment that lacks security controls is vulnerable to exploitation, data loss, and interruptions. Conversely, excessive use of security controls ___________________.",
    "choice_a": "Can lead to data breaches",
    "choice_b": "Causes electromagnetic interference",
    "choice_c": "Will affect quality of service",
    "choice_d": "Can cause regulatory noncompliance",
    "correct_answer": "C",
    "explanation": "Security and operations are always inversely related; excessive controls necessarily degrade performance. <br>Excessive use of controls should not lead to more data breaches; if anything, it may reduce their occurrence. However, it is more likely that there will be no effect. Option A is incorrect. <br>Many controls don\u2019t affect the electromagnetic spectrum in any way. Option B is incorrect. <br>Regulations don\u2019t usually mandate a maximum set of controls but rather a minimum. Option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      573,
      294,
      282,
      71,
      82
    ],
    "source": ""
  },
  {
    "id": 1027,
    "question": "A cloud environment that lacks security controls is vulnerable to exploitation, data loss, and interruptions. Conversely, excessive use of security controls ___________________.",
    "choice_a": "Can lead to distributed denial of service (DDoS)",
    "choice_b": "Allows malware infections",
    "choice_c": "Increases the risk of adverse environmental effects",
    "choice_d": "Is an unnecessary expense",
    "correct_answer": "D",
    "explanation": "From a simple financial perspective (which is often the managerial perspective), money spent on excessive <italic>anything</italic> is money wasted; spending to no good effect is detrimental. <br>Overuse of controls should not result in greater risks of DDoS, malware, or environmental threats in any way. Options A, B, and C are incorrect.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      294,
      282,
      296,
      573,
      71
    ],
    "source": ""
  },
  {
    "id": 1028,
    "question": "A cloud environment that lacks security controls is vulnerable to exploitation, data loss, and interruptions. Conversely, excessive use of security controls ___________________.",
    "choice_a": "Can lead to customer dissatisfaction",
    "choice_b": "Is a risk to health and human safety",
    "choice_c": "Brings down the organization\u2019s stock price",
    "choice_d": "Negates the need for insurance",
    "correct_answer": "A",
    "explanation": "If excessive controls impact the user/customer experience to the extent that system response speeds and results are delayed significantly, and performance is degraded to the point where competitors\u2019 systems are far superior, customer dissatisfaction can be a severe problem. <br>Some security controls (particularly physical controls) can affect health and human safety, such as if extraneous fencing/walls/barriers are put in place to control access/egress, and this hinders emergency escape from facilities. However, not all security controls pose this risk, so option B is a bit too specific; option A is still preferable. <br>Security controls should not affect stock price or, in and of themselves, negate insurance needs (risk mitigation does not automatically offset the benefits of risk transference). Options C and D are incorrect.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      294,
      282,
      573,
      64,
      71
    ],
    "source": ""
  },
  {
    "id": 1029,
    "question": "You are the security manager for an online retail sales company with 100 employees and a production environment hosted in a platform as a service (PaaS) model with a major cloud provider. According to your company policies, personnel are allowed to work equally from the company offices and their own homes or other locations, using their personal IT devices. The policies also dictate which application programming interfaces (APIs) can be used to access and manipulate company data and the process for getting an API added to the list of approved programs. You conduct an approved scan of the company data set in the cloud, with the provider\u2019s permission. This allows you to catalog all APIs that have accessed and manipulated company data through authorized user accounts in the last month. The scan reveals that 300 different APIs were used by authorized personnel. Of these, 30 had been approved by the company and were on the list. <br>Of the following, what is the <italic>most</italic> reasonable immediate action?",
    "choice_a": "Delete accounts of all users who had utilized unapproved APIs to access company data.",
    "choice_b": "Suspend access for all users who had utilized unapproved APIs to access company data.",
    "choice_c": "Block all unapproved APIs from accessing company data.",
    "choice_d": "Notify whomever you report to in the company hierarchy, and suggest bringing the matter to the attention of senior management immediately.",
    "correct_answer": "D",
    "explanation": "The problem in this case is not so much that policies have been violated or that, in a more literal sense, the unapproved APIs are being used to access the data, the problem is that the violations are so pervasive and extensive that taking any immediate direct action (such as the responses in options A, B, and C) might interfere with business activity in a drastic and potentially harmful way. Because of this, the matter needs to be dealt with as a business decision and requires that senior management make a determination before action is taken.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      82,
      64,
      63,
      416,
      71
    ],
    "source": ""
  },
  {
    "id": 1030,
    "question": "You are the security manager for an online retail sales company with 100 employees and a production environment hosted in a platform as a service (PaaS) model with a major cloud provider. According to your company policies, personnel are allowed to work equally from the company offices and their own homes or other locations, using their personal IT devices. The policies also dictate which application programming interfaces (APIs) can be used to access and manipulate company data and the process for getting an API added to the list of approved programs. You conduct an approved scan of the company data set in the cloud, with the provider\u2019s permission. This allows you to catalog all APIs that have accessed and manipulated company data through authorized user accounts in the last month. The scan reveals that 300 different APIs were used by authorized personnel. Of these, 30 had been approved by the company and were on the list. <br>You\u2019ve brought the matter to the attention of the chief executive officer (CEO), who understands the issue and asks for your recommendation. What is probably the best suggestion?",
    "choice_a": "Gather more data about how users are utilizing the APIs and for what purposes.",
    "choice_b": "Delete accounts of all users who had utilized unapproved APIs to access company data.",
    "choice_c": "Suspend access for all users who had utilized unapproved APIs to access company data.",
    "choice_d": "Block all unapproved APIs from accessing company data.",
    "correct_answer": "A",
    "explanation": "Before taking any action that might impact operations, it would probably be best to figure out the actual user needs being met by the unapproved APIs, and the severity of impact if they were removed from service, before performing the actions described in options B, C, and D.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      573,
      82,
      286,
      416,
      63
    ],
    "source": ""
  },
  {
    "id": 1031,
    "question": "You are the security manager for an online retail sales company with 100 employees and a production environment hosted in a platform as a service (PaaS) model with a major cloud provider. According to your company policies, personnel are allowed to work equally from the company offices and their own homes or other locations, using their personal IT devices. The policies also dictate which application programming interfaces (APIs) can be utilized to access and manipulate company data and the process for getting an API added to the list of approved programs. You conduct an approved scan of the company data set in the cloud, with the provider\u2019s permission. This allows you to catalog all APIs that have accessed and manipulated company data through authorized user accounts in the last month. The scan reveals that 300 different APIs were used by authorized personnel. Of these, 30 had been approved by the company and were on the list. <br>Upon performing an information-gathering investigation at the behest of the chief executive officer (CEO), you determine that these APIs increased productivity 387 percent over the period since they were adopted, at a cost that is negligible compared to getting even one API through the company\u2019s current approval process. What is your suggestion on how to handle the situation?",
    "choice_a": "Retroactively put all the APIs currently in use through the formal approval process, and require that all future APIs users want to install also get approved.",
    "choice_b": "Have the CEO waive formal approval processing for all APIs currently in use, granting them approval, but require all future APIs be approved through that process.",
    "choice_c": "Punish all employees who have installed or used any of the rogue APIs for violating company policy.",
    "choice_d": "Change the policy.",
    "correct_answer": "D",
    "explanation": "It\u2019s hard to argue with success; operational capability and security are always a trade-off, but this kind of productivity increase with little attendant cost is probably too good to pass up. It also seems evident that the existing policy is far too restrictive and limiting and that it is not being accepted by a significant number of users; trying to mandate its acceptance, and enforcing it with punitive measures, especially in the face of the overwhelming success of the violations, is most likely counter to the company\u2019s overall interests. It is best to revisit the policy itself, determine why it didn\u2019t meet user needs originally, and modify it so as to meet the demands of <italic>both</italic> the users <italic>and</italic> senior management (as well as whatever other externalities may have been the foundation of the policy). Options A, B, and C may be attractive, but they are all less preferable than D.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      573,
      416,
      82,
      64,
      71
    ],
    "source": ""
  },
  {
    "id": 1032,
    "question": "You are the security manager for an online retail sales company with 100 employees and a production environment hosted in a platform as a service (PaaS) model with a major cloud provider. According to your company policies, personnel are allowed to work equally from the company offices and their own homes or other locations, using their personal IT devices. The policies also dictate which application programming interfaces (APIs) can be utilized to access and manipulate company data and the process for getting an API added to the list of approved programs. You conduct an approved scan of the company data set in the cloud, with the provider\u2019s permission. This allows you to catalog all APIs that have accessed and manipulated company data through authorized user accounts in the last month. The scan reveals that 300 different APIs were used by authorized personnel. Of these, 30 had been approved by the company and were on the list. <br>As a subject matter expert, what should you also recommend to the chief executive officer (CEO)?",
    "choice_a": "Reward the users who committed the infractions, for aiding the company even when they were violating the policy.",
    "choice_b": "Replace all the personnel that violated the policy, and have the new personnel use the new policy from their start of hire.",
    "choice_c": "Restrict user access to possible APIs.",
    "choice_d": "Augment the current set of security controls used by the company in order to offset risks posed by the anticipated use of even more APIs from unknown sources.",
    "correct_answer": "D",
    "explanation": "APIs chosen by users may or may not have integral security and probably weren\u2019t chosen according to how secure they are; because the company will continue to be exposed to additional risks from these (and future) APIs, additional security controls are absolutely necessary. <br>However, personnel actions and draconian enforcement efforts at this point would be pointless and vindictive, and probably counter to the company\u2019s interests. Options A, B, and C are incorrect.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      82,
      73,
      286,
      294,
      573
    ],
    "source": ""
  },
  {
    "id": 1033,
    "question": "You are the security manager for an online retail sales company with 100 employees and a production environment hosted in a platform as a service (PaaS) model with a major cloud provider. According to your company policies, personnel are allowed to work equally from the company offices and their own homes or other locations, using their personal IT devices. The policies also allow users to select which application programming interfaces (APIs) they install and use on their own devices in order to access and manipulate company data. <br>Of the following, what is a security control you\u2019d like to implement to offset the risk(s) incurred by this practice?",
    "choice_a": "Encrypt all routers between mobile users and the cloud.",
    "choice_b": "Use additional anti-malware detection capabilities on both user devices and the environment to which they connect.",
    "choice_c": "Implement strong multifactor authentication on all user-owned devices.",
    "choice_d": "Employ regular performance monitoring in the cloud environment to ensure that the cloud provider is meeting the service level agreement (SLA) targets.",
    "correct_answer": "B",
    "explanation": "Because untrusted APIs may not be secured sufficiently, increased vigilance for the possibility of introducing malware into the production environment is essential. <br>It is impossible to encrypt devices that don\u2019t belong to the organization. Option A is incorrect. <br>Securing access to user-owned devices is admirable, but it has no effect at all on securing the device (or production environment) from risks due to installed APIs; option C is incorrect. <br>This is a security question, and option D addresses performance; this is incorrect.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      73,
      82,
      286,
      81,
      294
    ],
    "source": ""
  },
  {
    "id": 1034,
    "question": "You are the security manager for an online retail sales company with 100 employees and a production environment hosted in a platform as a service (PaaS) model with a major cloud provider. According to your company policies, personnel are allowed to work equally from the company offices and their own homes or other locations, using their personal IT devices. The policies also allow users to select which application programming interfaces (APIs) they install and use on their own devices in order to access and manipulate company data. <br>Of the following, what is a security control you\u2019d like to implement to offset the risk(s) incurred by this practice?",
    "choice_a": "Regular and widespread integrity checks on sampled data throughout the managed environment",
    "choice_b": "More extensive and granular background checks on all employees, particularly new hires",
    "choice_c": "Inclusion of references to all applicable regulations in the policy documents",
    "choice_d": "Increased enforcement of separation of duties for all workflows",
    "correct_answer": "A",
    "explanation": "In order to detect possible erroneous or malicious modification of the organization\u2019s data by unauthorized or security-deficient APIs, it\u2019s important to take representative samples of the production data on a continual basis and perform integrity checks. <br>Additional personnel security measures will not, in this case, yield any relevant security benefit; options B and D are not correct. <br>It is always good to refer to regulations in policies; this isn\u2019t something to be performed in response to the policy change but should have been included when the policy was created. Option C is incorrect.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      82,
      73,
      286,
      567,
      294
    ],
    "source": ""
  },
  {
    "id": 1035,
    "question": "You are the security manager for an online retail sales company with 100 employees and a production environment hosted in a platform as a service (PaaS) model with a major cloud provider. According to your company policies, personnel are allowed to work equally from the company offices and their own homes or other locations, using their personal IT devices. The policies also allow users to select which application programming interfaces (APIs) they install and use on their own devices in order to access and manipulate company data. <br>Of the following, what is a security control you\u2019d like to implement to offset the risk(s) incurred by this practice?",
    "choice_a": "Enact secure connections between the user devices and the cloud environment using end-to-end encryption.",
    "choice_b": "Enact secure connections between the user devices and the cloud environment using link encryption.",
    "choice_c": "Employ additional user training.",
    "choice_d": "Tunnel all connections with a virtual private network (VPN).",
    "correct_answer": "C",
    "explanation": "Additional user training would be helpful in this situation, particularly any information that helps users understand the reasons APIs from unknown sources might be less secure and the potential impacts from using them. <br>All the other answers are incorrect; securing the connection between endpoints and the cloud is irrelevant in protecting against risks caused by software installed on the client devices.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      82,
      73,
      436,
      294,
      416
    ],
    "source": ""
  },
  {
    "id": 1036,
    "question": "Users in your organization have been leveraging application programming interfaces (APIs) for enhancing their productivity in the cloud environment. To ensure that you are securing API access to the production environment, you should deploy ___________________ and ___________________.",
    "choice_a": "Secure Sockets Layer (SSL) and message-level cryptography",
    "choice_b": "Transport Layer Security (TLS) and message-level cryptography",
    "choice_c": "SSL and whole drive encryption",
    "choice_d": "TLS and whole drive encryption",
    "correct_answer": "B",
    "explanation": "Cryptography for the two main types of APIs is required; this is TLS for representational state transfer (REST) and message-level encryption for Simple Object Access Protocol (SOAP). <br>SSL has been deprecated because of severe vulnerabilities; this eliminates options A and C. Whole drive encryption protects against loss or theft of a device but does not secure API access to the data, which eliminates option D.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      705,
      704,
      567,
      81,
      286
    ],
    "source": ""
  },
  {
    "id": 1037,
    "question": "You implement identity and access management (IAM) in order to control access between subjects and objects. What is the ultimate purpose of this effort?",
    "choice_a": "Identification. Determine who the specific, individual subjects are.",
    "choice_b": "Authentication. Verify and validate any identification assertions.",
    "choice_c": "Authorization. Grant subjects permissions to objects once they\u2019ve been authenticated.",
    "choice_d": "Accountability. Be able to reconstruct a narrative of who accessed what.",
    "correct_answer": "D",
    "explanation": "Accountability is the end purpose of all IAM efforts; all the other options are the elements of IAM that support this effort.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      288,
      367,
      83,
      431,
      585
    ],
    "source": ""
  },
  {
    "id": 1038,
    "question": "___________________ is perhaps the main external factor driving identity and access management (IAM) efforts.",
    "choice_a": "Regulation",
    "choice_b": "Business need",
    "choice_c": "The evolving threat landscape",
    "choice_d": "Monetary value",
    "correct_answer": "A",
    "explanation": "Regulatory compliance has historically driven IAM efforts. All the other options can to some extent drive IAM efforts, however, they do not have as much influence as regulatory factors. Therefore options B, C, and D are incorrect answers.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      65,
      82,
      87,
      81,
      64
    ],
    "source": ""
  },
  {
    "id": 1039,
    "question": "Whether in a cloud or traditional environment, it is important to implement both ___________________ and ___________________ access controls.",
    "choice_a": "Internal and managed",
    "choice_b": "Provider and customer",
    "choice_c": "Physical and logical",
    "choice_d": "Administrative and technical",
    "correct_answer": "C",
    "explanation": "Both physical and logical controls are possible (and necessary) to implement in both environments. <br>Options A and B are really only feasible if the organization is using a cloud service (or other managed service); the terms <italic>managed</italic> and <italic>provider</italic> suggest this. This makes these options less desirable for a question that also includes the traditional environment. <br>It is not reasonable to expect that the organization can impose administrative controls in a cloud environment (for the provider environment), so option D is not correct.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      82,
      64,
      65,
      70,
      69
    ],
    "source": ""
  },
  {
    "id": 1040,
    "question": "Access to specific data sets should be granted by ___________________.",
    "choice_a": "The data subjects",
    "choice_b": "The data owners",
    "choice_c": "The data processors",
    "choice_d": "The data regulators",
    "correct_answer": "B",
    "explanation": "The data owner is most familiar with the risks and impacts associated with the data sets under their control. <br>The data subject may grant permission for a data owner to have the subject\u2019s data but will not govern the granular assignment of access rights. Option A is incorrect. <br>The data processor does not have the right to grant data access and must only act at the direction of the data owner. Option C is incorrect. <br>Regulators dictate how data must be secured, and possibly in what manner, but do not supervise explicit access to that data. Option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      63,
      64,
      82,
      83,
      69
    ],
    "source": ""
  },
  {
    "id": 1041,
    "question": "Access should be granted based on all of the following <italic>except</italic> ___________________.",
    "choice_a": "Policy",
    "choice_b": "Business needs",
    "choice_c": "Performance",
    "choice_d": "Acceptable risk",
    "correct_answer": "C",
    "explanation": "Performance should not determine who gets access to which data; all the other options are the factors for making this determination.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      288,
      431,
      69,
      71,
      64
    ],
    "source": ""
  },
  {
    "id": 1042,
    "question": "Federation allows ___________________ across organizations.",
    "choice_a": "Role replication",
    "choice_b": "Encryption",
    "choice_c": "Policy",
    "choice_d": "Access",
    "correct_answer": "D",
    "explanation": "Federation allows users from multiple member organizations to access resources owned by various members. <br>All the other answers are simply not correct.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      583,
      584,
      695,
      696,
      576
    ],
    "source": ""
  },
  {
    "id": 1043,
    "question": "Federation should be ___________________ to the users.",
    "choice_a": "Hostile",
    "choice_b": "Proportional",
    "choice_c": "Transparent",
    "choice_d": "Expensive",
    "correct_answer": "C",
    "explanation": "Federation allows ease of use for access to multiple resource providers; this provides a transparent user mechanism. <br> /br>The goal of federation is to enhance the user experience, the exact opposite of making the environment more hostile to them. Option A is incorrect. <br> Option B is incorrect because it is meaningless in this context. <br>Option D is incorrect. Users typically do not pay for the organization\u2019s IT environment.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      583,
      584,
      585,
      694,
      696
    ],
    "source": ""
  },
  {
    "id": 1044,
    "question": "A web application firewall (WAF) understands which protocol(s)?",
    "choice_a": "All protocols that use the Internet as a medium",
    "choice_b": "Transport Layer Security (TLS)",
    "choice_c": "Hypertext Transfer Protocol (HTTP)",
    "choice_d": "File Transfer Protocol (FTP)",
    "correct_answer": "C",
    "explanation": "WAFs apply rulesets to web traffic, which uses HTTP. All the other answers are incorrect.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      579,
      577,
      430,
      397,
      704
    ],
    "source": ""
  },
  {
    "id": 1045,
    "question": "Web application firewalls and database activity monitors function at levels ___________________ and ___________________ of the Open Systems Interconnection (OSI) model, respectively.",
    "choice_a": "1 and 7",
    "choice_b": "7 and 1",
    "choice_c": "7 and 7",
    "choice_d": "3 and 4",
    "correct_answer": "C",
    "explanation": "These are both Layer 7 tools. All the other answers are incorrect.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      577,
      579,
      578,
      430,
      453
    ],
    "source": ""
  },
  {
    "id": 1046,
    "question": "What can tokenization be used for?",
    "choice_a": "Encryption",
    "choice_b": "Compliance with the Payment Card Industry Data Security Standard (PCI DSS)",
    "choice_c": "Enhancing the user experience",
    "choice_d": "Giving management oversight to e-commerce functions",
    "correct_answer": "B",
    "explanation": "Aside from encryption, PCI DSS allows for tokenization as a means to protect account and cardholder data at rest. <br>Tokenization is not encryption; there is no encryption engine and no key involved in the process. Option A is incorrect. <br>Tokenization does not necessarily enhance or detract from the user experience; option C is incorrect. <br>Management is not allowed any additional oversight into any particular function by tokenization; option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      82,
      63,
      64,
      81,
      80
    ],
    "source": ""
  },
  {
    "id": 1047,
    "question": "Merchants who accept credit card payments can avoid some of the compliance burden for the Payment Card Industry Data Security Standard (PCI DSS) by outsourcing the tokenization function to ___________________.",
    "choice_a": "A third party",
    "choice_b": "The data owner",
    "choice_c": "The data subject",
    "choice_d": "The PCI Security Standards Council",
    "correct_answer": "A",
    "explanation": "By offloading privacy data to a tokenizing third party, merchants can free themselves of the contractual burdens for protecting cardholder data at rest. <br>The data owner is the merchants themselves, and the data subject is the person to whom the privacy data applies, so privacy data cannot be outsourced to either of these, and options B and C are incorrect. <br>The PCI Council is the body that promulgates and enforces the PCI DSS; they will not process data on behalf of any merchant. Option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      63,
      64,
      67,
      74,
      82
    ],
    "source": ""
  },
  {
    "id": 1048,
    "question": "Which of the following is an example of useful and sufficient data masking of the string \u201cCCSP\u201d?",
    "choice_a": "XCSP",
    "choice_b": "PSCC",
    "choice_c": "TtLp",
    "choice_d": "3X91",
    "correct_answer": "C",
    "explanation": "This answer requires some thought about how the original data is displayed and its properties. <br>Option A masks only one letter in a four-letter string; this is not sufficient because the original string could be identified with a very low-work factor, brute-force attack of only 26 possible combinations. <br>Option B is likewise easy to break; it only reverses the content of the string, which is very simple to determine, and would allow easy recovery of any other similar strings in the data set. <br>Option D mixes numeric characters into what was originally only an alphabetic string; this may detract from the utility of the string if the masked version is to be used for software testing. <br>Option C completely obscures the original content but retains the qualities of the original (all alphabetic characters). It may affect the use of the string by mixing uppercase and lowercase, but this is still the best choice of the four possible answers.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      69,
      70,
      71,
      64,
      65
    ],
    "source": ""
  },
  {
    "id": 1049,
    "question": "A cloud-based sandbox should <italic>not</italic> be used for ___________________.",
    "choice_a": "Application interoperability testing",
    "choice_b": "Processing sensitive data",
    "choice_c": "Application security testing",
    "choice_d": "Malware analysis",
    "correct_answer": "D",
    "explanation": "Installing malware on systems owned by someone else may be illegal in many jurisdictions. While on-premises sandboxes are fine for this purpose, it may be a felony if performed in the cloud. <br>All the other options are good uses of cloud-based sandboxes.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      285,
      283,
      284,
      72,
      71
    ],
    "source": ""
  },
  {
    "id": 1050,
    "question": "Which of the following should occur at each stage of the software development life cycle (SDLC)?",
    "choice_a": "Added functionality",
    "choice_b": "Management review",
    "choice_c": "Verification and validation",
    "choice_d": "Repurposing of any newly developed components",
    "correct_answer": "C",
    "explanation": "It is important to verify and validate the program at each stage of the SDLC. <br>Adding functionality at each stage of the SDLC is the definition of scope creep, which is what we\u2019d like to avoid. Option A is incorrect. <br>Management should not have to shepherd software through the development process; this is the process of the development team. Option B is incorrect. <br>Option D makes no sense: you can\u2019t repurpose something that has just been developed.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      295,
      282,
      300,
      441,
      439
    ],
    "source": ""
  },
  {
    "id": 1051,
    "question": "Software that includes security elements from the outset of the software development life cycle (SDLC) process will be ___________________.",
    "choice_a": "More secure in deployment",
    "choice_b": "Less secure in deployment",
    "choice_c": "More likely to malfunction",
    "choice_d": "Less likely to malfunction",
    "correct_answer": "A",
    "explanation": "When security is included at the outset of the process, the software will likely be more secure in production. Option B is incorrect for this reason as well. <br>Options C and D are incorrect because the inclusion of security will not necessarily affect the performance of the software to a significant degree.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      295,
      441,
      268,
      269,
      270
    ],
    "source": ""
  },
  {
    "id": 1052,
    "question": "Software that includes security elements from the outset of the software development life cycle (SDLC) process will ___________________.",
    "choice_a": "Be less expensive to operate securely in the production environment",
    "choice_b": "Be more expensive to operate securely in the production environment",
    "choice_c": "Not be interoperable with other software and systems in the production environment",
    "choice_d": "Have a greater likelihood of interoperability with other software and systems in the production environment",
    "correct_answer": "A",
    "explanation": "When security is created as an aspect of the software itself, there is less need to acquire and apply additional security controls to mitigate risks after deployment. Option B is also wrong for this same reason. <br>Options C and D are incorrect because the inclusion of security aspects in software design should not affect interoperability in any significant way.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      282,
      294,
      441,
      268,
      269
    ],
    "source": ""
  },
  {
    "id": 1053,
    "question": "The inclusion of security controls in the software design process is dictated by ___________________.",
    "choice_a": "The National Institute of Standards and Technology (NIST) 800-37",
    "choice_b": "The American Institute of Certified Public Accountants (AICPA)",
    "choice_c": "ISO 27034",
    "choice_d": "The Health Insurance Portability and Accountability Act (HIPAA)",
    "correct_answer": "C",
    "explanation": "ISO 27034 addresses the sets of controls used in software throughout the environment. <br>800-37 is the Risk Management Framework, which is about the organization\u2019s overall security, not software development, so option A is incorrect. <br>The AICPA is a standards-making body, not a standard itself, so option B is incorrect. <br>HIPAA deals with health care privacy, so option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      282,
      294,
      441,
      293,
      296
    ],
    "source": ""
  },
  {
    "id": 1054,
    "question": "Software development should be perceived as ___________________.",
    "choice_a": "Including all members of the organization",
    "choice_b": "The paramount goal of the organization",
    "choice_c": "The greatest risk to the organization",
    "choice_d": "A life cycle",
    "correct_answer": "D",
    "explanation": "It is important to consider software development as having a defined process and an eventual endpoint for the useful life of the product. <br>Not every organization is a software development company. Even in software development companies, not everyone participates in development (there are other departments/offices, such as sales, accounting, etc.). Option A is a poor choice. <br>Option B is only a correct answer if the organization is a software development company. Otherwise, it is not a correct answer. Option B is incorrect. <br>If software development poses the most significant risk to your organization, you probably shouldn\u2019t be doing software development. Option C is incorrect.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      573,
      282,
      298,
      299,
      439
    ],
    "source": ""
  },
  {
    "id": 1055,
    "question": "Dynamic testing of software is perhaps most useful for ___________________.",
    "choice_a": "Simulating negative test cases",
    "choice_b": "Finding errors in the source code",
    "choice_c": "Determining the effect of social engineering",
    "choice_d": "Penetration tests",
    "correct_answer": "A",
    "explanation": "Running the software and allowing users to operate it is a great form of dynamic testing, which simulates both known good and known bad inputs. <br>Dynamic testing does not involve source code review or social engineering; options B and C are incorrect. <br>Penetration tests occur in the production environment, not on pre-deployment software; option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      300,
      298,
      283,
      284,
      285
    ],
    "source": ""
  },
  {
    "id": 1056,
    "question": "What is the <italic>primary</italic> incident response goal?",
    "choice_a": "Remediating the incident",
    "choice_b": "Reverting to the last known good state",
    "choice_c": "Determining the scope of the possible loss",
    "choice_d": "Outcomes dictated by business requirements",
    "correct_answer": "D",
    "explanation": "This is not an easy question; different industries and different organizations will have differing goals. Each organization will determine for itself what the primary goal of incident response will be, and this may even differ from incident to incident, depending on the nature of the incident itself (in other words, a given organization may set priorities such that the primary goal of incident response in a disaster is continuity of operations, while the goal in responding to unauthorized access may be halting data disclosure).",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      247,
      249,
      401,
      402,
      636
    ],
    "source": ""
  },
  {
    "id": 1057,
    "question": "You are in charge of building a cloud data center. Which raised floor level is sufficient to meet standard requirements?",
    "choice_a": "10 inches",
    "choice_b": "8 inches",
    "choice_c": "18 inches",
    "choice_d": "2 feet",
    "correct_answer": "D",
    "explanation": "The minimum recommended height of a raised floor in a data center is 24 inches. All other options are incorrect.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      586,
      593,
      597,
      588,
      592
    ],
    "source": ""
  },
  {
    "id": 1058,
    "question": "You are in charge of building a cloud data center. What purposes does the raised floor serve?",
    "choice_a": "Allows airflow and increases structural soundness for holding large components",
    "choice_b": "Cold air feed and a place to run wires for the machines",
    "choice_c": "Additional storage for critical components and a dedicated access to a landline",
    "choice_d": "Fire suppression systems and personnel safety",
    "correct_answer": "B",
    "explanation": "The raised floor in a data center will serve as an air plenum (usually for cold air) and a wiring chase. All the other options are incorrect.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      586,
      587,
      596,
      595,
      597
    ],
    "source": ""
  },
  {
    "id": 1059,
    "question": "You are in charge of building a cloud data center. Which of the following is a useful rack configuration for regulating airflow?",
    "choice_a": "Exhaust fans on racks facing the inlet vents of other racks",
    "choice_b": "Inlet fans on racks facing exhaust fans of other racks",
    "choice_c": "All racks perpendicular to each other",
    "choice_d": "Exhaust fans on racks facing exhaust fans on other racks",
    "correct_answer": "D",
    "explanation": "The preferred method is cold aisle containment (hot aisle containment, where the inlets on racks face each other, is all right too). Options A and B are the same incorrect answer, just worded differently; if the exhaust fans on one rack face into the inlet vents on another rack, you would end up blowing warm air into the components, defeating the purpose of airflow management. Perpendicular racks will not optimize your airflow.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      593,
      587,
      597,
      94,
      618
    ],
    "source": ""
  },
  {
    "id": 1060,
    "question": "An event is something that can be measured within the environment. An incident is a(n) ___________________ event.",
    "choice_a": "Deleterious",
    "choice_b": "Negative",
    "choice_c": "Unscheduled",
    "choice_d": "Major",
    "correct_answer": "C",
    "explanation": "All activity in the environment can be considered events. Any event that was not planned or known is an incident. In the security industry, we often ascribe negative effects to the term <italic>incident</italic>, but incidents are not always malicious; they are only unscheduled. <br>All the other options are incorrect.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      400,
      401,
      626,
      308,
      111
    ],
    "source": ""
  },
  {
    "id": 1061,
    "question": "Which of the following factors would probably <italic>most</italic> affect the design of a cloud data center?",
    "choice_a": "Geographic location",
    "choice_b": "Functional purpose",
    "choice_c": "Cost",
    "choice_d": "Aesthetic intent",
    "correct_answer": "A",
    "explanation": "This is a difficult, nuanced question. Options A\u2013C are true; each element would affect the design of a cloud data center (D is not something that should be included in data center design). But the physical location of the data center would include legal constraints (based on jurisdiction), geological/natural constraints (based on altitude, proximity to water formations/flooding, climate, natural disaster, etc.), price, and other variables. Therefore, location would most likely have the greatest impact on the design of the facility.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      589,
      588,
      591,
      590,
      95
    ],
    "source": ""
  },
  {
    "id": 1062,
    "question": "All of the following elements must be considered in the design of a cloud data center <italic>except</italic> ___________________.",
    "choice_a": "External standards, such as ITIL or ISO 27001",
    "choice_b": "Physical environment",
    "choice_c": "Types of services offered",
    "choice_d": "Native language of the majority of customers",
    "correct_answer": "D",
    "explanation": "Language of the customers is irrelevant, assuming they can pay. All the other options are factors that must be considered in data center design.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      588,
      589,
      593,
      594,
      590
    ],
    "source": ""
  },
  {
    "id": 1063,
    "question": "In designing a data center to meet their own needs and provide optimum revenue/profit, the cloud provider will most likely aim to enhance ___________________.",
    "choice_a": "Functionality",
    "choice_b": "Automation of services",
    "choice_c": "Aesthetic value",
    "choice_d": "Inherent value",
    "correct_answer": "B",
    "explanation": "This is not an easy question. All the options are correct except C. Option B is the most correct because it will lead to maximizing performance, value, and profitability.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      615,
      588,
      94,
      95,
      323
    ],
    "source": ""
  },
  {
    "id": 1064,
    "question": "You are the security officer for a small cloud provider offering public cloud infrastructure as a service (IaaS); your clients are predominantly from the education sector, located in North America. Of the following technology architecture traits, which is probably the one your organization would most likely want to focus on?",
    "choice_a": "Reducing mean time to repair (MTTR)",
    "choice_b": "Reducing mean time between failure (MTBF)",
    "choice_c": "Reducing the recovery time objective (RTO)",
    "choice_d": "Automating service enablement",
    "correct_answer": "D",
    "explanation": "The goal of automating service enablement is probably paramount for any cloud service provider (of the qualities listed), because it allows for the most scalability and offers the most significant reduction in costs (which mainly come from personnel) and therefore the most profitability. The details of \u201cpublic cloud,\u201d \u201cIaaS,\u201d and \u201cNorth America\u201d are distractors in this context as they are irrelevant\u2014this answer would be true for any cloud provider offering any type of services. <br>Options A and B are not true because most cloud providers of any appreciable size are purchasing hardware on a scale that makes the per-unit failure rate fairly irrelevant; the bulk nature of IT purchases by cloud providers makes differences in MTTR and MTBF between vendors and products statistically insignificant. <br>Option C is incorrect because RTO is a quality involving business continuity and disaster recovery (BC/DR) planning, not IT architecture.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      602,
      107,
      615,
      446,
      96
    ],
    "source": ""
  },
  {
    "id": 1065,
    "question": "What is perhaps the <italic>main</italic> way in which software-defined networking (SDN) solutions facilitate security in the cloud environment?",
    "choice_a": "Monitoring outbound traffic",
    "choice_b": "Monitoring inbound traffic",
    "choice_c": "Segmenting networks",
    "choice_d": "Preventing distributed denial of service (DDoS) attacks",
    "correct_answer": "C",
    "explanation": "Network segmentation allows providers to create zones of trust within the cloud environment, tailoring the available services to meet the needs of a variety of clients and markets. <br>SDN does not really involve monitoring outbound traffic (that is done by egress monitoring solutions) or inbound traffic (that is usually performed by firewalls and routers), nor does it really prevent DDoS attacks (nothing can prevent such attacks, and risk reduction is usually done by routers), so all the other options are incorrect.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      97,
      98,
      94,
      108,
      96
    ],
    "source": ""
  },
  {
    "id": 1066,
    "question": "The logical design of a cloud environment can enhance the security offered in that environment. For instance, in a software as a service (SaaS) cloud, the provider can incorporate ___________________ capabilities into the application itself.",
    "choice_a": "High-speed processing",
    "choice_b": "Logging",
    "choice_c": "Performance-enhancing",
    "choice_d": "Cross-platform functionality",
    "correct_answer": "B",
    "explanation": "The ability to log activity is useful for many security purposes (such as monitoring and forensics); having that purposefully included in SaaS applications reduces the need to have a different tool added to the environment to achieve that same goal and reduces the possibility that any additional interface won\u2019t perform optimally. <br>The other options are all about enhancing the customer\u2019s ability to perform business function or meeting the customer\u2019s business needs. Although this is paramount from the customer\u2019s perspective and may tangentially fulfill some security purpose (increased processing capacity may, for instance, allow the use of additional encryption, where the overhead may otherwise deter the use of that tool), these are not direct security purposes and therefore are not correct answers to this specific question.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      401,
      402,
      96,
      108,
      101
    ],
    "source": ""
  },
  {
    "id": 1067,
    "question": "You are tasked with managing a cloud data center in Los Angeles; your customers are mostly from the entertainment industry, and you are offering both platform as a service (PaaS) and software as a service (SaaS) capabilities. From a physical design standpoint, you are probably going to be most concerned with ___________________.",
    "choice_a": "Offering digital rights management (DRM) capabilities",
    "choice_b": "Insuring against seasonal floods",
    "choice_c": "Preventing all malware infection potential",
    "choice_d": "Ensuring that the racks and utilities can endure an earthquake",
    "correct_answer": "D",
    "explanation": "California is known for suffering massive destruction from earthquakes, and physical design is the means with which this risk is addressed. <br>All the other options either involve a nonphysical risk (DRM will be necessary, because the entertainment industry relies heavily on copyrighted material) or a method other than physical design to address a risk (floods are physical threats, but insurance is an administrative control for risk transfer), so D is the best choice of these options.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      95,
      96,
      641,
      94,
      593
    ],
    "source": ""
  },
  {
    "id": 1068,
    "question": "You are the security manager for a small retail business involved mainly in direct e-commerce transactions with individual customers (members of the public). The bulk of your market is in Asia, but you do fulfill orders globally. Your company has its own data center located within its headquarters building in Hong Kong, but it also uses a public cloud environment for contingency backup and archiving purposes. Your cloud provider is changing its business model at the end of your contract term, and you have to find a new provider. In choosing providers, which tier of the Uptime Institute rating system should you be looking for, if minimizing cost is your ultimate goal?",
    "choice_a": "1",
    "choice_b": "3",
    "choice_c": "4",
    "choice_d": "8",
    "correct_answer": "A",
    "explanation": "For the purposes described in the question, a Tier 1 data center should suffice; it is the cheapest, and you need it only for occasional backup purposes (as opposed to constant access). The details of location and market are irrelevant.<br>Tiers 3 and 4 would be much more expensive, and they are not necessary for your business purposes; options B and C are thus incorrect. <br>There is no Tier 8 in the Uptime Institute system.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      95,
      96,
      113,
      110,
      323
    ],
    "source": ""
  },
  {
    "id": 1069,
    "question": "You are the security manager for a small retail business involved mainly in direct e-commerce transactions with individual customers (members of the public). The bulk of your market is in Asia, but you do fulfill orders globally. Your company has its own data center located within its headquarters building in Hong Kong, but it also uses a public cloud environment for contingency backup and archiving purposes. Your cloud provider is changing its business model at the end of your contract term, and you have to find a new provider. In choosing providers, which of the following functionalities will you consider absolutely essential?",
    "choice_a": "Distributed denial-of-service (DDoS) protections",
    "choice_b": "Constant data mirroring",
    "choice_c": "Encryption",
    "choice_d": "Hashing",
    "correct_answer": "C",
    "explanation": "If your company is involved in e-commerce, you are most likely using credit cards for online transactions; if you\u2019re using credit cards, you are almost certainly constrained by Payment Card Industry Data Security Standard (PCI DSS) or one of the other contractual standards like it. Because of this, you will be required to encrypt or tokenize all stored cardholder data, and for long-term storage, encryption is the cheaper, more durable process. <br>DDoS and mirroring are availability protections, and availability is not your company\u2019s main concern for cloud services from the question description; long-term storage is not focused on availability. Options A and B are thus incorrect. <br>Hashing is an integrity protection, and though hashes may be useful in this case (to determine whether stored data is accurate), they won\u2019t be as important as compliance with credit card standards. Option C is the preferable answer compared to D.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      113,
      101,
      96,
      110,
      108
    ],
    "source": ""
  },
  {
    "id": 1070,
    "question": "You are the security manager for a small retail business involved mainly in direct e-commerce transactions with individual customers (members of the public). The bulk of your market is in Asia, but you do fulfill orders globally. Your company has its own data center located within its headquarters building in Hong Kong, but it also uses a public cloud environment for contingency backup and archiving purposes. Which of the following standards are you most likely to adopt?",
    "choice_a": "National Institute of Standards and Technology (NIST) 800-37",
    "choice_b": "General Data Protection Regulation (GDPR)",
    "choice_c": "ISO 27001",
    "choice_d": "Sarbanes\u2013Oxley Act (SOX)",
    "correct_answer": "C",
    "explanation": "ISO is the only truly international standard on this list of choices; all the rest are either American laws or standards (options A and D) or European (option B).",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      113,
      110,
      96,
      588,
      594
    ],
    "source": ""
  },
  {
    "id": 1071,
    "question": "You are the security manager for a small retail business involved mainly in direct e-commerce transactions with individual customers (members of the public). The bulk of your market is in Asia, but you do fulfill orders globally. Your company has its own data center located within its headquarters building in Hong Kong, but it also uses a public cloud environment for contingency backup and archiving purposes. Your company has decided to expand its business to include selling and monitoring life-support equipment for medical providers. What characteristic do you need to ensure is offered by your cloud provider?",
    "choice_a": "Full automation of security controls within the cloud data center",
    "choice_b": "Tier 4 of the Uptime Institute certifications",
    "choice_c": "Global remote access",
    "choice_d": "Prevention of ransomware infections",
    "correct_answer": "B",
    "explanation": "The changing nature of your business will require a much more stringent set of operating standards, to include an increase in Uptime Institute tier levels; because you\u2019re no longer just using the cloud for backup and long-term storage and are now using it in direct support of health and human safety, Tier 4 is required. <br>Fully automated security controls are useful from the provider\u2019s perspective (allowing more profitability and scalability), but this is not a major concern of the customer. Option A is incorrect. <br>Global remote access and reducing the risk of malware infections (to include ransomware) are basic functions of almost all cloud providers; these functions aren\u2019t useful discriminators when choosing cloud providers because all cloud providers have them. Options C and D are thus incorrect.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      110,
      113,
      96,
      95,
      94
    ],
    "source": ""
  },
  {
    "id": 1072,
    "question": "When designing a cloud data center, which of the following aspects is <italic>not</italic> necessary to ensure continuity of operations during contingency operations?",
    "choice_a": "Access to clean water",
    "choice_b": "Broadband data connection",
    "choice_c": "Extended battery backup",
    "choice_d": "Physical access to the data center",
    "correct_answer": "C",
    "explanation": "Backup power does not have to be delivered by batteries; it can be fed to the data center through redundant utility lines or from a generator. <br>All the other elements are necessary for safe and secure data center operations, for both the personnel and the equipment within the data center.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      95,
      588,
      589,
      593,
      594
    ],
    "source": ""
  },
  {
    "id": 1073,
    "question": "You are the security manager for a small surgical center. Your organization is reviewing upgrade options for its current, on-premises data center. In order to best meet your needs, which one of the following options would you recommend to senior management?",
    "choice_a": "Building a completely new data center",
    "choice_b": "Leasing a data center that is currently owned by another firm",
    "choice_c": "Renting private cloud space in a Tier 2 data center",
    "choice_d": "Staying with the current data center",
    "correct_answer": "A",
    "explanation": "This answer is mostly arrived at through a process of elimination. <br>Option B is not optimum because of potential for vendor lock-in, restrictions on buildout, and privacy concerns. <br>Option C is not optimum because Tier 2 is not sufficient for medical uses. <br>Option D is not optimum because there was obviously a reason to consider a new option. <br>We are therefore left with option A, which is the most expensive of the choices but allows the greatest amount of control and security.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      636,
      638,
      95,
      108,
      333
    ],
    "source": ""
  },
  {
    "id": 1074,
    "question": "When building a new data center within an urban environment, which of the following is probably the <italic>most</italic> restrictive aspect?",
    "choice_a": "The size of the plot",
    "choice_b": "Utility availability",
    "choice_c": "Staffing",
    "choice_d": "Municipal codes",
    "correct_answer": "D",
    "explanation": "In any large metropolitan area, government restrictions on development and construction can severely limit how you use your property; this can be a significant limiting factor in building a data center. <br>The size of the plot may or may not matter, depending on if you are allowed to build up or dig down to make use of additional space\u2014these options will be limited by municipal building codes, so option D is preferable to option A. <br>Utilities and personnel are usually easy to acquire in an urban setting, so options B and C are incorrect.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      591,
      588,
      323,
      636,
      94
    ],
    "source": ""
  },
  {
    "id": 1075,
    "question": "When you are building a new data center in a rural setting, which of the following is probably the <italic>most</italic> restrictive aspect?",
    "choice_a": "Natural disasters",
    "choice_b": "Staffing",
    "choice_c": "Availability of emergency services",
    "choice_d": "Municipal codes",
    "correct_answer": "C",
    "explanation": "In a rural location, the positioning and depth of first responders (fire, law enforcement, paramedics, etc.) may be severely limited in comparison to an urban setting. <br>Natural disasters affect all locations, rural or urban, so a rural setting is not any more or less limiting in planning accordingly; option A is incorrect. <br>Oddly enough, because of the very limited need for personnel within modern data centers with significant automation, recruiting and placing the number of people necessary to serve the purpose should not be too difficult; option B is not correct. <br>One of the appeals of a rural setting is that building codes are often rudimentary or nonexistent. Option D is incorrect.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      590,
      591,
      95,
      636,
      628
    ],
    "source": ""
  },
  {
    "id": 1076,
    "question": "All tiers of the Uptime Institute standards for data centers require ___________________ hours of on-site generator fuel.",
    "choice_a": "6",
    "choice_b": "10",
    "choice_c": "12",
    "choice_d": "15",
    "correct_answer": "C",
    "explanation": "All the other options are incorrect.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      588,
      594,
      592,
      587,
      586
    ],
    "source": ""
  },
  {
    "id": 1077,
    "question": "The American Society of Heating, Refrigeration, and Air Conditioning Engineers (ASHRAE) guidelines for internal environmental conditions within a data center suggest that a temperature setting of ___________________ degrees (F) would be too high.",
    "choice_a": "93",
    "choice_b": "80",
    "choice_c": "72",
    "choice_d": "32",
    "correct_answer": "A",
    "explanation": "The range suggested by the ASHRAE Technical Committee 9.9 is 64 to 81 degrees Fahrenheit. All the other options are distractors (although D is particularly distracting, because it is <italic>lower</italic> than the recommended range, but that is not what the question is asking).",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      592,
      594,
      597,
      95,
      94
    ],
    "source": ""
  },
  {
    "id": 1078,
    "question": "Internal data center conditions that exceed the American Society of Heating, Refrigeration, and Air Conditioning Engineers (ASHRAE) guidelines for humidity could lead to an increase of the potential for all of the following <italic>except</italic> ___________________.",
    "choice_a": "Biological intrusion",
    "choice_b": "Electrical shorting",
    "choice_c": "Corrosion/oxidation",
    "choice_d": "Social engineering",
    "correct_answer": "D",
    "explanation": "Being damp does not make people more susceptible to trickery. <br>Moisture in the air can, however, create mold/mildew, short circuits, and rust; so all the other options are incorrect.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      592,
      597,
      596,
      95,
      94
    ],
    "source": ""
  },
  {
    "id": 1079,
    "question": "Setting thermostat controls by measuring the ___________________ temperature will result in the highest energy costs.",
    "choice_a": "Server inlet",
    "choice_b": "Return air",
    "choice_c": "Under-floor",
    "choice_d": "External ambient",
    "correct_answer": "B",
    "explanation": "The return air temperature will be slightly higher than anywhere else inside the data center because the air has been warmed by passing through the equipment (thus cooling the equipment but warming the air). Using this as a temperature set point will result in much cooler air feeding the server inlets, which takes more energy, which will be more expensive. <br>Options A and C are incorrect because that air is already cold; using these locations as set points will not consume as much energy and may result in somewhat warmer air entering the servers. This will be less expensive than option B. <br>Option D is an outlying distractor; if you set your heating, ventilation, and air conditioning (HVAC) controls to respond to the temperature outside the data center, your HVAC units are responding to temperatures that have nothing to do with the internal environment. In effect, you\u2019d be trying to adjust the temperature of the outside world, which is ridiculous.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      597,
      592,
      594,
      596,
      598
    ],
    "source": ""
  },
  {
    "id": 1080,
    "question": "Heating, ventilation, and air conditioning (HVAC) systems cool the data center by pushing warm air into___________________.",
    "choice_a": "The server inlets",
    "choice_b": "Underfloor plenums",
    "choice_c": "HVAC intakes",
    "choice_d": "The outside world",
    "correct_answer": "D",
    "explanation": "The HVAC system is a heat exchange, swapping warm internal air from the data center to the outside world and drawing fresh air through the HVAC chillers to feed the internal environment. <br>All the other options are incorrect because they will have the opposite effect by pushing warm air into those areas that cools air is supposed to be.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      595,
      587,
      593,
      586,
      592
    ],
    "source": ""
  },
  {
    "id": 1081,
    "question": "It is important to include ___________________ in the design of underfloor plenums if they are also used for wiring.",
    "choice_a": "Mantraps",
    "choice_b": "Sequestered channels",
    "choice_c": "Heat sinks",
    "choice_d": "Tight gaskets",
    "correct_answer": "D",
    "explanation": "When cables come up through a raised floor used as a cold air feed, we don\u2019t want cold air bleeding around the cables in an unplanned manner; this can cause inefficiencies in airflow control. Gaskets are required at all points where cable comes through the floor, to restrict airflow and reduce the possibility of cold air escaping. <br>All the other options are incorrect because we want to minimize obstructions in underfloor plenums we use for airflow. Options A, B, and C do not accomplish this.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      596,
      595,
      586,
      593,
      597
    ],
    "source": ""
  },
  {
    "id": 1082,
    "question": "Cable management includes all of the following <italic>except</italic> __________________.",
    "choice_a": "Tagging cables",
    "choice_b": "Removing unused/obsolete cables",
    "choice_c": "Banding and bundling cables",
    "choice_d": "Removing unused machines",
    "correct_answer": "D",
    "explanation": "While minimizing equipment in the operational environment can aid in many efforts, including cable management, it is not strictly an aspect of cable management, so this is the best choice from those available. All the other options are definitely aspects of cable management.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      596,
      611,
      615,
      94,
      606
    ],
    "source": ""
  },
  {
    "id": 1083,
    "question": "How often should cable management efforts take place?",
    "choice_a": "Annually",
    "choice_b": "Continually",
    "choice_c": "Quarterly",
    "choice_d": "Weekly",
    "correct_answer": "B",
    "explanation": "Cable management is an ongoing process. All the other options are incorrect because they are time based intervals rather than continuous.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      107,
      602,
      601,
      598,
      108
    ],
    "source": ""
  },
  {
    "id": 1084,
    "question": "You are designing a private cloud data center for an insurance underwriter, to be located in a major metropolitan area. Which of the following airflow management schemes is preferable?",
    "choice_a": "Hot aisle",
    "choice_b": "Cold aisle",
    "choice_c": "Either hot aisle or cold aisle",
    "choice_d": "Free flow",
    "correct_answer": "C",
    "explanation": "It shouldn\u2019t matter which design you use as long as airflow is managed. Neither hot nor cold aisle containment is preferable to the other, so options A and B are incorrect. Airflow does need to be managed, though, so option D is incorrect as well.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      593,
      587,
      595,
      597,
      594
    ],
    "source": ""
  },
  {
    "id": 1085,
    "question": "Which of the following factors will probably have the <italic>most</italic> impact on the cost of running your heating, ventilation, and air conditioning (HVAC) systems?",
    "choice_a": "Whether you choose hot or cold aisle containment",
    "choice_b": "The external ambient environment",
    "choice_c": "The initial cost of the HVAC systems",
    "choice_d": "Proper cable maintenance",
    "correct_answer": "B",
    "explanation": "This is a difficult question because almost all of the options are true\u2014they will all have an effect on the cost of running HVAC systems. <br>Because HVAC operates as a heat exchange, the outside environment will dictate how much power is needed to force warm air out of the data center. The warmer the climate in the location of the data center, the more energy it will take to exchange the heat, and the more costly the HVAC operation. This is the most significant factor. <br>Option A is incorrect and it is the only choice that does not affect energy costs; hot and cold aisle containment should be equivalent in terms of operational costs. <br>The initial cost of the HVAC units themselves will probably have an effect on operational costs because better equipment will cost more money, but it will also be more efficient and therefore less expensive to operate than cheaper alternatives. However, the effect still won\u2019t be as significant as the external climate, so option C is still not as good as option B. <br>Good cable management will make airflow more efficient and therefore make HVAC less expensive, but this will not be as dramatic in impact on operating costs as the external environment. Once again, option B is preferable to option D.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      593,
      587,
      597,
      595,
      94
    ],
    "source": ""
  },
  {
    "id": 1086,
    "question": "You are designing a Tier 4 data center for a large hospital. In order to plan for the possibility of losing utility power, in addition to having sufficient generators, you should plan to locate the data center ___________________.",
    "choice_a": "In an urban setting",
    "choice_b": "In a rural environment",
    "choice_c": "Near a coast",
    "choice_d": "At the border of different counties, regions, or states",
    "correct_answer": "D",
    "explanation": "Usually, different political regions are served by different utility providers; placing your data center on such a boundary may make it feasible to have redundant, overlapping power providers. <br>Municipalities typically limit selection of power providers by granting an artificial monopoly to a single provider; option A is incorrect. <br>Rural settings are often only served by a single provider because the demand is not sufficient to support competition; option B is incorrect. <br>Coasts do not affect the availability of multiple power providers; option C is a distractor.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      589,
      588,
      590,
      95,
      94
    ],
    "source": ""
  },
  {
    "id": 1087,
    "question": "Because most cloud environments rely heavily on virtualization, it is important to lock down or harden the virtualization software, or any software involved in virtualization. Which of the following is <italic>not</italic> an element of hardening software?",
    "choice_a": "Removing unused services and libraries",
    "choice_b": "Maintaining a strict license catalog",
    "choice_c": "Patching and updating as necessary",
    "choice_d": "Removing default accounts",
    "correct_answer": "B",
    "explanation": "While maintaining a library of software licenses is important, it is not part of the practice we ordinarily consider \u201chardening.\u201d <br>The other options are all aspects of software hardening.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      104,
      102,
      103,
      108,
      107
    ],
    "source": ""
  },
  {
    "id": 1088,
    "question": "Which of the following is <italic>not</italic> an aspect of host hardening?",
    "choice_a": "Removing all unnecessary software and services",
    "choice_b": "Patching and updating as needed",
    "choice_c": "Performing more frequent and thorough audits on the host",
    "choice_d": "Installing a host-based firewall and an intrusion detection system (IDS)",
    "correct_answer": "C",
    "explanation": "Audits usually aren\u2019t considered an element of hardening. Hardening is the process of provisioning a specific element (in this case, a host) against attack. Audits don\u2019t protect against attack; they only detect and direct response to attacks. <br>All the other options are aspects of host hardening.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      104,
      99,
      111,
      112,
      333
    ],
    "source": ""
  },
  {
    "id": 1089,
    "question": "Which of the following is <italic>not</italic> an element of ongoing configuration maintenance?",
    "choice_a": "Penetration tests of guest OSs and hosts",
    "choice_b": "Social engineering tests of all users",
    "choice_c": "Patch management of guest OSs, hosts, and applications",
    "choice_d": "Vulnerability scans of guest OSs and hosts",
    "correct_answer": "B",
    "explanation": "Users are not an aspect of configuration management. <br>All the other options are elements of secure configuration management.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      606,
      604,
      605,
      331,
      316
    ],
    "source": ""
  },
  {
    "id": 1090,
    "question": "Storage controllers will be used in conjunction with all the following protocols <italic>except</italic> ___________________.",
    "choice_a": "HTTPS",
    "choice_b": "Internet Small Computer Systems Interface (iSCSI)",
    "choice_c": "Fibre Channel",
    "choice_d": "Fibre Channel over Ethernet",
    "correct_answer": "A",
    "explanation": "HTTPS is not a storage protocol. All the other options are.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      608,
      607,
      609,
      598,
      108
    ],
    "source": ""
  },
  {
    "id": 1091,
    "question": "Which of these characteristics of a virtualized network adds risks to the cloud environment?",
    "choice_a": "Redundancy",
    "choice_b": "Scalability",
    "choice_c": "Pay-per-use",
    "choice_d": "Self-service",
    "correct_answer": "B",
    "explanation": "Virtual switches are widely used in virtualized networks. Unlike physical switches, which only lose one connection if a connecting cable is lost, virtual switches can be connected to multiple virtual machines via a single cable; if a cable is lost in a virtualized network, that can affect tens or dozens of devices. In this context, the benefits offered by scalability come with attendant risks. <br>The other options are characteristics that don\u2019t cause additional risk to the environment; in fact, redundancy reduces risk.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      105,
      94,
      97,
      615,
      307
    ],
    "source": ""
  },
  {
    "id": 1092,
    "question": "Security best practices in a virtualized network environment would include which of the following?",
    "choice_a": "Using distinct ports and port groups for various virtual local area networks (VLANs) on a virtual switch rather than running them through the same port",
    "choice_b": "Running Internet Small Computer Systems Interface (iSCSI) traffic unencrypted in order to have it observed and monitored by a network intrusion detection system (NIDS)",
    "choice_c": "Adding a host-based intrusion detection system (HIDS) to all virtual guests",
    "choice_d": "Hardening all outward-facing firewalls in order to make them resistant to attack",
    "correct_answer": "A",
    "explanation": "It is possible to route multiple VLANs through a switch port (physical or virtual) with proper frame tagging. However, to optimize isolation of subnets and processes in a virtual network environment, it is better to use different ports instead. <br> iSCSI traffic should be encrypted as another layer of defense within the environment; option B is wrong. <br>HIDSs may or may not be cost-effective, depending on the value and sensitivity of the data on each guest; the additional overhead may not justify their use. Option C is incorrect. <br>Firewalls should be hardened regardless of the nature of the network whether virtual or physical.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      105,
      104,
      97,
      613,
      108
    ],
    "source": ""
  },
  {
    "id": 1093,
    "question": "To enhance virtual environment isolation and security, a best practice is to ___________________.",
    "choice_a": "Ensure that all virtual switches are not connected to the physical network",
    "choice_b": "Ensure that management systems are connected to a different physical network than the production systems",
    "choice_c": "Never connect a virtual switch to a physical host",
    "choice_d": "Connect physical devices only with virtual switches",
    "correct_answer": "B",
    "explanation": "The management systems control the entirety of the virtual environment and are therefore extremely valuable and need to be protected accordingly. When possible, isolating those management systems, both physically and virtually, is optimum. <br>All the other options are incorrect because they imply that virtual and physical cannot coexist when in fact they need to coexist to work correctly.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      108,
      107,
      610,
      105,
      598
    ],
    "source": ""
  },
  {
    "id": 1094,
    "question": "Which of the following is a risk that stems from a virtualized environment?",
    "choice_a": "Live virtual machines in the production environment are moved from one host to another in the clear.",
    "choice_b": "Cloud data centers can become a single point of failure.",
    "choice_c": "It is difficult to find and contract with multiple utility providers of the same type (electric, water, etc.).",
    "choice_d": "Modern service level-agreement (SLA) demands are stringent and very hard to meet.",
    "correct_answer": "A",
    "explanation": "When an active virtual machine is moved from a given host to another (for instance, when the host is going into maintenance state), it is passed along the network without encryption. Theoretically, an insider threat observing the line along which the virtual machine is moving could capture/copy it in its entirety. <br>All the other options are not risks specific to a virtualized environment and are therefore incorrect.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      105,
      107,
      112,
      94,
      97
    ],
    "source": ""
  },
  {
    "id": 1095,
    "question": "Which of the following is a risk that stems from a pooled-resources environment?",
    "choice_a": "Loss of data to widespread phishing attacks",
    "choice_b": "Loss of availability due to widespread distributed denial-of-service (DDoS) attacks",
    "choice_c": "Loss of data to widespread insider threat",
    "choice_d": "Loss of data to law enforcement seizure of neighboring assets",
    "correct_answer": "D",
    "explanation": "In a pooled environment, law enforcement may acquire physical or logical assets (drives, data stores, etc.) that include your organization\u2019s data, even if your organization was not the target of the investigation. <br>All the other options are not risks due to pooled resources; they exist in all environments. These options are not correct.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      613,
      615,
      95,
      96,
      610
    ],
    "source": ""
  },
  {
    "id": 1096,
    "question": "Modern managed cloud service providers will often use secure keyboard/video/mouse (KVM) devices within their data centers. These devices are extremely expensive compared to their non-secured counterparts. Which of the following is one of the reasons cloud service providers do this?",
    "choice_a": "They have plenty of revenue and can afford it.",
    "choice_b": "They have invested heavily in the secure KVM market.",
    "choice_c": "Cloud data centers need very few of these devices.",
    "choice_d": "Managed cloud providers often manufacture their own devices as well.",
    "correct_answer": "C",
    "explanation": "The cost of each device is spread across many machines in the data center; unlike a desktop-based environment, where every user and every machine need their own KVM setup, just a few devices can serve an entire data center. <br>While the cloud provider may generate a great deal of revenue, no company likes to throw away money unnecessarily; option A is incorrect. <br>Cloud providers are not typically invested in KVM vendors. Option B is incorrect. <br>Option D is simply incorrect.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      95,
      615,
      306,
      304,
      305
    ],
    "source": ""
  },
  {
    "id": 1097,
    "question": "The American Society of Heating, Refrigeration, and Air Conditioning Engineers (ASHRAE) guidelines for internal environmental conditions within a data center suggest that a temperature setting of ___________________degrees (F) would be too low.",
    "choice_a": "93",
    "choice_b": "80",
    "choice_c": "72",
    "choice_d": "32",
    "correct_answer": "D",
    "explanation": "The range suggested by the ASHRAE Technical Committee 9.9 is 64 to 81 degrees Fahrenheit. All the other options are incorrect (although A is particularly distracting, because it is <italic>higher</italic> than the recommended range, but that is not what the question is asking).",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      592,
      594,
      597,
      95,
      94
    ],
    "source": ""
  },
  {
    "id": 1098,
    "question": "Modern managed cloud service providers will often use secure keyboard/video/mouse (KVM) devices within their data centers. These devices are extremely expensive compared to their non-secured counterparts. Which of the following is one of the reasons cloud service providers do this?",
    "choice_a": "The risk of transferring data from one customer to another is significant.",
    "choice_b": "The risk of devices leaving the cloud data center is significant.",
    "choice_c": "It makes physical inventories much easier to maintain.",
    "choice_d": "Audit purposes",
    "correct_answer": "A",
    "explanation": "Secure KVMs support drastically isolated operations; they cut down on the possibility of data being inadvertently shared from one customer to another. <br>Option B is incorrect because devices will not leave the cloud data center simply because they are not managed by secure KVMs. <br>Option C is incorrect because using secure KVMs will not have an effect on physical inventories. <br>Option D does contain enough information to be the correct answer. \u201cAudit purposes\u201d is ambiguous.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      305,
      304,
      95,
      96,
      99
    ],
    "source": ""
  },
  {
    "id": 1099,
    "question": "A truly air-gapped machine selector will ___________________.",
    "choice_a": "Terminate a connection before creating a new connection",
    "choice_b": "Be made of composites and not metal",
    "choice_c": "Have total Faraday properties",
    "choice_d": "Not be portable",
    "correct_answer": "A",
    "explanation": "Referred to as \u201cbreak before make,\u201d these devices often take the form of manual pushbutton controls; as the button is pushed, the current connection is forced to physically separate, and when the button is fully engaged, the new connection is made. <br>Options B and C have more to do with risks of electromagnetic emanations than with air-gapped selectivity; even air-gapped devices can leak data through emanations. <br>Option D is incorrect because portability is not a property we seek in device selectors.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      610,
      611,
      98,
      94,
      597
    ],
    "source": ""
  },
  {
    "id": 1100,
    "question": "Which of the following cloud data center functions do <italic>not</italic> have to be performed on isolated networks?",
    "choice_a": "Customer access provision",
    "choice_b": "Management system control interface",
    "choice_c": "Storage controller access",
    "choice_d": "Customer production activities",
    "correct_answer": "D",
    "explanation": "The production activities will make full use of pooled resources, so they will not be isolated (unless the customer is paying for that specific characteristic of service). <br>All the other options are functions that should take place on isolated networks/segments.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      613,
      614,
      615,
      94,
      107
    ],
    "source": ""
  },
  {
    "id": 1101,
    "question": "Which of the following is <italic>not</italic> a characteristic of a virtual local area network (VLAN)?",
    "choice_a": "Broadcast packets sent by a machine inside the VLAN will reach all other machines in that VLAN.",
    "choice_b": "Broadcast packets sent from outside the VLAN will not reach other machines outside the VLAN.",
    "choice_c": "Broadcast packets sent from a machine outside the VLAN will not reach machines inside the VLAN.",
    "choice_d": "Broadcast packets sent by a machine inside the VLAN will not reach machines outside the VLAN.",
    "correct_answer": "B",
    "explanation": "Broadcast packets sent by machines outside the VLAN will reach machines outside the VLAN that are on the same network/segment. <br>All the other options are characteristics of a VLAN.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      97,
      94,
      105,
      96,
      95
    ],
    "source": ""
  },
  {
    "id": 1102,
    "question": "In order for communications from inside a virtual local area network (VLAN) to reach endpoints outside the VLAN, ___________________.",
    "choice_a": "The communications must go through a gateway",
    "choice_b": "The traffic must be encrypted",
    "choice_c": "A repeater must be used",
    "choice_d": "The external endpoint must be in receive mode",
    "correct_answer": "A",
    "explanation": "Gateway devices enforce the VLAN rules and can allow or deny outbound traffic. <br>Communications traffic from a VLAN may or may not be encrypted; option B is incorrect. <br>Repeaters are used to enhance signals along a line over a certain distance; they have nothing to do with VLANs. Option C is incorrect. <br>Option D makes no sense in this context.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      97,
      98,
      94,
      105,
      613
    ],
    "source": ""
  },
  {
    "id": 1103,
    "question": "Transport Layer Security (TLS) uses ___________________ to authenticate a connection and create a shared secret for the duration of the session.",
    "choice_a": "Security Assertion Markup Language (SAML) 2.0",
    "choice_b": "X.509 certificates",
    "choice_c": "802.11X",
    "choice_d": "The Diffie-Hellman process",
    "correct_answer": "B",
    "explanation": "TLS uses X.509 certificates to establish a connection and create a symmetric key that lasts for only one session. <br>SAML is used for federation authentication/identification; option A is incorrect. <br>802.11 is the suite of wireless standards; option C is incorrect. <br>Diffie-Hellman uses asymmetric key pairs to create a symmetric key; option D is incorrect.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      100,
      103,
      108,
      94,
      598
    ],
    "source": ""
  },
  {
    "id": 1104,
    "question": "Halon is now illegal to use for data center fire suppression. What is the reason it was outlawed?",
    "choice_a": "It poses a threat to health and human safety when deployed.",
    "choice_b": "It can harm the environment.",
    "choice_c": "It does not adequately suppress fires.",
    "choice_d": "It causes undue damage to electronic systems.",
    "correct_answer": "B",
    "explanation": "This question is an outlier because it is one of the few such questions where the answer is <italic>not</italic> that it poses a threat to health and human safety (although, in fact, it does; option A is true, but incorrect). Halon was not prohibited because of this property. Halon was outlawed because it, like other CFCs (chlorofluorocarbons), was blamed for depleting the earth\u2019s ozone layer. Halon is still allowed in some very specialized cases (such as fire-suppression systems on aircraft), but this is an exception. <br>Options C and D are incorrect and untrue.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 1105,
    "question": "When cloud computing professionals use the term <italic>ping, power, pipe</italic>, which of the following characteristics is <italic>not</italic> being described?",
    "choice_a": "Logical connectivity",
    "choice_b": "Human interaction",
    "choice_c": "Electricity",
    "choice_d": "Heating, ventilation, and air conditioning (HVAC)",
    "correct_answer": "B",
    "explanation": "User interaction with the cloud is not described in this term. All the other options are characteristics of cloud computing mentioned in <italic>ping, power, pipe</italic>.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      94,
      95,
      615,
      598,
      97
    ],
    "source": ""
  },
  {
    "id": 1106,
    "question": "Which of the following is <italic>not</italic> a goal of a site survey?",
    "choice_a": "Threat definition",
    "choice_b": "Target identification",
    "choice_c": "Penetration testing",
    "choice_d": "Facility characteristics",
    "correct_answer": "C",
    "explanation": "The penetration test is not part of the site survey, which is one of the initial steps in securing/auditing a facility. The penetration test will, however, probably make use of the site survey information later. <br>All the other options are goals of the site survey.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      617,
      616,
      618,
      106,
      636
    ],
    "source": ""
  },
  {
    "id": 1107,
    "question": "Designing system redundancy into a cloud data center allows all the following capabilities <italic>except</italic> ___________________.",
    "choice_a": "Incorporating additional hardware into the production environment",
    "choice_b": "Preventing any chance of service interruption",
    "choice_c": "Load-sharing/balancing",
    "choice_d": "Planned, controlled failover during contingency operations",
    "correct_answer": "B",
    "explanation": "There is no such thing as zero risk; there will always be <italic>some</italic> chance of service interruption, no matter how minimized. <br>All the other options are capabilities allowed by redundancy.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      589,
      588,
      333,
      636,
      307
    ],
    "source": ""
  },
  {
    "id": 1108,
    "question": "Gaseous fire suppression systems that function by displacing oxygen need to be installed in conjunction with ___________________.",
    "choice_a": "Water cooling",
    "choice_b": "Filters",
    "choice_c": "Occupant training",
    "choice_d": "Failsafe or \u201clast person out\u201d switches",
    "correct_answer": "D",
    "explanation": "Before flooding an enclosed space with a gas that will displace oxygen, it is important to ensure that all personnel are out of the area. While this requires personnel training, such training is ineffective without a system to support this capability. Option C is true, but not as accurate as option D. <br>Options A and B are incorrect because they do not make senses given the question is about a system that displaces oxygen in the facility.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      315,
      314,
      328,
      445,
      636
    ],
    "source": ""
  },
  {
    "id": 1109,
    "question": "What aspect of data center planning occurs first?",
    "choice_a": "Logical design",
    "choice_b": "Physical design",
    "choice_c": "Audit",
    "choice_d": "Policy revision",
    "correct_answer": "A",
    "explanation": "The logical design should come before the physical design; function dictates form. Audit and revision come after creation.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      588,
      589,
      643,
      644,
      602
    ],
    "source": ""
  },
  {
    "id": 1110,
    "question": "Which of the following are <italic>not</italic> examples of personnel controls?",
    "choice_a": "Background checks",
    "choice_b": "Reference checks",
    "choice_c": "Strict access control mechanisms",
    "choice_d": "Continuous security training",
    "correct_answer": "C",
    "explanation": "While physical controls that inhibit movement affect personnel, they are not regarded as personnel controls. All the other options are examples of personnel controls.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      612,
      610,
      611,
      95,
      600
    ],
    "source": ""
  },
  {
    "id": 1111,
    "question": "Updating virtual machine management tools will require ___________________.",
    "choice_a": "An infusion of capital",
    "choice_b": "An alternate data center",
    "choice_c": "Sufficient redundancy",
    "choice_d": "Peer review",
    "correct_answer": "C",
    "explanation": "Because updating the virtualization toolset may require server downtime, it is essential to have a sufficient amount of redundant machines to roll out the update over the environment without significant disruption of operations. <br>Option A assumes that there isn\u2019t already enough of whatever the infusion of capital will purchase. Option A is incorrect. <br>Thankfully, option B is incorrect. It would be costly to obtain an alternate data center each time the virtual machine management tools are updated. <br>Peer review is not required when updating virtual machine management tools. Option D is incorrect.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      107,
      602,
      108,
      318,
      606
    ],
    "source": ""
  },
  {
    "id": 1112,
    "question": "Access control to virtualization management tools should be ___________________.",
    "choice_a": "Rule-based",
    "choice_b": "Role-based",
    "choice_c": "User-based",
    "choice_d": "Discretionary",
    "correct_answer": "B",
    "explanation": "It is important to limit access to the virtualization toolset to those administrators, engineers, and architects who are vital for supporting the virtualized environment and nobody else. <br>The other options are incorrect because they do not restrict access to the virtualization management tool set as specifically as role-based access control does. If someone\u2019s role changes and they no longer require access, then their access should be terminated.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      600,
      603,
      108,
      598,
      313
    ],
    "source": ""
  },
  {
    "id": 1113,
    "question": "Before deploying a specific brand of virtualization toolset, it is important to configure it according to ___________________.",
    "choice_a": "Industry standards",
    "choice_b": "Prevailing law of that jurisdiction",
    "choice_c": "Vendor guidance",
    "choice_d": "Expert opinion",
    "correct_answer": "C",
    "explanation": "Toolset vendors will specify secure configurations of their products; these must be followed in order to fulfill due care requirements. <br>Standards and laws don\u2019t usually specify builds for products or brands, so options A and B are incorrect. <br>Expert opinion, while useful, is not sufficient to demonstrate due care in many cases; option D is not the best response.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      108,
      102,
      323,
      333,
      110
    ],
    "source": ""
  },
  {
    "id": 1114,
    "question": "Which of the following is essential for getting full security value from your system baseline?",
    "choice_a": "Personnel training",
    "choice_b": "Documentation",
    "choice_c": "Host-based intrusion detection system (HIDS)",
    "choice_d": "Encryption",
    "correct_answer": "B",
    "explanation": "In order to understand, optimize, and re-create your secure baseline, proper and full documentation is absolutely essential. <br>Personnel training is important for secure system use, but it is not an element of baselining. Option A is incorrect. <br>A secure baseline for a given system may include HIDS and/or encryption, but they are not essential elements, so options C and D are incorrect.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      331,
      332,
      333,
      104,
      262
    ],
    "source": ""
  },
  {
    "id": 1115,
    "question": "Which of the following is essential for getting full security value from your system baseline?",
    "choice_a": "Capturing and storing an image of the baseline",
    "choice_b": "Keeping a copy of upcoming suggested modifications to the baseline",
    "choice_c": "Having the baseline vetted by an objective third party",
    "choice_d": "Using a baseline from another industry member so as not to engage in repetitious efforts",
    "correct_answer": "A",
    "explanation": "An image of the baseline should be stored securely, preferably in more than one location (to include the archive, the disaster kit, and any alternate site, to name a few). It is essential to have a copy on hand for reconstructing the environment during contingency operations, and it is also useful for audit/review purposes. <br>Option B is incorrect because planned modifications are not yet part of the actual baseline. <br>Option C may be a good answer in some situations; however, it is not essential, and option A is still a better answer. <br>Option D is incorrect because every environment (and, therefore, the baseline used in that environment) should be exclusively tailored for the organization using that environment.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      104,
      333,
      111,
      401,
      108
    ],
    "source": ""
  },
  {
    "id": 1116,
    "question": "Patching can be viewed as a configuration modification and therefore subject to the organization\u2019s configuration management program and methods. What may also be an aspect of patching in terms of configuration management?",
    "choice_a": "Patching doesn\u2019t need to be performed as a distinct effort; patching can go through the normal change request process like all other modifications.",
    "choice_b": "Any patches suggested or required by vendors to maintain compliance with service contracts must be made immediately, regardless of internal process restrictions.",
    "choice_c": "Any patches suggested by third parties should not be considered as they may invalidate service contracts or warranties and negatively affect the organization\u2019s security posture.",
    "choice_d": "The configuration or change management committee or board may grant blanket approval for patches (at a certain impact level) without the need to go through the formal change process.",
    "correct_answer": "D",
    "explanation": "In order to ensure timely application of patches, patching may receive blanket approval and only be reviewed by the committee or board after the fact for final approval. <br>Requiring normalized processing for patching may delay patching and expose the organization to undue risk; option A is thus incorrect. <br>Patching still needs to involve testing and confirmation to avoid interoperability and additional security problems, making option B incorrect. <br>Third parties can identify security problems as well as vendors; external patches need to be considered as well as vendor patches. Option C is thus incorrect.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      316,
      606,
      318,
      604,
      623
    ],
    "source": ""
  },
  {
    "id": 1117,
    "question": "Clustering hosts allows you to do all the following <italic>except</italic> ___________________.",
    "choice_a": "Meet high-availability demands",
    "choice_b": "Optimize performance with load balancing",
    "choice_c": "Enhance scalability",
    "choice_d": "Apply updates, patches, or configuration modifications instantly",
    "correct_answer": "D",
    "explanation": "Clustering does not preclude the time and diligence necessary to perform patching or updates. <br>All the other options are attributes provided by host clustering.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      619,
      317,
      318,
      102,
      107
    ],
    "source": ""
  },
  {
    "id": 1118,
    "question": "Which of the following is <italic>not</italic> a way to apportion resources in a pooled environment?",
    "choice_a": "Reservations",
    "choice_b": "Limits",
    "choice_c": "Tokens",
    "choice_d": "Shares",
    "correct_answer": "C",
    "explanation": "Tokenization is a method for obscuring or protecting data using two distinct databases, not a resource allocation method. <br>All the other options are methods for allocating shared resources.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      615,
      621,
      94,
      613,
      731
    ],
    "source": ""
  },
  {
    "id": 1119,
    "question": "A loosely coupled storage cluster will have performance and capacity limitations based on the ___________________.",
    "choice_a": "Physical backplane connecting it",
    "choice_b": "Total number of nodes in the cluster",
    "choice_c": "Amount of usage demanded",
    "choice_d": "The performance and capacity in each node",
    "correct_answer": "D",
    "explanation": "In a loosely coupled storage cluster, each node acts as an independent data store that can be added or removed from the cluster without affecting other nodes. This, however, means that the overall cluster\u2019s performance/capacity depends on each node\u2019s own maximum performance/capacity. <br>The physical backplane can be a limiting factor in a tightly coupled architecture but has less effect in a loosely coupled cluster; option A is incorrect. <br>Because each node in a loosely coupled cluster has its own limitations, the number of nodes will not affect overall performance. Option B is incorrect. <br>Option C is incorrect because \u201cusage demanded\u201d is not a factor in performance and capacity of a loosely coupled storage cluster.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      621,
      327,
      615,
      325,
      94
    ],
    "source": ""
  },
  {
    "id": 1120,
    "question": "When putting a system into maintenance mode, it\u2019s important to do all of the following <italic>except</italic> ___________________.",
    "choice_a": "Transfer any live virtual guests off the host",
    "choice_b": "Turn off logging",
    "choice_c": "Lock out the system from accepting any new guests",
    "choice_d": "Notify customers if there are any interruptions",
    "correct_answer": "B",
    "explanation": "Auditing is probably even more important during maintenance mode than normal operation because administrator activity is almost always involved. <br>All the other options are necessary measures for maintenance mode.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      330,
      329,
      620,
      627,
      108
    ],
    "source": ""
  },
  {
    "id": 1121,
    "question": "Typically, a cloud customer seeking stand-alone hosting will expect all of the following <italic>except</italic> ___________________.",
    "choice_a": "More control over governance of the environment",
    "choice_b": "Greater administrative control of the environment",
    "choice_c": "Higher overall security of the environment",
    "choice_d": "Lower costs for the environment",
    "correct_answer": "D",
    "explanation": "Almost invariably, stand-alone hosting will cost more than pooled resources and multitenancy. <br>All the other options are characteristics of stand-alone hosting.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      615,
      94,
      96,
      613,
      94
    ],
    "source": ""
  },
  {
    "id": 1122,
    "question": "Methods for achieving \u201chigh availability\u201d cloud environments include all of the following <italic>except</italic> ___________________.",
    "choice_a": "Extreme redundancy",
    "choice_b": "Multiple system vendors for the same services",
    "choice_c": "Explicitly documented business continuity and disaster recovery (BC/DR) functions in the service-level agreement (SLA) or contract",
    "choice_d": "Failover capability back to the customer\u2019s on-premises environment",
    "correct_answer": "D",
    "explanation": "In many cases, the customer will no longer <italic>have</italic> an on-premises environment after a cloud migration. <br>All the other options are methods cloud providers use to achieve \u201chigh availability\u201d environments.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      94,
      95,
      96,
      107,
      602
    ],
    "source": ""
  },
  {
    "id": 1123,
    "question": "You are in charge of a cloud migration for your organization. You anticipate attack traffic from various sources, each using a variety of both automated and manual intrusion techniques. In order to deter novel attacks used only against your organization, you would be wise to employ firewalls that use ___________________ to detect threats.",
    "choice_a": "Attack signatures",
    "choice_b": "Behavioral outliers",
    "choice_c": "Content filters",
    "choice_d": "Biometric templates",
    "correct_answer": "B",
    "explanation": "Behavioral detection looks for activity beyond the norm of the organization\u2019s usual traffic. Unique attacks would most likely fall into this category. <br>Unique attacks would not be detected by signature matching because no signatures exist for unique attacks; option A is incorrect. <br>Content filtering is less a means of detection and more a means of controlling traffic that users/systems are exposed to; while it may be useful for mitigating the possibility of malware infection, it\u2019s less suited to the purpose posed in the question. Option C is incorrect. <br>Firewalls don\u2019t work with biometrics; option D is a distractor.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      98,
      97,
      402,
      401,
      307
    ],
    "source": ""
  },
  {
    "id": 1124,
    "question": "Firewalls can be included in all the following aspects of a cloud environment <italic>except</italic> ___________________.",
    "choice_a": "The guest OS",
    "choice_b": "The cloud data center IT architecture",
    "choice_c": "Bandwidth providers used to connect to the cloud",
    "choice_d": "Applications used to manipulate data in the cloud",
    "correct_answer": "C",
    "explanation": "Internet service providers don\u2019t usually offer firewall services. <br>All the other options are locations/ways to implement firewalls.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      98,
      97,
      95,
      96,
      94
    ],
    "source": ""
  },
  {
    "id": 1125,
    "question": "A honeypot can be used for all the following purposes <italic>except</italic> ___________________.",
    "choice_a": "Gathering threat intelligence",
    "choice_b": "Luring attackers",
    "choice_c": "Distracting attackers",
    "choice_d": "Delaying attackers",
    "correct_answer": "B",
    "explanation": "It is very important to distinguish the purpose of the honeypot. It is <italic>not</italic> for luring in attackers; a lure is an invitation, and inviting an attack decreases the organization\u2019s ability to have the attacker prosecuted or conduct successful litigation against the attacker. <br>All the other options are purposes of a honeypot.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      99,
      108,
      318,
      636,
      314
    ],
    "source": ""
  },
  {
    "id": 1126,
    "question": "Which of the following should honeypots contain?",
    "choice_a": "Inward-facing connections",
    "choice_b": "Network schematics",
    "choice_c": "Production data",
    "choice_d": "Detection systems",
    "correct_answer": "D",
    "explanation": "The honeypot is used to gather information about the attacker, the attacker\u2019s tools, and the attacker\u2019s techniques. <br>The honeypot should not contain anything of value; all the other options are incorrect.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      99,
      98,
      97,
      401,
      104
    ],
    "source": ""
  },
  {
    "id": 1127,
    "question": "Because all cloud access is remote access, contact between users and the environment should include all of the following <italic>except</italic> ___________________.",
    "choice_a": "Encryption",
    "choice_b": "Secure login with complex passwords",
    "choice_c": "Once in-all in",
    "choice_d": "Logging and audits",
    "correct_answer": "C",
    "explanation": "It\u2019s preferable to have compartmentalized zones of trust within the production environment and not allow total access with one set of credentials. <br>All the other options are aspects that should be used in cloud access.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      603,
      600,
      108,
      97,
      101
    ],
    "source": ""
  },
  {
    "id": 1128,
    "question": "Most attacks that overcome encryption protections exploit ___________________.",
    "choice_a": "Mathematical principles",
    "choice_b": "Misconfigurations",
    "choice_c": "Supercomputers",
    "choice_d": "Statistical probabilities",
    "correct_answer": "B",
    "explanation": "Historically, when encryption had been used as a security mechanism, it was not defeated by attacking the encryption directly but rather by subverting the encryption implementation. <br>All the other options are actual methods for breaking encryption but are not the best answer for this question.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      104,
      102,
      98,
      108,
      333
    ],
    "source": ""
  },
  {
    "id": 1129,
    "question": "Administrators and engineers who work for cloud service providers will have a significant amount of control over multiple customer environments and therefore pose a severe risk. Which of the following is <italic>not</italic> a technique used to mitigate this level of increased risk from privileged users in the cloud data center?",
    "choice_a": "Two-person control",
    "choice_b": "Enhanced logging of administrative activity",
    "choice_c": "Granting privileged access only on a temporary basis",
    "choice_d": "Assigning permanent administrators to select customer accounts",
    "correct_answer": "D",
    "explanation": "Cloud vendors do not typically assign individual administrators permanently to specific accounts. All the other options (A\u2013C) <italic>are</italic> methods used to reduce risks associated with privileged accounts.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      108,
      598,
      603,
      95,
      111
    ],
    "source": ""
  },
  {
    "id": 1130,
    "question": "Which of these is a vital action to determine whether the business continuity and disaster recovery (BC/DR) effort has a chance of being successful?",
    "choice_a": "Perform an integrity check on archived data to ensure that the backup process is not corrupting the data.",
    "choice_b": "Encrypt all archived data to ensure that it can\u2019t be exposed while at rest in the long term.",
    "choice_c": "Periodically restore from backups.",
    "choice_d": "Train all personnel on BC/DR actions they should take to preserve health and human safety.",
    "correct_answer": "C",
    "explanation": "All the options are useful for enhancing the security and efficacy of the BC/DR effort, but only option C ensures that the BC/DR has a likely chance of success.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      636,
      628,
      631,
      111,
      110
    ],
    "source": ""
  },
  {
    "id": 1131,
    "question": "Patches do all the following <italic>except</italic> ___________________.",
    "choice_a": "Address newly discovered vulnerabilities",
    "choice_b": "Solve cloud interoperability problems",
    "choice_c": "Add new features and capabilities to existing systems",
    "choice_d": "Address performance issues",
    "correct_answer": "B",
    "explanation": "Patches can, and often do, <italic>create</italic> interoperability problems. <br>All the other options are functions offered by patching.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      624,
      622,
      623,
      318,
      606
    ],
    "source": ""
  },
  {
    "id": 1132,
    "question": "When applying patches, it is necessary to do all of the following <italic>except</italic> ___________________.",
    "choice_a": "Test the patch in a sandbox that simulates the production environment",
    "choice_b": "Put the patch through the formal change management process",
    "choice_c": "Be prepared to roll back to the last known good build",
    "choice_d": "Inform users of any impact or interruptions",
    "correct_answer": "B",
    "explanation": "In many cases, patches are released to deal with an imminent vulnerability/risk. Some organizations will give blanket preapproval for applying these patches and having the formal change management process approve the patch after the fact. <br>All the other options are activities that should take place with patching.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      316,
      318,
      313,
      314,
      102
    ],
    "source": ""
  },
  {
    "id": 1133,
    "question": "Which of the following is a risk associated with automated patching?",
    "choice_a": "Users can be leveraged by intruders.",
    "choice_b": "A patch may not be applicable to a given environment.",
    "choice_c": "Patches can come loaded with malware, in a Trojan horse attack.",
    "choice_d": "Automated patching is slow and inefficient.",
    "correct_answer": "B",
    "explanation": "Not all patches are necessary for all environments. Automated patching won\u2019t always account for variations in organizations and could cause interoperability problems in some. <br>Users don\u2019t usually apply patches and aren\u2019t involved in automatic patching; option A is incorrect. <br>It is rare that an automated patch tool will be exploited to install malware; option C is incorrect. <br>Automated patching is faster and more efficient than manual patching; option D is incorrect.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      623,
      622,
      317,
      624,
      318
    ],
    "source": ""
  },
  {
    "id": 1134,
    "question": "Which of the following is a risk associated with automated patching, especially in the cloud?",
    "choice_a": "Snapshot/saved virtual machine (VM) images won\u2019t take a patch.",
    "choice_b": "Remote access disallows patching.",
    "choice_c": "Cloud service providers aren\u2019t responsible for patching.",
    "choice_d": "Patches aren\u2019t applied among all cloud data centers.",
    "correct_answer": "A",
    "explanation": "When a VM instance is inactive, it is saved as a snapshot image in a file; patches can\u2019t be applied until the instance is running. Automated patching set to a certain scheduled time may miss inactive VMs. <br>Patches can be applied remotely or locally; option B is not true or correct. <br>Patching may be the responsibility of the cloud customer or provider, depending on the service model, type, and contract. Option C is incorrect. <br>Cloud service providers should apply patches ubiquitously throughout their service environment; option D is incorrect.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      317,
      102,
      107,
      96,
      620
    ],
    "source": ""
  },
  {
    "id": 1135,
    "question": "Which of the following is a risk associated with automated patching, especially in the cloud?",
    "choice_a": "Patches may interfere with some tenants\u2019 production environments.",
    "choice_b": "Patches don\u2019t work with software as a service (SaaS) service models.",
    "choice_c": "Patches don\u2019t work with private cloud builds.",
    "choice_d": "Vendors don\u2019t issue patches to cloud providers.",
    "correct_answer": "A",
    "explanation": "Because a multitenant environment may have a variety of different configurations for various customers, a given patch might interfere with a certain number of customers due to interoperability problems. <br>Option B is untrue. Patches do work with SaaS models. Option B is incorrect. <br>Option C is untrue. Patches do work with private cloud builds. Option C is incorrect. <br>On the contrary, vendors do issue patches to cloud providers. Option D is incorrect.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      623,
      622,
      102,
      96,
      315
    ],
    "source": ""
  },
  {
    "id": 1136,
    "question": "Which of the following is a risk associated with manual patching, especially in the cloud?",
    "choice_a": "It can happen too quickly.",
    "choice_b": "Vendors release patches that work only with their proprietary automated tools.",
    "choice_c": "It\u2019s not scalable.",
    "choice_d": "Users can be tricked into installing malware that looks like a patch.",
    "correct_answer": "C",
    "explanation": "Manual patching requires a significant degree of effort and time and is simply not feasible in a large enterprise, much less in the vast environment of the cloud. <br>Manual patching is slower than automated patching. Option A is incorrect. <br>Option B is incorrect; this is true in both traditional and cloud environments. <br>Option D is incorrect; users should not be performing patching.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      317,
      102,
      318,
      107,
      602
    ],
    "source": ""
  },
  {
    "id": 1137,
    "question": "Which of the following is a risk associated with manual patching especially in the cloud?",
    "choice_a": "No notice before the impact is realized",
    "choice_b": "There is a lack of applicability to the environment.",
    "choice_c": "Patches may or may not address the vulnerability they were designed to fix.",
    "choice_d": "The possibility for human error exists.",
    "correct_answer": "D",
    "explanation": "Patching is a mundane, repetitive process, and people have trouble focusing on such tasks, especially for the number of times necessary to patch a cloud environment. Automation can aid in addressing this aspect of patching. <br>With human involvement in patching, there is an opportunity to be aware of imminent patch impacts and to determine applicability of the patch before it is applied; options A and B are incorrect. <br>Option C is a risk involved with all patching and not limited to manual patching; option D is preferable as it is specific to the question.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      317,
      318,
      316,
      624,
      623
    ],
    "source": ""
  },
  {
    "id": 1138,
    "question": "You are the security manager for an organization that uses the cloud for its production environment. According to your contract with the cloud provider, your organization is responsible for patching. A new patch is issued by one of your vendors. You decide not to apply it immediately for fear of interoperability problems. What additional risk are you accepting?",
    "choice_a": "The cloud provider will suspend your access for violating its terms of service.",
    "choice_b": "The cloud provider may sue your organization for breach of contract.",
    "choice_c": "Your organization is subject to the vulnerability the patch addresses.",
    "choice_d": "Your end clients will no longer trust your organization, and this will hurt your revenue flow.",
    "correct_answer": "C",
    "explanation": "It is perfectly reasonable to not want to use the first version of a patch as there may be interoperability problems or even additional vulnerabilities contingent with its implementation. However, for as long as your environment remains unpatched, you are subject to attack through that new vulnerability. <br>All the other options are untrue. <br>The cloud provider will not suspend your access or sue your organization if you delay patching because of concerns about interoperability afterwards. Options A and B are incorrect. <br>Option D is incorrect. The opposite may actually be true. Your end clients may appreciate that you delay or test the patch before installing it on production systems.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      622,
      623,
      318,
      639,
      102
    ],
    "source": ""
  },
  {
    "id": 1139,
    "question": "You are the security manager for an organization that uses the cloud for its production environment. According to your contract with the cloud provider, your organization is responsible for patching. A new patch is issued by one of your vendors. You decide not to apply it immediately for fear of interoperability problems. Who may impose penalties on your organization for this decision if the vulnerability is exploited?",
    "choice_a": "The cloud provider",
    "choice_b": "Regulators",
    "choice_c": "Your end clients",
    "choice_d": "Your Internet service provider (ISP)",
    "correct_answer": "B",
    "explanation": "If your organization doesn\u2019t apply a patch for a known vulnerability, regulators may claim the organization was not performing adequate due diligence and penalize it accordingly. <br>None of the other entities listed in the other options can assess penalties, so they are incorrect. (End clients may try to recover damages realized from an attack through a known vulnerability, but those penalties will be imposed by a court if the end clients conduct successful litigation.).",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      318,
      622,
      623,
      624,
      110
    ],
    "source": ""
  },
  {
    "id": 1140,
    "question": "Which of the following aspects of a cloud environment is <italic>most</italic> likely to add risk to the patch management process?",
    "choice_a": "Variations in user training and familiarity with the cloud",
    "choice_b": "A cloud services contract that specifies which parties are responsible for which aspects of patching",
    "choice_c": "VMs located physically in one location but operating in different time zones",
    "choice_d": "The prevalence of attacker activity at the time the patch is applied",
    "correct_answer": "C",
    "explanation": "If patches are rolled out across an environment where users are operating virtual machines (VMs) at different times, there is a possibility that VMs will not be patched uniformly, which could lead to data disruption. <br>Option A is incorrect. Users should not be performing patching. <br>Option B is incorrect; a contract specifying who is responsible for specific patching activities actually reduces risk by enhancing the probability of proper patch application. <br>Option D is incorrect; attacker activity should be irrelevant to the patch process.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      620,
      623,
      316,
      622,
      107
    ],
    "source": ""
  },
  {
    "id": 1141,
    "question": "Which type of web application monitoring most closely measures actual activity?",
    "choice_a": "Synthetic performance monitoring",
    "choice_b": "Real-user monitoring (RUM)",
    "choice_c": "Security information and event management (SIEM)",
    "choice_d": "Database application monitor (DAM)",
    "correct_answer": "B",
    "explanation": "RUM harvests information from actual user activity, making it the most realistic depiction of user behavior. <br>Synthetic monitoring approximates user activity but is not as exact as RUM; option A is incorrect. <br>SIEM monitors more than web applications, so option C is not ideal for this question. <br>DAM is an OSI Layer 7 tool for monitoring database activity, specifically, so it is not the ideal answer for this question.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      326,
      249,
      400,
      401,
      98
    ],
    "source": ""
  },
  {
    "id": 1142,
    "question": "When using real-user monitoring (RUM) for web application activity analysis, which of the following do you need to take into account?",
    "choice_a": "False positives",
    "choice_b": "Attacker baseline actions",
    "choice_c": "Privacy concerns",
    "choice_d": "Sandboxed environments",
    "correct_answer": "C",
    "explanation": "Depending on the jurisdiction, RUM may entail unlawful surveillance, so the practitioner must take this into account and plan accordingly. <br>Option A is incorrect. False positives are typical for real-user monitoring systems. <br>Option B has no relevance in this context. Option B is incorrect. <br>Sandboxed environments are not a concern when using real-user monitoring for web application activity analysis. Option D is incorrect.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      249,
      326,
      111,
      110,
      618
    ],
    "source": ""
  },
  {
    "id": 1143,
    "question": "Synthetic performance monitoring may be preferable to real-user monitoring (RUM) because ___________________.",
    "choice_a": "It costs less",
    "choice_b": "It is a more accurate depiction of user behavior",
    "choice_c": "It is more comprehensive",
    "choice_d": "It can take place in the cloud",
    "correct_answer": "C",
    "explanation": "Synthetic agents can simulate user activity in a much faster, broader manner and perform these actions 24/7 without rest. <br>All the other options are incorrect; synthetic agents may cost more than RUM, are less accurate than actual user activity, and both can take place on the cloud.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      327,
      326,
      325,
      621,
      247
    ],
    "source": ""
  },
  {
    "id": 1144,
    "question": "You are the security manager for an organization with a cloud-based production environment. You are tasked with setting up the event monitoring and logging systems. In your jurisdiction, private entities are allowed to monitor all activity involving their systems, without exception. Which of the following best describes a logging scheme you would recommend?",
    "choice_a": "Logging every event, at all levels of granularity, including continual screen shots, keystroke logging, and browser history",
    "choice_b": "Sufficient logging to reconstruct a narrative of events at some later date",
    "choice_c": "Logging only data related to incidents after they have occurred",
    "choice_d": "Logging specific data sets recommended by industry standards and guidelines",
    "correct_answer": "B",
    "explanation": "Logging should suffice for the purpose of reconstructing the pertinent information (who, what, where, when, etc.) necessary to form a narrative of what transpired. This will be different for every organization and environment (so option D is incorrect). You will have to make this determination for your organization. <br>Logging everything would result in log storage that exceeds the amount of data in the production environment and would actually make it more difficult to locate pertinent information. Option A is incorrect. <br>Option C is incorrect. Logging data after the fact is impossible.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      401,
      402,
      627,
      625,
      108
    ],
    "source": ""
  },
  {
    "id": 1145,
    "question": "Who should be performing log review?",
    "choice_a": "Only certified, trained log review professionals with a great deal of experience with the logging tool",
    "choice_b": "The internal audit body",
    "choice_c": "External audit providers",
    "choice_d": "Someone with knowledge of the operation and a security background",
    "correct_answer": "D",
    "explanation": "It is important for the log review to be performed by someone who understands the normal operations of the organization so that they can discern between regular activity and anomalous behavior. This person also needs a security background so they can recognize common attack patterns/activity. <br>Option A sounds great, but the better answer is option D. A person with knowledge of the operation is a better fit than someone who is trained to review logs. <br>Options B and C are incorrect. Auditors are not the ones who should be reviewing logs for an organization.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      247,
      401,
      626,
      104,
      111
    ],
    "source": ""
  },
  {
    "id": 1146,
    "question": "Which of these subsystems is probably <italic>most</italic> important for acquiring useful log information?",
    "choice_a": "Fan",
    "choice_b": "RAM",
    "choice_c": "Clock",
    "choice_d": "Uninterruptible power supply (UPS)",
    "correct_answer": "C",
    "explanation": "The clock needs to be synched throughout the environment so that all activity can be contextualized and mapped and a true narrative of events can be reconstructed later. <br>All the other options are incorrect because they are simply IT terms. When it comes to useful logs, having the correct time relevant to all logged activity is vital.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      625,
      627,
      401,
      402,
      112
    ],
    "source": ""
  },
  {
    "id": 1147,
    "question": "A SIEM (security information and event management) system does <italic>not</italic> eliminate the need for human participation in ___________________.",
    "choice_a": "Log collection",
    "choice_b": "Responding to alerts",
    "choice_c": "Mathematical normalization of different logs",
    "choice_d": "Detecting and alerts",
    "correct_answer": "B",
    "explanation": "Response to anomalous activity detected by the SIEM tool will still require human involvement. <br>All the other options are functions that the SIEM system can perform on its own as automated tasks.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      247,
      402,
      249,
      326,
      626
    ],
    "source": ""
  },
  {
    "id": 1148,
    "question": "Log data should be protected ___________________.",
    "choice_a": "One level below the sensitivity level of the systems from which it was collected",
    "choice_b": "At least at the same sensitivity level as the systems from which it was collected",
    "choice_c": "With encryption in transit, at rest, and in use",
    "choice_d": "According to National Institute of Standards and Technology (NIST) guidelines",
    "correct_answer": "B",
    "explanation": "Because the logs are essential to reconstructing a record of what occurred within the environment, they are a valuable target for attackers. They therefore need a sufficient level of protection commensurate with the data/systems they are about. <br>We don\u2019t want to have less protection on the logs than on the systems they monitor; the controls on those systems were chosen according to what threats and risks they may be exposed to\u2014the level of security provided by those controls are, at a minimum, required for the log data. Option A is incorrect. <br>Encryption may or may not be used for securing log data, depending on the level of sensitivity of the systems/data they are protecting; option C is too specific and thus incorrect. <br>NIST guidelines are not suitable for all organizations and uses; option D is too broad and incorrect.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      401,
      626,
      108,
      333,
      110
    ],
    "source": ""
  },
  {
    "id": 1149,
    "question": "Risk is usually viewed with consideration for all the following elements <italic>except</italic> ___________________.",
    "choice_a": "Impact that could occur if a given circumstance is realized",
    "choice_b": "The likelihood or probability a circumstance will occur",
    "choice_c": "In the context of specific threats to an organization",
    "choice_d": "According to risks recently realized by other organizations in the same industry",
    "correct_answer": "D",
    "explanation": "While historical information, especially that specific to the organization\u2019s industry, can be useful in assessing threats, risk must be considered independently from other occurrences; whether something has occurred elsewhere does not necessarily directly affect the likelihood it will or will not occur for a certain target. <br>All the other options are elements typically considered in the risk context.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      630,
      628,
      629,
      631,
      635
    ],
    "source": ""
  },
  {
    "id": 1150,
    "question": "Risk management entails evaluating all of the following <italic>except</italic> ___________________.",
    "choice_a": "Threats",
    "choice_b": "Vulnerabilities",
    "choice_c": "Countermeasures",
    "choice_d": "Customers",
    "correct_answer": "D",
    "explanation": "We usually do not evaluate our customer base as an aspect of risk management. All the other options are aspects of common risk management practices.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      635,
      641,
      639,
      642,
      633
    ],
    "source": ""
  },
  {
    "id": 1151,
    "question": "Impact resulting from risk being realized is often measured in terms of ___________________.",
    "choice_a": "Amount of data lost",
    "choice_b": "Money",
    "choice_c": "Amount of property lost",
    "choice_d": "Number of people affected",
    "correct_answer": "B",
    "explanation": "While all the options are somewhat true, because all of that information can be used to provide the most comprehensive risk picture, the <italic>best</italic> answer among those listed is money; it is a discrete, numeric metric that can be used both for comparison to countermeasure/control cost and for recompense efforts (insurance claims, lawsuits, etc.).",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      640,
      637,
      638,
      639,
      636
    ],
    "source": ""
  },
  {
    "id": 1152,
    "question": "You are the security officer for a small nonprofit organization. You are tasked with performing a risk assessment for your organization; you have one month to complete it. The IT personnel you work with have been with the organization for many years and have\u00a0built the systems and infrastructure from the ground up. They have little training and experience in the field of risk. Which type of risk assessment would you choose to conduct?",
    "choice_a": "Quantitative",
    "choice_b": "Qualitative",
    "choice_c": "Pro forma",
    "choice_d": "Informal",
    "correct_answer": "B",
    "explanation": "Qualitative risk assessments are preferable in situations where the organization has personnel who understand the IT environment but may not have a lot of experience with risk functions and where the organization does not have a great deal of time or money to spend on the project. <br>A quantitative risk assessment requires a significant budget of time and money as well as well-trained, experience personnel familiar with risk; option A is not correct. <br>Options C and D are incorrect; these are not types of risk assessments.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      637,
      631,
      638,
      628,
      634
    ],
    "source": ""
  },
  {
    "id": 1153,
    "question": "Which of the following is <italic>most</italic> useful in determining the single loss expectancy (SLE) of an asset?",
    "choice_a": "The frequency with which you expect that type of loss to occur",
    "choice_b": "The dollar value of the asset",
    "choice_c": "The sensitivity of the asset",
    "choice_d": "The size and scope of the asset",
    "correct_answer": "B",
    "explanation": "The monetary value of the asset is the most objective, discrete metric possible and the most accurate for the purposes of SLE determination. <br>The other options are factors that may bear on how you determine the dollar value of the asset but are not as useful as option B.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      640,
      637,
      638,
      634,
      628
    ],
    "source": ""
  },
  {
    "id": 1154,
    "question": "Which of the following will likely <italic>best</italic> help you predict the annualized rate of occurrence (ARO) of a specific loss?",
    "choice_a": "Threat intelligence data",
    "choice_b": "Historical data",
    "choice_c": "Vulnerability scans",
    "choice_d": "Aggregation analysis",
    "correct_answer": "B",
    "explanation": "While previous activity is not a great predictor of future outcomes (especially in the field of IT security), it is the best source we have. <br>Threat intelligence information is useful but not as good as historical data in predicting ARO; option A is not as good as option B. <br>Vulnerability scans and aggregation do not really aid in predicting rate of occurrence at all; options C and D are incorrect.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      630,
      628,
      631,
      640,
      637
    ],
    "source": ""
  },
  {
    "id": 1155,
    "question": "Which of the following has the <italic>most</italic> effect on exposure factor (EF)?",
    "choice_a": "The type of threat vector",
    "choice_b": "The source location of the attack",
    "choice_c": "The target of the attack",
    "choice_d": "The jurisdiction where the attack takes place",
    "correct_answer": "A",
    "explanation": "The threat vector is the multiplier involved in determining exposure factor; of the options listed, this is the best answer (and, other than C, the only one that actually has bearing on EF).",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      636,
      628,
      631,
      314,
      313
    ],
    "source": ""
  },
  {
    "id": 1156,
    "question": "You are a consultant, performing an external security review on a large manufacturing firm. You determine that its newest assembly plant, which cost $24 million, could be completely destroyed by a fire but that a fire suppression system could effectively protect the plant. The fire suppression system costs $15 million. An insurance policy that would cover the full replacement cost of the plant costs $1 million per month. What is the annual rate of occurrence (ARO) in this scenario?",
    "choice_a": "12",
    "choice_b": "$24 million",
    "choice_c": "1",
    "choice_d": "$10 million",
    "correct_answer": "C",
    "explanation": "Absent any other information about a total physical loss, we can consider the rate of occurrence as 1: We would not expect the plant to burn down more than once in a year. In fact, we would expect that unless the plant was involved in some particularly flammable activity, the ARO would be less than 1 (that is, a fire is not expected every year) due to controls involved in the planning and building process of the plant (location of flammable material, fire-resistant construction techniques, etc.). <br>Options B and D are incorrect. The ARO is a number, not a dollar amount. <br>It is unlikely that the plant would burn down 12 times a year or every month. Option A is incorrect.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      631,
      628,
      637,
      640,
      636
    ],
    "source": ""
  },
  {
    "id": 1157,
    "question": "You are a consultant performing an external security review on a large manufacturing firm. You determine that its newest assembly plant, which cost $24 million, could be completely destroyed by a fire but that a fire suppression system could effectively protect the plant. The fire suppression system costs $15 million. An insurance policy that would cover the full replacement cost of the plant costs $1 million per month. What would you recommend?",
    "choice_a": "Accept the risk of fire, and save money by not spending anything on controls/countermeasures.",
    "choice_b": "Get the fire suppression system.",
    "choice_c": "Get the insurance policy.",
    "choice_d": "It is impossible to decide from this information.",
    "correct_answer": "D",
    "explanation": "What we can\u2019t determine from the available information is the actual annualized loss expectancy (ALE); the cost of the physical plant itself is not the actual value of the asset, so it\u2019s impossible to determine the ALE and therefore impossible to compare the ALE against the cost of possible controls and countermeasures. <br>All the other options incorrect; we can\u2019t make a suitable choice from the available information.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      640,
      637,
      634,
      639,
      636
    ],
    "source": ""
  },
  {
    "id": 1158,
    "question": "You are a consultant performing an external security review on a large manufacturing firm. You determine that its newest assembly plant, which cost $24 million, could be completely destroyed by a fire but that a fire suppression system could effectively protect the plant. The fire suppression system costs $15 million. An insurance policy that would cover the full replacement cost of the plant costs $1 million per month. In order to establish the true annualized loss expectancy (ALE), you would need all of the following information <italic>except</italic> ___________________.",
    "choice_a": "The amount of revenue generated by the plant",
    "choice_b": "The rate at which the plant generates revenue",
    "choice_c": "The length of time it would take to rebuild the plant",
    "choice_d": "The amount of product the plant creates",
    "correct_answer": "D",
    "explanation": "Unless this number is being used to determine the measures of options A or B, or we\u2019re trying to better estimate the cost of the impact of the first occurrence (i.e., including the value of lost product in the single loss expectancy [SLE]), the <italic>amount</italic> of product the plant creates is not as important as the attendant revenue that amount generates for the company. <br>All the other options are factors we need to know: The amount of revenue and the pace at which it is generated by the plant and the duration of downtime for the plant in the event of fire (so as to calculate possible lost revenue) will help us arrive at the annualized loss expectancy (ALE). In fact, additional information would also be useful, such as potential loss of market share if product was not delivered for the duration of the downtime, etc.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      638,
      640,
      634,
      628,
      636
    ],
    "source": ""
  },
  {
    "id": 1159,
    "question": "You are a consultant performing an external security review on a large manufacturing firm. You determine that its newest assembly plant, which cost $24 million, could be completely destroyed by a fire but that a fire suppression system could effectively protect the plant. The fire suppression system costs $15 million. An insurance policy that would cover the full replacement cost of the plant costs $1 million per month. The plant generates $2 million of revenue each month. The time to rebuild the plant at the current location is six months. What should you recommend?",
    "choice_a": "Accept the risk of fire, and save money by not spending anything on controls and countermeasures.",
    "choice_b": "Get the fire suppression system.",
    "choice_c": "Get the insurance policy.",
    "choice_d": "It is impossible to decide from this information.",
    "correct_answer": "B",
    "explanation": "The fire suppression system is the most cost-effective, reasonable means of dealing with the risk, if we use the formula for determining annualized loss expectancy (ALE). <br>First, we need to determine the single loss expectancy (SLE) and annualized rate of occurrence (ARO). ARO can be assumed to be 1; absent any other information about the plant, we don\u2019t expect more than one fire per year (and perhaps less, but we don\u2019t have that information, either). The SLE is $36 million ($24 million for the cost of rebuilding the plant, assuming no increase in costs over the previous construction, plus $2 million per month of lost revenue, for the six months it will take to rebuild). <br>Therefore, the ALE is $36 million (36 [SLE] \u00d7 1 [ARO]). <br>Either the fire suppression system or the insurance policy would be appealing, from a strictly financial standpoint, if we only compared the ALE to the annualized cost of the countermeasure ($15 million for the suppression system, $12 million for the insurance policy). <br>However, other factors have a bearing on this consideration too. For instance, fire poses a threat to health and human safety; obviating such risks should be a paramount concern to senior management. An insurance policy doesn\u2019t truly protect people, it only offsets the damages people experience through loss. Also, the insurance policy would be a recurring, continual cost; it costs less than the fire suppression system in the <italic>first year</italic> of the plant\u2019s operation ($12 million for insurance versus $15 million for the system), but once the system is purchased, though it may need upkeep and maintenance, we can assume it won\u2019t cost the same amount in future years, and it probably won\u2019t cost anywhere near as much as the continual costs of the insurance. <br>All the other options are not as good as B.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      640,
      637,
      628,
      638,
      636
    ],
    "source": ""
  },
  {
    "id": 1160,
    "question": "Risk mitigation must <italic>always</italic> also entail which other method of addressing risk?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk transfer",
    "choice_d": "Risk attenuation",
    "correct_answer": "A",
    "explanation": "Because risk can never be mitigated to zero (there is no such thing as \u201cno risk\u201d or \u201cperfect security\u201d), there will always be some residual risk after risk mitigation; this residual risk must be accepted. <br>Risk mitigation does not <italic>always</italic> involve risk transfer, or risk avoidance. \u201cRisk attenuation\u201d is not an industry-standard term associated with risk management Options B, C, and D are incorrect.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      635,
      639,
      641,
      333,
      633
    ],
    "source": ""
  },
  {
    "id": 1161,
    "question": "Which of the following poses a secondary risk?",
    "choice_a": "Fire exit signs",
    "choice_b": "Oxygen-displacing fire suppression",
    "choice_c": "Automated fire detection systems",
    "choice_d": "Fail-safe fire egress paths",
    "correct_answer": "B",
    "explanation": "Secondary risk is any risk resulting from enacting a control/countermeasure to the original risk. In this case, a fire suppression system that displaces oxygen is a means to mitigate the original risk (fire) but adds a new risk (suffocating people). <br>All the other options are not causes of secondary risk (except if we draw out unreasonable conclusions from the most extreme, ridiculous cases, for example, \u201cthe secondary risk is the risk that the control doesn\u2019t work\u201d).",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      641,
      639,
      635,
      642,
      333
    ],
    "source": ""
  },
  {
    "id": 1162,
    "question": "Which of the following is <italic>not</italic> true about risk mitigation?",
    "choice_a": "A given control/countermeasure should never cost more than the impact of the risk it mitigates.",
    "choice_b": "Risk cannot be reduced to zero.",
    "choice_c": "The end state of risk mitigation is risk at a tolerable level.",
    "choice_d": "Risk mitigation is always the best means to address risk.",
    "correct_answer": "D",
    "explanation": "The best means to address risk is completely dependent on the business needs of the specific entity and process. Mitigation may or may not be the optimum choice. <br>All the other options are true statements about risk mitigation.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      639,
      641,
      635,
      633,
      636
    ],
    "source": ""
  },
  {
    "id": 1163,
    "question": "Which of the following is <italic>not</italic> true about risk mitigation?",
    "choice_a": "The cost of the control/countermeasure per year is simple: the overall cost (of acquisition, implementation, and maintenance) divided by life span, in years.",
    "choice_b": "Ignoring risk is not risk mitigation; ignoring risk is risk acceptance.",
    "choice_c": "The cost of mitigation can be compared against the cost of a control/countermeasure to determine the optimum course of action.",
    "choice_d": "Risk is fluid, so all risk assessments are pointless.",
    "correct_answer": "D",
    "explanation": "A risk assessment may, indeed, be an estimate of a moving target, but it is invaluable in terms of measuring risk at any given point in time.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      636,
      635,
      641,
      633,
      639
    ],
    "source": ""
  },
  {
    "id": 1164,
    "question": "Which comes first?",
    "choice_a": "Accreditation",
    "choice_b": "Operation",
    "choice_c": "Maintenance",
    "choice_d": "Certification",
    "correct_answer": "D",
    "explanation": "In the certification/accreditation model of system approval, certification is the fundamental step. <br>All other options are incorrect because certification comes first in the certification/accreditation model of system approval.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      110,
      618,
      604,
      606,
      313
    ],
    "source": ""
  },
  {
    "id": 1165,
    "question": "The National Institute of Standards and Technology (NIST) Risk Management Framework (RMF) is required for federal agencies in the United States. Which of the following is <italic>not</italic> a characteristic of the RMF?",
    "choice_a": "Automation of controls wherever possible",
    "choice_b": "Focuses on continual improvement and near real-time risk management",
    "choice_c": "Is based on cost metrics and perceived threats",
    "choice_d": "Links risk management at the process level to risk management at the managerial level",
    "correct_answer": "C",
    "explanation": "The RMF is based on perceived risk as opposed to threats (threats may factor into risk assessment but are not the driver for the RMF). <br>All the other options are true regarding the RMF.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      636,
      637,
      640,
      639,
      631
    ],
    "source": ""
  },
  {
    "id": 1166,
    "question": "Symmetric encryption involves ___________________.",
    "choice_a": "Two key pairs, mathematically related",
    "choice_b": "Unknown parties, sharing information",
    "choice_c": "Signed certificates",
    "choice_d": "A shared secret",
    "correct_answer": "D",
    "explanation": "In symmetric encryption, a single key is used to both encrypt and decrypt a message. This is often referred to as a shared secret. <br>Two key pairs are not used in symmetric encryption; option A is incorrect. <br>Parties most often must be known to each other using symmetric encryption; option B is incorrect. <br>Certificates require public-private key pairs, which is not an element of symmetric encryption; option C is incorrect.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      100,
      103,
      101,
      108,
      96
    ],
    "source": ""
  },
  {
    "id": 1167,
    "question": "Symmetric encryption involves ___________________.",
    "choice_a": "The Diffie-Hellman key exchange",
    "choice_b": "Passing keys out of band",
    "choice_c": "Mathematically related key pairs",
    "choice_d": "A one-way mathematical algorithm for validating messages",
    "correct_answer": "B",
    "explanation": "In symmetric encryption, the key must usually be passed through a different medium than will be used for sending and receiving the encrypted messages. <br>DH is usually used for asymmetric encryption, to establish a temporary symmetric key; option A is incorrect. <br>Option C describes asymmetric encryption and is therefore incorrect. <br>Option D describes hashing and is therefore incorrect.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      100,
      103,
      108,
      98,
      94
    ],
    "source": ""
  },
  {
    "id": 1168,
    "question": "Which of the following is a U.S. audit standard often used to evaluate cloud providers?",
    "choice_a": "ISO 27001",
    "choice_b": "SOX",
    "choice_c": "SSAE 18",
    "choice_d": "IEC 43770",
    "correct_answer": "C",
    "explanation": "The Statement on Standards for Attestation Engagements (SSAE) 18 is the current AICPA (American Institute of Certified Public Accountants) audit standard. <br>ISO 27001 is an international audit standard. <br>The Sarbanes-Oxley Act (SOX) is a U.S. law pertaining to publicly traded corporations. <br>There is no such thing as the IEC 43770 standard.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      341,
      344,
      343,
      345,
      360
    ],
    "source": ""
  },
  {
    "id": 1169,
    "question": "The Cloud Security Alliance (CSA) Security, Trust, and Assurance Registry (STAR) program has ___________________ tiers.",
    "choice_a": "Two",
    "choice_b": "Three",
    "choice_c": "Four",
    "choice_d": "Eight",
    "correct_answer": "B",
    "explanation": "The STAR program has three tiers.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      646,
      647,
      360,
      359,
      358
    ],
    "source": ""
  },
  {
    "id": 1170,
    "question": "The Cloud Security Alliance (CSA) Security, Trust, and Assurance Registry (STAR) program\u2019s tier of self-assessment is which of the following?",
    "choice_a": "Tier 1",
    "choice_b": "Tier 2",
    "choice_c": "Tier 5",
    "choice_d": "Tier 8",
    "correct_answer": "A",
    "explanation": "Tier 1 is the lowest tier of the STAR program, involving only self-assessment.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      359,
      647,
      646,
      358,
      360
    ],
    "source": ""
  },
  {
    "id": 1171,
    "question": "Alice and Bob want to use the Internet to communicate privately. They each have their own asymmetric key pairs and want to use them to create temporary symmetric keys for each connection or session. Which of the following will enable them to do this?",
    "choice_a": "Remote Authentication Dial-In User Service (RADIUS)",
    "choice_b": "Rivest-Shamir-Adelman (RSA) encryption",
    "choice_c": "Diffie-Hellman exchange",
    "choice_d": "Terminal Access Controller Access-Control System (TACACS)",
    "correct_answer": "C",
    "explanation": "The Diffie-Hellman key exchange process is designed to allow two parties to create a shared secret (symmetric key) over an untrusted medium. RADIUS is an outmoded access control service for remote users. RSA is an encryption scheme. TACACS is a network access protocol set used through a centralized server.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      115,
      133,
      117,
      129,
      131
    ],
    "source": ""
  },
  {
    "id": 1172,
    "question": "Under European Union (EU) law, a cloud customer who gives sensitive data to a cloud provider is still legally responsible for the damages resulting from a data breach caused by the provider; the EU would say that it is the cloud customer\u2019s fault for choosing the wrong provider. This is an example of insufficient ___________________.",
    "choice_a": "Proof",
    "choice_b": "Evidence",
    "choice_c": "Due diligence",
    "choice_d": "Application of reasonableness",
    "correct_answer": "C",
    "explanation": "A party who does not perform sufficient due diligence in choosing a contractor can be held accountable for the actions made by that contractor. In current privacy and data laws, this is usually the government\u2019s perspective regarding wrongdoing on the part of cloud providers. <br>All the other options are incorrect because they are simply legal terms that do not correctly answer the question.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      709,
      648,
      344,
      357,
      651
    ],
    "source": ""
  },
  {
    "id": 1173,
    "question": "Which of the following is <italic>not</italic> an enforceable governmental request?",
    "choice_a": "Warrant",
    "choice_b": "Subpoena",
    "choice_c": "Court order",
    "choice_d": "Affidavit",
    "correct_answer": "D",
    "explanation": "An affidavit is only a form of formal testimony presented to the court. All the other options are enforceable governmental requests.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      649,
      650,
      651,
      672,
      664
    ],
    "source": ""
  },
  {
    "id": 1174,
    "question": "Which of the following is <italic>not</italic> a way of managing risk?",
    "choice_a": "Mitigation",
    "choice_b": "Acceptance",
    "choice_c": "Avoidance",
    "choice_d": "Streamlining",
    "correct_answer": "D",
    "explanation": "<italic>Streamlining</italic> is a nonsense term in this context. All the other options represent normal ways of addressing risk. Mitigation is the use of controls to attenuate the impact or likelihood (or both) of risk, acceptance is allowing the business to function with no further action, and avoidance is halting the business function.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      361,
      354,
      125,
      119,
      122
    ],
    "source": ""
  },
  {
    "id": 1175,
    "question": "The Organisation for Economic Cooperation and Development (OECD) is a multinational entity that creates nonbinding policy suggestions for its member countries. The OECD has published recommendations for privacy laws. One of the characteristics the OECD suggests that privacy laws include is the ___________________.",
    "choice_a": "Amorphous curtailment principle",
    "choice_b": "Collection limitation principle",
    "choice_c": "State-based incorporation principle",
    "choice_d": "Hard-copy instantiation principle",
    "correct_answer": "B",
    "explanation": "The collection limitation principle requires any entity that gathers personally identifiable information (PII) about a person to restrict data collection to only information that is necessary for the transaction, and only with the knowledge and permission of the individual. The other options are meaningless in this context.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      656,
      652,
      347,
      355,
      337
    ],
    "source": ""
  },
  {
    "id": 1176,
    "question": "The Organisation for Economic Cooperation and Development (OECD) is a multinational entity that creates nonbinding policy suggestions for its member countries. The OECD has published recommendations for privacy laws. One of the characteristics the OECD suggests that privacy laws include is the ___________________.",
    "choice_a": "Data quality principle",
    "choice_b": "Transformative neologism principle",
    "choice_c": "Encryption matrices principle",
    "choice_d": "Restful state principle",
    "correct_answer": "A",
    "explanation": "The data quality principle requires any entity that gathers personally identifiable information (PII) about a person to ensure that the data remains valid and accurate and allows for corrections by the data subject. The other answers are meaningless in this context.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      656,
      652,
      347,
      658,
      339
    ],
    "source": ""
  },
  {
    "id": 1177,
    "question": "The Organisation for Economic Cooperation and Development (OECD) is a multinational entity that creates nonbinding policy suggestions for its member countries. The OECD has published recommendations for privacy laws. One of the characteristics the OECD suggests that privacy laws include is the ___________________.",
    "choice_a": "Archipelago enhancement principle",
    "choice_b": "Solidity restoration principle",
    "choice_c": "Netherworking substrate principle",
    "choice_d": "Purpose specification principle",
    "correct_answer": "D",
    "explanation": "The purpose specification principle requires any entity that gathers personally identifiable information (PII) about a person to clearly state the explicit purpose for which the PII will be used. The other answers are meaningless in this context.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      656,
      652,
      347,
      337,
      646
    ],
    "source": ""
  },
  {
    "id": 1178,
    "question": "The Organisation for Economic Cooperation and Development (OECD) is a multinational entity that creates nonbinding policy suggestions for its member countries. The OECD has published recommendations for privacy laws. One of the characteristics the OECD suggests that privacy laws include is the ___________________.",
    "choice_a": "Use limitation principle",
    "choice_b": "Erstwhile substitution principle",
    "choice_c": "Flatline cohesion principle",
    "choice_d": "Airstream fluidity principle",
    "correct_answer": "A",
    "explanation": "The use limitation principle requires any entity that gathers personally identifiable information (PII) about a person to restrict the use of that PII to that which was permitted by the data subject and the reason given when it was collected. The other answers are meaningless in this context.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      656,
      652,
      347,
      339,
      337
    ],
    "source": ""
  },
  {
    "id": 1179,
    "question": "The Organisation for Economic Cooperation and Development (OECD) is a multinational entity that creates nonbinding policy suggestions for its member countries. The OECD has published recommendations for privacy laws. One of the characteristics the OECD suggests that privacy laws include is the ___________________.",
    "choice_a": "Transient data principle",
    "choice_b": "Security safeguards principle",
    "choice_c": "Longtrack resiliency principle",
    "choice_d": "Arbitrary insulation principle",
    "correct_answer": "B",
    "explanation": "The security safeguards principle requires any entity that gathers personally identifiable information (PII) about a person to protect that data against unauthorized access and modification. The other answers are meaningless in this context.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      656,
      652,
      653,
      347,
      352
    ],
    "source": ""
  },
  {
    "id": 1180,
    "question": "The Organisation for Economic Cooperation and Development (OECD) is a multinational entity that creates nonbinding policy suggestions for its member countries. The OECD has published recommendations for privacy laws. One of the characteristics the OECD suggests that privacy laws include is the ___________________.",
    "choice_a": "Volcanic principle",
    "choice_b": "Inherency principle",
    "choice_c": "Repository principle",
    "choice_d": "Openness principle",
    "correct_answer": "D",
    "explanation": "The openness principle requires any entity that gathers personally identifiable information (PII) about a person to allow that person to access the information. The other answers are meaningless in this context.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      337,
      652,
      656,
      347,
      650
    ],
    "source": ""
  },
  {
    "id": 1181,
    "question": "The Organisation for Economic Cooperation and Development (OECD) is a multinational entity that creates nonbinding policy suggestions for its member countries. The OECD has published recommendations for privacy laws. The OECD privacy principles influenced which lawmaking body and are readily apparent in the law(s) it created?",
    "choice_a": "U.S. Congress",
    "choice_b": "European Union (EU)",
    "choice_c": "Politburo",
    "choice_d": "International Standards Organization (ISO)",
    "correct_answer": "B",
    "explanation": "The EU crafted first the EU Data Directive and then the General Data Protection Regulation largely according to the OECD guidelines. The US Congress has (at the time of this writing) made no broad federal privacy law and instead has treated personal privacy on an industry-by-industry basis. The Politburo no longer exists.The ISO is not a lawmaking body.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      656,
      652,
      653,
      357,
      347
    ],
    "source": ""
  },
  {
    "id": 1182,
    "question": "Which of the following is <italic>not</italic> a way in which an entity located outside the European Union (EU) can be allowed to gather and process privacy data belonging to EU citizens?",
    "choice_a": "Be located in a country with a nationwide law that complies with the EU laws.",
    "choice_b": "Appeal to the EU High Court for permission.",
    "choice_c": "Create binding contractual language that complies with the EU laws.",
    "choice_d": "Join the Privacy Shield program in its own country.",
    "correct_answer": "B",
    "explanation": "The General Data Protection Regulation prohibits entities within a country that has no nationwide privacy law from gathering or processing privacy data belonging to EU citizens. Entities can be allowed to do so if the following conditions are met: <br>Their own country has nationwide laws that comply with the EU laws. <br>The entity creates contractual language that complies with the EU laws and has that language approved by each EU country from which the entity wishes to gather citizen data. <br>The entity voluntarily subscribes to its own nation\u2019s Privacy Shield program. <br>There is no process for the entity to appeal to the EU for permission to do so, however.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      660,
      656,
      347,
      357,
      648
    ],
    "source": ""
  },
  {
    "id": 1183,
    "question": "The Privacy Shield program is ___________________.",
    "choice_a": "Voluntary for non\u2013European Union (EU) entities",
    "choice_b": "Mandatory for all EU entities",
    "choice_c": "Mandatory for all non-EU entities",
    "choice_d": "Voluntary for all EU entities",
    "correct_answer": "A",
    "explanation": "The Privacy Shield program is for non-EU entities that also do not exist in a country with a nationwide privacy law; no entity is required to join the program, but those who don\u2019t are prevented from collecting and processing EU citizen privacy data. Entities within the EU are already subject to the EU General Data Protection Regulation law and therefore are not eligible or benefited by the Privacy Shield program.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      660,
      656,
      357,
      348,
      654
    ],
    "source": ""
  },
  {
    "id": 1184,
    "question": "Which of the following countries does <italic>not</italic> have a federal privacy law that complies with the European Union (EU) General Data Protection Regulation?",
    "choice_a": "Canada",
    "choice_b": "United States",
    "choice_c": "Switzerland",
    "choice_d": "Japan",
    "correct_answer": "B",
    "explanation": "The United States does not have a general nationwide privacy law that complies with the EU privacy statutes; it instead has created industry-specific privacy laws. Canada has a law (Personal Information Protection and Electronic Documents Act) that conforms with the EU laws, as does Switzerland and Japan.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      653,
      656,
      348,
      659,
      347
    ],
    "source": ""
  },
  {
    "id": 1185,
    "question": "Which of the following countries does <italic>not</italic> have a federal privacy law that complies with the European Union (EU) General Data Protection Regulation?",
    "choice_a": "Argentina",
    "choice_b": "Israel",
    "choice_c": "Australia",
    "choice_d": "Brazil",
    "correct_answer": "D",
    "explanation": "Brazil does not yet have federal privacy laws sufficient to be considered acceptable for EU compliance. Israel, Australia, and Argentina all do.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      659,
      656,
      348,
      357,
      347
    ],
    "source": ""
  },
  {
    "id": 1186,
    "question": "In the United States, who manages the Privacy Shield program for voluntary compliance with European Union (EU) data privacy laws?",
    "choice_a": "Department of State",
    "choice_b": "Department of Interior",
    "choice_c": "Department of Trade",
    "choice_d": "Department of Commerce",
    "correct_answer": "D",
    "explanation": "The Department of Commerce manages the Privacy Shield program in the United States; the Departments of State and Interior do not. There is no Department of Trade.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      656,
      660,
      347,
      653,
      650
    ],
    "source": ""
  },
  {
    "id": 1187,
    "question": "You\u2019re a sophomore at a small, private medical teaching college in the midwestern United States; you make your tuition payments directly from your bank account via a debit card. Which of the following laws and standards will <italic>not</italic> be applicable to you, your personal data, or the data you work with as a student?",
    "choice_a": "Sarbanes-Oxley Act (SOX)",
    "choice_b": "Health Information Portability and Accountability Act (HIPAA)",
    "choice_c": "Payment Card Industry Data Security Standards (PCI DSS)",
    "choice_d": "Family Educational Rights and Privacy Act (FERPA)",
    "correct_answer": "A",
    "explanation": "SOX is only applicable to publicly traded corporations, not all companies. HIPAA may be applicable to the data you work with as a medical student, if you work with patient data. Your payment and personal data is governed by PCI DSS. FERPA protects your personal student information.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      654,
      652,
      653,
      347,
      356
    ],
    "source": ""
  },
  {
    "id": 1188,
    "question": "U.S. federal entities are required to use cloud data centers within the borders of the United States only. Which law, standard, or requirement mandates this?",
    "choice_a": "Federal Information Security Management Act (FISMA)",
    "choice_b": "Federal Risk and Authorization Management Program (FedRAMP)",
    "choice_c": "Organisation for Economic Cooperation and Development (OECD)",
    "choice_d": "General Data Protection Regulation (GDPR)",
    "correct_answer": "B",
    "explanation": "The FedRAMP standard dictates that American federal agencies must retain their data within the boundaries of the United States, including data within cloud data centers. <br>FISMA is the federal law requiring agencies to comply with National Institute of Standards and Technology (NIST) guidance; option A is broader than B, so B is better in this case. <br>Options C and D are not American laws and therefore not applicable.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      347,
      356,
      348,
      357,
      651
    ],
    "source": ""
  },
  {
    "id": 1189,
    "question": "The Cloud Security Alliance (CSA) Security, Trust, and Assurance Registry (STAR) program includes a level of certification for cloud providers that acquire third-party assessments of their environment and controls. Which STAR level is this?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "B",
    "explanation": "Level 2 of the CSA STAR program requires third-party assessment of the provider. <br>Level 1 is a self-assessment; option A is incorrect. <br>Level 3 requires continual monitoring by a third party; option C is incorrect. <br>There is no Level 4 of the STAR program.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      647,
      360,
      358,
      646,
      344
    ],
    "source": ""
  },
  {
    "id": 1190,
    "question": "___________________ is the legal concept whereby a cloud customer is held to a reasonable expectation for providing security of its users\u2019 and clients\u2019 privacy data.",
    "choice_a": "Due care",
    "choice_b": "Due diligence",
    "choice_c": "Liability",
    "choice_d": "Reciprocity",
    "correct_answer": "A",
    "explanation": "This is an example of due care. <br>Due diligence is the processes and activities used to ensure that due care is maintained; option B is incorrect. <br>Liability is the measure of responsibility an entity has for providing due care; option C is incorrect. <br>Option D has no meaning in this context.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      709,
      710,
      356,
      670,
      652
    ],
    "source": ""
  },
  {
    "id": 1191,
    "question": "Under European Union law, what is the difference between a directive and a regulation?",
    "choice_a": "A directive is enforced by the member states; a regulation is enforced by an international body.",
    "choice_b": "A directive is put in place by statute; a regulation is put in place by precedent.",
    "choice_c": "A directive is for local laws; a regulation is for laws dealing with matters outside the EU.",
    "choice_d": "A directive allows member states to create their own laws; a regulation is applied to all member states.",
    "correct_answer": "D",
    "explanation": "The CCSP candidate is probably most familiar with the European Union\u2019s (EU\u2019s) Data Directive and General Data Protection Regulation in this regard. The directive allows every member country to create its own law that is compliant with the directive; the regulation mandates that all countries comply with the regulation itself. <br>Both directives and regulations can be enforced by either member states or EU international tribunals; option A is not correct. <br>Both directives and regulations are statutory; option B is not correct. <br>Both directives and regulations deal with both internal EU matters and those that extend outside Europe; option C is not correct.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      348,
      356,
      357,
      347,
      655
    ],
    "source": ""
  },
  {
    "id": 1192,
    "question": "You work for a European government agency providing tax counseling services to taxpayers. On your website home page, you include a banner with the following text: \u201cAs a visitor to this website, I agree that any information I disclose to the Tax Counseling Agency can be used for any and all purposes under the General Data Protection Regulation (GDPR).\u201d This is followed by a button that says, \u201cI Agree\u201d: users have to click the button, or they are taken to a page that says, \u201cGoodbye. Thank you for visiting the Tax Counseling Agency, and have a nice day.\u201d <br>This method of collecting personal information is _____________.",
    "choice_a": "Illegal under the GDPR because it is electronic and needs to be in hard copy",
    "choice_b": "Legal under the GDPR",
    "choice_c": "Illegal under the GDPR because it doesn\u2019t allow service if the visitor refuses",
    "choice_d": "Illegal under the GDPR because it doesn\u2019t ask the nationality of the visitor",
    "correct_answer": "C",
    "explanation": "A government service provider is not allowed to refuse service if an individual refuses to participate in data collection. <br>Option A is incorrect. There is no requirement for hardcopy. <br>Option B is incorrect because the provider is a government agency. <br>Option D is incorrect. The scenario in the question is illegal whether or not the visitor is asked about their nationality.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      710,
      651,
      648,
      360,
      344
    ],
    "source": ""
  },
  {
    "id": 1193,
    "question": "Administrative penalties for violating the General Data Protection Regulation (GDPR) can range up to ___________________.",
    "choice_a": "US$100,000",
    "choice_b": "500,000 euros",
    "choice_c": "20,000,000 euros",
    "choice_d": "1,000,000 euros",
    "correct_answer": "C",
    "explanation": "All the other options are incorrect.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      655,
      656,
      659,
      672,
      653
    ],
    "source": ""
  },
  {
    "id": 1194,
    "question": "The European Union (EU) General Data Protection Regulation (GDPR) addresses performance by ___________________.",
    "choice_a": "Data subjects",
    "choice_b": "Data controllers",
    "choice_c": "Data processors",
    "choice_d": "Data controllers and processors",
    "correct_answer": "D",
    "explanation": "The GDPR describes requirements for data collection by and transfers to data controllers and processors. <br>All the other options are incorrect.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      658,
      659,
      660,
      651,
      652
    ],
    "source": ""
  },
  {
    "id": 1195,
    "question": "You are the security manager for a mid-sized nonprofit organization. Your organization has decided to use a software as a service (SaaS) public cloud provider for its production environment. A service contract audit reveals that while your organization has budgeted for 76 user accounts, there are currently 89 active user accounts. Your organization is paying the contract price, plus a per-account fee for every account over the contracted number. <br>This is an example of costs incurred by ___________________.",
    "choice_a": "Data breach",
    "choice_b": "Shadow IT",
    "choice_c": "Intrusions",
    "choice_d": "Insider threat",
    "correct_answer": "B",
    "explanation": "This is the definition of shadow IT: unplanned costs from uncontrolled user activity. <br>This does not constitute a data breach because no data has been disclosed to unauthorized entities; option A is incorrect. <br>This is not an intrusion because no external entity has gained access to the environment; option C is incorrect. <br>While shadow IT may be considered a particular kind of insider threat, we usually consider insider threats as malicious, and shadow IT is typically the result of benign intentions. Option B is better than option D.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      710,
      130,
      134,
      344,
      648
    ],
    "source": ""
  },
  {
    "id": 1196,
    "question": "An audit against the ___________________ will demonstrate that an organization has a holistic, comprehensive security program.",
    "choice_a": "Statement on Auditing Standards (SAS) 70 standard",
    "choice_b": "Statement on Standards for Attestation Engagements (SSAE) 18 standard",
    "choice_c": "Service Organization Control (SOC)  2, Type 2 report matrix",
    "choice_d": "ISO 27001 certification requirements",
    "correct_answer": "D",
    "explanation": "The ISO 27001 certification is for the information security management system (ISMS), the organization\u2019s entire security program. <br>The SAS 70 and SSAE 18 are audit standards for service providers and include some review of security controls but not a cohesive program (and the SAS 70 is outdated); options A and B are not correct. <br>The SOC reports are how SSAE 18 audits are conducted; option C is incorrect.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      345,
      343,
      344,
      358,
      340
    ],
    "source": ""
  },
  {
    "id": 1197,
    "question": "An audit against the ___________________ reporting mechanism will demonstrate that an organization has an adequate security control design.",
    "choice_a": "Service Organization Control (SOC) 1",
    "choice_b": "SOC 2, Type 1",
    "choice_c": "SOC 2, Type 2",
    "choice_d": "SOC 3",
    "correct_answer": "B",
    "explanation": "This is what a SOC 2, Type 1 report is for. <br>The SOC 1 is for financial reporting; the SOC 2, Type 2 is to review the implementation (not design) of controls; and the SOC 3 is just an attestation that an audit was performed. All these options are incorrect.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      350,
      349,
      344,
      341,
      340
    ],
    "source": ""
  },
  {
    "id": 1198,
    "question": "A(n) ___________________ includes reviewing the organization\u2019s current position/performance as revealed by an audit against a given standard.",
    "choice_a": "Service Organization Control (SOC) report",
    "choice_b": "Gap analysis",
    "choice_c": "Audit scoping statement",
    "choice_d": "Federal guideline",
    "correct_answer": "B",
    "explanation": "This is the definition of a gap analysis. <br>SOC reports are specific kinds of audits; option A is incorrect. <br>The scoping statement is a pre-audit function that aids both the organization and the auditor to determine what, specifically, will be audited. Option C is incorrect. <br>Federal guidelines are government recommendations on how something should be done. Option D is incorrect.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      343,
      344,
      349,
      341,
      345
    ],
    "source": ""
  },
  {
    "id": 1199,
    "question": "An audit against the ___________________ will demonstrate that an organization has adequate security controls to meet its ISO 27001 requirements.",
    "choice_a": "Statement on Auditing Standards (SAS) 70 standard",
    "choice_b": "Statement on Standards for Attestation Engagements (SSAE) 18 standard",
    "choice_c": "ISO 27002 certification criteria",
    "choice_d": "National Institute of Standards and Technology (NIST) Special Publication (SP) 800-53",
    "correct_answer": "C",
    "explanation": "The 27002 standard contains sets of controls to be used in order to allow the organization to match the security program created for the organization with 27001. <br>The SAS 70 and SSAE 18 are audit standards for service providers and include some review of security controls but not a cohesive program (and the SAS 70 is outdated); options A and B are not correct. <br>NIST SP 800-53 allows the organization to craft a set of controls to meet the requirements created for and by the organization when using NIST SP 800-37; option D is incorrect.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      341,
      363,
      354,
      646,
      360
    ],
    "source": ""
  },
  {
    "id": 1200,
    "question": "An audit scoping statement might include constraints on all of the following aspects of an environment <italic>except</italic> ___________________.",
    "choice_a": "Time spent in the production space",
    "choice_b": "Business areas and topics to be reviewed",
    "choice_c": "Automated audit tools allowed in the environment",
    "choice_d": "Not reviewing illicit activities that may be discovered",
    "correct_answer": "D",
    "explanation": "While the auditor is not a law enforcement entity, they will likely have an ethical, if not legal, requirement to report illicit activities discovered during the audit. <br>All the other options are incorrect as they are all facets of audit scoping.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      662,
      663,
      661,
      342,
      340
    ],
    "source": ""
  },
  {
    "id": 1201,
    "question": "An audit scoping statement might include all of the following constraints <italic>except</italic> ___________________.",
    "choice_a": "Limitation on destructive techniques",
    "choice_b": "Prohibition of all personnel interviews",
    "choice_c": "Prohibition on access to the production environment",
    "choice_d": "Mandate of particular time zone review",
    "correct_answer": "B",
    "explanation": "Auditors may find it necessary to speak to particular individuals in order to locate artifacts and understand the environment. Although there may be some limitation on particular points of contact and nature of interviews, there cannot be a total prohibition. <br>All the other options are incorrect as they are all facets of audit scoping.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      662,
      661,
      663,
      343,
      341
    ],
    "source": ""
  },
  {
    "id": 1202,
    "question": "You are the IT director for a European cloud service provider. In reviewing possible certifications your company may want to acquire for its data centers, you consider the possibilities of the Cloud Security Alliance (CSA) Security, Trust, and Assurance Registry (STAR) program, the Uptime Institute\u2019s tier certification motif, and ___________________.",
    "choice_a": "The National Institute of Standards and Technology (NIST) Risk Management Framework (Special Publication [SP] 800-37)",
    "choice_b": "The Federal Risk and Authorization Management Program (FedRAMP)",
    "choice_c": "ISO 27034",
    "choice_d": "The EuroCloud Star Audit (ECSA) program",
    "correct_answer": "D",
    "explanation": "The ECSA is designed as a cloud service certification motif for organizations located in Europe. <br>NIST (which also administers FedRAMP) is designed specifically for federal agencies in the United States and is not applicable for European providers, so options A and B are incorrect. <br>ISO 27034 deals with an organization\u2019s use of security controls for software; while this may be pertinent to your organization, it is not a comprehensive view of cloud services and is not as beneficial or equivalent to the CSA STAR or Uptime Institute certifications. Option D is preferable to option C.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      648,
      646,
      358,
      360,
      359
    ],
    "source": ""
  },
  {
    "id": 1203,
    "question": "Who should perform the gap analysis following an audit?",
    "choice_a": "The security office",
    "choice_b": "The auditor",
    "choice_c": "A department other than the audit target",
    "choice_d": "An external audit body other than the original auditor",
    "correct_answer": "C",
    "explanation": "Perspectives gained from people outside the audit target are invaluable because they may see possibilities and opportunities revealed by the audit, whereas the personnel in the target department may be constrained by habit and tradition. <br>Options A and B are incorrect because this poses a conflict of interest. <br>Option D is incorrect. Audits often reveal sensitive information that does not need to be shared with an external audit body that was not part of the original audit.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      340,
      341,
      360,
      342,
      663
    ],
    "source": ""
  },
  {
    "id": 1204,
    "question": "An IT security audit is designed to reveal all of the following <italic>except</italic> ___________________.",
    "choice_a": "Financial fraud",
    "choice_b": "Malfunctioning controls",
    "choice_c": "Inadequate controls",
    "choice_d": "Failure to meet target standards and guidelines",
    "correct_answer": "A",
    "explanation": "An IT security audit is not intended to locate financial fraud; it may, however, lead to such revelations unintentionally. There are specific other audits that exist for this purpose. <br>All the other options are incorrect because they are intended goals for IT security audits.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      341,
      344,
      343,
      340,
      358
    ],
    "source": ""
  },
  {
    "id": 1205,
    "question": "What was the first international privacy standard specifically for cloud providers?",
    "choice_a": "National Institute of Standards and Technology (NIST) Special Publication (SP) 800-37",
    "choice_b": "Personal Information Protection and Electronic Documents Act",
    "choice_c": "Payment Card Industry",
    "choice_d": "ISO 27018",
    "correct_answer": "D",
    "explanation": "ISO 27018 describes privacy requirements for cloud providers, including an annual audit mandate. <br>Option A is incorrect because NIST SP 800-37 describes the Risk Management Framework and is not an international privacy standard. <br>The Personal Information Protection and Electronic Documents Act is a Canadian law relating to data privacy. Option B is incorrect. <br>Option C is incorrect because the PCI DSS is specifically for merchants who accept credit cards, not cloud providers (while cloud providers may process credit cards, and therefore must follow PCI DSS, option D is preferable, and a better answer).",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      356,
      344,
      648,
      652,
      656
    ],
    "source": ""
  },
  {
    "id": 1206,
    "question": "Choose the entity that has <italic>not</italic> published a privacy principle document that includes recognizing a subject\u2019s right to access any of their own privacy data; limitations on the use of privacy data collected from subjects; and security measures for privacy data.",
    "choice_a": "Organisation for Economic Cooperation and Development (OECD)",
    "choice_b": "American Institute of Certified Public Accountants (AICPA)",
    "choice_c": "The European Union (EU) parliament",
    "choice_d": "U.S. Congress",
    "correct_answer": "D",
    "explanation": "Aside from industry-specific legislation, the United States does not have any federal laws outlining how citizens\u2019 privacy data should be treated. <br>All the other entities have published such guidance, and those options are therefore incorrect.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      653,
      656,
      347,
      356,
      360
    ],
    "source": ""
  },
  {
    "id": 1207,
    "question": "The field of digital forensics does <italic>not</italic> include the practice of securely ___________________ data.",
    "choice_a": "Collecting",
    "choice_b": "Creating",
    "choice_c": "Analyzing",
    "choice_d": "Presenting",
    "correct_answer": "B",
    "explanation": "With rare exceptions, digital forensics does not include creation of data (other than the forensic reports regarding the analysis of data). While this could arguably be considered an aspect of digital forensics as well, the other options are more suited to describing digital forensics, so this is the best negative answer.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      407,
      408,
      406,
      667,
      339
    ],
    "source": ""
  },
  {
    "id": 1208,
    "question": "Which of the following is a legal practice of removing a suspect from one jurisdiction to another in order for the suspect to face prosecution for violating laws in the latter?",
    "choice_a": "Applicable law",
    "choice_b": "Judgments",
    "choice_c": "Criminal law",
    "choice_d": "Extradition",
    "correct_answer": "D",
    "explanation": "This is the definition of extradition.. <br>Applicable law is the regulation/legislation affecting a certain circumstance. Option A is incorrect. <br>Judgments are legal conclusions or decisions. Option B is incorrect. <br>Option C is incorrect because criminal law is the body of law that pertains to crime.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      357,
      348,
      651,
      649,
      650
    ],
    "source": ""
  },
  {
    "id": 1209,
    "question": "In which court must the defendant be determined to have acted in a certain fashion according to the preponderance of the evidence?",
    "choice_a": "Civil court",
    "choice_b": "Criminal court",
    "choice_c": "Religious court",
    "choice_d": "Tribal court",
    "correct_answer": "A",
    "explanation": "Civil courts (for example, in a breach of contract case) are held to the \u201cpreponderance of evidence\u201d standard. <br>All the other options are incorrect because they do not hold to the preponderance of the evidence requirement.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      665,
      666,
      664,
      672,
      670
    ],
    "source": ""
  },
  {
    "id": 1210,
    "question": "You are the security manager for a retail sales company that uses a software as a service (SaaS) public cloud service. One of your employees uploads sensitive information they were <italic>not</italic> authorized to put in the cloud. An administrator working for the cloud provider accesses that information and uses it for an illegal purpose, benefiting the administrator and causing harm to your organization. <br>After you perform all the incident-response activity related to the situation, your organization determines that the price of the damage was US$125,000. Your organization sues the cloud provider, and the jury determines that your organization shares in the blame (liability) for the loss because it was your employee performing an unauthorized action that created the situation. <br>If the jury determines that 25 percent of the evidence shows that the situation was your organization\u2019s fault and 75 percent of the evidence shows that the situation was the cloud provider\u2019s fault, what is the likely outcome?",
    "choice_a": "Your organization owes the cloud provider $31,250.",
    "choice_b": "The cloud provider owes your organization $93,750.",
    "choice_c": "Neither side owes the other party anything.",
    "choice_d": "The cloud provider owes your organization $125,000.",
    "correct_answer": "D",
    "explanation": "Except in jurisdictions where contributory negligence is a factor in the proceedings, civil courts use a standard of \u201cpreponderance of evidence,\u201d so the entity that has a simple majority of fault (51 percent or more) is responsible for the full weight of the breach. Because the question did not specify the case was in contributory negligence jurisdiction, option D is the best answer because it is the most likely outcome. <br>Options A, B, and C are incorrect because they are 25%, 75% and 0% of the full weight of the breach.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      664,
      665,
      666,
      344,
      648
    ],
    "source": ""
  },
  {
    "id": 1211,
    "question": "You are the security manager for a small American tech firm and investigate an incident. Upon analysis, you determine that one of your employees was stealing proprietary material and selling it to a competitor. You inform law enforcement and turn over the forensic data with which you determined the source and nature of the theft. The prosecutor can use the material you delivered because of ___________.",
    "choice_a": "The doctrine of plain view",
    "choice_b": "The silver platter doctrine",
    "choice_c": "The General Data Protection Regulation (GDPR)",
    "choice_d": "The Federal Information System Management Act (FISMA)",
    "correct_answer": "B",
    "explanation": "The silver platter doctrine allows law enforcement entities to use material presented voluntarily by the owner as evidence in the prosecution of crimes, without a warrant or a court order. <br>The doctrine of plain view allows law enforcement to act on probable cause when evidence of a crime is within their presence; option A is incorrect. <br>The GDPR is a European Union (EU0 privacy law and not applicable here; option C is incorrect. <br>FISMA is the American law requiring federal agencies to adhere to National Institute of Standards and Technology (NIST) standards; option D is incorrect.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      650,
      407,
      671,
      672,
      347
    ],
    "source": ""
  },
  {
    "id": 1212,
    "question": "You are the security director for an online retailer in Belgium. In February 2019, an audit reveals that your company may have been responsible for exposing personal data belonging to some of your customers over the previous month. Which law is applicable in this instance?",
    "choice_a": "Belgian law",
    "choice_b": "The General Data Protection Regulation (GDPR)",
    "choice_c": "National Institute of Standards and Technology (NIST) Special Publication (SP) 800-53",
    "choice_d": "The Federal Information Systems Management Act (FISMA)",
    "correct_answer": "B",
    "explanation": "As of May 2018, the GDPR is the law throughout all EU member states, superseding any existing local laws. <br>Belgian law will be superseded at that point, and the GDPR has primacy over Belgian law. Option A is incorrect. <br>Options C and D are an American standard and law, respectively, and are not applicable to companies in the European Union (EU), so they are therefore incorrect. <br>It\u2019s important to note that the GDPR covers all entities that are located and/or operate in the EU, regardless of other details such as where the business entity stores the data or where the customers are located.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      656,
      655,
      658,
      659,
      660
    ],
    "source": ""
  },
  {
    "id": 1213,
    "question": "You are the security manager for a software company that uses platform as a service (PaaS) in a public cloud service. Your company\u2019s general counsel informs you that they have received a letter from a former employee who is filing a lawsuit against your company. You should immediately issue a(n) ___________________ to all personnel and offices within your company.",
    "choice_a": "Litigation hold notice",
    "choice_b": "Audit scoping letter",
    "choice_c": "Stop loss memo",
    "choice_d": "Memorandum of agreement",
    "correct_answer": "A",
    "explanation": "A litigation hold notice is required to prevent possible destruction of pertinent evidence that may be used in the case. <br>An audit scoping letter outlines the parameters for an audit engagement; option B is incorrect. <br>Options C and D do not have meaning in this context.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      661,
      662,
      663,
      664,
      665
    ],
    "source": ""
  },
  {
    "id": 1214,
    "question": "You are the security manager for a software company that uses platform as a service (PaaS) in a public cloud service. Your company\u2019s general counsel informs you that they have received a letter from a former employee who is filing a lawsuit against your company. If you do not take proper steps to retain, capture, and deliver pertinent data to the person making the request (or their attorney), the company could be facing legal problems with ___________________ as well as the lawsuit.",
    "choice_a": "Spoliation",
    "choice_b": "Fraud",
    "choice_c": "Jurisdiction",
    "choice_d": "Recompositing",
    "correct_answer": "A",
    "explanation": "<italic>Spoliation</italic> is the term used to describe the destruction of potential evidence (intentionally or otherwise); in various jurisdictions, it can be a crime, or the grounds for another lawsuit. <br>Destroying evidence is not <italic>fraud</italic>; fraud can be a crime or tort on its own, but option B is incorrect. <br><italic>Jurisdiction</italic> describes the geographical area over which a court has power; option C is incorrect. <br><italic>Recompositing</italic> is a made-up word and has no meaning in this context. Option D is incorrect.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      408,
      651,
      650,
      343,
      344
    ],
    "source": ""
  },
  {
    "id": 1215,
    "question": "You are the chief information officer (CIO) for an IT hardware manufacturer. Your company uses cloud-based software as a service (SaaS) services, including email. You receive a legal request for data pertinent to a case. Your e-discovery efforts will largely be dependent on ___________________.",
    "choice_a": "The cloud provider",
    "choice_b": "Regulators",
    "choice_c": "The cloud customer",
    "choice_d": "Internal IT personnel",
    "correct_answer": "A",
    "explanation": "In an SaaS model, the customer has little insight into event logs and traffic analysis useful for evidentiary purposes. The customer will largely be reliant on the cloud provider to locate, collect, and deliver this information for e-discovery. <br>Regulators do not take part in e-discovery; option B is incorrect. <br>In this situation, your company is the cloud customer and will not have a great deal of access to event logs, which may be a crucial element of e-discovery; options C and D are incorrect.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      710,
      651,
      709,
      344,
      648
    ],
    "source": ""
  },
  {
    "id": 1216,
    "question": "You work for a company that operates a production environment in the cloud. Another company using the same cloud provider is under investigation by law enforcement for racketeering. Your company should be concerned about this because of the cloud characteristic of ___________________.",
    "choice_a": "Virtualization",
    "choice_b": "Pooled resources",
    "choice_c": "Elasticity",
    "choice_d": "Automated self-service",
    "correct_answer": "B",
    "explanation": "Multitenancy in the cloud is a direct result of sharing resources; many customers use the same underlying hardware infrastructure. A seizure of hardware assets by law enforcement investigating another cloud customer could conceivably result in the seizure of your company\u2019s data because it happened to be residing on the same hardware when that hardware was seized. <br>The other options are aspects of cloud computing but do not have anything to do with the risk of unauthorized disclosure due to seizure by law enforcement.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      348,
      357,
      651,
      649,
      406
    ],
    "source": ""
  },
  {
    "id": 1217,
    "question": "You are the security manager for a software company that uses platform as a service (PaaS) in a public cloud service. Your company\u2019s general counsel informs you that they have received a letter from a former employee who is filing a lawsuit against your company. What is one of the common practices used in your industry that will have to be halted until the resolution of the case?",
    "choice_a": "Versioning",
    "choice_b": "Patching",
    "choice_c": "Threat modeling",
    "choice_d": "Secure destruction",
    "correct_answer": "D",
    "explanation": "Your company will not be allowed to destroy any data for the duration of the legal case because that might constitute tampering with potential evidence. <br>All the other aspects of software development may continue as long as no destructive measures or methods are utilized; all the other options are incorrect.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      650,
      651,
      339,
      664,
      665
    ],
    "source": ""
  },
  {
    "id": 1218,
    "question": "Your company receives a litigation hold notice from a customer that is suing you for harm caused by one of your products. You are using a managed cloud service for your production environment. You determine that the data requested by the litigant is vast and is going be very difficult to review for pertinence to the case. <br>The senior executive at your firm who is making decisions about this case suggests handing over all data the company has archived for the time frame related to the case, whether or not it may be pertinent, in order to both allow the litigant to find the pertinent data and reduce the costs your company would incur if it performed the reform. <br>What should be your response to the executive?",
    "choice_a": "This is an excellent idea; it fulfills the company\u2019s legal requirements and reduces the overall costs of the litigation.",
    "choice_b": "This is a good idea; it may alleviate some of the costs associated with the court case.",
    "choice_c": "This is a bad idea; the company might not realize the full cost savings that it expects.",
    "choice_d": "This is a horrible idea; it could lead to extensive unauthorized disclosure and additional lawsuits.",
    "correct_answer": "D",
    "explanation": "While e-discovery may be a painful, monotonous, expensive process, a vast data dump of the organization\u2019s entire data store would entail massive risk and liability. <br>The other options are simply incorrect.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      355,
      658,
      339,
      664,
      651
    ],
    "source": ""
  },
  {
    "id": 1219,
    "question": "Your company receives a litigation hold notice from a customer that is suing you for harm caused by one of your products. You are using a managed cloud service for your production environment. You determine that the data requested by the litigant is vast and is going be very difficult to review for pertinence to the case. <br>Which security control mechanism may also be useful in the e-discovery effort?",
    "choice_a": "Trained and aware personnel",
    "choice_b": "An egress monitoring solution (data loss prevention or data leak protection [DLP])",
    "choice_c": "A digital rights management (DRM) solution",
    "choice_d": "A multifactor authentication implementation",
    "correct_answer": "B",
    "explanation": "Typically, a discovery tool is a primary component of a DLP solution. This might be employed for purposes of identifying and collecting pertinent data. <br>All the other options describe important facets of an overall organizational security program but are not especially helpful in e-discovery efforts.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      118,
      127,
      651,
      710,
      344
    ],
    "source": ""
  },
  {
    "id": 1220,
    "question": "When targeting a cloud customer, a court grants an order allowing a law enforcement entity to seize ___________________.",
    "choice_a": "Electronic data",
    "choice_b": "Hardware",
    "choice_c": "Electronic data and the hardware on which it resides",
    "choice_d": "Only data extracted from hardware",
    "correct_answer": "C",
    "explanation": "Courts can issue seizure orders for anything and everything. <br>All the other options are either incorrect because they are too limited (A and B) or just absurd (D).",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      649,
      348,
      357,
      664,
      671
    ],
    "source": ""
  },
  {
    "id": 1221,
    "question": "Your company is defending itself during a civil trial for a breach of contract case. Personnel from your IT department have performed forensic analysis on event logs that reflect the circumstances related to the case. <br>In order for your personnel to present the evidence they collected during forensic analysis as expert witnesses, you should ensure that ___________________.",
    "choice_a": "Their testimony is scripted, and they do not deviate from the script",
    "choice_b": "They present only evidence that is favorable to your side of the case",
    "choice_c": "They are trained and certified in the tools they used",
    "choice_d": "They are paid for their time while they are appearing in the courtroom",
    "correct_answer": "C",
    "explanation": "In order to deliver credible, believable expert testimony, it\u2019s important that your personnel have more than an amateur\u2019s understanding and familiarity with any forensic tools they use to perform analysis. Formal training and certification are excellent methods for creating credibility. <br>Scripting testimony is usually frowned on by the court; coaching witnesses how to perform and what to expect in court is all right, but it does not lead to credibility. Option A is incorrect. <br>Your expert witnesses are not allowed to withhold any evidence from their testimony if it is pertinent to the case, even if that evidence aids the other side. Option B is incorrect. <br>You should pay your employees for their time, regardless of whether they\u2019re performing on the job site or in a courtroom, but this has nothing to do with enhancing credibility. Option D is incorrect.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      667,
      669,
      668,
      407,
      664
    ],
    "source": ""
  },
  {
    "id": 1222,
    "question": "In some jurisdictions, it is mandatory that personnel conducting forensic analysis collection or analysis have a proper ___________________.",
    "choice_a": "Training credential",
    "choice_b": "License",
    "choice_c": "Background check",
    "choice_d": "Approved toolset",
    "correct_answer": "B",
    "explanation": "There are certain jurisdictions where forensic data/IT analysis requires licensure (the American states of Texas, Colorado, and Michigan, for example); it is important for you to determine whether this is the case in your jurisdiction before proceeding with any forensic efforts. <br>It is important for forensic investigators to have proper training, background checks, and approved tools in every jurisdiction, so all the other options are incorrect as they are not specific enough.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      667,
      669,
      668,
      407,
      648
    ],
    "source": ""
  },
  {
    "id": 1223,
    "question": "You run an IT security incident response team. When seizing and analyzing data for forensic purposes, your investigative personnel modify the data from its original content. For courtroom evidentiary purposes, this makes the data ___________________.",
    "choice_a": "Inadmissible",
    "choice_b": "Less believable, if the changes aren\u2019t documented",
    "choice_c": "Harder to control",
    "choice_d": "Easily refutable",
    "correct_answer": "B",
    "explanation": "All forensics processes and activity should be documented with extreme scrutiny. It is very important for your actions to be documented and repeatable in order for them to remain credible. <br>Evidence is only inadmissible if it has no probative value\u2014that is, if it has no bearing on the case. Modified data is still admissible, as long as the modification process was documented and presented along with the evidence. Option A is incorrect. <br>Option C is ambiguous as to its meaning and is therefore an incorrect choice for an answer. <br>Option D is true if the data modification process is not documented and presented in detail.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      408,
      354,
      651,
      355,
      357
    ],
    "source": ""
  },
  {
    "id": 1224,
    "question": "You are the security manager for a small investing firm. After a heated debate regarding security control implementation, one of your employees strikes another employee with a keyboard. The local media hear about the incident and broadcast/publish stories about it under the title \u201cComputer-related attack.\u201d <br>What may be the result of this situation?",
    "choice_a": "A criminal trial",
    "choice_b": "A civil case",
    "choice_c": "Both criminal and civil proceedings",
    "choice_d": "Federal racketeering charges",
    "correct_answer": "C",
    "explanation": "The battery is a crime and may be prosecuted as such, and the act may also result in the victim suing the attacker for damages. <br>Options A and B are not sufficient compared to C. <br>Option D is a distractor in this case; battery is not a form of racketeering, unless linked to a larger pattern of crimes.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      664,
      665,
      666,
      347,
      650
    ],
    "source": ""
  },
  {
    "id": 1225,
    "question": "You are the security manager for a small investing firm. After a heated debate regarding security control implementation, one of your employees strikes another employee with a keyboard. The local media hear about the incident and broadcast/publish stories about it under the title \u201cComputer-related attack.\u201d <br>In this circumstance, who would likely be prosecuted?",
    "choice_a": "Your organization",
    "choice_b": "The attacker",
    "choice_c": "The victim",
    "choice_d": "You, as the manager of both parties",
    "correct_answer": "B",
    "explanation": "The attacker is the one who committed the crime and is therefore likely to be prosecuted (<italic>prosecuted</italic> denotes a criminal trial, as opposed to a civil suit). <br>It is unlikely that the company would be prosecuted for causing the crime because the company did not engage in the wrongful behavior; in this case, there was a very specific attacker and victim. Option A is incorrect. <br>The victim does not get prosecuted for crimes committed against them. Option C is incorrect. <br>If you had ordered the attack, or somehow caused it to occur, you might be prosecuted, but this is not detailed in the question and is an unlikely circumstance; option D is incorrect.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      670,
      664,
      666,
      650,
      347
    ],
    "source": ""
  },
  {
    "id": 1226,
    "question": "__________________ is the legal concept that describes the actions and processes a cloud customer uses to ensure that a reasonable level of protection is applied to the data in their control.",
    "choice_a": "Due care",
    "choice_b": "Due diligence",
    "choice_c": "Liability",
    "choice_d": "Reciprocity",
    "correct_answer": "B",
    "explanation": "This is an example of due diligence. <br>Due care is the duty owed by one entity to another, in terms of a reasonable expectation; option A is incorrect. <br>Liability is the measure of responsibility an entity has for providing due care; option C is incorrect. <br>Answer D has no meaning in this context; option D is incorrect.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      709,
      356,
      710,
      339,
      647
    ],
    "source": ""
  },
  {
    "id": 1227,
    "question": "Which of the following aspects of virtualization make the technology useful for evidence collection?",
    "choice_a": "Hypervisors",
    "choice_b": "Pooled resources",
    "choice_c": "Snapshotting",
    "choice_d": "Live migration",
    "correct_answer": "C",
    "explanation": "Snapshotting an entire virtual machine or memory device is an excellent method for capturing its current data and settings at a specific moment. <br>Hypervisors do not particularly aid in evidence collection, although they may provide log data; option C is still preferable to option A. <br>Pooled resources actually complicate evidence collection; option B is quite wrong. <br>Live migration does not aid in evidence collection; option D is incorrect.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      407,
      406,
      408,
      669,
      355
    ],
    "source": ""
  },
  {
    "id": 1228,
    "question": "Which of the following practices can enhance both operational capabilities and forensic readiness?",
    "choice_a": "Highly trained forensic personnel",
    "choice_b": "Regular full backups",
    "choice_c": "A highly secure data archive",
    "choice_d": "Homomorphic encryption",
    "correct_answer": "B",
    "explanation": "Backups can serve to provide excellent forensics about incidents that have already occurred and also serve to provide an operational reach-back capability for users that have accidentally lost data or modified it incorrectly. <br>While highly trained forensic personnel will be very useful in forensic activities, that is not usually an operational benefit. Option A is incorrect. <br>The more secure the data archive, the less useful it is for operational purposes; option C is not as good as option B. <br>Option D is wrong because homomorphic encryption is still theoretical and currently serves no actual purpose.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      408,
      407,
      124,
      114,
      648
    ],
    "source": ""
  },
  {
    "id": 1229,
    "question": "Which of the following practices can enhance both operational capabilities and configuration management efforts?",
    "choice_a": "Regular backups",
    "choice_b": "Constant uptime",
    "choice_c": "Multifactor authentication",
    "choice_d": "File hashes",
    "correct_answer": "D",
    "explanation": "File hashes can serve as integrity checks for both configuration management (to determine which systems are not configured to the baseline) and audit purposes (as artifacts/common builds of systems for audit review). <br>Backups and constant uptime may aid in availability efforts for operational purposes, but they don\u2019t really help in configuration management; options A and B are incorrect. <br>Multifactor authentication provides neither configuration management nor forensic benefits; option C is wrong.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      124,
      127,
      119,
      125,
      114
    ],
    "source": ""
  },
  {
    "id": 1230,
    "question": "Which of the following is probably the <italic>most</italic> volatile form of data that might serve a forensic purpose?",
    "choice_a": "Virtual instance RAM",
    "choice_b": "Hardware RAM",
    "choice_c": "Hypervisor logs",
    "choice_d": "Drive storage",
    "correct_answer": "A",
    "explanation": "Because RAM is inherently volatile, and virtual resources are simulated only for limited time periods, virtual RAM is probably the most volatile data store. <br>Hardware RAM is probably as volatile as virtual RAM, but the virtualization aspect of option A may make it a more suitable answer for this particular question. <br>Log data and drive storage should both be durable and not volatile at all, so options C and D are incorrect.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      407,
      115,
      114,
      119,
      124
    ],
    "source": ""
  },
  {
    "id": 1231,
    "question": "You are the security representative of a small company doing business through a cloud provider. Your company comes under investigation by law enforcement for possible wrongdoing. In performing e-discovery activity so as to comply with a court order, the cloud provider offers to ship a piece of hardware, a storage drive, from their data center to you for inspection/analysis. <br>What should probably be your response?",
    "choice_a": "Yes. You want it because it gives you the most granular and comprehensive view of the pertinent data.",
    "choice_b": "Yes. You want to be able to inspect it before law enforcement has the opportunity to review it.",
    "choice_c": "No. You don\u2019t want the liability of possibly disclosing someone else\u2019s privacy data.",
    "choice_d": "No. You don\u2019t want the liability of possibly damaging someone else\u2019s property.",
    "correct_answer": "C",
    "explanation": "In a multitenant environment, it is quite likely that any particular piece of hardware will contain data from many customers. In this case, your company may become liable for violating privacy laws for accessing privacy data belonging to another cloud customer, which would increase your company\u2019s exposure (something that could be disastrous because the company is already under investigation). <br>None, some, or all of the other options might be true, however, the liability of possibly disclosing someone else\u2019s privacy data is an overwhelming business risk; therefore, option C is the best answer.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      651,
      406,
      652,
      407,
      357
    ],
    "source": ""
  },
  {
    "id": 1232,
    "question": "The Reporting phase of forensic investigation usually involves presenting findings to ___________________.",
    "choice_a": "Senior management",
    "choice_b": "Regulators",
    "choice_c": "The court",
    "choice_d": "Stakeholders",
    "correct_answer": "C",
    "explanation": "This is a very difficult question as all the options are correct. However, the ultimate recipient of all forensic evidentiary collection and analysis\u2014the entity getting the reports\u2014will be the court, in order to make a final determination of its merits and insights.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      407,
      406,
      668,
      667,
      664
    ],
    "source": ""
  },
  {
    "id": 1233,
    "question": "When presenting forensic evidence in court as testimony, you should include, if at all possible, ___________________.",
    "choice_a": "Your personal opinion",
    "choice_b": "A clear, concise view of your side of the case",
    "choice_c": "Alternative explanations",
    "choice_d": "Historical examples that have bearing on the circumstances of the current case",
    "correct_answer": "C",
    "explanation": "It\u2019s important to present a full view of the evidence, including any alternative findings that were considered but eliminated through reason. This serves many purposes, not the least of which is strengthening your case in the minds of those who hear your testimony. <br>Your professional opinion is vital, but your personal opinion should not have bearing on the case; option A is incorrect. <br>Option B is only incorrect because it limits the presentation to your side of the case, where C is broader and more accurate. <br>Unless instructed by counsel, bringing up similar past activity is not germane to the current case; option D is incorrect.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      667,
      669,
      407,
      664,
      671
    ],
    "source": ""
  },
  {
    "id": 1234,
    "question": "When collecting digital evidence for forensic purposes, it is important to compare the integrity value for any copied material against ___________________.",
    "choice_a": "The original",
    "choice_b": "The backup",
    "choice_c": "Another copy",
    "choice_d": "The industry standard",
    "correct_answer": "A",
    "explanation": "An integrity check comparing the copy to the original is essential so that the report can demonstrate that none of the data was lost or tampered with before analysis begins. <br>All the other options are simply incorrect for integrity check purposes.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      407,
      406,
      344,
      343,
      667
    ],
    "source": ""
  },
  {
    "id": 1235,
    "question": "Who should be responsible for ensuring the state, security, and control of all evidence, from the time it\u2019s collected until it is presented in court?",
    "choice_a": "The data controller",
    "choice_b": "The evidence custodian",
    "choice_c": "The security manager",
    "choice_d": "The IT director",
    "correct_answer": "B",
    "explanation": "The evidence custodian is the person designated to maintain the chain of custody for the duration of the investigation. All the other options could be roles of people who are tasked with custodianship.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      407,
      406,
      650,
      664,
      670
    ],
    "source": ""
  },
  {
    "id": 1236,
    "question": "When you\u2019re accessing an electronic storage file for forensic purposes, it is a best practice to use ___________________.",
    "choice_a": "Gloves",
    "choice_b": "A trusted computing base",
    "choice_c": "Sysadmin access",
    "choice_d": "A write-blocker",
    "correct_answer": "D",
    "explanation": "It is important that any changes to the data only be made in purposeful, specific ways; a write-blocker helps to ensure that extraneous changes aren\u2019t made to the data. <br>The other options are not necessary for accessing an electronic storage file for forensic purposes. Options A, B, and C are incorrect.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      407,
      668,
      667,
      669,
      664
    ],
    "source": ""
  },
  {
    "id": 1237,
    "question": "Which of the following should <italic>not</italic> be true about any tests performed during forensic analysis?",
    "choice_a": "Tests should be repeatable by opposing attorneys.",
    "choice_b": "Tests should be standard to the forensics industry.",
    "choice_c": "Tests should be performed by trained, certified professionals.",
    "choice_d": "Tests should be tailored and customized for specific purposes.",
    "correct_answer": "D",
    "explanation": "You do <italic>not</italic> want to have unique testing techniques used in your analysis, because those may not be repeatable or accepted by other experts (or the court). <br>All the other options are traits of forensic testing we <italic>do</italic> want our tests to include.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      407,
      668,
      667,
      669,
      651
    ],
    "source": ""
  },
  {
    "id": 1238,
    "question": "Which of the following pieces of data is considered personally identifiable information (PII) in the European Union (EU) but <italic>not</italic> in the United States?",
    "choice_a": "Name",
    "choice_b": "Home address",
    "choice_c": "Birth date",
    "choice_d": "Mobile phone number",
    "correct_answer": "D",
    "explanation": "U.S. laws do not, for the most part, consider cell phone numbers an element of PII; in the EU, they are. <br>All the other options are PII elements under both jurisdictions.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      337,
      339,
      338,
      656,
      660
    ],
    "source": ""
  },
  {
    "id": 1239,
    "question": "The Privacy Shield program allows U.S. companies to collect and process privacy information about European Union (EU) citizens. The program is included in which law?",
    "choice_a": "Federal Information Security Management Act (FISMA)",
    "choice_b": "The EU General Data Protection Regulation (GDPR)",
    "choice_c": "Health Information Portability and Accountability Act (HIPAA)",
    "choice_d": "Sarbanes-Oxley Act",
    "correct_answer": "B",
    "explanation": "The GDPR contains the provisions under which the Privacy Shield program was implemented. <br>All the other options are all U.S. law and therefore incorrect.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      658,
      655,
      656,
      347,
      348
    ],
    "source": ""
  },
  {
    "id": 1240,
    "question": "You are the security manager for a U.S.-based company that has branches abroad, including offices in Germany, Italy, and Brazil. If your company wants to process European Union (EU) citizen personally identifiable information (PII) data, one of the options is to use standard contractual clauses (also known as model contracts, or binding rules). <br>If you choose this option, your company will have to get approval from ___________________.",
    "choice_a": "Privacy officials in Italy",
    "choice_b": "Privacy officials in Brazil",
    "choice_c": "Privacy officials in Italy and Germany",
    "choice_d": "Privacy officials in Italy, Germany, and Brazil",
    "correct_answer": "C",
    "explanation": "The EU General Data Protection Regulation (GDPR) requires that multinationals using standard contractual clauses get those clauses approved by the privacy office in every EU member state where the company will operate. Italy and Germany are both EU member states; Brazil is not.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      347,
      651,
      648,
      355,
      653
    ],
    "source": ""
  },
  {
    "id": 1241,
    "question": "Using cloud storage is considered ___________________ under most privacy frameworks and laws.",
    "choice_a": "Illegal",
    "choice_b": "Data collection",
    "choice_c": "Opt-in",
    "choice_d": "Processing",
    "correct_answer": "D",
    "explanation": "Processing includes any manipulation, use, movement, or alteration of data\u2014pretty much anything that can be done with or to data is \u201cprocessing\u201d (including making and manipulating hard-copy versions of data). <br>Storing data in the cloud is not illegal in most jurisdictions (as long as certain rules are followed, for specific industries and data sets); option A is incorrect. <br>Storing often happens at or soon after the time of collection, but they are not the same function; option B is incorrect. <br>Opt-in is the concept under which a data subject must give clear consent to personally identifiable information (PII) data collection and use; option C is incorrect.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      660,
      658,
      652,
      355,
      348
    ],
    "source": ""
  },
  {
    "id": 1242,
    "question": "Which U.S. federal government entity is in charge of administering the Privacy Shield program?",
    "choice_a": "State Department",
    "choice_b": "Privacy Protection Office",
    "choice_c": "Federal Trade Commission (FTC)",
    "choice_d": "Department of Health and Human Services (HHS)",
    "correct_answer": "C",
    "explanation": "The FTC is in charge of the Privacy Shield program. <br>The State Department is involved with controlling some exports, under the International Traffic in Arms Regulations (ITAR) regulations; option A is incorrect. <br>There is no Privacy Protection Office; option B is meaningless term and is incorrect. <br>HHS is in charge of managing the Health Information Portability and Accountability Act (HIPAA); option D is incorrect.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      347,
      650,
      658,
      660,
      348
    ],
    "source": ""
  },
  {
    "id": 1243,
    "question": "In deciding which cloud provider to use, one of the characteristics you may want to determine about the provider is their level of professionalism. Which of the following tools could be used to determine the thoroughness, detail, and repeatability of the processes and procedures offered by a cloud provider?",
    "choice_a": "The Cloud Security Alliance (CSA) Security, Trust, and Assurance Registry (STAR) certification program",
    "choice_b": "The Risk Management Framework (RMF)",
    "choice_c": "The Capability Maturity Model (CMM)",
    "choice_d": "The EuroCloud Star Audit Certification",
    "correct_answer": "C",
    "explanation": "The CMM is a way of determining a target\u2019s maturity in terms of process documentation and repeatability. <br>The CSA STAR and EuroCloud Star programs are certifications based on applicable control sets and compliance with standards and regulations, not process maturity; options A and D are incorrect. <br>The RMF is National Institute of Standards and Technology (NIST) guidance on how to assess risk in an environment; option B is incorrect.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      363,
      358,
      646,
      347,
      354
    ],
    "source": ""
  },
  {
    "id": 1244,
    "question": "Service Organization Control (SOC) 2 reports were intended to be ___________________.",
    "choice_a": "Released to the public",
    "choice_b": "Only technical assessments",
    "choice_c": "Retained for internal use",
    "choice_d": "Nonbinding",
    "correct_answer": "C",
    "explanation": "SOC 2 reports were not designed for dissemination outside the target organization. <br>All the other options are incorrect.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      344,
      341,
      343,
      345,
      349
    ],
    "source": ""
  },
  {
    "id": 1245,
    "question": "To receive a Service Organization Control (SOC) 2 Type 2 report from a potential provider, the provider may require you to perform/provide a(n) ___________________.",
    "choice_a": "Security deposit",
    "choice_b": "Nondisclosure agreement (NDA)",
    "choice_c": "Cloud Security Alliance (CSA) Security, Trust, and Assurance Registry (STAR) certification application",
    "choice_d": "Act of fealty",
    "correct_answer": "B",
    "explanation": "In order to protect extremely sensitive material that is discussed in the SOC 2, Type 2, the provider may request that you sign an NDA and limit distribution. <br>The provider is the entity that should be seeking CSA STAR certification, not the customer; option C is incorrect. <br>Be wary of any provider that asks for security deposits and/or acts of fealty; options A and D are incorrect.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      344,
      349,
      351,
      341,
      710
    ],
    "source": ""
  },
  {
    "id": 1246,
    "question": "The Generally Accepted Privacy Principles described by the American Institute of Certified Public Accountants (AICPA) are very similar to the privacy principles described by ___________________.",
    "choice_a": "The Organisation for Economic Cooperation and Development (OECD) and European Union (EU) General Data Protection Regulation (GDPR)",
    "choice_b": "National Institute of Standards and Technology (NIST) and European Union Agency for Network and Information Security (ENISA)",
    "choice_c": "Health Information Portability and Accountability Act (HIPAA) and Gramm\u2013Leach\u2013Bliley Act (GLBA)",
    "choice_d": "The Federal Trade Commission (FTC) and the U.S. State Department",
    "correct_answer": "A",
    "explanation": "The AICPA, the OECD, and the EU have all outlined certain basic expectations for entities that are privacy data controllers; these expectations are extremely similar in the documentation produced by all three. <br>All the other options are forms of legislation or regulators that do have some content that addresses privacy; however, option A is the most specific and preferable answer because the privacy principles of the AICPA, OECD, and EU are so very similar.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      656,
      652,
      653,
      347,
      660
    ],
    "source": ""
  },
  {
    "id": 1247,
    "question": "The Payment Card Industry Data Security Standard (PCI DSS) requires that all merchants who want to process credit card transactions be compliant with a wide variety of security control requirements. Approximately how many controls are listed in the PCI DSS?",
    "choice_a": "Around a dozen",
    "choice_b": "About 20",
    "choice_c": "About 100",
    "choice_d": "Over 200",
    "correct_answer": "D",
    "explanation": "The PCI DSS is extremely thorough and wide reaching. <br>All the other options are just wrong.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      653,
      356,
      354,
      358,
      344
    ],
    "source": ""
  },
  {
    "id": 1248,
    "question": "The Payment Card Industry Data Security Standard (PCI DSS) requires that all merchants who want to process credit card transactions be compliant with a wide variety of security control requirements. Merchants are assigned different tier levels under PCI DSS, based on ___________________.",
    "choice_a": "Availability",
    "choice_b": "Redundancy",
    "choice_c": "Location of their corporate headquarters",
    "choice_d": "Number of transactions per year",
    "correct_answer": "D",
    "explanation": "The different merchant tiers are based on the number of transactions a specific merchant conducts annually. <br>All the other options are incorrect.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      647,
      646,
      354,
      353,
      356
    ],
    "source": ""
  },
  {
    "id": 1249,
    "question": "The Payment Card Industry Data Security Standard (PCI DSS) requires that all merchants who want to process credit card transaction be compliant with a wide variety of security control requirements. The different merchant tier requirements will dictate ___________________.",
    "choice_a": "Different types of audits each must conduct",
    "choice_b": "Different amounts of audits each must conduct",
    "choice_c": "Different control sets based on tier level",
    "choice_d": "Different cost of controls based on tier level",
    "correct_answer": "B",
    "explanation": "Merchants at different tiers are required to have more or fewer audits in the same time frame as merchants in other tiers, depending on the tier. <br>All PCI DSS\u2013compliant merchants must meet all the control and audit requirements of the standard; options A and C are incorrect. <br>PCI DSS does not dictate costs of controls; option D is wrong.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      647,
      351,
      344,
      354,
      356
    ],
    "source": ""
  },
  {
    "id": 1250,
    "question": "___________________ are required to use <italic>only</italic> cryptographic modules that are compliant with Federal Information Processing Standard (FIPS) 140-2.",
    "choice_a": "Americans",
    "choice_b": "Cloud providers",
    "choice_c": "Infrastructure as a service (IaaS) providers",
    "choice_d": "U.S. federal agencies",
    "correct_answer": "D",
    "explanation": "U.S. federal entities are prohibited from using cryptosystems that are not compliant with FIPS 140-2. <br>All the other options are incorrect because they are not related to FIPS 140-2.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      673,
      675,
      674,
      652,
      651
    ],
    "source": ""
  },
  {
    "id": 1251,
    "question": "In performing vendor management and selection, one of the questions you, as the potential cloud customer, might ask is, \u201cDoes it seem as if this vendor is subject to any pending acquisitions or mergers?\u201d In gathering data to answer this question, what you are trying to avoid?",
    "choice_a": "Vendor lockout",
    "choice_b": "Due care",
    "choice_c": "Third-party dependencies",
    "choice_d": "Regulatory oversight",
    "correct_answer": "A",
    "explanation": "Vendor lockout can occur when your provider no longer offers the service for which you contracted; it is possible that a merger or acquisition of your provider might lead to this circumstance. <br>All the other options are incorrect because they are not relevant in terms of the question.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      648,
      358,
      646,
      345,
      710
    ],
    "source": ""
  },
  {
    "id": 1252,
    "question": "You work for a government research facility. Your organization often shares data with other government research organizations. You would like to create a single sign-on experience across the organizations, where users at each organization can sign in with the user ID/authentication issued by that organization, then access research data in all the other organizations. Instead of replicating the data stores of each organization at every other organization (which is one way of accomplishing this goal), you instead want every user to have access to each organization\u2019s specific storage resources. <br>What is the term for this kind of arrangement?",
    "choice_a": "Public-key infrastructure (PKI)",
    "choice_b": "Portability",
    "choice_c": "Federation",
    "choice_d": "Repudiation",
    "correct_answer": "C",
    "explanation": "This is the definition of federation. PKI is used to establish trust between parties across an untrusted medium, portability is the characteristic describing the likelihood of being able to move data away from one cloud provider to another, and repudiation is when a party to a transaction can deny having taken part in that transaction.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      583,
      584,
      368,
      67,
      74
    ],
    "source": ""
  },
  {
    "id": 1253,
    "question": "You work for a government research facility. Your organization often shares data with other government research organizations. You would like to create a single sign-on experience across the organizations, where users at each organization can sign in with the user ID/authentication issued by that organization, then access research data in all the other organizations. Instead of replicating the data stores of each organization at every other organization (which is one way of accomplishing this goal), you instead want every user to have access to each organization\u2019s specific storage resources. <br>You want to connect your organization to 13 other organizations. You consider using the cross-certification model but then decide against it. What is the <italic>most</italic> likely reason for declining that option?",
    "choice_a": "It is impossible to trust more than two organizations.",
    "choice_b": "If you work for the government, the maximum parties allowed to share data is five.",
    "choice_c": "Trying to maintain currency in reviewing and approving the security governance and configurations of that many entities would create an overwhelming task.",
    "choice_d": "Data shared among that many entities loses its inherent value.",
    "correct_answer": "C",
    "explanation": "In the cross-certification model, every participating organization has to review and approve every other organization; this does not scale well, and once the number of organizations gets fairly substantial, it becomes unwieldy. <br>Option A is incorrect because it is possible to trust more than two organizations. <br>Option B is not true. There is no law/rule that limits the government to sharing data to five or less parties. <br>Option D is incorrect. Sharing data does not automatically affect the value of the data.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      583,
      65,
      71,
      64,
      82
    ],
    "source": ""
  },
  {
    "id": 1254,
    "question": "You work for a government research facility. Your organization often shares data with other government research organizations. You would like to create a single sign-on experience across the organizations, where users at each organization can sign in with the user ID/authentication issued by that organization, then access research data in all the other organizations. Instead of replicating the data stores of each organization at every other organization (which is one way of accomplishing this goal), you instead want every user to have access to each organization\u2019s specific storage resources. <br>In order to pass the user IDs and authenticating credentials of each user among the organizations, what protocol, language, or technique will you <italic>most</italic> likely utilize?",
    "choice_a": "Representational State Transfer (REST)",
    "choice_b": "Security Assertion Markup Language (SAML)",
    "choice_c": "Simple Object Access Protocol (SOAP)",
    "choice_d": "Hypertext Markup Language (HTML)",
    "correct_answer": "B",
    "explanation": "SAML 2.0 is currently the standard used to pass security assertions across the Internet. REST and SOAP are ways of presenting data and executing operations on the Internet, and HTML is a way of displaying web pages.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      584,
      583,
      705,
      436,
      437
    ],
    "source": ""
  },
  {
    "id": 1255,
    "question": "You work for a government research facility. Your organization often shares data with other government research organizations. You would like to create a single sign-on experience across the organizations, where users at each organization can sign in with the user ID/authentication issued by that organization, then access research data in all the other organizations. Instead of replicating the data stores of each organization at every other organization (which is one way of accomplishing this goal), you instead want every user to have access to each organization\u2019s specific storage resources. <br>If you don\u2019t use cross-certification, what other model can you implement for this purpose?",
    "choice_a": "Third-party identity broker",
    "choice_b": "Cloud reseller",
    "choice_c": "Intractable nuanced variance",
    "choice_d": "Mandatory access control (MAC)",
    "correct_answer": "A",
    "explanation": "A third-party identity broker can serve the purpose of checking and approving all participants to the federation so that the participants don\u2019t have to perform that task. A cloud reseller is an entity that sells cloud services without maintaining its own data centers. Option C is gibberish. MAC is used to define access relationships between subjects and objects.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      583,
      584,
      576,
      64,
      82
    ],
    "source": ""
  },
  {
    "id": 1256,
    "question": "You work for a government research facility. Your organization often shares data with other government research organizations. You would like to create a single sign-on experience across the organizations, where users at each organization can sign in with the user ID/authentication issued by that organization, then access research data in all the other organizations. Instead of replicating the data stores of each organization at every other organization (which is one way of accomplishing this goal), you instead want every user to have access to each organization\u2019s specific storage resources. <br>If you are in the United States, one of the standards you should adhere to is ___________________.",
    "choice_a": "National Institute of Standards and Technology (NIST) 800-53",
    "choice_b": "Payment Card Industry (PCI)",
    "choice_c": "ISO 27014",
    "choice_d": "European Union Agency for Network and Information Security (ENISA)",
    "correct_answer": "A",
    "explanation": "NIST Special Publication 800-53 pertains to U.S. federal information systems, guiding the selection of controls according to the Risk Management Framework. PCI is a contractual standard for commercial entities that take credit card payments, not applicable to the government. ENISA publishes a European standard, which is also not applicable to the United States. ISO is not required for government systems in the United States.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      583,
      576,
      64,
      82,
      71
    ],
    "source": ""
  },
  {
    "id": 1257,
    "question": "You work for a government research facility. Your organization often shares data with other government research organizations. You would like to create a single sign-on experience across the organizations, where users at each organization can sign in with the user ID/authentication issued by that organization, then access research data in all the other organizations. Instead of replicating the data stores of each organization at every other organization (which is one way of accomplishing this goal), you instead want every user to have access to each organization\u2019s specific storage resources. <br>If you are in Canada, one of the standards you will have to adhere to is ___________________.",
    "choice_a": "FIPS 140-2",
    "choice_b": "PIPEDA",
    "choice_c": "HIPAA",
    "choice_d": "EFTA",
    "correct_answer": "B",
    "explanation": "The Personal Information Protection and Electronic Documents Act (PIPEDA) is a Canadian law governing protection of personal information. The Federal Information Processing Standard (FIPS) 140-2 standard certifies cryptologic components for use by American federal government entities. The Health Information Portability and Accountability Act (HIPAA) is an American law regulating patient information for medical providers. The European Free Trade Association (EFTA) is not a standard; it is a group of European countries.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      172,
      182,
      187,
      192,
      10
    ],
    "source": ""
  },
  {
    "id": 1258,
    "question": "You are the security policy lead for your organization, which is considering migrating from your on-premises, traditional IT environment into the cloud. You are reviewing the Cloud Security Alliance Cloud Controls Matrix (CSA CCM) as a tool for your organization. <br>Which of the following benefits will the CSA CCM offer your organization?",
    "choice_a": "Simplifying regulatory compliance",
    "choice_b": "Collecting multiple data streams from your log files",
    "choice_c": "Ensuring that the baseline configuration is applied to all systems",
    "choice_d": "Enforcing contract terms between your organization and the cloud provider",
    "correct_answer": "A",
    "explanation": "The CSA CCM will aid you in selecting and implementing appropriate controls for various regulatory frameworks. The CCM does not aid in collecting log files; that is the function of a security information and event management (SIEM), search engine marketing (SEM), or security information management (SIM) tool. The CCM will not help ensure that the baseline is applied to systems; automated configuration tools are available for that purpose (although this answer might be interpreted as desirable; the CCM will help you select appropriate controls for your baseline, but it won\u2019t check to see if those are applied). Contract terms are not enforced by the CCM; the service-level agreement (SLA) should be the mechanism for that task.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      648,
      358,
      646,
      359,
      360
    ],
    "source": ""
  },
  {
    "id": 1259,
    "question": "You are the security policy lead for your organization, which is considering migrating from your on-premises, traditional IT environment into the cloud. You are reviewing the Cloud Security Alliance Cloud Controls Matrix (CSA CCM) as a tool for your organization. <br>Which of the following regulatory frameworks is <italic>not</italic> covered by the CCM?",
    "choice_a": "ISACA\u2019s Control Objectives for Information and Related Technologies (COBIT)",
    "choice_b": "Canada\u2019s Personal Information Protection and Electronic Documents Act (PIPEDA) privacy law",
    "choice_c": "The ALL-TRUST framework from the environmental industry",
    "choice_d": "The U.S. Federal Risk and Authorization Management Program (FedRAMP)",
    "correct_answer": "C",
    "explanation": "Option C is a nonsense term made up as a distractor. All the other frameworks are addressed in the CCM.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      358,
      646,
      648,
      353,
      341
    ],
    "source": ""
  },
  {
    "id": 1260,
    "question": "You are the security policy lead for your organization, which is considering migrating from your on-premises, traditional IT environment into the cloud. You are reviewing the Cloud Security Alliance Cloud Controls Matrix (CSA CCM) as a tool for your organization. <br>Which tool, also available from the CSA, can be used in conjunction with the CCM to aid you in selecting and applying the proper controls to meet your organization\u2019s regulatory needs?",
    "choice_a": "The Consensus Assessments Initiative Questionnaire (CAIQ)",
    "choice_b": "The Open Web Application Security Project (OWASP) Top Ten",
    "choice_c": "The Critical Security Controls (CSC) list",
    "choice_d": "National Institute of Standards and Technology (NIST) Federal Information Processing Standard (FIPS) 140-2",
    "correct_answer": "A",
    "explanation": "The CAIQ is a self-administered tool propagated by the CSA for the purpose of aiding organizations in selecting the necessary controls. The OWASP Top Ten is used to indicate trends in poor design of web applications. The CSC may be a useful tool for choosing and implementing appropriate controls, but it comes from the Center for Internet Security (CIS), not the CSA. The FIPS 140-2 lists only approved cryptographic tools and is published by NIST.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      648,
      646,
      358,
      354,
      347
    ],
    "source": ""
  },
  {
    "id": 1261,
    "question": "You are the security policy lead for your organization, which is considering migrating from your on-premises, traditional IT environment into the cloud. You are reviewing the Cloud Security Alliance Cloud Controls Matrix (CSA CCM) as a tool for your organization. <br>What is probably the <italic>best</italic> benefit offered by the CCM?",
    "choice_a": "The low cost of the tool",
    "choice_b": "Allowing your organization to leverage existing controls across multiple frameworks so as not to duplicate effort",
    "choice_c": "Simplicity of control selection from the list of approved choices",
    "choice_d": "Ease of implementation by choosing controls from the list of qualified vendors",
    "correct_answer": "B",
    "explanation": "The CCM allows you to note where specific controls (some of which you might already have in place) will address requirements listed in multiple regulatory and contractual standards, laws, and guides. Option A is a misnomer because the CCM is free of charge. Options C and D are incorrect because the CCM does not list either specific controls or vendors.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      648,
      358,
      347,
      354,
      353
    ],
    "source": ""
  },
  {
    "id": 1262,
    "question": "You are the IT security subject matter expert for a hobbyist collective that researches and archives old music. Your collective is set up in such a way that the members own various pieces of the network themselves, pool resources and data, and communicate and share files via the Internet. This is an example of what cloud model?",
    "choice_a": "Hydrogenous",
    "choice_b": "Private",
    "choice_c": "Public",
    "choice_d": "Community",
    "correct_answer": "D",
    "explanation": "This is a community cloud, because various parties own different elements of it for a common purpose. A private cloud would typically be owned by a single entity, hosted at a cloud provider data center. A public cloud would be open to anyone and everyone. Hydrogenous is a word that does not have relevant meaning in this context.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      10,
      1,
      236,
      7,
      8
    ],
    "source": ""
  },
  {
    "id": 1263,
    "question": "You are the IT security subject matter expert for a hobbyist collective that researches and archives old music. Your collective wants to create a single sign-on experience for all members of the collective, where assurance and trust in the various members are created by having each member review all the others\u2019 policies, governance, procedures, and controls before allowing them to participate. This is an example of what kind of arrangement?",
    "choice_a": "Security Assertion Markup Language (SAML)",
    "choice_b": "Cross-certification federation",
    "choice_c": "Third-party certification federation",
    "choice_d": "JavaScript Object Notation (JSON)",
    "correct_answer": "B",
    "explanation": "The cross-certification model of federated identity requires all participants to review and confirm all the others. SAML is the format most often used for identity assertions in a federated environment. JSON is a communications format for exchanging objects online.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      478,
      208,
      170,
      194,
      168
    ],
    "source": ""
  },
  {
    "id": 1264,
    "question": "You are the IT security subject matter expert for a hobbyist collective that researches and archives old music. Your collective exchanges music files in two forms: images of written sheet music and electronic copies of recordings. Both of these are protected by what intellectual property legal construct?",
    "choice_a": "Trademark",
    "choice_b": "Copyright",
    "choice_c": "Patent",
    "choice_d": "Trade secret",
    "correct_answer": "B",
    "explanation": "A copyright protects expressions of ideas, usually creative expression. Music, whether written or recorded, falls into this category. Trademarks are for data that is associated with a brand of a company. Patents are usually for processes or inventions. Trade secrets are business elements kept from public disclosure\u2014music would not usually fit into this category as its value is derived from its distribution in the marketplace.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      385,
      386,
      395,
      396,
      387
    ],
    "source": ""
  },
  {
    "id": 1265,
    "question": "You are the IT security subject matter expert for a hobbyist collective that researches and archives old music. If you create a federated identity management structure for all the participants in the collective using a third-party certification model, who would be the federated service provider(s) in that structure?",
    "choice_a": "The third party",
    "choice_b": "A cloud access security broker (CASB)",
    "choice_c": "The various members of the collective",
    "choice_d": "The cloud provider",
    "correct_answer": "C",
    "explanation": "In federations where the participating entities are sharing data and resources, all of those entities are usually the service providers. In a third-party certification model, the third party is the identity provider; this is often a CASB. The cloud provider is neither a federated identity provider nor a federated service provider, unless the cloud provider is specifically chosen as the third party providing this function; in this question, option C is more general and requires no assumptions, so it is the correct choice.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      367,
      369,
      368,
      584,
      695
    ],
    "source": ""
  },
  {
    "id": 1266,
    "question": "You are the IT security subject matter expert for a hobbyist collective that researches and archives old music. You receive a Digital Millennium Copyright Act (DMCA) takedown notice from someone who claims that your collective is hosting music that does not belong to you. You are fairly certain the complaint is not applicable and that the material in question does not belong to anyone else. What should you do in order to comply with the law?",
    "choice_a": "Take the material down, do an investigation, and then repost the material if the claim turns out to be unfounded.",
    "choice_b": "Leave the material up, do an investigation, and post the results of the investigation alongside the material itself once the investigation is complete.",
    "choice_c": "Ignore the complaint.",
    "choice_d": "Leave the material up until such time as the complainant delivers an enforceable governmental request, such as a warrant or subpoena.",
    "correct_answer": "A",
    "explanation": "This is the correct process, according to the law. The rest are not proper procedures for complying with the law and are therefore incorrect and inadvisable.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      651,
      654,
      665,
      355,
      348
    ],
    "source": ""
  },
  {
    "id": 1267,
    "question": "You are the IT security subject matter expert for a hobbyist collective that researches and archives old music. You receive a Digital Millennium Copyright Act (DMCA) takedown notice from someone who claims that your collective is hosting music that does not belong to you. Upon investigation, you determine that the material in question is the sheet music for a concerto written in 1872. What should you do in order to comply with the law?",
    "choice_a": "Contact the current owners of the copyright in order to get proper permissions to host and exchange the data.",
    "choice_b": "Nothing. The material is so old it is in the public domain, and you have as much right as anyone else to use it in any way you see fit.",
    "choice_c": "Apply for a new copyright based on the new usage of the material.",
    "choice_d": "Offer to pay the complainant for the usage of the material.",
    "correct_answer": "B",
    "explanation": "Copyrights expire after a certain duration and then fall into the public domain, where they can be used by anyone for any purpose. This material certainly exceeds the time of any copyright protection. All other options are invalid.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      664,
      665,
      666,
      355,
      654
    ],
    "source": ""
  },
  {
    "id": 1268,
    "question": "Bob is designing a data center to support his organization, a financial services firm. What Uptime Institute tier rating should Bob try to attain in order to meet his company\u2019s needs without adding extraneous costs?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "C",
    "explanation": "Tier 3 should probably suffice for Bob\u2019s purposes, providing sufficient redundancy and resiliency. <br>Tier 4 probably offers more than what Bob needs; it will cost considerably more than a Tier 3 implementation and is most likely only necessary for organizations providing health and human safety services (hospitals and trauma centers, for instance). <br>Tiers 1 and 2 are probably not sufficient and might only be considered for non-constant situations, such as archiving and backup.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      291,
      334,
      290,
      729,
      553
    ],
    "source": ""
  },
  {
    "id": 1269,
    "question": "Bob is designing a data center to support his organization, a financial services firm. Bob\u2019s data center will have to be approved by regulators using a framework under which law?",
    "choice_a": "Health Industry Portability and Accountability Act (HIPPA)",
    "choice_b": "Payment Card Industry (PCI)",
    "choice_c": "Gramm\u2013Leach\u2013Bliley Act (GLBA)",
    "choice_d": "Sarbanes\u2013Oxley Act (SOX)",
    "correct_answer": "C",
    "explanation": "GLBA mandates requirements for securing personal account information in the financial and insurance industries; Bob\u2019s company provides financial services, so he will definitely have to comply with GLBA. <br>If Bob\u2019s company is publicly traded, he may have to comply with SOX, but we don\u2019t know enough about Bob\u2019s company from the question to choose that answer. <br>HIPAA is a requirement only for medical providers and their business associates. <br>PCI is not a law.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      57,
      53,
      48,
      43,
      47
    ],
    "source": ""
  },
  {
    "id": 1270,
    "question": "Bob is designing a data center to support his organization, a financial services firm. Which of the following actions would <italic>best</italic> enhance Bob\u2019s efforts to create redundancy and resiliency in the data center?",
    "choice_a": "Ensure that all entrances are secured with biometric-based locks.",
    "choice_b": "Purchase uninterruptible power supplies (UPSs) from different vendors.",
    "choice_c": "Include financial background checks in all personnel reviews for administrators.",
    "choice_d": "Make sure all raised floors have at least 24 inches of clearance.",
    "correct_answer": "B",
    "explanation": "Using different vendors for multiple systems of the same type adds not only redundancy but also resiliency; if one product has an inherent manufacturing flaw, the other should not, if it comes from a different producer. The other suggestions are all suitable but do not offer redundancy or resiliency.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      289,
      290,
      684,
      555,
      241
    ],
    "source": ""
  },
  {
    "id": 1271,
    "question": "Bob is designing a data center to support his organization, a financial services firm. How long should the uninterruptible power supply (UPS) provide power to the systems in the data center?",
    "choice_a": "12 hours",
    "choice_b": "An hour",
    "choice_c": "10 minutes",
    "choice_d": "Long enough to perform graceful shutdown of the data center systems",
    "correct_answer": "D",
    "explanation": "Traditionally, it would be optimum if the UPS lasted as long as necessary until the generator is able to resume providing the electrical load that was previously handled by utility power. However, the absolute baseline for battery power is just long enough for all systems to complete their transactions without losing data. <br>The other options are incorrect, because they use finite, specific durations; there is no single value that is optimum for all organizations.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      289,
      290,
      291,
      310,
      557
    ],
    "source": ""
  },
  {
    "id": 1272,
    "question": "You are the IT security manager for a video game software development company. For your company, minimizing security flaws in the delivered product is <italic>probably</italic> a ___________________.",
    "choice_a": "Functional requirement",
    "choice_b": "Nonfunctional requirement",
    "choice_c": "Regulatory issue",
    "choice_d": "Third-party function",
    "correct_answer": "B",
    "explanation": "It is preferable that your games do not have security flaws in them, but this is not a core aspect of the product you are delivering: you are delivering entertainment, which is the primary goal; security is therefore a nonfunctional requirement. <br>If you were creating security products, security would be a functional requirement; games are not security products. A game with security flaws is still a game and fulfills the purpose. Option A is therefore incorrect (although hotly debated among IT security personnel\u2014remember, the game can exist without a security department, but the security department couldn\u2019t exist without games). <br>Thus far, regulations have not imposed particular security conditions on delivered products by statute. This does not obviate all liability from shipping defective products, of course; the need for due care and due diligence remains. However, this is a much lower threshold than direct statutory guidance, which exists in fields other than software development (to date). Option C is incorrect. <br>Outsourcing may or may not be used when performing software security reviews; there is not enough information in the question to determine which method your company uses, so option D is too specific for the vague data provided.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      571,
      300,
      270,
      441,
      573
    ],
    "source": ""
  },
  {
    "id": 1273,
    "question": "You are the IT security manager for a video game software development company. In order to test your products for security defects and performance issues, your firm decides to use a small team of game testers recruited from a public pool of interested gamers who apply for a chance to take part. This is an example of ___________________.",
    "choice_a": "Static testing",
    "choice_b": "Dynamic testing",
    "choice_c": "Code review",
    "choice_d": "Open source review",
    "correct_answer": "B",
    "explanation": "Testing the product in a runtime context is dynamic testing. <br>Because this is being done in runtime, it is neither code review nor static testing; options A and C are incorrect. <br>Using a small pool of specified individuals is not truly open source, which would involve releasing the game to the public. Option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      298,
      678,
      268,
      269,
      441
    ],
    "source": ""
  },
  {
    "id": 1274,
    "question": "You are the IT security manager for a video game software development company. In order to test your products for security defects and performance issues, your firm decides to use a small team of game testers recruited from a public pool of interested gamers who apply for a chance to take part. To optimize this situation, the test will need to involve ___________________.",
    "choice_a": "Management oversight",
    "choice_b": "A database administrator",
    "choice_c": "A trained moderator",
    "choice_d": "Members of the security team",
    "correct_answer": "C",
    "explanation": "The moderator will serve to guide the experience in an objective, dispassionate manner, without influencing the test, as well as to help document the outcomes. <br>Having managers in attendance would present a form of unnecessary micromanagement; option A is wrong. <br>There is no need for a database administrator (DBA) to be involved in the test; option B is wrong. <br>The security team should use the data gathered from the test, but they don\u2019t need to be present for the testing; option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      294,
      293,
      573,
      90,
      441
    ],
    "source": ""
  },
  {
    "id": 1275,
    "question": "You are the IT security manager for a video game software development company. In order to test your products for security defects and performance issues, your firm decides to use a small team of game testers recruited from a public pool of interested gamers who apply for a chance to take part. Of the parties listed, who should <italic>most</italic> be excluded from the test?",
    "choice_a": "Management",
    "choice_b": "Security personnel",
    "choice_c": "Billing department representatives",
    "choice_d": "The game developers",
    "correct_answer": "D",
    "explanation": "It is absolutely essential that the developers are not present during the actual testing as they are likely to influence the test unduly, purposefully or otherwise. <br>The other parties don\u2019t need to participate in the testing process but are not as undesirable as the developers; all the other options are incorrect.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      676,
      300,
      284,
      441,
      573
    ],
    "source": ""
  },
  {
    "id": 1276,
    "question": "You are the IT security manager for a video game software development company. In order to test your products for security defects and performance issues, your firm decides to use a small team of game testers recruited from a public pool of interested gamers who apply for a chance to take part. It is absolutely crucial to include ___________________ as part of this process.",
    "choice_a": "Managerial oversight",
    "choice_b": "Signed nondisclosure agreements",
    "choice_c": "Health benefits",
    "choice_d": "The programming team",
    "correct_answer": "B",
    "explanation": "Having the test participants provide signed nondisclosure agreements is an absolutely essential part of this process; they will be exposed to proprietary material and need to be held accountable for any disclosures they might make. <br>Managerial oversight is not at all necessary at this level of development and would actually be a form of micromanagement; option A is incorrect. <br>Health benefits are in no way appropriate for temporary, unpaid testers; option C is only a distractor. <br>Programmers should be prevented from participating in testing as they have inherent bias and may unduly influence the results; option D is wrong.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      676,
      284,
      64,
      573,
      293
    ],
    "source": ""
  },
  {
    "id": 1277,
    "question": "You are the IT security manager for a video game software development company. Which of the following is <italic>most</italic> likely to be your primary concern on a daily basis?",
    "choice_a": "Health and human safety",
    "choice_b": "Security flaws in your products",
    "choice_c": "Security flaws in your organization",
    "choice_d": "Regulatory compliance",
    "correct_answer": "C",
    "explanation": "This is not an easy question and requires some concerted thought. The most grave concern to your company is the loss of proprietary information\u2014that is, your games, which are your property and means of profit. Security flaws in your organization could lead to a total loss of your property, which could end your business. <br>This is one of the very few questions where \u201chealth and human safety\u201d is not the correct answer to a security issue; there just isn\u2019t much danger involved in either producing or consuming video games (aside from dated, anecdotal reports of seizures resulting from flashing images, which lacked scientific substantiation). Though this will be something you must consider (such as workplace violence issues), it will not be a daily activity. Option A is incorrect. <br>Security flaws in your products will most likely not be critical or of grave impact; people who hack your game after shipping may be able to include additional functionality or violate some elements of copy protection, but this is not as threatening as pre-release exposure of the material. Option B is incorrect. <br>Current laws do not dictate much in the way of either content or functionality for software (other than very specific industries, such as health care or financial services); option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      64,
      67,
      92,
      82,
      83
    ],
    "source": ""
  },
  {
    "id": 1278,
    "question": "You are the IT security manager for a video game software development company. Which type of intellectual property protection will your company likely rely upon for legally enforcing your rights?",
    "choice_a": "Trademark",
    "choice_b": "Patent",
    "choice_c": "Copyright",
    "choice_d": "Trade secret",
    "correct_answer": "C",
    "explanation": "Software is protected by copyright. All the other options are forms of intellectual property protections but not applicable to software for the most part (trademarked names and characters may be important, but not as important as the copyright).",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      65,
      93,
      277,
      441,
      566
    ],
    "source": ""
  },
  {
    "id": 1279,
    "question": "You are the IT security manager for a video game software development company. In order to test your products for security defects and performance issues, your firm decides to use a small team of game testers recruited from a public pool of interested gamers who apply for a chance to take part. Gamers are notorious for attempting to perform actions that were never anticipated or intended by the programmers. Results gathered from this activity are ___________________.",
    "choice_a": "Useless",
    "choice_b": "Harmful",
    "choice_c": "Desirable",
    "choice_d": "Illegal",
    "correct_answer": "C",
    "explanation": "This is a very pragmatic and helpful means of gathering inputs that are unpredictable and difficult to simulate and that mimic conditions under which the software will operate. <br>All the other options are incorrect.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      572,
      573,
      294,
      90,
      93
    ],
    "source": ""
  },
  {
    "id": 1280,
    "question": "You are the IT security manager for a video game software development company. In order to test your products for security defects and performance issues, your firm decides to use a small team of game testers recruited from a public pool of interested gamers who apply for a chance to take part. Gamers are notorious for attempting to perform actions that were never anticipated or intended by the programmers. Trying to replicate this phenomenon in a testbed environment with internal testing mechanisms is called ___________________.",
    "choice_a": "Source code review",
    "choice_b": "Deep testing",
    "choice_c": "Fuzz testing",
    "choice_d": "White-box testing",
    "correct_answer": "C",
    "explanation": "Fuzz testing is the term used to describe the use of known bad or randomized inputs to determine what unintended results may occur. <br>Source code review, just like it sounds, is a review of the actual program code; option A is incorrect. <br>Deep testing is a made-up term; option B is incorrect. <br>White-box testing is a term used to describe a form of code review; option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      298,
      300,
      678,
      676,
      293
    ],
    "source": ""
  },
  {
    "id": 1281,
    "question": "You are the IT security manager for a video game software development company. Your development team hired an external game development lab to work on part of the game engine. A few weeks before the initial release of your game, the company that owns the lab publishes a strikingly similar game, with many of the features and elements that appear in your work. Which of the following methods could be used to determine if your ownership rights were violated?",
    "choice_a": "Physical surveillance of their property and personnel",
    "choice_b": "Communications tapping of their offices",
    "choice_c": "Code signing",
    "choice_d": "Subverting insiders",
    "correct_answer": "C",
    "explanation": "Digitally signing software code is an excellent method for determining original ownership and has proven effective in major intellectual property rights disputes. <br>All the other options represent solutions that not only probably lack efficacy but are also often illegal.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      386,
      385,
      394,
      31,
      32
    ],
    "source": ""
  },
  {
    "id": 1282,
    "question": "You are the IT security manager for a video game software development company. Your development team hired an external game development lab to work on part of the game engine. A few weeks before the initial release of your game, the company that owns the lab publishes a strikingly similar game, with many of the features and elements that appear in your work. Which of the following legal methods are you likely able to exercise to defend your rights?",
    "choice_a": "Criminal prosecution",
    "choice_b": "Public hearings",
    "choice_c": "Civil court",
    "choice_d": "Arrest and detention",
    "correct_answer": "C",
    "explanation": "Enforcement of copyright is usually a tortious civil action, as a conflict between private parties. <br>Only crimes involve arrest, detention, and prosecution; most copyright cases such as this would not be tried as a crime, and the government would not be involved (other than in the form of the judge/court). Options A and D are incorrect. <br>Public hearings are not used to gain restitution for harmful acts; option B is incorrect.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      31,
      386,
      32,
      392,
      37
    ],
    "source": ""
  },
  {
    "id": 1283,
    "question": "You are the IT security manager for a video game software development company. In order to test the functionality of online multiplayer game content, your testing team wants to use a cloud service independent from the internal production environment. You suggest that a(n) ___________________ service model will best meet this requirement.",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "TaaS",
    "correct_answer": "B",
    "explanation": "A platform as a service (PaaS) environment will likely provide the best option for testing the game; the provider will offer various OS platforms for the game to run on, giving your company the opportunity to reach as many customers (using various platforms) as possible, raising your potential for market penetration. <br>Although infrastructure as a service (IaaS) is not a terrible option and would give your team additional control of the entire test, it would also require the team to duplicate many different platforms and OSs, requiring a much greater level of effort and additional expertise at what would likely be a much greater cost. Option B is preferable to option A. <br>A software as a service (SaaS) model will not allow your team to install and run the game; option C is incorrect. <br>TaaS is a made-up term with no meaning in this context, making option D incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      8,
      23,
      5,
      13,
      12
    ],
    "source": ""
  },
  {
    "id": 1284,
    "question": "You are the IT security manager for a video game software development company. In order to test the functionality of online multiplayer game content, your testing team wants to use a cloud service independent from the internal production environment. You remind them that it is absolutely crucial that they perform ___________________ before including any sample player or billing data.",
    "choice_a": "Vulnerability scans",
    "choice_b": "Intrusion detection",
    "choice_c": "Masking",
    "choice_d": "Malware scans",
    "correct_answer": "C",
    "explanation": "To attenuate the risks of inadvertent disclosure inherent in untested software, it is essential to obfuscate any raw production data (such as potential personally identifiable information [PII]) before including it in any test environment. <br>The other options represent activity that is obviously beneficial but secondary to the importance of masking production data. Think of it this way: even if there is a vulnerability, breach, or malware in the test environment, if raw data is included something of value is lost; if dummy or masked data is the only content included, nothing of value is lost.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      502,
      25,
      29,
      258,
      24
    ],
    "source": ""
  },
  {
    "id": 1285,
    "question": "Which of the following is not an essential element defining cloud computing?",
    "choice_a": "Broad network access",
    "choice_b": "Metered service",
    "choice_c": "Offsite storage",
    "choice_d": "On-demand self-service",
    "correct_answer": "C",
    "explanation": "Offsite storage is not intrinsic to the definition of cloud computing; all the other options are.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      1,
      13,
      6,
      21,
      206
    ],
    "source": ""
  },
  {
    "id": 1286,
    "question": "Which of the following is not an essential element defining cloud computing?",
    "choice_a": "Rapid elasticity",
    "choice_b": "Pooled resources",
    "choice_c": "On-demand self-service",
    "choice_d": "Immediate customer support",
    "correct_answer": "D",
    "explanation": "Immediate customer support may be an option offered by some cloud providers, but it is not a defining characteristic of the industry. All the other options are essential elements of cloud computing.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      1,
      2,
      12,
      13,
      7
    ],
    "source": ""
  },
  {
    "id": 1287,
    "question": "In what cloud computing service model is the customer responsible for installing and maintaining the operating system?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "QaaS",
    "correct_answer": "A",
    "explanation": "In the infrastructure as a service (IaaS) model, the customer is responsible for everything up from the hardware layer. <br>In platform as a service (PaaS) and software as a service (SaaS), this will be performed by the provider; options B and C are incorrect. <br>QaaS is an invented term and not meaningful; option D is wrong.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      8,
      12,
      237,
      13,
      1
    ],
    "source": ""
  },
  {
    "id": 1288,
    "question": "Your company is considering migrating its production environment to the cloud. In reviewing the proposed contract, you notice that it includes a clause that requires an additional fee, equal to six monthly payments (equal to half the term of the contract) for ending the contract at any point prior to the scheduled date. This is best described as an example of ___________________.",
    "choice_a": "Favorable contract terms",
    "choice_b": "Strong negotiation",
    "choice_c": "Infrastructure as a service (IaaS)",
    "choice_d": "Vendor lock-in",
    "correct_answer": "D",
    "explanation": "Vendor lock-in occurs when the customer is dissuaded from leaving a provider, even when that is the best decision for the customer. <br>These contract terms can be described as favorable only from the provider\u2019s perspective; option D is preferable to option A for describing this situation. <br>There was no description of negotiation included in the question; option B is incorrect. <br>IaaS is a service model and doesn\u2019t really apply to anything in this context; option C is incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      229,
      232,
      237,
      170,
      172
    ],
    "source": ""
  },
  {
    "id": 1289,
    "question": "There are two general types of smoke detectors. Which type uses a small portion of radioactive material?",
    "choice_a": "Photoelectric",
    "choice_b": "Ionization",
    "choice_c": "Electron pulse",
    "choice_d": "Integral field",
    "correct_answer": "B",
    "explanation": "Ionization detectors usually use a small amount of americium in the detection chamber. <br>Photoelectric detectors use a light source instead. Option A is incorrect. <br>Options C and D are incorrect because they are meaningless in this context.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      722,
      721,
      723,
      241,
      725
    ],
    "source": ""
  },
  {
    "id": 1290,
    "question": "You are the privacy data officer for a large hospital and trauma center. You are called on to give your opinion of the hospital\u2019s plans to migrate all IT functions to a cloud service. Which of the following Uptime Institute tier-level ratings would you insist be included for any data center offered by potential providers?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "D",
    "explanation": "Because the nature of a life-support effort requires absolute availability, nothing less than a Tier 4 data center will serve your purposes. All the other options are incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      135,
      161,
      5,
      182,
      170
    ],
    "source": ""
  },
  {
    "id": 1291,
    "question": "What is the <italic>most</italic> important factor when considering the lowest temperature setting within a data center?",
    "choice_a": "System performance",
    "choice_b": "Health and human safety",
    "choice_c": "Risk of fire",
    "choice_d": "Regulatory issues",
    "correct_answer": "B",
    "explanation": "Bare skin sticks to cold metal. <br>Most modern systems don\u2019t suffer performance degradation at the lower ends of the temperature spectrum; it\u2019s the higher temperatures that are of concern for that aspect of the data center. Option B is preferable to option A. <br>Similarly, high temperature invokes a greater risk of fire, not low temperature, and this environmental aspect is perhaps the factor least impacting risk of fire anyway. Option C is incorrect. <br>Any regulatory issues stemming from a workplace that is too cold correlates directly with risks to health and human safety, so option B is still preferable to option D.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      592,
      594,
      587,
      593,
      642
    ],
    "source": ""
  },
  {
    "id": 1292,
    "question": "Storage controllers will typically be involved with each of the following storage protocols <italic>except</italic> ___________________.",
    "choice_a": "Internet Small Computer Systems Interface (iSCSI)",
    "choice_b": "RAID",
    "choice_c": "Fibre Channel",
    "choice_d": "Fibre Channel over Ethernet",
    "correct_answer": "B",
    "explanation": "This question might be susceptible to overthinking because it is simplistically straightforward: RAID is not a protocol\u2014it\u2019s a configuration mechanism. <br>All the other options are storage protocols that will involve storage controllers.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      682,
      684,
      683,
      532,
      534
    ],
    "source": ""
  },
  {
    "id": 1293,
    "question": "When you\u2019re using a storage protocol that involves a storage controller, it is very important that the controller be configured in accordance with ___________________.",
    "choice_a": "Internal guidance",
    "choice_b": "Industry standards",
    "choice_c": "Vendor guidance",
    "choice_d": "Regulatory dictates",
    "correct_answer": "C",
    "explanation": "While it is important to follow internal policy, industry standards, and regulations when they are applicable, vendor guidance will most often offer the most detailed, specific settings for the particular product in question; the other forms of guidance do not usually specify individual products/versions. This does not mean using the default configuration; the vendor will continue to publish suggestions and recommendations for optimizing performance and security of the product after it goes into distribution in order to meet evolving needs and threats.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      683,
      525,
      43,
      53,
      48
    ],
    "source": ""
  },
  {
    "id": 1294,
    "question": "What is the importance of adhering to vendor guidance in configuration settings?",
    "choice_a": "Conforming with federal law",
    "choice_b": "Demonstrating due diligence",
    "choice_c": "Staying one step ahead of aggressors",
    "choice_d": "Maintaining customer satisfaction",
    "correct_answer": "B",
    "explanation": "Applying vendor configurations is an excellent method for demonstrating due diligence in IT security efforts. Always remember that proper documentation of the action is also necessary. <br>Federal law rarely dictates application of vendor guidance, or any other specific security method for individual platforms; option A is incorrect. <br>Aggressors will almost always be on the offensive and adapt attack methodology faster than our industry creates defenses; even vendor guidance is usually reactive. Option C is incorrect. <br>Customers rarely have any idea of (or reason to know) configuration settings; option D is incorrect.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      331,
      605,
      604,
      332,
      636
    ],
    "source": ""
  },
  {
    "id": 1295,
    "question": "Which of the following is a true statement about the virtualization management toolset?",
    "choice_a": "It can be regarded as something public facing.",
    "choice_b": "It must be on a distinct, isolated management network (virtual local area network [VLAN]).",
    "choice_c": "It connects physically to the specific storage area allocated to a given customer.",
    "choice_d": "The responsibility for securely installing and updating it falls on the customer.",
    "correct_answer": "B",
    "explanation": "All management functions should take place on a highly secure, isolated network. <br>The toolset may be available via remote access but is not in any way to be considered public facing; option A is incorrect. <br>Resource pooling contradicts direct connections to any particular storage mechanism; option C is incorrect. <br>Usually, virtualization management will be a responsibility of the provider because it is a crucial element for all customers; option D is incorrect.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      603,
      108,
      614,
      598,
      94
    ],
    "source": ""
  },
  {
    "id": 1296,
    "question": "In order to ensure proper ___________________ in a secure cloud network environment, consider the use of Domain Name System Security Extensions (DNSSEC), Internet Protocol Security\u00a0(IPSec), and Transport Layer Security (TLS).",
    "choice_a": "Isolation",
    "choice_b": "Motif",
    "choice_c": "Multitenancy",
    "choice_d": "Signal modulation",
    "correct_answer": "A",
    "explanation": "Isolation in the cloud is imperative, largely because of multitenancy (not to support it, as option C implies). In order to do this, the use of technologies like those listed in the question is warranted. <br>Options B and D have no meaning in this context and are therefore incorrect.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      97,
      717,
      613,
      94,
      100
    ],
    "source": ""
  },
  {
    "id": 1297,
    "question": "Domain Name System Security Extensions (DNSSEC) provides all of the following <italic>except</italic> ___________________.",
    "choice_a": "Payload encryption",
    "choice_b": "Origin authority",
    "choice_c": "Data integrity",
    "choice_d": "Authenticated denial of existence",
    "correct_answer": "A",
    "explanation": "DNSSEC is basically DNS with the added benefit of certificate validation and the usual functions that certificates offer (the other options). This does not include payload encryption\u2014confidentiality is not an aspect of DNSSEC.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 1298,
    "question": "All of the following are activities that should be performed when capturing and maintaining an accurate, secure system baseline <italic>except</italic> ___________________.",
    "choice_a": "Updating the OS baseline image according to a scheduled interval to include any necessary security patches and configuration modifications",
    "choice_b": "Starting with a clean installation (hardware or virtual) of the desired OS",
    "choice_c": "Including only the default account credentials and nothing customized",
    "choice_d": "Halting or removing all unnecessary services",
    "correct_answer": "C",
    "explanation": "Default credentials are the bane of security, everywhere. This is definitely the correct answer because it should <italic>not</italic> be part of the baseline build. <br>All the other options are actual baselining functions.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      104,
      262,
      331,
      108,
      318
    ],
    "source": ""
  },
  {
    "id": 1299,
    "question": "All of the following are activities that should be performed when capturing and maintaining an accurate, secure system baseline <italic>except</italic> ___________________.",
    "choice_a": "Removing all nonessential programs from the baseline image",
    "choice_b": "Excluding the target system you intend to baseline from any scheduled updates or patching used in production systems",
    "choice_c": "Including the baseline image in the asset inventory and configuration management database",
    "choice_d": "Configuring the host OS according to the baseline requirements",
    "correct_answer": "B",
    "explanation": "Baseline systems need current patches/configuration updates in order to be used to replicate production systems. <br>All the other options are actual baselining functions.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      104,
      331,
      332,
      102,
      333
    ],
    "source": ""
  },
  {
    "id": 1300,
    "question": "All of the following are activities that should be performed when capturing and maintaining an accurate, secure system baseline, <italic>except</italic> ___________________.",
    "choice_a": "Auditing the baseline to ensure that all configuration items have been included and applied correctly",
    "choice_b": "Imposing the baseline throughout the environment",
    "choice_c": "Capturing an image of the baseline system for future reference, versioning, and rollback purposes",
    "choice_d": "Documenting all baseline configuration elements and versioning data",
    "correct_answer": "B",
    "explanation": "Before applying the baseline to the environment, it is important to determine if there are any offices/systems that will require exceptions; not all baselines meet all business needs. <br>All the other options are actual baselining functions.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      331,
      605,
      104,
      318,
      606
    ],
    "source": ""
  },
  {
    "id": 1301,
    "question": "You are the IT director for a small contracting firm. Your company is considering migrating to a cloud production environment. Which service model would <italic>best</italic> fit your needs if you wanted an option that reduced the chance of vendor lock-in but also did not require the highest degree of administration by your own personnel?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "TanstaafL",
    "correct_answer": "B",
    "explanation": "With platform as a service (PaaS), the cloud provider will administer both the hardware and the OS, but you will be in charge of managing the applications and data. There is less likelihood of vendor lock-in with PaaS than software as a service (SaaS), because your data will not be put into a proprietary format (option B is preferable to option C). <br>With infrastructure as a service (IaaS), your company will still retain a great deal of the administrative responsibility, so PaaS is a better option; option B is preferable to A. <br>Option D has no applicability in this context and is incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      8,
      18,
      12,
      229,
      220
    ],
    "source": ""
  },
  {
    "id": 1302,
    "question": "You are the data manager for a retail company; you anticipate a much higher volume of sales activity in the final quarter of each calendar year than the other quarters. In order to handle these increased transactions, and to accommodate the temporary sales personnel you will hire for only that time period, you consider augmenting your internal, on-premises production environment with a cloud capability for a specific duration and will return to operating fully on-premises after the period of increased activity. This is an example of ________________.",
    "choice_a": "Cloud framing",
    "choice_b": "Cloud enhancement",
    "choice_c": "Cloud fragility",
    "choice_d": "Cloud bursting",
    "correct_answer": "D",
    "explanation": "Cloud bursting is the industry term usually associated with this type of practice. <br>All the other options are not terms with any particular meaning in this context.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      535,
      536,
      556,
      545,
      427
    ],
    "source": ""
  },
  {
    "id": 1303,
    "question": "You are the data manager for a retail company; you anticipate a much higher volume of sales activity in the final quarter of each calendar year than the other quarters. In order to handle these increased transactions, and to accommodate the temporary sales personnel you will hire for only that time period, you consider augmenting your internal, on-premises production environment with a cloud capability for a specific duration, and will return to operating fully on-premises after the period of increased activity. Which facet of cloud computing is <italic>most</italic> important for making this possible?",
    "choice_a": "Broad network access",
    "choice_b": "Rapid elasticity",
    "choice_c": "Metered service",
    "choice_d": "Resource pooling",
    "correct_answer": "B",
    "explanation": "While all aspects of cloud computing are necessary to provide a true cloud service, this type of business flexibility is possible because of rapid (close to instant) elasticity, the means to scale your usage up and down as needed. <br>All the other options are facets of cloud computing but are not as pertinent to the question.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      532,
      545,
      556,
      557,
      312
    ],
    "source": ""
  },
  {
    "id": 1304,
    "question": "You are the data manager for a retail company; you anticipate a much higher volume of sales activity in the final quarter of each calendar year than the other quarters. In order to handle these increased transactions, and to accommodate the temporary sales personnel you will hire for only that time period, you consider augmenting your internal, on-premises production environment with a cloud capability for a specific duration, and will return to operating fully on-premises after the period of increased activity. Which deployment model best describes this type of arrangement?",
    "choice_a": "Private cloud",
    "choice_b": "Community cloud",
    "choice_c": "Public cloud",
    "choice_d": "Hybrid cloud",
    "correct_answer": "D",
    "explanation": "This is an excellent description of the hybrid model, where the customer owns elements of the infrastructure (the on-premises traditional environment) and the cloud provider owns other elements (the cloud environment used for the temporary additional demand). <br>All the other options are cloud deployment models but do not suit this particular case.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      9,
      8,
      6,
      1,
      12
    ],
    "source": ""
  },
  {
    "id": 1305,
    "question": "You are the security manager for a research and development firm. Your company does contract work for a number of highly sensitive industries, including aerospace and pharmaceuticals. <br>Your company\u2019s senior management is considering cloud migration and wants an option that is highly secure but still offers some of the flexibility and reduced overhead of the cloud. Which of the following deployment models do you recommend?",
    "choice_a": "Private cloud",
    "choice_b": "Community cloud",
    "choice_c": "Public cloud",
    "choice_d": "Hybrid cloud",
    "correct_answer": "A",
    "explanation": "A private cloud is the best option for work in highly regulated industries or industries that involve very sensitive assets. <br>The other options simply are not as preferable as option A for this question.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      9,
      10,
      5,
      182,
      6
    ],
    "source": ""
  },
  {
    "id": 1306,
    "question": "You are the IT director for a small engineering services company. During the last year, one of your managing partners left the firm, and you lost several large customers, creating a cash flow problem. The remaining partners are looking to use a cloud environment as a means of drastically and quickly cutting costs, migrating away from the expense of operating an internal network. <br>Which cloud deployment model would you suggest to best meet their needs?",
    "choice_a": "Private cloud",
    "choice_b": "Community cloud",
    "choice_c": "Public cloud",
    "choice_d": "Hybrid cloud",
    "correct_answer": "C",
    "explanation": "A public cloud will be the easiest, least expensive option and probably offer the simplest transition. <br>The other options are not as preferable as C for this question.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      9,
      8,
      5,
      7,
      17
    ],
    "source": ""
  },
  {
    "id": 1307,
    "question": "You run an online club for antique piano enthusiasts. In order to better share photo files and other data online, you want to establish a cloud-based environment where all your members can connect their own devices and files to each other, at their discretion. You do not want to centralize payment for such services as Internet service provider (ISP) connectivity, and you want to leave that up to the members. <br>Which cloud deployment model would best suit your needs?",
    "choice_a": "Private cloud",
    "choice_b": "Community cloud",
    "choice_c": "Public cloud",
    "choice_d": "Hybrid cloud",
    "correct_answer": "B",
    "explanation": "This is an optimum situation for the use of a community cloud model. <br>The other options are not as preferable as B for this question.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      10,
      13,
      8,
      5,
      229
    ],
    "source": ""
  },
  {
    "id": 1308,
    "question": "Full isolation of user activity, processes, and virtual network segments in a cloud environment is incredibly important because of risks due to ___________________.",
    "choice_a": "Distributed denial of service (DDoS)",
    "choice_b": "Unencrypted packets",
    "choice_c": "Multitenancy",
    "choice_d": "Insider threat",
    "correct_answer": "C",
    "explanation": "The fact that many various customers (including some that may be competitive with, or even hostile to, each other) will be utilizing the cloud environment concurrently means that isolating each is of the utmost importance in the cloud environment. <br>DDoS is an availability threat, not something to do with confidentiality, so isolation does not serve much purpose in reducing it. Option A is incorrect. <br>Unencrypted message traffic is not the prevailing, general reason for the need for isolation; it might be one specific, particular aspect of a confidentiality concern, but option C is preferable to B. <br>Insider threat is not countered by isolation in the same way that isolation protects against threats due to multitenancy; option C is preferable to D.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      11,
      142,
      16,
      15,
      1
    ],
    "source": ""
  },
  {
    "id": 1309,
    "question": "You are the security manager for a small European appliance rental company. The senior management of your company is considering cloud migration for the production environment, which handles marketing, billing, and logistics. <br>Which cloud deployment model should you be <italic>most</italic> likely to recommend?",
    "choice_a": "Private cloud",
    "choice_b": "Community cloud",
    "choice_c": "Public cloud",
    "choice_d": "Hybrid cloud",
    "correct_answer": "A",
    "explanation": "Because of European personal data privacy laws, it is extremely important for your company to be sure that the data does not leave the borders of a country approved to handle such data. A private cloud model is the best means for your company to be sure that the data is processed in a data center residing in a particular geophysical location. <br>The other options simply are not as preferable as A for this question.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      9,
      187,
      172,
      170,
      5
    ],
    "source": ""
  },
  {
    "id": 1310,
    "question": "You are the security manager for a data analysis company. Your senior management is considering a cloud migration in order to use the greater capabilities of a cloud provider to perform calculations and computations. Your company wants to ensure that neither the contractual nor the technical setup of the cloud service will affect your data sets in any way so that you are not locked in to a single provider. <br>Which of the following criteria will probably be <italic>most</italic> crucial for your choice of cloud providers?",
    "choice_a": "Portability",
    "choice_b": "Interoperability",
    "choice_c": "Resiliency",
    "choice_d": "Governance",
    "correct_answer": "A",
    "explanation": "Portability is the term used to describe the ease with which a customer can move from one cloud provider to another; the higher the portability, the less chance for vendor lock-in. <br>Interoperability describes how systems work together (or don\u2019t); because the question did not mention the use of your own company\u2019s systems, interoperability does not seem to be a major concern in this case. Option B is incorrect. <br>Resiliency is how well an environment can withstand duress. While this is of obvious importance to all organizations in the cloud, it is usually seen as defense against availability concerns, while the question has more to do with portability; option A is still preferable to option C. <br>Nothing in the question suggests a need for the company to retain some form of governance; option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      18,
      170,
      13,
      6,
      5
    ],
    "source": ""
  },
  {
    "id": 1311,
    "question": "Migrating to a cloud environment will reduce an organization\u2019s dependence on ___________________.",
    "choice_a": "Capital expenditures for IT",
    "choice_b": "Operational expenditures for IT",
    "choice_c": "Data-driven workflows",
    "choice_d": "Customer satisfaction",
    "correct_answer": "A",
    "explanation": "As a cloud customer, the organization is not responsible for making up-front infrastructure purchases, which are capital expenditures. <br>Cloud customers do, however, make continual operational expenditures for IT resources, in the form of their payments to cloud providers. Option B is incorrect. <br>Modern business is driven by data as much as any other input, regardless of sector or industry; this does not change whether the organization operates in the cloud or in the traditional IT environment. Option C is incorrect. <br>The cloud does not obviate the need to satisfy customers. Option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      6,
      8,
      9,
      7,
      5
    ],
    "source": ""
  },
  {
    "id": 1312,
    "question": "Firewalls, DLP (data loss prevention or data leak protection) and digital rights management (DRM) solutions, and security information and event management (SIEM) products are all examples of ___________________ controls.",
    "choice_a": "Technical",
    "choice_b": "Administrative",
    "choice_c": "Physical",
    "choice_d": "Competing",
    "correct_answer": "A",
    "explanation": "These are technical controls, automated systems that perform security functions. <br>An argument could be made that there is an administrative component to these controls as well: the firewall rules, the DLP data discovery strategy, etc.\u2014these are expressed in the form of a list or set of criteria, which might be viewed as an administrative control. However, the system itself (which is what the question asked) is still a technical control. Option A is preferable to option B. <br>Because these devices/systems do not deter physical intrusion, but rather logical intrusion, they are not considered physical controls. Option C is incorrect. <br>\u201cCompeting\u201d is not a control type; option D is incorrect.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      98,
      97,
      401,
      612,
      104
    ],
    "source": ""
  },
  {
    "id": 1313,
    "question": "Fiber-optic lines are considered part of Layer ___________________ of the Open Systems Interconnection (OSI) model.",
    "choice_a": "1",
    "choice_b": "3",
    "choice_c": "5",
    "choice_d": "7",
    "correct_answer": "A",
    "explanation": "The lines themselves are physical, which puts them at Layer 1. <br>All the other options are simply incorrect.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      686,
      685,
      687,
      714,
      713
    ],
    "source": ""
  },
  {
    "id": 1314,
    "question": "It is probably fair to assume that software as a service (SaaS) functions take place at Layer ___________________ of the OSI model.",
    "choice_a": "1",
    "choice_b": "3",
    "choice_c": "5",
    "choice_d": "7",
    "correct_answer": "D",
    "explanation": "Layer 7 is the application\u2019s entry point to networking. <br>All the other options are simply incorrect.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      685,
      687,
      714,
      713,
      712
    ],
    "source": ""
  },
  {
    "id": 1315,
    "question": "Because of the nature of the cloud, all access is remote access. One of the preferred technologies employed for secure remote access is ___________________.",
    "choice_a": "VPN",
    "choice_b": "HTML",
    "choice_c": "DEED",
    "choice_d": "DNS",
    "correct_answer": "A",
    "explanation": "A virtual private network (VPN) creates a trusted path across an untrusted (often public) network (such as the Internet). It is highly recommended for cloud operations. <br>Hypertext Markup Language (HTML) is used for displaying web pages; it is not inherently secure. Option B is incorrect. <br>DEED is an invented term with no meaning in this context. Option C is incorrect. <br>Domain Name System (DNS) is for resolving IP addresses to URLs; it has no inherent security benefits. Option D is incorrect.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      716,
      97,
      98,
      108,
      94
    ],
    "source": ""
  },
  {
    "id": 1316,
    "question": "You are the security manager for a small retailer engaged in e-commerce. A large part of your sales is transacted through the use of credit and debit cards. <br>You have determined that the costs of maintaining an encrypted storage capability in order to meet compliance requirements are prohibitive. What other technology can you use instead to meet those regulatory needs?",
    "choice_a": "Obfuscation",
    "choice_b": "Masking",
    "choice_c": "Tokenization",
    "choice_d": "Hashing",
    "correct_answer": "C",
    "explanation": "Tokenization is an approved alternative to encryption for complying with Payment Card Industry (PCI) requirements. <br>Obfuscation and masking don\u2019t really serve the purpose because they obscure data, making it unreadable; storing payment information that is unreadable does not aid in the efficiency of future transactions. Moreover, neither technique meets PCI requirements. Options A and B are incorrect. <br>Hashing does not serve the purpose because it is a one-way conversion of data; there is no way to retrieve payment information for future transactions once it has been hashed. Option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      255,
      392,
      494,
      414,
      396
    ],
    "source": ""
  },
  {
    "id": 1317,
    "question": "Which of the following mechanisms <italic>cannot</italic> be used by a data loss prevention or data leak protection (DLP) solution to sort data?",
    "choice_a": "Labels",
    "choice_b": "Metadata",
    "choice_c": "Content strings",
    "choice_d": "Inverse signifiers",
    "correct_answer": "D",
    "explanation": "This term has no meaning in this context and is only a distractor. <br>All the other mechanisms can be (and are) used by DLP solutions to sort data.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      690,
      689,
      688,
      413,
      414
    ],
    "source": ""
  },
  {
    "id": 1318,
    "question": "You are the security manager for an online marketing company. Your company has recently migrated to a cloud production environment and has deployed a number of new cloud-based protection mechanisms offered by both third parties and the cloud provider, including data loss prevention or data leak protection (DLP) and security information and event management (SIEM) solutions. <br>After one week of operation, your security team reports an inordinate amount of time responding to potential incidents that have turned out to only be false-positive reports. Management is concerned that the cloud migration was a bad idea and that it is too costly in terms of misspent security efforts. What do you recommend?",
    "choice_a": "Change the control set so that you use only security products not offered by the cloud provider.",
    "choice_b": "Change the control set so that you use only security products offered by the cloud provider.",
    "choice_c": "Wait three weeks before making a final decision.",
    "choice_d": "Move back to an on-premises environment as soon as possible to avoid additional wasted funds and effort.",
    "correct_answer": "C",
    "explanation": "Many security solutions, particularly DLP and similar tools, require a \u201clearning curve\u201d as they become accustomed to new data sets/configurations in order to discriminate between false positives and actual data loss. One week is not enough time to get an accurate determination of the efficacy of these products, and waiting to gather more data over time is a good idea. <br>The origin of the products probably does not matter in any significant way; options A and B are incorrect. <br>Hastily migrating out of the current cloud environment (whether to another cloud provider or back on-premises) is reactionary and could prove expensive. Option D is incorrect.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      402,
      401,
      333,
      636,
      638
    ],
    "source": ""
  },
  {
    "id": 1319,
    "question": "In a cloud context, who determines the risk appetite of your organization?",
    "choice_a": "The cloud provider",
    "choice_b": "Your Internet service provider (ISP)",
    "choice_c": "Federal regulators",
    "choice_d": "Senior management",
    "correct_answer": "D",
    "explanation": "Senior management is always responsible for determining the risk appetite of any organization, regardless of where and how it operates. <br>Neither the cloud provider, nor the ISP, nor federal regulators determine the risk appetite of your organization. Options A, B, and C are incorrect.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      240,
      238,
      241,
      536,
      457
    ],
    "source": ""
  },
  {
    "id": 1320,
    "question": "You are the security manager for a small application development company. Your company is considering the use of the cloud for software testing purposes. <br>Which of the following traits of cloud functionality is probably the <italic>most</italic> crucial in terms of deciding which cloud provider you will choose?",
    "choice_a": "Portability",
    "choice_b": "Interoperability",
    "choice_c": "Resiliency",
    "choice_d": "Governance",
    "correct_answer": "B",
    "explanation": "Because you will be creating proprietary software, you will probably be most concerned with how it will function across many platforms, in a virtualized environment, and in an environment that you do not own or operate. Interoperability describes how well a system relates to other systems. <br>Portability is always a concern for cloud customers, as it is an indication of how likely the customer is to be subject to the risk of vendor lock-in. However, because you are using your own proprietary software and not that of another company, this is not a major issue in this case. Option A is incorrect. <br>Resiliency is how well an environment can withstand duress. Although this is of obvious importance to all organizations, it is usually seen as a defense against availability concerns; the question has more to do with interoperability, and thus option B is still preferable to option C. <br>Nothing in the question suggests a need for the company to retain some form of governance; option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      8,
      136,
      225,
      7,
      158
    ],
    "source": ""
  },
  {
    "id": 1321,
    "question": "You are the security manager for a small application development company. Your company is considering the use of the cloud for software testing purposes. Which cloud service model is <italic>most</italic> likely to suit your needs?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "LaaS",
    "correct_answer": "B",
    "explanation": "Platform as a service (PaaS) allows a software development team to test their product across multiple OSs and hosting platforms, without the need for the customer to manage each one. <br>Although infrastructure as a service (IaaS) could offer similar cross-platform benefits, it would require additional effort and expertise on the part of the customer, which would not be nearly as appealing and efficient. Option A is incorrect. <br>Software as a service (SaaS) does not allow the customer to install software and would be useless for this purpose, making option C incorrect. <br>LaaS is not a cloud service model and has no meaning in this context. Option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      8,
      23,
      12,
      13,
      3
    ],
    "source": ""
  },
  {
    "id": 1322,
    "question": "ISO 31000 is most similar to which of the following regulations, standards, guidelines, and frameworks?",
    "choice_a": "NIST 800-37",
    "choice_b": "COBIT",
    "choice_c": "ITIL",
    "choice_d": "GDPR",
    "correct_answer": "A",
    "explanation": "Both ISO 31000 and National Institute of Standards and Technology (NIST) 800-37 are risk management frameworks. <br>Control Objectives for Information and Related Technology (COBIT) is ISACA\u2019s framework for managing IT and IT controls, largely from a process and governance perspective. Though it includes elements of risk management, NIST 800-37 is still closer in nature to ISO 31000, so option A is preferable to B. <br>ITIL\u00a0(Information Technology Infrastructure Library) is a framework mostly focused on service delivery as opposed to risk management; option C is incorrect. <br>The General Data Protection Regulation (GDPR) is a European Union law regarding privacy information, not risk management; option D is incorrect.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      363,
      361,
      354,
      646,
      360
    ],
    "source": ""
  },
  {
    "id": 1323,
    "question": "Which of the following entities publishes a cloud-centric set of risk-benefit recommendations that includes a \u201cTop 8\u201d list of security risks an organization might face during a cloud migration, based on likelihood and impact?",
    "choice_a": "National Institute of Standards and Technology (NIST)",
    "choice_b": "International Organization for Standardization (ISO)",
    "choice_c": "European Union Agency for Network and Information Security (ENISA)",
    "choice_d": "Payment Card Industry (PCI)",
    "correct_answer": "C",
    "explanation": "The <italic>ENISA Cloud Computing: Benefits, Risks, and Recommendations for Information Security</italic> is the publication. <br>All the other options are standards bodies but do not have a publication that matches the description in the question as well.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      42,
      48,
      50,
      52,
      684
    ],
    "source": ""
  },
  {
    "id": 1324,
    "question": "Which standards body depends heavily on contributions and input from its open membership base?",
    "choice_a": "National Institute of Standards and Technology (NIST)",
    "choice_b": "International Organization for Standardization (ISO)",
    "choice_c": "Internet Corporation for Assigned Names and Numbers (ICANN)",
    "choice_d": "Cloud Security Alliance (CSA)",
    "correct_answer": "D",
    "explanation": "The Cloud Security Alliance is a volunteer organization that includes members from various industries and sectors and is focused on cloud computing. It relies largely on member participation for developing standards. <br>All the other options are standards bodies that involve a specific board or other centralized authority for publishing requirements.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      646,
      648,
      358,
      360,
      359
    ],
    "source": ""
  },
  {
    "id": 1325,
    "question": "In regard to most privacy guidance, the data subject is ___________________.",
    "choice_a": "The individual described by the privacy data",
    "choice_b": "The entity that collects or creates the privacy data",
    "choice_c": "The entity that uses privacy data on behalf of the controller",
    "choice_d": "The entity that regulates privacy data",
    "correct_answer": "A",
    "explanation": "Option A is the definition of the data subject. <br>All the other options define other privacy-related roles.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      658,
      660,
      337,
      339,
      652
    ],
    "source": ""
  },
  {
    "id": 1326,
    "question": "In regard to most privacy guidance, the data controller is ___________________.",
    "choice_a": "The individual described by the privacy data",
    "choice_b": "The entity that collects or creates the privacy data",
    "choice_c": "The entity that uses privacy data on behalf of the controller",
    "choice_d": "The entity that regulates privacy data",
    "correct_answer": "B",
    "explanation": "Option B is the definition of the data controller. <br>All the other options define other privacy-related roles.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      658,
      659,
      660,
      656,
      652
    ],
    "source": ""
  },
  {
    "id": 1327,
    "question": "In regard to most privacy guidance, the data processor is ___________________.",
    "choice_a": "The individual described by the privacy data",
    "choice_b": "The entity that collects or creates the privacy data",
    "choice_c": "The entity that uses privacy data on behalf of the controller",
    "choice_d": "The entity that regulates privacy data",
    "correct_answer": "C",
    "explanation": "Option C is the definition of the data processor. <br>All the other options define other privacy-related roles.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      658,
      659,
      660,
      656,
      337
    ],
    "source": ""
  },
  {
    "id": 1328,
    "question": "In most privacy-regulation situations, which entity is <italic>most</italic> responsible for deciding how a particular privacy-related data set will be used or processed?",
    "choice_a": "The data subject",
    "choice_b": "The data controller",
    "choice_c": "The data steward",
    "choice_d": "The data custodian",
    "correct_answer": "B",
    "explanation": "The data controller makes the determination of purpose and scope of privacy-related data sets. <br>The other options are the names of other privacy-related roles.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      660,
      658,
      659,
      656,
      652
    ],
    "source": ""
  },
  {
    "id": 1329,
    "question": "In most privacy-regulation situations, which entity is <italic>most</italic> responsible for the day-to-day maintenance and security of a privacy-related data set?",
    "choice_a": "The data subject",
    "choice_b": "The data controller",
    "choice_c": "The data steward",
    "choice_d": "The data custodian",
    "correct_answer": "D",
    "explanation": "The data custodian is usually tasked with securing and maintaining the privacy data on a regular basis, on behalf and under the guidance of the controller and steward. <br>The other options are the names of other privacy-related roles.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      658,
      660,
      339,
      652,
      347
    ],
    "source": ""
  },
  {
    "id": 1330,
    "question": "You are the compliance officer for a medical device manufacturing firm. Your company maintains a cloud-based list of patients currently fitted with your devices for long-term care and quality assurance purposes. The list is maintained in a database that cross-references details about the hardware and some billing data. <br>In this situation, who is likely to be considered the data custodian, under many privacy regulations and laws?",
    "choice_a": "You (the compliance officer)",
    "choice_b": "The cloud provider\u2019s network security team",
    "choice_c": "Your company",
    "choice_d": "The database administrator",
    "correct_answer": "D",
    "explanation": "The custodian is usually that specific entity in charge of maintaining and securing the privacy-related data on a daily basis, as an element of the data\u2019s use. <br>The compliance officer might be considered a representative of the data controller (your company), or perhaps the data steward, depending on how much actual responsibility and interaction with the data you have on a regular basis. Option A is not as accurate as option D. <br>The cloud provider (and anyone working for the provider) would be considered the data processor under most privacy regulation; option B is incorrect. <br>Your company is the data controller, the legal entity ultimately responsible for the data. Option C is incorrect.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      658,
      660,
      339,
      652,
      357
    ],
    "source": ""
  },
  {
    "id": 1331,
    "question": "Which of the following is probably <italic>least</italic> suited for inclusion in the service-level agreement (SLA) between a cloud customer and cloud provider?",
    "choice_a": "Bandwidth",
    "choice_b": "Jurisdiction",
    "choice_c": "Storage space",
    "choice_d": "Availability",
    "correct_answer": "B",
    "explanation": "The SLA should contain elements of the contract that can be subject to discrete, objective, repeatable, numeric metrics. Jurisdiction is usually dictated by location instead, which should be included in the contract but is probably not useful to include in the SLA. <br>All the other options are excellent examples of items that can and should be included in the SLA.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      710,
      343,
      344,
      648,
      651
    ],
    "source": ""
  },
  {
    "id": 1332,
    "question": "Which of the following items, included in the contract between a cloud customer and cloud provider, can best aid in reducing vendor lock-in?",
    "choice_a": "Data format type and structure",
    "choice_b": "Availability",
    "choice_c": "Storage space",
    "choice_d": "List of available operating systems (OSs)",
    "correct_answer": "A",
    "explanation": "When the cloud customer can ensure that their data will not be ported to a proprietary data format or system, the customer has a better assurance of not being constrained to a given provider; a platform-agnostic data set is more portable and less subject to vendor lock-in. <br>Availability may be an aspect of portability; the ease and speed at which the customer can access their own data can influence how readily the data might be moved to another provider. However, this is less influential than the format and structure of the data; option A is preferable to option B. <br>Storage space has little to do with vendor lock-in; option C is incorrect. <br>A list of OSs the provider offers might be influential for the customer\u2019s decision of which provider to select, but it is not typically a constraining factor that would restrict portability. Option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      18,
      229,
      231,
      170,
      237
    ],
    "source": ""
  },
  {
    "id": 1333,
    "question": "Which of the following contract terms <italic>most</italic> incentivizes the cloud provider to meet the requirements listed in the service-level agreement (SLA)?",
    "choice_a": "Regulatory oversight",
    "choice_b": "Financial penalties",
    "choice_c": "Performance details",
    "choice_d": "Desire to maintain customer satisfaction",
    "correct_answer": "B",
    "explanation": "The contract usually stipulates what kind of financial penalties are imposed when the provider fails to meet the SLAs (for instance, waiver for payment of a given service term). This is a huge motivating element for the provider. <br>Regulatory oversight usually affects the customer, not the provider; option A is incorrect. <br>The performance details are often included in the SLA but aren\u2019t the motivating factor; option C is incorrect. <br>In a perfect world, option D would be the correct answer; B is a better answer to this question, however.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      710,
      344,
      358,
      648,
      651
    ],
    "source": ""
  },
  {
    "id": 1334,
    "question": "Which of the following contract terms <italic>most</italic> incentivizes the cloud customer to meet the requirements listed in the contract?",
    "choice_a": "Financial penalties",
    "choice_b": "Regulatory oversight",
    "choice_c": "Suspension of service",
    "choice_d": "Media attention",
    "correct_answer": "C",
    "explanation": "The cloud provider is usually allowed to suspend service to the customer if the customer fails to meet the contract requirements (specifically, not paying for the service in accordance with the contract terms). This can be fatal to a customer\u2019s operations and is a great motivation to make timely payments. <br>Option A is incorrect because the cloud provider would be the entity that would face financial penalties for not fulfilling the SLA. <br>Options B and D are incorrect because regulatory oversight and media attention cannot be controlled by the contract between cloud provider and customer.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      710,
      709,
      338,
      339,
      646
    ],
    "source": ""
  },
  {
    "id": 1335,
    "question": "Which of the following is <italic>not</italic> a reason for conducting audits?",
    "choice_a": "Regulatory compliance",
    "choice_b": "Enhanced user experience",
    "choice_c": "Determination of service quality",
    "choice_d": "Security assurance",
    "correct_answer": "B",
    "explanation": "Audits don\u2019t really provide any perceptible effect on user experience. <br>All the other options are good reasons for performing audits.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      344,
      340,
      343,
      351,
      358
    ],
    "source": ""
  },
  {
    "id": 1336,
    "question": "Which of the following is a tool that can be used to perform security control audits?",
    "choice_a": "Federal Information Processing Standard (FIPS) 140-2",
    "choice_b": "General Data Protection Regulation (GDPR)",
    "choice_c": "ISO 27001",
    "choice_d": "Cloud Security Alliance Cloud Controls Matrix (CSA CCM)",
    "correct_answer": "D",
    "explanation": "The Cloud Controls Matrix is an excellent tool for determining completeness and possible replication of security controls. <br>FIPS 140-2 is a list of cryptographic system products approved for use by U.S. federal customers; option A is incorrect. <br>The GDPR is a European Union law regarding privacy; ostensibly, an audit could be performed to ensure that an organization is meeting the law\u2019s requirements, but the law itself is not a tool for the purpose. Option B is incorrect. <br>ISO 27001 details the information security management system an organization can adopt; it is not specifically a tool for reviewing cloud security controls. Option C is incorrect.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      648,
      358,
      646,
      344,
      341
    ],
    "source": ""
  },
  {
    "id": 1337,
    "question": "Which of the following dictates the requirements for U.S. federal agencies operating in a cloud environment?",
    "choice_a": "ISO 27002",
    "choice_b": "NIST SP 800-37",
    "choice_c": "ENISA",
    "choice_d": "FedRAMP",
    "correct_answer": "D",
    "explanation": "Federal Risk and Authorization Management Program (FedRAMP) is the U.S. program for federal entities operating in the cloud. <br>The International Organization for Standardization (ISO) is an international standards body and does not dictate American government practices. Option A is incorrect. <br>National Institute of Standards and Technology (NIST) Special Publication (SP) 800-37 is the Risk Management Framework (RMF) not specifically related to the cloud; option D is preferable to option B. <br>The European Union Agency for Network and Information Security (ENISA) is a European Union standards body and does not dictate American government practices. Option C is incorrect.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      675,
      347,
      648,
      646,
      354
    ],
    "source": ""
  },
  {
    "id": 1338,
    "question": "Which of the following common aspects of cloud computing can aid in audit efforts?",
    "choice_a": "Scalability",
    "choice_b": "Virtualization",
    "choice_c": "Multitenancy",
    "choice_d": "Metered self-service",
    "correct_answer": "B",
    "explanation": "A ubiquitous baseline configuration used in a virtualized environment can serve as an artifact for auditors and enhance the audit process. <br>The other options are common facets of cloud computing but do not typically serve the purpose of auditing.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      124,
      343,
      341,
      662,
      663
    ],
    "source": ""
  },
  {
    "id": 1339,
    "question": "Which of the following does <italic>not</italic> typically represent a means for enhanced authentication?",
    "choice_a": "Challenge questions",
    "choice_b": "Variable keystrokes",
    "choice_c": "Out-of-band identity confirmation",
    "choice_d": "Dynamic end-user knowledge",
    "correct_answer": "B",
    "explanation": "Variables, in general, aren\u2019t useful for authentication; authentication requires a match against a template or a known quantity. <br>All the other options are typical methods for enhancing authentication.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      692,
      691,
      693,
      48,
      54
    ],
    "source": ""
  },
  {
    "id": 1340,
    "question": "Which of the following is <italic>not</italic> a common identity federation standard?",
    "choice_a": "WS-Federation",
    "choice_b": "OpenID",
    "choice_c": "OISame",
    "choice_d": "Security Assertion Markup Language (SAML)",
    "correct_answer": "C",
    "explanation": "This is a nonsense term, with no meaning in this context. <br>All the other options are actual common identity federation standards.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      695,
      694,
      575,
      574,
      367
    ],
    "source": ""
  },
  {
    "id": 1341,
    "question": "Multifactor authentication typically includes two or more of all the following elements <italic>except</italic> ___________________.",
    "choice_a": "What you know",
    "choice_b": "Who you know",
    "choice_c": "What you are",
    "choice_d": "What you have",
    "correct_answer": "B",
    "explanation": "Multifactor authentication doesn\u2019t typically utilize associative identification. <br>All the other options are typical aspects used in multifactor authentication.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      436,
      438,
      437,
      288,
      585
    ],
    "source": ""
  },
  {
    "id": 1342,
    "question": "Which of the following aspects of cloud computing can enhance the customer\u2019s business continuity and disaster recovery (BC/DR) efforts?",
    "choice_a": "Multitenancy",
    "choice_b": "Pooled resources",
    "choice_c": "Virtualization",
    "choice_d": "Remote access",
    "correct_answer": "D",
    "explanation": "Because the cloud environment can be accessed from any location (assuming good connectivity), the cloud customer is not required to maintain an expensive operational facility, either for primary or backup purposes. <br>All the other options are common aspects of cloud computing, but don\u2019t particularly serve BC/DR purposes.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      334,
      319,
      544,
      403,
      545
    ],
    "source": ""
  },
  {
    "id": 1343,
    "question": "Which of the following aspects of cloud computing can enhance the customer\u2019s business continuity and disaster recovery (BC/DR) efforts?",
    "choice_a": "Rapid elasticity",
    "choice_b": "Online collaboration",
    "choice_c": "Support of common regulatory frameworks",
    "choice_d": "Attention to customer service",
    "correct_answer": "A",
    "explanation": "Rapid elasticity allows the cloud customer to scale cloud operations as necessary, including during contingency operations; this is extremely useful for BC/DR activities. <br>All the other options are common aspects of cloud computing but don\u2019t particularly serve BC/DR purposes.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      319,
      334,
      336,
      526,
      428
    ],
    "source": ""
  },
  {
    "id": 1344,
    "question": "Which of the following aspects of cloud computing can enhance the customer\u2019s business continuity and disaster recovery (BC/DR) efforts?",
    "choice_a": "On-demand self-service",
    "choice_b": "Pooled resources",
    "choice_c": "Virtualization",
    "choice_d": "The control plane",
    "correct_answer": "A",
    "explanation": "On-demand self-service allows the cloud customer to provision those production resources during a contingency without any delay in ordering or allocating those resources. <br>All the other options are common aspects of cloud computing but don\u2019t particularly serve BC/DR purposes.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      319,
      334,
      544,
      526,
      428
    ],
    "source": ""
  },
  {
    "id": 1345,
    "question": "What functional process can aid business continuity and disaster recovery (BC/DR) efforts?",
    "choice_a": "The software development life cycle (SDLC)",
    "choice_b": "Data classification",
    "choice_c": "Honeypots",
    "choice_d": "Identity management",
    "correct_answer": "B",
    "explanation": "The data classification process is the organization\u2019s formal means of determining value of its assets; this is extremely important to BC/DR efforts in that it can be useful in determining the critical path to be maintained during contingency events. <br>The SDLC is a system development/acquisition tool; it doesn\u2019t particularly assist in BC/DR efforts. Option A is incorrect. <br>Honeypots are a threat intelligence tool; they don\u2019t serve any useful BC/DR purpose. Option C is incorrect. <br>Identity management is a part of the entitlement process but does not add any value to BC/DR efforts; option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      544,
      336,
      319,
      334,
      239
    ],
    "source": ""
  },
  {
    "id": 1346,
    "question": "Which common security tool can aid in the overall business continuity and disaster recovery (BC/DR) process?",
    "choice_a": "Honeypots",
    "choice_b": "Data loss prevention or data leak protection (DLP)",
    "choice_c": "Security information and event management (SIEM)",
    "choice_d": "Firewalls",
    "correct_answer": "B",
    "explanation": "DLP solutions typically have the capability to aid in asset valuation and location, both important facets of the BC/DR process. <br>All the other options are common security tools but don\u2019t really serve to enhance BC/DR efforts.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      238,
      59,
      544,
      336,
      240
    ],
    "source": ""
  },
  {
    "id": 1347,
    "question": "Which of the following aspects of cloud computing can enhance the customer\u2019s business continuity and disaster recovery (BC/DR) efforts?",
    "choice_a": "Geographical separation of data centers",
    "choice_b": "Hypervisor security",
    "choice_c": "Pooled resources",
    "choice_d": "Multitenancy",
    "correct_answer": "A",
    "explanation": "Because cloud data is typically spread across more than one data center and these data centers can be geographically separated, a single natural disaster event may be less likely to reduce access to the data. <br>All the other options are common aspects of cloud computing but don\u2019t particularly serve BC/DR purposes.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      334,
      319,
      544,
      729,
      403
    ],
    "source": ""
  },
  {
    "id": 1348,
    "question": "Which of the following is <italic>not</italic> typically used as an information source for business continuity and disaster recovery (BC/DR) event anticipation?",
    "choice_a": "Open source news",
    "choice_b": "Business threat intelligence",
    "choice_c": "Egress monitoring solutions",
    "choice_d": "Weather monitoring agencies",
    "correct_answer": "C",
    "explanation": "Egress-monitoring solutions do not typically predict contingency-level events and are not useful for the purpose. <br>All the other options represent information sources that can aid in predicting BC/DR events.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      697,
      699,
      45,
      61,
      60
    ],
    "source": ""
  },
  {
    "id": 1349,
    "question": "Which of the following aspects of the business continuity and disaster recovery (BC/DR) process poses a risk to the organization?",
    "choice_a": "Premature return to normal operations",
    "choice_b": "Event anticipation information",
    "choice_c": "Assigning roles for BC/DR activities",
    "choice_d": "Preparing the continuity-of-operations plan",
    "correct_answer": "A",
    "explanation": "A hasty return to normal operations can put operations and personnel at risk if whatever caused the contingency situation has not yet been fully resolved. <br>All the other options are common aspects of BC/DR preparation and do not typically pose a threat to the organization.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      544,
      334,
      319,
      403,
      557
    ],
    "source": ""
  },
  {
    "id": 1350,
    "question": "Which of the following aspects of the business continuity and disaster recovery (BC/DR) process poses a risk to the organization?",
    "choice_a": "Threat intelligence gathering",
    "choice_b": "Preplacement of response assets",
    "choice_c": "Budgeting for disaster",
    "choice_d": "Full testing of the plan",
    "correct_answer": "D",
    "explanation": "A full test of the BC/DR plan can result in an actual disaster because it may involve interruption of service; the simulation can become the reality. <br>All the other options are common aspects of BC/DR preparation and do not typically pose a threat to the organization.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      544,
      319,
      334,
      545,
      697
    ],
    "source": ""
  },
  {
    "id": 1351,
    "question": "In container virtualization, unlike standard virtualization, what is <italic>not</italic> included?",
    "choice_a": "Hardware emulation",
    "choice_b": "OS replication",
    "choice_c": "A single kernel",
    "choice_d": "The possibility for multiple containers",
    "correct_answer": "A",
    "explanation": "In containerization, the underlying hardware is not emulated; the container(s) run on the same underlying kernel, sharing the majority of the base OS. <br>All the other options are aspects of containerization.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      532,
      534,
      50,
      49,
      53
    ],
    "source": ""
  },
  {
    "id": 1352,
    "question": "Which of the following is <italic>not</italic> typically a phase in the software development life cycle (SDLC)?",
    "choice_a": "Define",
    "choice_b": "Test",
    "choice_c": "Develop",
    "choice_d": "Sanitization",
    "correct_answer": "D",
    "explanation": "Secure sanitization is not included in all (or even many) SDLC models. <br>The other options are typical SDLC steps.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      441,
      439,
      300,
      295,
      299
    ],
    "source": ""
  },
  {
    "id": 1353,
    "question": "An application programming interface (API) gateway can typically offer all of the following capabilities <italic>except</italic> ___________________.",
    "choice_a": "Rate limiting",
    "choice_b": "Access control",
    "choice_c": "Hardware confirmation",
    "choice_d": "Logging",
    "correct_answer": "C",
    "explanation": "Hardware confirmation is a meaningless term in this respect. <br>All the other options represent common capabilities of API gateways.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      700,
      701,
      452,
      702,
      577
    ],
    "source": ""
  },
  {
    "id": 1354,
    "question": "Cloud customers in a public cloud managed services environment can install all the following types of firewalls <italic>except</italic> ___________________.",
    "choice_a": "Provider operated",
    "choice_b": "Host based",
    "choice_c": "Third party",
    "choice_d": "Hardware",
    "correct_answer": "D",
    "explanation": "Cloud customers, with rare exception, will not be allowed to add hardware to the cloud data center. <br>All the other options are various types of firewalls that a customer could implement in a cloud managed services environment.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      98,
      96,
      95,
      94,
      108
    ],
    "source": ""
  },
  {
    "id": 1355,
    "question": "The Transport Layer Security (TLS) protocol creates a secure communications channel over public media (such as the Internet). In a typical TLS session, who initiates the protocol?",
    "choice_a": "The server",
    "choice_b": "The client",
    "choice_c": "The certifying authority",
    "choice_d": "The Internet service provider (ISP)",
    "correct_answer": "B",
    "explanation": "In a typical TLS handshake, the client sends the message (called ClientHello) that initiates the negotiation of the session. <br>All the other options are incorrect.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      608
    ],
    "source": ""
  },
  {
    "id": 1356,
    "question": "The Transport Layer Security (TLS) protocol creates a secure communications channel over public media (such as the Internet). In a typical TLS session, what is the <italic>usual</italic> means for establishing trust between the parties?",
    "choice_a": "Out-of-band authentication",
    "choice_b": "Multifactor authentication",
    "choice_c": "Public-key infrastructure (PKI) certificates",
    "choice_d": "Preexisting knowledge of each other",
    "correct_answer": "C",
    "explanation": "TLS usually relies on PKI certificates authenticated and issued by a trusted third party. <br>All the other options are incorrect because they are not the usual means of establishing trust between the parties in a typical TLS session.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 1357,
    "question": "The Transport Layer Security (TLS) protocol creates a secure communications channel over public media (such as the Internet). In a typical TLS session, what form of cryptography is used for the session key?",
    "choice_a": "Symmetric key",
    "choice_b": "Asymmetric key pairs",
    "choice_c": "Hashing",
    "choice_d": "One asymmetric key pair",
    "correct_answer": "A",
    "explanation": "In TLS, the parties will establish a shared secret, or symmetric key, for the duration of the session. <br>All the other options are incorrect because they are not the form of cryptography used for the session key in a TLS session.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      100,
      716,
      98,
      97,
      108
    ],
    "source": ""
  },
  {
    "id": 1358,
    "question": "DevOps is a form of software development that typically joins the software development team with ___________________.",
    "choice_a": "The production team",
    "choice_b": "The marketing team",
    "choice_c": "The security office",
    "choice_d": "Management",
    "correct_answer": "A",
    "explanation": "In DevOps, the programmers continually work in close conjunction with the production team to ensure that the project will meet their needs. <br>All the other options are simply incorrect.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      678,
      441,
      300,
      299,
      580
    ],
    "source": ""
  },
  {
    "id": 1359,
    "question": "The Agile Manifesto for software development focuses largely on ___________________.",
    "choice_a": "Secure build",
    "choice_b": "Thorough documentation",
    "choice_c": "Working prototypes",
    "choice_d": "Proper planning",
    "correct_answer": "C",
    "explanation": "The Agile Manifesto specifically advocates for getting sample systems into the hands of the users as soon as possible in order to ensure that development is meeting customer needs. The Manifesto refutes all other elements of programming that slow down this effort, including documentation, planning, processes, and specific tools.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 1360,
    "question": "When a program\u2019s source code is open to review by the public, what is that software called?",
    "choice_a": "Freeware",
    "choice_b": "Malware",
    "choice_c": "Open source",
    "choice_d": "Shareware",
    "correct_answer": "C",
    "explanation": "Open source software includes programs where customers (or even the public) can view the software\u2019s source code. <br>Freeware and shareware are licensing arrangements and ways of distributing intellectual property. Options A and D are incorrect. <br>Malware is harmful software designed for attack purposes; option B is incorrect.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      268,
      269,
      298,
      74,
      67
    ],
    "source": ""
  },
  {
    "id": 1361,
    "question": "Why is Simple Object Access Protocol (SOAP) used for accessing web services instead of the Distributed Component Object Model (DCOM) and the Common Object Request Broker Architecture (CORBA)?",
    "choice_a": "SOAP provides a much more lightweight solution.",
    "choice_b": "SOAP replaces binary messaging with XML.",
    "choice_c": "SOAP is much more secure.",
    "choice_d": "SOAP is newer.",
    "correct_answer": "B",
    "explanation": "XML works better over the Internet than the binary messaging of the older technologies. <br>SOAP is not particularly lightweight; in fact, it is kind of cumbersome. Option A is not true. <br>SOAP is not especially more secure than DCOM or CORBA; option C is incorrect. <br>SOAP is newer than the other technologies; however, that is not the reason it is preferable in a web context. Option B is still preferable to D.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      559,
      560,
      398,
      703,
      576
    ],
    "source": ""
  },
  {
    "id": 1362,
    "question": "How does representational state transfer (REST) make web service requests?",
    "choice_a": "XML",
    "choice_b": "SAML",
    "choice_c": "URIs",
    "choice_d": "TLS",
    "correct_answer": "C",
    "explanation": "REST calls web resources by using uniform resource identifiers (URIs). <br>Extensible Markup Language (XML) may be used for REST, but it is not a requirement as it is in Simple Object Access Protocol (SOAP). Option A is incorrect. <br>Security Assertion Markup Language (SAML) is a form of XML used in passing identity assertions; option B is incorrect. <br>Transport Layer Security (TLS) is a secure virtual private network (VPN) mechanism, not an element of SOAP. Option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      703,
      705,
      398,
      567,
      566
    ],
    "source": ""
  },
  {
    "id": 1363,
    "question": "Representational state transfer (REST) outputs often take the form of ___________________.",
    "choice_a": "JavaScript Object Notation (JSON)",
    "choice_b": "Certificates",
    "choice_c": "Database entries",
    "choice_d": "WS-Policy",
    "correct_answer": "A",
    "explanation": "JSON outputs are common for REST applications. <br>All the other options are incorrect because they are not the form of output one would expect from REST.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      707,
      568,
      569,
      398,
      277
    ],
    "source": ""
  },
  {
    "id": 1364,
    "question": "\u201cSensitive data exposure\u201d is often included on the list of the Open Web Application Security Project (OWASP) Top Ten web application vulnerabilities. In addition to programming discipline and technological controls, what other approach is important for reducing this risk?",
    "choice_a": "Physical access control to the facility",
    "choice_b": "User training",
    "choice_c": "Crafting sophisticated policies",
    "choice_d": "Redundant backup power",
    "correct_answer": "B",
    "explanation": "Sensitive data is often exposed inadvertently because of user error or lack of knowledge about the material. User training can offset a significant portion of this risk by informing users about the value of data assets and the proper use of controls and behaviors. <br>Physical access control is important, but less for controlling exposure and more for preventing theft. Option B is preferable to A in this context. <br>Policies are crucial but don\u2019t actually offset the risk; they are the underlying structure for creating programs and methods for dealing with the risk. Option B is preferable to C in this case. <br>Backup power has nothing to do with data exposure, therefore option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      437,
      82,
      74,
      294,
      63
    ],
    "source": ""
  },
  {
    "id": 1365,
    "question": "During maintenance mode for a given node in a virtualized environment, which of the following conditions is <italic>not</italic> accurate?",
    "choice_a": "Generation of new instances is prevented.",
    "choice_b": "Admin access is prevented.",
    "choice_c": "Alerting mechanisms are suspended.",
    "choice_d": "Events are logged.",
    "correct_answer": "B",
    "explanation": "Administrators will access devices during maintenance mode; blocking admin access would be contrary to the entire point of the activity. <br>All other options are conditions that are true during maintenance mode.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      328,
      620,
      330,
      329,
      614
    ],
    "source": ""
  },
  {
    "id": 1366,
    "question": "How are virtual machines (VMs) moved from active hosts when the host is being put into maintenance mode?",
    "choice_a": "As a snapshotted image file",
    "choice_b": "In encrypted form",
    "choice_c": "As a live instance",
    "choice_d": "Via portable media",
    "correct_answer": "C",
    "explanation": "Live migration is the term used to describe the movement of functioning virtual instances from one physical host to another and how VMs are moved prior to maintenance on a physical device. <br>VMs are moved as image snapshots when they are transitioned from production to storage; option A is incorrect. <br>During live migration, the VM moves in unencrypted form. Option B is incorrect. <br>Live migration goes over the network; portable media is not necessary. Option D is incorrect.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      105,
      107,
      620,
      619,
      94
    ],
    "source": ""
  },
  {
    "id": 1367,
    "question": "Which of the following is <italic>not</italic> a typical mechanism used by intrusion detection system (IDS) and intrusion prevention system (IPS) solutions to detect threats?",
    "choice_a": "Signature-based detection",
    "choice_b": "User input",
    "choice_c": "Statistical-based detection",
    "choice_d": "Heuristic detection",
    "correct_answer": "B",
    "explanation": "IDS/IPS solutions do not elicit user input. <br>All the other options are mechanisms used by IDS/IPS solutions to detect threats.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      98,
      402,
      401,
      303,
      302
    ],
    "source": ""
  },
  {
    "id": 1368,
    "question": "When you\u2019re deploying a honeypot/honeynet, it is best to fill it with ___________________ data.",
    "choice_a": "Masked",
    "choice_b": "Raw",
    "choice_c": "Encrypted",
    "choice_d": "Useless",
    "correct_answer": "D",
    "explanation": "Because the honeypot/honeynet is meant to be observed, production data in any form should not be included. <br>All the other options are insufficient for the question; D is, by far, the best answer.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      613,
      598,
      600,
      112,
      318
    ],
    "source": ""
  },
  {
    "id": 1369,
    "question": "The cloud provider should be required to make proof of vulnerability scans available to all of the following <italic>except</italic> ___________________.",
    "choice_a": "Regulators",
    "choice_b": "The public",
    "choice_c": "Auditors",
    "choice_d": "The cloud customer",
    "correct_answer": "B",
    "explanation": "The public does not have a need to know regarding proof of vulnerability scans. <br>All the other options are legitimate recipients of proof of vulnerability scans.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      648,
      344,
      360,
      651,
      650
    ],
    "source": ""
  },
  {
    "id": 1370,
    "question": "You are the security director for a chain of automotive repair centers across several states. Your company uses a cloud software as a service (SaaS) provider for business functions that cross several of the locations of your facilities, such as ordering of parts, logistics and inventory, billing, and marketing. <br>The manager at one of your newest locations reports that there is a competing car repair company that has a logo that looks almost exactly like the one your company uses. This intellectual property is likely protected as a ___________________.",
    "choice_a": "Copyright",
    "choice_b": "Trademark",
    "choice_c": "Patent",
    "choice_d": "Trade secret",
    "correct_answer": "B",
    "explanation": "Logos and other identifying material are subject to trademark protections. <br>The other options are also ways to protect intellectual property, but they are not usually associated with logos.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      385,
      386,
      395,
      29,
      25
    ],
    "source": ""
  },
  {
    "id": 1371,
    "question": "You are the security director for a chain of automotive repair centers across several states. Your company uses a cloud software as a service (SaaS) provider for business functions that cross several of the locations of your facilities, such as ordering of parts, logistics and inventory, billing, and marketing. <br>The manager at one of your newest locations reports that there is a competing car repair company that has a logo that looks almost exactly like the one your company uses. This conflict will <italic>most</italic> likely have to be resolved with what legal method?",
    "choice_a": "Breach of contract lawsuit",
    "choice_b": "Criminal prosecution",
    "choice_c": "Civil suit",
    "choice_d": "Military tribunal",
    "correct_answer": "C",
    "explanation": "Intellectual property disputes are usually settled in civil court, as a conflict among private parties. <br>Because there was no agreement between your company and the competitor in question, there is no contract, so no breach of contract dispute is pertinent. Option A is incorrect. <br>Although statutes concerning intellectual property protections exist, they are usually in the form of torts (that is, laws that define how civil actions can pursue restitution for private harm). This is not the government prosecuting someone in order to protect the public; criminal proceedings are rare when it comes to enforcing intellectual property rights. Option B is incorrect. <br>The military does not often get involved in intellectual property disputes and most often uses the civil courts when it does. Option D is incorrect.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      711,
      670,
      665,
      666,
      672
    ],
    "source": ""
  },
  {
    "id": 1372,
    "question": "You are the security director for a chain of automotive repair centers across several states. Your company uses a cloud software as a service (SaaS) provider for business functions that cross several of the locations of your facilities, such as ordering of parts, logistics and inventory, billing, and marketing. <br>The manager at one of your newest locations reports that there is a competing car repair company that has a logo that looks almost exactly like the one your company uses. What will <italic>most likely</italic> affect the determination of who has ownership of the logo?",
    "choice_a": "Whoever first used the logo",
    "choice_b": "The jurisdiction where both businesses are using the logo simultaneously",
    "choice_c": "Whoever first applied for legal protection of the logo",
    "choice_d": "Whichever entity has the most customers who recognize the logo",
    "correct_answer": "C",
    "explanation": "Trademark protection is provided to those who apply for it, to either a state or federal trademark registration body. In the case of conflicting usage (or infringement), courts will take many criteria into account, including which party has first claim on the trademark (that is, who used it the longest), the location(s) where the trademark is used, the possibility for confusion among customers, and so forth. But for a specific location and specific business purpose, the deciding element will probably be which party first registered the trademark in question. <br>All the other options may be factors the court takes into account when making its decision, but option C is the best answer.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      711,
      648,
      646,
      650,
      665
    ],
    "source": ""
  },
  {
    "id": 1373,
    "question": "Which Statement on Standards for Attestation Engagements (SSAE) 18 audit report is simply an attestation of audit results?",
    "choice_a": "Service Organization Control (SOC) 1",
    "choice_b": "SOC 2, Type 1",
    "choice_c": "SOC 2, Type 2",
    "choice_d": "SOC 3",
    "correct_answer": "D",
    "explanation": "This is the definition of a SOC 3. <br>All the other options are SSAE 18 reports but not the correct answer.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      343,
      344,
      349,
      341,
      350
    ],
    "source": ""
  },
  {
    "id": 1374,
    "question": "Which Statement on Standards for Attestation Engagements (SSAE) 18 report is purposefully designed for public release (for instance, to be posted on a company\u2019s website)?",
    "choice_a": "Service Organization Control (SOC) 1",
    "choice_b": "SOC 2, Type 1",
    "choice_c": "SOC 2, Type 2",
    "choice_d": "SOC 3",
    "correct_answer": "D",
    "explanation": "This is the purpose of the SOC 3 report. <br>All the other options are SSAE 18 reports but not the correct answer.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      349,
      343,
      344,
      350,
      345
    ],
    "source": ""
  },
  {
    "id": 1375,
    "question": "Which of the following countries has a national privacy law that conforms to European Union (EU) legislation?",
    "choice_a": "The United States",
    "choice_b": "Australia",
    "choice_c": "Jamaica",
    "choice_d": "Honduras",
    "correct_answer": "B",
    "explanation": "Both Australia and New Zealand have privacy laws that conform to EU privacy legislation. <br>All the other options are examples of countries that do not.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      656,
      348,
      357,
      651,
      347
    ],
    "source": ""
  },
  {
    "id": 1376,
    "question": "Which of the following countries has a national privacy law that conforms to European Union (EU) legislation?",
    "choice_a": "Japan",
    "choice_b": "Alaska",
    "choice_c": "Belize",
    "choice_d": "Madagascar",
    "correct_answer": "A",
    "explanation": "Japan\u2019s privacy law is sufficient to meet EU legislative requirements. <br>Alaska is not a country\u2014it is a state. Option B is wrong. <br>Neither Belize nor Madagascar has privacy laws sufficient to meet EU requirements; options C and D are incorrect.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      656,
      348,
      357,
      347,
      356
    ],
    "source": ""
  },
  {
    "id": 1377,
    "question": "You are the IT director for an automotive parts supply distribution service; your company\u00a0wants to operate a production environment in the cloud. In reviewing provider options, management considers an offer from Cloud Services Corp., who has contracts with several cloud providers and data centers and has offered to tailor a package\u00a0of services for your company\u2019s needs. In this case, Cloud Services Corp. is considered a ___________________.",
    "choice_a": "Cloud provider",
    "choice_b": "Cloud customer",
    "choice_c": "Cloud reseller",
    "choice_d": "Cloud database",
    "correct_answer": "C",
    "explanation": "A cloud reseller is a firm that contracts with both cloud providers and customers in order to arrange custom services. <br>The cloud provider(s), in this case, would be those entities selling services to Cloud Services Corp. Option A is incorrect. <br>The cloud customer, in this case, would be your company. Option B is incorrect. <br>No aspect of the question describes a cloud database specifically. Option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      13,
      8,
      170,
      7,
      234
    ],
    "source": ""
  },
  {
    "id": 1378,
    "question": "You are the IT director for an automotive parts supply distribution service; your company wants to operate a production environment in the cloud. Management has expressed a concern that any cloud provider the company chooses will have your company at a disadvantage\u2014that your company will be at great risk because the provider will have your data and operational capability, and that the provider could hold the data \u201chostage\u201d in order to raise the price of the service dramatically at the end of the contract term. To address management\u2019s concerns, you should try to find a cloud offering that places a great deal of emphasis on the ___________________ trait of cloud computing.",
    "choice_a": "Resource pooling",
    "choice_b": "Scalability",
    "choice_c": "Portability",
    "choice_d": "Metered service",
    "correct_answer": "C",
    "explanation": "Portability is the aspect of cloud computing that describes the ability to move data and operations away from a given cloud provider (either to another cloud provider or to an on-premise solution). <br>All the other options are aspects of cloud computing but do not aid in addressing the concerns described in the question.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      1,
      12,
      230,
      170,
      237
    ],
    "source": ""
  },
  {
    "id": 1379,
    "question": "You are the IT director for an automotive parts supply distribution service; your company wants to operate a production environment in the cloud. As you consider possible providers, you are careful to check that they each offer the essential traits of cloud computing. These include all of the following <italic>except</italic> ___________________.",
    "choice_a": "Broad network access",
    "choice_b": "Metered service",
    "choice_c": "On-demand self-service",
    "choice_d": "Automatic antimalware and intrusion prevention",
    "correct_answer": "D",
    "explanation": "While many cloud providers will offer these services (as well as many others), they are not defining characteristics of cloud computing. <br>All the other options are defining characteristics of cloud computing.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      1,
      2,
      8,
      12,
      17
    ],
    "source": ""
  },
  {
    "id": 1380,
    "question": "You are the IT director for an automotive parts supply distribution service; your company wants to operate a production environment in the cloud. Your company wants to install its own software solutions in a managed environment to decrease the cost of purchasing and maintaining the hardware of a data center. You should <italic>most</italic> likely be considering a(n) ___________________ offering.",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "Hybrid",
    "correct_answer": "B",
    "explanation": "A platform as a service (PaaS) model will probably best suit your company\u2019s needs as it allows the customer (your company) to install software and load data onto a hardware infrastructure owned and operated by the provider. <br>An infrastructure as a service (IaaS) solution may be viable for this situation, because it allows the same functionality, but it also requires the customer (your company) to install and maintain the OS(s) that run the software. In looking to decrease cost of investment and maintenance, the PaaS model is probably preferable. Option A is not as good as option B, in this case. <br>A software as a service (SaaS) model does not allow the customer to install software; option C is incorrect. <br>A hybrid cloud model usually requires the customer to maintain at least part of the hardware infrastructure; in accordance with the description of the situation in this question, option D is not as optimum as option B.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      8,
      12,
      237,
      3,
      7
    ],
    "source": ""
  },
  {
    "id": 1381,
    "question": "If a company wanted to retain some of its own internal traditional hardware but use the cloud as a means of performing software testing functions, which service and deployment models should it probably use?",
    "choice_a": "PaaS, hybrid",
    "choice_b": "IaaS, private",
    "choice_c": "PaaS, community",
    "choice_d": "SaaS, hybrid",
    "correct_answer": "A",
    "explanation": "Platform as a service (PaaS) models are particularly useful for performing software testing because the customer can install and run their own programs across multiple OSs/systems. A hybrid model is used to describe a situation where ownership of the infrastructure is split between the provider and the customer. <br>A software as a service (SaaS) or infrastructure as a service (IaaS) model would not be optimum for software testing; options B and D are incorrect. <br>A community cloud model involves the joint ownership of infrastructure among many providers and customers; option C is not correct.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      8,
      9,
      23,
      156,
      12
    ],
    "source": ""
  },
  {
    "id": 1382,
    "question": "A company wants to absolutely minimize their involvement in administration of IT; which combination of cloud service model and deployment should it consider?",
    "choice_a": "IaaS, private",
    "choice_b": "PaaS, private",
    "choice_c": "SaaS, private",
    "choice_d": "SaaS, public",
    "correct_answer": "D",
    "explanation": "A software as a service (SaaS) model reduces customer involvement more than the other models; a public cloud deployment likewise reduces customer participation in ownership and maintenance of infrastructure. <br>Infrastructure as a service (IaaS) and platform as a service (PaaS) models require the customer to participate in some administration of the environment; options A and B are incorrect. <br>A private cloud entails customer involvement in at least the detailing of governance of the environment; option C is incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      8,
      9,
      12,
      237,
      13
    ],
    "source": ""
  },
  {
    "id": 1383,
    "question": "During a cost\u00ad\u2013benefit analysis, your company determines that it spends a disproportionate amount of money on software licensing and administration. Which cloud model may best help your company to reduce these costs?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "Hybrid",
    "correct_answer": "C",
    "explanation": "In a software as a service (SaaS) model, the cloud provider is tasked with acquiring and managing the software licenses; the scale of a cloud provider\u2019s operations can allow them to reduce the per-seat cost of software considerably. <br>The customer is still responsible for some software licensing and maintenance activities (and therefore costs) in infrastructure as a service (IaaS) and platform as a service (PaaS) models; options A and B are incorrect. <br>A hybrid deployment usually entails the customer maintaining some infrastructure elements, and that usually would also include software licensing requirements. Option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      8,
      12,
      9,
      7,
      3
    ],
    "source": ""
  },
  {
    "id": 1384,
    "question": "Your company does not have a well-trained, experienced IT staff and is reluctant to spend more money on training personnel (in recent company history, personnel have received training and then immediately quit the company to work for competitors). If senior management considers cloud migration, which deployment model would probably best suit their needs?",
    "choice_a": "Public",
    "choice_b": "Private",
    "choice_c": "Community",
    "choice_d": "Hybrid",
    "correct_answer": "A",
    "explanation": "A public cloud deployment would probably best meet the needs of a company without a robust, trained IT staff. The cloud provider will be responsible for the greatest degree of administration and maintenance compared to the other options. <br>Options B, C, nor D would not be the optimal choices for a cloud deployment model in this case, because each of those requires personnel with more experience/training. Options B, C, and D are incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      9,
      6,
      12,
      8,
      7
    ],
    "source": ""
  },
  {
    "id": 1385,
    "question": "Your company operates under a high degree of regulatory scrutiny. Senior management wants to migrate to a cloud environment but is concerned that providers will not meet the company\u2019s compliance needs. Which deployment model would probably best suit the company\u2019s needs?",
    "choice_a": "Public",
    "choice_b": "Private",
    "choice_c": "Community",
    "choice_d": "Hybrid",
    "correct_answer": "B",
    "explanation": "A private cloud arrangement allows the customer to have greater control of the governance and policy within an environment. <br>All the other options are cloud deployment models that allow the customer less control over the environment as a whole.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      9,
      206,
      237,
      182,
      207
    ],
    "source": ""
  },
  {
    "id": 1386,
    "question": "Your company operates in a highly competitive market, with extremely high-value data assets. Senior management wants to migrate to a cloud environment but is concerned that providers will not meet the company\u2019s security needs. Which deployment model would probably best suit the company\u2019s needs?",
    "choice_a": "Public",
    "choice_b": "Private",
    "choice_c": "Community",
    "choice_d": "Hybrid",
    "correct_answer": "B",
    "explanation": "A private cloud model can allow the customer to have the greatest assurance of confidentiality compared to the other models. <br>Options A, C, and D provide less confidentiality than option B and are therefore incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      9,
      237,
      16,
      12,
      225
    ],
    "source": ""
  },
  {
    "id": 1387,
    "question": "Your company operates in a highly cooperative market, with a high degree of information sharing between participants. Senior management wants to migrate to a cloud environment but is concerned that providers will not meet the company\u2019s collaboration needs. Which deployment model would probably best suit the company\u2019s needs?",
    "choice_a": "Public",
    "choice_b": "Private",
    "choice_c": "Community",
    "choice_d": "Hybrid",
    "correct_answer": "C",
    "explanation": "A community cloud entails all participants to have some degree of ownership and responsibility for the cloud environment; this is the preferred model for cooperative ownership and collaboration among a group with a shared interest/goal.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      10,
      9,
      236,
      12,
      231
    ],
    "source": ""
  },
  {
    "id": 1388,
    "question": "Your company maintains an on-premises data center for daily production activities but wants to use a cloud service to augment this capability during times of increased demand (cloud bursting). Which deployment model would probably best suit the company\u2019s needs?",
    "choice_a": "Public",
    "choice_b": "Private",
    "choice_c": "Community",
    "choice_d": "Hybrid",
    "correct_answer": "D",
    "explanation": "A hybrid model, where ownership fluctuates between exclusive control of the customer (private) and provider (public) only during times of increased demand, is almost a textbook description of this arrangement and translates very well for cloud-bursting techniques.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      9,
      12,
      3,
      5,
      140
    ],
    "source": ""
  },
  {
    "id": 1389,
    "question": "A company is considering a cloud migration to a platform as a service (PaaS) environment. Which of the following factors might make the company <italic>less</italic> likely to choose the cloud environment?",
    "choice_a": "The company wants to reduce overhead costs.",
    "choice_b": "The company operates proprietary software.",
    "choice_c": "The company hopes to reduce energy costs related to operation of a data center.",
    "choice_d": "The company is seeking to enhance its business continuity and disaster recovery (BC/DR) capabilities.",
    "correct_answer": "B",
    "explanation": "A customer using proprietary software in a PaaS environment faces the risk that updates to the underlying OS(s) and/or hardware infrastructure will not be compatible with the customer\u2019s software and will affect productivity. <br>Cloud migration can, however, aid in reducing overhead costs, including energy costs associated with operating a data center, and can enhance BC/DR capability through the provider\u2019s increased investment in redundancy and continuity.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      8,
      6,
      223,
      216,
      220
    ],
    "source": ""
  },
  {
    "id": 1390,
    "question": "Which mechanism <italic>best</italic> aids to ensure that the cloud customer receives dependable, consistent performance in the cloud environment?",
    "choice_a": "Audits",
    "choice_b": "Service-level agreement (SLA)",
    "choice_c": "Regulators",
    "choice_d": "Training",
    "correct_answer": "B",
    "explanation": "The service-level agreement creates financial incentive for the cloud provider to meet the customer\u2019s needs on a consistent basis. <br>Audits and regulators might help this effort, somewhat, by ensuring that the provider adheres to certain mandates and standards, but these are less convincing (and occur after the fact of delivery) than profit motive. Options A and C are incorrect. <br>Training does not really aid the efforts described in the question; option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      17,
      12,
      170,
      147,
      237
    ],
    "source": ""
  },
  {
    "id": 1391,
    "question": "What is the business advantage of shifting from capital expenditure in an on-premises environment to the operating expenditures of a cloud environment?",
    "choice_a": "Reduces the overall cost",
    "choice_b": "Reduces tax exposure",
    "choice_c": "Reduces cash flow risks",
    "choice_d": "Increases profit",
    "correct_answer": "C",
    "explanation": "By spreading costs over time, a business can reduce the risk that there will be a lack of money at any given time, impacting operations. <br>A shift from a capital expenditure scheme to operational expenditure arrangement does not necessarily mean that overall costs decrease; in fact, costs might very likely increase because the sum of the OpEx installments may total more than the CapEx would have been. Option A is incorrect. <br>CapEx usually reduces tax exposure because it allows for depreciation of assets, whereas OpEx does not. Option B is incorrect. <br>Whether the business uses CapEx or OpEx financing does not necessarily increase or decrease profit. Option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      6,
      4,
      5,
      222,
      229
    ],
    "source": ""
  },
  {
    "id": 1392,
    "question": "A host-based firewall in a virtualized cloud environment might have aspects of all the following types of controls <italic>except</italic> ___________________.",
    "choice_a": "Administrative",
    "choice_b": "Deterrent",
    "choice_c": "Corrective",
    "choice_d": "Preventive",
    "correct_answer": "B",
    "explanation": "This is a complicated question and requires a significant amount of understanding of control types. <br>A firewall uses aspects of administrative controls. The firewall policy is a set of rules that dictate the type of traffic and source/destination of that traffic. Option A is incorrect. <br>Firewalls can be set to change activity in reaction to detected threats, which is a corrective action; option C is incorrect. <br>Firewall rules can also prevent certain kinds of traffic/access; option D is incorrect. <br>However, the effect of a deterrent control is the result of its perception by someone who might engage in wrongdoing\u2014unless it is perceived, the control is not really a deterrent. Most firewalls don\u2019t function in that manner; they are transparent to both legitimate users and attackers. Option B is therefore correct.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      294,
      293,
      296,
      579,
      85
    ],
    "source": ""
  },
  {
    "id": 1393,
    "question": "A virtual network interface card (NIC) exists at Layer ___________________ of the OSI model.",
    "choice_a": "2",
    "choice_b": "4",
    "choice_c": "6",
    "choice_d": "8",
    "correct_answer": "A",
    "explanation": "The virtualized NIC is part of the Data-Link layer. <br>All of the other options are incorrect. Option D is incorrect because there is no Layer 8 in the Open Systems Interconnection (OSI) model.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      712,
      714,
      687,
      713,
      685
    ],
    "source": ""
  },
  {
    "id": 1394,
    "question": "Which technology is <italic>most</italic> associated with tunneling?",
    "choice_a": "IPSec",
    "choice_b": "GRE",
    "choice_c": "IaaS",
    "choice_d": "XML",
    "correct_answer": "B",
    "explanation": "Generic routing encapsulation (GRE) is a tunneling mechanism, specifically designed for the purpose. <br>Internet Protocol Security (IPSec) may or may not involve tunneling. Option A is incorrect. <br>Infrastructure as a service (IaaS) may or may not use tunneling for remote access/administration; option C is incorrect. <br>Extensible Markup Language (XML) is a format for communicating data; option D is incorrect.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      717,
      716,
      715,
      96,
      98
    ],
    "source": ""
  },
  {
    "id": 1395,
    "question": "Secure Shell (SSH) tunneling can include all of the following services <italic>except</italic> ___________________.",
    "choice_a": "Remote log-on",
    "choice_b": "Content filtering",
    "choice_c": "Port forwarding",
    "choice_d": "Command execution",
    "correct_answer": "B",
    "explanation": "SSH does not offer content filtering. It does offer all the services listed in the other options.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      716,
      715,
      717,
      97,
      598
    ],
    "source": ""
  },
  {
    "id": 1396,
    "question": "Transport Layer Security (TLS) is a session encryption tool that uses ___________________ encryption to create a ___________________ session key.",
    "choice_a": "Symmetric, symmetric",
    "choice_b": "Asymmetric, symmetric",
    "choice_c": "Asymmetric, asymmetric",
    "choice_d": "Symmetric, asymmetric",
    "correct_answer": "B",
    "explanation": "TLS uses asymmetric encryption to create a symmetric session key.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 1397,
    "question": "Which of the following architecture frameworks was designed for service delivery entities, from the perspective of how they serve customers?",
    "choice_a": "SABSA (Sherwood Applied Business Security Architecture)",
    "choice_b": "ITIL",
    "choice_c": "COBIT (Control Objectives for Information and Related Technologies)",
    "choice_d": "TOGAF (The Open Group Architecture Framework)",
    "correct_answer": "B",
    "explanation": "ITIL was specifically designed to address service delivery entities (in particular, British telecommunications providers), and how they provide service to their customers. <br>SABSA is a means of looking at security capabilities from a business perspective; option A is incorrect. <br>COBIT is designed for all types of business, regardless of their purpose; option C is incorrect. <br>TOGAF is a means to incorporate security architecture with the overall business architecture; option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      158,
      13,
      12,
      229,
      155
    ],
    "source": ""
  },
  {
    "id": 1398,
    "question": "The Cloud Security Alliance (CSA) created the Trusted Cloud Initiative (TCI) to define principles of cloud computing that providers should strive for in order to foster a clear understanding of the cloud marketplace and to enhance that market. Which of the following is not one of the CSA\u2019s TCI fundamental principles?",
    "choice_a": "Delegate or federate access control when appropriate.",
    "choice_b": "Ensure the [trusted cloud] architecture is resilient, elastic, and flexible.",
    "choice_c": "Ensure the [trusted cloud] architecture addresses and supports multiple levels of protection.",
    "choice_d": "Provide economical services to all customers, regardless of point of origin.",
    "correct_answer": "D",
    "explanation": "The TCI does not, specifically, require cost-effectiveness of cloud services. <br>All the other options are principles detailed in the TCI.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      358,
      646,
      647,
      648,
      344
    ],
    "source": ""
  },
  {
    "id": 1399,
    "question": "Data loss prevention or data leak protection (DLP) solutions typically involve all of the following aspects <italic>except</italic> ___________________.",
    "choice_a": "Data discovery",
    "choice_b": "Tokenization",
    "choice_c": "Monitoring",
    "choice_d": "Enforcement",
    "correct_answer": "B",
    "explanation": "Tokenization is not typically an aspect of DLP solutions. All the other options are.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      414,
      690,
      255,
      253,
      501
    ],
    "source": ""
  },
  {
    "id": 1400,
    "question": "A typical data loss prevention or data leak protection (DLP) tool can enhance the organization\u2019s efforts at accomplishing what legal task?",
    "choice_a": "Evidence collection",
    "choice_b": "Delivering testimony",
    "choice_c": "Criminal prosecution",
    "choice_d": "Enforcement of intellectual property rights",
    "correct_answer": "A",
    "explanation": "The data discovery facet of DLP solutions can aid an organization in gathering applicable evidence, especially in response to a legal request such as a subpoena (this is often termed e-discovery). <br>Tools cannot deliver testimony; only people can testify. Option B is incorrect. <br>DLP solutions do not perform prosecutorial work; that is the function of law enforcement agencies. Option C is incorrect. <br>While DLP tools can locate intellectual property assets, they do not, strictly speaking, enforce the rights attendant to those assets. Option A is still preferable to D in this case.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      37,
      28,
      412,
      510,
      688
    ],
    "source": ""
  },
  {
    "id": 1401,
    "question": "Which of the following activities can enhance the usefulness and abilities of a data loss prevention or data leak protection (DLP) solution?",
    "choice_a": "Perform emergency egress training for all personnel.",
    "choice_b": "Require data owners, stewards, and custodians to properly classify and label data at time of creation or collection.",
    "choice_c": "Require senior management to participate in all security functions, including initial, recurring, and refresher training.",
    "choice_d": "Display security guidance in a variety of formats, including a web page, banner, posters, and hard-copy material.",
    "correct_answer": "B",
    "explanation": "DLP tools can function better if appropriate and accurate classification and labeling is applied throughout the environment and done on a consistent basis. <br>All the other options are good aspects of a security program but not exactly germane to DLP function.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      26,
      29,
      689,
      413,
      25
    ],
    "source": ""
  },
  {
    "id": 1402,
    "question": "Data archiving can also provide what production capability?",
    "choice_a": "Enhanced database mechanisms",
    "choice_b": "Near-term data recovery",
    "choice_c": "New data-driven business workflows",
    "choice_d": "Greater management insight into productivity",
    "correct_answer": "B",
    "explanation": "Depending on the availability of the archive, it may be possible to use it to recover production data that has been accidentally or inadvertently deleted or destroyed. <br>Archiving does not really offer any of the other benefits; when data is taken out of the production environment and put into long-term storage, the organization loses the capability to manipulate it and create new assets from it. Options A, C, and D are incorrect.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      36,
      34,
      37,
      377,
      41
    ],
    "source": ""
  },
  {
    "id": 1403,
    "question": "Data archiving can be required for regulatory compliance as a legal mandate. What other business function is also often tied to archiving?",
    "choice_a": "Marketing",
    "choice_b": "Business continuity and disaster recovery (BC/DR)",
    "choice_c": "Personnel development",
    "choice_d": "Intellectual property protection",
    "correct_answer": "B",
    "explanation": "Having a suitable backup, away from the main production environment, allows the organization to recover from contingency operations that have interrupted or affected the production environment. <br>All the other options are not benefits directly associated with data archiving.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      36,
      34,
      37,
      377,
      38
    ],
    "source": ""
  },
  {
    "id": 1404,
    "question": "Which of the following is probably <italic>most</italic> important to include in a data archiving policy?",
    "choice_a": "Data format and type",
    "choice_b": "Data classification",
    "choice_c": "Encryption procedures and standards",
    "choice_d": "Data audit and review processes",
    "correct_answer": "A",
    "explanation": "In order to use the archive for recovery (either on a large scale for contingency operations or for granular recovery as a means of data discovery), the data needs to be of a format and type that can be utilized by the organization\u2019s systems and environment. Saving data in the wrong format can be equivalent to losing the data. <br>All the other options are important aspects of a data archiving policy but are not as important as option A (for instance, data that is not encrypted might pose a risk of loss, but data in the wrong format may not be recoverable at all).",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      36,
      34,
      377,
      493,
      40
    ],
    "source": ""
  },
  {
    "id": 1405,
    "question": "The destruction of a cloud customer\u2019s data can be required by all of the following <italic>except</italic> ___________________.",
    "choice_a": "Statute",
    "choice_b": "Regulation",
    "choice_c": "The cloud provider\u2019s policy",
    "choice_d": "Contract",
    "correct_answer": "C",
    "explanation": "The cloud provider cannot typically require the destruction of the customer\u2019s data simply because of its own (provider\u2019s) policy. If this is an aspect of the contract between the provider and customer, that is another issue (and listed as another option in this question). <br>The other options are all sources that may dictate the customer\u2019s destruction of data.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      37,
      34,
      392,
      24,
      40
    ],
    "source": ""
  },
  {
    "id": 1406,
    "question": "Which of the following data storage types is most associated with software as a service (SaaS)?",
    "choice_a": "Content delivery network (CDN)",
    "choice_b": "Databases",
    "choice_c": "Volume storage",
    "choice_d": "Data warehousing",
    "correct_answer": "A",
    "explanation": "CDNs are often used in conjunction with SaaS services to deliver high-quality data of large sizes (often multimedia). <br>Databases and data warehousing are typically associated with platform as a service (PaaS), where the provider owns and maintains the infrastructure and data management engine but the customer can install programs and interfaces to manipulate the data. Options B and D are incorrect. <br>Volume storage is typically associated with infrastructure as a service (IaaS); option C is incorrect.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      49,
      50,
      51,
      42,
      45
    ],
    "source": ""
  },
  {
    "id": 1407,
    "question": "You are the security manager for a bookkeeping firm that is considering moving to a cloud-based production environment. In selecting a cloud provider, your company is reviewing many criteria. One of these is enhancing the company\u2019s business continuity and disaster recovery (BC/DR) capabilities. You want to ensure that the cloud provider you select will allow for migration to an alternate provider in the event of contingencies. The provider you choose should be able to\u00a0support a migration to an alternate provider within ___________________.",
    "choice_a": "24 hours",
    "choice_b": "1 hour",
    "choice_c": "Your company\u2019s recovery time objective (RTO)",
    "choice_d": "Your company\u2019s recovery point objective (RPO)",
    "correct_answer": "C",
    "explanation": "The RTO is the measure of time after an interruption at which the company needs to resume critical functions; any service migration must take place within that time. <br>RTOs vary for every organization; there is no set answer for all organizations. Options A and B might be correct for a given organization but incorrect in the general case because it\u2019s impossible to know an organization\u2019s RTO without knowing more about the organization. <br>The RPO is a measure of data that can be lost, not time; option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      319,
      334,
      428,
      556,
      535
    ],
    "source": ""
  },
  {
    "id": 1408,
    "question": "In which phase of the cloud secure data life cycle does data leave the production environment and go into long-term storage?",
    "choice_a": "Store",
    "choice_b": "Use",
    "choice_c": "Share",
    "choice_d": "Archive",
    "correct_answer": "D",
    "explanation": "This action defines the archive phase. All the other options are incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      421,
      422,
      423,
      474,
      231
    ],
    "source": ""
  },
  {
    "id": 1409,
    "question": "In which phase of the cloud secure data life cycle should classifications and labels be assigned to data?",
    "choice_a": "Create",
    "choice_b": "Store",
    "choice_c": "Use",
    "choice_d": "Share",
    "correct_answer": "A",
    "explanation": "Data should be labeled and classified as soon as it is created/collected. <br>All the other options are incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      421,
      422,
      231,
      473,
      214
    ],
    "source": ""
  },
  {
    "id": 1410,
    "question": "Which of the following is <italic>not</italic> included in the Open Web Application Security Project (OWASP) Top Ten web application security threats?",
    "choice_a": "Injection",
    "choice_b": "Cross-site scripting",
    "choice_c": "Internal theft",
    "choice_d": "Sensitive data exposure",
    "correct_answer": "C",
    "explanation": "Internal theft is not listed in the OWASP Top Ten, probably because the list concerns web application security, not security overall. <br>All the other options are included in the OWASP Top Ten.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      74,
      293,
      295,
      297,
      579
    ],
    "source": ""
  },
  {
    "id": 1411,
    "question": "Your organization is developing software for wide use by the public. You have decided to test it in a cloud environment, in a platform as a service (PaaS) model. Which of the following should be of particular concern to your organization for this situation?",
    "choice_a": "Vendor lock-in",
    "choice_b": "Backdoors",
    "choice_c": "Regulatory compliance",
    "choice_d": "High-speed network connectivity",
    "correct_answer": "B",
    "explanation": "Backdoors are a particularly prevalent risk in software development because programmers legitimately use backdoors for ease of use and speed of delivery but may mistakenly (or even purposefully) leave the backdoors in the software after development, creating a hidden and significant vulnerability. <br>All the other options should be concerns of any cloud customer, but they are not of specific or increased concern for this situation.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      73,
      75,
      72,
      71,
      69
    ],
    "source": ""
  },
  {
    "id": 1412,
    "question": "Which of the following management risks can make an organization\u2019s cloud environment unviable?",
    "choice_a": "Insider trading",
    "choice_b": "Virtual machine (VM) sprawl",
    "choice_c": "Hostile takeover",
    "choice_d": "Improper personnel selection",
    "correct_answer": "B",
    "explanation": "Because the cost of creating new instances in the cloud environment is transparent to many users/offices, there is a significant likelihood that users/offices will create many new virtual machine (VM) instances without the knowledge/oversight of management. This can result in a very expensive surprise at the end of the payment period, when the organization receives the bill from the cloud provider. <br>All the other options are management risks that do not have anything specific to do with the cloud environment and should not affect it/be affected by it.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      107,
      598,
      108,
      636,
      606
    ],
    "source": ""
  },
  {
    "id": 1413,
    "question": "You are the security manager for a company that is considering cloud migration to an infrastructure as a service (IaaS) environment. You are assisting your company\u2019s IT architects in constructing the environment. Which of the following options do you recommend?",
    "choice_a": "Unrestricted public access",
    "choice_b": "Use of a Type I hypervisor",
    "choice_c": "Use of a Type II hypervisor",
    "choice_d": "Enhanced productivity without encryption",
    "correct_answer": "B",
    "explanation": "The Type I hypervisor is preferable, as it offers less attack surface. <br>All the other options increase risk and should not be recommended.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      14,
      142,
      223,
      225,
      8
    ],
    "source": ""
  },
  {
    "id": 1414,
    "question": "Your company uses a managed cloud service provider to host the production environment. The provider has notified you, along with several other of the provider\u2019s customers, that an engineer working for the provider has been using administrative access to steal sensitive data and has been selling it to your competitors. Some of this sensitive data included personally identifiable information (PII) related to your employees. Your company\u2019s general counsel informs you that there are at least three jurisdictions involved that have laws requiring data breach notification for PII. Who has <italic>legal</italic> liability for the costs involved with making the required notifications?",
    "choice_a": "The cloud provider",
    "choice_b": "Your company",
    "choice_c": "The Internet service provider (ISP)",
    "choice_d": "Your regulators",
    "correct_answer": "B",
    "explanation": "Under current laws, the owner of the PII is legally responsible for data breach notifications, regardless of the circumstances of the breach; in this case, your company is the PII owner. <br>All the other options are incorrect because those entities are not the owner of the PII.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      709,
      337,
      339,
      338,
      651
    ],
    "source": ""
  },
  {
    "id": 1415,
    "question": "Which of the following techniques is <italic>not</italic> recommended for privileged user management?",
    "choice_a": "Increased password/phrase complexity",
    "choice_b": "More frequent password/phrase changes",
    "choice_c": "More detailed background checks",
    "choice_d": "Less detailed audit trail",
    "correct_answer": "D",
    "explanation": "If anything, the audit trail for privileged users should be more detailed than that for regular users. <br>All the other options are recommended techniques for privileged user management.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      719,
      720,
      718,
      38,
      39
    ],
    "source": ""
  },
  {
    "id": 1416,
    "question": "You are the security officer for a company operating a production environment in the cloud. Your company\u2019s assets have a high degree of sensitivity and value, and your company has decided to retain control and ownership of the encryption key management system. In order to do so, your company will have to have which of the following cloud service/deployment models?",
    "choice_a": "Public",
    "choice_b": "Infrastructure as a service (IaaS)",
    "choice_c": "Hybrid",
    "choice_d": "Software as a service (SaaS)",
    "correct_answer": "C",
    "explanation": "Managing the encryption keys on-premises necessitates some elements of a hybrid cloud model; the key management is done on-premises, and the production takes place in the cloud. <br>A public cloud arrangement would preclude the customer hosting the key management system on its premises; option A is incorrect. <br>The service model is slightly irrelevant to where the key management system is located; whereas customer-hosted key management is usually associated with an SaaS model, it is not strictly required. Options B and D are incorrect.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      418,
      420,
      411,
      24,
      419
    ],
    "source": ""
  },
  {
    "id": 1417,
    "question": "Which security principle dictates that encryption key management and storage should be isolated from the data encrypted with those keys?",
    "choice_a": "Least privilege",
    "choice_b": "Two-person integrity",
    "choice_c": "Compartmentalization",
    "choice_d": "Separation of duties",
    "correct_answer": "D",
    "explanation": "Separation of duties dictates that one person/entity cannot complete an entire transaction alone. In the case of encryption, a single entity should not be able to administer the issuing of keys, encrypt the data, and store the keys, because this could lead to a situation where that entity has the ability to access or take encrypted data. <br>All the other options are security principles but are not intrinsically applicable to the concept of storing encryption keys away from encrypted data.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      418,
      420,
      24,
      718,
      386
    ],
    "source": ""
  },
  {
    "id": 1418,
    "question": "Which cloud data storage technique involves encrypting a data set, then splitting the data into pieces, splitting the key into pieces, then signing the data pieces and key pieces and distributing them to various cloud storage locations?",
    "choice_a": "RAID",
    "choice_b": "Secret sharing made short (SSMS)",
    "choice_c": "Homomorphic encryption",
    "choice_d": "Asymmetric encryption",
    "correct_answer": "B",
    "explanation": "This is a description of the SSMS process. <br>Option A is incorrect because RAID is a storage virtualization technology, used in traditional environments, that combines physical disks components into one or more logical units. <br>Homomorphic encryption is a theoretical conversion of data into ciphertext that can be analyzed as if it were in its original form. Option C is incorrect. <br>Option D is incorrect because it uses public and private key pairs to encrypt and decrypt data.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      53,
      48,
      54,
      57,
      59
    ],
    "source": ""
  },
  {
    "id": 1419,
    "question": "Which theoretical technique would allow encrypted data to be manipulated without decrypting it first?",
    "choice_a": "RAID",
    "choice_b": "Secret sharing made short (SSMS)",
    "choice_c": "Homomorphic encryption",
    "choice_d": "Asymmetric encryption",
    "correct_answer": "C",
    "explanation": "This is the definition of homomorphic encryption. <br>Option A is incorrect because RAID is a storage virtualization technology, used in traditional environments, that combines physical disks components into one or more logical units. <br>SSMS involves encrypting a data set, then splitting the data into pieces, splitting the key into pieces, then signing the data pieces and key pieces and distributing them to various cloud storage locations. Option B is incorrect. <br>Option D is incorrect because it uses public and private key pairs to encrypt and decrypt data.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      418,
      419,
      41,
      505,
      414
    ],
    "source": ""
  },
  {
    "id": 1420,
    "question": "Which theoretical technology would allow superposition of physical states to increase both computing capacity and encryption keyspace?",
    "choice_a": "All-or-nothing-transform with Reed-Solomon (AONT-RS)",
    "choice_b": "Quantum computing",
    "choice_c": "Filigree investment",
    "choice_d": "Sharding",
    "correct_answer": "B",
    "explanation": "This is a description of quantum computing. <br>Option A is incorrect because it refers to a data transformation. <br>Option C is a made up term and is therefore incorrect. <br>Option D is incorrect because it is a data dispersion term.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 1421,
    "question": "In a virtualized environment, suspended virtual machine (VM) instances at rest are subject to increased risk because ___________________.",
    "choice_a": "There is no way to encrypt instances at rest",
    "choice_b": "Insider threats are greater for data storage locations than processing locations",
    "choice_c": "The instances are saved as image snapshots and highly portable",
    "choice_d": "They are unprotected unless multifactor authentication is required",
    "correct_answer": "C",
    "explanation": "Saved virtual instances are simply inert files, and they are very easy to copy and move. <br>Encryption may be applied to data at rest (even VM snapshots); option A is incorrect. <br>Insider threats within the cloud data center probably pose just as much risk to the storage nodes as the processing nodes; option B is incorrect. <br>Option D is nonsensical and untrue. Option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      49,
      52,
      42,
      53,
      48
    ],
    "source": ""
  },
  {
    "id": 1422,
    "question": "In a virtualized cloud environment, the management plane is usually responsible for provisioning virtual machine instances with all of the following resources <italic>except</italic> __________.",
    "choice_a": "CPU",
    "choice_b": "Memory",
    "choice_c": "User interface",
    "choice_d": "Permanent storage",
    "correct_answer": "C",
    "explanation": "The user interface to the virtualized instance can be handled by a variety of mechanisms, but it is not the function of the management plane. <br>All the other options are resources provisioned to the virtual machine(s) by the management plane.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      522,
      534,
      712,
      714,
      685
    ],
    "source": ""
  },
  {
    "id": 1423,
    "question": "Which of the following business continuity and disaster recovery (BC/DR) testing methodologies is least intrusive?",
    "choice_a": "Walk-through",
    "choice_b": "Simulation",
    "choice_c": "Tabletop",
    "choice_d": "Full test",
    "correct_answer": "C",
    "explanation": "The tabletop testing method is the least intrusive type of BC/DR test. All the other options are BC/DR testing methods that are more intrusive.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      319,
      334,
      544,
      556,
      557
    ],
    "source": ""
  },
  {
    "id": 1424,
    "question": "In order for an organization to determine if its backup solution is adequate for meeting the recovery point objective (RPO), what <italic>must</italic> be done?",
    "choice_a": "Conduct full backups at least daily.",
    "choice_b": "Use a data mirroring solution.",
    "choice_c": "Put all backups in the cloud.",
    "choice_d": "Practice a restore from backup.",
    "correct_answer": "D",
    "explanation": "There is no way to know if the backup actually serves the purpose until the organization tests a restoration. <br>The other options are all backup options but do not actually demonstrate whether the backup is suitable for the business continuity and disaster recovery (BC/DR) requirements.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      105,
      112,
      111,
      636,
      313
    ],
    "source": ""
  },
  {
    "id": 1425,
    "question": "Which common characteristic of the cloud data center also serves customer business continuity and disaster recovery (BC/DR) needs?",
    "choice_a": "Multitenancy",
    "choice_b": "Virtualization",
    "choice_c": "Redundancy",
    "choice_d": "Software-defined networking",
    "correct_answer": "C",
    "explanation": "The ubiquitous redundancy of systems and capabilities within most cloud data centers not only serves the provider\u2019s requirement to meet customer service-level agreements but also enhances the data center\u2019s (and the customer\u2019s) resistance to disasters and interruptions. <br>All the other options are characteristics of a cloud data center, but they don\u2019t serve much BC/DR purpose; option C is the best choice.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      319,
      334,
      544,
      289,
      684
    ],
    "source": ""
  },
  {
    "id": 1426,
    "question": "Which phase of the business continuity and disaster recovery (BC/DR) process can result in a second disaster?",
    "choice_a": "Event anticipation",
    "choice_b": "Creating BC/DR plans and policy",
    "choice_c": "Return to normal operations",
    "choice_d": "Incident initiation",
    "correct_answer": "C",
    "explanation": "Returning to normal operations can result in a second disaster if the conditions created by the initial disaster (which created the need to run the BC/DR plan) have not fully been addressed/resolved. <br>An inadvertent initiation of the plan can result in a disaster, but that would only be one disaster, not two; for instance, if senior management got faulty information during the event anticipation phase and decided to switch to contingency operations, but there was no actual causative event, that would be a single disaster. Options A and D are incorrect. <br>The act of planning and crafting policy cannot take the form of a disaster. Option B is incorrect.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      334,
      319,
      544,
      697,
      545
    ],
    "source": ""
  },
  {
    "id": 1427,
    "question": "Which process artifact aids an organization in determining the critical assets and functions that need to continue operations during a business continuity and disaster recovery (BC/DR) contingency?",
    "choice_a": "Service Organization Control (SOC) 2, Type 2",
    "choice_b": "Business impact analysis (BIA)",
    "choice_c": "Qualitative risk analysis report",
    "choice_d": "Annual loss expectancy (ALE) calculation",
    "correct_answer": "B",
    "explanation": "The BIA lists the assets of the organization and states their importance, value, and criticality. This can easily be used for BC/DR planning purposes. <br>The SOC is an audit report; this does not aid in BC/DR planning. Option A is incorrect. <br>The risk analysis and ALE calculation are used to select reasonable and cost-effective controls suitable for the environment; this does not aid in BC/DR efforts. Options C and D are incorrect.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      238,
      544,
      334,
      336,
      697
    ],
    "source": ""
  },
  {
    "id": 1428,
    "question": "In general, a cloud business continuity and disaster recovery (BC/DR) solution will be ___________________ than a physical solution.",
    "choice_a": "Slower",
    "choice_b": "Less expensive",
    "choice_c": "Larger",
    "choice_d": "More difficult to engineer",
    "correct_answer": "B",
    "explanation": "Typically, the cost of using the cloud for contingency operations will be much less than creating a physical alternate operating site. <br>Usually, a cloud solution may also be faster and easier to engineer than a physical solution; options A and D are incorrect. <br>\u201cLarger,\u201d in this context, has no meaning, because the \u201csize\u201d of the cloud is a misnomer; option C is incorrect.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      334,
      544,
      319,
      428,
      312
    ],
    "source": ""
  },
  {
    "id": 1429,
    "question": "Which of the following is not a common federation technology?",
    "choice_a": "WS-Federation",
    "choice_b": "OWASP",
    "choice_c": "OpenID",
    "choice_d": "OAuth",
    "correct_answer": "B",
    "explanation": "The Open Web Application Security Project (OWASP) is a volunteer organization that devises standards and solutions for web application development. All the other options are common federation technologies.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      574,
      576,
      694,
      583,
      585
    ],
    "source": ""
  },
  {
    "id": 1430,
    "question": "Which of the following is an audit report on the design of an organization\u2019s controls?",
    "choice_a": "Service Organization Control (SOC) 1",
    "choice_b": "SOC 2, Type 1",
    "choice_c": "SOC 3",
    "choice_d": "SOC 4",
    "correct_answer": "B",
    "explanation": "The SOC 2 ,Type 1 audit reviews management\u2019s selection of controls for the organization\u2019s environment. <br>The SOC 1 audit reviews the accuracy and correctness of the organization\u2019s financial reporting. Option A is incorrect. <br>The SOC 3 is an attestation of an audit. Option C is incorrect. <br>There is no SOC 4 report. Option D is incorrect.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      349,
      350,
      343,
      344,
      341
    ],
    "source": ""
  },
  {
    "id": 1431,
    "question": "Which of the following is not usually suitable for inclusion in a service-level agreement (SLA) for managed cloud services?",
    "choice_a": "Service availability",
    "choice_b": "Number of users and virtual machines",
    "choice_c": "Background checks for provider personnel",
    "choice_d": "Amount of cloud storage",
    "correct_answer": "C",
    "explanation": "The SLA won\u2019t typically include direct mention of the sorts of personnel security measures undertaken by the cloud provider. This may be mentioned, obliquely, in another part of the contract (that is, there may be some language that states that the provider is responsible for ensuring the trustworthiness of its personnel), but it is not a useful SLA element. <br>All the other options are excellent items to include in an SLA.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      344,
      646,
      710,
      648,
      358
    ],
    "source": ""
  },
  {
    "id": 1432,
    "question": "Which of the following is <italic>not</italic> a typical physical access control mechanism in the cloud data center?",
    "choice_a": "Cage locks",
    "choice_b": "Video surveillance",
    "choice_c": "Rack locks",
    "choice_d": "Fire suppression",
    "correct_answer": "D",
    "explanation": "Fire suppression systems are physical control mechanisms commonly found in cloud data centers but are not an element of access control. <br>All the other options are common physical access control mechanisms in a cloud data center.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      241,
      448,
      553,
      724,
      311
    ],
    "source": ""
  },
  {
    "id": 1433,
    "question": "Which of the following cloud environment accounts should only be granted on a temporary basis?",
    "choice_a": "Remote users",
    "choice_b": "Senior management",
    "choice_c": "Internal users",
    "choice_d": "External vendors",
    "correct_answer": "D",
    "explanation": "If external vendors need access to the cloud environment, that access should only be granted on an extremely limited and temporary basis. <br>All other options are common cloud access types and don\u2019t necessarily need to be limited in duration.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      600,
      603,
      602,
      96,
      324
    ],
    "source": ""
  },
  {
    "id": 1434,
    "question": "Which of the following attack vectors is new to the cloud environment and was not typically found in on-premises, legacy environments?",
    "choice_a": "Distributed denial of service (DDoS)",
    "choice_b": "Guest escape",
    "choice_c": "Internal threats",
    "choice_d": "Inadvertent disclosure",
    "correct_answer": "B",
    "explanation": "Guest escape is a prevailing threat in a virtualized, multitenant cloud environment and was not commonly found in traditional environments (those environments were typically not virtualized and did not serve more than one customer, the owning organization). <br>All the other threats are currently faced by cloud customers but also existed in the traditional environment.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      534,
      539,
      532,
      552,
      712
    ],
    "source": ""
  },
  {
    "id": 1435,
    "question": "Which of the following is a file server that provides data access to multiple, heterogeneous machines and users on the network?",
    "choice_a": "Storage area network (SAN)",
    "choice_b": "Network-attached storage (NAS)",
    "choice_c": "Hardware security module (HSM)",
    "choice_d": "Content delivery network (CDN)",
    "correct_answer": "B",
    "explanation": "This is the description of a NAS device. <br>A SAN typically presents storage devices to users as attached/mounted drives. Option A is incorrect. <br>An HSM is designed for encryption generation and management; option C is incorrect. <br>A CDN typically replicates multimedia content at multiple, geographically diverse locations to ensure high quality for recipients. Option D is incorrect.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      609,
      607,
      94,
      615,
      100
    ],
    "source": ""
  },
  {
    "id": 1436,
    "question": "You are the security manager for a retail company that is considering cloud migration to a public, software as a service (SaaS) solution both for your current internal production environment (an on-premises data center) and to host your e-commerce presence. Which of the following is a new concern you should bring up to senior management for them to consider before the migration?",
    "choice_a": "Regulatory compliance for your credit card processing transactions",
    "choice_b": "Inadvertent disclosure by internal (company) personnel",
    "choice_c": "Data disclosure through insufficiently isolated resources",
    "choice_d": "Malicious intrusion by external entities",
    "correct_answer": "C",
    "explanation": "Because of the multitenant nature of public cloud services, processes and resources that are not properly isolated may create a situation where data could be disclosed to other cloud customers (neighboring tenants). This is a new threat that may result from the migration. <br>All the other options are existing threats in the company\u2019s current environment.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      42,
      52,
      44,
      45,
      53
    ],
    "source": ""
  },
  {
    "id": 1437,
    "question": "When a data center is configured such that the backs of the devices face each other and the ambient temperature in the work area is cool, it is called ___________________.",
    "choice_a": "Hot aisle containment",
    "choice_b": "Cold aisle containment",
    "choice_c": "Thermo-optimized",
    "choice_d": "Heating, ventilation, and air conditioning (HVAC) modulated",
    "correct_answer": "A",
    "explanation": "This is a description of hot aisle containment. <br>Cold aisle containment is a configuration where the fronts of devices face each other. Option B is incorrect. <br>Option C is not relevant in this context. Option C is incorrect. <br>Option D does not describe the data center configuration in the question. Option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      312,
      241,
      684,
      682,
      725
    ],
    "source": ""
  },
  {
    "id": 1438,
    "question": "Disciplined cable management is crucial for cloud data centers because it provides greater\u00a0assurance of only authorized lines operating in the environment and ___________________.",
    "choice_a": "Reduces unproductive heating, ventilation, and air conditioning (HVAC) activity",
    "choice_b": "Reduces the risk of slip, trip, and fall hazard",
    "choice_c": "Greatly reduces the environmental footprint",
    "choice_d": "Ensures regulatory compliance",
    "correct_answer": "A",
    "explanation": "Unused or poorly managed cabling can impede efficient air flow, increasing HVAC and energy costs and increasing the difficulty of optimizing temperature. <br>While it is possible that mismanaged cabling could cause slip/trip/fall hazards, this is much less common in modern data centers; option A is preferable in this case. <br>Cabling does not really have much of an environmental footprint, so discipline applied to cabling won\u2019t affect the environment much, one way or the other; option C is incorrect. <br>Regulators do not usually enforce cable management; option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      241,
      312,
      534,
      685,
      724
    ],
    "source": ""
  },
  {
    "id": 1439,
    "question": "To optimize airflow within a data center according to industry standards, a raised floor used as an air plenum must have at least ___________________ of clearance.",
    "choice_a": "One foot",
    "choice_b": "One meter",
    "choice_c": "24 inches",
    "choice_d": "30 inches",
    "correct_answer": "C",
    "explanation": "The industry standard is 24 inches. All the other options are incorrect.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      291,
      289,
      312,
      545,
      557
    ],
    "source": ""
  },
  {
    "id": 1440,
    "question": "Raised flooring can serve as both an air plenum and ___________________.",
    "choice_a": "A convenient location for RAID arrays",
    "choice_b": "Cool storage for data center personnel meals",
    "choice_c": "A conduit for running cable",
    "choice_d": "Disaster shelter locations",
    "correct_answer": "C",
    "explanation": "Raised flooring can serve as air plenum and wiring location. <br>Ideally, raised flooring should be used for no other purpose because any objects in that location would impede airflow. Therefore, options A, B, and D are incorrect because they defeat the purpose of the raised flooring design.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      534,
      712,
      685,
      50,
      49
    ],
    "source": ""
  },
  {
    "id": 1441,
    "question": "Typically, when raised flooring is used as an air plenum, ___________________ air is directed through it.",
    "choice_a": "Warm",
    "choice_b": "Cold",
    "choice_c": "Bleed",
    "choice_d": "Exhaust",
    "correct_answer": "B",
    "explanation": "Cold air is usually put through raised flooring because warm air naturally rises and using the raised flooring to conduct warm air would require an unnecessary and inefficient expenditure of energy. <br>All the other options are incorrect as they include warmer air.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 1442,
    "question": "There are two general types of smoke detectors. One type uses a light source to detect the presence of particulate matter resulting from a fire, and the other uses ___________________.",
    "choice_a": "Electric pulses",
    "choice_b": "Small amounts of radioactive material",
    "choice_c": "Fiber-optic mechanisms",
    "choice_d": "A water-pressure plate",
    "correct_answer": "B",
    "explanation": "Ionization-based smoke detectors use trace amounts of a radionuclide (often americium) to detect the presence of particulate matter in the detection chamber when smoke particles interrupt the constant electric current. <br>Neither type uses the techniques described in the other options, as they are all incorrect answers.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      721,
      722,
      723,
      241,
      685
    ],
    "source": ""
  },
  {
    "id": 1443,
    "question": "Fire suppression systems are often linked to a detection system. Common detection systems include all of the following <italic>except</italic> ___________________.",
    "choice_a": "Heat",
    "choice_b": "Pressure",
    "choice_c": "Flame",
    "choice_d": "Smoke",
    "correct_answer": "B",
    "explanation": "Pressure detection is not a common detection technology. <br>All the other options are common fire detection methods.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      723,
      721,
      722,
      724,
      729
    ],
    "source": ""
  },
  {
    "id": 1444,
    "question": "FM-200 has all the following properties <italic>except</italic> ___________________.",
    "choice_a": "It\u2019s nontoxic at levels used for fire suppression",
    "choice_b": "It\u2019s gaseous at room temperature",
    "choice_c": "It may deplete the earth\u2019s ozone layer",
    "choice_d": "It does not leave a film or coagulant after use",
    "correct_answer": "C",
    "explanation": "FM-200 is used as a replacement for older Halon systems specifically because it (unlike Halon) does not deplete the ozone layer. <br>All the other options are true statements about FM-200 used in fire suppression.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      724,
      725,
      726,
      727,
      728
    ],
    "source": ""
  },
  {
    "id": 1445,
    "question": "FM-200 has all the following properties <italic>except</italic> ___________________.",
    "choice_a": "It is colorless",
    "choice_b": "It leaves a faint chemical residue after use",
    "choice_c": "It is liquid when stored",
    "choice_d": "It is nonconductive",
    "correct_answer": "B",
    "explanation": "One of the properties that makes it desirable for fire suppression in a data center is that FM-200 does not leave a residue. <br>All the other options are true statements about FM-200.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      725,
      727,
      726,
      728,
      729
    ],
    "source": ""
  },
  {
    "id": 1446,
    "question": "Dynamic Host Configuration Protocol (DHCP) servers in a network will provide the clients with all of the following <italic>except</italic> ___________________.",
    "choice_a": "A temporary IP address",
    "choice_b": "Encryption protocols",
    "choice_c": "A default gateway",
    "choice_d": "Time server synchronization",
    "correct_answer": "B",
    "explanation": "DHCP servers do not normally orchestrate encryption. <br>All the other options are common functions of DHCP servers.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      97,
      94,
      608,
      609,
      598
    ],
    "source": ""
  },
  {
    "id": 1447,
    "question": "You are the security officer for a cloud deployment. In order to secure data in transit, you can choose to implement all of the following techniques and technologies <italic>except</italic> ___________________.",
    "choice_a": "DNSSEC",
    "choice_b": "TLS",
    "choice_c": "IDS/IPS",
    "choice_d": "IPSec",
    "correct_answer": "C",
    "explanation": "This question is challenging because it requires some abstract thought and all answers seem correct at first glance. intrusion detection system (IDSs) and intrusion prevention system (IPSs) do not secure data; they detect attack activity. <br>Domain Name System Security Extensions (DNSSEC) protects data in transit by reducing the risk of DNS poisoning; Transport Layer Security (TLS) and Internet Protocol Security (IPSec) reduce the risk of eavesdropping and interception of data.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      98,
      717,
      716,
      97,
      402
    ],
    "source": ""
  },
  {
    "id": 1448,
    "question": "All of the following techniques are used in OS hardening <italic>except</italic> ___________________.",
    "choice_a": "Removing default accounts",
    "choice_b": "Disallowing local save of credentials",
    "choice_c": "Removing unnecessary services",
    "choice_d": "Preventing all administrative access",
    "correct_answer": "D",
    "explanation": "Administrative access may be limited but not prevented. <br>All the other options are common steps of OS hardening.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      104,
      262,
      598,
      306,
      603
    ],
    "source": ""
  },
  {
    "id": 1449,
    "question": "You are performing an audit of the security controls used in a cloud environment. Which of the following would <italic>best</italic> serve your purpose?",
    "choice_a": "The business impact analysis (BIA)",
    "choice_b": "A copy of the virtual machine (VM) baseline configuration",
    "choice_c": "The latest version of the company\u2019s financial records",
    "choice_d": "A Service Organization Control (SOC) 3 report from another (external) auditor",
    "correct_answer": "B",
    "explanation": "The baseline configuration can be used as a template of controls applied throughout the environment. <br>The BIA and financial records may offer an auditor insight into asset valuation/risk but will not provide meaningful data for a control audit. Options A and C are incorrect. <br>The SOC 3 report is only an attestation by an auditor that an audit has taken place; it does not provide any useful information about security controls.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      331,
      333,
      110,
      111,
      104
    ],
    "source": ""
  },
  {
    "id": 1450,
    "question": "In a cloud environment, prior to putting a node into maintenance mode, all of the following actions should be taken <italic>except</italic> ___________________.",
    "choice_a": "Prevent any new users from logging on or creating any new instances",
    "choice_b": "Migrate any existing guest virtual machines (VMs) to another node",
    "choice_c": "Disable alerts from host-based intrusion detection system (IDSs), intrusion prevention systems (IPSs), or firewalls",
    "choice_d": "Disable logging functions and tools",
    "correct_answer": "D",
    "explanation": "During maintenance mode, all maintenance activities should still be logged and tracked. <br>All the other actions are recommended for a cloud node entering maintenance mode.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      329,
      328,
      620,
      330,
      627
    ],
    "source": ""
  },
  {
    "id": 1451,
    "question": "A cloud provider conducting scheduled maintenance of the environment should do all the following <italic>except</italic> ___________________.",
    "choice_a": "Notify any customers who may be affected",
    "choice_b": "Require reverification of all user accounts",
    "choice_c": "Follow approved change-management procedures and processes",
    "choice_d": "Confirm that remaining resources are sufficient to manage the minimum load as dictated by service-level agreements (SLAs)",
    "correct_answer": "B",
    "explanation": "This action is pointless and excessive; the option is a distractor. <br>All the other options are actions the cloud provider should undertake when conducting scheduled maintenance.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      329,
      107,
      602,
      95,
      108
    ],
    "source": ""
  },
  {
    "id": 1452,
    "question": "Which of the following is characterized by a set maximum capacity?",
    "choice_a": "A secret-sharing-made-short (SSMS) bit-splitting implementation",
    "choice_b": "A tightly coupled cloud storage cluster",
    "choice_c": "A loosely coupled cloud storage cluster",
    "choice_d": "A public-key infrastructure",
    "correct_answer": "B",
    "explanation": "By definition, the tightly coupled cluster has a maximum capacity, whereas the loosely coupled cluster does not. <br>The other options do not have a set maximum capacity and are therefore incorrect.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      621,
      327,
      615,
      94,
      107
    ],
    "source": ""
  },
  {
    "id": 1453,
    "question": "Which of the following is an open source cloud-based software project characterized by a toolset that includes components called Nova, Neutron, Heat, Ironic, and Cinder?",
    "choice_a": "OWASP",
    "choice_b": "OAuth",
    "choice_c": "OpenStack",
    "choice_d": "Mozilla",
    "correct_answer": "C",
    "explanation": "OpenStack is an open source project for creating cloud environments regardless of hardware brand. <br>Open Web Application Security Project (OWASP) is an open source web application development project and does not involve the use of any of the tools mentioned in the question. Option A is incorrect. <br>OAuth is a set of standards for identity federation. Option B is incorrect. <br>Mozilla is a company that produces and administers open source software such as the Firefox web browser. Option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      71,
      75,
      72,
      73,
      74
    ],
    "source": ""
  },
  {
    "id": 1454,
    "question": "You are the security director for a call center that provides live support for customers of various vendors. Your staff handles calls regarding refunds, complaints, and the use of products customers have purchased. To process refunds, your staff will have access to purchase information, determine which credit card the customer used, and identify specific elements of personal data. How should you best protect this sensitive data and still accomplish the purpose?",
    "choice_a": "Encrypt the data while it is at rest but allow the call center personnel to decrypt it for refund transactions.",
    "choice_b": "Encrypt the data while call center personnel are performing their operations.",
    "choice_c": "Mask the data while call center personnel are performing their operations.",
    "choice_d": "Have the call center personnel request the pertinent information from the customer for every refund transaction.",
    "correct_answer": "C",
    "explanation": "Masking the data (such as replacing the majority of the credit card number with Xs, leaving only the last four digits in view) should suffice for the purpose; it allows the call center personnel to determine which card was used in the sale but does not reveal the card number to the call center. <br>Encrypting the data in storage but allowing call center personnel to decrypt it creates a vast opportunity for fraud and abuse; option A is incorrect. <br>Encrypting the data while the call center is trying to make the refund would be counterproductive; the call center personnel would be unable to determine which card gets the refund. Option B is incorrect. <br>Relying on the customer to provide the correct card number invites inaccuracy and exposes the transaction to fraud; option D is not correct.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      502,
      255,
      395,
      29,
      25
    ],
    "source": ""
  },
  {
    "id": 1455,
    "question": "Which of the following is <italic>not</italic> typically included as a basic phase of the software development life cycle (SDLC)?",
    "choice_a": "Define",
    "choice_b": "Design",
    "choice_c": "Describe",
    "choice_d": "Develop",
    "correct_answer": "C",
    "explanation": "Describe is not a common phase in the SDLC; the software should be described in the Define phase. <br>All the other options are common phases of the SDLC.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      441,
      439,
      300,
      297,
      296
    ],
    "source": ""
  },
  {
    "id": 1456,
    "question": "What is the most important input to the software development life cycle (SDLC)?",
    "choice_a": "Senior management direction",
    "choice_b": "Legislation/regulation",
    "choice_c": "Investor oversight",
    "choice_d": "Business requirements",
    "correct_answer": "D",
    "explanation": "Business requirements are paramount because they incorporate the elements of all the other options as well as additional inputs.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      572,
      571,
      573,
      441,
      416
    ],
    "source": ""
  },
  {
    "id": 1457,
    "question": "Which of the following can be included in the cloud security architecture as a means to identify and reject hostile SQL commands?",
    "choice_a": "Web application firewall (WAF)",
    "choice_b": "Application programming interface (API) gateway",
    "choice_c": "Data loss prevention or data leak protection (DLP)",
    "choice_d": "Database activity monitor (DAM)",
    "correct_answer": "D",
    "explanation": "A DAM can recognize and block malicious SQL traffic. <br>A WAF is a Layer 7 firewall that understands hostile HTTP traffic. Option A is incorrect. <br>An API gateway filters API traffic. Option B is incorrect. <br>DLP solutions are used for egress monitoring, not incoming SQL commands. Option C is incorrect.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      578,
      579,
      577,
      701,
      453
    ],
    "source": ""
  },
  {
    "id": 1458,
    "question": "You are the security manager for a software development firm. Your company is interested in using a managed cloud service provider for hosting its testing environment. Which cloud service or deployment model would probably best suit your needs?",
    "choice_a": "Infrastructure as a service (IaaS)",
    "choice_b": "Platform as a service (PaaS)",
    "choice_c": "Software as a service (SaaS)",
    "choice_d": "Community",
    "correct_answer": "B",
    "explanation": "PaaS is optimum for software testing as it allows the software to run across multiple platforms/OSs. <br>All the other options are service/deployment models that are not as optimum for software testing as PaaS.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      8,
      23,
      156,
      12,
      9
    ],
    "source": ""
  },
  {
    "id": 1459,
    "question": "You are the security manager for a software development firm. Your company is interested in using a managed cloud service provider for hosting its testing environment. Which of the following tools, technologies, or techniques may be very useful for your purposes?",
    "choice_a": "Data loss prevention or data leak protection (DLP)",
    "choice_b": "Digital rights management (DRM)",
    "choice_c": "Sandboxing",
    "choice_d": "Web application firewall (WAF)",
    "correct_answer": "C",
    "explanation": "Sandboxing allows software to be run in an isolated environment, which can aid in error detection. <br>Software testing should not include raw production data, so there is no purpose for using DLP and DRM solutions; options A and B are incorrect. <br>The WAF is used to filter web traffic; in the testing environment, there should not be any live traffic going to the software. Option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      283,
      284,
      285,
      300,
      678
    ],
    "source": ""
  },
  {
    "id": 1460,
    "question": "You are the security manager for a software development firm. Your company is interested in using a managed cloud service provider for hosting its testing environment. Previous releases have shipped with major flaws that were not detected in the testing phase; leadership wants to avoid repeating that problem. What tool, technique, or technology might you suggest to aid in identifying programming errors?",
    "choice_a": "Vulnerability scans",
    "choice_b": "Open source review",
    "choice_c": "Service Organization Control (SOC) audits",
    "choice_d": "Regulatory review",
    "correct_answer": "B",
    "explanation": "Open source review can detect flaws that a structured testing method might not. <br>Vulnerability scans will only detect known problems, not programming defects that have not yet been identified; option A is incorrect. <br>Neither SOC audit nor regulatory review have anything to do with finding software flaws; options C and D are incorrect.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      268,
      298,
      300,
      677,
      270
    ],
    "source": ""
  },
  {
    "id": 1461,
    "question": "You are the security manager for a software development firm. Your company is interested in using a managed cloud service provider for hosting its testing environment. Previous releases have shipped with major flaws that were not detected in the testing phase; leadership wants to avoid repeating that problem. It is important to prevent ___________________ from being present during the testing.",
    "choice_a": "Senior management",
    "choice_b": "Marketing department personnel",
    "choice_c": "Finance analysts",
    "choice_d": "Programmers who worked on the software",
    "correct_answer": "D",
    "explanation": "Programmers have a vested interest in, and a specific perspective of, software they create. They can unduly influence testing outcomes, even unintentionally. It is best to prevent programmers from attending testing of software they helped create. <br>All the other options are personnel who do not need to be present but will not necessarily cause undue influence of the testing process.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      676,
      678,
      270,
      677,
      300
    ],
    "source": ""
  },
  {
    "id": 1462,
    "question": "You are the security manager for a software development firm. Your company is interested in using a managed cloud service provider for hosting its testing environment. Management is interested in adopting an Agile development style. When you explain what impact this will have, you note that ____________ may be decreased by this option.",
    "choice_a": "Speed of development",
    "choice_b": "Thoroughness of documentation",
    "choice_c": "Availability of prototypes",
    "choice_d": "Customer collaboration",
    "correct_answer": "B",
    "explanation": "The Agile method reduces the dependence and importance of documentation in favor of functioning software versions. <br>All the other options are elements that will most likely be increased by transitioning to an Agile model.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      300,
      270,
      677,
      441,
      572
    ],
    "source": ""
  },
  {
    "id": 1463,
    "question": "You are the security manager for a software development firm. Your company is interested in using a managed cloud service provider for hosting its testing environment. Management is interested in adopting an Agile development style. In order for this to happen, the company will have to increase the involvement of ___________________.",
    "choice_a": "Security personnel",
    "choice_b": "Budget and finance representatives",
    "choice_c": "Members of the user group",
    "choice_d": "Senior management",
    "correct_answer": "C",
    "explanation": "Agile requires interaction between developers and personnel who will use the software. <br>All the other options are not essential roles in Agile development.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      678,
      441,
      300,
      582,
      580
    ],
    "source": ""
  },
  {
    "id": 1464,
    "question": "You are the security manager for a software development firm. Your company is interested in using a managed cloud service provider for hosting its testing environment. Management is interested in adopting an Agile development style. This will be typified by which of the following traits?",
    "choice_a": "Reliance on a concrete plan formulated during the Define phase",
    "choice_b": "Rigorous, repeated security testing",
    "choice_c": "Isolated programming experts for specific functional elements",
    "choice_d": "Short, iterative work periods",
    "correct_answer": "D",
    "explanation": "Agile development is usually organized in relatively short iterations of effort, between a week and a month in duration. <br>Dependence on planning is directly contrary to Agile methodology; option A is incorrect. <br>In Agile, prototyping is favored over testing; option B is incorrect. <br>Agile relies on cooperative development instead of stovepiped expertise; option C is incorrect.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      441,
      439,
      298,
      299,
      282
    ],
    "source": ""
  },
  {
    "id": 1465,
    "question": "You are the security manager for a software development firm. Your company is interested in using a managed cloud service provider for hosting its testing environment. Management is interested in adopting an Agile development style. This will be typified by which of the following traits?",
    "choice_a": "Daily meetings",
    "choice_b": "A specific shared toolset",
    "choice_c": "Defined plans that dictate all efforts",
    "choice_d": "Addressing customer needs with an exhaustive initial contract",
    "correct_answer": "A",
    "explanation": "Agile development often involves daily meetings (called Scrums). <br>Agile methodology spurns the use of specific tools and concrete planning; options B and C are incorrect. <br>Agile also favors customer collaboration and prototyping instead of an elaborate contract mechanism; option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      441,
      561,
      567,
      299,
      298
    ],
    "source": ""
  },
  {
    "id": 1466,
    "question": "You are the security manager for a software development firm. Your company is interested in using a managed cloud service provider for hosting its testing environment. The back end of the software will have the data structured in a way to optimize XML requests. Which API programming style should programmers most likely concentrate on for the front-end interface?",
    "choice_a": "Simple Object Access Protocol (SOAP)",
    "choice_b": "Representational state transfer (REST)",
    "choice_c": "Security Assertion Markup Language (SAML)",
    "choice_d": "Data loss prevention or data leak protection (DLP)",
    "correct_answer": "A",
    "explanation": "SOAP is a web service programming format that requires the use of XML. <br>REST relies more often on uniform resource identifiers (URIs) than XML; option B is incorrect. <br>SAML is a protocol for passing identity assertions over the Internet; option C is incorrect. <br>DLP is a data egress monitoring tool; option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      559,
      398,
      705,
      569,
      441
    ],
    "source": ""
  },
  {
    "id": 1467,
    "question": "You are the security manager for a software development firm. Your company is interested in using a managed cloud service provider for hosting its testing environment. You recommend the use of STRIDEthreat modeling to assess potential risks associated with the software. Which of the following is <italic>not</italic> addressed by STRIDE?",
    "choice_a": "External parties presenting false credentials",
    "choice_b": "External parties illicitly modifying information",
    "choice_c": "Participants able to deny a transaction",
    "choice_d": "Users unprepared for secure operation by lack of training",
    "correct_answer": "D",
    "explanation": "STRIDE does not address user security training. <br>All the other options are aspects addressed by the STRIDE model.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      293,
      292,
      295,
      296,
      294
    ],
    "source": ""
  },
  {
    "id": 1468,
    "question": "You are the security manager for a software development firm. Your company is interested in using a managed cloud service provider for hosting its testing environment. Management has decided that the company will deploy encryption, data loss prevention or data leak protection (DLP), and digital rights management (DRM) in the cloud environment for additional protection. When consulting with management, you explain that these tools will most likely reduce ___________________.",
    "choice_a": "External threats",
    "choice_b": "Internal threats",
    "choice_c": "Software vulnerabilities",
    "choice_d": "Quality of service",
    "correct_answer": "D",
    "explanation": "Every additional security measure might reduce a potential threat but definitely will reduce productivity and quality of service. There is always an overhead cost of security.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      414,
      250,
      412,
      395,
      32
    ],
    "source": ""
  },
  {
    "id": 1469,
    "question": "You are the security manager for a software development firm. Your company is interested in using a managed cloud service provider for hosting its testing environment. Your company has, and wishes to retain, ISO 27034 certification. For every new application it creates, it will also have to create a(n) ___________________.",
    "choice_a": "Organizational normative framework (ONF)",
    "choice_b": "Application normative framework (ANF)",
    "choice_c": "Intrinsic normative framework (INF)",
    "choice_d": "Service Organization Control (SOC) 3 report",
    "correct_answer": "B",
    "explanation": "ISO 27034 compliance requires an ANF for every application within the organization. <br>Under 27034, the organization only needs one ONF, of which every ANF is a subset. Option A is incorrect. <br>There is no INF. The term is a distractor; option C is incorrect. <br>SOC 3 reports are for the Statement on Standards for Attestation Engagements (SSAE) standard, not ISO 27034; option D is incorrect.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      119,
      124,
      128,
      125,
      114
    ],
    "source": ""
  },
  {
    "id": 1470,
    "question": "You are the security manager for a software development firm. Your company is interested in using a managed cloud service provider for hosting a customer-facing production environment. Many of your end users are located in the European Union (EU) and will provide personal data as they use your software. Your company will not be allowed to use a cloud data center in which of the following countries?",
    "choice_a": "Japan",
    "choice_b": "Australia",
    "choice_c": "Belgium",
    "choice_d": "Chile",
    "correct_answer": "D",
    "explanation": "Chile does not currently have a federal privacy law that conforms to EU legislation. All the other options are countries that do (Belgium is in the EU).",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      348,
      357,
      656,
      651,
      652
    ],
    "source": ""
  },
  {
    "id": 1471,
    "question": "You are the security manager for a software development firm. Your company is interested in using a managed cloud service provider for hosting a customer-facing production environment. Many of your end users are located in the European Union (EU) and will provide personal data as they use your software. Your company will not be allowed to use a cloud data center in which of the following countries?",
    "choice_a": "Argentina",
    "choice_b": "Israel",
    "choice_c": "South Korea",
    "choice_d": "Switzerland",
    "correct_answer": "C",
    "explanation": "South Korea does not currently have a federal privacy law that conforms to EU legislation. All the other options are countries that do.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      348,
      357,
      656,
      652,
      358
    ],
    "source": ""
  },
  {
    "id": 1472,
    "question": "You are the security manager for a software development firm. Your company is interested in using a managed cloud service provider for hosting a customer-facing production environment. Many of your end users are located in the European Union (EU) and will provide personal data as they use your software. Your company will not be allowed to use a cloud data center in which of the following countries?",
    "choice_a": "Canada",
    "choice_b": "Singapore",
    "choice_c": "France",
    "choice_d": "Kenya",
    "correct_answer": "D",
    "explanation": "Kenya does not currently have a federal privacy law that conforms to EU legislation. All the other options are countries that do (France is in the EU).",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      348,
      357,
      656,
      652,
      651
    ],
    "source": ""
  },
  {
    "id": 1473,
    "question": "Which of the following is not a core principle included in the Organisation for Economic Cooperation and Development (OECD) privacy guidelines?",
    "choice_a": "The individual must have the ability to refrain from sharing their data.",
    "choice_b": "The individual must have the ability to correct errors in their data.",
    "choice_c": "The individual must be able to request a purge of their data.",
    "choice_d": "The entity holding the data must secure it.",
    "correct_answer": "C",
    "explanation": "This is an aspect of the current European Union (EU) legislation, known colloquially as \u201cthe right to be forgotten\u201d\u2014it is not an aspect of the OECD principles. <br>All the other options are included in the OECD principles.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      652,
      656,
      347,
      648,
      358
    ],
    "source": ""
  },
  {
    "id": 1474,
    "question": "Who is the entity identified by personal data?",
    "choice_a": "The data owner",
    "choice_b": "The data processor",
    "choice_c": "The data custodian",
    "choice_d": "The data subject",
    "correct_answer": "D",
    "explanation": "The data subject is the person who is identified by personal data. <br>All the other options are other privacy-data-related roles.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      658,
      129,
      132,
      134,
      347
    ],
    "source": ""
  },
  {
    "id": 1475,
    "question": "What is the current European Union (EU) privacy legislation that restricts dissemination of personal data outside the EU?",
    "choice_a": "The EU Data Directive",
    "choice_b": "Privacy Shield",
    "choice_c": "The General Data Protection Regulation (GDPR)",
    "choice_d": "Sarbanes\u2013Oxley (SOX)",
    "correct_answer": "C",
    "explanation": "The GDPR is the current prevailing EU privacy data legislation. It replaced the Data Directive. Privacy Shield is the program under which entities in non-adhering countries can still be allowed to process the personal data of EU citizens. SOX is an American law.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      656,
      660,
      658,
      659,
      655
    ],
    "source": ""
  },
  {
    "id": 1476,
    "question": "In order for American companies to process personal data belonging to European Union (EU) citizens, they must comply with the Privacy Shield program. The program is administered by the U.S. Department of Transportation and the ___________________.",
    "choice_a": "U.S. State Department",
    "choice_b": "Fish and Wildlife Service",
    "choice_c": "Federal Trade Commission (FTC)",
    "choice_d": "Federal Communication Commission (FCC)",
    "correct_answer": "C",
    "explanation": "The FTC is the local US enforcement arm for most Privacy Shield activity. <br>All the other options are US government agencies not involved with Privacy Shield.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      656,
      653,
      347,
      650,
      646
    ],
    "source": ""
  },
  {
    "id": 1477,
    "question": "In addition to the Privacy Shield program, what other means can non\u2013European Union (EU) companies use to be allowed to process personal data of EU citizens?",
    "choice_a": "Enhanced security controls",
    "choice_b": "Standard contractual clauses",
    "choice_c": "Increased oversight",
    "choice_d": "Modified legal regulation",
    "correct_answer": "B",
    "explanation": "Companies that are not in countries that have laws in accordance with the EU privacy regulations can instead opt for creating contract language that voluntarily complies with the laws. <br>All the other options are incorrect because they do not allow non\u2013European Union companies to process personal data of EU citizens.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      660,
      656,
      338,
      347,
      652
    ],
    "source": ""
  },
  {
    "id": 1478,
    "question": "Which entity is legally responsible for the protection of personal data?",
    "choice_a": "The data subject",
    "choice_b": "The data controller",
    "choice_c": "The data processor",
    "choice_d": "The data steward",
    "correct_answer": "B",
    "explanation": "The data controller is legally liable for protecting any privacy data it has. All the other options are other data privacy roles that do not have ultimate legal responsibility.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      659,
      658,
      660,
      709,
      656
    ],
    "source": ""
  },
  {
    "id": 1479,
    "question": "When a company is first starting and has no defined processes and little documentation, it can be said to be at level ___________________ of the Capability Maturity Model (CMM).",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "A",
    "explanation": "Level 1 is the initial level of maturity for a company and its processes; activity may be performed in an ad hoc manner. <br>All the other options are greater maturity levels of the CMM.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      358,
      646,
      360,
      119,
      124
    ],
    "source": ""
  },
  {
    "id": 1480,
    "question": "Which of the following standards addresses a company\u2019s entire security program, involving all aspects of various security disciplines?",
    "choice_a": "ISO 27001",
    "choice_b": "ISO 27002",
    "choice_c": "National Institute of Standards and Technology (NIST) 800-37",
    "choice_d": "Statement on Standards for Attestation Engagements (SSAE) 18",
    "correct_answer": "A",
    "explanation": "The ISO 27001 standard reviews an organization\u2019s security in terms of an information security management system (ISMS), which involves a holistic view of the entire security program. <br>ISO 27002 is a standard for applying controls to the ISMS; option B is incorrect. <br>NIST 800-37 is the Risk Management Framework; option C is incorrect. <br>SSAE is an audit standard for financial reporting and the controls within an environment; option D is incorrect.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      111,
      110,
      313,
      333,
      618
    ],
    "source": ""
  },
  {
    "id": 1481,
    "question": "A cloud provider might only release Service Organization Control (SOC 2), Type 2 reports to ___________________.",
    "choice_a": "Regulators",
    "choice_b": "The public",
    "choice_c": "Potential customers",
    "choice_d": "Current customers",
    "correct_answer": "D",
    "explanation": "Because of the sensitive nature of the material covered in the SOC 2, Type 2 report, a cloud provider might not be willing to share it with any entity that does not have a financial stake in the cloud service. <br>All the other options are entities that are unlikely to receive a SOC 2, Type 2 report from a cloud provider.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      344,
      349,
      341,
      345,
      358
    ],
    "source": ""
  },
  {
    "id": 1482,
    "question": "A cloud provider\u2019s Service Organization Control (SOC) 1 report may not be useful to customers interested in determining the provider\u2019s security posture because the SOC 1 report contains only information about ___________________.",
    "choice_a": "Sales projections",
    "choice_b": "Financial reporting",
    "choice_c": "Previous customer satisfaction",
    "choice_d": "Process definition",
    "correct_answer": "B",
    "explanation": "The SOC 1 report reviews the accuracy and completeness of an organization\u2019s financial reporting mechanisms. <br>All the other options are incorrect.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      341,
      349,
      350,
      344,
      345
    ],
    "source": ""
  },
  {
    "id": 1483,
    "question": "The Payment Card Industry (PCI) Data Security Standard requires different levels of activity based on participants\u2019 ___________________.",
    "choice_a": "Number of personnel",
    "choice_b": "Branch locations",
    "choice_c": "Number of transactions per year",
    "choice_d": "Preferred banking institutions",
    "correct_answer": "C",
    "explanation": "There are four PCI merchant levels, based on the number of transactions an organization conducts per year. <br>All the other options are incorrect answers.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      653,
      356,
      353,
      346,
      339
    ],
    "source": ""
  },
  {
    "id": 1484,
    "question": "Which IT product review framework is intended to determine the accuracy of vendor claims regarding security functions of the product?",
    "choice_a": "Underwriters Laboratories (UL)",
    "choice_b": "Federal Information Processing Standard (FIPS) 140-2",
    "choice_c": "Payment Card Industry (PCI) Data Security Standard (DSS)",
    "choice_d": "Common Criteria",
    "correct_answer": "D",
    "explanation": "The Common Criteria is a framework for reviewing product security functions, as stated by the vendor. <br>The UL is a standards and certification entity concerned with product safety; option A is incorrect. <br>FIPS 140-2 is a standard for certifying cryptographic modules; option B is incorrect. <br>PCI DSS is a security standard for credit card merchants and processors; option C is incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      233,
      475,
      192,
      463,
      182
    ],
    "source": ""
  },
  {
    "id": 1485,
    "question": "What is the lowest level of cryptographic security for a cryptographic module, according to the Federal Information Processing Standard (FIPS) 140-2 standard?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "A",
    "explanation": "The lowest level of the FIPS 140-2 standard is 1. All the other options are incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      233,
      192,
      10,
      208,
      182
    ],
    "source": ""
  },
  {
    "id": 1486,
    "question": "What is the highest level of the Cloud Security Alliance Security, Trust, and Assurance Registry (CSA STAR) certification program for cloud service providers?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "C",
    "explanation": "There are three levels of the CSA STAR program, and 3 is the highest. All the other options are incorrect.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      358,
      647,
      360,
      646,
      359
    ],
    "source": ""
  },
  {
    "id": 1487,
    "question": "Every cloud service provider that opts to join the Cloud Security Alliance Security, Trust, and Assurance Registry (CSA STAR) program registry must complete a ___________________.",
    "choice_a": "Service Organization Control (SOC) 2, Type 2 audit report",
    "choice_b": "Consensus Assessment Initiative Questionnaire (CAIQ)",
    "choice_c": "National Institute of Standards and Technology (NIST) 800-37 Risk Management Framework (RMF) audit",
    "choice_d": "ISO 27001 information security management system (ISMS) review",
    "correct_answer": "B",
    "explanation": "The CAIQ is the CSA\u2019s mechanism for STAR applicants to evaluate their own service. <br>The SOC reports are part of the Statement on Standards for Attestation Engagements (SSAE) 18 audit standard; option A is incorrect. <br>The NIST RMF is only mandated for US federal agencies and not part of the CSA purview; option C is incorrect. <br>The ISMS is one of the ISO standards and not part of the CSA purview; option D is incorrect.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      646,
      358,
      359,
      360,
      647
    ],
    "source": ""
  },
  {
    "id": 1488,
    "question": "The term <italic>cloud carrier</italic> most often refers to ___________________.",
    "choice_a": "The cloud provider",
    "choice_b": "The cloud customer",
    "choice_c": "An Internet service provider (ISP)",
    "choice_d": "A cloud manager",
    "correct_answer": "C",
    "explanation": "Cloud carrier is a term describing the intermediary between cloud customer and provider that delivers connectivity; this is typically an ISP. <br>Options A and B are other typical cloud computing roles; option D is not a term with any meaning in this context.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      13,
      12,
      234,
      1,
      9
    ],
    "source": ""
  },
  {
    "id": 1489,
    "question": "In a centralized broker identity federation, which entity typically creates and sends the Security Assertion Markup Language (SAML) token?",
    "choice_a": "The cloud provider",
    "choice_b": "The Internet service provider (ISP)",
    "choice_c": "The broker",
    "choice_d": "The cloud customer",
    "correct_answer": "C",
    "explanation": "In a centralized broker federation, the broker (typically a third party) acting as the identity provider, creates the SAML identity assertion tokens and delivers them to the relying parties. <br>All the other options are distractors and not entities that are assigned specific roles in a federation motif.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      478,
      480,
      13,
      12,
      490
    ],
    "source": ""
  },
  {
    "id": 1490,
    "question": "Which of the following tools incorporates and references the requirements listed in all the others?",
    "choice_a": "ISO 27001",
    "choice_b": "Cloud Security Alliance (CSA) Cloud Controls Matrix (CCM)",
    "choice_c": "Federal Risk and Authorization Management Program (FedRAMP)",
    "choice_d": "European Union Agency for Network and Information Security (ENISA)",
    "correct_answer": "B",
    "explanation": "The CCM is a tool for determining control coverage for compliance with a variety of standards and regulations. <br>All the other options are standards or regulations.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      347,
      353,
      363,
      345,
      344
    ],
    "source": ""
  },
  {
    "id": 1491,
    "question": "Which of the following is an example of true multifactor authentication?",
    "choice_a": "Having a login that requires both a password and a personal identification number (PIN)",
    "choice_b": "Using a thumbprint and voice recognition software for access control",
    "choice_c": "Presenting a credit card along with a Social Security card",
    "choice_d": "Signing a personal check",
    "correct_answer": "D",
    "explanation": "The check involves two kinds of security elements: something you have (the check) and something you are (the biometric control, the signature). <br>Option A is two elements of the same kind: something you know. This is incorrect. <br>Option B is two elements of the same kind: something you are. This is incorrect. <br>Option C is two elements of the same kind: something you have. This is incorrect.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      436,
      295,
      296,
      368,
      416
    ],
    "source": ""
  },
  {
    "id": 1492,
    "question": "Which of the following is appropriate to include in a service-level agreement (SLA)?",
    "choice_a": "That the provider deliver excellent uptime",
    "choice_b": "That the provider host the customer\u2019s data only within specific jurisdictions",
    "choice_c": "That any conflicts arising from the contract be settled within a particular jurisdiction",
    "choice_d": "The specific amount of data that can be uploaded to the cloud environment in any given month",
    "correct_answer": "D",
    "explanation": "SLA elements should be objective, numeric values, for repeated activity. <br>Options B and C are useful elements to be included in the contract, but not specifically the SLA. Options B and C are incorrect. <br>Option A is too ambiguous; \u201cexcellent\u201d is not a discrete value. Option A is incorrect.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      343,
      648,
      651,
      347,
      360
    ],
    "source": ""
  },
  {
    "id": 1493,
    "question": "Which of the following standards is typically used to convey public key information in a public-key infrastructure (PKI) arrangement?",
    "choice_a": "Security Assertion Markup Language (SAML)",
    "choice_b": "X.400",
    "choice_c": "X.509",
    "choice_d": "802.11",
    "correct_answer": "C",
    "explanation": "X.509 is the certificate standard for communicating public key information. <br>SAML is the protocol used to pass identity assertions over a network; option A is incorrect. <br>X.400 is an archaic mail standard; option B is incorrect. <br>802.11 is the standard for wireless communications; option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      11,
      5,
      5
    ],
    "source": ""
  },
  {
    "id": 1494,
    "question": "In working with various networking technologies such as Frame Relay, ATM, and Ethernet, the capability of the network to provide better service to selected traffic is called ___________________.",
    "choice_a": "QaS",
    "choice_b": "ASP",
    "choice_c": "OLA",
    "choice_d": "QoS",
    "correct_answer": "D",
    "explanation": "Quality of service (QoS) refers to the capability of a network to provide better service for certain traffic regardless of network type or topology. <br>The other options contain uppercase and lowercase letters that may or may not be related to the cloud. Option D is the only option that answers the question correctly. The acronym QoS represents Quality of Service. QoS is used to set priorities for specific types of data to dependably run high-priority applications and traffic.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      520,
      712,
      685,
      522,
      521
    ],
    "source": ""
  },
  {
    "id": 1495,
    "question": "Which type of networking model is optimized for cloud deployments and the underlying storage and IP networks are combined so as to maximize the benefits of a cloud workload?",
    "choice_a": "Software-defined networking model",
    "choice_b": "Enterprise networking model",
    "choice_c": "Converged networking model",
    "choice_d": "Legacy networking model",
    "correct_answer": "C",
    "explanation": "Optimized for cloud deployments, the converged networking model combines the underlying storage and IP networks to maximize the benefits of a cloud workload. <br>Option A is incorrect because software-defined networking refers to a networking architecture consisting of three layers: application, control, and infrastructure. <br>Enterprise networking is a general term, not specifically related to the cloud. Option B is incorrect. <br>Legacy networking or traditional networking is designed for traditional networks that use physical devices and components rather than virtual. Option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      520,
      685,
      712,
      714,
      532
    ],
    "source": ""
  },
  {
    "id": 1496,
    "question": "Which type of law consists of a body of rules and statutes that define prohibited conduct and is set out to protect the safety and well-being of the public?",
    "choice_a": "Tort",
    "choice_b": "Criminal",
    "choice_c": "Civil",
    "choice_d": "Contract",
    "correct_answer": "B",
    "explanation": "Criminal law is set out in rules and statutes created by a government, prohibiting certain activities as a means of protecting the safety and well-being of its citizens. Violations generally consist of both monetary and/or loss of liberty punishments. <br>Tort law refers the body of laws that provide remedies to individuals who have been caused harm by unreasonable acts of others. Negligence is the most common type of tort lawsuit. Therefore, option A is incorrect. <br>Option C is incorrect because civil law pertains to contracts, property, and family law as opposed to crimes like murder and theft that are associated with criminal law. <br>Contracts are agreements between parties to exchange goods and services; Option D is incorrect.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      670,
      672,
      666,
      664,
      671
    ],
    "source": ""
  },
  {
    "id": 1497,
    "question": "What is the primary reason for the use of SSDs in the cloud today?",
    "choice_a": "They are faster than traditional spinning drives.",
    "choice_b": "They last longer than traditional spinning drives.",
    "choice_c": "They are easier to replace than traditional spinning drives.",
    "choice_d": "They can be replaced quickly.",
    "correct_answer": "A",
    "explanation": "Solid-state disks (SSDs) are used in cloud computing today because they operate at high speeds as compared to traditional spinning drives. <br>Option B is incorrect. SSDs do not necessarily last longer than magnetic drives. <br>Options C and D are incorrect because SSDs are not noticeably easier or quicker to replace than traditional drives.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      94,
      615,
      95,
      96,
      98
    ],
    "source": ""
  },
  {
    "id": 1498,
    "question": "Which of the following are risks associated with virtualization?",
    "choice_a": "Loss of governance, snapshot and image security, and sprawl",
    "choice_b": "Public awareness, snapshot and image availability, and sprawl",
    "choice_c": "Increased cost, snapshot and image security, and sprawl",
    "choice_d": "Loss of data",
    "correct_answer": "A",
    "explanation": "The primary risks associated with virtualization are loss of governance, snapshot and image security, and sprawl. <br>Options B and C are incorrect. Public awareness and increased costs are not risks associated with virtualization. <br>Option D is incorrect because the loss of data is not associated with virtualization anymore than the loss of data is associated with non-virtualization.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      532,
      534,
      546,
      459,
      241
    ],
    "source": ""
  },
  {
    "id": 1499,
    "question": "Which of the following is the core of any system handling all input/output (I/O) instructions?",
    "choice_a": "Central processing unit (CPU)",
    "choice_b": "Hypervisor",
    "choice_c": "User interface",
    "choice_d": "Supervising application",
    "correct_answer": "A",
    "explanation": "The central processing unit (CPU) is the core of any and all systems, handling all the basic I/O instructions as they originate from the software. <br>The question focuses on the handling of all input/output (I/O) instructions. Only the CPU does that. Options B, C, and D function as a result of the CPU handling all of I/O for the hypervisor, user interface, and supervising application. The CPU is the core of computing systems. Options B, C, and D are incorrect.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      730,
      731,
      732,
      325,
      94
    ],
    "source": ""
  },
  {
    "id": 1500,
    "question": "Which of the following is an international organization of network designers and architects who work together in establishing standards and protocols for the Internet?",
    "choice_a": "Internet Assigned Numbers Authority (IANA)",
    "choice_b": "International Organization for Standardization (ISO)/ International Electrotechnical Commission (IEC)",
    "choice_c": "National Institute of Standards and Technology (NIST)",
    "choice_d": "Internet Engineering Task Force (IETF)",
    "correct_answer": "D",
    "explanation": "The IETF is an international organization of network designers and architects who work together in establishing standards and protocols for the Internet. <br>IANA oversees global IP address allocation among other Internet tasks. IANA does not establish standards and protocols for the Internet. Option A is incorrect. <br>Option B is incorrect because the ISO/IEC develops, maintains and promotes standards in information technology and information communication technology. <br>Option C is incorrect because NIST is a federal government standards body in the US.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 1501,
    "question": "_____________ is a symmetric block type of cipher used to encrypt information and is currently the standard for the U.S. government in protecting sensitive and secret documents.",
    "choice_a": "MD5",
    "choice_b": "Secure Socket Layer (SSL)",
    "choice_c": "Blowfish",
    "choice_d": "Advanced Encryption Standard (AES)",
    "correct_answer": "D",
    "explanation": "The Advanced Encryption Standard (AES) is currently used to encrypt and protect U.S. government sensitive and secret data. There are variants, but the most common is 256-bit, which is virtually impossible to break today. <br>Option A is incorrect because MD5 is a cryptographic hash function used to verify that a file has not been altered. <br>SSL uses certificates to create a secure connection using encryption. Option B is incorrect. <br>Blowfish is a symmetric-key block cipher that has been replaced by AES encryption. The U.S. government uses AES and not Blowfish. Option C is incorrect.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      494,
      493,
      496,
      41,
      40
    ],
    "source": ""
  }
];
